import { createInstance as e } from "i18next";
import { memo as t, useEffect as n, useLayoutEffect as r, useRef as i, useState as a, useSyncExternalStore as o } from "react";
import { Fragment as s, jsx as c, jsxs as l } from "react/jsx-runtime";
import { createPortal as u } from "react-dom";
import { useDraggable as d } from "@frontends/ui-kit";
//#region src/utils/colors.ts
var f = (e) => {
	let t = e.trim().replace(/^#/, "");
	return t.length === 3 && (t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2]), t.length !== 6 || /[^0-9a-fA-F]/.test(t) ? null : {
		r: parseInt(t.slice(0, 2), 16),
		g: parseInt(t.slice(2, 4), 16),
		b: parseInt(t.slice(4, 6), 16)
	};
}, p = (e, t) => {
	let n = f(e);
	return n ? `rgba(${n.r}, ${n.g}, ${n.b}, ${(100 - t) / 100})` : e;
}, m = (e, t, n) => {
	let r = f(e), i = f(n);
	if (!r || !i) return p(e, t);
	let a = (100 - t) / 100, o = (e, t) => Math.round(e * a + t * (1 - a));
	return `rgb(${o(r.r, i.r)}, ${o(r.g, i.g)}, ${o(r.b, i.b)})`;
}, h = (e) => {
	let t = f(e);
	if (!t) return "#FFFFFF";
	let n = (e) => {
		let t = e / 255;
		return t <= .03928 ? t / 12.92 : ((t + .055) / 1.055) ** 2.4;
	}, r = .2126 * n(t.r) + .7152 * n(t.g) + .0722 * n(t.b), i = 1.05 / (r + .05);
	return (r + .05) / .05 >= i ? "#000000" : "#FFFFFF";
}, g = (e, t) => {
	let n = e.symbol;
	return {
		symbol: n.info?.ticker || n.info?.name || n.ticker || t.ticker(e),
		resolution: String(n.period || n.resolution || "")
	};
}, _ = (e, t) => {
	let n = null;
	return () => n ??= g(e, t);
}, v = 56, y = 41, b = (e, t) => [e, t].flatMap((e) => Array.from({ length: y }, (t, n) => p(e, v + n))), x = (e, t) => {
	let n = b(e, t);
	return {
		palette: {
			colors: n.map((e, t) => ({ name: `Flash ${t}` })),
			valToIndex: Object.fromEntries(n.map((e, t) => [t, t]))
		},
		defaults: { colors: n.map((e) => ({ color: e })) }
	};
}, S = (e, t) => (e > 0 ? 0 : y) + Math.min(y - 1, Math.max(0, Math.round(t) - v)), C = () => {
	let e = !1, t = NaN, n = NaN, r = 0;
	return {
		reset: () => {
			e = !1, t = NaN, n = NaN, r = 0;
		},
		step: (i, a, o) => {
			let s = i.isLastBar && !i.isNewBar && i.isBarClosed && i.time === t;
			i.isLastBar && (i.isNewBar ? e : !i.isBarClosed) && (t = i.time), i.isLastBar && (e = !0);
			let c = s && a.enabled && i.trigger !== 0, l = NaN;
			if (s) {
				let e = a.blinks / a.hz * 1e3;
				c && (n = o + e, r = i.trigger);
				let t = a.enabled && (a.test || o < n), s = a.test ? o : e - (n - o), u = a.test && r === 0 ? 1 : r;
				t && u !== 0 && Math.floor(s / (1e3 / (a.hz * 2))) % 2 == 0 && (l = S(u, Math.min(96, a.transparency + 6)));
			}
			return {
				direction: c ? i.trigger : a.test && r === 0 ? 1 : r,
				fired: c,
				stripe: l
			};
		}
	};
}, w = (e, t, n, r, i) => {
	let a = e.get(n);
	if (r.na(a)) return NaN;
	let o = t + n;
	for (let t = 0; t <= o; t++) {
		if (t === n) continue;
		let o = e.get(t);
		if (r.na(o) || !i(a, o)) return NaN;
	}
	return a;
}, T = (e, t, n, r) => w(e, t, n, r, (e, t) => e > t), E = (e, t, n, r) => w(e, t, n, r, (e, t) => e < t), D = 4, O = 10, k = {
	highs: [],
	lows: [],
	lastBullBar: -1e4,
	lastBearBar: -1e4
}, ee = (e, t) => e && t <= 5 ? 5 : 3, te = (e, t, n, r, i, a, o) => {
	let s = n.get(1), c = e, l = !1, u = !1;
	if (!Number.isNaN(E(n, a, 1, o))) {
		let n = i.get(1);
		l = t - e.lastBullBar >= O && e.lows.some((e) => n < e.price && s > e.pulse), c = {
			...c,
			lows: [{
				price: n,
				pulse: s
			}, ...e.lows].slice(0, D),
			lastBullBar: l ? t : e.lastBullBar
		};
	}
	if (!Number.isNaN(T(n, a, 1, o))) {
		let n = r.get(1);
		u = t - e.lastBearBar >= O && e.highs.some((e) => n > e.price && s < e.pulse), c = {
			...c,
			highs: [{
				price: n,
				pulse: s
			}, ...e.highs].slice(0, D),
			lastBearBar: u ? t : e.lastBearBar
		};
	}
	return {
		bear: u,
		bull: l,
		state: c
	};
}, ne = "C Trigger", A = {
	bull: "#4CAF50",
	bear: "#9236da",
	neutral: "#787B86"
}, j = A.bull, M = A.bear, re = A.neutral, N = 4294967291, P = 1, ie = 0, ae = 5, oe = 6, se = " ", ce = x(j, M), le = (e, t) => ({
	name: ne,
	metainfo: {
		_metainfoVersion: 51,
		id: "CTrigger@tv-basicstudies-1",
		name: ne,
		description: ne,
		shortDescription: ne,
		isCustomIndicator: !0,
		is_price_study: !1,
		linkedToSeries: !0,
		format: {
			type: "price",
			precision: 2
		},
		inputs: [
			{
				id: "rsiLen",
				name: "EXP RSI Length",
				type: "integer",
				defval: 5,
				min: 1,
				group: "RSI & Smoothing"
			},
			{
				id: "expSmooth",
				name: "Exponential Smoothing Factor",
				type: "float",
				defval: .1,
				step: .01,
				group: "RSI & Smoothing"
			},
			{
				id: "emaPeriod",
				name: "EMA Period (band accuracy)",
				type: "integer",
				defval: 200,
				min: 1,
				group: "RSI & Smoothing"
			},
			{
				id: "lrBars",
				name: "Linear Regression Bars",
				type: "integer",
				defval: 5,
				min: 1,
				group: "Channel / Bands"
			},
			{
				id: "chanMult",
				name: "Channel Multiplier",
				type: "float",
				defval: 2,
				step: .1,
				group: "Channel / Bands"
			},
			{
				id: "chanDev1",
				name: "Channel Multiplier 1.0 Dev",
				type: "float",
				defval: 1,
				step: .1,
				group: "Channel / Bands"
			},
			{
				id: "chanDev15",
				name: "Channel Multiplier 1.5 Dev",
				type: "float",
				defval: 1.5,
				step: .1,
				group: "Channel / Bands"
			},
			{
				id: "stAtrLen",
				name: "ATR Length",
				type: "integer",
				defval: 10,
				min: 1,
				group: "Super Trend"
			},
			{
				id: "stFactor",
				name: "Factor",
				type: "float",
				defval: 3,
				step: .1,
				group: "Super Trend"
			},
			{
				id: "htAmp",
				name: "Amplitude",
				type: "integer",
				defval: 2,
				min: 1,
				group: "Half Trend"
			},
			{
				id: "htDev",
				name: "Channel Deviation",
				type: "integer",
				defval: 2,
				min: 1,
				group: "Half Trend"
			},
			{
				id: "ichConv",
				name: "Conversion Period",
				type: "integer",
				defval: 5,
				min: 1,
				group: "Ichimoku Cloud"
			},
			{
				id: "ichBase",
				name: "Base Period",
				type: "integer",
				defval: 26,
				min: 1,
				group: "Ichimoku Cloud"
			},
			{
				id: "ichLag",
				name: "Lagging Span 2 Periods",
				type: "integer",
				defval: 52,
				min: 1,
				group: "Ichimoku Cloud"
			},
			{
				id: "ichDisp",
				name: "Displacement",
				type: "integer",
				defval: 26,
				min: 1,
				group: "Ichimoku Cloud"
			},
			{
				id: "sarStart",
				name: "PS Start",
				type: "float",
				defval: .02,
				step: .01,
				group: "Parabolic SAR"
			},
			{
				id: "sarInc",
				name: "PS Increment",
				type: "float",
				defval: .02,
				step: .01,
				group: "Parabolic SAR"
			},
			{
				id: "sarMax",
				name: "Max Value",
				type: "float",
				defval: .2,
				step: .01,
				group: "Parabolic SAR"
			},
			{
				id: "obLevel",
				name: "Bearish Div High RSI floor (prior pivot)",
				type: "integer",
				defval: 50,
				group: "Divergence",
				tooltip: "Prior pivot's smoothed RSI must be at or above this to qualify as a bearish divergence. Default 50 (midline)."
			},
			{
				id: "osLevel",
				name: "Bullish Div Low RSI ceiling (prior pivot)",
				type: "integer",
				defval: 50,
				group: "Divergence",
				tooltip: "Prior pivot's smoothed RSI must be at or below this to qualify as a bullish divergence. Default 50 (midline)."
			},
			{
				id: "showBand10",
				name: "Show 1.0 Dev Bands",
				type: "bool",
				defval: !1,
				group: "Visibility"
			},
			{
				id: "showBand15",
				name: "Show 1.5 Dev Bands",
				type: "bool",
				defval: !0,
				group: "Visibility"
			},
			{
				id: "showGlow",
				name: "Show Glow Zones",
				type: "bool",
				defval: !1,
				group: "Visibility"
			},
			{
				id: "flashOn",
				name: "Flash on new trigger",
				type: "bool",
				defval: !0,
				group: "New-Flag Alert",
				tooltip: "Loud cue when a fresh C Trigger buy/sell fires live. Only animates on the forming candle and needs incoming ticks (TradingView limitation)."
			},
			{
				id: "flashCount",
				name: "Number of flashes",
				type: "integer",
				defval: 3,
				min: 1,
				max: 12,
				group: "New-Flag Alert"
			},
			{
				id: "flashHz",
				name: "Flash speed (blinks / sec)",
				type: "float",
				defval: 1.5,
				min: .3,
				max: 6,
				step: .1,
				group: "New-Flag Alert"
			},
			{
				id: "flashTransp",
				name: "Background flash strength",
				type: "integer",
				defval: 82,
				min: 50,
				max: 96,
				group: "New-Flag Alert",
				tooltip: "Lower = bolder wash (50 very strong, 96 faint)."
			},
			{
				id: "flashTest",
				name: "Test flash now (preview)",
				type: "bool",
				defval: !1,
				group: "New-Flag Alert",
				tooltip: "Force the flash on the live bar to preview / tune it without waiting for a real signal. Turn OFF for live use."
			}
		],
		plots: [
			{
				id: "trendDirection",
				type: "line"
			},
			{
				id: "trendColor",
				type: "colorer",
				target: "trendDirection",
				palette: "palette_trend_side"
			},
			{
				id: "pulse",
				type: "line"
			},
			{
				id: "pulseColor",
				type: "colorer",
				target: "pulse",
				palette: "palette_pulse_slope"
			},
			{
				id: "previousValue",
				type: "line"
			},
			{
				id: "tradeColor",
				type: "colorer",
				target: "previousValue",
				palette: "palette_trade_side"
			},
			{
				id: "upper10",
				type: "line"
			},
			{
				id: "lower10",
				type: "line"
			},
			{
				id: "upper15",
				type: "line"
			},
			{
				id: "lower15",
				type: "line"
			},
			{
				id: "overbought",
				type: "line"
			},
			{
				id: "oversold",
				type: "line"
			},
			{
				id: "upper20",
				type: "line"
			},
			{
				id: "lower20",
				type: "line"
			},
			{
				id: "bullBallpoint",
				type: "line"
			},
			{
				id: "bearBallpoint",
				type: "line"
			},
			{
				id: "bullDivLabel",
				type: "shapes"
			},
			{
				id: "bearDivLabel",
				type: "shapes"
			},
			{
				id: "bullFishHook",
				type: "line"
			},
			{
				id: "bearFishHook",
				type: "line"
			},
			{
				id: "trendBarColumns",
				type: "line"
			},
			{
				id: "trendBarColor",
				type: "colorer",
				target: "trendBarColumns",
				palette: "palette_trend_bar"
			},
			{
				id: "flashBackground",
				type: "bg_colorer",
				palette: "palette_flash_background"
			}
		],
		palettes: {
			palette_trend_side: {
				colors: [{ name: "Bearish" }, { name: "Bullish" }],
				valToIndex: {
					0: 0,
					1: 1
				}
			},
			palette_pulse_slope: {
				colors: [{ name: "Falling" }, { name: "Rising" }],
				valToIndex: {
					0: 0,
					1: 1
				}
			},
			palette_trade_side: {
				colors: [{ name: "Below Midline" }, { name: "Above Midline" }],
				valToIndex: {
					0: 0,
					1: 1
				}
			},
			palette_trend_bar: {
				colors: [
					{ name: "Bearish" },
					{ name: "Neutral" },
					{ name: "Bullish" }
				],
				valToIndex: {
					0: 0,
					1: 1,
					2: 2
				}
			},
			palette_flash_background: ce.palette
		},
		filledAreas: [{
			id: "glowUpperZone",
			objAId: "upper15",
			objBId: "upper20",
			type: "plot_plot",
			title: "Glow Upper Zone"
		}, {
			id: "glowLowerZone",
			objAId: "lower20",
			objBId: "lower15",
			type: "plot_plot",
			title: "Glow Lower Zone"
		}],
		defaults: {
			inputs: {
				rsiLen: 5,
				expSmooth: .1,
				emaPeriod: 200,
				lrBars: 5,
				chanMult: 2,
				chanDev1: 1,
				chanDev15: 1.5,
				stAtrLen: 10,
				stFactor: 3,
				htAmp: 2,
				htDev: 2,
				ichConv: 5,
				ichBase: 26,
				ichLag: 52,
				ichDisp: 26,
				sarStart: .02,
				sarInc: .02,
				sarMax: .2,
				obLevel: 50,
				osLevel: 50,
				showBand10: !1,
				showBand15: !0,
				showGlow: !1,
				flashOn: !0,
				flashCount: 3,
				flashHz: 1.5,
				flashTransp: 82,
				flashTest: !1
			},
			styles: {
				trendDirection: {
					linestyle: 0,
					linewidth: 2,
					plottype: ie,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: re,
					display: N
				},
				pulse: {
					linestyle: 0,
					linewidth: 3,
					plottype: ie,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: j,
					display: N
				},
				previousValue: {
					linestyle: 0,
					linewidth: 1,
					plottype: ie,
					trackPrice: !1,
					transparency: 40,
					visible: !0,
					color: j,
					display: N
				},
				upper10: {
					linestyle: 0,
					linewidth: 1,
					plottype: ie,
					trackPrice: !1,
					transparency: 60,
					visible: !0,
					color: re,
					display: N
				},
				lower10: {
					linestyle: 0,
					linewidth: 1,
					plottype: ie,
					trackPrice: !1,
					transparency: 60,
					visible: !0,
					color: re,
					display: N
				},
				upper15: {
					linestyle: 0,
					linewidth: 2,
					plottype: ie,
					trackPrice: !1,
					transparency: 30,
					visible: !0,
					color: M,
					display: N
				},
				lower15: {
					linestyle: 0,
					linewidth: 2,
					plottype: ie,
					trackPrice: !1,
					transparency: 30,
					visible: !0,
					color: j,
					display: N
				},
				overbought: {
					linestyle: 1,
					linewidth: 1,
					plottype: ie,
					trackPrice: !1,
					transparency: 70,
					visible: !0,
					color: M,
					display: P
				},
				oversold: {
					linestyle: 1,
					linewidth: 1,
					plottype: ie,
					trackPrice: !1,
					transparency: 70,
					visible: !0,
					color: j,
					display: P
				},
				upper20: {
					linestyle: 0,
					linewidth: 1,
					plottype: ie,
					trackPrice: !1,
					transparency: 80,
					visible: !0,
					color: M,
					display: N
				},
				lower20: {
					linestyle: 0,
					linewidth: 1,
					plottype: ie,
					trackPrice: !1,
					transparency: 80,
					visible: !0,
					color: j,
					display: N
				},
				bullBallpoint: {
					linestyle: 0,
					linewidth: 3,
					plottype: oe,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: j,
					display: N
				},
				bearBallpoint: {
					linestyle: 0,
					linewidth: 3,
					plottype: oe,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: M,
					display: N
				},
				bullDivLabel: {
					plottype: "shape_label_up",
					location: "Absolute",
					color: j,
					textColor: "#FFFFFF",
					visible: !0,
					display: P
				},
				bearDivLabel: {
					plottype: "shape_label_down",
					location: "Absolute",
					color: M,
					textColor: "#FFFFFF",
					visible: !0,
					display: P
				},
				bullFishHook: {
					linestyle: 0,
					linewidth: 3,
					plottype: oe,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: j,
					display: N
				},
				bearFishHook: {
					linestyle: 0,
					linewidth: 3,
					plottype: oe,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: M,
					display: N
				},
				trendBarColumns: {
					linestyle: 0,
					linewidth: 4,
					plottype: ae,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: re,
					display: P
				},
				flashBackground: {
					transparency: 0,
					visible: !0
				}
			},
			palettes: {
				palette_trend_side: { colors: [{
					color: M,
					width: 2,
					style: 0
				}, {
					color: j,
					width: 2,
					style: 0
				}] },
				palette_pulse_slope: { colors: [{
					color: M,
					width: 3,
					style: 0
				}, {
					color: j,
					width: 3,
					style: 0
				}] },
				palette_trade_side: { colors: [{
					color: M,
					width: 1,
					style: 0
				}, {
					color: j,
					width: 1,
					style: 0
				}] },
				palette_trend_bar: { colors: [
					{
						color: p(M, 30),
						width: 4,
						style: 0
					},
					{
						color: p(re, 60),
						width: 4,
						style: 0
					},
					{
						color: p(j, 30),
						width: 4,
						style: 0
					}
				] },
				palette_flash_background: ce.defaults
			},
			filledAreasStyle: {
				glowUpperZone: {
					visible: !0,
					color: M,
					transparency: 88
				},
				glowLowerZone: {
					visible: !0,
					color: j,
					transparency: 88
				}
			},
			precision: 2
		},
		styles: {
			trendDirection: { title: "Trend Direction" },
			pulse: { title: "Pulse Line" },
			previousValue: { title: "Previous Value" },
			upper10: { title: "Upper Band 1.0 Dev" },
			lower10: { title: "Lower Band 1.0 Dev" },
			upper15: { title: "Upper Band 1.5 Dev" },
			lower15: { title: "Lower Band 1.5 Dev" },
			overbought: { title: "Overbought" },
			oversold: { title: "Oversold" },
			upper20: { title: "Glow Upper" },
			lower20: { title: "Glow Lower" },
			bullBallpoint: { title: "Bull Ballpoint" },
			bearBallpoint: { title: "Bear Ballpoint" },
			bullDivLabel: {
				title: "Bullish Divergence",
				isHidden: !1,
				text: `${se}D${se}`,
				size: "small"
			},
			bearDivLabel: {
				title: "Bearish Divergence",
				isHidden: !1,
				text: `${se}D${se}`,
				size: "small"
			},
			bullFishHook: { title: "Fish Hook Bull" },
			bearFishHook: { title: "Fish Hook Bear" },
			trendBarColumns: {
				title: "Trend Bar",
				histogramBase: 0
			},
			flashBackground: {
				title: "Flash Background",
				isHidden: !0
			}
		}
	},
	constructor: function() {
		let n = NaN, r = 0, i = NaN, a = 0, o = NaN, s = 0, c = NaN, l = NaN, u = 0, d = NaN, f = NaN, p = k, m = k, h = C(), _ = "";
		this.init = function() {
			n = NaN, r = 0, i = NaN, a = 0, o = NaN, s = 0, c = NaN, l = NaN, u = 0, d = NaN, f = NaN, p = k, m = k, h.reset(), _ = "";
		}, this.main = function(v, y) {
			this._context = v, this._input = y, v.setMinimumAdditionalDepth(300);
			let b = e.Std.time(v), x = v.symbol.index, S = b !== n;
			S && (n = b);
			let C = y(0), w = y(1), T = y(2), E = y(3), D = y(4), O = y(5), k = y(6), ne = y(7), A = y(8), j = y(9), M = y(10), re = y(11), N = y(12), P = y(15), ie = y(16), ae = y(17), oe = y(18), se = y(19), ce = y(20), le = y(21), F = y(22), ue = y(23) === !0, de = y(24), fe = y(25), pe = y(26), me = y(27) === !0, he = e.Std.close(v), ge = e.Std.high(v), _e = e.Std.low(v), ve = v.new_var(he), ye = v.new_unlimited_var(ge), be = v.new_unlimited_var(_e), I = v.new_unlimited_var(b), xe = (t, n) => e.Std.n(v) >= t ? n : NaN, Se = e.Std.change(ve), Ce = Math.max(Se, 0), L = Math.max(-Se, 0), we = v.new_var(Ce), R = v.new_var(L), Te = e.Std.rma(we, C, v), Ee = e.Std.rma(R, C, v), De = e.Std.rsi(Te, Ee), Oe = v.new_var(De), ke = e.Std.ema(Oe, E, v), Ae = v.new_var(ke), z = e.Std.ema(Ae, E, v), B = Math.max(Math.trunc(1 / w), 2), V = e.Std.ema(Oe, B, v), H = e.Std.sma(Oe, T, v), je = e.Std.stdev(Oe, T, v), Me = H + O * je, Ne = H - O * je, Pe = H + k * je, Fe = H - k * je, Ie = H + D * je, Le = H - D * je, Re = z > 50, ze = v.new_unlimited_var(z), Be = v.new_unlimited_var(V), U = ze.get(1), Ve = ze.get(2), He = Be.get(1), Ue = e.Std.rma(v.new_var(e.Std.tr(!0, v)), ne, v), We = (ge + _e) / 2, Ge = We + A * Ue, Ke = We - A * Ue, qe = ve.get(1);
			S && (c = d, l = f, s = u);
			let Je = isNaN(c) ? Ge : c, Ye = isNaN(l) ? Ke : l;
			Ge = Ge < Je || !isNaN(qe) && qe > Je ? Ge : Je, Ke = Ke > Ye || !isNaN(qe) && qe < Ye ? Ke : Ye;
			let Xe;
			Xe = isNaN(c) ? 1 : s === 1 && he > Ge ? -1 : s === -1 && he < Ke ? 1 : s, d = Ge, f = Ke, u = Xe;
			let Ze = Xe < 0;
			e.Std.atr(100, v) / 2 * M;
			let Qe = e.Std.highest(ye, j, v), $e = e.Std.lowest(be, j, v);
			S && (r = a, i = o);
			let W = r, et = i;
			if (x >= j) if (W === 1) {
				let e = Math.max(isNaN(et) ? $e : et, $e);
				et = e, he < e && (W = -1, et = Qe);
			} else if (W === -1) {
				let e = Math.min(isNaN(et) ? Qe : et, Qe);
				et = e, he > e && (W = 1, et = $e);
			} else {
				let e = ve.get(1);
				W = !isNaN(e) && he > e ? 1 : -1, et = W === 1 ? $e : Qe;
			}
			a = W, o = et;
			let tt = W === 1, nt = xe(re, (e.Std.highest(ye, re, v) + e.Std.lowest(be, re, v)) / 2) > xe(N, (e.Std.highest(ye, N, v) + e.Std.lowest(be, N, v)) / 2), rt = he > e.Std.sar(P, ie, ae, v), it = 0;
			Ze && it++, tt && it++, nt && it++, rt && it++, Re && it++;
			let at = String(e.Std.interval(v)), ot = e.Std.isintraday(v), st = parseInt(at, 10);
			S && (p = m);
			let ct = te(p, x, ze, ye, be, ee(ot, st), e.Std);
			m = ct.state;
			let lt = !isNaN(U) && !isNaN(He) && U <= He && z > V, ut = !isNaN(U) && !isNaN(He) && U >= He && z < V, dt = !isNaN(U) && !isNaN(Ve) && U < Ve && z > U && U < Fe, G = !isNaN(U) && !isNaN(Ve) && U > Ve && z < U && U > Pe, ft = +(!isNaN(U) && z > U), pt = +(V > 50), mt = +!!Re, ht = it >= 4 ? 2 : it <= 1 ? 0 : 1, gt = ze.get(1), _t = !isNaN(U) && U <= 50 && z > 50, vt = !isNaN(U) && U >= 50 && z < 50, yt = _t || dt || ct.bull ? 1 : vt || G || ct.bear ? -1 : 0, bt = v.symbol.isLastBar === !0, xt = h.step({
				isBarClosed: v.symbol.isBarClosed === !0,
				isLastBar: bt,
				isNewBar: S,
				time: b,
				trigger: yt
			}, {
				blinks: de,
				enabled: ue,
				hz: fe,
				test: me,
				transparency: pe
			}, Date.now());
			if (t && bt) {
				let n = g(v, e.Std);
				(xt.fired || S) && t.onFlash({
					...n,
					time: b / 1e3,
					fromTime: I.get(Math.min(400 - !!xt.fired, x)) / 1e3,
					high: xe(60, e.Std.highest(ze, 60, v)),
					low: xe(60, e.Std.lowest(ze, 60, v)),
					direction: xt.direction < 0 ? "sell" : "buy",
					enabled: ue,
					test: me,
					triggered: xt.fired,
					playsOnNextBar: xt.fired,
					showBackground: !0,
					showBanner: !1,
					blinks: de,
					hz: fe,
					transparency: pe
				});
				let r = isNaN(Pe) ? 70 : Pe, i = isNaN(Fe) ? 30 : Fe, a = {
					bearReversal: r,
					bearRetest: (r + 50) / 2,
					trend: 50,
					bullRetest: (i + 50) / 2,
					bullReversal: i
				}, o = [b, ...Object.values(a).map((e) => Math.round(e * 2))].join();
				o !== _ && (_ = o, t.onLevels({
					...n,
					time: b / 1e3,
					...a
				}));
			}
			return [
				50,
				mt,
				z,
				ft,
				V,
				pt,
				ce ? Me : NaN,
				ce ? Ne : NaN,
				le ? Pe : NaN,
				le ? Fe : NaN,
				oe,
				se,
				F ? Ie : NaN,
				F ? Le : NaN,
				lt ? z : NaN,
				ut ? z : NaN,
				ct.bull ? {
					value: gt - 8,
					offset: -1
				} : NaN,
				ct.bear ? {
					value: gt + 8,
					offset: -1
				} : NaN,
				dt ? z : NaN,
				G ? z : NaN,
				5,
				ht,
				xt.stripe
			];
		};
	}
}), F = "feature-indicators", ue = {
	asia: "آسيا",
	atrPeriod: "فترة ATR",
	auraScanner: {
		guide: {
			bigDiamondMark: "كبير أحمر/أخضر",
			bigDiamondMeaning: "المعين الأحمر الكبير فوق قمة يحذر من الشراء. والمعين الأخضر الكبير تحت قاع يحذر من البيع.",
			blueMark: "المنحنى الأزرق",
			blueMeaning: "50 EMA. وجود الوردي فوق الأزرق يعني شراء، وتحته يعني بيعًا.",
			dashedMark: "الخطوط المتقطعة",
			dashedMeaning: "الدعم والمقاومة. الأحمر تحت السعر، والأخضر فوقه.",
			diamondsMark: "المعينات",
			diamondsMeaning: "نقاط انعكاس. الذهبي هو الأضعف، ثم الأزرق، ثم الأحمر والأخضر.",
			flatGoldMark: "الذهبي الأفقي",
			flatGoldMeaning: "مستوى السعر الأعلى حجمًا خلال آخر ست ساعات على مخطط 15 دقيقة.",
			levelsMark: "خطوط المستويات",
			levelsMeaning: "الدخول ووقف الخسارة والأهداف لآخر صفقة. علامة الصح تعني بلوغ المستوى.",
			pinkMark: "المنحنى الوردي",
			pinkMeaning: "20 EMA. تقاطعه مع الأزرق يولد إشارة.",
			subtitle: "كيفية قراءة هذا المخطط",
			thickGoldMark: "الذهبي السميك",
			thickGoldMeaning: "خط 238. إذا كان بين الدخول والهدف، فتجاوز الصفقة.",
			title: "AURA",
			triangleMark: "المثلث",
			triangleMeaning: "صفقة اجتازت جميع الفحوص. مرر المؤشر فوقه لرؤية الأرقام."
		},
		groups: {
			display: "العرض",
			eightChecks: "الفحوص الثمانية",
			riskAndTargets: "المخاطرة والأهداف",
			signalEngine: "محرك الإشارات"
		},
		inputs: {
			emaFastLen: "الخط السريع (الوردي)",
			emaSlowLen: "الخط البطيء (الأزرق)",
			f1Clock: "1. ضمن فترة الحجم الجيد فقط",
			f2Trend: "2. متوافق مع اتجاه 15 دقيقة",
			f3Mode: "3. شمعة بلون غير مناسب",
			f4Min: "الحد الأدنى للتباعد (بيب لكل شمعة)",
			f4Sep: "4. الخطان يتباعدان",
			f5Clear: "5. خط 238 ليس بين الدخول والهدف",
			f6R: "الحد الأدنى للمساحة (× المخاطرة)",
			f6Reward: "6. المساحة حتى المستوى التالي",
			f7Bars: "خلال آخر عدد من الشموع",
			f7Consol: "7. غير عالق في نطاق جانبي",
			f7Pips: "يجب أن يتجاوز النطاق (بيب)",
			f9Bars: "خلال آخر N شموع",
			f9Star: "8. لا يوجد معين تحذير كبير",
			guidePos: "موضع لوحة الدليل",
			longMode: "وضع خط الأمان (238)",
			panelSize: "حجم نص اللوحات",
			pipIn: "حجم البيب (0 = تلقائي)",
			showClock: "لوحة الوضع الحالي",
			showGuide: "دليل معاني العلامات",
			showLadder: "مستويات الصفقة على اليمين",
			showPoc: "خط الحجم",
			showSr: "المستويات المتقطعة",
			showStars: "معينات التحذير",
			showTable: "جدول الاتجاهات",
			showTint: "لون الخلفية",
			showWhy: "شرح الإشارات المتجاوزة",
			slMinPips: "أقل مسافة خلف الخط البطيء (بيب)",
			srAtrMove: "المستويات: الارتداد المطلوب (× حجم الشمعة المعتاد)",
			srLookback: "المستويات: نطاق البحث عن نقاط الانعكاس",
			srMax: "أقصى عدد من المستويات على الشاشة",
			srRange: "تجاهل المستويات الأبعد من (× حجم الشمعة المعتاد)",
			srReset: "المستويات: مرات إعادة الاختبار قبل الإزالة",
			stripLen: "عرض العمود الأيمن (شموع)",
			tablePos: "موضع لوحة الوضع الحالي",
			theme: "سمة المخطط",
			tp1R: "TP1 (مضاعف R)",
			tp2R: "TP2 (مضاعف R)",
			trendPos: "موضع جدول الاتجاهات",
			tz: "المنطقة الزمنية لفترات التداول"
		},
		ladder: {
			closedAtStop: "أُغلقت عند وقف الخسارة",
			closedAtTarget: "أُغلقت TP{{hit}}",
			entry: "الدخول",
			stop: "وقف الخسارة",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "تحجيم تلقائي",
			bottomCentre: "أسفل الوسط",
			bottomLeft: "أسفل اليسار",
			bottomRight: "أسفل اليمين",
			dark: "داكنة",
			ignore: "تجاهل",
			large: "كبير",
			light: "فاتحة",
			literal238: "قيمة ثابتة 238",
			middleCentre: "الوسط",
			middleLeft: "منتصف اليسار",
			middleRight: "منتصف اليمين",
			normal: "عادي",
			reject: "رفض",
			small: "صغير",
			topCentre: "أعلى الوسط",
			topLeft: "أعلى اليسار",
			topRight: "أعلى اليمين",
			waitForPullback: "انتظار التراجع"
		},
		reasons: {
			clock: "خارج فترة التداول",
			diamond: "ظهر للتو معين تحذير كبير",
			range: "المخطط عالق في تذبذب جانبي",
			room: "المستوى قريب جدًا، ولا توجد مساحة حتى الهدف",
			safetyLine: "خط 238 بين الدخول والهدف",
			separation: "الخطان متقاربان جدًا، ولا توجد مساحة للحركة بعد",
			trend: "عكس اتجاه 15 دقيقة",
			wrongColour: "أغلقت شمعة التقاطع بلون غير مناسب"
		},
		rightNow: {
			aBuy: "شراء",
			aSell: "بيع",
			bestBuysOnly: "ابحث عن الشراء فقط",
			bestNow: "الأفضل الآن",
			bestSellsOnly: "ابحث عن البيع فقط",
			bestWaitThin: "انتظر، الحجم ضعيف",
			goodVolume: "حجم جيد",
			lowVolume: "حجم منخفض",
			safetyAbove: "238 فوق السعر، توجد مساحة للبيع",
			safetyBelow: "238 تحت السعر، توجد مساحة للشراء",
			safetyLine: "خط الأمان",
			skipped: "تم التجاوز",
			skippedAgo_one: "{{side}} قبل {{bars}} شمعة: {{reason}}",
			skippedAgo_other: "{{side}} قبل {{bars}} شمعة: {{reason}}",
			skippedNothing: "لم تُتجاوز أي إشارة بعد",
			title: "الوضع الحالي",
			trend: "الاتجاه",
			trendSummaryDown: "15m هابط، و{{agree}} من 6 أطر زمنية صاعدة",
			trendSummaryUp: "15m صاعد، و{{agree}} من 6 أطر زمنية صاعدة",
			skippedAgo_zero: "{{side}} دون مرور أي شمعة ({{bars}}): {{reason}}",
			skippedAgo_two: "{{side}} قبل شمعتين ({{bars}}): {{reason}}",
			skippedAgo_few: "{{side}} قبل {{bars}} شمعات: {{reason}}",
			skippedAgo_many: "{{side}} قبل {{bars}} شمعة: {{reason}}"
		},
		signal: {
			buy: "شراء",
			pips: "بيب",
			sell: "بيع",
			stop: "وقف الخسارة"
		},
		tooltip: {
			f3Mode: "لا يُنفذ الشراء على شمعة حمراء أو البيع على شمعة زرقاء مباشرة. ينتظر وضع انتظار التراجع عودة السعر إلى الخطوط على شمعة باللون المناسب. أما الرفض فيستبعد الإشارة.",
			f4Min: "سرعة تباعد الخطين على شمعة الإشارة. الخطوط المتشابكة والمسطحة لا تترك مساحة للحركة.",
			f6Reward: "يجب أن يبعد المستوى المتقطع التالي بهذه المسافة على الأقل. الخيار معطل افتراضيًا: يرسم الماسح المستويات بطريقته الخاصة، لذا تحقق من المساحة بالنظر أيضًا.",
			f7Pips: "تجنب نطاقات التذبذب بعرض 100 بيب أو أقل.",
			longMode: "238 هو الإعداد القياسي لمخططات الدقيقة الواحدة. يكيف التحجيم التلقائي خط الأمان مع الأطر الأخرى، فيصبح نحو 83 على مخطط ثلاث دقائق.",
			pipIn: "تلقائي: 0.10 للذهب، وعشر حركات سعرية دنيا لبقية الأدوات (نقطة واحدة على US30).",
			showGuide: "دليل مختصر على المخطط. أوقفه بعد معرفة العلامات.",
			showLadder: "تُرسم مستويات الدخول ووقف الخسارة والأهداف لآخر صفقة على يمين آخر شمعة. تُضاف علامة صح إلى الأهداف عند بلوغها.",
			showWhy: "عندما يتقاطع الخطان لكن أحد الفحوص يمنع الصفقة، توضح لوحة الوضع الحالي الفحص والسبب.",
			slMinPips: "يوضع وقف الخسارة على الجانب الآخر من الخطين الأحمر والأزرق، وعلى بُعد 10 بيب على الأقل من الأزرق.",
			srMax: "تُحفظ فقط المستويات الأقرب إلى السعر حتى يبقى المخطط واضحًا.",
			theme: "اختر ما يطابق سمة TradingView لتبقى جميع الألوان واضحة.",
			tz: "تُحدد فترات التداول بهذه المنطقة الزمنية. America/Denver هو توقيت الجبال في أمريكا الشمالية مع التوقيت الصيفي. استخدم America/Phoenix لتوقيت الجبال دون تغيير صيفي."
		},
		trendTable: {
			above: "أعلى",
			below: "أسفل",
			down: "هابط",
			notAvailable: "غير متاح",
			up: "صاعد",
			volumeLine: "خط الحجم"
		}
	},
	bearish: "هابط",
	bfs: {
		duplicateRemoved: "لا يُدعم سوى مؤشر واحد من BFS — Blessed Flow System لكل رسم بياني، وقد تم حذف النسخة المكررة.",
		emaCrossSoon: "EMA30/50 على وشك التقاطع",
		engineOff: "انتقل إلى M1",
		engineOn: "المحرك M1",
		input: {
			armWin: "النافذة (شموع M1) للمس EMA30",
			asiaSess: "آسيا (HHMM-HHMM)",
			bePts: "التعادل: عند +نقاط ينتقل الوقف إلى ذلك المستوى",
			cooldown: "فترة توقف (شموع M1) بعد إغلاق الصفقة",
			lenFast: "EMA السريع (الاتجاه)",
			lenH1a: "H1 · EMA القصير",
			lenH1b: "H1 · EMA الطويل",
			lenMid: "EMA المتوسط",
			lenSlow: "EMA البطيء",
			londonSess: "لندن (HHMM-HHMM، ساعة الجلسة)",
			maxPerBlock: "أقصى عدد دخول في فترة الجلسة (0 = بلا حد)",
			nearLb: "عدد الشموع لقياس التقارب",
			nearPts: "أقصى مسافة بين EMA30 و EMA50 (نقاط)",
			nySess: "نيويورك (HHMM-HHMM)",
			onlyM1: "تشغيل المحرك على M1 فقط",
			pv: "قيمة النقطة الواحدة بالسعر",
			r1lb: "R1 · عدد شموع M1 للخلف (السعر غير ممتد)",
			rr: "نسبة الهدف R:R (عند إيقاف الأهداف المتعددة)",
			rsiHi: "RSI >= للشورت",
			rsiLen: "طول RSI",
			rsiLo: "RSI <= للونج",
			rsiWin: "نافذة الانتظار (شموع بعد الإشارة)",
			showLevels: "رسم مستويات الصفقة",
			showNear: "التعليم عندما يقترب EMA30 من تقاطع EMA50",
			slPts: "وقف الخسارة (نقاط)",
			swLenA: "قوة النقطة المحورية (شموع على كل جانب)",
			tp1Pts: "TP1 (نقاط)",
			tp2Pts: "TP2 (نقاط)",
			tp3Pts: "TP3 (نقاط)",
			tzOffset: "فرق UTC لساعة الجلسة (بوغوتا = -5)",
			useArm: "اشتراط تصحيح 50% ولمس EMA30 داخل النافذة",
			useAsia: "تضمين آسيا (للاختبار فقط)",
			useBE: "تفعيل نقطة التعادل",
			useLadder: "استخدام TP1/TP2/TP3 (الخروج النهائي = TP3)",
			useR2: "R2 · اشتراط ترتيب M5 + M15 واتجاه H1",
			useRSI: "انتظار RSI بعد الإشارة",
			useSess: "التصفية حسب الجلسة",
			useTrend: "الحفاظ على ترتيب EMA أثناء الانتظار"
		},
		longSignal: "إشارة لونج",
		noSignal: "لا توجد إشارة",
		retracementDot: "نقطة تصحيح 50%",
		rewardZone: "منطقة الربح",
		riskZone: "منطقة المخاطرة",
		session: "الجلسة",
		sessionClosed: "مغلقة",
		sessionOpen: "مفتوحة",
		shortSignal: "إشارة شورت",
		signal: "الإشارة",
		signalActive: "{{side}} قائمة",
		waitingRsi: "في انتظار RSI {{arrow}} ({{n}})",
		waitingRsiLong: "في انتظار RSI (لونج)",
		waitingRsiShort: "في انتظار RSI (شورت)"
	},
	breakEven: "نقطة التعادل",
	bullish: "صاعد",
	buy: "شراء",
	colour: "اللون",
	cypher: {
		above55: "أعلى 55",
		aboveBelow: "أعلى/أسفل",
		barColors: "ألوان الشموع",
		bbLength: "طول BB",
		bbStdDev: "الانحراف المعياري BB {{n}}",
		bearBreak: "اختراق هابط",
		bearPattern: "شمعة دبوس / ابتلاع هابط",
		below55: "أسفل 55",
		bullBreak: "اختراق صاعد",
		bullPattern: "شمعة دبوس / ابتلاع صاعد",
		cmoLength: "طول CMO",
		colorCandles: "تلوين الشموع",
		confluenceLong: "التقاء لونج",
		confluenceShort: "التقاء شورت",
		consolidating: "تماسك",
		direction: "الاتجاه",
		emaPeriodTrend: "فترة EMA (الاتجاه)",
		flagOffsetAtr: "إزاحة العلم (x ATR)",
		flashBackground: "خلفية الوميض",
		flashCount: "عدد الومضات",
		flashHz: "سرعة الوميض (ومضة / ثانية)",
		flashOn: "وميض عند علم جديد",
		flashShowBanner: "إظهار شعار NEW BUY / SELL",
		flashShowBg: "وميض خلفية الرسم البياني",
		flashStrength: "شدة وميض الخلفية",
		flashTest: "اختبار الوميض الآن (معاينة)",
		fvgKeep: "عدد فجوات القيمة العادلة لكل جانب",
		glowOpacity: "عتامة التوهج (أعلى = أكثر شفافية)",
		glowSizeTicks: "حجم التوهج (تيك)",
		groupFlash: "تنبيه العلم الجديد",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "مستويات KDE",
		groupKeyLevels: "المستويات الرئيسية",
		groupLrEma: "قناة LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "نقاط الارتكاز",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "نطاقات الانعكاس",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "المكونات",
		groupTrendTable: "جدول الترند",
		groupVidya: "VIDYA / الترند",
		halfTrendAmplitude: "سعة HalfTrend",
		halfTrendChannelDeviation: "انحراف قناة HalfTrend",
		ichimokuBase: "خط الأساس Ichimoku",
		ichimokuConversion: "خط التحويل Ichimoku",
		kdeActivation: "تفعيل حد التنشيط",
		kdeBins: "عدد الفئات",
		kdeThreshold: "الحد %",
		labelPosition: "موضع التسمية",
		lineWidth: "سماكة الخط",
		lowerBb: "BB{{n}} السفلي",
		lowerInnerZone: "المنطقة الداخلية السفلية",
		lowerReversalZone: "منطقة الانعكاس السفلية",
		maCloudLong: "سحابة MA (طويلة)",
		maCloudShort: "سحابة MA (قصيرة)",
		newBuy: "شراء جديد",
		newSell: "بيع جديد",
		numberOfLevels: "عدد المستويات",
		parabolicSar: "SAR المكافئ",
		pivotAuto: "تلقائي",
		pivotDaily: "يومي",
		pivotMonthly: "شهري",
		pivotsTimeframe: "الإطار الزمني للنقاط المحورية",
		pivotWeekly: "أسبوعي",
		positionBottomCenter: "أسفل الوسط",
		positionBottomLeft: "أسفل اليسار",
		positionBottomRight: "أسفل اليمين",
		positionLeft: "يسار",
		positionRight: "يمين",
		positionTopCenter: "أعلى الوسط",
		positionTopLeft: "أعلى اليسار",
		positionTopRight: "أعلى اليمين",
		psarBear: "PSAR هابط",
		psarBull: "PSAR صاعد",
		psarIncrement: "زيادة PSAR",
		psarMax: "حد PSAR الأقصى",
		psarStart: "بداية PSAR",
		pullingBack: "تراجع",
		pulseSmoothingBars: "أشرطة تنعيم Pulse",
		reEntry: "إعادة الدخول",
		rightOffsetBars: "الإزاحة لليمين (شموع)",
		showCamarillaPivots: "إظهار نقاط كاماريلا المحورية",
		showConfluenceFlag: "إظهار علم الالتقاء (B/S)",
		showFvg: "فجوات القيمة العادلة (15 دقيقة فأكثر)",
		showKde: "مستويات حجم KDE",
		showKeyLevels: "إظهار المستويات الرئيسية",
		showLabels: "إظهار التسميات",
		showLevelGlow: "إظهار توهج المستوى",
		showMaCloud: "إظهار سحابة MA",
		showPrices: "إظهار الأسعار",
		showPsar: "إظهار PSAR",
		showReversalBands: "إظهار نطاقات الانعكاس",
		showSlTpLabels: "إظهار ملصقات SL / TP",
		showSniperBreakArrows: "إظهار أسهم Sniper / الاختراق",
		showTrendTable: "إظهار جدول الترند",
		showVidya233: "إظهار VIDYA 233",
		showVidya55: "إظهار VIDYA 55",
		showVidya987: "إظهار VIDYA 987 (مغناطيس)",
		showVidyaLines: "إظهار خطوط VIDYA",
		sizeNormal: "عادي",
		sizeSmall: "صغير",
		sizeTiny: "صغير جدًا",
		slBufferAtr: "SL: حد الهامش (x ATR)",
		slBufferPips: "SL: هامش بعد القمة/القاع (نقاط)",
		slMaxRiskAtr: "SL: أقصى مخاطرة (x ATR)",
		slSwingLookback: "SL: نطاق البحث عن القمة/القاع (شموع)",
		sniperDown: "Sniper هابط",
		sniperUp: "Sniper صاعد",
		source: "المصدر",
		state: "الحالة",
		strength: "القوة",
		strong: "قوي",
		superTrend2AtrLength: "طول ATR لـ SuperTrend 2",
		superTrend2Factor: "معامل SuperTrend 2",
		superTrendAtrLength: "طول ATR لـ SuperTrend",
		superTrendMultiplier: "مضاعف SuperTrend",
		tablePosition: "موضع الجدول",
		tableSize: "حجم الجدول",
		tpRiskReward: "TP {{n}} المخاطرة/العائد",
		tradeManagement: "إدارة الصفقة (SL / TP)",
		trend: "الترند",
		trending: "في اتجاه",
		upperBb: "BB{{n}} العلوي",
		upperInnerZone: "المنطقة الداخلية العلوية",
		upperReversalZone: "منطقة الانعكاس العلوية",
		veryStrong: "قوي جدًا",
		veryWeak: "ضعيف جدًا",
		vidya987Magnet: "VIDYA 987 (مغناطيس)",
		volumeAvgLength: "طول متوسط الحجم (مرشح الاختراق)",
		weak: "ضعيف",
		zoneEdge: "{{name}} (حافة التعبئة)"
	},
	entry: "الدخول",
	gainColor: "لون الربح",
	harsiCandle: "شمعة HARSI",
	harsiLength: "طول HARSI",
	heikinAshiRsiOscillator: "مذبذب RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "القيمة الرئيسية 'هذا يغير الحساسية'",
	labelsIndicator: "مؤشر التسميات",
	london: "لندن",
	londonBackground: "خلفية لندن",
	londonSession: "جلسة لندن",
	long: "لونج",
	lossColor: "لون الخسارة",
	median: "الوسيط",
	neutral: "محايد",
	newYork: "نيويورك",
	newYorkBackground: "خلفية نيويورك",
	newYorkSession: "جلسة نيويورك",
	openSmoothing: "تنعيم الافتتاح",
	optimus: {
		activeTradeLevels: "صفقة قائمة · المستويات",
		bias: "الاتجاه",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "متباين {{n}}/{{total}}",
		disclaimer: "المستويات مرسومة على الرسم البياني. هذا ليس نصيحة مالية.",
		duplicateRemoved: "لا يُدعم سوى مؤشر واحد من Optimus Prime لكل رسم بياني، وقد تم حذف النسخة المكررة.",
		enter: "دخول · {{side}}",
		input: {
			atrLength: "طول ATR الخاص بـ KC",
			buffer: "هامش التمايل (بالسعر)",
			emaLength: "طول EMA",
			kcLength: "طول KC",
			kcMult: "مضاعف KC",
			lrcLength: "طول LRC",
			minRisk: "أدنى مخاطرة R (بالسعر)",
			requireAlign: "اشتراط توافق EMA و LRC",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "عدد الشموع للخلف للتمايل (R)"
		},
		kcLower: "KC الأدنى",
		kcMid: "KC الأوسط",
		kcUpper: "KC الأعلى",
		keltnerFill: "تظليل كيلتنر",
		noClosedTrades: "لا توجد صفقات مغلقة بعد",
		reasonForming: "النموذج قيد التكوّن — في انتظار التأكيد",
		reasonLatched: "الصفقة مثبّتة · المستويات على الرسم",
		reasonNoSetup: "لا يوجد نموذج · EMA/LRC غير متوافقين",
		recentSignals: "أحدث الإشارات",
		riskReward: "المخاطرة/الربح",
		trendMtf: "الاتجاه · أطر زمنية متعددة",
		wait: "انتظار",
		warmingUp: "قيد التهيئة"
	},
	overbought: "شراء مفرط",
	overboughtMax: "الشراء المفرط (الأقصى)",
	overboughtMin: "الشراء المفرط (الأدنى)",
	oversold: "بيع مفرط",
	oversoldMax: "البيع المفرط (الأقصى)",
	oversoldMin: "البيع المفرط (الأدنى)",
	rsiLength: "طول RSI",
	rsiLine: "خط RSI",
	rsiLineShadow: "ظل خط RSI",
	sell: "بيع",
	short: "شورت",
	signalsFromHeikinAshiCandles: "إشارات من شموع Heikin Ashi",
	sl: "وقف الخسارة",
	smoothedMode: "وضع التنعيم",
	sydney: "سيدني",
	sydneyBackground: "خلفية سيدني",
	sydneySession: "جلسة سيدني",
	tfD1: "1ي",
	tfH1: "1س",
	tfH4: "4س",
	tfM1: "1د",
	tfM15: "15د",
	tfM30: "30د",
	tfM5: "5د",
	tokyo: "طوكيو",
	tokyoBackground: "خلفية طوكيو",
	tokyoSession: "جلسة طوكيو",
	tp: "جني الربح {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "هابط",
			bullish: "صاعد",
			confluence: "التقاء",
			entry: "الدخول",
			neckline: "خط العنق",
			score: "النتيجة",
			state: "الحالة",
			states: {
				completed: "مكتمل",
				invalidated: "ملغى",
				projected: "متوقع",
				przActive: "PRZ نشطة",
				stopped: "تم الوصول للوقف"
			},
			stop: "الوقف",
			target: "الهدف"
		},
		classic: {
			doubleBottom: "القاع المزدوج",
			doubleTop: "القمة المزدوجة",
			headAndShoulders: "الرأس والكتفين",
			inverseHeadAndShoulders: "رأس وكتفين مقلوب",
			tripleBottom: "القاع الثلاثي",
			tripleTop: "القمة الثلاثية"
		},
		direction: {
			bearishOnly: "الهابط فقط",
			both: "الاثنان",
			bullishOnly: "الصاعد فقط"
		},
		group: {
			classics: "الأنماط الكلاسيكية والدعم/المقاومة (S/R)",
			filters: "الفلاتر والعرض",
			patterns: "الأنماط",
			pivotEngine: "محرك النقاط المحورية",
			ratios: "النسب والتسامح"
		},
		input: {
			atrLen: "فترة ATR",
			atrMult: "انعكاس زيجزاج (x ATR)",
			colBear: "هابط",
			colBull: "صاعد",
			colPrz: "PRZ",
			colSR: "المستويات الرئيسية",
			dirFilter: "فلتر الاتجاه",
			enClassics: "اكتشاف الأنماط الكلاسيكية",
			enDoubles: "القمة / القاع المزدوج",
			enHS: "الرأس والكتفين",
			enTriples: "القمة / القاع الثلاثي",
			fillTransp: "شفافية تعبئة النمط",
			formingLife: "عمر منطقة التشكّل (شموع)",
			keepFailed: "إبقاء الأنماط التي ضُرب وقفها على الرسم (✕، باهتة)",
			keepSuccessful: "إبقاء الأنماط الناجحة على الرسم (✓)",
			maxPatterns: "أقصى عدد للأنماط على الرسم",
			minScore: "الحد الأدنى لدرجة الجودة",
			pivotDepth: "عمق مخزن النقاط المحورية",
			showLetters: "إظهار حروف النقاط X A B C D",
			showPlan: "إظهار مستويات خطة التداول",
			showProjected: "إظهار الأنماط المتوقعة (قيد التشكّل)",
			showRatios: "إظهار أرقام النسب على الأضلاع",
			showSR: "مستويات الدعم/المقاومة",
			showStats: "إظهار جدول الإحصاءات",
			srMinTouch: "S/R: الحد الأدنى للمسات النقطة المحورية",
			tolEdge: "التسامح عند حافة النطاق",
			tolPoint: "التسامح في نسب النقاط",
			useScale2: "فحص مقياس 2x أيضًا (هياكل أكبر)"
		},
		label: {
			confirmed: "مؤكد",
			forming: "قيد التشكّل",
			sl: "SL",
			target: "الهدف",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "المنتهية",
			stops: "وقف الخسارة",
			t1Wins: "بلغت T1",
			winRate: "نسبة النجاح %"
		},
		tooltip: {
			colPrz: "منطقة PRZ بلون كهرماني بغض النظر عن اتجاه النمط (الإعداد الافتراضي في ProTrader).",
			fillTransp: "القيمة الأقل تعني تعبئة أوضح. القيم بين 65 و80 مناسبة.",
			formingLife: "النمط قيد التشكّل الذي تكون نقطته C أقدم من هذه القيمة، دون أن يكتمل أو يُلغى، تنتهي صلاحيته ويُحذف.",
			maxPatterns: "تُحذف الأنماط الأقدم أولاً، بحيث يبقى السجل الحديث (✓ / ✕) ومناطق التشكّل الجديدة ظاهرة دائماً.",
			showProjected: "يرسم بنية X-A-B مع خط إرشادي متقطع نحو منطقة PRZ المتوقعة.",
			showRatios: "أقطار قياس منقّطة (X-B، A-C، B-D، X-D) مع نسبة فيبوناتشي المقاسة في منتصف كل منها، وهو الترميز المعتاد في الرسوم التوافقية.",
			tolPoint: "يُطبَّق على النسب الدقيقة مثل Gartley B=0.618. صارم = 0.03، متوازن = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ إغلاق الكل",
		duplicateRemoved: "لا يُدعم سوى مؤشر واحد من Trade Finder لكل رسم بياني، وقد تم حذف النسخة المكررة.",
		durationHm: "{{h}} س {{m}} د",
		durationM: "{{m}} د",
		emaEntry1: "EMA الدخول 1",
		emaEntry2: "EMA الدخول 2 / الاتجاه",
		emaRangeFilter: "EMA مرشّح النطاق",
		emaTrigger: "EMA المُشغّل",
		entry1: "الدخول 1",
		entry2: "الدخول 2",
		entry2Mark: "E2",
		entryZoneBear: "منطقة الدخول {{n}} (هابط)",
		entryZoneBull: "منطقة الدخول {{n}} (صاعد)",
		frameFailed: "تعذّر تحميل الإطار الزمني {{frame}}؛ ستتم إعادة المحاولة.",
		framesUnavailable: "لا توجد بيانات للأطر الزمنية · انتظار",
		ghostEntry: "الإعداد السابق",
		ghostStop: "الوقف السابق",
		group: {
			bias: "الانحياز",
			display: "العرض",
			emaSystem: "نظام EMA",
			entries: "الدخول",
			filter: "المرشّح",
			riskManagement: "إدارة المخاطر",
			session: "الجلسة",
			supportResistance: "الدعم والمقاومة",
			trailingStop: "وقف متحرك",
			trendPanel: "لوحة الاتجاه"
		},
		input: {
			adxLen: "طول ADX",
			adxSmoothing: "تنعيم ADX",
			asiaSession: "جلسة آسيا / طوكيو (UTC)",
			atrBufferMultBtc: "هامش الوقف خلف التأرجح — بيتكوين (× ATR)",
			atrBufferMultGold: "هامش الوقف خلف التأرجح — الذهب (× ATR)",
			atrBufferMultOther: "هامش الوقف خلف التأرجح — غير ذلك (× ATR)",
			atrLength: "طول ATR (إدارة المخاطر)",
			atrSlMult: "وقف الخسارة = ATR ×",
			atrTpMult: "جني الربح {{n}} = ATR ×",
			beGoldPoints: "الذهب: الانتقال إلى التعادل بعد هذا العدد من النقاط",
			biasEmaLen: "طول EMA للانحياز",
			crossLookback: "نطاق تقاطعات الانحياز (شموع)",
			dxySymbol: "رمز مؤشر الدولار (اتركه فارغًا لتعطيله)",
			emaBigLen: "طول EMA مرشّح النطاق",
			emaFastLen: "طول EMA الدخول 1",
			emaMidLen: "طول EMA الدخول 2 / الاتجاه",
			emaTriggerLen: "طول EMA المُشغّل",
			feeBufferPct: "هامش الرسوم بعد نقطة التعادل (%)",
			flatThreshPct: "عتبة الاستواء (% من EMA الانحياز)",
			londonSession: "جلسة لندن (UTC)",
			maxCrosses: "أقصى عدد تقاطعات قبل تجاهل الانحياز",
			newYorkSession: "جلسة نيويورك (UTC)",
			showEmaLabels: "إظهار تسميات أسماء EMA",
			showEntrySignals: "إظهار علامات الإعداد",
			showEntryZone: "إظهار منطقة الدخول",
			showSRLines: "إظهار الدعم والمقاومة",
			showTradeLevels: "إظهار مستويات الدخول والوقف والأهداف",
			slMaxPointsBtc: "أقصى مسافة للوقف — بيتكوين (نقاط)",
			slMaxPointsGold: "أقصى مسافة للوقف — الذهب (نقاط)",
			slMaxPointsIndex: "أقصى مسافة للوقف — المؤشرات (نقاط)",
			slMaxPointsOther: "أقصى مسافة للوقف — غير ذلك (نقاط)",
			slMinPointsGold: "أدنى مسافة للوقف — الذهب (نقاط)",
			slopeLookback: "نطاق ميل الانحياز (شموع)",
			srLeftBars: "الدعم / المقاومة · الشموع على يسار المحور",
			srRightBars: "الدعم / المقاومة · الشموع على يمين المحور",
			swingPivotLen: "طول محور التأرجح (وقف الخسارة)",
			tp1ClosePct: "إغلاق عند الهدف 1 (%)",
			tp2ClosePct: "إغلاق عند الهدف 2 (%)",
			tp5CloseAlways: "جني الربح 5 يُغلق دائمًا، حتى مع الوقف المتحرك",
			tpR: "جني الربح {{n}} (بوحدة R)",
			tpSlMode: "وضع الوقف والأهداف",
			trailAtrMult: "مسافة الوقف المتحرك (× ATR)",
			trendPanelEmaLen: "طول EMA لصف الاتجاه",
			trendSlopeLB: "فترة ميل المتوسط للدخول 2 (شموع)",
			useAdxFilter: "اشتراط ADX فوق عتبة النمط",
			useBiasFilter: "احتساب انحياز الإطار الأعلى (لا يمنع الدخول)",
			useEmaStackCheck: "اشتراط ترتيب المتوسطات المتحركة",
			useInstrumentAutoDetect: "اكتشاف الأداة تلقائيًا",
			useSessionFilter: "إظهار الإشارات خلال جلسات التداول فقط",
			useSlopeDynamic: "مواءمة فترة الميل مع الإطار الزمني",
			useStrictCandle: "مرشح شمعة صارم (الظل والإغلاق)",
			useTrailingStop: "وقف متحرك (بدءًا من جني الربح 1)",
			useVolumeConfirm: "اشتراط حجم أعلى من المتوسط عند الدخول",
			volAvgLen: "طول متوسط الحجم",
			volMultiplier: "الحد الأدنى للحجم (× المتوسط)"
		},
		maxStop: "أقصى وقف خسارة",
		minuteAgainst: "تقاطع ضد الإعداد",
		minuteOk: "لا توجد تحذيرات",
		minuteReversal: "تقاطع · احتمال انعكاس",
		modeAtr: "ATR",
		modeAuto: "تلقائي",
		modeRiskReward: "المخاطرة / العائد",
		noBias: "لا يوجد ميل",
		noSetup: "لا يوجد إعداد نشط",
		recentTitle: "الإعدادات الأخيرة",
		reEntry: "إعادة الدخول",
		reEntryMark: "RE",
		rest: "الباقي",
		rowBias: "الميل",
		rowContext: "السياق",
		rowInfo: "معلومات",
		rowSession: "الجلسة",
		rowSetup: "الإعداد",
		rowVolume: "الحجم",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "يتبقى {{time}}",
		sessionOutside: "خارج الساعات · لندن {{time}} UTC",
		sessionOverlap: "تداخل الجلسات",
		statsTitle: "آخر {{n}} إعدادات",
		statusBreakEvenSet: "نقطة التعادل",
		statusMoveToBreakEven: "حرّك الوقف",
		statusPending: "ملامسة المنطقة",
		statusRunning: "قيد التنفيذ",
		statusSpike: "تقلب · انتظار",
		statusWaiting: "بانتظار",
		stopHit: "تم بلوغ وقف الخسارة",
		styleDaytrade: "التداول اليومي",
		styleScalping: "المضاربة السريعة",
		styleSwing: "التأرجح",
		subFrameReversal: "الإطار الزمني الأدنى ينعكس",
		targetHit: "تم بلوغ الهدف النهائي",
		trailStop: "وقف متحرك",
		volAboveAverage: "أعلى من المتوسط",
		volBelowAverage: "أقل من المتوسط",
		zoneEdgeBear: "حافة المنطقة {{n}} (هابط)",
		zoneEdgeBull: "حافة المنطقة {{n}} (صاعد)"
	},
	tradingSessions: "جلسات التداول",
	unintendedSymbol: "هذه الاستراتيجية مصممة لـ {{symbols}}، وقد لا تكون مستوياتها ذات معنى على {{symbol}}.",
	utBotAlerts: "تنبيهات UT Bot"
}, de = {
	asia: "Asien",
	atrPeriod: "ATR-Periode",
	auraScanner: {
		guide: {
			bigDiamondMark: "Groß, rot/grün",
			bigDiamondMeaning: "Groß und rot über einem Hoch warnt vor Käufen. Groß und grün unter einem Tief vor Verkäufen.",
			blueMark: "Blaue Kurve",
			blueMeaning: "50 EMA. Rosa über Blau bedeutet Kauf, darunter Verkauf.",
			dashedMark: "Gestrichelte Linien",
			dashedMeaning: "Unterstützung und Widerstand. Rot unter dem Kurs, grün darüber.",
			diamondsMark: "Rauten",
			diamondsMeaning: "Wendepunkte. Gold ist am schwächsten, dann folgen Blau, Rot und Grün.",
			flatGoldMark: "Waagerecht, goldfarben",
			flatGoldMeaning: "Der umsatzstärkste Kurs im 15-Minuten-Chart über die letzten sechs Stunden.",
			levelsMark: "Niveaulinien",
			levelsMeaning: "Einstieg, Stopp und Ziele des letzten Trades. Ein Häkchen bedeutet erreicht.",
			pinkMark: "Rosa Kurve",
			pinkMeaning: "20 EMA. Ihr Kreuzen der blauen Linie erzeugt ein Signal.",
			subtitle: "So liest du diesen Chart",
			thickGoldMark: "Dick, goldfarben",
			thickGoldMeaning: "Die 238. Liegt sie zwischen Einstieg und Ziel, auslassen.",
			title: "AURA",
			triangleMark: "Dreieck",
			triangleMeaning: "Ein Trade, der alle Prüfungen bestanden hat. Mit der Maus darüber werden die Werte angezeigt."
		},
		groups: {
			display: "Anzeige",
			eightChecks: "Die acht Prüfungen",
			riskAndTargets: "Risiko und Ziele",
			signalEngine: "Signallogik"
		},
		inputs: {
			emaFastLen: "Schnelle Linie (rosa)",
			emaSlowLen: "Langsame Linie (blau)",
			f1Clock: "1. Nur im Zeitfenster mit gutem Handelsvolumen",
			f2Trend: "2. Im Einklang mit dem 15-Minuten-Trend",
			f3Mode: "3. Kerze mit falscher Farbe",
			f4Min: "Mindestzunahme des Abstands (Pips je Kerze)",
			f4Sep: "4. Linien entfernen sich voneinander",
			f5Clear: "5. 238 nicht zwischen Einstieg und Ziel",
			f6R: "Mindestspielraum (× Risiko)",
			f6Reward: "6. Platz bis zum nächsten Niveau",
			f7Bars: "Über die letzten (Kerzen)",
			f7Consol: "7. Nicht in einer Seitwärtsspanne",
			f7Pips: "Spanne muss größer sein als (Pips)",
			f9Bars: "Innerhalb der letzten N Kerzen",
			f9Star: "8. Keine große Warnraute",
			guidePos: "Position der Erklärung",
			longMode: "Modus der Sicherheitslinie (238)",
			panelSize: "Textgröße der Tafeln",
			pipIn: "Pip-Größe (0 = automatisch)",
			showClock: "Tafel zur aktuellen Lage",
			showGuide: "Erklärung der Markierungen",
			showLadder: "Handelsniveaus rechts",
			showPoc: "Volumenlinie",
			showSr: "Gestrichelte Niveaus",
			showStars: "Warnrauten",
			showTable: "Trendtabelle",
			showTint: "Hintergrundfarbe",
			showWhy: "Ausgelassene Signale erklären",
			slMinPips: "Mindestabstand hinter der langsamen Linie (Pips)",
			srAtrMove: "Niveaus: erforderlicher Abprall (× übliche Kerzengröße)",
			srLookback: "Niveaus: Rückblick für Wendepunkte",
			srMax: "Höchstzahl sichtbarer Niveaus",
			srRange: "Entferntere Niveaus ignorieren (× übliche Kerzengröße)",
			srReset: "Niveaus: erneute Tests bis zur Entfernung",
			stripLen: "Breite der rechten Spalte (Kerzen)",
			tablePos: "Position der aktuellen Lage",
			theme: "Chart-Farbschema",
			tp1R: "TP1 (R-Multiplikator)",
			tp2R: "TP2 (R-Multiplikator)",
			trendPos: "Position der Trendtabelle",
			tz: "Zeitzone der Handelsfenster"
		},
		ladder: {
			closedAtStop: "GESCHLOSSEN am Stopp",
			closedAtTarget: "GESCHLOSSEN TP{{hit}}",
			entry: "EINSTIEG",
			stop: "STOPP",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Automatisch skalieren",
			bottomCentre: "Unten mittig",
			bottomLeft: "Unten links",
			bottomRight: "Unten rechts",
			dark: "Dunkel",
			ignore: "Ignorieren",
			large: "Groß",
			light: "Hell",
			literal238: "Fester Wert 238",
			middleCentre: "Mittig zentriert",
			middleLeft: "Mitte links",
			middleRight: "Mitte rechts",
			normal: "Standardgröße",
			reject: "Verwerfen",
			small: "Klein",
			topCentre: "Oben mittig",
			topLeft: "Oben links",
			topRight: "Oben rechts",
			waitForPullback: "Rücksetzer abwarten"
		},
		reasons: {
			clock: "außerhalb der Handelsfenster",
			diamond: "gerade ist eine große Warnraute erschienen",
			range: "der Chart steckt in einer Seitwärtsphase",
			room: "ein Niveau liegt zu nah, kein Platz bis zum Ziel",
			safetyLine: "die 238 liegt zwischen Einstieg und Ziel",
			separation: "die Linien liegen zu dicht beieinander, noch kein Bewegungsspielraum",
			trend: "gegen den 15-Minuten-Trend",
			wrongColour: "die Kreuzungskerze schloss in der falschen Farbe"
		},
		rightNow: {
			aBuy: "Kauf",
			aSell: "Verkauf",
			bestBuysOnly: "nur Käufe suchen",
			bestNow: "Jetzt am besten",
			bestSellsOnly: "nur Verkäufe suchen",
			bestWaitThin: "abwarten, geringes Volumen",
			goodVolume: "Hohes Volumen",
			lowVolume: "Geringes Volumen",
			safetyAbove: "238 über dem Kurs, Spielraum für Verkäufe",
			safetyBelow: "238 unter dem Kurs, Spielraum für Käufe",
			safetyLine: "Sicherheitslinie",
			skipped: "Ausgelassen",
			skippedAgo_one: "{{side}} vor {{bars}} Kerze: {{reason}}",
			skippedAgo_other: "{{side}} vor {{bars}} Kerzen: {{reason}}",
			skippedNothing: "bisher nichts ausgelassen",
			title: "JETZT",
			trend: "Trendrichtung",
			trendSummaryDown: "15m abwärts, {{agree}} von 6 Zeiteinheiten aufwärts",
			trendSummaryUp: "15m aufwärts, {{agree}} von 6 Zeiteinheiten aufwärts"
		},
		signal: {
			buy: "KAUF",
			pips: "Pips",
			sell: "VERKAUF",
			stop: "Stopp"
		},
		tooltip: {
			f3Mode: "Ein Kauf auf einer roten oder ein Verkauf auf einer blauen Kerze wird nie direkt ausgeführt. Rücksetzer abwarten wartet, bis der Kurs auf einer Kerze der richtigen Farbe zu den Linien zurückkehrt. Verwerfen lehnt das Signal ab.",
			f4Min: "Wie schnell sich die Linien auf der Signalkerze voneinander entfernen. Verflochtene, flache Linien lassen keinen Bewegungsspielraum.",
			f6Reward: "Das nächste gestrichelte Niveau muss mindestens so weit entfernt sein. Standardmäßig aus: Die Niveaus stammen aus dem eigenen Verfahren dieses Scanners. Den Spielraum daher auch nach Augenmaß prüfen.",
			f7Pips: "Konsolidierungen von höchstens 100 Pips meiden.",
			longMode: "238 ist die Standardeinstellung für Ein-Minuten-Charts. Automatisch skalieren passt die Sicherheitslinie anderen Zeiteinheiten an, etwa 83 bei drei Minuten.",
			pipIn: "Automatisch: 0.10 bei Gold, sonst zehn Ticks (1 Punkt bei US30).",
			showGuide: "Eine kurze Erklärung im Chart. Abschalten, sobald die Markierungen bekannt sind.",
			showLadder: "Einstieg, Stopp und Ziele des letzten Trades stehen rechts neben der letzten Kerze. Erreichte Ziele erhalten ein Häkchen.",
			showWhy: "Wenn sich die Linien kreuzen, aber eine Prüfung den Trade verhindert, zeigt die Tafel zur aktuellen Lage die Prüfung und den Grund.",
			slMinPips: "Der Stopp liegt jenseits der roten und der blauen Linie, mindestens 10 Pips von der blauen entfernt.",
			srMax: "Nur die kursnächsten Niveaus bleiben sichtbar, damit der Chart lesbar bleibt.",
			theme: "An das TradingView-Farbschema anpassen, damit alle Farben gut erkennbar sind.",
			tz: "Die Handelsfenster gelten in dieser Zeitzone. America/Denver nutzt die nordamerikanische Mountain-Zeit mit Sommerzeit. Für Mountain-Zeit ohne Sommerzeit America/Phoenix verwenden."
		},
		trendTable: {
			above: "darüber",
			below: "darunter",
			down: "Abwärts",
			notAvailable: "k. A.",
			up: "Aufwärts",
			volumeLine: "Volumenlinie"
		}
	},
	bearish: "Bärisch",
	bfs: {
		duplicateRemoved: "Pro Chart ist nur eine Instanz von BFS — Blessed Flow System möglich — das Duplikat wurde entfernt.",
		emaCrossSoon: "EMA30/50 kurz vor Kreuzung",
		engineOff: "auf M1 wechseln",
		engineOn: "Engine M1",
		input: {
			armWin: "Fenster (M1-Kerzen) für die EMA30-Berührung",
			asiaSess: "Asien (HHMM-HHMM)",
			bePts: "BE: bei +Punkten rückt der Stop AUF dieses Niveau",
			cooldown: "Wartezeit (M1-Kerzen) nach Trade-Ende",
			lenFast: "EMA schnell (Richtung)",
			lenH1a: "H1 · kurzer EMA",
			lenH1b: "H1 · langer EMA",
			lenMid: "EMA mittel",
			lenSlow: "EMA langsam",
			londonSess: "London (HHMM-HHMM, Session-Uhr)",
			maxPerBlock: "Max. Einstiege je Session-Block (0 = ohne Limit)",
			nearLb: "Kerzen zur Messung der Annäherung",
			nearPts: "Max. Abstand EMA30-EMA50 (Punkte)",
			nySess: "New York (HHMM-HHMM)",
			onlyM1: "Engine nur auf M1 laufen lassen",
			pv: "Kurswert eines Punktes",
			r1lb: "R1 · M1-Rückblick (nicht überdehnt)",
			rr: "TP-Verhältnis R:R (ohne Ladder)",
			rsiHi: "RSI >= für SHORT",
			rsiLen: "RSI-Länge",
			rsiLo: "RSI <= für LONG",
			rsiWin: "Wartefenster (Kerzen nach dem Signal)",
			showLevels: "Trade-Niveaus zeichnen",
			showNear: "Markieren, wenn EMA30 den EMA50 bald kreuzt",
			slPts: "SL (Punkte)",
			swLenA: "Pivot-Stärke (Kerzen je Seite)",
			tp1Pts: "TP1 (Punkte)",
			tp2Pts: "TP2 (Punkte)",
			tp3Pts: "TP3 (Punkte)",
			tzOffset: "UTC-Abweichung der Session-Uhr (Bogotá = -5)",
			useArm: "50 % Retracement + EMA30-Berührung im Fenster verlangen",
			useAsia: "Asien einbeziehen (nur zum Testen)",
			useBE: "Break-even aktiv",
			useLadder: "TP1/TP2/TP3 nutzen (Endausstieg = TP3)",
			useR2: "R2 · M5- + M15-Stapel und H1-Bias verlangen",
			useRSI: "Nach dem Signal auf RSI warten",
			useSess: "Nach Session filtern",
			useTrend: "EMA-Reihenfolge während des Wartens halten"
		},
		longSignal: "Long-Signal",
		noSignal: "kein Signal",
		retracementDot: "Punkt bei 50 % Retracement",
		rewardZone: "Gewinnzone",
		riskZone: "Risikozone",
		session: "Session",
		sessionClosed: "geschlossen",
		sessionOpen: "offen",
		shortSignal: "Short-Signal",
		signal: "Signal",
		signalActive: "{{side}} aktiv",
		waitingRsi: "warte auf RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Warten auf RSI (Long)",
		waitingRsiShort: "Warten auf RSI (Short)"
	},
	breakEven: "Break-even",
	bullish: "Bullisch",
	buy: "Kauf",
	colour: "Farbe",
	cypher: {
		above55: "Über 55",
		aboveBelow: "Über/Unter",
		barColors: "Balkenfarben",
		bbLength: "BB-Länge",
		bbStdDev: "BB Std.-Abw. {{n}}",
		bearBreak: "Bärischer Ausbruch",
		bearPattern: "Bärische Pin-Bar / Engulfing",
		below55: "Unter 55",
		bullBreak: "Bullischer Ausbruch",
		bullPattern: "Bullische Pin-Bar / Engulfing",
		cmoLength: "CMO-Länge",
		colorCandles: "Kerzen einfärben",
		confluenceLong: "Konfluenz Long",
		confluenceShort: "Konfluenz Short",
		consolidating: "Konsolidierung",
		direction: "Richtung",
		emaPeriodTrend: "EMA-Periode (Trend)",
		flagOffsetAtr: "Flaggen-Abstand (x ATR)",
		flashBackground: "Blinkhintergrund",
		flashCount: "Anzahl der Blinkvorgänge",
		flashHz: "Blinkgeschwindigkeit (Blinker / Sek.)",
		flashOn: "Bei neuem Signal blinken",
		flashShowBanner: "NEW BUY / SELL-Banner einblenden",
		flashShowBg: "Charthintergrund blinken lassen",
		flashStrength: "Stärke des Hintergrundblinkens",
		flashTest: "Blinken jetzt testen (Vorschau)",
		fvgKeep: "Fair Value Gaps pro Seite",
		glowOpacity: "Leuchten-Deckkraft (höher = transparenter)",
		glowSizeTicks: "Leuchten-Größe (Ticks)",
		groupFlash: "Neues-Signal-Alarm",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "KDE-Niveaus",
		groupKeyLevels: "Schlüsselniveaus",
		groupLrEma: "LR-Kanal / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivots",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Umkehrbänder",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Komponenten",
		groupTrendTable: "Trendtabelle",
		groupVidya: "VIDYA / Trend",
		halfTrendAmplitude: "HalfTrend-Amplitude",
		halfTrendChannelDeviation: "HalfTrend-Kanalabweichung",
		ichimokuBase: "Ichimoku-Basislinie",
		ichimokuConversion: "Ichimoku-Konversionslinie",
		kdeActivation: "Aktivierungsschwelle aktivieren",
		kdeBins: "Anzahl der Bins",
		kdeThreshold: "Schwelle %",
		labelPosition: "Beschriftungsposition",
		lineWidth: "Linienbreite",
		lowerBb: "Unteres BB{{n}}",
		lowerInnerZone: "Untere Innenzone",
		lowerReversalZone: "Untere Umkehrzone",
		maCloudLong: "MA-Wolke (lang)",
		maCloudShort: "MA-Wolke (kurz)",
		newBuy: "NEUER KAUF",
		newSell: "NEUER VERKAUF",
		numberOfLevels: "Anzahl der Niveaus",
		parabolicSar: "Parabolic SAR",
		pivotAuto: "Auto",
		pivotDaily: "Täglich",
		pivotMonthly: "Monatlich",
		pivotsTimeframe: "Pivot-Zeitrahmen",
		pivotWeekly: "Wöchentlich",
		positionBottomCenter: "Unten Mitte",
		positionBottomLeft: "Unten links",
		positionBottomRight: "Unten rechts",
		positionLeft: "Links",
		positionRight: "Rechts",
		positionTopCenter: "Oben Mitte",
		positionTopLeft: "Oben links",
		positionTopRight: "Oben rechts",
		psarBear: "PSAR bärisch",
		psarBull: "PSAR bullisch",
		psarIncrement: "PSAR Inkrement",
		psarMax: "PSAR Maximum",
		psarStart: "PSAR Start",
		pullingBack: "Rücksetzer",
		pulseSmoothingBars: "Pulse-Glättungsbalken",
		reEntry: "Wiedereinstieg",
		rightOffsetBars: "Abstand rechts (Kerzen)",
		showCamarillaPivots: "Camarilla-Pivots anzeigen",
		showConfluenceFlag: "Konfluenz-Flagge anzeigen (B/S)",
		showFvg: "Fair Value Gaps (ab 15m)",
		showKde: "KDE-Volumenniveaus",
		showKeyLevels: "Schlüsselniveaus anzeigen",
		showLabels: "Beschriftungen anzeigen",
		showLevelGlow: "Niveau-Leuchten anzeigen",
		showMaCloud: "MA-Wolke anzeigen",
		showPrices: "Preise anzeigen",
		showPsar: "PSAR anzeigen",
		showReversalBands: "Umkehrbänder anzeigen",
		showSlTpLabels: "SL/TP-Labels anzeigen",
		showSniperBreakArrows: "Sniper-/Ausbruchspfeile anzeigen",
		showTrendTable: "Trendtabelle anzeigen",
		showVidya233: "VIDYA 233 anzeigen",
		showVidya55: "VIDYA 55 anzeigen",
		showVidya987: "VIDYA 987 (Magnet) anzeigen",
		showVidyaLines: "VIDYA-Linien anzeigen",
		sizeNormal: "Normal",
		sizeSmall: "Klein",
		sizeTiny: "Winzig",
		slBufferAtr: "SL-Puffer max. (x ATR)",
		slBufferPips: "SL-Puffer jenseits des Swings (Pips)",
		slMaxRiskAtr: "SL max. Risiko (x ATR)",
		slSwingLookback: "SL Swing-Rückblick (Kerzen)",
		sniperDown: "Sniper abwärts",
		sniperUp: "Sniper aufwärts",
		source: "Quelle",
		state: "Status",
		strength: "Stärke",
		strong: "Stark",
		superTrend2AtrLength: "SuperTrend 2 ATR-Länge",
		superTrend2Factor: "SuperTrend 2 Faktor",
		superTrendAtrLength: "SuperTrend ATR-Länge",
		superTrendMultiplier: "SuperTrend-Multiplikator",
		tablePosition: "Tabellenposition",
		tableSize: "Tabellengröße",
		tpRiskReward: "TP {{n}} Chance/Risiko",
		tradeManagement: "Trade-Management (SL / TP)",
		trend: "Trend",
		trending: "Im Trend",
		upperBb: "Oberes BB{{n}}",
		upperInnerZone: "Obere Innenzone",
		upperReversalZone: "Obere Umkehrzone",
		veryStrong: "Sehr stark",
		veryWeak: "Sehr schwach",
		vidya987Magnet: "VIDYA 987 (Magnet)",
		volumeAvgLength: "Volumendurchschnitt-Länge (Ausbruchsfilter)",
		weak: "Schwach",
		zoneEdge: "{{name}} (Füllkante)"
	},
	entry: "Einstieg",
	gainColor: "Gewinnfarbe",
	harsiCandle: "HARSI-Kerze",
	harsiLength: "HARSI-Länge",
	heikinAshiRsiOscillator: "Heikin-Ashi RSI Oszillator",
	keyValueThisChangesTheSensitivity: "Schlüsselwert 'Dies ändert die Empfindlichkeit'",
	labelsIndicator: "Label-Indikator",
	london: "London",
	londonBackground: "London-Hintergrund",
	londonSession: "London-Sitzung",
	long: "Long",
	lossColor: "Verlustfarbe",
	median: "Median",
	neutral: "Neutral",
	newYork: "New York",
	newYorkBackground: "New-York-Hintergrund",
	newYorkSession: "New-York-Sitzung",
	openSmoothing: "Eröffnungsglättung",
	optimus: {
		activeTradeLevels: "Aktiver Trade · Niveaus",
		bias: "Bias",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "GEMISCHT {{n}}/{{total}}",
		disclaimer: "Die Niveaus sind im Chart eingezeichnet. Keine Anlageberatung.",
		duplicateRemoved: "Pro Chart ist nur eine Instanz von Optimus Prime möglich — das Duplikat wurde entfernt.",
		enter: "EINSTIEG · {{side}}",
		input: {
			atrLength: "KC-ATR-Länge",
			buffer: "Swing-Puffer (Kurs)",
			emaLength: "EMA-Länge",
			kcLength: "KC-Länge",
			kcMult: "KC-Multiplikator",
			lrcLength: "LRC-Länge",
			minRisk: "Min. Risiko R (Kurs)",
			requireAlign: "EMA und LRC müssen ausgerichtet sein",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Swing-Rückblick (R)"
		},
		kcLower: "KC unten",
		kcMid: "KC Mitte",
		kcUpper: "KC oben",
		keltnerFill: "Keltner-Fläche",
		noClosedTrades: "Noch keine geschlossenen Trades",
		reasonForming: "Setup bildet sich — Bestätigung fehlt",
		reasonLatched: "Trade fixiert · Niveaus im Chart",
		reasonNoSetup: "Kein Setup · EMA/LRC nicht ausgerichtet",
		recentSignals: "Letzte Signale",
		riskReward: "RISIKO/GEWINN",
		trendMtf: "Trend · mehrere Zeitebenen",
		wait: "WARTEN",
		warmingUp: "INITIALISIERT"
	},
	overbought: "Überkauft",
	overboughtMax: "Überkauft Max",
	overboughtMin: "Überkauft Min",
	oversold: "Überverkauft",
	oversoldMax: "Überverkauft Max",
	oversoldMin: "Überverkauft Min",
	rsiLength: "RSI-Länge",
	rsiLine: "RSI-Linie",
	rsiLineShadow: "RSI-Linienschatten",
	sell: "Verkauf",
	short: "Short",
	signalsFromHeikinAshiCandles: "Signale aus Heikin-Ashi-Kerzen",
	sl: "SL",
	smoothedMode: "Geglätteter Modus",
	sydney: "Sydney",
	sydneyBackground: "Sydney-Hintergrund",
	sydneySession: "Sydney-Sitzung",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokio",
	tokyoBackground: "Tokio-Hintergrund",
	tokyoSession: "Tokio-Sitzung",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "bärisch",
			bullish: "bullisch",
			confluence: "Konfluenz",
			entry: "Einstieg",
			neckline: "Nackenlinie",
			score: "Score",
			state: "Status",
			states: {
				completed: "abgeschlossen",
				invalidated: "ungültig",
				projected: "projiziert",
				przActive: "PRZ aktiv",
				stopped: "ausgestoppt"
			},
			stop: "Stopp",
			target: "Ziel"
		},
		classic: {
			doubleBottom: "Doppelboden",
			doubleTop: "Doppeltop",
			headAndShoulders: "Kopf-Schulter-Formation",
			inverseHeadAndShoulders: "Inv. SKS",
			tripleBottom: "Dreifachboden",
			tripleTop: "Dreifachtop"
		},
		direction: {
			bearishOnly: "Nur bärisch",
			both: "Beide",
			bullishOnly: "Nur bullisch"
		},
		group: {
			classics: "Klassische Muster & S/R",
			filters: "Filter & Anzeige",
			patterns: "Muster",
			pivotEngine: "Pivot-Engine",
			ratios: "Verhältnisse & Toleranz"
		},
		input: {
			atrLen: "ATR-Periode",
			atrMult: "Zigzag-Umkehr (x ATR)",
			colBear: "Bärisch",
			colBull: "Bullisch",
			colPrz: "PRZ",
			colSR: "Schlüsselniveaus",
			dirFilter: "Richtungsfilter",
			enClassics: "Klassische Muster erkennen",
			enDoubles: "Doppeltop / Doppelboden",
			enHS: "Kopf-Schulter-Formation",
			enTriples: "Dreifachtop / Dreifachboden",
			fillTransp: "Transparenz der Musterfüllung",
			formingLife: "Lebensdauer der Bildungszone (Kerzen)",
			keepFailed: "Gestoppte Muster im Chart behalten (✕, abgedunkelt)",
			keepSuccessful: "Erfolgreiche Muster im Chart behalten (✓)",
			maxPatterns: "Max. Muster im Chart",
			minScore: "Minimale Qualitätswertung",
			pivotDepth: "Pivot-Puffertiefe",
			showLetters: "Punktbuchstaben X A B C D anzeigen",
			showPlan: "Trade-Plan-Niveaus anzeigen",
			showProjected: "Projizierte (entstehende) Muster anzeigen",
			showRatios: "Verhältniszahlen an den Beinen anzeigen",
			showSR: "Unterstützungs-/Widerstandsniveaus",
			showStats: "Statistiktabelle anzeigen",
			srMinTouch: "S/R: Mindestanzahl Pivot-Berührungen",
			tolEdge: "Toleranz am Bereichsrand",
			tolPoint: "Toleranz der Punktverhältnisse",
			useScale2: "Auch 2x-Skala scannen (größere Strukturen)"
		},
		label: {
			confirmed: "bestätigt",
			forming: "entsteht",
			sl: "SL",
			target: "Ziel",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Abgeschlossen",
			stops: "Stopps",
			t1Wins: "T1-Treffer",
			winRate: "Trefferquote %"
		},
		tooltip: {
			colPrz: "Bernsteinfarbene PRZ unabhängig von der Musterrichtung (ProTrader-Standard).",
			fillTransp: "Niedriger = sichtbarere Füllung. Etwa 65-80 funktioniert gut.",
			formingLife: "Ein entstehendes Muster, dessen Punkt C älter als dieser Wert ist und das weder abgeschlossen noch ungültig geworden ist, läuft ab und wird entfernt.",
			maxPatterns: "Die ältesten Muster werden zuerst entfernt, sodass die jüngste Historie (✓ / ✕) und frische entstehende Zonen immer sichtbar bleiben.",
			showProjected: "Zeichnet die X-A-B-Struktur mit einer gestrichelten Hilfslinie in die projizierte PRZ.",
			showRatios: "Gepunktete Messdiagonalen (X-B, A-C, B-D, X-D) mit dem gemessenen Fibonacci-Verhältnis in der Mitte jeder Diagonale, die übliche Beschriftung harmonischer Charts.",
			tolPoint: "Gilt für exakte Verhältnisse wie Gartley B=0.618. Streng = 0.03, ausgewogen = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ ALLES SCHLIESSEN",
		duplicateRemoved: "Pro Chart ist nur eine Instanz von Trade Finder möglich — das Duplikat wurde entfernt.",
		durationHm: "{{h}} Std {{m}} Min",
		durationM: "{{m}} Min",
		emaEntry1: "EMA Einstieg 1",
		emaEntry2: "EMA Einstieg 2 / Trend",
		emaRangeFilter: "EMA Range-Filter",
		emaTrigger: "EMA Trigger",
		entry1: "Entry 1",
		entry2: "Entry 2",
		entry2Mark: "E2",
		entryZoneBear: "Einstiegszone {{n}} (bärisch)",
		entryZoneBull: "Einstiegszone {{n}} (bullisch)",
		frameFailed: "Zeitrahmen {{frame}} konnte nicht geladen werden — es wird erneut versucht.",
		framesUnavailable: "Keine Zeitrahmendaten · warten",
		ghostEntry: "Vorheriges Setup",
		ghostStop: "Vorheriger Stop",
		group: {
			bias: "Bias",
			display: "Anzeige",
			emaSystem: "EMA-System",
			entries: "Einstiege",
			filter: "Filter",
			riskManagement: "Risikomanagement",
			session: "Session",
			supportResistance: "Unterstützung und Widerstand",
			trailingStop: "Trailing-Stop",
			trendPanel: "Trend-Panel"
		},
		input: {
			adxLen: "ADX-Länge",
			adxSmoothing: "ADX-Glättung",
			asiaSession: "Asien-/Tokio-Session (UTC)",
			atrBufferMultBtc: "Stop-Puffer hinter dem Swing — BTC (× ATR)",
			atrBufferMultGold: "Stop-Puffer hinter dem Swing — Gold (× ATR)",
			atrBufferMultOther: "Stop-Puffer hinter dem Swing — andere (× ATR)",
			atrLength: "ATR-Länge (Risikomanagement)",
			atrSlMult: "Stop-Loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Gold: Break-even nach so vielen Punkten",
			biasEmaLen: "Länge Bias-EMA",
			crossLookback: "Bias-Kreuzungen Lookback (Bars)",
			dxySymbol: "Symbol des Dollar-Index (leer = aus)",
			emaBigLen: "Länge EMA Range-Filter",
			emaFastLen: "Länge EMA Einstieg 1",
			emaMidLen: "Länge EMA Einstieg 2 / Trend",
			emaTriggerLen: "Länge EMA Trigger",
			feeBufferPct: "Gebührenpuffer über Break-even (%)",
			flatThreshPct: "Flat-Schwelle (% der Bias-EMA)",
			londonSession: "London-Session (UTC)",
			maxCrosses: "Max. Kreuzungen, bevor der Bias verworfen wird",
			newYorkSession: "New-York-Session (UTC)",
			showEmaLabels: "EMA-Namens-Labels anzeigen",
			showEntrySignals: "Setup-Markierungen anzeigen",
			showEntryZone: "Einstiegszone anzeigen",
			showSRLines: "Unterstützung und Widerstand anzeigen",
			showTradeLevels: "Entry-, Stop- und Ziellinien anzeigen",
			slMaxPointsBtc: "Maximaler Stop-Abstand — BTC (Punkte)",
			slMaxPointsGold: "Maximaler Stop-Abstand — Gold (Punkte)",
			slMaxPointsIndex: "Maximaler Stop-Abstand — Indizes (Punkte)",
			slMaxPointsOther: "Maximaler Stop-Abstand — andere (Punkte)",
			slMinPointsGold: "Minimaler Stop-Abstand — Gold (Punkte)",
			slopeLookback: "Bias-Slope Lookback (Bars)",
			srLeftBars: "Unterstützung / Widerstand · Bars links vom Pivot",
			srRightBars: "Unterstützung / Widerstand · Bars rechts vom Pivot",
			swingPivotLen: "Swing-Pivot-Länge (Stop-Loss)",
			tp1ClosePct: "TP1 schließen %",
			tp2ClosePct: "TP2 schließen %",
			tp5CloseAlways: "TP5 schließt immer, auch bei aktivem Trailing-Stop",
			tpR: "TP{{n}} (in R)",
			tpSlMode: "Stop- und Zielmodus",
			trailAtrMult: "Abstand des Trailing-Stops (× ATR)",
			trendPanelEmaLen: "Länge EMA der Trendzeile",
			trendSlopeLB: "Slope-Lookback EMA Entry 2 (Bars)",
			useAdxFilter: "ADX über der Modus-Schwelle verlangen",
			useBiasFilter: "Bias des höheren Timeframes bewerten (blockiert nie)",
			useEmaStackCheck: "EMAs müssen in der richtigen Reihenfolge stehen",
			useInstrumentAutoDetect: "Instrument automatisch erkennen",
			useSessionFilter: "Signale nur während der Handelssessions",
			useSlopeDynamic: "Slope-Lookback an den Timeframe anpassen",
			useStrictCandle: "Strenger Kerzenfilter (Docht und Schluss)",
			useTrailingStop: "Trailing-Stop (ab TP1)",
			useVolumeConfirm: "Überdurchschnittliches Volumen beim Einstieg verlangen",
			volAvgLen: "Länge des Volumen-Durchschnitts",
			volMultiplier: "Mindestvolumen (× Durchschnitt)"
		},
		maxStop: "Max. SL",
		minuteAgainst: "Kreuzung gegen das Setup",
		minuteOk: "Keine Warnung",
		minuteReversal: "Kreuzung · Umkehr möglich",
		modeAtr: "ATR",
		modeAuto: "Automatisch",
		modeRiskReward: "Chance / Risiko",
		noBias: "Kein Bias",
		noSetup: "Kein aktives Setup",
		recentTitle: "Letzte Setups",
		reEntry: "Wiedereinstieg",
		reEntryMark: "RE",
		rest: "REST",
		rowBias: "Bias",
		rowContext: "Kontext",
		rowInfo: "Info",
		rowSession: "Session",
		rowSetup: "Setup",
		rowVolume: "Volumen",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "noch {{time}}",
		sessionOutside: "Außerhalb · London {{time}} UTC",
		sessionOverlap: "Überlappung",
		statsTitle: "Letzte {{n}} Setups",
		statusBreakEvenSet: "Break-even",
		statusMoveToBreakEven: "Stopp ziehen",
		statusPending: "Zonenkontakt",
		statusRunning: "Läuft",
		statusSpike: "Volatil · warten",
		statusWaiting: "Warten",
		stopHit: "Stop ausgelöst",
		styleDaytrade: "Daytrading",
		styleScalping: "Scalping",
		styleSwing: "Swing",
		subFrameReversal: "Niedrigerer Timeframe dreht",
		targetHit: "Endziel erreicht",
		trailStop: "Trailing-Stop",
		volAboveAverage: "über Durchschnitt",
		volBelowAverage: "unter Durchschnitt",
		zoneEdgeBear: "Zonenrand {{n}} (bärisch)",
		zoneEdgeBull: "Zonenrand {{n}} (bullisch)"
	},
	tradingSessions: "Handelssitzungen",
	unintendedSymbol: "Diese Strategie ist für {{symbols}} gedacht — auf {{symbol}} können ihre Niveaus wenig aussagen.",
	utBotAlerts: "UT-Bot-Alarme"
}, fe = {
	asia: "Asia",
	atrPeriod: "ATR Period",
	auraScanner: {
		guide: {
			bigDiamondMark: "Big red/green",
			bigDiamondMeaning: "big red above a high warns a buy. Big green below a low, a sell.",
			blueMark: "Blue curve",
			blueMeaning: "50 EMA. Pink over blue is a buy, under is a sell.",
			dashedMark: "Dashed lines",
			dashedMeaning: "support and resistance. Red below price, green above.",
			diamondsMark: "Diamonds",
			diamondsMeaning: "turning points. Gold weakest, then blue, then red and green.",
			flatGoldMark: "Flat gold",
			flatGoldMeaning: "the 15 minute point of control, the last six hours.",
			levelsMark: "Level lines",
			levelsMeaning: "entry, stop and targets of the latest trade. A tick means hit.",
			pinkMark: "Pink curve",
			pinkMeaning: "20 EMA. A signal is this crossing the blue one.",
			subtitle: "how to read this chart",
			thickGoldMark: "Thick gold",
			thickGoldMeaning: "the 238. If it sits between you and your target, skip.",
			title: "AURA",
			triangleMark: "Triangle",
			triangleMeaning: "a trade that passed every check. Hover it for the numbers."
		},
		groups: {
			display: "Display",
			eightChecks: "The eight checks",
			riskAndTargets: "Risk and targets",
			signalEngine: "Signal engine"
		},
		inputs: {
			emaFastLen: "Fast line (pink)",
			emaSlowLen: "Slow line (blue)",
			f1Clock: "1. Good volume window only",
			f2Trend: "2. Agrees with the 15 minute trend",
			f3Mode: "3. Wrong-coloured candle",
			f4Min: "Opening by at least (pips a candle)",
			f4Sep: "4. Lines pulling apart",
			f5Clear: "5. 238 not between entry and target",
			f6R: "Minimum room (x risk)",
			f6Reward: "6. Room to the next level",
			f7Bars: "Over the last (bars)",
			f7Consol: "7. Not stuck in a range",
			f7Pips: "Range must be more than (pips)",
			f9Bars: "Within the last N bars",
			f9Star: "8. No big warning diamond",
			guidePos: "Guide panel position",
			longMode: "Safety line (238) mode",
			panelSize: "Panel text size",
			pipIn: "Pip size (0 = automatic)",
			showClock: "Right now panel",
			showGuide: "Guide panel (what the marks mean)",
			showLadder: "Trade levels on the right",
			showPoc: "Volume line",
			showSr: "Dashed levels",
			showStars: "Warning diamonds",
			showTable: "Trend table",
			showTint: "Background colour",
			showWhy: "Explain skipped signals",
			slMinPips: "Minimum gap past the slow line (pips)",
			srAtrMove: "Levels: bounce needed (x normal candle size)",
			srLookback: "Levels: swing lookback",
			srMax: "Most levels to keep on screen",
			srRange: "Ignore levels further than (x normal candle size)",
			srReset: "Levels: retests before removal",
			stripLen: "Width of the right-hand column (bars)",
			tablePos: "Right now panel position",
			theme: "Chart theme",
			tp1R: "TP1 (R multiple)",
			tp2R: "TP2 (R multiple)",
			trendPos: "Trend table position",
			tz: "Trading-times timezone"
		},
		ladder: {
			closedAtStop: "CLOSED  at stop",
			closedAtTarget: "CLOSED  TP{{hit}}",
			entry: "ENTRY",
			stop: "STOP",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Auto-scale",
			bottomCentre: "Bottom centre",
			bottomLeft: "Bottom left",
			bottomRight: "Bottom right",
			dark: "Dark",
			ignore: "Ignore",
			large: "Large",
			light: "Light",
			literal238: "Literal 238",
			middleCentre: "Middle centre",
			middleLeft: "Middle left",
			middleRight: "Middle right",
			normal: "Normal",
			reject: "Reject",
			small: "Small",
			topCentre: "Top centre",
			topLeft: "Top left",
			topRight: "Top right",
			waitForPullback: "Wait for pullback"
		},
		reasons: {
			clock: "outside the trading-times window",
			diamond: "a big warning diamond just printed",
			range: "the chart is stuck in consolidation",
			room: "a level is too close, no room to the target",
			safetyLine: "the 238 sits between the entry and the target",
			separation: "the two lines are too close together, no room to run yet",
			trend: "against the 15 minute trend",
			wrongColour: "crossover candle closed the wrong colour"
		},
		rightNow: {
			aBuy: "a buy",
			aSell: "a sell",
			bestBuysOnly: "look for buys only",
			bestNow: "Best now",
			bestSellsOnly: "look for sells only",
			bestWaitThin: "wait, volume is thin",
			goodVolume: "Good Volume",
			lowVolume: "Low Volume",
			safetyAbove: "238 above price, sells can run",
			safetyBelow: "238 below price, buys can run",
			safetyLine: "Safety line",
			skipped: "Skipped",
			skippedAgo_one: "{{side}} {{bars}} bar ago: {{reason}}",
			skippedAgo_other: "{{side}} {{bars}} bars ago: {{reason}}",
			skippedNothing: "nothing skipped yet",
			title: "RIGHT NOW",
			trend: "Trend",
			trendSummaryDown: "15m down, {{agree}} of 6 timeframes up",
			trendSummaryUp: "15m up, {{agree}} of 6 timeframes up"
		},
		signal: {
			buy: "BUY",
			pips: "pips",
			sell: "SELL",
			stop: "Stop"
		},
		tooltip: {
			f3Mode: "A buy on a red candle or a sell on a blue candle is never taken as it is. Wait for pullback waits for price to pull back into the lines on a candle of the right colour. Reject throws it out.",
			f4Min: "How fast the two lines are moving apart on the signal candle. Tangled, flat lines have no room to run.",
			f6Reward: "The next dashed level must be at least this far away. Off by default: the levels are drawn by this scanner's own method, so check the room by eye.",
			f7Pips: "Stay away from a consolidation of 100 pips or less.",
			longMode: "238 is the standard setting, made for one-minute charts. Auto-scale adjusts the safety line to suit other timeframes, around 83 on a three-minute chart.",
			pipIn: "Automatic: 0.10 on gold, and ten ticks elsewhere (1 point on US30).",
			showGuide: "A short legend on the chart. Turn it off once you know the marks.",
			showLadder: "The latest trade's entry, stop and targets are drawn to the right of the last candle. Targets tick off as they are hit.",
			showWhy: "When the lines cross but a check stops the trade, the Right now panel says which check and why.",
			slMinPips: "The stop goes on the other side of both the red and the blue line, with at least 10 pips of space from the blue.",
			srMax: "Only the levels nearest to price are kept, so the chart stays readable.",
			theme: "Match this to your TradingView theme so every colour stays clear.",
			tz: "The trading windows are set in this timezone. America/Denver is Mountain time and follows daylight saving. Use America/Phoenix for Mountain time without daylight saving."
		},
		trendTable: {
			above: "above",
			below: "below",
			down: "Down",
			notAvailable: "n/a",
			up: "Up",
			volumeLine: "Volume line"
		}
	},
	bearish: "Bearish",
	bfs: {
		duplicateRemoved: "Only one BFS — Blessed Flow System study per chart is supported — the duplicate was removed.",
		emaCrossSoon: "EMA30/50 about to cross",
		engineOff: "switch to M1",
		engineOn: "engine M1",
		input: {
			armWin: "Window (M1 bars) to touch EMA30",
			asiaSess: "Asia (HHMM-HHMM)",
			bePts: "BE: at +points the stop moves TO that level",
			cooldown: "Cooldown (M1 bars) after a trade closes",
			lenFast: "EMA fast (direction)",
			lenH1a: "H1 · short EMA",
			lenH1b: "H1 · long EMA",
			lenMid: "EMA mid",
			lenSlow: "EMA slow",
			londonSess: "London (HHMM-HHMM, session clock)",
			maxPerBlock: "Max entries per session block (0 = no limit)",
			nearLb: "Bars used to measure convergence",
			nearPts: "Max EMA30-EMA50 distance (points)",
			nySess: "New York (HHMM-HHMM)",
			onlyM1: "Run the engine on M1 only",
			pv: "Price value of 1 point",
			r1lb: "R1 · M1 lookback (not extended)",
			rr: "TP ratio R:R (when the ladder is off)",
			rsiHi: "RSI >= for SHORT",
			rsiLen: "RSI length",
			rsiLo: "RSI <= for LONG",
			rsiWin: "Wait window (bars after signal)",
			showLevels: "Draw the trade levels",
			showNear: "Mark when EMA30 is about to cross EMA50",
			slPts: "SL (points)",
			swLenA: "Pivot strength (bars each side)",
			tp1Pts: "TP1 (points)",
			tp2Pts: "TP2 (points)",
			tp3Pts: "TP3 (points)",
			tzOffset: "Session clock UTC offset (Bogota = -5)",
			useArm: "Require 50% retracement + EMA30 touch in window",
			useAsia: "Include Asia (test only)",
			useBE: "Break-even active",
			useLadder: "Use TP1/TP2/TP3 (final exit = TP3)",
			useR2: "R2 · require M5 + M15 stack + H1 bias",
			useRSI: "Wait for RSI after the signal",
			useSess: "Filter by session",
			useTrend: "Keep EMA order during the wait"
		},
		longSignal: "Long signal",
		noSignal: "no signal",
		retracementDot: "50% retracement dot",
		rewardZone: "Reward zone",
		riskZone: "Risk zone",
		session: "Session",
		sessionClosed: "closed",
		sessionOpen: "open",
		shortSignal: "Short signal",
		signal: "Signal",
		signalActive: "{{side}} active",
		waitingRsi: "waiting RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Waiting RSI (long)",
		waitingRsiShort: "Waiting RSI (short)"
	},
	breakEven: "Break-even",
	bullish: "Bullish",
	buy: "Buy",
	colour: "Colour",
	cypher: {
		above55: "Above 55",
		aboveBelow: "Above/Below",
		barColors: "Bar Colors",
		bbLength: "BB Length",
		bbStdDev: "BB Std Dev {{n}}",
		bearBreak: "Bear Break",
		bearPattern: "Bear Pin Bar / Engulfing",
		below55: "Below 55",
		bullBreak: "Bull Break",
		bullPattern: "Bull Pin Bar / Engulfing",
		cmoLength: "CMO Length",
		colorCandles: "Color Candles",
		confluenceLong: "Confluence Long",
		confluenceShort: "Confluence Short",
		consolidating: "Consolidating",
		direction: "Direction",
		emaPeriodTrend: "EMA Period (trend)",
		flagOffsetAtr: "Flag offset (x ATR)",
		flashBackground: "Flash Background",
		flashCount: "Number of flashes",
		flashHz: "Flash speed (blinks / sec)",
		flashOn: "Flash on new flag",
		flashShowBanner: "Flash a NEW BUY / SELL banner",
		flashShowBg: "Flash the chart background",
		flashStrength: "Background flash strength",
		flashTest: "Test flash now (preview)",
		fvgKeep: "Fair Value Gaps kept per side",
		glowOpacity: "Glow Opacity (higher = more transparent)",
		glowSizeTicks: "Glow Size (ticks)",
		groupFlash: "New-Flag Alert",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "KDE Levels",
		groupKeyLevels: "Key Levels",
		groupLrEma: "LR Channel / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivots",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Reversal Bands",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Component Toggles",
		groupTrendTable: "Trend Table",
		groupVidya: "VIDYA / Trend",
		halfTrendAmplitude: "HalfTrend Amplitude",
		halfTrendChannelDeviation: "HalfTrend Channel Deviation",
		ichimokuBase: "Ichimoku Base",
		ichimokuConversion: "Ichimoku Conversion",
		kdeActivation: "Enable Activation Threshold",
		kdeBins: "Number of Bins",
		kdeThreshold: "Threshold %",
		labelPosition: "Label Position",
		lineWidth: "Line Width",
		lowerBb: "Lower BB{{n}}",
		lowerInnerZone: "Lower Inner Zone",
		lowerReversalZone: "Lower Reversal Zone",
		maCloudLong: "MA Cloud Long",
		maCloudShort: "MA Cloud Short",
		newBuy: "NEW BUY",
		newSell: "NEW SELL",
		numberOfLevels: "Number of Levels",
		parabolicSar: "Parabolic SAR",
		pivotAuto: "Auto",
		pivotDaily: "Daily",
		pivotMonthly: "Monthly",
		pivotsTimeframe: "Pivots Timeframe",
		pivotWeekly: "Weekly",
		positionBottomCenter: "Bottom Center",
		positionBottomLeft: "Bottom Left",
		positionBottomRight: "Bottom Right",
		positionLeft: "Left",
		positionRight: "Right",
		positionTopCenter: "Top Center",
		positionTopLeft: "Top Left",
		positionTopRight: "Top Right",
		psarBear: "PSAR Bear",
		psarBull: "PSAR Bull",
		psarIncrement: "PSAR Increment",
		psarMax: "PSAR Max",
		psarStart: "PSAR Start",
		pullingBack: "Pulling Back",
		pulseSmoothingBars: "Pulse Smoothing Bars",
		reEntry: "Re-Entry",
		rightOffsetBars: "Right Offset (bars)",
		showCamarillaPivots: "Show Camarilla Pivots",
		showConfluenceFlag: "Show Confluence Flag (B/S)",
		showFvg: "Fair Value Gaps (15m and above)",
		showKde: "KDE Volume Levels",
		showKeyLevels: "Show Key Levels",
		showLabels: "Show Labels",
		showLevelGlow: "Show Level Glow",
		showMaCloud: "Show MA Cloud",
		showPrices: "Show Prices",
		showPsar: "Show PSAR",
		showReversalBands: "Show Reversal Bands",
		showSlTpLabels: "Show SL / TP Labels",
		showSniperBreakArrows: "Show Sniper / Break Arrows",
		showTrendTable: "Show Trend Table",
		showVidya233: "Show VIDYA 233",
		showVidya55: "Show VIDYA 55",
		showVidya987: "Show VIDYA 987 (Magnet)",
		showVidyaLines: "Show VIDYA Lines",
		sizeNormal: "Normal",
		sizeSmall: "Small",
		sizeTiny: "Tiny",
		slBufferAtr: "SL buffer cap (x ATR)",
		slBufferPips: "SL buffer beyond swing (pips)",
		slMaxRiskAtr: "SL max risk (x ATR)",
		slSwingLookback: "SL swing lookback (bars)",
		sniperDown: "Sniper Down",
		sniperUp: "Sniper Up",
		source: "Source",
		state: "State",
		strength: "Strength",
		strong: "Strong",
		superTrend2AtrLength: "SuperTrend 2 ATR Length",
		superTrend2Factor: "SuperTrend 2 Factor",
		superTrendAtrLength: "SuperTrend ATR Length",
		superTrendMultiplier: "SuperTrend Multiplier",
		tablePosition: "Table Position",
		tableSize: "Table Size",
		tpRiskReward: "TP {{n}} Risk/Reward",
		tradeManagement: "Trade Management (SL / TP)",
		trend: "Trend",
		trending: "Trending",
		upperBb: "Upper BB{{n}}",
		upperInnerZone: "Upper Inner Zone",
		upperReversalZone: "Upper Reversal Zone",
		veryStrong: "Very Strong",
		veryWeak: "Very Weak",
		vidya987Magnet: "VIDYA 987 (Magnet)",
		volumeAvgLength: "Volume Avg Length (break filter)",
		weak: "Weak",
		zoneEdge: "{{name}} (fill edge)"
	},
	entry: "Entry",
	gainColor: "Gain color",
	harsiCandle: "HARSI candle",
	harsiLength: "HARSI Length",
	heikinAshiRsiOscillator: "Heikin-Ashi RSI Oscillator",
	keyValueThisChangesTheSensitivity: "Key Value 'This changes the sensitivity'",
	labelsIndicator: "Labels Indicator",
	london: "London",
	londonBackground: "London background",
	londonSession: "London Session",
	long: "Long",
	lossColor: "Loss color",
	median: "Median",
	neutral: "Neutral",
	newYork: "New York",
	newYorkBackground: "New York background",
	newYorkSession: "New York Session",
	openSmoothing: "Open Smoothing",
	optimus: {
		activeTradeLevels: "Active trade · levels",
		bias: "Bias",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "MIXED {{n}}/{{total}}",
		disclaimer: "Levels are drawn on the chart. Not financial advice.",
		duplicateRemoved: "Only one Optimus Prime study per chart is supported — the duplicate was removed.",
		enter: "ENTER · {{side}}",
		input: {
			atrLength: "KC ATR Length",
			buffer: "Swing buffer (price)",
			emaLength: "EMA Length",
			kcLength: "KC Length",
			kcMult: "KC Multiplier",
			lrcLength: "LRC Length",
			minRisk: "Min Risk R (price)",
			requireAlign: "Require EMA & LRC aligned",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Swing Lookback (R)"
		},
		kcLower: "KC Lower",
		kcMid: "KC Mid",
		kcUpper: "KC Upper",
		keltnerFill: "Keltner Fill",
		noClosedTrades: "No closed trades yet",
		reasonForming: "Setup forming — awaiting confirmation",
		reasonLatched: "Trade latched · levels drawn on chart",
		reasonNoSetup: "No setup · EMA/LRC not aligned",
		recentSignals: "Recent signals",
		riskReward: "RISK/REWARD",
		trendMtf: "Trend · multi-timeframe",
		wait: "WAIT",
		warmingUp: "WARMING UP"
	},
	overbought: "Overbought",
	overboughtMax: "Overbought Max",
	overboughtMin: "Overbought Min",
	oversold: "Oversold",
	oversoldMax: "Oversold Max",
	oversoldMin: "Oversold Min",
	rsiLength: "RSI Length",
	rsiLine: "RSI Line",
	rsiLineShadow: "RSI Line Shadow",
	sell: "Sell",
	short: "Short",
	signalsFromHeikinAshiCandles: "Signals from Heikin Ashi Candles",
	sl: "SL",
	smoothedMode: "Smoothed Mode",
	sydney: "Sydney",
	sydneyBackground: "Sydney background",
	sydneySession: "Sydney Session",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokyo",
	tokyoBackground: "Tokyo  background",
	tokyoSession: "Tokyo Session",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "bearish",
			bullish: "bullish",
			confluence: "confluence",
			entry: "entry",
			neckline: "neckline",
			score: "score",
			state: "state",
			states: {
				completed: "completed",
				invalidated: "invalidated",
				projected: "projected",
				przActive: "prz_active",
				stopped: "stopped"
			},
			stop: "stop",
			target: "target"
		},
		classic: {
			doubleBottom: "Double Bottom",
			doubleTop: "Double Top",
			headAndShoulders: "Head & Shoulders",
			inverseHeadAndShoulders: "Inv H&S",
			tripleBottom: "Triple Bottom",
			tripleTop: "Triple Top"
		},
		direction: {
			bearishOnly: "Bearish only",
			both: "Both",
			bullishOnly: "Bullish only"
		},
		group: {
			classics: "Classic patterns & S/R",
			filters: "Filters & display",
			patterns: "Patterns",
			pivotEngine: "Pivot engine",
			ratios: "Ratios & tolerance"
		},
		input: {
			atrLen: "ATR period",
			atrMult: "Zigzag reversal (x ATR)",
			colBear: "Bearish",
			colBull: "Bullish",
			colPrz: "PRZ",
			colSR: "Key levels",
			dirFilter: "Direction filter",
			enClassics: "Detect classic patterns",
			enDoubles: "Double Top / Bottom",
			enHS: "Head & Shoulders",
			enTriples: "Triple Top / Bottom",
			fillTransp: "Pattern fill transparency",
			formingLife: "Forming zone lifetime (bars)",
			keepFailed: "Keep stopped patterns on chart (✕, dimmed)",
			keepSuccessful: "Keep successful patterns on chart (✓)",
			maxPatterns: "Max patterns on chart",
			minScore: "Minimum quality score",
			pivotDepth: "Pivot buffer depth",
			showLetters: "Show X A B C D point letters",
			showPlan: "Show trade plan levels",
			showProjected: "Show projected (forming) patterns",
			showRatios: "Show ratio numbers on legs",
			showSR: "Support/Resistance levels",
			showStats: "Show stats table",
			srMinTouch: "S/R minimum pivot touches",
			tolEdge: "Range-edge tolerance",
			tolPoint: "Point-ratio tolerance",
			useScale2: "Also scan 2x scale (larger structures)"
		},
		label: {
			confirmed: "confirmed",
			forming: "forming",
			sl: "SL",
			target: "target",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Done",
			stops: "Stops",
			t1Wins: "T1 wins",
			winRate: "Win %"
		},
		tooltip: {
			colPrz: "Amber PRZ regardless of pattern direction (ProTrader default).",
			fillTransp: "Lower = more visible fill. Around 65-80 works well.",
			formingLife: "A forming pattern whose C point is older than this, without completing or being invalidated, expires and is removed.",
			maxPatterns: "Oldest patterns are removed first, so recent history (✓ / ✕) and fresh forming zones always stay visible.",
			showProjected: "Draws the X-A-B structure with a dashed guide into the projected PRZ.",
			showRatios: "Dotted measurement diagonals (X-B, A-C, B-D, X-D) with the measured Fibonacci ratio at each midpoint — the standard harmonic-chart annotation.",
			tolPoint: "Applied to exact ratios like Gartley B=0.618. Strict = 0.03, Balanced = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ CLOSE ALL",
		duplicateRemoved: "Only one Trade Finder study per chart is supported — the duplicate was removed.",
		durationHm: "{{h}}h {{m}}m",
		durationM: "{{m}}m",
		emaEntry1: "EMA Entry 1",
		emaEntry2: "EMA Entry 2 / Trend",
		emaRangeFilter: "EMA Range Filter",
		emaTrigger: "EMA Trigger",
		entry1: "Entry 1",
		entry2: "Entry 2",
		entry2Mark: "E2",
		entryZoneBear: "Entry Zone {{n}} (bearish)",
		entryZoneBull: "Entry Zone {{n}} (bullish)",
		frameFailed: "Timeframe {{frame}} could not be loaded — it will be retried.",
		framesUnavailable: "No timeframe data · hold",
		ghostEntry: "Previous setup",
		ghostStop: "Previous stop",
		group: {
			bias: "Bias",
			display: "Display",
			emaSystem: "EMA system",
			entries: "Entries",
			filter: "Filter",
			riskManagement: "Risk management",
			session: "Session",
			supportResistance: "Support and resistance",
			trailingStop: "Trailing stop",
			trendPanel: "Trend panel"
		},
		input: {
			adxLen: "ADX length",
			adxSmoothing: "ADX smoothing",
			asiaSession: "Asia / Tokyo session (UTC)",
			atrBufferMultBtc: "Stop buffer behind the swing — BTC (× ATR)",
			atrBufferMultGold: "Stop buffer behind the swing — gold (× ATR)",
			atrBufferMultOther: "Stop buffer behind the swing — other (× ATR)",
			atrLength: "ATR length (risk management)",
			atrSlMult: "Stop loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Gold: break even after this many points",
			biasEmaLen: "Bias EMA length",
			crossLookback: "Bias crossing lookback (bars)",
			dxySymbol: "Dollar index symbol (empty turns the term off)",
			emaBigLen: "EMA Range Filter length",
			emaFastLen: "EMA Entry 1 length",
			emaMidLen: "EMA Entry 2 / Trend length",
			emaTriggerLen: "EMA Trigger length",
			feeBufferPct: "Fee buffer past break-even (%)",
			flatThreshPct: "Flat threshold (% of the bias EMA)",
			londonSession: "London session (UTC)",
			maxCrosses: "Max bias crossings before the bias is discarded",
			newYorkSession: "New York session (UTC)",
			showEmaLabels: "Show EMA name labels",
			showEntrySignals: "Show setup markers",
			showEntryZone: "Show the entry zone",
			showSRLines: "Show support and resistance",
			showTradeLevels: "Show entry, stop and target levels",
			slMaxPointsBtc: "Maximum stop distance — BTC (points)",
			slMaxPointsGold: "Maximum stop distance — gold (points)",
			slMaxPointsIndex: "Maximum stop distance — indices (points)",
			slMaxPointsOther: "Maximum stop distance — other (points)",
			slMinPointsGold: "Minimum stop distance — gold (points)",
			slopeLookback: "Bias slope lookback (bars)",
			srLeftBars: "Support / resistance · bars left of the pivot",
			srRightBars: "Support / resistance · bars right of the pivot",
			swingPivotLen: "Swing pivot length (stop loss)",
			tp1ClosePct: "TP1 close %",
			tp2ClosePct: "TP2 close %",
			tp5CloseAlways: "TP5 always closes, even while trailing",
			tpR: "TP{{n}} (in R)",
			tpSlMode: "Stop and target mode",
			trailAtrMult: "Trailing stop distance (× ATR)",
			trendPanelEmaLen: "Trend row EMA length",
			trendSlopeLB: "EMA Entry 2 slope lookback (bars)",
			useAdxFilter: "Require ADX above the mode threshold",
			useBiasFilter: "Score the higher-timeframe bias (never blocks an entry)",
			useEmaStackCheck: "Require the EMAs to be stacked in order",
			useInstrumentAutoDetect: "Detect the instrument automatically",
			useSessionFilter: "Only signal during trading sessions",
			useSlopeDynamic: "Scale the slope lookback to the timeframe",
			useStrictCandle: "Strict candle filter (wick and close)",
			useTrailingStop: "Trailing stop (from TP1)",
			useVolumeConfirm: "Require above-average volume at entry",
			volAvgLen: "Volume average length",
			volMultiplier: "Minimum volume (× average)"
		},
		maxStop: "Max SL",
		minuteAgainst: "Cross against the setup",
		minuteOk: "No warning",
		minuteReversal: "Cross · reversal possible",
		modeAtr: "ATR",
		modeAuto: "Automatic",
		modeRiskReward: "Risk / reward",
		noBias: "No bias",
		noSetup: "No active setup",
		recentTitle: "Recent setups",
		reEntry: "Re-entry",
		reEntryMark: "RE",
		rest: "REST",
		rowBias: "Bias",
		rowContext: "Context",
		rowInfo: "Info",
		rowSession: "Session",
		rowSetup: "Setup",
		rowVolume: "Volume",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "{{time}} left",
		sessionOutside: "Outside hours · London {{time}} UTC",
		sessionOverlap: "Overlap",
		statsTitle: "Last {{n}} setups",
		statusBreakEvenSet: "Break-even",
		statusMoveToBreakEven: "Move stop",
		statusPending: "Zone touch",
		statusRunning: "Running",
		statusSpike: "Volatile · hold",
		statusWaiting: "Waiting",
		stopHit: "Stop hit",
		styleDaytrade: "Day trading",
		styleScalping: "Scalping",
		styleSwing: "Swing",
		subFrameReversal: "Lower timeframe turning",
		targetHit: "Final target reached",
		trailStop: "Trailing stop",
		volAboveAverage: "above average",
		volBelowAverage: "below average",
		zoneEdgeBear: "Zone edge {{n}} (bearish)",
		zoneEdgeBull: "Zone edge {{n}} (bullish)"
	},
	tradingSessions: "Trading sessions",
	unintendedSymbol: "This strategy is designed for {{symbols}} — its levels may not be meaningful on {{symbol}}.",
	utBotAlerts: "UT Bot Alerts"
}, pe = {
	asia: "Asia",
	atrPeriod: "Período ATR",
	auraScanner: {
		guide: {
			bigDiamondMark: "Grande rojo/verde",
			bigDiamondMeaning: "Un rombo rojo grande sobre un máximo advierte del riesgo de comprar. Uno verde grande bajo un mínimo, del riesgo de vender.",
			blueMark: "Curva azul",
			blueMeaning: "50 EMA. Rosa sobre azul indica compra; por debajo, venta.",
			dashedMark: "Líneas discontinuas",
			dashedMeaning: "Soporte y resistencia. Rojas bajo el precio, verdes por encima.",
			diamondsMark: "Rombos",
			diamondsMeaning: "Puntos de giro. Los dorados son los más débiles; después, azules, rojos y verdes.",
			flatGoldMark: "Dorada horizontal",
			flatGoldMeaning: "El nivel con mayor volumen de las últimas seis horas en el gráfico de 15 minutos.",
			levelsMark: "Líneas de niveles",
			levelsMeaning: "Entrada, protección y objetivos de la última operación. Una marca indica que se alcanzó.",
			pinkMark: "Curva rosa",
			pinkMeaning: "20 EMA. Su cruce con la azul genera una señal.",
			subtitle: "Cómo leer este gráfico",
			thickGoldMark: "Dorada gruesa",
			thickGoldMeaning: "La 238. Si está entre la entrada y el objetivo, omite la operación.",
			title: "AURA",
			triangleMark: "Triángulo",
			triangleMeaning: "Una operación que superó todas las comprobaciones. Pasa el cursor para ver los valores."
		},
		groups: {
			display: "Visualización",
			eightChecks: "Las ocho comprobaciones",
			riskAndTargets: "Riesgo y objetivos",
			signalEngine: "Motor de señales"
		},
		inputs: {
			emaFastLen: "Línea rápida (rosa)",
			emaSlowLen: "Línea lenta (azul)",
			f1Clock: "1. Solo en la franja de buen volumen",
			f2Trend: "2. A favor de la tendencia de 15 minutos",
			f3Mode: "3. Vela del color incorrecto",
			f4Min: "Ampliación mínima de la separación (pips por vela)",
			f4Sep: "4. Las líneas se separan",
			f5Clear: "5. 238 fuera del tramo entre entrada y objetivo",
			f6R: "Espacio mínimo (× riesgo)",
			f6Reward: "6. Espacio hasta el siguiente nivel",
			f7Bars: "Durante las últimas (velas)",
			f7Consol: "7. Sin quedar atrapado en un rango",
			f7Pips: "El rango debe superar (pips)",
			f9Bars: "En las últimas N velas",
			f9Star: "8. Sin rombo grande de advertencia",
			guidePos: "Posición de la guía",
			longMode: "Modo de la línea de seguridad (238)",
			panelSize: "Tamaño del texto de los paneles",
			pipIn: "Tamaño del pip (0 = automático)",
			showClock: "Panel de situación actual",
			showGuide: "Guía de los símbolos",
			showLadder: "Niveles de operación a la derecha",
			showPoc: "Línea de volumen",
			showSr: "Niveles discontinuos",
			showStars: "Rombos de advertencia",
			showTable: "Tabla de tendencias",
			showTint: "Color de fondo",
			showWhy: "Explicar señales omitidas",
			slMinPips: "Separación mínima tras la línea lenta (pips)",
			srAtrMove: "Niveles: rebote necesario (× tamaño habitual de vela)",
			srLookback: "Niveles: historial de giros",
			srMax: "Máximo de niveles en pantalla",
			srRange: "Ignorar niveles más lejanos que (× tamaño habitual de vela)",
			srReset: "Niveles: nuevos contactos antes de eliminar",
			stripLen: "Anchura de la columna derecha (velas)",
			tablePos: "Posición del panel actual",
			theme: "Tema del gráfico",
			tp1R: "TP1 (múltiplo de R)",
			tp2R: "TP2 (múltiplo de R)",
			trendPos: "Posición de la tabla de tendencias",
			tz: "Zona horaria de las franjas de negociación"
		},
		ladder: {
			closedAtStop: "CERRADA por protección",
			closedAtTarget: "CERRADA TP{{hit}}",
			entry: "ENTRADA",
			stop: "PROTECCIÓN",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Escala automática",
			bottomCentre: "Abajo en el centro",
			bottomLeft: "Abajo a la izquierda",
			bottomRight: "Abajo a la derecha",
			dark: "Oscuro",
			ignore: "Ignorar",
			large: "Grande",
			light: "Claro",
			literal238: "Valor fijo 238",
			middleCentre: "En el centro",
			middleLeft: "Centro a la izquierda",
			middleRight: "Centro a la derecha",
			normal: "Estándar",
			reject: "Rechazar",
			small: "Pequeño",
			topCentre: "Arriba en el centro",
			topLeft: "Arriba a la izquierda",
			topRight: "Arriba a la derecha",
			waitForPullback: "Esperar retroceso"
		},
		reasons: {
			clock: "fuera de la franja de negociación",
			diamond: "acaba de aparecer un rombo grande de advertencia",
			range: "el gráfico está atrapado en una consolidación",
			room: "hay un nivel demasiado cerca, sin espacio hasta el objetivo",
			safetyLine: "la 238 está entre la entrada y el objetivo",
			separation: "las líneas están demasiado juntas, aún no hay espacio para avanzar",
			trend: "en contra de la tendencia de 15 minutos",
			wrongColour: "la vela del cruce cerró con el color incorrecto"
		},
		rightNow: {
			aBuy: "Compra",
			aSell: "Venta",
			bestBuysOnly: "buscar solo compras",
			bestNow: "Ahora conviene",
			bestSellsOnly: "buscar solo ventas",
			bestWaitThin: "esperar, el volumen es bajo",
			goodVolume: "Buen volumen",
			lowVolume: "Volumen bajo",
			safetyAbove: "238 sobre el precio, margen para las ventas",
			safetyBelow: "238 bajo el precio, margen para las compras",
			safetyLine: "Línea de seguridad",
			skipped: "Omitida",
			skippedAgo_one: "{{side}} hace {{bars}} vela: {{reason}}",
			skippedAgo_other: "{{side}} hace {{bars}} velas: {{reason}}",
			skippedNothing: "aún no se ha omitido nada",
			title: "AHORA MISMO",
			trend: "Tendencia",
			trendSummaryDown: "15m a la baja, {{agree}} de 6 marcos temporales al alza",
			trendSummaryUp: "15m al alza, {{agree}} de 6 marcos temporales al alza",
			skippedAgo_many: "{{side}} hace {{bars}} velas: {{reason}}"
		},
		signal: {
			buy: "COMPRA",
			pips: "pips",
			sell: "VENTA",
			stop: "Protección"
		},
		tooltip: {
			f3Mode: "Una compra en una vela roja o una venta en una azul nunca se ejecuta directamente. Esperar retroceso espera a que el precio vuelva a las líneas en una vela del color adecuado. Rechazar descarta la señal.",
			f4Min: "La rapidez con que se separan las líneas en la vela de señal. Si están entrelazadas y planas, no hay espacio para avanzar.",
			f6Reward: "El siguiente nivel discontinuo debe estar al menos a esta distancia. Desactivado por defecto: el escáner traza los niveles con su propio método, así que comprueba también el espacio a simple vista.",
			f7Pips: "Evita consolidaciones de 100 pips o menos.",
			longMode: "238 es el ajuste estándar para gráficos de un minuto. La escala automática adapta la línea de seguridad a otros marcos temporales: unos 83 en un gráfico de tres minutos.",
			pipIn: "Automático: 0.10 para el oro y diez ticks para los demás (1 punto en US30).",
			showGuide: "Una leyenda breve en el gráfico. Desactívala cuando conozcas los símbolos.",
			showLadder: "La entrada, la protección y los objetivos de la última operación se dibujan a la derecha de la última vela. Los objetivos alcanzados se marcan.",
			showWhy: "Cuando las líneas se cruzan pero una comprobación bloquea la operación, el panel de situación actual indica cuál y por qué.",
			slMinPips: "La protección se coloca al otro lado de las líneas roja y azul, al menos a 10 pips de la azul.",
			srMax: "Solo se conservan los niveles más próximos al precio para que el gráfico siga siendo legible.",
			theme: "Adáptalo al tema de TradingView para distinguir bien todos los colores.",
			tz: "Las franjas de negociación se definen en esta zona horaria. America/Denver corresponde a la hora de la montaña de Norteamérica con horario de verano. Usa America/Phoenix para esa hora sin cambios estacionales."
		},
		trendTable: {
			above: "por encima",
			below: "por debajo",
			down: "A la baja",
			notAvailable: "sin datos",
			up: "Al alza",
			volumeLine: "Línea de volumen"
		}
	},
	bearish: "Bajista",
	bfs: {
		duplicateRemoved: "Solo se admite un indicador BFS — Blessed Flow System por gráfico; se eliminó el duplicado.",
		emaCrossSoon: "EMA30/50 a punto de cruzarse",
		engineOff: "cambia a M1",
		engineOn: "motor M1",
		input: {
			armWin: "Ventana (velas M1) para tocar la EMA30",
			asiaSess: "Asia (HHMM-HHMM)",
			bePts: "BE: a +puntos el stop se mueve A ese nivel",
			cooldown: "Espera (velas M1) tras cerrar una operación",
			lenFast: "EMA rápida (dirección)",
			lenH1a: "H1 · EMA corta",
			lenH1b: "H1 · EMA larga",
			lenMid: "EMA media",
			lenSlow: "EMA lenta",
			londonSess: "Londres (HHMM-HHMM, reloj de sesión)",
			maxPerBlock: "Entradas máximas por bloque de sesión (0 = sin límite)",
			nearLb: "Velas usadas para medir la convergencia",
			nearPts: "Distancia máxima EMA30-EMA50 (puntos)",
			nySess: "Nueva York (HHMM-HHMM)",
			onlyM1: "Ejecutar el motor solo en M1",
			pv: "Valor en precio de 1 punto",
			r1lb: "R1 · velas M1 revisadas (precio no extendido)",
			rr: "Ratio de TP R:R (sin la escalera)",
			rsiHi: "RSI >= para CORTO",
			rsiLen: "Longitud del RSI",
			rsiLo: "RSI <= para LARGO",
			rsiWin: "Ventana de espera (velas tras la señal)",
			showLevels: "Dibujar los niveles de la operación",
			showNear: "Marcar cuando la EMA30 esté a punto de cruzar la EMA50",
			slPts: "SL (puntos)",
			swLenA: "Fuerza del pivote (velas a cada lado)",
			tp1Pts: "TP1 (puntos)",
			tp2Pts: "TP2 (puntos)",
			tp3Pts: "TP3 (puntos)",
			tzOffset: "Desfase UTC del reloj de sesión (Bogotá = -5)",
			useArm: "Exigir retroceso del 50 % y toque de la EMA30 en la ventana",
			useAsia: "Incluir Asia (solo pruebas)",
			useBE: "Punto de equilibrio activo",
			useLadder: "Usar TP1/TP2/TP3 (salida final = TP3)",
			useR2: "R2 · exigir orden M5 + M15 y sesgo H1",
			useRSI: "Esperar al RSI después de la señal",
			useSess: "Filtrar por sesión",
			useTrend: "Mantener el orden de las EMA durante la espera"
		},
		longSignal: "Señal larga",
		noSignal: "sin señal",
		retracementDot: "Punto del retroceso del 50 %",
		rewardZone: "Zona de beneficio",
		riskZone: "Zona de riesgo",
		session: "Sesión",
		sessionClosed: "cerrada",
		sessionOpen: "abierta",
		shortSignal: "Señal corta",
		signal: "Señal",
		signalActive: "{{side}} en curso",
		waitingRsi: "esperando el RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Esperando el RSI (largo)",
		waitingRsiShort: "Esperando el RSI (corto)"
	},
	breakEven: "Punto de equilibrio",
	bullish: "Alcista",
	buy: "Compra",
	colour: "Color",
	cypher: {
		above55: "Encima de 55",
		aboveBelow: "Encima/Debajo",
		barColors: "Colores de barras",
		bbLength: "Longitud BB",
		bbStdDev: "Desviación estándar BB {{n}}",
		bearBreak: "Ruptura bajista",
		bearPattern: "Pin bar / envolvente bajista",
		below55: "Debajo de 55",
		bullBreak: "Ruptura alcista",
		bullPattern: "Pin bar / envolvente alcista",
		cmoLength: "Longitud CMO",
		colorCandles: "Colorear velas",
		confluenceLong: "Confluencia Long",
		confluenceShort: "Confluencia Short",
		consolidating: "Consolidación",
		direction: "Dirección",
		emaPeriodTrend: "Período EMA (tendencia)",
		flagOffsetAtr: "Desplazamiento de la bandera (x ATR)",
		flashBackground: "Fondo del destello",
		flashCount: "Número de destellos",
		flashHz: "Velocidad del destello (parpadeos / s)",
		flashOn: "Destellar con nueva señal",
		flashShowBanner: "Mostrar banner NEW BUY / SELL",
		flashShowBg: "Destellar el fondo del gráfico",
		flashStrength: "Intensidad del destello de fondo",
		flashTest: "Probar destello ahora (vista previa)",
		fvgKeep: "Fair Value Gaps por lado",
		glowOpacity: "Opacidad del brillo (más alto = más transparente)",
		glowSizeTicks: "Tamaño del brillo (ticks)",
		groupFlash: "Alerta de nueva señal",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "Niveles KDE",
		groupKeyLevels: "Niveles clave",
		groupLrEma: "Canal LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivotes",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Bandas de reversión",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Componentes",
		groupTrendTable: "Tabla de tendencia",
		groupVidya: "VIDYA / Tendencia",
		halfTrendAmplitude: "Amplitud HalfTrend",
		halfTrendChannelDeviation: "Desviación del canal HalfTrend",
		ichimokuBase: "Línea base Ichimoku",
		ichimokuConversion: "Línea de conversión Ichimoku",
		kdeActivation: "Activar umbral de activación",
		kdeBins: "Número de intervalos",
		kdeThreshold: "Umbral %",
		labelPosition: "Posición de la etiqueta",
		lineWidth: "Grosor de línea",
		lowerBb: "BB{{n}} inferior",
		lowerInnerZone: "Zona interior inferior",
		lowerReversalZone: "Zona de reversión inferior",
		maCloudLong: "Nube MA (larga)",
		maCloudShort: "Nube MA (corta)",
		newBuy: "NUEVA COMPRA",
		newSell: "NUEVA VENTA",
		numberOfLevels: "Número de niveles",
		parabolicSar: "SAR parabólico",
		pivotAuto: "Auto",
		pivotDaily: "Diario",
		pivotMonthly: "Mensual",
		pivotsTimeframe: "Marco temporal de pivotes",
		pivotWeekly: "Semanal",
		positionBottomCenter: "Abajo al centro",
		positionBottomLeft: "Abajo a la izquierda",
		positionBottomRight: "Abajo a la derecha",
		positionLeft: "Izquierda",
		positionRight: "Derecha",
		positionTopCenter: "Arriba al centro",
		positionTopLeft: "Arriba a la izquierda",
		positionTopRight: "Arriba a la derecha",
		psarBear: "PSAR bajista",
		psarBull: "PSAR alcista",
		psarIncrement: "Incremento PSAR",
		psarMax: "Máximo PSAR",
		psarStart: "Inicio PSAR",
		pullingBack: "Retroceso",
		pulseSmoothingBars: "Barras de suavizado Pulse",
		reEntry: "Reentrada",
		rightOffsetBars: "Desplazamiento a la derecha (barras)",
		showCamarillaPivots: "Mostrar pivotes Camarilla",
		showConfluenceFlag: "Mostrar bandera de confluencia (B/S)",
		showFvg: "Fair Value Gaps (15m o más)",
		showKde: "Niveles de volumen KDE",
		showKeyLevels: "Mostrar niveles clave",
		showLabels: "Mostrar etiquetas",
		showLevelGlow: "Mostrar brillo del nivel",
		showMaCloud: "Mostrar nube MA",
		showPrices: "Mostrar precios",
		showPsar: "Mostrar PSAR",
		showReversalBands: "Mostrar bandas de reversión",
		showSlTpLabels: "Mostrar etiquetas SL / TP",
		showSniperBreakArrows: "Mostrar flechas Sniper / de ruptura",
		showTrendTable: "Mostrar tabla de tendencia",
		showVidya233: "Mostrar VIDYA 233",
		showVidya55: "Mostrar VIDYA 55",
		showVidya987: "Mostrar VIDYA 987 (imán)",
		showVidyaLines: "Mostrar líneas VIDYA",
		sizeNormal: "Normal",
		sizeSmall: "Pequeño",
		sizeTiny: "Diminuto",
		slBufferAtr: "SL: margen máximo (x ATR)",
		slBufferPips: "SL: margen tras el swing (pips)",
		slMaxRiskAtr: "SL: riesgo máximo (x ATR)",
		slSwingLookback: "SL: retrospectiva del swing (barras)",
		sniperDown: "Sniper abajo",
		sniperUp: "Sniper arriba",
		source: "Fuente",
		state: "Estado",
		strength: "Fuerza",
		strong: "Fuerte",
		superTrend2AtrLength: "Longitud ATR SuperTrend 2",
		superTrend2Factor: "Factor SuperTrend 2",
		superTrendAtrLength: "Longitud ATR SuperTrend",
		superTrendMultiplier: "Multiplicador SuperTrend",
		tablePosition: "Posición de la tabla",
		tableSize: "Tamaño de la tabla",
		tpRiskReward: "TP {{n}} riesgo/beneficio",
		tradeManagement: "Gestión de operaciones (SL / TP)",
		trend: "Tendencia",
		trending: "En tendencia",
		upperBb: "BB{{n}} superior",
		upperInnerZone: "Zona interior superior",
		upperReversalZone: "Zona de reversión superior",
		veryStrong: "Muy fuerte",
		veryWeak: "Muy débil",
		vidya987Magnet: "VIDYA 987 (imán)",
		volumeAvgLength: "Longitud media de volumen (filtro de ruptura)",
		weak: "Débil",
		zoneEdge: "{{name}} (borde de relleno)"
	},
	entry: "Entrada",
	gainColor: "Color de ganancia",
	harsiCandle: "Vela HARSI",
	harsiLength: "Longitud HARSI",
	heikinAshiRsiOscillator: "Oscilador RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "Valor clave 'Esto cambia la sensibilidad'",
	labelsIndicator: "Indicador de etiquetas",
	london: "Londres",
	londonBackground: "Fondo de Londres",
	londonSession: "Sesión de Londres",
	long: "Largo",
	lossColor: "Color de pérdida",
	median: "Mediana",
	neutral: "Neutral",
	newYork: "Nueva York",
	newYorkBackground: "Fondo de Nueva York",
	newYorkSession: "Sesión de Nueva York",
	openSmoothing: "Suavizado de apertura",
	optimus: {
		activeTradeLevels: "Operación activa · niveles",
		bias: "Sesgo",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "MIXTO {{n}}/{{total}}",
		disclaimer: "Los niveles están dibujados en el gráfico. No es asesoramiento financiero.",
		duplicateRemoved: "Solo se admite un indicador Optimus Prime por gráfico; se eliminó el duplicado.",
		enter: "ENTRAR · {{side}}",
		input: {
			atrLength: "Longitud del ATR del KC",
			buffer: "Margen del swing (en precio)",
			emaLength: "Longitud de la EMA",
			kcLength: "Longitud del KC",
			kcMult: "Multiplicador del KC",
			lrcLength: "Longitud del LRC",
			minRisk: "Riesgo R mínimo (en precio)",
			requireAlign: "Exigir la EMA y el LRC alineados",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Velas revisadas del swing (R)"
		},
		kcLower: "KC inferior",
		kcMid: "KC medio",
		kcUpper: "KC superior",
		keltnerFill: "Relleno de Keltner",
		noClosedTrades: "Aún no hay operaciones cerradas",
		reasonForming: "Setup formándose — falta confirmación",
		reasonLatched: "Operación fijada · niveles en el gráfico",
		reasonNoSetup: "Sin setup · EMA/LRC no alineados",
		recentSignals: "Señales recientes",
		riskReward: "RIESGO/BENEFICIO",
		trendMtf: "Tendencia · varias temporalidades",
		wait: "ESPERAR",
		warmingUp: "INICIANDO"
	},
	overbought: "Sobrecomprado",
	overboughtMax: "Sobrecompra Máx",
	overboughtMin: "Sobrecompra Mín",
	oversold: "Sobrevendido",
	oversoldMax: "Sobreventa Máx",
	oversoldMin: "Sobreventa Mín",
	rsiLength: "Longitud RSI",
	rsiLine: "Línea RSI",
	rsiLineShadow: "Sombra de la línea RSI",
	sell: "Venta",
	short: "Corto",
	signalsFromHeikinAshiCandles: "Señales de velas Heikin Ashi",
	sl: "SL",
	smoothedMode: "Modo suavizado",
	sydney: "Sídney",
	sydneyBackground: "Fondo de Sídney",
	sydneySession: "Sesión de Sídney",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokio",
	tokyoBackground: "Fondo de Tokio",
	tokyoSession: "Sesión de Tokio",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "bajista",
			bullish: "alcista",
			confluence: "confluencia",
			entry: "entrada",
			neckline: "línea de cuello",
			score: "puntuación",
			state: "estado",
			states: {
				completed: "completado",
				invalidated: "invalidado",
				projected: "proyectado",
				przActive: "PRZ activa",
				stopped: "stop alcanzado"
			},
			stop: "stop",
			target: "objetivo"
		},
		classic: {
			doubleBottom: "Doble suelo",
			doubleTop: "Doble techo",
			headAndShoulders: "Hombro-Cabeza-Hombro",
			inverseHeadAndShoulders: "HCH inv.",
			tripleBottom: "Triple suelo",
			tripleTop: "Triple techo"
		},
		direction: {
			bearishOnly: "Solo bajista",
			both: "Ambas",
			bullishOnly: "Solo alcista"
		},
		group: {
			classics: "Patrones clásicos y S/R",
			filters: "Filtros y visualización",
			patterns: "Patrones",
			pivotEngine: "Motor de pivotes",
			ratios: "Ratios y tolerancia"
		},
		input: {
			atrLen: "Período ATR",
			atrMult: "Reversión del zigzag (x ATR)",
			colBear: "Bajista",
			colBull: "Alcista",
			colPrz: "PRZ",
			colSR: "Niveles clave",
			dirFilter: "Filtro de dirección",
			enClassics: "Detectar patrones clásicos",
			enDoubles: "Doble techo / suelo",
			enHS: "Hombro-Cabeza-Hombro",
			enTriples: "Triple techo / suelo",
			fillTransp: "Transparencia del relleno del patrón",
			formingLife: "Vida de la zona en formación (velas)",
			keepFailed: "Mantener en el gráfico los patrones con stop alcanzado (✕, atenuados)",
			keepSuccessful: "Mantener en el gráfico los patrones exitosos (✓)",
			maxPatterns: "Máx. de patrones en el gráfico",
			minScore: "Puntuación mínima de calidad",
			pivotDepth: "Profundidad del búfer de pivotes",
			showLetters: "Mostrar letras de los puntos X A B C D",
			showPlan: "Mostrar niveles del plan de trading",
			showProjected: "Mostrar patrones proyectados (en formación)",
			showRatios: "Mostrar ratios en los tramos",
			showSR: "Niveles de soporte/resistencia",
			showStats: "Mostrar tabla de estadísticas",
			srMinTouch: "S/R: mínimo de toques de pivote",
			tolEdge: "Tolerancia en el borde del rango",
			tolPoint: "Tolerancia de ratios de puntos",
			useScale2: "Escanear también la escala 2x (estructuras mayores)"
		},
		label: {
			confirmed: "confirmado",
			forming: "en formación",
			sl: "SL",
			target: "objetivo",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Completados",
			stops: "Stops",
			t1Wins: "Aciertos T1",
			winRate: "% de acierto"
		},
		tooltip: {
			colPrz: "PRZ en ámbar sin importar la dirección del patrón (predeterminado de ProTrader).",
			fillTransp: "Menor = relleno más visible. Entre 65 y 80 funciona bien.",
			formingLife: "Un patrón en formación cuyo punto C es más antiguo que este valor, sin completarse ni invalidarse, caduca y se elimina.",
			maxPatterns: "Los patrones más antiguos se eliminan primero, así el historial reciente (✓ / ✕) y las zonas en formación recientes siempre quedan visibles.",
			showProjected: "Dibuja la estructura X-A-B con una guía discontinua hacia la PRZ proyectada.",
			showRatios: "Diagonales de medición punteadas (X-B, A-C, B-D, X-D) con el ratio de Fibonacci medido en cada punto medio, la anotación estándar de los gráficos armónicos.",
			tolPoint: "Se aplica a ratios exactos como Gartley B=0.618. Estricto = 0.03, equilibrado = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ CERRAR TODO",
		duplicateRemoved: "Solo se admite un indicador Trade Finder por gráfico; se eliminó el duplicado.",
		durationHm: "{{h}} h {{m}} min",
		durationM: "{{m}} min",
		emaEntry1: "EMA Entrada 1",
		emaEntry2: "EMA Entrada 2 / Tendencia",
		emaRangeFilter: "EMA Filtro de rango",
		emaTrigger: "EMA Disparador",
		entry1: "Entrada 1",
		entry2: "Entrada 2",
		entry2Mark: "E2",
		entryZoneBear: "Zona de entrada {{n}} (bajista)",
		entryZoneBull: "Zona de entrada {{n}} (alcista)",
		frameFailed: "No se pudo cargar el marco temporal {{frame}}; se reintentará.",
		framesUnavailable: "Sin datos de marcos · esperar",
		ghostEntry: "Setup anterior",
		ghostStop: "Stop anterior",
		group: {
			bias: "Sesgo",
			display: "Visualización",
			emaSystem: "Sistema de EMA",
			entries: "Entradas",
			filter: "Filtro",
			riskManagement: "Gestión de riesgo",
			session: "Sesión",
			supportResistance: "Soporte y resistencia",
			trailingStop: "Stop dinámico",
			trendPanel: "Panel de tendencia"
		},
		input: {
			adxLen: "Longitud de ADX",
			adxSmoothing: "Suavizado de ADX",
			asiaSession: "Sesión de Asia / Tokio (UTC)",
			atrBufferMultBtc: "Margen del stop tras el swing — BTC (× ATR)",
			atrBufferMultGold: "Margen del stop tras el swing — oro (× ATR)",
			atrBufferMultOther: "Margen del stop tras el swing — otros (× ATR)",
			atrLength: "Longitud del ATR (gestión de riesgo)",
			atrSlMult: "Stop loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Oro: punto de equilibrio tras estos puntos",
			biasEmaLen: "Longitud de la EMA del sesgo",
			crossLookback: "Ventana de cruces del sesgo (barras)",
			dxySymbol: "Símbolo del índice dólar (vacío lo desactiva)",
			emaBigLen: "Longitud de EMA Filtro de rango",
			emaFastLen: "Longitud de EMA Entrada 1",
			emaMidLen: "Longitud de EMA Entrada 2 / Tendencia",
			emaTriggerLen: "Longitud de EMA Disparador",
			feeBufferPct: "Margen de comisiones sobre el punto de equilibrio (%)",
			flatThreshPct: "Umbral de planitud (% de la EMA del sesgo)",
			londonSession: "Sesión de Londres (UTC)",
			maxCrosses: "Cruces máximos antes de descartar el sesgo",
			newYorkSession: "Sesión de Nueva York (UTC)",
			showEmaLabels: "Mostrar etiquetas con el nombre de las EMA",
			showEntrySignals: "Mostrar marcadores de configuración",
			showEntryZone: "Mostrar la zona de entrada",
			showSRLines: "Mostrar soporte y resistencia",
			showTradeLevels: "Mostrar niveles de entrada, stop y objetivo",
			slMaxPointsBtc: "Distancia máxima del stop — BTC (puntos)",
			slMaxPointsGold: "Distancia máxima del stop — oro (puntos)",
			slMaxPointsIndex: "Distancia máxima del stop — índices (puntos)",
			slMaxPointsOther: "Distancia máxima del stop — otros (puntos)",
			slMinPointsGold: "Distancia mínima del stop — oro (puntos)",
			slopeLookback: "Ventana de pendiente del sesgo (barras)",
			srLeftBars: "Soporte / resistencia · barras a la izquierda del pivote",
			srRightBars: "Soporte / resistencia · barras a la derecha del pivote",
			swingPivotLen: "Longitud del pivote de swing (stop loss)",
			tp1ClosePct: "Cerrar en TP1 %",
			tp2ClosePct: "Cerrar en TP2 %",
			tp5CloseAlways: "TP5 siempre cierra, incluso con stop dinámico",
			tpR: "TP{{n}} (en R)",
			tpSlMode: "Modo de stop y objetivos",
			trailAtrMult: "Distancia del stop dinámico (× ATR)",
			trendPanelEmaLen: "Longitud de la EMA de la fila de tendencia",
			trendSlopeLB: "Retroceso de la pendiente de EMA Entrada 2 (barras)",
			useAdxFilter: "Exigir ADX por encima del umbral del modo",
			useBiasFilter: "Puntuar el sesgo superior (nunca bloquea la entrada)",
			useEmaStackCheck: "Exigir que las EMA estén ordenadas",
			useInstrumentAutoDetect: "Detectar el instrumento automáticamente",
			useSessionFilter: "Señales solo durante las sesiones de negociación",
			useSlopeDynamic: "Ajustar el retroceso de la pendiente al marco temporal",
			useStrictCandle: "Filtro de vela estricto (mecha y cierre)",
			useTrailingStop: "Stop dinámico (desde TP1)",
			useVolumeConfirm: "Exigir volumen superior a la media en la entrada",
			volAvgLen: "Longitud de la media de volumen",
			volMultiplier: "Volumen mínimo (× media)"
		},
		maxStop: "SL máx.",
		minuteAgainst: "Cruce contra el setup",
		minuteOk: "Sin avisos",
		minuteReversal: "Cruce · posible reversión",
		modeAtr: "ATR",
		modeAuto: "Automático",
		modeRiskReward: "Riesgo / beneficio",
		noBias: "Sin sesgo",
		noSetup: "Sin setup activo",
		recentTitle: "Setups recientes",
		reEntry: "Reentrada",
		reEntryMark: "RE",
		rest: "RESTO",
		rowBias: "Sesgo",
		rowContext: "Contexto",
		rowInfo: "Info",
		rowSession: "Sesión",
		rowSetup: "Setup",
		rowVolume: "Volumen",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "queda {{time}}",
		sessionOutside: "Sin sesión · Londres {{time}} UTC",
		sessionOverlap: "Solapamiento",
		statsTitle: "Últimos {{n}} setups",
		statusBreakEvenSet: "Sin pérdida",
		statusMoveToBreakEven: "Mover el stop",
		statusPending: "Toque de zona",
		statusRunning: "En curso",
		statusSpike: "Volátil · espera",
		statusWaiting: "Esperando",
		stopHit: "Stop alcanzado",
		styleDaytrade: "Intradía",
		styleScalping: "Scalping",
		styleSwing: "Swing",
		subFrameReversal: "El marco inferior está girando",
		targetHit: "Objetivo final alcanzado",
		trailStop: "Stop dinámico",
		volAboveAverage: "sobre la media",
		volBelowAverage: "bajo la media",
		zoneEdgeBear: "Borde de zona {{n}} (bajista)",
		zoneEdgeBull: "Borde de zona {{n}} (alcista)"
	},
	tradingSessions: "Sesiones de trading",
	unintendedSymbol: "Esta estrategia está pensada para {{symbols}}; en {{symbol}} sus niveles pueden no significar nada.",
	utBotAlerts: "Alertas UT Bot"
}, me = {
	asia: "Asie",
	atrPeriod: "Période ATR",
	auraScanner: {
		guide: {
			bigDiamondMark: "Grand rouge/vert",
			bigDiamondMeaning: "Un grand losange rouge au-dessus d'un sommet avertit avant un achat. Un grand vert sous un creux, avant une vente.",
			blueMark: "Courbe bleue",
			blueMeaning: "50 EMA. Rose au-dessus du bleu indique un achat, en dessous une vente.",
			dashedMark: "Lignes pointillées",
			dashedMeaning: "Support et résistance. Rouges sous le cours, vertes au-dessus.",
			diamondsMark: "Losanges",
			diamondsMeaning: "Points de retournement. Dorés les plus faibles, puis bleus, rouges et verts.",
			flatGoldMark: "Dorée horizontale",
			flatGoldMeaning: "Le niveau au plus fort volume des six dernières heures sur le graphique de 15 minutes.",
			levelsMark: "Lignes de niveaux",
			levelsMeaning: "Entrée, protection et objectifs de la dernière opération. Une coche signifie atteint.",
			pinkMark: "Courbe rose",
			pinkMeaning: "20 EMA. Son croisement avec la bleue donne un signal.",
			subtitle: "Comment lire ce graphique",
			thickGoldMark: "Dorée épaisse",
			thickGoldMeaning: "La 238. Si elle est entre l'entrée et l'objectif, passez votre tour.",
			title: "AURA",
			triangleMark: "Triangle",
			triangleMeaning: "Une opération ayant passé tous les contrôles. Survolez pour voir les valeurs."
		},
		groups: {
			display: "Affichage",
			eightChecks: "Les huit contrôles",
			riskAndTargets: "Risque et objectifs",
			signalEngine: "Moteur de signaux"
		},
		inputs: {
			emaFastLen: "Ligne rapide (rose)",
			emaSlowLen: "Ligne lente (bleue)",
			f1Clock: "1. Uniquement pendant les plages de bon volume",
			f2Trend: "2. Dans le sens de la tendance de 15 minutes",
			f3Mode: "3. Bougie de la mauvaise couleur",
			f4Min: "Écartement minimal (pips par bougie)",
			f4Sep: "4. Les lignes s'écartent",
			f5Clear: "5. 238 hors du trajet entrée–objectif",
			f6R: "Marge minimale (× risque)",
			f6Reward: "6. Marge jusqu'au prochain niveau",
			f7Bars: "Sur les dernières (bougies)",
			f7Consol: "7. Hors d'une zone de consolidation",
			f7Pips: "L'amplitude doit dépasser (pips)",
			f9Bars: "Sur les N dernières bougies",
			f9Star: "8. Aucun grand losange d'avertissement",
			guidePos: "Position du guide",
			longMode: "Mode de la ligne de sécurité (238)",
			panelSize: "Taille du texte des panneaux",
			pipIn: "Taille du pip (0 = automatique)",
			showClock: "Panneau de situation actuelle",
			showGuide: "Guide des repères",
			showLadder: "Niveaux de l'opération à droite",
			showPoc: "Ligne de volume",
			showSr: "Niveaux pointillés",
			showStars: "Losanges d'avertissement",
			showTable: "Tableau des tendances",
			showTint: "Couleur de fond",
			showWhy: "Expliquer les signaux ignorés",
			slMinPips: "Écart minimal au-delà de la ligne lente (pips)",
			srAtrMove: "Niveaux : rebond requis (× taille habituelle d'une bougie)",
			srLookback: "Niveaux : historique des retournements",
			srMax: "Nombre maximal de niveaux affichés",
			srRange: "Ignorer les niveaux au-delà de (× taille habituelle d'une bougie)",
			srReset: "Niveaux : nouveaux tests avant suppression",
			stripLen: "Largeur de la colonne de droite (bougies)",
			tablePos: "Position du panneau actuel",
			theme: "Thème du graphique",
			tp1R: "TP1 (multiple de R)",
			tp2R: "TP2 (multiple de R)",
			trendPos: "Position du tableau des tendances",
			tz: "Fuseau horaire des plages de négociation"
		},
		ladder: {
			closedAtStop: "CLÔTURÉE sur protection",
			closedAtTarget: "CLÔTURÉE TP{{hit}}",
			entry: "ENTRÉE",
			stop: "PROTECTION",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Échelle automatique",
			bottomCentre: "En bas au centre",
			bottomLeft: "En bas à gauche",
			bottomRight: "En bas à droite",
			dark: "Sombre",
			ignore: "Ignorer",
			large: "Grand",
			light: "Clair",
			literal238: "Valeur fixe 238",
			middleCentre: "Au centre",
			middleLeft: "Au milieu à gauche",
			middleRight: "Au milieu à droite",
			normal: "Standard",
			reject: "Rejeter",
			small: "Petit",
			topCentre: "En haut au centre",
			topLeft: "En haut à gauche",
			topRight: "En haut à droite",
			waitForPullback: "Attendre un repli"
		},
		reasons: {
			clock: "hors des plages de négociation",
			diamond: "un grand losange d'avertissement vient d'apparaître",
			range: "le graphique reste en consolidation",
			room: "un niveau est trop proche, sans marge jusqu'à l'objectif",
			safetyLine: "la 238 est entre l'entrée et l'objectif",
			separation: "les lignes sont trop proches, pas encore de place pour avancer",
			trend: "contre la tendance de 15 minutes",
			wrongColour: "la bougie du croisement a clôturé avec la mauvaise couleur"
		},
		rightNow: {
			aBuy: "Achat",
			aSell: "Vente",
			bestBuysOnly: "chercher uniquement des achats",
			bestNow: "À privilégier",
			bestSellsOnly: "chercher uniquement des ventes",
			bestWaitThin: "attendre, volume faible",
			goodVolume: "Bon volume",
			lowVolume: "Volume faible",
			safetyAbove: "238 au-dessus du cours, marge pour les ventes",
			safetyBelow: "238 sous le cours, marge pour les achats",
			safetyLine: "Ligne de sécurité",
			skipped: "Ignoré",
			skippedAgo_one: "{{side}} il y a {{bars}} bougie : {{reason}}",
			skippedAgo_other: "{{side}} il y a {{bars}} bougies : {{reason}}",
			skippedNothing: "aucun signal ignoré pour l'instant",
			title: "EN CE MOMENT",
			trend: "Tendance",
			trendSummaryDown: "15m en baisse, {{agree}} unités de temps sur 6 en hausse",
			trendSummaryUp: "15m en hausse, {{agree}} unités de temps sur 6 en hausse",
			skippedAgo_many: "{{side}} il y a {{bars}} bougies : {{reason}}"
		},
		signal: {
			buy: "ACHAT",
			pips: "pips",
			sell: "VENTE",
			stop: "Protection"
		},
		tooltip: {
			f3Mode: "Un achat sur une bougie rouge ou une vente sur une bleue n'est jamais pris directement. Attendre un repli attend le retour du cours vers les lignes sur une bougie de la bonne couleur. Rejeter écarte le signal.",
			f4Min: "La vitesse d'écartement des lignes sur la bougie du signal. Des lignes plates et emmêlées ne laissent pas de place au mouvement.",
			f6Reward: "Le prochain niveau pointillé doit être au moins à cette distance. Désactivé par défaut : les niveaux sont tracés selon la méthode propre au scanner. Vérifiez donc aussi la marge visuellement.",
			f7Pips: "Évitez les consolidations de 100 pips ou moins.",
			longMode: "238 est le réglage standard pour les graphiques d'une minute. L'échelle automatique adapte la ligne de sécurité aux autres unités de temps, environ 83 sur un graphique de trois minutes.",
			pipIn: "Automatique : 0.10 pour l'or et dix ticks ailleurs (1 point sur US30).",
			showGuide: "Une courte légende sur le graphique. Désactivez-la lorsque vous connaissez les repères.",
			showLadder: "L'entrée, la protection et les objectifs de la dernière opération figurent à droite de la dernière bougie. Les objectifs atteints sont cochés.",
			showWhy: "Quand les lignes se croisent mais qu'un contrôle bloque l'opération, le panneau actuel indique le contrôle et sa raison.",
			slMinPips: "La protection est placée de l'autre côté des lignes rouge et bleue, à au moins 10 pips de la bleue.",
			srMax: "Seuls les niveaux les plus proches du cours restent affichés pour garder le graphique lisible.",
			theme: "Choisissez le même thème que TradingView pour bien distinguer toutes les couleurs.",
			tz: "Les plages de négociation utilisent ce fuseau horaire. America/Denver correspond à l'heure des Rocheuses avec passage à l'heure d'été. Utilisez America/Phoenix pour cette heure sans changement saisonnier."
		},
		trendTable: {
			above: "au-dessus",
			below: "en dessous",
			down: "En baisse",
			notAvailable: "indisponible",
			up: "En hausse",
			volumeLine: "Ligne de volume"
		}
	},
	bearish: "Baissier",
	bfs: {
		duplicateRemoved: "Un seul indicateur BFS — Blessed Flow System est pris en charge par graphique — le doublon a été supprimé.",
		emaCrossSoon: "EMA30/50 sur le point de se croiser",
		engineOff: "passer en M1",
		engineOn: "moteur M1",
		input: {
			armWin: "Fenêtre (bougies M1) pour toucher l'EMA30",
			asiaSess: "Asie (HHMM-HHMM)",
			bePts: "BE : à +points, le stop est déplacé SUR ce niveau",
			cooldown: "Pause (bougies M1) après la clôture d'un trade",
			lenFast: "EMA rapide (direction)",
			lenH1a: "H1 · EMA courte",
			lenH1b: "H1 · EMA longue",
			lenMid: "EMA moyenne",
			lenSlow: "EMA lente",
			londonSess: "Londres (HHMM-HHMM, horloge de séance)",
			maxPerBlock: "Entrées max. par bloc de séance (0 = sans limite)",
			nearLb: "Bougies utilisées pour mesurer la convergence",
			nearPts: "Écart maximal EMA30-EMA50 (points)",
			nySess: "New York (HHMM-HHMM)",
			onlyM1: "N'exécuter le moteur qu'en M1",
			pv: "Valeur en prix d'un point",
			r1lb: "R1 · profondeur M1 (prix non étiré)",
			rr: "Ratio de TP R:R (sans l'échelle)",
			rsiHi: "RSI >= pour un SHORT",
			rsiLen: "Longueur du RSI",
			rsiLo: "RSI <= pour un LONG",
			rsiWin: "Fenêtre d'attente (bougies après le signal)",
			showLevels: "Tracer les niveaux du trade",
			showNear: "Signaler quand l'EMA30 va croiser l'EMA50",
			slPts: "SL (points)",
			swLenA: "Force du pivot (bougies de chaque côté)",
			tp1Pts: "TP1 (points)",
			tp2Pts: "TP2 (points)",
			tp3Pts: "TP3 (points)",
			tzOffset: "Décalage UTC de l'horloge de séance (Bogota = -5)",
			useArm: "Exiger le retracement de 50 % + le contact de l'EMA30 dans la fenêtre",
			useAsia: "Inclure l'Asie (test uniquement)",
			useBE: "Seuil de rentabilité actif",
			useLadder: "Utiliser TP1/TP2/TP3 (sortie finale = TP3)",
			useR2: "R2 · exiger l'empilement M5 + M15 et le biais H1",
			useRSI: "Attendre le RSI après le signal",
			useSess: "Filtrer par séance",
			useTrend: "Conserver l'ordre des EMA pendant l'attente"
		},
		longSignal: "Signal long",
		noSignal: "aucun signal",
		retracementDot: "Point au retracement de 50 %",
		rewardZone: "Zone de gain",
		riskZone: "Zone de risque",
		session: "Séance",
		sessionClosed: "fermée",
		sessionOpen: "ouverte",
		shortSignal: "Signal short",
		signal: "Signal",
		signalActive: "{{side}} en cours",
		waitingRsi: "attente du RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Attente du RSI (long)",
		waitingRsiShort: "Attente du RSI (short)"
	},
	breakEven: "Seuil de rentabilité",
	bullish: "Haussier",
	buy: "Achat",
	colour: "Couleur",
	cypher: {
		above55: "Au-dessus de 55",
		aboveBelow: "Dessus/Dessous",
		barColors: "Couleurs des barres",
		bbLength: "Longueur BB",
		bbStdDev: "Écart-type BB {{n}}",
		bearBreak: "Cassure baissière",
		bearPattern: "Pin bar / avalement baissier",
		below55: "Sous 55",
		bullBreak: "Cassure haussière",
		bullPattern: "Pin bar / avalement haussier",
		cmoLength: "Longueur CMO",
		colorCandles: "Colorer les bougies",
		confluenceLong: "Confluence Long",
		confluenceShort: "Confluence Short",
		consolidating: "Consolidation",
		direction: "Direction",
		emaPeriodTrend: "Période EMA (tendance)",
		flagOffsetAtr: "Décalage du drapeau (x ATR)",
		flashBackground: "Arrière-plan du flash",
		flashCount: "Nombre de flashs",
		flashHz: "Vitesse du flash (clignements / s)",
		flashOn: "Flash sur nouveau signal",
		flashShowBanner: "Afficher la bannière NEW BUY / SELL",
		flashShowBg: "Faire clignoter l'arrière-plan du graphique",
		flashStrength: "Intensité du flash d'arrière-plan",
		flashTest: "Tester le flash maintenant (aperçu)",
		fvgKeep: "Fair Value Gaps conservés par côté",
		glowOpacity: "Opacité du halo (plus élevé = plus transparent)",
		glowSizeTicks: "Taille du halo (ticks)",
		groupFlash: "Alerte de nouveau signal",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "Niveaux KDE",
		groupKeyLevels: "Niveaux clés",
		groupLrEma: "Canal LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivots",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Bandes de retournement",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Composants",
		groupTrendTable: "Tableau de tendance",
		groupVidya: "VIDYA / Tendance",
		halfTrendAmplitude: "Amplitude HalfTrend",
		halfTrendChannelDeviation: "Déviation du canal HalfTrend",
		ichimokuBase: "Ligne de base Ichimoku",
		ichimokuConversion: "Ligne de conversion Ichimoku",
		kdeActivation: "Activer le seuil d'activation",
		kdeBins: "Nombre de classes",
		kdeThreshold: "Seuil %",
		labelPosition: "Position des étiquettes",
		lineWidth: "Épaisseur de ligne",
		lowerBb: "BB{{n}} inférieure",
		lowerInnerZone: "Zone intérieure inférieure",
		lowerReversalZone: "Zone de retournement inférieure",
		maCloudLong: "Nuage MA (long)",
		maCloudShort: "Nuage MA (court)",
		newBuy: "NOUVEL ACHAT",
		newSell: "NOUVELLE VENTE",
		numberOfLevels: "Nombre de niveaux",
		parabolicSar: "SAR parabolique",
		pivotAuto: "Auto",
		pivotDaily: "Quotidien",
		pivotMonthly: "Mensuel",
		pivotsTimeframe: "Unité de temps des pivots",
		pivotWeekly: "Hebdomadaire",
		positionBottomCenter: "En bas au centre",
		positionBottomLeft: "En bas à gauche",
		positionBottomRight: "En bas à droite",
		positionLeft: "Gauche",
		positionRight: "Droite",
		positionTopCenter: "En haut au centre",
		positionTopLeft: "En haut à gauche",
		positionTopRight: "En haut à droite",
		psarBear: "PSAR baissier",
		psarBull: "PSAR haussier",
		psarIncrement: "Incrément PSAR",
		psarMax: "Maximum PSAR",
		psarStart: "Départ PSAR",
		pullingBack: "Repli",
		pulseSmoothingBars: "Barres de lissage Pulse",
		reEntry: "Réentrée",
		rightOffsetBars: "Décalage à droite (barres)",
		showCamarillaPivots: "Afficher les pivots Camarilla",
		showConfluenceFlag: "Afficher le drapeau de confluence (B/S)",
		showFvg: "Fair Value Gaps (15m et plus)",
		showKde: "Niveaux de volume KDE",
		showKeyLevels: "Afficher les niveaux clés",
		showLabels: "Afficher les étiquettes",
		showLevelGlow: "Afficher le halo des niveaux",
		showMaCloud: "Afficher le nuage MA",
		showPrices: "Afficher les prix",
		showPsar: "Afficher le PSAR",
		showReversalBands: "Afficher les bandes de retournement",
		showSlTpLabels: "Afficher les étiquettes SL / TP",
		showSniperBreakArrows: "Afficher les flèches Sniper / de cassure",
		showTrendTable: "Afficher le tableau de tendance",
		showVidya233: "Afficher VIDYA 233",
		showVidya55: "Afficher VIDYA 55",
		showVidya987: "Afficher VIDYA 987 (aimant)",
		showVidyaLines: "Afficher les lignes VIDYA",
		sizeNormal: "Normale",
		sizeSmall: "Petite",
		sizeTiny: "Très petite",
		slBufferAtr: "SL : marge max. (x ATR)",
		slBufferPips: "SL : marge au-delà du swing (pips)",
		slMaxRiskAtr: "SL : risque max. (x ATR)",
		slSwingLookback: "SL : historique du swing (barres)",
		sniperDown: "Sniper bas",
		sniperUp: "Sniper haut",
		source: "Source",
		state: "État",
		strength: "Force",
		strong: "Forte",
		superTrend2AtrLength: "Longueur ATR SuperTrend 2",
		superTrend2Factor: "Facteur SuperTrend 2",
		superTrendAtrLength: "Longueur ATR SuperTrend",
		superTrendMultiplier: "Multiplicateur SuperTrend",
		tablePosition: "Position du tableau",
		tableSize: "Taille du tableau",
		tpRiskReward: "TP {{n}} risque/rendement",
		tradeManagement: "Gestion des trades (SL / TP)",
		trend: "Tendance",
		trending: "En tendance",
		upperBb: "BB{{n}} supérieure",
		upperInnerZone: "Zone intérieure supérieure",
		upperReversalZone: "Zone de retournement supérieure",
		veryStrong: "Très forte",
		veryWeak: "Très faible",
		vidya987Magnet: "VIDYA 987 (aimant)",
		volumeAvgLength: "Longueur moy. du volume (filtre de cassure)",
		weak: "Faible",
		zoneEdge: "{{name}} (bord de remplissage)"
	},
	entry: "Entrée",
	gainColor: "Couleur de gain",
	harsiCandle: "Bougie HARSI",
	harsiLength: "Longueur HARSI",
	heikinAshiRsiOscillator: "Oscillateur RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "Valeur clé 'Cela modifie la sensibilité'",
	labelsIndicator: "Indicateur d'étiquettes",
	london: "Londres",
	londonBackground: "Arrière-plan Londres",
	londonSession: "Session de Londres",
	long: "Long",
	lossColor: "Couleur de perte",
	median: "Médiane",
	neutral: "Neutre",
	newYork: "New York",
	newYorkBackground: "Arrière-plan New York",
	newYorkSession: "Session de New York",
	openSmoothing: "Lissage de l'ouverture",
	optimus: {
		activeTradeLevels: "Trade en cours · niveaux",
		bias: "Biais",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "MITIGÉ {{n}}/{{total}}",
		disclaimer: "Les niveaux sont tracés sur le graphique. Ceci n'est pas un conseil en investissement.",
		duplicateRemoved: "Un seul indicateur Optimus Prime est pris en charge par graphique — le doublon a été supprimé.",
		enter: "ENTRÉE · {{side}}",
		input: {
			atrLength: "Longueur ATR du KC",
			buffer: "Marge sur le swing (en prix)",
			emaLength: "Longueur EMA",
			kcLength: "Longueur KC",
			kcMult: "Multiplicateur KC",
			lrcLength: "Longueur LRC",
			minRisk: "Risque R minimal (en prix)",
			requireAlign: "Exiger l'alignement de l'EMA et du LRC",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Profondeur du swing (R)"
		},
		kcLower: "KC bas",
		kcMid: "KC milieu",
		kcUpper: "KC haut",
		keltnerFill: "Remplissage Keltner",
		noClosedTrades: "Aucun trade clôturé pour l'instant",
		reasonForming: "Configuration en formation — confirmation attendue",
		reasonLatched: "Trade verrouillé · niveaux tracés",
		reasonNoSetup: "Aucune configuration · EMA/LRC non alignés",
		recentSignals: "Signaux récents",
		riskReward: "RISQUE/GAIN",
		trendMtf: "Tendance · multi-unités de temps",
		wait: "ATTENTE",
		warmingUp: "INITIALISATION"
	},
	overbought: "Suracheté",
	overboughtMax: "Surachat Max",
	overboughtMin: "Surachat Min",
	oversold: "Survendu",
	oversoldMax: "Survente Max",
	oversoldMin: "Survente Min",
	rsiLength: "Longueur RSI",
	rsiLine: "Ligne RSI",
	rsiLineShadow: "Ombre de la ligne RSI",
	sell: "Vente",
	short: "Short",
	signalsFromHeikinAshiCandles: "Signaux des bougies Heikin Ashi",
	sl: "SL",
	smoothedMode: "Mode lissé",
	sydney: "Sydney",
	sydneyBackground: "Arrière-plan Sydney",
	sydneySession: "Session de Sydney",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokyo",
	tokyoBackground: "Arrière-plan Tokyo",
	tokyoSession: "Session de Tokyo",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "baissier",
			bullish: "haussier",
			confluence: "confluence",
			entry: "entrée",
			neckline: "ligne de cou",
			score: "score",
			state: "état",
			states: {
				completed: "terminé",
				invalidated: "invalidé",
				projected: "projeté",
				przActive: "PRZ active",
				stopped: "stop touché"
			},
			stop: "stop",
			target: "objectif"
		},
		classic: {
			doubleBottom: "Double creux",
			doubleTop: "Double sommet",
			headAndShoulders: "Épaule-Tête-Épaule",
			inverseHeadAndShoulders: "ETE inv.",
			tripleBottom: "Triple creux",
			tripleTop: "Triple sommet"
		},
		direction: {
			bearishOnly: "Baissier uniquement",
			both: "Les deux",
			bullishOnly: "Haussier uniquement"
		},
		group: {
			classics: "Figures classiques et S/R",
			filters: "Filtres et affichage",
			patterns: "Figures",
			pivotEngine: "Moteur de pivots",
			ratios: "Ratios et tolérance"
		},
		input: {
			atrLen: "Période de l'ATR",
			atrMult: "Retournement du zigzag (x ATR)",
			colBear: "Baissier",
			colBull: "Haussier",
			colPrz: "PRZ",
			colSR: "Niveaux clés",
			dirFilter: "Filtre de direction",
			enClassics: "Détecter les figures classiques",
			enDoubles: "Double sommet / creux",
			enHS: "Épaule-Tête-Épaule",
			enTriples: "Triple sommet / creux",
			fillTransp: "Transparence du remplissage des figures",
			formingLife: "Durée de vie de la zone en formation (bougies)",
			keepFailed: "Conserver les figures stoppées sur le graphique (✕, atténuées)",
			keepSuccessful: "Conserver les figures réussies sur le graphique (✓)",
			maxPatterns: "Nombre max. de figures sur le graphique",
			minScore: "Score de qualité minimal",
			pivotDepth: "Profondeur du tampon de pivots",
			showLetters: "Afficher les lettres des points X A B C D",
			showPlan: "Afficher les niveaux du plan de trade",
			showProjected: "Afficher les figures projetées (en formation)",
			showRatios: "Afficher les ratios sur les jambes",
			showSR: "Niveaux de support/résistance",
			showStats: "Afficher le tableau de statistiques",
			srMinTouch: "S/R : nombre minimal de touches de pivot",
			tolEdge: "Tolérance en bord de plage",
			tolPoint: "Tolérance des ratios de points",
			useScale2: "Analyser aussi l'échelle 2x (structures plus grandes)"
		},
		label: {
			confirmed: "confirmé",
			forming: "en formation",
			sl: "SL",
			target: "objectif",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Terminées",
			stops: "Stops",
			t1Wins: "T1 atteints",
			winRate: "Réussite %"
		},
		tooltip: {
			colPrz: "PRZ couleur ambre quelle que soit la direction de la figure (par défaut dans ProTrader).",
			fillTransp: "Plus la valeur est basse, plus le remplissage est visible. Une valeur entre 65 et 80 convient bien.",
			formingLife: "Une figure en formation dont le point C est plus ancien que cette valeur, sans être complétée ni invalidée, expire et est supprimée.",
			maxPatterns: "Les figures les plus anciennes sont supprimées en premier, ainsi l'historique récent (✓ / ✕) et les zones en formation récentes restent toujours visibles.",
			showProjected: "Trace la structure X-A-B avec un guide en tirets vers la PRZ projetée.",
			showRatios: "Diagonales de mesure en pointillés (X-B, A-C, B-D, X-D) avec le ratio de Fibonacci mesuré au milieu de chacune, l'annotation standard des graphiques harmoniques.",
			tolPoint: "S'applique aux ratios exacts comme Gartley B=0.618. Strict = 0.03, équilibré = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ TOUT CLÔTURER",
		duplicateRemoved: "Un seul indicateur Trade Finder est pris en charge par graphique — le doublon a été supprimé.",
		durationHm: "{{h}} h {{m}}",
		durationM: "{{m}} min",
		emaEntry1: "EMA Entrée 1",
		emaEntry2: "EMA Entrée 2 / Tendance",
		emaRangeFilter: "EMA Filtre de range",
		emaTrigger: "EMA Déclencheur",
		entry1: "Entrée 1",
		entry2: "Entrée 2",
		entry2Mark: "E2",
		entryZoneBear: "Zone d'entrée {{n}} (baissier)",
		entryZoneBull: "Zone d'entrée {{n}} (haussier)",
		frameFailed: "L’unité de temps {{frame}} n’a pas pu être chargée — une nouvelle tentative suivra.",
		framesUnavailable: "Pas de données d’unités · attente",
		ghostEntry: "Setup précédent",
		ghostStop: "Stop précédent",
		group: {
			bias: "Biais",
			display: "Affichage",
			emaSystem: "Système d’EMA",
			entries: "Entrées",
			filter: "Filtre",
			riskManagement: "Gestion du risque",
			session: "Session",
			supportResistance: "Support et résistance",
			trailingStop: "Stop suiveur",
			trendPanel: "Panneau de tendance"
		},
		input: {
			adxLen: "Longueur ADX",
			adxSmoothing: "Lissage ADX",
			asiaSession: "Session Asie / Tokyo (UTC)",
			atrBufferMultBtc: "Marge du stop derrière le swing — BTC (× ATR)",
			atrBufferMultGold: "Marge du stop derrière le swing — or (× ATR)",
			atrBufferMultOther: "Marge du stop derrière le swing — autres (× ATR)",
			atrLength: "Longueur de l’ATR (gestion du risque)",
			atrSlMult: "Stop loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Or : seuil de rentabilité après ce nombre de points",
			biasEmaLen: "Longueur de l'EMA du biais",
			crossLookback: "Fenêtre des croisements du biais (bougies)",
			dxySymbol: "Symbole de l'indice dollar (vide = désactivé)",
			emaBigLen: "Longueur EMA Filtre de range",
			emaFastLen: "Longueur EMA Entrée 1",
			emaMidLen: "Longueur EMA Entrée 2 / Tendance",
			emaTriggerLen: "Longueur EMA Déclencheur",
			feeBufferPct: "Marge de frais au-delà du seuil de rentabilité (%)",
			flatThreshPct: "Seuil de platitude (% de l'EMA du biais)",
			londonSession: "Session de Londres (UTC)",
			maxCrosses: "Croisements max avant d'écarter le biais",
			newYorkSession: "Session de New York (UTC)",
			showEmaLabels: "Afficher les étiquettes de nom des EMA",
			showEntrySignals: "Afficher les marqueurs de configuration",
			showEntryZone: "Afficher la zone d'entrée",
			showSRLines: "Afficher le support et la résistance",
			showTradeLevels: "Afficher les niveaux d’entrée, de stop et d’objectif",
			slMaxPointsBtc: "Distance maximale du stop — BTC (points)",
			slMaxPointsGold: "Distance maximale du stop — or (points)",
			slMaxPointsIndex: "Distance maximale du stop — indices (points)",
			slMaxPointsOther: "Distance maximale du stop — autres (points)",
			slMinPointsGold: "Distance minimale du stop — or (points)",
			slopeLookback: "Fenêtre de pente du biais (bougies)",
			srLeftBars: "Support / résistance · barres à gauche du pivot",
			srRightBars: "Support / résistance · barres à droite du pivot",
			swingPivotLen: "Longueur du pivot de swing (stop loss)",
			tp1ClosePct: "Clôture au TP1 %",
			tp2ClosePct: "Clôture au TP2 %",
			tp5CloseAlways: "Le TP5 clôture toujours, même avec un stop suiveur",
			tpR: "TP{{n}} (en R)",
			tpSlMode: "Mode stop et objectifs",
			trailAtrMult: "Distance du stop suiveur (× ATR)",
			trendPanelEmaLen: "Longueur de l'EMA de la ligne de tendance",
			trendSlopeLB: "Recul de la pente EMA Entrée 2 (bougies)",
			useAdxFilter: "Exiger un ADX au-dessus du seuil du mode",
			useBiasFilter: "Noter le biais supérieur (ne bloque jamais l'entrée)",
			useEmaStackCheck: "Exiger que les EMA soient dans l’ordre",
			useInstrumentAutoDetect: "Détecter l’instrument automatiquement",
			useSessionFilter: "Signaux uniquement pendant les sessions de marché",
			useSlopeDynamic: "Adapter le recul de la pente à l’unité de temps",
			useStrictCandle: "Filtre de bougie strict (mèche et clôture)",
			useTrailingStop: "Stop suiveur (à partir du TP1)",
			useVolumeConfirm: "Exiger un volume supérieur à la moyenne à l’entrée",
			volAvgLen: "Longueur de la moyenne de volume",
			volMultiplier: "Volume minimum (× moyenne)"
		},
		maxStop: "SL max.",
		minuteAgainst: "Croisement contraire",
		minuteOk: "Aucune alerte",
		minuteReversal: "Croisement · inversion possible",
		modeAtr: "ATR",
		modeAuto: "Automatique",
		modeRiskReward: "Risque / rendement",
		noBias: "Aucun biais",
		noSetup: "Aucun setup actif",
		recentTitle: "Setups récents",
		reEntry: "Réentrée",
		reEntryMark: "RE",
		rest: "RESTE",
		rowBias: "Biais",
		rowContext: "Contexte",
		rowInfo: "Info",
		rowSession: "Session",
		rowSetup: "Setup",
		rowVolume: "Volume",
		scoreLine: "S : {{setup}} / 5   E : {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "fin dans {{time}}",
		sessionOutside: "Hors séance · Londres {{time}} UTC",
		sessionOverlap: "Chevauchement",
		statsTitle: "{{n}} derniers setups",
		statusBreakEvenSet: "Au seuil",
		statusMoveToBreakEven: "Bouger le stop",
		statusPending: "Contact zone",
		statusRunning: "En cours",
		statusSpike: "Volatil · attente",
		statusWaiting: "En attente",
		stopHit: "Stop touché",
		styleDaytrade: "Day trading",
		styleScalping: "Scalping",
		styleSwing: "Swing",
		subFrameReversal: "L’unité inférieure se retourne",
		targetHit: "Objectif final atteint",
		trailStop: "Stop suiveur",
		volAboveAverage: "au-dessus de la moyenne",
		volBelowAverage: "sous la moyenne",
		zoneEdgeBear: "Bord de zone {{n}} (baissier)",
		zoneEdgeBull: "Bord de zone {{n}} (haussier)"
	},
	tradingSessions: "Sessions de trading",
	unintendedSymbol: "Cette stratégie est conçue pour {{symbols}} — ses niveaux risquent de n'avoir aucun sens sur {{symbol}}.",
	utBotAlerts: "Alertes UT Bot"
}, he = {
	asia: "Asia",
	atrPeriod: "Periode ATR",
	auraScanner: {
		guide: {
			bigDiamondMark: "Besar merah/hijau",
			bigDiamondMeaning: "Belah ketupat merah besar di atas puncak memperingatkan pembelian. Hijau besar di bawah lembah memperingatkan penjualan.",
			blueMark: "Kurva biru",
			blueMeaning: "50 EMA. Merah muda di atas biru berarti beli, di bawahnya berarti jual.",
			dashedMark: "Garis putus-putus",
			dashedMeaning: "Dukungan dan hambatan. Merah di bawah harga, hijau di atas.",
			diamondsMark: "Belah ketupat",
			diamondsMeaning: "Titik pembalikan. Emas paling lemah, lalu biru, merah, dan hijau.",
			flatGoldMark: "Emas mendatar",
			flatGoldMeaning: "Tingkat harga dengan volume terbesar selama enam jam terakhir pada grafik 15 menit.",
			levelsMark: "Garis tingkat harga",
			levelsMeaning: "Harga masuk, batas rugi, dan sasaran transaksi terakhir. Centang berarti tercapai.",
			pinkMark: "Kurva merah muda",
			pinkMeaning: "20 EMA. Persilangannya dengan garis biru menghasilkan sinyal.",
			subtitle: "Cara membaca grafik ini",
			thickGoldMark: "Emas tebal",
			thickGoldMeaning: "Garis 238. Jika berada di antara harga masuk dan sasaran, lewati.",
			title: "AURA",
			triangleMark: "Segitiga",
			triangleMeaning: "Transaksi yang lolos semua pemeriksaan. Arahkan penunjuk untuk melihat angkanya."
		},
		groups: {
			display: "Tampilan",
			eightChecks: "Delapan pemeriksaan",
			riskAndTargets: "Risiko dan sasaran",
			signalEngine: "Mesin sinyal"
		},
		inputs: {
			emaFastLen: "Garis cepat (merah muda)",
			emaSlowLen: "Garis lambat (biru)",
			f1Clock: "1. Hanya dalam rentang waktu bervolume baik",
			f2Trend: "2. Sejalan dengan tren 15 menit",
			f3Mode: "3. Lilin berwarna tidak sesuai",
			f4Min: "Pelebaran minimum (pip per lilin)",
			f4Sep: "4. Garis saling menjauh",
			f5Clear: "5. 238 tidak di antara harga masuk dan sasaran",
			f6R: "Ruang minimum (× risiko)",
			f6Reward: "6. Ruang ke tingkat harga berikutnya",
			f7Bars: "Selama beberapa lilin terakhir",
			f7Consol: "7. Tidak terjebak dalam rentang",
			f7Pips: "Rentang harus lebih dari (pip)",
			f9Bars: "Dalam N lilin terakhir",
			f9Star: "8. Tanpa belah ketupat peringatan besar",
			guidePos: "Posisi panel panduan",
			longMode: "Mode garis pengaman (238)",
			panelSize: "Ukuran teks panel",
			pipIn: "Ukuran pip (0 = otomatis)",
			showClock: "Panel kondisi terkini",
			showGuide: "Panel panduan arti penanda",
			showLadder: "Tingkat transaksi di kanan",
			showPoc: "Garis volume",
			showSr: "Tingkat harga putus-putus",
			showStars: "Belah ketupat peringatan",
			showTable: "Tabel tren",
			showTint: "Warna latar",
			showWhy: "Jelaskan sinyal yang dilewati",
			slMinPips: "Jarak minimum melewati garis lambat (pip)",
			srAtrMove: "Tingkat harga: pantulan yang diperlukan (× ukuran lilin biasa)",
			srLookback: "Tingkat harga: jangkauan riwayat titik balik",
			srMax: "Jumlah maksimum tingkat harga di layar",
			srRange: "Abaikan tingkat yang lebih jauh dari (× ukuran lilin biasa)",
			srReset: "Tingkat harga: pengujian ulang sebelum dihapus",
			stripLen: "Lebar kolom kanan (lilin)",
			tablePos: "Posisi panel kondisi terkini",
			theme: "Tema grafik",
			tp1R: "TP1 (kelipatan R)",
			tp2R: "TP2 (kelipatan R)",
			trendPos: "Posisi tabel tren",
			tz: "Zona waktu jendela perdagangan"
		},
		ladder: {
			closedAtStop: "DITUTUP pada batas rugi",
			closedAtTarget: "DITUTUP TP{{hit}}",
			entry: "MASUK",
			stop: "BATAS RUGI",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Skala otomatis",
			bottomCentre: "Bawah tengah",
			bottomLeft: "Bawah kiri",
			bottomRight: "Bawah kanan",
			dark: "Gelap",
			ignore: "Abaikan",
			large: "Besar",
			light: "Terang",
			literal238: "Nilai tetap 238",
			middleCentre: "Tengah",
			middleLeft: "Tengah kiri",
			middleRight: "Tengah kanan",
			normal: "Sedang",
			reject: "Tolak",
			small: "Kecil",
			topCentre: "Atas tengah",
			topLeft: "Atas kiri",
			topRight: "Atas kanan",
			waitForPullback: "Tunggu penarikan balik"
		},
		reasons: {
			clock: "di luar jendela waktu perdagangan",
			diamond: "belah ketupat peringatan besar baru muncul",
			range: "grafik terjebak dalam konsolidasi",
			room: "tingkat harga terlalu dekat, tidak ada ruang menuju sasaran",
			safetyLine: "garis 238 berada di antara harga masuk dan sasaran",
			separation: "kedua garis terlalu dekat, belum ada ruang untuk bergerak",
			trend: "melawan tren 15 menit",
			wrongColour: "lilin persilangan ditutup dengan warna yang tidak sesuai"
		},
		rightNow: {
			aBuy: "Pembelian",
			aSell: "Penjualan",
			bestBuysOnly: "cari pembelian saja",
			bestNow: "Pilihan terbaik kini",
			bestSellsOnly: "cari penjualan saja",
			bestWaitThin: "tunggu, volume tipis",
			goodVolume: "Volume baik",
			lowVolume: "Volume rendah",
			safetyAbove: "238 di atas harga, ada ruang untuk penjualan",
			safetyBelow: "238 di bawah harga, ada ruang untuk pembelian",
			safetyLine: "Garis pengaman",
			skipped: "Dilewati",
			skippedAgo_other: "{{side}} {{bars}} lilin lalu: {{reason}}",
			skippedNothing: "belum ada yang dilewati",
			title: "SAAT INI",
			trend: "Tren",
			trendSummaryDown: "15m turun, {{agree}} dari 6 kerangka waktu naik",
			trendSummaryUp: "15m naik, {{agree}} dari 6 kerangka waktu naik"
		},
		signal: {
			buy: "BELI",
			pips: "pip",
			sell: "JUAL",
			stop: "Batas rugi"
		},
		tooltip: {
			f3Mode: "Pembelian pada lilin merah atau penjualan pada lilin biru tidak pernah langsung diambil. Tunggu penarikan balik menunggu harga kembali ke garis pada lilin dengan warna yang sesuai. Tolak membuang sinyal tersebut.",
			f4Min: "Seberapa cepat kedua garis menjauh pada lilin sinyal. Garis datar yang saling membelit tidak menyediakan ruang untuk bergerak.",
			f6Reward: "Tingkat putus-putus berikutnya setidaknya harus sejauh ini. Secara bawaan nonaktif: pemindai menggambar tingkat dengan metodenya sendiri, jadi periksa juga ruangnya secara visual.",
			f7Pips: "Hindari konsolidasi sebesar 100 pip atau kurang.",
			longMode: "238 adalah pengaturan standar untuk grafik satu menit. Skala otomatis menyesuaikan garis pengaman untuk kerangka waktu lain, sekitar 83 pada grafik tiga menit.",
			pipIn: "Otomatis: 0.10 untuk emas dan sepuluh tik untuk instrumen lain (1 poin pada US30).",
			showGuide: "Legenda singkat pada grafik. Matikan setelah Anda mengenali penandanya.",
			showLadder: "Harga masuk, batas rugi, dan sasaran transaksi terakhir digambar di kanan lilin terakhir. Sasaran diberi centang ketika tercapai.",
			showWhy: "Ketika garis bersilangan tetapi pemeriksaan menghalangi transaksi, panel kondisi terkini menjelaskan pemeriksaan dan alasannya.",
			slMinPips: "Batas rugi ditempatkan di seberang garis merah dan biru, dengan jarak setidaknya 10 pip dari garis biru.",
			srMax: "Hanya tingkat terdekat dengan harga yang dipertahankan agar grafik tetap terbaca.",
			theme: "Sesuaikan dengan tema TradingView agar semua warna terlihat jelas.",
			tz: "Jendela perdagangan menggunakan zona waktu ini. America/Denver memakai waktu Pegunungan Amerika Utara dengan waktu musim panas. Gunakan America/Phoenix untuk waktu Pegunungan tanpa perubahan musim panas."
		},
		trendTable: {
			above: "di atas",
			below: "di bawah",
			down: "Turun",
			notAvailable: "tidak tersedia",
			up: "Naik",
			volumeLine: "Garis volume"
		}
	},
	bearish: "Bearish",
	bfs: {
		duplicateRemoved: "Hanya satu indikator BFS — Blessed Flow System per grafik yang didukung; duplikatnya dihapus.",
		emaCrossSoon: "EMA30/50 akan berpotongan",
		engineOff: "pindah ke M1",
		engineOn: "mesin M1",
		input: {
			armWin: "Jendela (candle M1) untuk menyentuh EMA30",
			asiaSess: "Asia (HHMM-HHMM)",
			bePts: "BE: pada +poin, stop dipindah TEPAT ke level itu",
			cooldown: "Jeda (candle M1) setelah posisi ditutup",
			lenFast: "EMA cepat (arah)",
			lenH1a: "H1 · EMA pendek",
			lenH1b: "H1 · EMA panjang",
			lenMid: "EMA menengah",
			lenSlow: "EMA lambat",
			londonSess: "London (HHMM-HHMM, jam sesi)",
			maxPerBlock: "Maks. entry per blok sesi (0 = tanpa batas)",
			nearLb: "Candle untuk mengukur konvergensi",
			nearPts: "Jarak maksimum EMA30-EMA50 (poin)",
			nySess: "New York (HHMM-HHMM)",
			onlyM1: "Jalankan mesin hanya di M1",
			pv: "Nilai harga dari 1 poin",
			r1lb: "R1 · candle M1 ke belakang (harga tidak terlalu jauh)",
			rr: "Rasio TP R:R (saat tangga TP nonaktif)",
			rsiHi: "RSI >= untuk SHORT",
			rsiLen: "Panjang RSI",
			rsiLo: "RSI <= untuk LONG",
			rsiWin: "Jendela tunggu (candle setelah sinyal)",
			showLevels: "Gambar level posisi",
			showNear: "Tandai saat EMA30 akan memotong EMA50",
			slPts: "SL (poin)",
			swLenA: "Kekuatan pivot (candle di setiap sisi)",
			tp1Pts: "TP1 (poin)",
			tp2Pts: "TP2 (poin)",
			tp3Pts: "TP3 (poin)",
			tzOffset: "Selisih UTC jam sesi (Bogota = -5)",
			useArm: "Wajib retracement 50% dan sentuhan EMA30 dalam jendela",
			useAsia: "Sertakan Asia (hanya untuk uji)",
			useBE: "Titik impas aktif",
			useLadder: "Gunakan TP1/TP2/TP3 (keluar terakhir = TP3)",
			useR2: "R2 · wajib susunan M5 + M15 dan bias H1",
			useRSI: "Tunggu RSI setelah sinyal",
			useSess: "Filter berdasarkan sesi",
			useTrend: "Pertahankan urutan EMA selama menunggu"
		},
		longSignal: "Sinyal long",
		noSignal: "tidak ada sinyal",
		retracementDot: "Titik retracement 50%",
		rewardZone: "Zona imbalan",
		riskZone: "Zona risiko",
		session: "Sesi",
		sessionClosed: "tutup",
		sessionOpen: "buka",
		shortSignal: "Sinyal short",
		signal: "Sinyal",
		signalActive: "{{side}} berjalan",
		waitingRsi: "menunggu RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Menunggu RSI (long)",
		waitingRsiShort: "Menunggu RSI (short)"
	},
	breakEven: "Titik impas",
	bullish: "Bullish",
	buy: "Beli",
	colour: "Warna",
	cypher: {
		above55: "Di Atas 55",
		aboveBelow: "Atas/Bawah",
		barColors: "Warna Bar",
		bbLength: "Panjang BB",
		bbStdDev: "Deviasi Standar BB {{n}}",
		bearBreak: "Penembusan Bearish",
		bearPattern: "Pin Bar / Engulfing Bearish",
		below55: "Di Bawah 55",
		bullBreak: "Penembusan Bullish",
		bullPattern: "Pin Bar / Engulfing Bullish",
		cmoLength: "Panjang CMO",
		colorCandles: "Warnai Candle",
		confluenceLong: "Konfluensi Long",
		confluenceShort: "Konfluensi Short",
		consolidating: "Konsolidasi",
		direction: "Arah",
		emaPeriodTrend: "Periode EMA (tren)",
		flagOffsetAtr: "Jarak bendera (x ATR)",
		flashBackground: "Latar Kilatan",
		flashCount: "Jumlah kilatan",
		flashHz: "Kecepatan kilatan (kedip / detik)",
		flashOn: "Kilatan saat sinyal baru",
		flashShowBanner: "Tampilkan banner NEW BUY / SELL",
		flashShowBg: "Kilatkan latar grafik",
		flashStrength: "Kekuatan kilatan latar",
		flashTest: "Uji kilatan sekarang (pratinjau)",
		fvgKeep: "Fair Value Gap per sisi",
		glowOpacity: "Opasitas Glow (lebih tinggi = lebih transparan)",
		glowSizeTicks: "Ukuran Glow (tick)",
		groupFlash: "Peringatan Sinyal Baru",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "Level KDE",
		groupKeyLevels: "Level Kunci",
		groupLrEma: "Kanal LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivot",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Pita Pembalikan",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Komponen",
		groupTrendTable: "Tabel Tren",
		groupVidya: "VIDYA / Tren",
		halfTrendAmplitude: "Amplitudo HalfTrend",
		halfTrendChannelDeviation: "Deviasi Kanal HalfTrend",
		ichimokuBase: "Garis Dasar Ichimoku",
		ichimokuConversion: "Garis Konversi Ichimoku",
		kdeActivation: "Aktifkan Ambang Aktivasi",
		kdeBins: "Jumlah Bin",
		kdeThreshold: "Ambang %",
		labelPosition: "Posisi Label",
		lineWidth: "Ketebalan Garis",
		lowerBb: "BB{{n}} Bawah",
		lowerInnerZone: "Zona Dalam Bawah",
		lowerReversalZone: "Zona Pembalikan Bawah",
		maCloudLong: "Awan MA (Panjang)",
		maCloudShort: "Awan MA (Pendek)",
		newBuy: "BELI BARU",
		newSell: "JUAL BARU",
		numberOfLevels: "Jumlah Level",
		parabolicSar: "Parabolic SAR",
		pivotAuto: "Otomatis",
		pivotDaily: "Harian",
		pivotMonthly: "Bulanan",
		pivotsTimeframe: "Kerangka Waktu Pivot",
		pivotWeekly: "Mingguan",
		positionBottomCenter: "Bawah Tengah",
		positionBottomLeft: "Bawah Kiri",
		positionBottomRight: "Bawah Kanan",
		positionLeft: "Kiri",
		positionRight: "Kanan",
		positionTopCenter: "Atas Tengah",
		positionTopLeft: "Atas Kiri",
		positionTopRight: "Atas Kanan",
		psarBear: "PSAR Bearish",
		psarBull: "PSAR Bullish",
		psarIncrement: "Inkremen PSAR",
		psarMax: "Maksimum PSAR",
		psarStart: "Awal PSAR",
		pullingBack: "Koreksi",
		pulseSmoothingBars: "Bar Penghalusan Pulse",
		reEntry: "Masuk Ulang",
		rightOffsetBars: "Jarak Kanan (bar)",
		showCamarillaPivots: "Tampilkan Pivot Camarilla",
		showConfluenceFlag: "Tampilkan Bendera Konfluensi (B/S)",
		showFvg: "Fair Value Gap (15m ke atas)",
		showKde: "Level Volume KDE",
		showKeyLevels: "Tampilkan Level Kunci",
		showLabels: "Tampilkan Label",
		showLevelGlow: "Tampilkan Glow Level",
		showMaCloud: "Tampilkan Awan MA",
		showPrices: "Tampilkan Harga",
		showPsar: "Tampilkan PSAR",
		showReversalBands: "Tampilkan Pita Pembalikan",
		showSlTpLabels: "Tampilkan Label SL / TP",
		showSniperBreakArrows: "Tampilkan Panah Sniper / Penembusan",
		showTrendTable: "Tampilkan Tabel Tren",
		showVidya233: "Tampilkan VIDYA 233",
		showVidya55: "Tampilkan VIDYA 55",
		showVidya987: "Tampilkan VIDYA 987 (Magnet)",
		showVidyaLines: "Tampilkan Garis VIDYA",
		sizeNormal: "Normal",
		sizeSmall: "Kecil",
		sizeTiny: "Sangat Kecil",
		slBufferAtr: "SL batas buffer (x ATR)",
		slBufferPips: "SL buffer di luar swing (pip)",
		slMaxRiskAtr: "SL risiko maks. (x ATR)",
		slSwingLookback: "SL lookback swing (bar)",
		sniperDown: "Sniper Turun",
		sniperUp: "Sniper Naik",
		source: "Sumber",
		state: "Status",
		strength: "Kekuatan",
		strong: "Kuat",
		superTrend2AtrLength: "Panjang ATR SuperTrend 2",
		superTrend2Factor: "Faktor SuperTrend 2",
		superTrendAtrLength: "Panjang ATR SuperTrend",
		superTrendMultiplier: "Pengali SuperTrend",
		tablePosition: "Posisi Tabel",
		tableSize: "Ukuran Tabel",
		tpRiskReward: "TP {{n}} Risiko/Imbalan",
		tradeManagement: "Manajemen Trade (SL / TP)",
		trend: "Tren",
		trending: "Sedang Tren",
		upperBb: "BB{{n}} Atas",
		upperInnerZone: "Zona Dalam Atas",
		upperReversalZone: "Zona Pembalikan Atas",
		veryStrong: "Sangat Kuat",
		veryWeak: "Sangat Lemah",
		vidya987Magnet: "VIDYA 987 (Magnet)",
		volumeAvgLength: "Panjang Rata-rata Volume (filter penembusan)",
		weak: "Lemah",
		zoneEdge: "{{name}} (tepi isian)"
	},
	entry: "Entry",
	gainColor: "Warna Untung",
	harsiCandle: "Candle HARSI",
	harsiLength: "Panjang HARSI",
	heikinAshiRsiOscillator: "Osilator RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "Nilai kunci 'Ini mengubah sensitivitas'",
	labelsIndicator: "Indikator Label",
	london: "London",
	londonBackground: "Latar London",
	londonSession: "Sesi London",
	long: "Long",
	lossColor: "Warna Rugi",
	median: "Median",
	neutral: "Netral",
	newYork: "New York",
	newYorkBackground: "Latar New York",
	newYorkSession: "Sesi New York",
	openSmoothing: "Pelembutan Open",
	optimus: {
		activeTradeLevels: "Posisi aktif · level",
		bias: "Bias",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "CAMPURAN {{n}}/{{total}}",
		disclaimer: "Level digambar pada grafik. Bukan nasihat keuangan.",
		duplicateRemoved: "Hanya satu indikator Optimus Prime per grafik yang didukung; duplikatnya dihapus.",
		enter: "MASUK · {{side}}",
		input: {
			atrLength: "Panjang ATR untuk KC",
			buffer: "Margin swing (dalam harga)",
			emaLength: "Panjang EMA",
			kcLength: "Panjang KC",
			kcMult: "Pengali KC",
			lrcLength: "Panjang LRC",
			minRisk: "Risiko R minimum (dalam harga)",
			requireAlign: "Wajib EMA dan LRC sejajar",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Candle ke belakang untuk swing (R)"
		},
		kcLower: "KC bawah",
		kcMid: "KC tengah",
		kcUpper: "KC atas",
		keltnerFill: "Isian Keltner",
		noClosedTrades: "Belum ada posisi yang ditutup",
		reasonForming: "Setup sedang terbentuk — menunggu konfirmasi",
		reasonLatched: "Posisi terkunci · level ada di grafik",
		reasonNoSetup: "Tidak ada setup · EMA/LRC tidak sejajar",
		recentSignals: "Sinyal terbaru",
		riskReward: "RISIKO/IMBALAN",
		trendMtf: "Tren · beberapa time frame",
		wait: "TUNGGU",
		warmingUp: "MENYIAPKAN"
	},
	overbought: "Jenuh Beli",
	overboughtMax: "Jenuh Beli Maks",
	overboughtMin: "Jenuh Beli Min",
	oversold: "Jenuh Jual",
	oversoldMax: "Jenuh Jual Maks",
	oversoldMin: "Jenuh Jual Min",
	rsiLength: "Panjang RSI",
	rsiLine: "Garis RSI",
	rsiLineShadow: "Bayangan Garis RSI",
	sell: "Jual",
	short: "Short",
	signalsFromHeikinAshiCandles: "Sinyal dari Candlestick Heikin Ashi",
	sl: "SL",
	smoothedMode: "Mode Halus",
	sydney: "Sydney",
	sydneyBackground: "Latar Sydney",
	sydneySession: "Sesi Sydney",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokyo",
	tokyoBackground: "Latar Tokyo",
	tokyoSession: "Sesi Tokyo",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "bearish",
			bullish: "bullish",
			confluence: "konfluensi",
			entry: "entry",
			neckline: "neckline",
			score: "skor",
			state: "status",
			states: {
				completed: "selesai",
				invalidated: "tidak valid",
				projected: "proyeksi",
				przActive: "PRZ aktif",
				stopped: "kena stop"
			},
			stop: "stop",
			target: "target"
		},
		classic: {
			doubleBottom: "Double Bottom",
			doubleTop: "Double Top",
			headAndShoulders: "Head & Shoulders",
			inverseHeadAndShoulders: "H&S Terbalik",
			tripleBottom: "Triple Bottom",
			tripleTop: "Triple Top"
		},
		direction: {
			bearishOnly: "Hanya bearish",
			both: "Keduanya",
			bullishOnly: "Hanya bullish"
		},
		group: {
			classics: "Pola klasik & S/R",
			filters: "Filter & tampilan",
			patterns: "Pola",
			pivotEngine: "Mesin pivot",
			ratios: "Rasio & toleransi"
		},
		input: {
			atrLen: "Periode ATR",
			atrMult: "Pembalikan zigzag (x ATR)",
			colBear: "Bearish",
			colBull: "Bullish",
			colPrz: "PRZ",
			colSR: "Level kunci",
			dirFilter: "Filter arah",
			enClassics: "Deteksi pola klasik",
			enDoubles: "Double Top / Bottom",
			enHS: "Head & Shoulders",
			enTriples: "Triple Top / Bottom",
			fillTransp: "Transparansi isian pola",
			formingLife: "Masa hidup zona pembentukan (bar)",
			keepFailed: "Pertahankan pola yang kena stop di grafik (✕, diredupkan)",
			keepSuccessful: "Pertahankan pola yang berhasil di grafik (✓)",
			maxPatterns: "Maks. pola di grafik",
			minScore: "Skor kualitas minimum",
			pivotDepth: "Kedalaman buffer pivot",
			showLetters: "Tampilkan huruf titik X A B C D",
			showPlan: "Tampilkan level rencana trading",
			showProjected: "Tampilkan pola proyeksi (sedang terbentuk)",
			showRatios: "Tampilkan angka rasio pada kaki pola",
			showSR: "Level support/resistance",
			showStats: "Tampilkan tabel statistik",
			srMinTouch: "S/R: minimum sentuhan pivot",
			tolEdge: "Toleransi tepi rentang",
			tolPoint: "Toleransi rasio titik",
			useScale2: "Pindai juga skala 2x (struktur lebih besar)"
		},
		label: {
			confirmed: "terkonfirmasi",
			forming: "sedang terbentuk",
			sl: "SL",
			target: "target",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Selesai",
			stops: "Stop",
			t1Wins: "T1 tercapai",
			winRate: "% Menang"
		},
		tooltip: {
			colPrz: "PRZ berwarna amber terlepas dari arah pola (bawaan ProTrader).",
			fillTransp: "Lebih rendah = isian lebih terlihat. Sekitar 65-80 sudah bagus.",
			formingLife: "Pola yang sedang terbentuk dengan titik C lebih lama dari nilai ini, tanpa selesai atau batal, akan kedaluwarsa dan dihapus.",
			maxPatterns: "Pola tertua dihapus lebih dulu, sehingga riwayat terbaru (✓ / ✕) dan zona pembentukan yang baru selalu tetap terlihat.",
			showProjected: "Menggambar struktur X-A-B dengan garis panduan putus-putus ke PRZ proyeksi.",
			showRatios: "Diagonal pengukuran bertitik (X-B, A-C, B-D, X-D) dengan rasio Fibonacci terukur di titik tengah masing-masing, anotasi standar pada grafik harmonik.",
			tolPoint: "Diterapkan pada rasio pasti seperti Gartley B=0.618. Ketat = 0.03, seimbang = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ TUTUP SEMUA",
		duplicateRemoved: "Hanya satu indikator Trade Finder per grafik yang didukung; duplikatnya dihapus.",
		durationHm: "{{h}} j {{m}} mnt",
		durationM: "{{m}} mnt",
		emaEntry1: "EMA Entry 1",
		emaEntry2: "EMA Entry 2 / Tren",
		emaRangeFilter: "EMA Filter Rentang",
		emaTrigger: "EMA Pemicu",
		entry1: "Entry 1",
		entry2: "Entry 2",
		entry2Mark: "E2",
		entryZoneBear: "Zona entry {{n}} (bearish)",
		entryZoneBull: "Zona entry {{n}} (bullish)",
		frameFailed: "Timeframe {{frame}} tidak dapat dimuat; akan dicoba lagi.",
		framesUnavailable: "Tidak ada data timeframe · tunggu",
		ghostEntry: "Setup sebelumnya",
		ghostStop: "Stop sebelumnya",
		group: {
			bias: "Bias",
			display: "Tampilan",
			emaSystem: "Sistem EMA",
			entries: "Entry",
			filter: "Filter",
			riskManagement: "Manajemen risiko",
			session: "Sesi",
			supportResistance: "Support dan resistance",
			trailingStop: "Trailing stop",
			trendPanel: "Panel tren"
		},
		input: {
			adxLen: "Panjang ADX",
			adxSmoothing: "Penghalusan ADX",
			asiaSession: "Sesi Asia / Tokyo (UTC)",
			atrBufferMultBtc: "Jarak aman stop di balik swing — BTC (× ATR)",
			atrBufferMultGold: "Jarak aman stop di balik swing — emas (× ATR)",
			atrBufferMultOther: "Jarak aman stop di balik swing — lainnya (× ATR)",
			atrLength: "Panjang ATR (manajemen risiko)",
			atrSlMult: "Stop loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Emas: titik impas setelah sekian poin",
			biasEmaLen: "Panjang EMA bias",
			crossLookback: "Jendela persilangan bias (bar)",
			dxySymbol: "Simbol indeks dolar (kosong = nonaktif)",
			emaBigLen: "Panjang EMA Filter Rentang",
			emaFastLen: "Panjang EMA Entry 1",
			emaMidLen: "Panjang EMA Entry 2 / Tren",
			emaTriggerLen: "Panjang EMA Pemicu",
			feeBufferPct: "Cadangan biaya di luar titik impas (%)",
			flatThreshPct: "Ambang datar (% dari EMA bias)",
			londonSession: "Sesi London (UTC)",
			maxCrosses: "Maks persilangan sebelum bias diabaikan",
			newYorkSession: "Sesi New York (UTC)",
			showEmaLabels: "Tampilkan label nama EMA",
			showEntrySignals: "Tampilkan penanda setup",
			showEntryZone: "Tampilkan zona entry",
			showSRLines: "Tampilkan support dan resistance",
			showTradeLevels: "Tampilkan level masuk, stop, dan target",
			slMaxPointsBtc: "Jarak stop maksimum — BTC (poin)",
			slMaxPointsGold: "Jarak stop maksimum — emas (poin)",
			slMaxPointsIndex: "Jarak stop maksimum — indeks (poin)",
			slMaxPointsOther: "Jarak stop maksimum — lainnya (poin)",
			slMinPointsGold: "Jarak stop minimum — emas (poin)",
			slopeLookback: "Jendela kemiringan bias (bar)",
			srLeftBars: "Support / resistance · bar di kiri pivot",
			srRightBars: "Support / resistance · bar di kanan pivot",
			swingPivotLen: "Panjang pivot swing (stop loss)",
			tp1ClosePct: "Tutup di TP1 %",
			tp2ClosePct: "Tutup di TP2 %",
			tp5CloseAlways: "TP5 selalu menutup, bahkan saat trailing",
			tpR: "TP{{n}} (dalam R)",
			tpSlMode: "Mode stop dan target",
			trailAtrMult: "Jarak trailing stop (× ATR)",
			trendPanelEmaLen: "Panjang EMA baris tren",
			trendSlopeLB: "Lookback kemiringan EMA Entry 2 (bar)",
			useAdxFilter: "Wajibkan ADX di atas ambang mode",
			useBiasFilter: "Nilai bias timeframe atas (tidak pernah memblokir entry)",
			useEmaStackCheck: "Wajibkan urutan EMA yang benar",
			useInstrumentAutoDetect: "Deteksi instrumen secara otomatis",
			useSessionFilter: "Hanya beri sinyal selama sesi perdagangan",
			useSlopeDynamic: "Sesuaikan lookback kemiringan dengan kerangka waktu",
			useStrictCandle: "Filter candle ketat (sumbu dan penutupan)",
			useTrailingStop: "Trailing stop (mulai TP1)",
			useVolumeConfirm: "Wajibkan volume di atas rata-rata saat masuk",
			volAvgLen: "Panjang rata-rata volume",
			volMultiplier: "Volume minimum (× rata-rata)"
		},
		maxStop: "SL maks.",
		minuteAgainst: "Persilangan melawan setup",
		minuteOk: "Tidak ada peringatan",
		minuteReversal: "Persilangan · mungkin berbalik",
		modeAtr: "ATR",
		modeAuto: "Otomatis",
		modeRiskReward: "Risiko / imbal hasil",
		noBias: "Tanpa bias",
		noSetup: "Tidak ada setup aktif",
		recentTitle: "Setup terbaru",
		reEntry: "Masuk ulang",
		reEntryMark: "RE",
		rest: "SISA",
		rowBias: "Bias",
		rowContext: "Konteks",
		rowInfo: "Info",
		rowSession: "Sesi",
		rowSetup: "Setup",
		rowVolume: "Volume",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "sisa {{time}}",
		sessionOutside: "Di luar jam · London {{time}} UTC",
		sessionOverlap: "Tumpang tindih",
		statsTitle: "{{n}} setup terakhir",
		statusBreakEvenSet: "Impas",
		statusMoveToBreakEven: "Geser stop",
		statusPending: "Sentuh zona",
		statusRunning: "Berjalan",
		statusSpike: "Volatil · tunggu",
		statusWaiting: "Menunggu",
		stopHit: "Stop tersentuh",
		styleDaytrade: "Day trading",
		styleScalping: "Scalping",
		styleSwing: "Swing",
		subFrameReversal: "Kerangka waktu bawah berbalik",
		targetHit: "Target akhir tercapai",
		trailStop: "Trailing stop",
		volAboveAverage: "di atas rata-rata",
		volBelowAverage: "di bawah rata-rata",
		zoneEdgeBear: "Tepi zona {{n}} (bearish)",
		zoneEdgeBull: "Tepi zona {{n}} (bullish)"
	},
	tradingSessions: "Sesi Perdagangan",
	unintendedSymbol: "Strategi ini dirancang untuk {{symbols}}; pada {{symbol}} levelnya bisa jadi tidak berarti apa-apa.",
	utBotAlerts: "Peringatan UT Bot"
}, ge = {
	asia: "アジア",
	atrPeriod: "ATR期間",
	auraScanner: {
		guide: {
			bigDiamondMark: "大きな赤／緑",
			bigDiamondMeaning: "高値の上の大きな赤いひし形は買いへの警告です。安値の下の大きな緑は売りへの警告です。",
			blueMark: "青い曲線",
			blueMeaning: "50 EMA。ピンクが青より上なら買い、下なら売りです。",
			dashedMark: "破線",
			dashedMeaning: "支持線と抵抗線。赤は価格の下、緑は上です。",
			diamondsMark: "ひし形",
			diamondsMeaning: "転換点。金色が最も弱く、次に青、赤、緑です。",
			flatGoldMark: "水平な金色の線",
			flatGoldMeaning: "15分足で見た過去6時間の最大出来高の価格帯です。",
			levelsMark: "水準線",
			levelsMeaning: "直近取引のエントリー、損切り、目標。チェックは到達済みです。",
			pinkMark: "ピンクの曲線",
			pinkMeaning: "20 EMA。青い線との交差がシグナルです。",
			subtitle: "このチャートの見方",
			thickGoldMark: "太い金色の線",
			thickGoldMeaning: "238の線。エントリーと目標の間にある場合は見送ります。",
			title: "AURA",
			triangleMark: "三角形",
			triangleMeaning: "すべての条件を満たした取引。カーソルを合わせると数値を確認できます。"
		},
		groups: {
			display: "表示",
			eightChecks: "8つの確認条件",
			riskAndTargets: "リスクと目標",
			signalEngine: "シグナル判定"
		},
		inputs: {
			emaFastLen: "短期線（ピンク）",
			emaSlowLen: "長期線（青）",
			f1Clock: "1. 出来高が十分な時間帯のみ",
			f2Trend: "2. 15分足のトレンドと一致",
			f3Mode: "3. ローソク足の色が逆の場合",
			f4Min: "最小拡大量（1本あたりのピップス）",
			f4Sep: "4. 2本の線が離れている",
			f5Clear: "5. 238がエントリーと目標の間にない",
			f6R: "最小余地（リスクの倍数）",
			f6Reward: "6. 次の水準までの余地",
			f7Bars: "直近の確認本数",
			f7Consol: "7. レンジ内で停滞していない",
			f7Pips: "必要なレンジ幅の下限（ピップス）",
			f9Bars: "直近N本以内",
			f9Star: "8. 大きな警告ひし形がない",
			guidePos: "ガイドパネルの位置",
			longMode: "安全線（238）のモード",
			panelSize: "パネルの文字サイズ",
			pipIn: "ピップサイズ（0 = 自動）",
			showClock: "現在の状況パネル",
			showGuide: "記号の意味を示すガイド",
			showLadder: "右側に取引水準を表示",
			showPoc: "出来高線",
			showSr: "破線の水準",
			showStars: "警告ひし形",
			showTable: "トレンド表",
			showTint: "背景色",
			showWhy: "見送ったシグナルの理由を表示",
			slMinPips: "長期線の外側の最小間隔（ピップス）",
			srAtrMove: "水準：必要な反発幅（通常の足の大きさの倍数）",
			srLookback: "水準：転換点を探す過去の範囲",
			srMax: "画面に残す水準の最大数",
			srRange: "遠すぎる水準を除外（通常の足の大きさの倍数）",
			srReset: "水準：削除までの再テスト回数",
			stripLen: "右側の列の幅（本数）",
			tablePos: "現在の状況パネルの位置",
			theme: "チャートの配色",
			tp1R: "TP1（Rの倍数）",
			tp2R: "TP2（Rの倍数）",
			trendPos: "トレンド表の位置",
			tz: "取引時間帯のタイムゾーン"
		},
		ladder: {
			closedAtStop: "損切りで決済",
			closedAtTarget: "決済 TP{{hit}}",
			entry: "エントリー",
			stop: "損切り",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "自動調整",
			bottomCentre: "下中央",
			bottomLeft: "左下",
			bottomRight: "右下",
			dark: "ダーク配色",
			ignore: "無視",
			large: "大",
			light: "ライト配色",
			literal238: "238に固定",
			middleCentre: "中央",
			middleLeft: "左中央",
			middleRight: "右中央",
			normal: "標準",
			reject: "却下",
			small: "小",
			topCentre: "上中央",
			topLeft: "左上",
			topRight: "右上",
			waitForPullback: "押し戻りを待つ"
		},
		reasons: {
			clock: "取引時間帯の範囲外",
			diamond: "大きな警告ひし形が出た直後",
			range: "チャートが持ち合いで停滞している",
			room: "水準が近すぎて目標までの余地がない",
			safetyLine: "238がエントリーと目標の間にある",
			separation: "2本の線が近すぎて、まだ値動きの余地がない",
			trend: "15分足のトレンドに逆行",
			wrongColour: "交差した足が逆の色で確定した"
		},
		rightNow: {
			aBuy: "買い",
			aSell: "売り",
			bestBuysOnly: "買いのみを探す",
			bestNow: "今の最善策",
			bestSellsOnly: "売りのみを探す",
			bestWaitThin: "出来高が少ないため待機",
			goodVolume: "出来高十分",
			lowVolume: "出来高不足",
			safetyAbove: "238が価格の上、売りの余地あり",
			safetyBelow: "238が価格の下、買いの余地あり",
			safetyLine: "安全線",
			skipped: "見送り",
			skippedAgo_other: "{{bars}}本前の{{side}}：{{reason}}",
			skippedNothing: "まだ見送りなし",
			title: "現在の状況",
			trend: "トレンド",
			trendSummaryDown: "15mは下降、6種類の時間足のうち{{agree}}つが上昇",
			trendSummaryUp: "15mは上昇、6種類の時間足のうち{{agree}}つが上昇"
		},
		signal: {
			buy: "買い",
			pips: "ピップス",
			sell: "売り",
			stop: "損切り"
		},
		tooltip: {
			f3Mode: "赤い足での買いや青い足での売りは、そのまま採用しません。「押し戻りを待つ」は適切な色の足で価格が線まで戻るのを待ちます。「却下」はシグナルを除外します。",
			f4Min: "シグナルの足で2本の線が離れる速さです。絡み合って横ばいの線には値動きの余地がありません。",
			f6Reward: "次の破線水準まで最低でもこの距離が必要です。初期設定は無効です。水準はこのスキャナー独自の方法で算出するため、余地を目視でも確認してください。",
			f7Pips: "幅が100ピップス以下の持ち合いを避けます。",
			longMode: "238は1分足向けの標準設定です。自動調整では他の時間足に安全線を合わせ、3分足なら約83になります。",
			pipIn: "自動：金は0.10、その他は10ティック（US30は1ポイント）。",
			showGuide: "チャート上の簡単な凡例です。記号を覚えたら非表示にしてください。",
			showLadder: "直近取引のエントリー、損切り、目標を最後の足の右に表示します。目標に到達するとチェックが付きます。",
			showWhy: "線が交差しても条件で取引を見送った場合、現在の状況パネルに該当条件と理由が表示されます。",
			slMinPips: "損切りは赤と青の両方の線の反対側に置き、青から最低10ピップス離します。",
			srMax: "チャートを見やすくするため、価格に最も近い水準のみを残します。",
			theme: "すべての色を見やすくするため、TradingViewの配色に合わせてください。",
			tz: "取引時間帯はこのタイムゾーンで設定されます。America/Denverは夏時間のある北米山岳部時間です。夏時間のない山岳部時間にはAmerica/Phoenixを使います。"
		},
		trendTable: {
			above: "上",
			below: "下",
			down: "下降",
			notAvailable: "データなし",
			up: "上昇",
			volumeLine: "出来高線"
		}
	},
	bearish: "弱気",
	bfs: {
		duplicateRemoved: "1 つのチャートで使える BFS — Blessed Flow System は 1 つだけです。重複したものを削除しました。",
		emaCrossSoon: "EMA30/50 がクロス寸前",
		engineOff: "M1 に切り替え",
		engineOn: "エンジン M1",
		input: {
			armWin: "EMA30 にタッチするまでの期間（M1 本数）",
			asiaSess: "アジア（HHMM-HHMM）",
			bePts: "BE: +ポイントに達したら損切りをその値位置へ動かす",
			cooldown: "決済後の待ち時間（M1 本数）",
			lenFast: "短期 EMA（方向の判定）",
			lenH1a: "H1 · 短期 EMA",
			lenH1b: "H1 · 長期 EMA",
			lenMid: "中期 EMA",
			lenSlow: "長期 EMA",
			londonSess: "ロンドン（HHMM-HHMM、セッション時計）",
			maxPerBlock: "セッション区間ごとの最大エントリー数（0 = 無制限）",
			nearLb: "収束を測るのに使う本数",
			nearPts: "EMA30-EMA50 の最大間隔（ポイント）",
			nySess: "ニューヨーク（HHMM-HHMM）",
			onlyM1: "エンジンを M1 のみで動かす",
			pv: "1 ポイントあたりの価格",
			r1lb: "R1 · さかのぼる M1 本数（価格が伸びきっていない）",
			rr: "利確のリスクリワード R:R（段階利確を使わない場合）",
			rsiHi: "ショートに必要な RSI >=",
			rsiLen: "RSI の期間",
			rsiLo: "ロングに必要な RSI <=",
			rsiWin: "待機期間（シグナル後の本数）",
			showLevels: "取引の価格ラインを描く",
			showNear: "EMA30 が EMA50 とクロスしそうなときに印を付ける",
			slPts: "損切り（ポイント）",
			swLenA: "ピボットの強さ（左右の本数）",
			tp1Pts: "TP1（ポイント）",
			tp2Pts: "TP2（ポイント）",
			tp3Pts: "TP3（ポイント）",
			tzOffset: "セッション時計の UTC オフセット（ボゴタ = -5）",
			useArm: "50% 押し戻しと期間内の EMA30 タッチを必須にする",
			useAsia: "アジアも含める（テスト用）",
			useBE: "損益分岐点への移動を有効にする",
			useLadder: "TP1/TP2/TP3 を使う（最終決済 = TP3）",
			useR2: "R2 · M5 + M15 の並びと H1 の方向を必須にする",
			useRSI: "シグナルの後に RSI を待つ",
			useSess: "セッションで絞り込む",
			useTrend: "待機中も EMA の並びを保つ"
		},
		longSignal: "ロングのシグナル",
		noSignal: "シグナルなし",
		retracementDot: "50% 押し戻しのドット",
		rewardZone: "リワードゾーン",
		riskZone: "リスクゾーン",
		session: "セッション",
		sessionClosed: "クローズ",
		sessionOpen: "オープン",
		shortSignal: "ショートのシグナル",
		signal: "シグナル",
		signalActive: "{{side}} 進行中",
		waitingRsi: "RSI 待ち {{arrow}}（{{n}}）",
		waitingRsiLong: "RSI 待ち（ロング）",
		waitingRsiShort: "RSI 待ち（ショート）"
	},
	breakEven: "損益分岐点",
	bullish: "強気",
	buy: "買い",
	colour: "色",
	cypher: {
		above55: "55より上",
		aboveBelow: "上/下",
		barColors: "バーの色",
		bbLength: "BB期間",
		bbStdDev: "BB標準偏差 {{n}}",
		bearBreak: "弱気ブレイク",
		bearPattern: "弱気ピンバー／包み足",
		below55: "55より下",
		bullBreak: "強気ブレイク",
		bullPattern: "強気ピンバー／包み足",
		cmoLength: "CMO期間",
		colorCandles: "ローソク足に色付け",
		confluenceLong: "コンフルエンス・ロング",
		confluenceShort: "コンフルエンス・ショート",
		consolidating: "保ち合い",
		direction: "方向",
		emaPeriodTrend: "EMA期間（トレンド）",
		flagOffsetAtr: "フラグのオフセット（x ATR）",
		flashBackground: "フラッシュ背景",
		flashCount: "フラッシュ回数",
		flashHz: "フラッシュ速度（回 / 秒）",
		flashOn: "新しいフラグでフラッシュ",
		flashShowBanner: "NEW BUY / SELLバナーを表示",
		flashShowBg: "チャート背景をフラッシュ",
		flashStrength: "背景フラッシュの強さ",
		flashTest: "フラッシュを今すぐテスト（プレビュー）",
		fvgKeep: "片側あたりのフェアバリューギャップ数",
		glowOpacity: "グローの不透明度（高いほど透明）",
		glowSizeTicks: "グローのサイズ（ティック）",
		groupFlash: "新規フラグアラート",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "一目均衡表",
		groupKde: "KDEレベル",
		groupKeyLevels: "キーレベル",
		groupLrEma: "LRチャネル / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "ピボット",
		groupPsar: "パラボリックSAR",
		groupReversalBands: "リバーサルバンド",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "コンポーネント",
		groupTrendTable: "トレンドテーブル",
		groupVidya: "VIDYA / トレンド",
		halfTrendAmplitude: "HalfTrend振幅",
		halfTrendChannelDeviation: "HalfTrendチャネル偏差",
		ichimokuBase: "一目均衡表 基準線",
		ichimokuConversion: "一目均衡表 転換線",
		kdeActivation: "アクティベーション閾値を有効化",
		kdeBins: "ビン数",
		kdeThreshold: "閾値 %",
		labelPosition: "ラベル位置",
		lineWidth: "線の太さ",
		lowerBb: "下部BB{{n}}",
		lowerInnerZone: "下部インナーゾーン",
		lowerReversalZone: "下部リバーサルゾーン",
		maCloudLong: "MAクラウド（長期）",
		maCloudShort: "MAクラウド（短期）",
		newBuy: "新規買い",
		newSell: "新規売り",
		numberOfLevels: "レベル数",
		parabolicSar: "パラボリックSAR",
		pivotAuto: "自動",
		pivotDaily: "日足",
		pivotMonthly: "月足",
		pivotsTimeframe: "ピボット時間足",
		pivotWeekly: "週足",
		positionBottomCenter: "下中央",
		positionBottomLeft: "左下",
		positionBottomRight: "右下",
		positionLeft: "左",
		positionRight: "右",
		positionTopCenter: "上中央",
		positionTopLeft: "左上",
		positionTopRight: "右上",
		psarBear: "PSAR弱気",
		psarBull: "PSAR強気",
		psarIncrement: "PSAR増分",
		psarMax: "PSAR最大値",
		psarStart: "PSAR開始値",
		pullingBack: "プルバック",
		pulseSmoothingBars: "Pulse平滑化バー数",
		reEntry: "再エントリー",
		rightOffsetBars: "右側オフセット（本数）",
		showCamarillaPivots: "カマリラ・ピボットを表示",
		showConfluenceFlag: "コンフルエンスフラグを表示（B/S）",
		showFvg: "フェアバリューギャップ（15分足以上）",
		showKde: "KDE出来高レベル",
		showKeyLevels: "キーレベルを表示",
		showLabels: "ラベルを表示",
		showLevelGlow: "レベルのグローを表示",
		showMaCloud: "MAクラウドを表示",
		showPrices: "価格を表示",
		showPsar: "PSARを表示",
		showReversalBands: "リバーサルバンドを表示",
		showSlTpLabels: "SL / TPラベルを表示",
		showSniperBreakArrows: "Sniper／ブレイク矢印を表示",
		showTrendTable: "トレンドテーブルを表示",
		showVidya233: "VIDYA 233を表示",
		showVidya55: "VIDYA 55を表示",
		showVidya987: "VIDYA 987（マグネット）を表示",
		showVidyaLines: "VIDYAラインを表示",
		sizeNormal: "標準",
		sizeSmall: "小",
		sizeTiny: "極小",
		slBufferAtr: "SLバッファ上限（x ATR）",
		slBufferPips: "SLのスイング外バッファ（pips）",
		slMaxRiskAtr: "SL最大リスク（x ATR）",
		slSwingLookback: "SLスイング参照期間（本数）",
		sniperDown: "Sniper下",
		sniperUp: "Sniper上",
		source: "ソース",
		state: "状態",
		strength: "強度",
		strong: "強い",
		superTrend2AtrLength: "SuperTrend 2 ATR期間",
		superTrend2Factor: "SuperTrend 2係数",
		superTrendAtrLength: "SuperTrend ATR期間",
		superTrendMultiplier: "SuperTrend乗数",
		tablePosition: "テーブル位置",
		tableSize: "テーブルサイズ",
		tpRiskReward: "TP {{n}} リスクリワード",
		tradeManagement: "トレード管理（SL / TP）",
		trend: "トレンド",
		trending: "トレンド中",
		upperBb: "上部BB{{n}}",
		upperInnerZone: "上部インナーゾーン",
		upperReversalZone: "上部リバーサルゾーン",
		veryStrong: "非常に強い",
		veryWeak: "非常に弱い",
		vidya987Magnet: "VIDYA 987（マグネット）",
		volumeAvgLength: "出来高平均期間（ブレイクフィルター）",
		weak: "弱い",
		zoneEdge: "{{name}}（塗りつぶし境界）"
	},
	entry: "エントリー",
	gainColor: "利益カラー",
	harsiCandle: "HARSIローソク足",
	harsiLength: "HARSIの長さ",
	heikinAshiRsiOscillator: "平均足RSIオシレーター",
	keyValueThisChangesTheSensitivity: "キー値『これは感度を変更します』",
	labelsIndicator: "ラベルインジケーター",
	london: "ロンドン",
	londonBackground: "ロンドン背景",
	londonSession: "ロンドンセッション",
	long: "ロング",
	lossColor: "損失カラー",
	median: "中央値",
	neutral: "中立",
	newYork: "ニューヨーク",
	newYorkBackground: "ニューヨーク背景",
	newYorkSession: "ニューヨークセッション",
	openSmoothing: "始値スムージング",
	optimus: {
		activeTradeLevels: "進行中の取引 · 価格ライン",
		bias: "方向",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "混在 {{n}}/{{total}}",
		disclaimer: "価格ラインはチャートに描かれています。投資助言ではありません。",
		duplicateRemoved: "1 つのチャートで使える Optimus Prime は 1 つだけです。重複したものを削除しました。",
		enter: "エントリー · {{side}}",
		input: {
			atrLength: "KC の ATR 期間",
			buffer: "スイングの余裕幅（価格）",
			emaLength: "EMA の期間",
			kcLength: "KC の期間",
			kcMult: "KC の倍率",
			lrcLength: "LRC の期間",
			minRisk: "最小リスク R（価格）",
			requireAlign: "EMA と LRC の向きが揃うことを必須にする",
			rrTp1: "TP1（xR）",
			rrTp2: "TP2（xR）",
			rrTp3: "TP3（xR）",
			rrTp4: "TP4（xR）",
			swingLookback: "スイングをさかのぼる本数（R）"
		},
		kcLower: "KC 下限",
		kcMid: "KC 中央",
		kcUpper: "KC 上限",
		keltnerFill: "ケルトナーの塗り",
		noClosedTrades: "決済済みの取引はまだありません",
		reasonForming: "セットアップ形成中 — 確認待ち",
		reasonLatched: "取引を確定 · 価格ラインはチャート上",
		reasonNoSetup: "セットアップなし · EMA/LRC の向きが揃っていない",
		recentSignals: "最近のシグナル",
		riskReward: "リスクリワード",
		trendMtf: "トレンド · 複数時間足",
		wait: "待機",
		warmingUp: "準備中"
	},
	overbought: "買われすぎ",
	overboughtMax: "買われすぎ最大値",
	overboughtMin: "買われすぎ最小値",
	oversold: "売られすぎ",
	oversoldMax: "売られすぎ最大値",
	oversoldMin: "売られすぎ最小値",
	rsiLength: "RSIの長さ",
	rsiLine: "RSIライン",
	rsiLineShadow: "RSIライン影",
	sell: "売り",
	short: "ショート",
	signalsFromHeikinAshiCandles: "平均足ローソク足からのシグナル",
	sl: "損切り",
	smoothedMode: "スムーズモード",
	sydney: "シドニー",
	sydneyBackground: "シドニー背景",
	sydneySession: "シドニーセッション",
	tfD1: "1日",
	tfH1: "1時間",
	tfH4: "4時間",
	tfM1: "1分",
	tfM15: "15分",
	tfM30: "30分",
	tfM5: "5分",
	tokyo: "東京",
	tokyoBackground: "東京背景",
	tokyoSession: "東京セッション",
	tp: "利確 {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "弱気",
			bullish: "強気",
			confluence: "コンフルエンス",
			entry: "エントリー",
			neckline: "ネックライン",
			score: "スコア",
			state: "状態",
			states: {
				completed: "完了",
				invalidated: "無効",
				projected: "予測",
				przActive: "PRZ有効",
				stopped: "損切り到達"
			},
			stop: "損切り",
			target: "ターゲット"
		},
		classic: {
			doubleBottom: "ダブルボトム",
			doubleTop: "ダブルトップ",
			headAndShoulders: "ヘッド・アンド・ショルダーズ",
			inverseHeadAndShoulders: "逆H&S",
			tripleBottom: "トリプルボトム",
			tripleTop: "トリプルトップ"
		},
		direction: {
			bearishOnly: "弱気のみ",
			both: "両方",
			bullishOnly: "強気のみ"
		},
		group: {
			classics: "クラシックパターンとS/R",
			filters: "フィルターと表示",
			patterns: "パターン",
			pivotEngine: "ピボットエンジン",
			ratios: "比率と許容誤差"
		},
		input: {
			atrLen: "ATR期間",
			atrMult: "ジグザグ反転 (x ATR)",
			colBear: "弱気",
			colBull: "強気",
			colPrz: "PRZ",
			colSR: "キーレベル",
			dirFilter: "方向フィルター",
			enClassics: "クラシックパターンを検出",
			enDoubles: "ダブルトップ / ボトム",
			enHS: "ヘッド・アンド・ショルダーズ",
			enTriples: "トリプルトップ / ボトム",
			fillTransp: "パターン塗りつぶしの透明度",
			formingLife: "形成中ゾーンの存続期間 (バー)",
			keepFailed: "損切りされたパターンをチャートに残す (✕、薄表示)",
			keepSuccessful: "成功したパターンをチャートに残す (✓)",
			maxPatterns: "チャート上の最大パターン数",
			minScore: "最小品質スコア",
			pivotDepth: "ピボットバッファの深さ",
			showLetters: "ポイント文字 X A B C D を表示",
			showPlan: "トレードプランの水準を表示",
			showProjected: "予測 (形成中) パターンを表示",
			showRatios: "各レッグに比率を表示",
			showSR: "サポート/レジスタンス水準",
			showStats: "統計テーブルを表示",
			srMinTouch: "S/R の最小ピボット接触回数",
			tolEdge: "レンジ端の許容誤差",
			tolPoint: "ポイント比率の許容誤差",
			useScale2: "2倍スケールもスキャン (より大きな構造)"
		},
		label: {
			confirmed: "確定",
			forming: "形成中",
			sl: "SL",
			target: "ターゲット",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "完了",
			stops: "損切り",
			t1Wins: "T1到達",
			winRate: "勝率 %"
		},
		tooltip: {
			colPrz: "パターンの方向に関係なく PRZ は琥珀色です (ProTrader のデフォルト)。",
			fillTransp: "値が低いほど塗りつぶしがはっきり見えます。65-80 程度がおすすめです。",
			formingLife: "C 点がこの値より古く、完成も無効化もしていない形成中のパターンは期限切れとなり削除されます。",
			maxPatterns: "古いパターンから削除されるため、最近の履歴 (✓ / ✕) と新しい形成中ゾーンは常に表示されます。",
			showProjected: "X-A-B の構造と、予測 PRZ へ向かう破線のガイドを描画します。",
			showRatios: "点線の計測用対角線 (X-B、A-C、B-D、X-D) と、各中点に計測したフィボナッチ比率を表示します。ハーモニックチャートの標準的な注記です。",
			tolPoint: "Gartley B=0.618 のような厳密な比率に適用されます。厳しめ = 0.03、標準 = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ 全決済",
		duplicateRemoved: "1 つのチャートで使える Trade Finder は 1 つだけです。重複したものを削除しました。",
		durationHm: "{{h}}時間{{m}}分",
		durationM: "{{m}}分",
		emaEntry1: "EMA エントリー 1",
		emaEntry2: "EMA エントリー 2 / トレンド",
		emaRangeFilter: "EMA レンジフィルター",
		emaTrigger: "EMA トリガー",
		entry1: "エントリー 1",
		entry2: "エントリー 2",
		entry2Mark: "E2",
		entryZoneBear: "エントリーゾーン {{n}}（弱気）",
		entryZoneBull: "エントリーゾーン {{n}}（強気）",
		frameFailed: "時間足 {{frame}} を読み込めませんでした。再試行します。",
		framesUnavailable: "時間足データなし · 待機",
		ghostEntry: "前のセットアップ",
		ghostStop: "前のストップ",
		group: {
			bias: "バイアス",
			display: "表示",
			emaSystem: "EMA システム",
			entries: "エントリー",
			filter: "フィルター",
			riskManagement: "リスク管理",
			session: "セッション",
			supportResistance: "サポートとレジスタンス",
			trailingStop: "トレーリングストップ",
			trendPanel: "トレンドパネル"
		},
		input: {
			adxLen: "ADX の期間",
			adxSmoothing: "ADX の平滑化",
			asiaSession: "アジア・東京セッション（UTC）",
			atrBufferMultBtc: "スイング後方のストップ余裕 — BTC（× ATR）",
			atrBufferMultGold: "スイング後方のストップ余裕 — ゴールド（× ATR）",
			atrBufferMultOther: "スイング後方のストップ余裕 — その他（× ATR）",
			atrLength: "ATR 期間（リスク管理）",
			atrSlMult: "損切り = ATR ×",
			atrTpMult: "利確 {{n}} = ATR ×",
			beGoldPoints: "ゴールド: この値幅で損益分岐点へ移動",
			biasEmaLen: "バイアス EMA の期間",
			crossLookback: "バイアスのクロス参照期間（バー）",
			dxySymbol: "ドル指数のシンボル（空欄で無効）",
			emaBigLen: "EMA レンジフィルターの期間",
			emaFastLen: "EMA エントリー 1 の期間",
			emaMidLen: "EMA エントリー 2 / トレンドの期間",
			emaTriggerLen: "EMA トリガーの期間",
			feeBufferPct: "損益分岐点を超える手数料分の余裕（%）",
			flatThreshPct: "フラット判定のしきい値（バイアス EMA の %）",
			londonSession: "ロンドンセッション（UTC）",
			maxCrosses: "バイアスを破棄するクロス回数の上限",
			newYorkSession: "ニューヨークセッション（UTC）",
			showEmaLabels: "EMA の名前ラベルを表示",
			showEntrySignals: "セットアップのマーカーを表示",
			showEntryZone: "エントリーゾーンを表示",
			showSRLines: "サポートとレジスタンスを表示",
			showTradeLevels: "エントリー・ストップ・目標の水準を表示",
			slMaxPointsBtc: "最大ストップ幅 — BTC（ポイント）",
			slMaxPointsGold: "最大ストップ幅 — ゴールド（ポイント）",
			slMaxPointsIndex: "最大ストップ幅 — 指数（ポイント）",
			slMaxPointsOther: "最大ストップ幅 — その他（ポイント）",
			slMinPointsGold: "最小ストップ幅 — ゴールド（ポイント）",
			slopeLookback: "バイアスの傾き参照期間（バー）",
			srLeftBars: "サポート / レジスタンス · ピボット左のバー数",
			srRightBars: "サポート / レジスタンス · ピボット右のバー数",
			swingPivotLen: "スイングピボット長（損切り）",
			tp1ClosePct: "利確 1 で決済する割合 (%)",
			tp2ClosePct: "利確 2 で決済する割合 (%)",
			tp5CloseAlways: "利確 5 で常に決済（トレーリング中でも）",
			tpR: "利確 {{n}}（R 倍）",
			tpSlMode: "ストップと目標のモード",
			trailAtrMult: "トレーリングストップ幅（× ATR）",
			trendPanelEmaLen: "トレンド行の EMA 期間",
			trendSlopeLB: "EMA エントリー 2 の傾き参照期間（本）",
			useAdxFilter: "ADX がモードのしきい値を超えることを必須にする",
			useBiasFilter: "上位足バイアスを採点する（エントリーは止めない）",
			useEmaStackCheck: "EMA が正しい順序に並ぶことを要求",
			useInstrumentAutoDetect: "銘柄を自動判別する",
			useSessionFilter: "取引セッション中のみシグナルを出す",
			useSlopeDynamic: "傾きの参照期間を時間足に合わせる",
			useStrictCandle: "厳格なローソク足フィルター（ヒゲと終値）",
			useTrailingStop: "トレーリングストップ（利確 1 以降）",
			useVolumeConfirm: "エントリー時に平均以上の出来高を要求",
			volAvgLen: "出来高平均の期間",
			volMultiplier: "最低出来高（× 平均）"
		},
		maxStop: "最大ストップ",
		minuteAgainst: "セットアップに逆行",
		minuteOk: "警告なし",
		minuteReversal: "クロス · 反転の可能性",
		modeAtr: "ATR",
		modeAuto: "自動",
		modeRiskReward: "リスクリワード",
		noBias: "バイアスなし",
		noSetup: "有効なセットアップなし",
		recentTitle: "最近のセットアップ",
		reEntry: "再エントリー",
		reEntryMark: "RE",
		rest: "残り",
		rowBias: "バイアス",
		rowContext: "状況",
		rowInfo: "情報",
		rowSession: "時間帯",
		rowSetup: "仕掛け",
		rowVolume: "出来高",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "残り{{time}}",
		sessionOutside: "時間外 · ロンドン {{time}} UTC",
		sessionOverlap: "重複時間帯",
		statsTitle: "直近 {{n}} 件のセットアップ",
		statusBreakEvenSet: "建値",
		statusMoveToBreakEven: "ストップ移動",
		statusPending: "ゾーン接触",
		statusRunning: "進行中",
		statusSpike: "変動大 · 待機",
		statusWaiting: "待機中",
		stopHit: "ストップ到達",
		styleDaytrade: "デイトレード",
		styleScalping: "スキャルピング",
		styleSwing: "スイング",
		subFrameReversal: "下位時間足が反転中",
		targetHit: "最終目標に到達",
		trailStop: "トレーリングストップ",
		volAboveAverage: "平均以上",
		volBelowAverage: "平均以下",
		zoneEdgeBear: "ゾーン境界 {{n}}（弱気）",
		zoneEdgeBull: "ゾーン境界 {{n}}（強気）"
	},
	tradingSessions: "取引セッション",
	unintendedSymbol: "この戦略は {{symbols}} 向けです。{{symbol}} では価格ラインが意味を持たないことがあります。",
	utBotAlerts: "UTボットアラート"
}, _e = {
	asia: "아시아",
	atrPeriod: "ATR 기간",
	bearish: "약세",
	bfs: {
		duplicateRemoved: "차트당 BFS — Blessed Flow System 지표는 하나만 지원됩니다. 중복된 지표를 제거했습니다.",
		emaCrossSoon: "EMA30/50 교차 임박",
		engineOff: "M1로 전환하세요",
		engineOn: "엔진 M1",
		input: {
			armWin: "EMA30 터치 구간(M1 봉)",
			asiaSess: "아시아(HHMM-HHMM)",
			bePts: "BE: +포인트 도달 시 손절매를 바로 그 레벨로 이동",
			cooldown: "거래 청산 후 쿨다운(M1 봉)",
			lenFast: "빠른 EMA(방향)",
			lenH1a: "H1 · 단기 EMA",
			lenH1b: "H1 · 장기 EMA",
			lenMid: "중간 EMA",
			lenSlow: "느린 EMA",
			londonSess: "런던(HHMM-HHMM, 세션 시계)",
			maxPerBlock: "세션 블록당 최대 진입 횟수(0 = 제한 없음)",
			nearLb: "수렴 측정에 사용할 봉 수",
			nearPts: "EMA30-EMA50 최대 간격(포인트)",
			nySess: "뉴욕(HHMM-HHMM)",
			onlyM1: "M1에서만 엔진 실행",
			pv: "1포인트당 가격 값",
			r1lb: "R1 · M1 조회 기간(과확장 없음)",
			rr: "TP 비율 R:R(단계별 TP 미사용 시)",
			rsiHi: "숏 조건 RSI >=",
			rsiLen: "RSI 길이",
			rsiLo: "롱 조건 RSI <=",
			rsiWin: "대기 구간(시그널 후 봉 수)",
			showLevels: "거래 레벨 그리기",
			showNear: "EMA30/EMA50 교차 임박 시 표시",
			slPts: "SL(포인트)",
			swLenA: "피벗 강도(좌우 각 봉 수)",
			tp1Pts: "TP1(포인트)",
			tp2Pts: "TP2(포인트)",
			tp3Pts: "TP3(포인트)",
			tzOffset: "세션 시계 UTC 오프셋(보고타 = -5)",
			useArm: "50% 되돌림 + 구간 내 EMA30 터치 필수",
			useAsia: "아시아 포함(테스트 전용)",
			useBE: "손익분기 활성화",
			useLadder: "TP1/TP2/TP3 사용(최종 청산 = TP3)",
			useR2: "R2 · M5 + M15 배열 + H1 바이어스 필수",
			useRSI: "시그널 후 RSI 대기",
			useSess: "세션으로 필터링",
			useTrend: "대기 중 EMA 순서 유지"
		},
		longSignal: "롱 시그널",
		noSignal: "시그널 없음",
		retracementDot: "50% 되돌림 점",
		rewardZone: "보상 구간",
		riskZone: "리스크 구간",
		session: "세션",
		sessionClosed: "마감",
		sessionOpen: "개장",
		shortSignal: "숏 시그널",
		signal: "시그널",
		signalActive: "{{side}} 진행 중",
		waitingRsi: "RSI 대기 {{arrow}} ({{n}})",
		waitingRsiLong: "RSI 대기(롱)",
		waitingRsiShort: "RSI 대기(숏)"
	},
	breakEven: "손익분기",
	bullish: "강세",
	buy: "매수",
	colour: "색상",
	cypher: {
		above55: "55 상회",
		aboveBelow: "상회/하회",
		barColors: "봉 색상",
		bbLength: "BB 길이",
		bbStdDev: "BB 표준편차 {{n}}",
		bearBreak: "약세 돌파",
		bearPattern: "약세 핀바 / 장악형",
		below55: "55 하회",
		bullBreak: "강세 돌파",
		bullPattern: "강세 핀바 / 장악형",
		cmoLength: "CMO 길이",
		colorCandles: "캔들 색상 적용",
		confluenceLong: "컨플루언스 롱",
		confluenceShort: "컨플루언스 숏",
		consolidating: "횡보",
		direction: "방향",
		emaPeriodTrend: "EMA 기간(추세)",
		flagOffsetAtr: "플래그 오프셋(x ATR)",
		flashBackground: "깜빡임 배경",
		flashCount: "깜빡임 횟수",
		flashHz: "깜빡임 속도(회 / 초)",
		flashOn: "새 플래그 시 깜빡임",
		flashShowBanner: "신규 매수 / 매도 배너 깜빡임",
		flashShowBg: "차트 배경 깜빡임",
		flashStrength: "배경 깜빡임 강도",
		flashTest: "지금 깜빡임 테스트(미리 보기)",
		fvgKeep: "방향별 유지할 공정가치 갭 수",
		glowOpacity: "글로우 불투명도(높을수록 더 투명)",
		glowSizeTicks: "글로우 크기(틱)",
		groupFlash: "새 플래그 알림",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "일목균형표",
		groupKde: "KDE 레벨",
		groupKeyLevels: "주요 레벨",
		groupLrEma: "LR 채널 / EMA",
		groupMaCloud: "MA 클라우드",
		groupPivots: "피벗",
		groupPsar: "파라볼릭 SAR",
		groupReversalBands: "반전 밴드",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "구성 요소 켜기/끄기",
		groupTrendTable: "추세 표",
		groupVidya: "VIDYA / 추세",
		halfTrendAmplitude: "HalfTrend 진폭",
		halfTrendChannelDeviation: "HalfTrend 채널 편차",
		ichimokuBase: "일목균형표 기준선",
		ichimokuConversion: "일목균형표 전환선",
		kdeActivation: "활성화 임계값 사용",
		kdeBins: "구간 수",
		kdeThreshold: "임계값 %",
		labelPosition: "레이블 위치",
		lineWidth: "선 두께",
		lowerBb: "하단 BB{{n}}",
		lowerInnerZone: "하단 내부 구간",
		lowerReversalZone: "하단 반전 구간",
		maCloudLong: "MA 클라우드(장기)",
		maCloudShort: "MA 클라우드(단기)",
		newBuy: "신규 매수",
		newSell: "신규 매도",
		numberOfLevels: "레벨 수",
		parabolicSar: "파라볼릭 SAR",
		pivotAuto: "자동",
		pivotDaily: "일봉",
		pivotMonthly: "월봉",
		pivotsTimeframe: "피벗 시간 프레임",
		pivotWeekly: "주봉",
		positionBottomCenter: "하단 중앙",
		positionBottomLeft: "하단 왼쪽",
		positionBottomRight: "하단 오른쪽",
		positionLeft: "왼쪽",
		positionRight: "오른쪽",
		positionTopCenter: "상단 중앙",
		positionTopLeft: "상단 왼쪽",
		positionTopRight: "상단 오른쪽",
		psarBear: "PSAR 약세",
		psarBull: "PSAR 강세",
		psarIncrement: "PSAR 증가분",
		psarMax: "PSAR 최댓값",
		psarStart: "PSAR 시작값",
		pullingBack: "되돌림",
		pulseSmoothingBars: "Pulse 스무딩 봉 수",
		reEntry: "재진입",
		rightOffsetBars: "오른쪽 오프셋(봉)",
		showCamarillaPivots: "Camarilla 피벗 표시",
		showConfluenceFlag: "컨플루언스 플래그 표시(B/S)",
		showFvg: "공정가치 갭(15분봉 이상)",
		showKde: "KDE 거래량 레벨",
		showKeyLevels: "주요 레벨 표시",
		showLabels: "레이블 표시",
		showLevelGlow: "레벨 글로우 표시",
		showMaCloud: "MA 클라우드 표시",
		showPrices: "가격 표시",
		showPsar: "PSAR 표시",
		showReversalBands: "반전 밴드 표시",
		showSlTpLabels: "SL / TP 레이블 표시",
		showSniperBreakArrows: "Sniper / 돌파 화살표 표시",
		showTrendTable: "추세 표 표시",
		showVidya233: "VIDYA 233 표시",
		showVidya55: "VIDYA 55 표시",
		showVidya987: "VIDYA 987(마그넷) 표시",
		showVidyaLines: "VIDYA 라인 표시",
		sizeNormal: "보통",
		sizeSmall: "작게",
		sizeTiny: "아주 작게",
		slBufferAtr: "SL 버퍼 상한(x ATR)",
		slBufferPips: "스윙 너머 SL 버퍼(핍)",
		slMaxRiskAtr: "SL 최대 리스크(x ATR)",
		slSwingLookback: "SL 스윙 조회 기간(봉)",
		sniperDown: "Sniper 하락",
		sniperUp: "Sniper 상승",
		source: "소스",
		state: "상태",
		strength: "강도",
		strong: "강함",
		superTrend2AtrLength: "SuperTrend 2 ATR 길이",
		superTrend2Factor: "SuperTrend 2 계수",
		superTrendAtrLength: "SuperTrend ATR 길이",
		superTrendMultiplier: "SuperTrend 승수",
		tablePosition: "표 위치",
		tableSize: "표 크기",
		tpRiskReward: "TP {{n}} 손익비",
		tradeManagement: "거래 관리(SL / TP)",
		trend: "추세",
		trending: "추세 진행",
		upperBb: "상단 BB{{n}}",
		upperInnerZone: "상단 내부 구간",
		upperReversalZone: "상단 반전 구간",
		veryStrong: "매우 강함",
		veryWeak: "매우 약함",
		vidya987Magnet: "VIDYA 987(마그넷)",
		volumeAvgLength: "거래량 평균 길이(돌파 필터)",
		weak: "약함",
		zoneEdge: "{{name}}(채우기 경계)"
	},
	entry: "진입가",
	gainColor: "수익 색상",
	harsiCandle: "HARSI 캔들",
	harsiLength: "HARSI 길이",
	heikinAshiRsiOscillator: "하이킨아시 RSI 오실레이터",
	keyValueThisChangesTheSensitivity: "키 값 '민감도를 변경합니다'",
	labelsIndicator: "레이블 지표",
	london: "런던",
	londonBackground: "런던 배경",
	londonSession: "런던 세션",
	long: "롱",
	lossColor: "손실 색상",
	median: "중앙값",
	neutral: "중립",
	newYork: "뉴욕",
	newYorkBackground: "뉴욕 배경",
	newYorkSession: "뉴욕 세션",
	openSmoothing: "시가 스무딩",
	optimus: {
		activeTradeLevels: "진행 중 거래 · 레벨",
		bias: "바이어스",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "혼조 {{n}}/{{total}}",
		disclaimer: "레벨은 차트에 표시됩니다. 투자 조언이 아닙니다.",
		duplicateRemoved: "차트당 Optimus Prime 지표는 하나만 지원됩니다. 중복된 지표를 제거했습니다.",
		enter: "진입 · {{side}}",
		input: {
			atrLength: "KC ATR 길이",
			buffer: "스윙 버퍼(가격)",
			emaLength: "EMA 길이",
			kcLength: "KC 길이",
			kcMult: "KC 승수",
			lrcLength: "LRC 길이",
			minRisk: "최소 리스크 R(가격)",
			requireAlign: "EMA와 LRC 방향 일치 필수",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "스윙 조회 기간(R)"
		},
		kcLower: "KC 하단",
		kcMid: "KC 중앙",
		kcUpper: "KC 상단",
		keltnerFill: "Keltner 채우기",
		noClosedTrades: "아직 청산된 거래가 없습니다",
		reasonForming: "셋업 형성 중 — 확인 대기",
		reasonLatched: "거래 확정 · 차트에 레벨 표시",
		reasonNoSetup: "셋업 없음 · EMA/LRC 방향 불일치",
		recentSignals: "최근 시그널",
		riskReward: "손익비",
		trendMtf: "추세 · 다중 시간 프레임",
		wait: "대기",
		warmingUp: "준비 중"
	},
	overbought: "과매수",
	overboughtMax: "과매수 최댓값",
	overboughtMin: "과매수 최솟값",
	oversold: "과매도",
	oversoldMax: "과매도 최댓값",
	oversoldMin: "과매도 최솟값",
	rsiLength: "RSI 길이",
	rsiLine: "RSI 라인",
	rsiLineShadow: "RSI 라인 그림자",
	sell: "매도",
	short: "숏",
	signalsFromHeikinAshiCandles: "하이킨아시 캔들 기반 시그널",
	sl: "SL",
	smoothedMode: "스무딩 모드",
	sydney: "시드니",
	sydneyBackground: "시드니 배경",
	sydneySession: "시드니 세션",
	tfD1: "1일",
	tfH1: "1시간",
	tfH4: "4시간",
	tfM1: "1분",
	tfM15: "15분",
	tfM30: "30분",
	tfM5: "5분",
	tokyo: "도쿄",
	tokyoBackground: "도쿄 배경",
	tokyoSession: "도쿄 세션",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "약세",
			bullish: "강세",
			confluence: "컨플루언스",
			entry: "진입가",
			neckline: "넥라인",
			score: "점수",
			state: "상태",
			states: {
				completed: "완료",
				invalidated: "무효화",
				projected: "예상",
				przActive: "PRZ 활성",
				stopped: "손절매 도달"
			},
			stop: "손절매",
			target: "목표가"
		},
		classic: {
			doubleBottom: "이중 바닥",
			doubleTop: "이중 천장",
			headAndShoulders: "헤드 앤 숄더",
			inverseHeadAndShoulders: "역 H&S",
			tripleBottom: "삼중 바닥",
			tripleTop: "삼중 천장"
		},
		direction: {
			bearishOnly: "약세만",
			both: "양방향",
			bullishOnly: "강세만"
		},
		group: {
			classics: "클래식 패턴 및 S/R",
			filters: "필터 및 표시",
			patterns: "패턴",
			pivotEngine: "피벗 엔진",
			ratios: "비율 및 허용 오차"
		},
		input: {
			atrLen: "ATR 기간",
			atrMult: "지그재그 반전(x ATR)",
			colBear: "약세",
			colBull: "강세",
			colPrz: "PRZ",
			colSR: "주요 레벨",
			dirFilter: "방향 필터",
			enClassics: "클래식 패턴 감지",
			enDoubles: "이중 천장 / 바닥",
			enHS: "헤드 앤 숄더",
			enTriples: "삼중 천장 / 바닥",
			fillTransp: "패턴 채우기 투명도",
			formingLife: "형성 중 구간 유지 기간(봉)",
			keepFailed: "손절매 도달 패턴을 차트에 유지(✕, 흐리게)",
			keepSuccessful: "성공한 패턴을 차트에 유지(✓)",
			maxPatterns: "차트 내 최대 패턴 수",
			minScore: "최소 품질 점수",
			pivotDepth: "피벗 버퍼 깊이",
			showLetters: "X A B C D 포인트 문자 표시",
			showPlan: "거래 계획 레벨 표시",
			showProjected: "예상(형성 중) 패턴 표시",
			showRatios: "레그에 비율 수치 표시",
			showSR: "지지/저항 레벨",
			showStats: "통계 표 표시",
			srMinTouch: "S/R 최소 피벗 터치 횟수",
			tolEdge: "범위 경계 허용 오차",
			tolPoint: "포인트 비율 허용 오차",
			useScale2: "2x 스케일도 스캔(더 큰 구조)"
		},
		label: {
			confirmed: "확인됨",
			forming: "형성 중",
			sl: "SL",
			target: "목표가",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "완료",
			stops: "손절매",
			t1Wins: "T1 도달",
			winRate: "승률 %"
		},
		tooltip: {
			colPrz: "패턴 방향과 관계없이 PRZ는 호박색입니다(ProTrader 기본값).",
			fillTransp: "값이 낮을수록 채우기가 더 잘 보입니다. 65-80 정도가 적당합니다.",
			formingLife: "완성되지도 무효화되지도 않은 채 C 포인트가 이 값보다 오래된 형성 중 패턴은 만료되어 제거됩니다.",
			maxPatterns: "가장 오래된 패턴부터 제거되므로 최근 기록(✓ / ✕)과 새로 형성 중인 구간은 항상 표시됩니다.",
			showProjected: "X-A-B 구조를 예상 PRZ로 이어지는 점선 가이드와 함께 그립니다.",
			showRatios: "점선 측정 대각선(X-B, A-C, B-D, X-D)과 각 중간점의 측정된 피보나치 비율 — 하모닉 차트의 표준 주석입니다.",
			tolPoint: "Gartley B=0.618과 같은 정확한 비율에 적용됩니다. 엄격 = 0.03, 균형 = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ 전량 청산",
		duplicateRemoved: "차트당 Trade Finder 지표는 하나만 지원됩니다. 중복된 지표를 제거했습니다.",
		durationHm: "{{h}}시간 {{m}}분",
		durationM: "{{m}}분",
		emaEntry1: "EMA 진입 1",
		emaEntry2: "EMA 진입 2 / 추세",
		emaRangeFilter: "EMA 범위 필터",
		emaTrigger: "EMA 트리거",
		entry1: "진입 1",
		entry2: "진입 2",
		entry2Mark: "E2",
		entryZoneBear: "진입 구간 {{n}}(약세)",
		entryZoneBull: "진입 구간 {{n}}(강세)",
		frameFailed: "{{frame}} 시간 프레임을 불러오지 못했습니다. 다시 시도합니다.",
		framesUnavailable: "TF 데이터 없음 · 대기",
		ghostEntry: "이전 셋업",
		ghostStop: "이전 손절매",
		group: {
			bias: "바이어스",
			display: "표시",
			emaSystem: "EMA 시스템",
			entries: "진입",
			filter: "필터",
			riskManagement: "리스크 관리",
			session: "세션",
			supportResistance: "지지 및 저항",
			trailingStop: "트레일링 스톱",
			trendPanel: "추세 패널"
		},
		input: {
			adxLen: "ADX 길이",
			adxSmoothing: "ADX 스무딩",
			asiaSession: "아시아 / 도쿄 세션(UTC)",
			atrBufferMultBtc: "스윙 너머 손절매 버퍼 — BTC(× ATR)",
			atrBufferMultGold: "스윙 너머 손절매 버퍼 — 금(× ATR)",
			atrBufferMultOther: "스윙 너머 손절매 버퍼 — 기타(× ATR)",
			atrLength: "ATR 길이(리스크 관리)",
			atrSlMult: "손절매 = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "금: 이 포인트 수 도달 후 손익분기",
			biasEmaLen: "바이어스 EMA 길이",
			crossLookback: "바이어스 교차 조회 기간(봉)",
			dxySymbol: "달러 인덱스 심볼(비워 두면 해당 항목 비활성화)",
			emaBigLen: "EMA 범위 필터 길이",
			emaFastLen: "EMA 진입 1 길이",
			emaMidLen: "EMA 진입 2 / 추세 길이",
			emaTriggerLen: "EMA 트리거 길이",
			feeBufferPct: "손익분기 너머 수수료 버퍼(%)",
			flatThreshPct: "평탄 임계값(바이어스 EMA 대비 %)",
			londonSession: "런던 세션(UTC)",
			maxCrosses: "바이어스 폐기 전 최대 교차 횟수",
			newYorkSession: "뉴욕 세션(UTC)",
			showEmaLabels: "EMA 이름 레이블 표시",
			showEntrySignals: "셋업 마커 표시",
			showEntryZone: "진입 구간 표시",
			showSRLines: "지지 및 저항 표시",
			showTradeLevels: "진입·손절매·목표가 레벨 표시",
			slMaxPointsBtc: "최대 손절매 거리 — BTC(포인트)",
			slMaxPointsGold: "최대 손절매 거리 — 금(포인트)",
			slMaxPointsIndex: "최대 손절매 거리 — 지수(포인트)",
			slMaxPointsOther: "최대 손절매 거리 — 기타(포인트)",
			slMinPointsGold: "최소 손절매 거리 — 금(포인트)",
			slopeLookback: "바이어스 기울기 조회 기간(봉)",
			srLeftBars: "지지 / 저항 · 피벗 왼쪽 봉 수",
			srRightBars: "지지 / 저항 · 피벗 오른쪽 봉 수",
			swingPivotLen: "스윙 피벗 길이(손절매)",
			tp1ClosePct: "TP1 청산 %",
			tp2ClosePct: "TP2 청산 %",
			tp5CloseAlways: "트레일링 중에도 TP5에서 항상 청산",
			tpR: "TP{{n}}(R 단위)",
			tpSlMode: "손절매·목표가 모드",
			trailAtrMult: "트레일링 스톱 거리(× ATR)",
			trendPanelEmaLen: "추세 행 EMA 길이",
			trendSlopeLB: "EMA 진입 2 기울기 조회 기간(봉)",
			useAdxFilter: "ADX가 모드 임계값 이상이어야 함",
			useBiasFilter: "상위 시간 프레임 바이어스를 점수에 반영(진입을 차단하지 않음)",
			useEmaStackCheck: "EMA 순서대로 배열 필수",
			useInstrumentAutoDetect: "종목 자동 감지",
			useSessionFilter: "거래 세션 중에만 시그널 발생",
			useSlopeDynamic: "시간 프레임에 맞춰 기울기 조회 기간 조정",
			useStrictCandle: "엄격한 캔들 필터(꼬리 및 종가)",
			useTrailingStop: "트레일링 스톱(TP1부터)",
			useVolumeConfirm: "진입 시 평균 이상 거래량 필수",
			volAvgLen: "거래량 평균 길이",
			volMultiplier: "최소 거래량(× 평균)"
		},
		maxStop: "최대 SL",
		minuteAgainst: "셋업 반대 방향 교차",
		minuteOk: "경고 없음",
		minuteReversal: "교차 · 반전 가능성",
		modeAtr: "ATR",
		modeAuto: "자동",
		modeRiskReward: "손익비",
		noBias: "바이어스 없음",
		noSetup: "활성 셋업 없음",
		recentTitle: "최근 셋업",
		reEntry: "재진입",
		reEntryMark: "RE",
		rest: "잔여",
		rowBias: "바이어스",
		rowContext: "상황",
		rowInfo: "정보",
		rowSession: "세션",
		rowSetup: "셋업",
		rowVolume: "거래량",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "{{time}} 남음",
		sessionOutside: "시간 외 · 런던 {{time}} UTC",
		sessionOverlap: "중첩 시간대",
		statsTitle: "최근 {{n}}개 셋업",
		statusBreakEvenSet: "손익분기",
		statusMoveToBreakEven: "손절매 이동",
		statusPending: "구간 터치",
		statusRunning: "진행 중",
		statusSpike: "고변동성 · 대기",
		statusWaiting: "대기 중",
		stopHit: "손절매 도달",
		styleDaytrade: "데이트레이딩",
		styleScalping: "스캘핑",
		styleSwing: "스윙",
		subFrameReversal: "하위 시간 프레임 반전 중",
		targetHit: "최종 목표가 도달",
		trailStop: "트레일링 스톱",
		volAboveAverage: "평균 이상",
		volBelowAverage: "평균 미만",
		zoneEdgeBear: "구간 경계 {{n}}(약세)",
		zoneEdgeBull: "구간 경계 {{n}}(강세)"
	},
	tradingSessions: "거래 세션",
	unintendedSymbol: "이 전략은 {{symbols}}용으로 설계되었습니다. {{symbol}}에서는 레벨이 의미가 없을 수 있습니다.",
	utBotAlerts: "UT Bot 알림"
}, ve = {
	asia: "Azja",
	atrPeriod: "Okres ATR",
	auraScanner: {
		guide: {
			bigDiamondMark: "Duży czerwony/zielony",
			bigDiamondMeaning: "Duży czerwony romb nad szczytem ostrzega przed kupnem. Duży zielony pod dołkiem przed sprzedażą.",
			blueMark: "Niebieska krzywa",
			blueMeaning: "50 EMA. Różowa nad niebieską oznacza kupno, pod nią sprzedaż.",
			dashedMark: "Linie przerywane",
			dashedMeaning: "Wsparcie i opór. Czerwone poniżej ceny, zielone powyżej.",
			diamondsMark: "Romby",
			diamondsMeaning: "Punkty zwrotne. Złote są najsłabsze, potem niebieskie, czerwone i zielone.",
			flatGoldMark: "Pozioma złota",
			flatGoldMeaning: "Poziom największego wolumenu na wykresie 15-minutowym z ostatnich sześciu godzin.",
			levelsMark: "Linie poziomów",
			levelsMeaning: "Wejście, stop i cele ostatniej transakcji. Ptaszek oznacza osiągnięcie.",
			pinkMark: "Różowa krzywa",
			pinkMeaning: "20 EMA. Jej przecięcie z niebieską linią daje sygnał.",
			subtitle: "Jak czytać ten wykres",
			thickGoldMark: "Gruba złota",
			thickGoldMeaning: "Linia 238. Jeśli leży między wejściem a celem, pomiń transakcję.",
			title: "AURA",
			triangleMark: "Trójkąt",
			triangleMeaning: "Transakcja, która przeszła wszystkie kontrole. Najedź kursorem, aby zobaczyć wartości."
		},
		groups: {
			display: "Wyświetlanie",
			eightChecks: "Osiem kontroli",
			riskAndTargets: "Ryzyko i cele",
			signalEngine: "Mechanizm sygnałów"
		},
		inputs: {
			emaFastLen: "Szybka linia (różowa)",
			emaSlowLen: "Wolna linia (niebieska)",
			f1Clock: "1. Tylko w oknie dobrego wolumenu",
			f2Trend: "2. Zgodność z trendem 15-minutowym",
			f3Mode: "3. Świeca o niewłaściwym kolorze",
			f4Min: "Minimalne rozszerzenie (pipsy na świecę)",
			f4Sep: "4. Linie oddalają się od siebie",
			f5Clear: "5. 238 poza odcinkiem wejście–cel",
			f6R: "Minimalne miejsce (× ryzyko)",
			f6Reward: "6. Miejsce do następnego poziomu",
			f7Bars: "W ostatnich (świecach)",
			f7Consol: "7. Bez utknięcia w konsolidacji",
			f7Pips: "Zakres musi przekraczać (pipsy)",
			f9Bars: "W ostatnich N świecach",
			f9Star: "8. Bez dużego rombu ostrzegawczego",
			guidePos: "Położenie objaśnień",
			longMode: "Tryb linii bezpieczeństwa (238)",
			panelSize: "Rozmiar tekstu paneli",
			pipIn: "Wielkość pipsa (0 = automatycznie)",
			showClock: "Panel bieżącej sytuacji",
			showGuide: "Objaśnienia oznaczeń",
			showLadder: "Poziomy transakcji po prawej",
			showPoc: "Linia wolumenu",
			showSr: "Poziomy przerywane",
			showStars: "Romby ostrzegawcze",
			showTable: "Tabela trendów",
			showTint: "Kolor tła",
			showWhy: "Wyjaśniaj pominięte sygnały",
			slMinPips: "Minimalny odstęp za wolną linią (pipsy)",
			srAtrMove: "Poziomy: wymagane odbicie (× zwykły rozmiar świecy)",
			srLookback: "Poziomy: zakres szukania punktów zwrotnych",
			srMax: "Maksymalna liczba poziomów na ekranie",
			srRange: "Pomijaj poziomy dalsze niż (× zwykły rozmiar świecy)",
			srReset: "Poziomy: ponowne testy przed usunięciem",
			stripLen: "Szerokość prawej kolumny (świece)",
			tablePos: "Położenie panelu bieżącej sytuacji",
			theme: "Motyw wykresu",
			tp1R: "TP1 (mnożnik R)",
			tp2R: "TP2 (mnożnik R)",
			trendPos: "Położenie tabeli trendów",
			tz: "Strefa czasowa okien handlu"
		},
		ladder: {
			closedAtStop: "ZAMKNIĘTO na stopie",
			closedAtTarget: "ZAMKNIĘTO TP{{hit}}",
			entry: "WEJŚCIE",
			stop: "STOP OCHRONNY",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Skalowanie automatyczne",
			bottomCentre: "Na dole pośrodku",
			bottomLeft: "Na dole po lewej",
			bottomRight: "Na dole po prawej",
			dark: "Ciemny",
			ignore: "Ignoruj",
			large: "Duży",
			light: "Jasny",
			literal238: "Stała wartość 238",
			middleCentre: "Pośrodku",
			middleLeft: "Pośrodku po lewej",
			middleRight: "Pośrodku po prawej",
			normal: "Zwykły",
			reject: "Odrzuć",
			small: "Mały",
			topCentre: "Na górze pośrodku",
			topLeft: "Na górze po lewej",
			topRight: "Na górze po prawej",
			waitForPullback: "Czekaj na cofnięcie"
		},
		reasons: {
			clock: "poza oknem handlu",
			diamond: "właśnie pojawił się duży romb ostrzegawczy",
			range: "wykres utknął w konsolidacji",
			room: "poziom jest za blisko, brak miejsca do celu",
			safetyLine: "linia 238 leży między wejściem a celem",
			separation: "linie są zbyt blisko, jeszcze brak miejsca na ruch",
			trend: "wbrew trendowi 15-minutowemu",
			wrongColour: "świeca przecięcia zamknęła się w niewłaściwym kolorze"
		},
		rightNow: {
			aBuy: "Kupno",
			aSell: "Sprzedaż",
			bestBuysOnly: "szukaj tylko kupna",
			bestNow: "Teraz najlepiej",
			bestSellsOnly: "szukaj tylko sprzedaży",
			bestWaitThin: "czekaj, niski wolumen",
			goodVolume: "Dobry wolumen",
			lowVolume: "Niski wolumen",
			safetyAbove: "238 nad ceną, miejsce dla sprzedaży",
			safetyBelow: "238 pod ceną, miejsce dla kupna",
			safetyLine: "Linia bezpieczeństwa",
			skipped: "Pominięto",
			skippedAgo_one: "{{side}} {{bars}} świecę temu: {{reason}}",
			skippedAgo_other: "{{side}} {{bars}} świecy temu: {{reason}}",
			skippedNothing: "jeszcze nic nie pominięto",
			title: "TERAZ",
			trend: "Kierunek trendu",
			trendSummaryDown: "15m w dół, {{agree}} z 6 interwałów w górę",
			trendSummaryUp: "15m w górę, {{agree}} z 6 interwałów w górę",
			skippedAgo_few: "{{side}} {{bars}} świece temu: {{reason}}",
			skippedAgo_many: "{{side}} {{bars}} świec temu: {{reason}}"
		},
		signal: {
			buy: "KUPNO",
			pips: "pipsy",
			sell: "SPRZEDAŻ",
			stop: "Stop ochronny"
		},
		tooltip: {
			f3Mode: "Kupno na czerwonej świecy lub sprzedaż na niebieskiej nigdy nie następuje od razu. Czekaj na cofnięcie czeka na powrót ceny do linii na świecy o właściwym kolorze. Odrzuć odrzuca sygnał.",
			f4Min: "Jak szybko linie oddalają się na świecy sygnałowej. Splątane, płaskie linie nie dają miejsca na ruch.",
			f6Reward: "Następny przerywany poziom musi być oddalony co najmniej o tyle. Domyślnie wyłączone: skaner wyznacza poziomy własną metodą, więc oceń miejsce także wzrokowo.",
			f7Pips: "Unikaj konsolidacji o szerokości 100 pipsów lub mniejszej.",
			longMode: "238 to ustawienie standardowe dla wykresów jednominutowych. Skalowanie automatyczne dostosowuje linię bezpieczeństwa do innych interwałów: około 83 na wykresie trzyminutowym.",
			pipIn: "Automatycznie: 0.10 dla złota, poza tym dziesięć tików (1 punkt dla US30).",
			showGuide: "Krótka legenda na wykresie. Wyłącz ją, gdy poznasz oznaczenia.",
			showLadder: "Wejście, stop i cele ostatniej transakcji są po prawej od ostatniej świecy. Osiągnięte cele otrzymują ptaszek.",
			showWhy: "Gdy linie się przetną, lecz kontrola zatrzyma transakcję, panel bieżącej sytuacji wskaże kontrolę i przyczynę.",
			slMinPips: "Stop znajduje się po drugiej stronie zarówno czerwonej, jak i niebieskiej linii, co najmniej 10 pipsów od niebieskiej.",
			srMax: "Pozostają tylko poziomy najbliższe cenie, aby wykres był czytelny.",
			theme: "Dopasuj do motywu TradingView, aby wszystkie kolory były wyraźne.",
			tz: "Okna handlu są określone w tej strefie czasowej. America/Denver oznacza północnoamerykański czas górski ze zmianą na czas letni. Dla czasu górskiego bez zmiany sezonowej użyj America/Phoenix."
		},
		trendTable: {
			above: "powyżej",
			below: "poniżej",
			down: "W dół",
			notAvailable: "brak danych",
			up: "W górę",
			volumeLine: "Linia wolumenu"
		}
	},
	bearish: "Niedźwiedzi",
	bfs: {
		duplicateRemoved: "Na jednym wykresie obsługiwany jest tylko jeden wskaźnik BFS — Blessed Flow System — duplikat został usunięty.",
		emaCrossSoon: "EMA30/50 zaraz się przetną",
		engineOff: "przełącz na M1",
		engineOn: "silnik M1",
		input: {
			armWin: "Okno (świece M1) na dotknięcie EMA30",
			asiaSess: "Azja (HHMM-HHMM)",
			bePts: "BE: przy +punktach stop przenosi się NA ten poziom",
			cooldown: "Przerwa (świece M1) po zamknięciu transakcji",
			lenFast: "EMA szybka (kierunek)",
			lenH1a: "H1 · EMA krótka",
			lenH1b: "H1 · EMA długa",
			lenMid: "EMA średnia",
			lenSlow: "EMA wolna",
			londonSess: "Londyn (HHMM-HHMM, zegar sesji)",
			maxPerBlock: "Maks. wejść na blok sesji (0 = bez limitu)",
			nearLb: "Świece do pomiaru zbliżenia",
			nearPts: "Maksymalny odstęp EMA30-EMA50 (punkty)",
			nySess: "Nowy Jork (HHMM-HHMM)",
			onlyM1: "Uruchamiaj silnik tylko na M1",
			pv: "Wartość cenowa 1 punktu",
			r1lb: "R1 · świece M1 wstecz (cena nierozciągnięta)",
			rr: "Stosunek TP R:R (gdy drabinka wyłączona)",
			rsiHi: "RSI >= dla SHORT",
			rsiLen: "Długość RSI",
			rsiLo: "RSI <= dla LONG",
			rsiWin: "Okno oczekiwania (świece po sygnale)",
			showLevels: "Rysuj poziomy transakcji",
			showNear: "Oznacz, gdy EMA30 zaraz przetnie EMA50",
			slPts: "SL (punkty)",
			swLenA: "Siła pivotu (świece po każdej stronie)",
			tp1Pts: "TP1 (punkty)",
			tp2Pts: "TP2 (punkty)",
			tp3Pts: "TP3 (punkty)",
			tzOffset: "Przesunięcie UTC zegara sesji (Bogota = -5)",
			useArm: "Wymagaj zniesienia 50% i dotknięcia EMA30 w oknie",
			useAsia: "Uwzględnij Azję (tylko testy)",
			useBE: "Próg rentowności aktywny",
			useLadder: "Użyj TP1/TP2/TP3 (wyjście końcowe = TP3)",
			useR2: "R2 · wymagaj układu M5 + M15 i nastawienia H1",
			useRSI: "Czekaj na RSI po sygnale",
			useSess: "Filtruj według sesji",
			useTrend: "Utrzymaj kolejność EMA w czasie oczekiwania"
		},
		longSignal: "Sygnał long",
		noSignal: "brak sygnału",
		retracementDot: "Kropka przy zniesieniu 50%",
		rewardZone: "Strefa zysku",
		riskZone: "Strefa ryzyka",
		session: "Sesja",
		sessionClosed: "zamknięta",
		sessionOpen: "otwarta",
		shortSignal: "Sygnał short",
		signal: "Sygnał",
		signalActive: "{{side}} w toku",
		waitingRsi: "czekam na RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Oczekiwanie na RSI (long)",
		waitingRsiShort: "Oczekiwanie na RSI (short)"
	},
	breakEven: "Próg rentowności",
	bullish: "Byczy",
	buy: "Kupno",
	colour: "Kolor",
	cypher: {
		above55: "Powyżej 55",
		aboveBelow: "Powyżej/Poniżej",
		barColors: "Kolory świec",
		bbLength: "Długość BB",
		bbStdDev: "Odchylenie std. BB {{n}}",
		bearBreak: "Wybicie niedźwiedzie",
		bearPattern: "Niedźwiedzia pin bar / objęcie",
		below55: "Poniżej 55",
		bullBreak: "Wybicie bycze",
		bullPattern: "Bycza pin bar / objęcie",
		cmoLength: "Długość CMO",
		colorCandles: "Koloruj świece",
		confluenceLong: "Konfluencja Long",
		confluenceShort: "Konfluencja Short",
		consolidating: "Konsolidacja",
		direction: "Kierunek",
		emaPeriodTrend: "Okres EMA (trend)",
		flagOffsetAtr: "Odstęp flagi (x ATR)",
		flashBackground: "Tło błysku",
		flashCount: "Liczba błysków",
		flashHz: "Szybkość błysku (mignięcia / s)",
		flashOn: "Błysk przy nowej fladze",
		flashShowBanner: "Pokaż baner NEW BUY / SELL",
		flashShowBg: "Błysk tła wykresu",
		flashStrength: "Siła błysku tła",
		flashTest: "Testuj błysk teraz (podgląd)",
		fvgKeep: "Fair Value Gaps na stronę",
		glowOpacity: "Krycie poświaty (więcej = bardziej przezroczysta)",
		glowSizeTicks: "Rozmiar poświaty (ticki)",
		groupFlash: "Alert nowej flagi",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "Poziomy KDE",
		groupKeyLevels: "Poziomy kluczowe",
		groupLrEma: "Kanał LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivoty",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Pasma odwrócenia",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Komponenty",
		groupTrendTable: "Tabela trendu",
		groupVidya: "VIDYA / Trend",
		halfTrendAmplitude: "Amplituda HalfTrend",
		halfTrendChannelDeviation: "Odchylenie kanału HalfTrend",
		ichimokuBase: "Linia bazowa Ichimoku",
		ichimokuConversion: "Linia konwersji Ichimoku",
		kdeActivation: "Włącz próg aktywacji",
		kdeBins: "Liczba przedziałów",
		kdeThreshold: "Próg %",
		labelPosition: "Pozycja etykiety",
		lineWidth: "Grubość linii",
		lowerBb: "Dolne BB{{n}}",
		lowerInnerZone: "Dolna strefa wewnętrzna",
		lowerReversalZone: "Dolna strefa odwrócenia",
		maCloudLong: "Chmura MA (długa)",
		maCloudShort: "Chmura MA (krótka)",
		newBuy: "NOWE KUPNO",
		newSell: "NOWA SPRZEDAŻ",
		numberOfLevels: "Liczba poziomów",
		parabolicSar: "Parabolic SAR",
		pivotAuto: "Auto",
		pivotDaily: "Dzienny",
		pivotMonthly: "Miesięczny",
		pivotsTimeframe: "Interwał pivotów",
		pivotWeekly: "Tygodniowy",
		positionBottomCenter: "Dół, środek",
		positionBottomLeft: "Dół, lewo",
		positionBottomRight: "Dół, prawo",
		positionLeft: "Lewo",
		positionRight: "Prawo",
		positionTopCenter: "Góra, środek",
		positionTopLeft: "Góra, lewo",
		positionTopRight: "Góra, prawo",
		psarBear: "PSAR niedźwiedzi",
		psarBull: "PSAR byczy",
		psarIncrement: "Przyrost PSAR",
		psarMax: "Maksimum PSAR",
		psarStart: "Start PSAR",
		pullingBack: "Korekta",
		pulseSmoothingBars: "Świece wygładzania Pulse",
		reEntry: "Ponowne wejście",
		rightOffsetBars: "Przesunięcie w prawo (świece)",
		showCamarillaPivots: "Pokaż pivoty Camarilla",
		showConfluenceFlag: "Pokaż flagę konfluencji (B/S)",
		showFvg: "Fair Value Gaps (15m i wyżej)",
		showKde: "Poziomy wolumenu KDE",
		showKeyLevels: "Pokaż poziomy kluczowe",
		showLabels: "Pokaż etykiety",
		showLevelGlow: "Pokaż poświatę poziomów",
		showMaCloud: "Pokaż chmurę MA",
		showPrices: "Pokaż ceny",
		showPsar: "Pokaż PSAR",
		showReversalBands: "Pokaż pasma odwrócenia",
		showSlTpLabels: "Pokaż etykiety SL / TP",
		showSniperBreakArrows: "Pokaż strzałki Sniper / wybicia",
		showTrendTable: "Pokaż tabelę trendu",
		showVidya233: "Pokaż VIDYA 233",
		showVidya55: "Pokaż VIDYA 55",
		showVidya987: "Pokaż VIDYA 987 (magnes)",
		showVidyaLines: "Pokaż linie VIDYA",
		sizeNormal: "Normalny",
		sizeSmall: "Mały",
		sizeTiny: "Bardzo mały",
		slBufferAtr: "SL: maks. bufor (x ATR)",
		slBufferPips: "SL: bufor za swingiem (pipsy)",
		slMaxRiskAtr: "SL: maks. ryzyko (x ATR)",
		slSwingLookback: "SL: okres swingu (świece)",
		sniperDown: "Sniper w dół",
		sniperUp: "Sniper w górę",
		source: "Źródło",
		state: "Stan",
		strength: "Siła",
		strong: "Silna",
		superTrend2AtrLength: "Długość ATR SuperTrend 2",
		superTrend2Factor: "Współczynnik SuperTrend 2",
		superTrendAtrLength: "Długość ATR SuperTrend",
		superTrendMultiplier: "Mnożnik SuperTrend",
		tablePosition: "Pozycja tabeli",
		tableSize: "Rozmiar tabeli",
		tpRiskReward: "TP {{n}} ryzyko/zysk",
		tradeManagement: "Zarządzanie transakcją (SL / TP)",
		trend: "Trend",
		trending: "W trendzie",
		upperBb: "Górne BB{{n}}",
		upperInnerZone: "Górna strefa wewnętrzna",
		upperReversalZone: "Górna strefa odwrócenia",
		veryStrong: "Bardzo silna",
		veryWeak: "Bardzo słaba",
		vidya987Magnet: "VIDYA 987 (magnes)",
		volumeAvgLength: "Długość średniej wolumenu (filtr wybicia)",
		weak: "Słaba",
		zoneEdge: "{{name}} (krawędź wypełnienia)"
	},
	entry: "Wejście",
	gainColor: "Kolor zysku",
	harsiCandle: "Świeca HARSI",
	harsiLength: "Długość HARSI",
	heikinAshiRsiOscillator: "Oscylator RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "Kluczowa wartość 'To zmienia czułość'",
	labelsIndicator: "Wskaźnik etykiet",
	london: "Londyn",
	londonBackground: "Tło Londynu",
	londonSession: "Sesja londyńska",
	long: "Long",
	lossColor: "Kolor straty",
	median: "Mediana",
	neutral: "Neutralny",
	newYork: "Nowy Jork",
	newYorkBackground: "Tło Nowego Jorku",
	newYorkSession: "Sesja nowojorska",
	openSmoothing: "Wygładzanie otwarcia",
	optimus: {
		activeTradeLevels: "Aktywna transakcja · poziomy",
		bias: "Nastawienie",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "MIESZANE {{n}}/{{total}}",
		disclaimer: "Poziomy są narysowane na wykresie. To nie jest porada inwestycyjna.",
		duplicateRemoved: "Na jednym wykresie obsługiwany jest tylko jeden wskaźnik Optimus Prime — duplikat został usunięty.",
		enter: "WEJŚCIE · {{side}}",
		input: {
			atrLength: "Długość ATR dla KC",
			buffer: "Bufor swingu (w cenie)",
			emaLength: "Długość EMA",
			kcLength: "Długość KC",
			kcMult: "Mnożnik KC",
			lrcLength: "Długość LRC",
			minRisk: "Minimalne ryzyko R (w cenie)",
			requireAlign: "Wymagaj zgodności EMA i LRC",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Świece wstecz dla swingu (R)"
		},
		kcLower: "KC dolny",
		kcMid: "KC środkowy",
		kcUpper: "KC górny",
		keltnerFill: "Wypełnienie Keltnera",
		noClosedTrades: "Brak zamkniętych transakcji",
		reasonForming: "Układ się formuje — brak potwierdzenia",
		reasonLatched: "Transakcja zablokowana · poziomy na wykresie",
		reasonNoSetup: "Brak układu · EMA/LRC niezgodne",
		recentSignals: "Ostatnie sygnały",
		riskReward: "RYZYKO/ZYSK",
		trendMtf: "Trend · wiele interwałów",
		wait: "CZEKAJ",
		warmingUp: "ROZGRZEWANIE"
	},
	overbought: "Przekupiony",
	overboughtMax: "Przekupienie Maks",
	overboughtMin: "Przekupienie Min",
	oversold: "Przesprzedany",
	oversoldMax: "Przesprzedanie Maks",
	oversoldMin: "Przesprzedanie Min",
	rsiLength: "Długość RSI",
	rsiLine: "Linia RSI",
	rsiLineShadow: "Cień linii RSI",
	sell: "Sprzedaż",
	short: "Short",
	signalsFromHeikinAshiCandles: "Sygnały ze świec Heikin Ashi",
	sl: "SL",
	smoothedMode: "Tryb wygładzony",
	sydney: "Sydney",
	sydneyBackground: "Tło Sydney",
	sydneySession: "Sesja sydnejska",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokio",
	tokyoBackground: "Tło Tokio",
	tokyoSession: "Sesja tokijska",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "spadkowy",
			bullish: "wzrostowy",
			confluence: "konfluencja",
			entry: "wejście",
			neckline: "linia szyi",
			score: "wynik",
			state: "stan",
			states: {
				completed: "zakończony",
				invalidated: "unieważniony",
				projected: "prognozowany",
				przActive: "PRZ aktywna",
				stopped: "stop wybity"
			},
			stop: "stop",
			target: "cel"
		},
		classic: {
			doubleBottom: "Podwójne dno",
			doubleTop: "Podwójny szczyt",
			headAndShoulders: "Głowa z ramionami",
			inverseHeadAndShoulders: "Odwr. RGR",
			tripleBottom: "Potrójne dno",
			tripleTop: "Potrójny szczyt"
		},
		direction: {
			bearishOnly: "Tylko niedźwiedzie",
			both: "Oba",
			bullishOnly: "Tylko bycze"
		},
		group: {
			classics: "Formacje klasyczne i S/R",
			filters: "Filtry i wyświetlanie",
			patterns: "Formacje",
			pivotEngine: "Silnik pivotów",
			ratios: "Proporcje i tolerancja"
		},
		input: {
			atrLen: "Okres ATR",
			atrMult: "Odwrócenie zigzaga (x ATR)",
			colBear: "Niedźwiedzi",
			colBull: "Byczy",
			colPrz: "PRZ",
			colSR: "Kluczowe poziomy",
			dirFilter: "Filtr kierunku",
			enClassics: "Wykrywaj formacje klasyczne",
			enDoubles: "Podwójny szczyt / dno",
			enHS: "Głowa z ramionami",
			enTriples: "Potrójny szczyt / dno",
			fillTransp: "Przezroczystość wypełnienia formacji",
			formingLife: "Czas życia strefy tworzenia (świece)",
			keepFailed: "Zachowaj zatrzymane formacje na wykresie (✕, przyciemnione)",
			keepSuccessful: "Zachowaj udane formacje na wykresie (✓)",
			maxPatterns: "Maks. formacji na wykresie",
			minScore: "Minimalna ocena jakości",
			pivotDepth: "Głębokość bufora pivotów",
			showLetters: "Pokaż litery punktów X A B C D",
			showPlan: "Pokaż poziomy planu transakcji",
			showProjected: "Pokaż formacje prognozowane (tworzące się)",
			showRatios: "Pokaż proporcje na odcinkach",
			showSR: "Poziomy wsparcia/oporu",
			showStats: "Pokaż tabelę statystyk",
			srMinTouch: "S/R: minimalna liczba dotknięć pivotu",
			tolEdge: "Tolerancja na krawędzi zakresu",
			tolPoint: "Tolerancja proporcji punktów",
			useScale2: "Skanuj także skalę 2x (większe struktury)"
		},
		label: {
			confirmed: "potwierdzono",
			forming: "w tworzeniu",
			sl: "SL",
			target: "cel",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Zakończone",
			stops: "Stopy",
			t1Wins: "Trafione T1",
			winRate: "Skuteczność %"
		},
		tooltip: {
			colPrz: "Bursztynowa PRZ niezależnie od kierunku formacji (domyślnie w ProTrader).",
			fillTransp: "Niżej = bardziej widoczne wypełnienie. Dobrze sprawdza się około 65-80.",
			formingLife: "Tworząca się formacja, której punkt C jest starszy niż ta wartość i która nie została ukończona ani unieważniona, wygasa i jest usuwana.",
			maxPatterns: "Najstarsze formacje są usuwane jako pierwsze, więc najnowsza historia (✓ / ✕) i świeże strefy tworzenia zawsze pozostają widoczne.",
			showProjected: "Rysuje strukturę X-A-B z przerywaną linią pomocniczą do prognozowanej PRZ.",
			showRatios: "Kropkowane przekątne pomiarowe (X-B, A-C, B-D, X-D) ze zmierzoną proporcją Fibonacciego w środku każdej z nich, standardowe oznaczenie wykresów harmonicznych.",
			tolPoint: "Dotyczy dokładnych proporcji, np. Gartley B=0.618. Ścisła = 0.03, zrównoważona = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ ZAMKNIJ WSZYSTKO",
		duplicateRemoved: "Na jednym wykresie obsługiwany jest tylko jeden wskaźnik Trade Finder — duplikat został usunięty.",
		durationHm: "{{h}} g {{m}} min",
		durationM: "{{m}} min",
		emaEntry1: "EMA Wejście 1",
		emaEntry2: "EMA Wejście 2 / Trend",
		emaRangeFilter: "EMA Filtr zakresu",
		emaTrigger: "EMA Wyzwalacz",
		entry1: "Wejście 1",
		entry2: "Wejście 2",
		entry2Mark: "E2",
		entryZoneBear: "Strefa wejścia {{n}} (niedźwiedzia)",
		entryZoneBull: "Strefa wejścia {{n}} (bycza)",
		frameFailed: "Nie udało się wczytać interwału {{frame}} — nastąpi ponowna próba.",
		framesUnavailable: "Brak danych interwałów · czekaj",
		ghostEntry: "Poprzedni układ",
		ghostStop: "Poprzedni stop",
		group: {
			bias: "Nastawienie",
			display: "Wyświetlanie",
			emaSystem: "System EMA",
			entries: "Wejścia",
			filter: "Filtr",
			riskManagement: "Zarządzanie ryzykiem",
			session: "Sesja",
			supportResistance: "Wsparcie i opór",
			trailingStop: "Stop kroczący",
			trendPanel: "Panel trendu"
		},
		input: {
			adxLen: "Długość ADX",
			adxSmoothing: "Wygładzanie ADX",
			asiaSession: "Sesja azjatycka / tokijska (UTC)",
			atrBufferMultBtc: "Bufor stopu za swingiem — BTC (× ATR)",
			atrBufferMultGold: "Bufor stopu za swingiem — złoto (× ATR)",
			atrBufferMultOther: "Bufor stopu za swingiem — pozostałe (× ATR)",
			atrLength: "Długość ATR (zarządzanie ryzykiem)",
			atrSlMult: "Stop loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Złoto: próg rentowności po tylu punktach",
			biasEmaLen: "Długość EMA nastawienia",
			crossLookback: "Okno przecięć nastawienia (słupki)",
			dxySymbol: "Symbol indeksu dolara (puste = wyłączone)",
			emaBigLen: "Długość EMA Filtr zakresu",
			emaFastLen: "Długość EMA Wejście 1",
			emaMidLen: "Długość EMA Wejście 2 / Trend",
			emaTriggerLen: "Długość EMA Wyzwalacz",
			feeBufferPct: "Bufor na prowizje powyżej progu rentowności (%)",
			flatThreshPct: "Próg płaskości (% EMA nastawienia)",
			londonSession: "Sesja londyńska (UTC)",
			maxCrosses: "Maks. przecięć, zanim nastawienie zostanie odrzucone",
			newYorkSession: "Sesja nowojorska (UTC)",
			showEmaLabels: "Pokaż etykiety z nazwami EMA",
			showEntrySignals: "Pokaż znaczniki układu",
			showEntryZone: "Pokaż strefę wejścia",
			showSRLines: "Pokaż wsparcie i opór",
			showTradeLevels: "Pokaż poziomy wejścia, stopu i celów",
			slMaxPointsBtc: "Maksymalny dystans stopu — BTC (punkty)",
			slMaxPointsGold: "Maksymalny dystans stopu — złoto (punkty)",
			slMaxPointsIndex: "Maksymalny dystans stopu — indeksy (punkty)",
			slMaxPointsOther: "Maksymalny dystans stopu — pozostałe (punkty)",
			slMinPointsGold: "Minimalny dystans stopu — złoto (punkty)",
			slopeLookback: "Okno nachylenia nastawienia (słupki)",
			srLeftBars: "Wsparcie / opór · słupki na lewo od pivotu",
			srRightBars: "Wsparcie / opór · słupki na prawo od pivotu",
			swingPivotLen: "Długość pivotu swingu (stop loss)",
			tp1ClosePct: "Zamknięcie na TP1 %",
			tp2ClosePct: "Zamknięcie na TP2 %",
			tp5CloseAlways: "TP5 zawsze zamyka, nawet przy stopie kroczącym",
			tpR: "TP{{n}} (w R)",
			tpSlMode: "Tryb stopu i celów",
			trailAtrMult: "Dystans stopu kroczącego (× ATR)",
			trendPanelEmaLen: "Długość EMA wiersza trendu",
			trendSlopeLB: "Okno nachylenia EMA Wejście 2 (świece)",
			useAdxFilter: "Wymagaj ADX powyżej progu trybu",
			useBiasFilter: "Punktuj nastawienie wyższego interwału (nigdy nie blokuje)",
			useEmaStackCheck: "Wymagaj ułożenia EMA w kolejności",
			useInstrumentAutoDetect: "Wykrywaj instrument automatycznie",
			useSessionFilter: "Sygnały tylko podczas sesji giełdowych",
			useSlopeDynamic: "Dopasuj okno nachylenia do interwału",
			useStrictCandle: "Ścisły filtr świecy (knot i zamknięcie)",
			useTrailingStop: "Stop kroczący (od TP1)",
			useVolumeConfirm: "Wymagaj wolumenu powyżej średniej przy wejściu",
			volAvgLen: "Długość średniej wolumenu",
			volMultiplier: "Minimalny wolumen (× średnia)"
		},
		maxStop: "Maks. SL",
		minuteAgainst: "Przecięcie przeciw setupowi",
		minuteOk: "Brak ostrzeżeń",
		minuteReversal: "Przecięcie · możliwy zwrot",
		modeAtr: "ATR",
		modeAuto: "Automatycznie",
		modeRiskReward: "Ryzyko / zysk",
		noBias: "Brak nastawienia",
		noSetup: "Brak aktywnego układu",
		recentTitle: "Ostatnie układy",
		reEntry: "Ponowne wejście",
		reEntryMark: "RE",
		rest: "RESZTA",
		rowBias: "Bias",
		rowContext: "Kontekst",
		rowInfo: "Info",
		rowSession: "Sesja",
		rowSetup: "Układ",
		rowVolume: "Wolumen",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "koniec za {{time}}",
		sessionOutside: "Poza godzinami · Londyn {{time}} UTC",
		sessionOverlap: "Nakładanie",
		statsTitle: "Ostatnie {{n}} układów",
		statusBreakEvenSet: "Bez straty",
		statusMoveToBreakEven: "Przesuń stop",
		statusPending: "Dotyk strefy",
		statusRunning: "W toku",
		statusSpike: "Zmienność · pauza",
		statusWaiting: "Oczekiwanie",
		stopHit: "Stop trafiony",
		styleDaytrade: "Day trading",
		styleScalping: "Skalpowanie",
		styleSwing: "Swing",
		subFrameReversal: "Niższy interwał się odwraca",
		targetHit: "Osiągnięto cel końcowy",
		trailStop: "Stop kroczący",
		volAboveAverage: "powyżej średniej",
		volBelowAverage: "poniżej średniej",
		zoneEdgeBear: "Krawędź strefy {{n}} (niedźwiedzia)",
		zoneEdgeBull: "Krawędź strefy {{n}} (bycza)"
	},
	tradingSessions: "Sesje handlowe",
	unintendedSymbol: "Ta strategia jest przeznaczona dla {{symbols}} — na {{symbol}} jej poziomy mogą nic nie znaczyć.",
	utBotAlerts: "Alerty UT Bot"
}, ye = {
	asia: "Ásia",
	atrPeriod: "Período ATR",
	auraScanner: {
		guide: {
			bigDiamondMark: "Grande vermelho/verde",
			bigDiamondMeaning: "Um losango vermelho grande acima de um máximo alerta para o risco de comprar. Um verde grande abaixo de um mínimo, para o risco de vender.",
			blueMark: "Curva azul",
			blueMeaning: "50 EMA. Rosa acima do azul indica compra; abaixo, venda.",
			dashedMark: "Linhas tracejadas",
			dashedMeaning: "Suporte e resistência. Vermelhas abaixo do preço, verdes acima.",
			diamondsMark: "Losangos",
			diamondsMeaning: "Pontos de inversão. Dourados são os mais fracos, depois azuis, vermelhos e verdes.",
			flatGoldMark: "Dourada horizontal",
			flatGoldMeaning: "O nível de maior volume das últimas seis horas no gráfico de 15 minutos.",
			levelsMark: "Linhas de níveis",
			levelsMeaning: "Entrada, proteção e objetivos da última operação. Um visto indica que foi atingido.",
			pinkMark: "Curva rosa",
			pinkMeaning: "20 EMA. O cruzamento com a azul gera um sinal.",
			subtitle: "Como ler este gráfico",
			thickGoldMark: "Dourada grossa",
			thickGoldMeaning: "A 238. Se estiver entre a entrada e o objetivo, ignore a operação.",
			title: "AURA",
			triangleMark: "Triângulo",
			triangleMeaning: "Uma operação que passou todas as verificações. Passe o cursor para ver os valores."
		},
		groups: {
			display: "Apresentação",
			eightChecks: "As oito verificações",
			riskAndTargets: "Risco e objetivos",
			signalEngine: "Motor de sinais"
		},
		inputs: {
			emaFastLen: "Linha rápida (rosa)",
			emaSlowLen: "Linha lenta (azul)",
			f1Clock: "1. Apenas na janela de bom volume",
			f2Trend: "2. A favor da tendência de 15 minutos",
			f3Mode: "3. Vela da cor errada",
			f4Min: "Afastamento mínimo (pips por vela)",
			f4Sep: "4. Linhas a afastarem-se",
			f5Clear: "5. 238 fora do percurso entrada–objetivo",
			f6R: "Espaço mínimo (× risco)",
			f6Reward: "6. Espaço até ao próximo nível",
			f7Bars: "Nas últimas (velas)",
			f7Consol: "7. Fora de uma zona de consolidação",
			f7Pips: "A amplitude deve ultrapassar (pips)",
			f9Bars: "Nas últimas N velas",
			f9Star: "8. Sem losango grande de aviso",
			guidePos: "Posição do guia",
			longMode: "Modo da linha de segurança (238)",
			panelSize: "Tamanho do texto dos painéis",
			pipIn: "Tamanho do pip (0 = automático)",
			showClock: "Painel da situação atual",
			showGuide: "Guia dos símbolos",
			showLadder: "Níveis da operação à direita",
			showPoc: "Linha de volume",
			showSr: "Níveis tracejados",
			showStars: "Losangos de aviso",
			showTable: "Tabela de tendências",
			showTint: "Cor de fundo",
			showWhy: "Explicar sinais ignorados",
			slMinPips: "Distância mínima além da linha lenta (pips)",
			srAtrMove: "Níveis: ressalto necessário (× tamanho habitual da vela)",
			srLookback: "Níveis: histórico de inversões",
			srMax: "Máximo de níveis no ecrã",
			srRange: "Ignorar níveis além de (× tamanho habitual da vela)",
			srReset: "Níveis: novos testes antes da remoção",
			stripLen: "Largura da coluna direita (velas)",
			tablePos: "Posição do painel atual",
			theme: "Tema do gráfico",
			tp1R: "TP1 (múltiplo de R)",
			tp2R: "TP2 (múltiplo de R)",
			trendPos: "Posição da tabela de tendências",
			tz: "Fuso horário das janelas de negociação"
		},
		ladder: {
			closedAtStop: "FECHADA por proteção",
			closedAtTarget: "FECHADA TP{{hit}}",
			entry: "ENTRADA",
			stop: "PROTEÇÃO",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Escala automática",
			bottomCentre: "Em baixo ao centro",
			bottomLeft: "Em baixo à esquerda",
			bottomRight: "Em baixo à direita",
			dark: "Escuro",
			ignore: "Ignorar",
			large: "Grande",
			light: "Claro",
			literal238: "Valor fixo 238",
			middleCentre: "Ao centro",
			middleLeft: "Ao meio à esquerda",
			middleRight: "Ao meio à direita",
			normal: "Padrão",
			reject: "Rejeitar",
			small: "Pequeno",
			topCentre: "Em cima ao centro",
			topLeft: "Em cima à esquerda",
			topRight: "Em cima à direita",
			waitForPullback: "Esperar recuo"
		},
		reasons: {
			clock: "fora da janela de negociação",
			diamond: "acabou de aparecer um losango grande de aviso",
			range: "o gráfico está preso numa consolidação",
			room: "um nível está demasiado perto, sem espaço até ao objetivo",
			safetyLine: "a 238 está entre a entrada e o objetivo",
			separation: "as linhas estão demasiado próximas, ainda sem espaço para avançar",
			trend: "contra a tendência de 15 minutos",
			wrongColour: "a vela do cruzamento fechou com a cor errada"
		},
		rightNow: {
			aBuy: "Compra",
			aSell: "Venda",
			bestBuysOnly: "procurar apenas compras",
			bestNow: "Agora é melhor",
			bestSellsOnly: "procurar apenas vendas",
			bestWaitThin: "esperar, volume baixo",
			goodVolume: "Bom volume",
			lowVolume: "Volume baixo",
			safetyAbove: "238 acima do preço, espaço para vendas",
			safetyBelow: "238 abaixo do preço, espaço para compras",
			safetyLine: "Linha de segurança",
			skipped: "Ignorado",
			skippedAgo_one: "{{side}} há {{bars}} vela: {{reason}}",
			skippedAgo_other: "{{side}} há {{bars}} velas: {{reason}}",
			skippedNothing: "ainda nada foi ignorado",
			title: "NESTE MOMENTO",
			trend: "Tendência",
			trendSummaryDown: "15m em queda, {{agree}} de 6 períodos em alta",
			trendSummaryUp: "15m em alta, {{agree}} de 6 períodos em alta",
			skippedAgo_many: "{{side}} há {{bars}} velas: {{reason}}"
		},
		signal: {
			buy: "COMPRA",
			pips: "pips",
			sell: "VENDA",
			stop: "Proteção"
		},
		tooltip: {
			f3Mode: "Uma compra numa vela vermelha ou uma venda numa azul nunca é executada diretamente. Esperar recuo aguarda que o preço regresse às linhas numa vela da cor certa. Rejeitar descarta o sinal.",
			f4Min: "A rapidez com que as linhas se afastam na vela do sinal. Linhas planas e entrelaçadas não deixam espaço para avançar.",
			f6Reward: "O próximo nível tracejado deve estar pelo menos a esta distância. Desligado por predefinição: o scanner traça os níveis com o seu próprio método, por isso confirme também o espaço visualmente.",
			f7Pips: "Evite consolidações de 100 pips ou menos.",
			longMode: "238 é a definição padrão para gráficos de um minuto. A escala automática adapta a linha de segurança a outros períodos, cerca de 83 num gráfico de três minutos.",
			pipIn: "Automático: 0.10 no ouro e dez ticks nos restantes instrumentos (1 ponto no US30).",
			showGuide: "Uma legenda breve no gráfico. Desative-a quando conhecer os símbolos.",
			showLadder: "A entrada, a proteção e os objetivos da última operação são desenhados à direita da última vela. Os objetivos atingidos ficam assinalados.",
			showWhy: "Quando as linhas se cruzam mas uma verificação impede a operação, o painel atual indica qual e porquê.",
			slMinPips: "A proteção fica do outro lado das linhas vermelha e azul, a pelo menos 10 pips da azul.",
			srMax: "Mantêm-se apenas os níveis mais próximos do preço para o gráfico continuar legível.",
			theme: "Escolha o mesmo tema do TradingView para distinguir bem todas as cores.",
			tz: "As janelas de negociação usam este fuso horário. America/Denver corresponde à hora das Montanhas Rochosas com horário de verão. Use America/Phoenix para essa hora sem mudanças sazonais."
		},
		trendTable: {
			above: "acima",
			below: "abaixo",
			down: "Em queda",
			notAvailable: "indisponível",
			up: "Em alta",
			volumeLine: "Linha de volume"
		}
	},
	bearish: "Baixista",
	bfs: {
		duplicateRemoved: "É suportado apenas um indicador BFS — Blessed Flow System por gráfico; o duplicado foi removido.",
		emaCrossSoon: "EMA30/50 prestes a cruzar",
		engineOff: "mude para M1",
		engineOn: "motor M1",
		input: {
			armWin: "Janela (candles M1) para tocar a EMA30",
			asiaSess: "Ásia (HHMM-HHMM)",
			bePts: "BE: a +pontos o stop vai PARA esse nível",
			cooldown: "Espera (candles M1) após o encerramento de uma operação",
			lenFast: "EMA rápida (direção)",
			lenH1a: "H1 · EMA curta",
			lenH1b: "H1 · EMA longa",
			lenMid: "EMA média",
			lenSlow: "EMA lenta",
			londonSess: "Londres (HHMM-HHMM, relógio da sessão)",
			maxPerBlock: "Máximo de entradas por bloco de sessão (0 = sem limite)",
			nearLb: "Candles usados para medir a convergência",
			nearPts: "Distância máxima EMA30-EMA50 (pontos)",
			nySess: "Nova York (HHMM-HHMM)",
			onlyM1: "Executar o motor somente em M1",
			pv: "Valor em preço de 1 ponto",
			r1lb: "R1 · candles M1 analisados (preço não estendido)",
			rr: "Razão de TP R:R (sem a escada)",
			rsiHi: "RSI >= para SHORT",
			rsiLen: "Comprimento do RSI",
			rsiLo: "RSI <= para LONG",
			rsiWin: "Janela de espera (candles após o sinal)",
			showLevels: "Desenhar os níveis da operação",
			showNear: "Marcar quando a EMA30 estiver prestes a cruzar a EMA50",
			slPts: "SL (pontos)",
			swLenA: "Força do pivô (candles de cada lado)",
			tp1Pts: "TP1 (pontos)",
			tp2Pts: "TP2 (pontos)",
			tp3Pts: "TP3 (pontos)",
			tzOffset: "Deslocamento UTC do relógio da sessão (Bogotá = -5)",
			useArm: "Exigir retração de 50% e toque na EMA30 dentro da janela",
			useAsia: "Incluir a Ásia (apenas testes)",
			useBE: "Ponto de equilíbrio ativo",
			useLadder: "Usar TP1/TP2/TP3 (saída final = TP3)",
			useR2: "R2 · exigir ordem M5 + M15 e viés H1",
			useRSI: "Aguardar o RSI depois do sinal",
			useSess: "Filtrar por sessão",
			useTrend: "Manter a ordem das EMAs durante a espera"
		},
		longSignal: "Sinal de long",
		noSignal: "sem sinal",
		retracementDot: "Ponto no retração de 50%",
		rewardZone: "Zona de ganho",
		riskZone: "Zona de risco",
		session: "Sessão",
		sessionClosed: "fechada",
		sessionOpen: "aberta",
		shortSignal: "Sinal de short",
		signal: "Sinal",
		signalActive: "{{side}} em andamento",
		waitingRsi: "aguardando o RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Aguardando o RSI (long)",
		waitingRsiShort: "Aguardando o RSI (short)"
	},
	breakEven: "Ponto de equilíbrio",
	bullish: "Altista",
	buy: "Compra",
	colour: "Cor",
	cypher: {
		above55: "Acima de 55",
		aboveBelow: "Acima/Abaixo",
		barColors: "Cores das barras",
		bbLength: "Comprimento BB",
		bbStdDev: "Desvio padrão BB {{n}}",
		bearBreak: "Rompimento baixista",
		bearPattern: "Pin bar / engolfo baixista",
		below55: "Abaixo de 55",
		bullBreak: "Rompimento altista",
		bullPattern: "Pin bar / engolfo altista",
		cmoLength: "Comprimento CMO",
		colorCandles: "Colorir velas",
		confluenceLong: "Confluência Long",
		confluenceShort: "Confluência Short",
		consolidating: "Consolidação",
		direction: "Direção",
		emaPeriodTrend: "Período EMA (tendência)",
		flagOffsetAtr: "Deslocamento da bandeira (x ATR)",
		flashBackground: "Fundo do flash",
		flashCount: "Número de flashes",
		flashHz: "Velocidade do flash (piscadas / s)",
		flashOn: "Piscar em novo sinal",
		flashShowBanner: "Mostrar banner NEW BUY / SELL",
		flashShowBg: "Piscar o fundo do gráfico",
		flashStrength: "Intensidade do flash de fundo",
		flashTest: "Testar flash agora (prévia)",
		fvgKeep: "Fair Value Gaps mantidos por lado",
		glowOpacity: "Opacidade do brilho (maior = mais transparente)",
		glowSizeTicks: "Tamanho do brilho (ticks)",
		groupFlash: "Alerta de novo sinal",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "Níveis KDE",
		groupKeyLevels: "Níveis-chave",
		groupLrEma: "Canal LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivôs",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Bandas de reversão",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Componentes",
		groupTrendTable: "Tabela de tendência",
		groupVidya: "VIDYA / Tendência",
		halfTrendAmplitude: "Amplitude HalfTrend",
		halfTrendChannelDeviation: "Desvio do canal HalfTrend",
		ichimokuBase: "Linha base Ichimoku",
		ichimokuConversion: "Linha de conversão Ichimoku",
		kdeActivation: "Ativar limite de ativação",
		kdeBins: "Número de faixas",
		kdeThreshold: "Limite %",
		labelPosition: "Posição do rótulo",
		lineWidth: "Espessura da linha",
		lowerBb: "BB{{n}} inferior",
		lowerInnerZone: "Zona interna inferior",
		lowerReversalZone: "Zona de reversão inferior",
		maCloudLong: "Nuvem MA (longa)",
		maCloudShort: "Nuvem MA (curta)",
		newBuy: "NOVA COMPRA",
		newSell: "NOVA VENDA",
		numberOfLevels: "Número de níveis",
		parabolicSar: "SAR parabólico",
		pivotAuto: "Auto",
		pivotDaily: "Diário",
		pivotMonthly: "Mensal",
		pivotsTimeframe: "Tempo gráfico dos pivôs",
		pivotWeekly: "Semanal",
		positionBottomCenter: "Inferior central",
		positionBottomLeft: "Inferior esquerdo",
		positionBottomRight: "Inferior direito",
		positionLeft: "Esquerda",
		positionRight: "Direita",
		positionTopCenter: "Superior central",
		positionTopLeft: "Superior esquerdo",
		positionTopRight: "Superior direito",
		psarBear: "PSAR baixista",
		psarBull: "PSAR altista",
		psarIncrement: "Incremento PSAR",
		psarMax: "Máximo PSAR",
		psarStart: "Início PSAR",
		pullingBack: "Recuo",
		pulseSmoothingBars: "Barras de suavização Pulse",
		reEntry: "Reentrada",
		rightOffsetBars: "Deslocamento à direita (barras)",
		showCamarillaPivots: "Mostrar pivôs Camarilla",
		showConfluenceFlag: "Mostrar bandeira de confluência (B/S)",
		showFvg: "Fair Value Gaps (15m ou mais)",
		showKde: "Níveis de volume KDE",
		showKeyLevels: "Mostrar níveis-chave",
		showLabels: "Mostrar rótulos",
		showLevelGlow: "Mostrar brilho dos níveis",
		showMaCloud: "Mostrar nuvem MA",
		showPrices: "Mostrar preços",
		showPsar: "Mostrar PSAR",
		showReversalBands: "Mostrar bandas de reversão",
		showSlTpLabels: "Mostrar rótulos SL / TP",
		showSniperBreakArrows: "Mostrar setas Sniper / de rompimento",
		showTrendTable: "Mostrar tabela de tendência",
		showVidya233: "Mostrar VIDYA 233",
		showVidya55: "Mostrar VIDYA 55",
		showVidya987: "Mostrar VIDYA 987 (ímã)",
		showVidyaLines: "Mostrar linhas VIDYA",
		sizeNormal: "Normal",
		sizeSmall: "Pequeno",
		sizeTiny: "Minúsculo",
		slBufferAtr: "SL: margem máxima (x ATR)",
		slBufferPips: "SL: margem além do swing (pips)",
		slMaxRiskAtr: "SL: risco máximo (x ATR)",
		slSwingLookback: "SL: retrospectiva do swing (barras)",
		sniperDown: "Sniper para baixo",
		sniperUp: "Sniper para cima",
		source: "Fonte",
		state: "Estado",
		strength: "Força",
		strong: "Forte",
		superTrend2AtrLength: "Comprimento ATR SuperTrend 2",
		superTrend2Factor: "Fator SuperTrend 2",
		superTrendAtrLength: "Comprimento ATR SuperTrend",
		superTrendMultiplier: "Multiplicador SuperTrend",
		tablePosition: "Posição da tabela",
		tableSize: "Tamanho da tabela",
		tpRiskReward: "TP {{n}} risco/retorno",
		tradeManagement: "Gestão de operações (SL / TP)",
		trend: "Tendência",
		trending: "Em tendência",
		upperBb: "BB{{n}} superior",
		upperInnerZone: "Zona interna superior",
		upperReversalZone: "Zona de reversão superior",
		veryStrong: "Muito forte",
		veryWeak: "Muito fraca",
		vidya987Magnet: "VIDYA 987 (ímã)",
		volumeAvgLength: "Comprimento da média de volume (filtro de rompimento)",
		weak: "Fraca",
		zoneEdge: "{{name}} (borda do preenchimento)"
	},
	entry: "Entrada",
	gainColor: "Cor do Ganho",
	harsiCandle: "Candle HARSI",
	harsiLength: "Comprimento HARSI",
	heikinAshiRsiOscillator: "Oscilador RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "Valor-chave 'Isto altera a sensibilidade'",
	labelsIndicator: "Indicador de Rótulos",
	london: "Londres",
	londonBackground: "Fundo de Londres",
	londonSession: "Sessão de Londres",
	long: "Long",
	lossColor: "Cor da Perda",
	median: "Mediana",
	neutral: "Neutro",
	newYork: "Nova Iorque",
	newYorkBackground: "Fundo de Nova Iorque",
	newYorkSession: "Sessão de Nova Iorque",
	openSmoothing: "Suavização de Abertura",
	optimus: {
		activeTradeLevels: "Operação ativa · níveis",
		bias: "Viés",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "MISTO {{n}}/{{total}}",
		disclaimer: "Os níveis estão desenhados no gráfico. Não é recomendação de investimento.",
		duplicateRemoved: "É suportado apenas um indicador Optimus Prime por gráfico; o duplicado foi removido.",
		enter: "ENTRAR · {{side}}",
		input: {
			atrLength: "Comprimento do ATR do KC",
			buffer: "Margem do swing (em preço)",
			emaLength: "Comprimento da EMA",
			kcLength: "Comprimento do KC",
			kcMult: "Multiplicador do KC",
			lrcLength: "Comprimento do LRC",
			minRisk: "Risco R mínimo (em preço)",
			requireAlign: "Exigir EMA e LRC alinhados",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Candles analisados do swing (R)"
		},
		kcLower: "KC inferior",
		kcMid: "KC médio",
		kcUpper: "KC superior",
		keltnerFill: "Preenchimento de Keltner",
		noClosedTrades: "Nenhuma operação encerrada ainda",
		reasonForming: "Setup se formando — falta confirmação",
		reasonLatched: "Operação travada · níveis no gráfico",
		reasonNoSetup: "Sem setup · EMA/LRC não alinhados",
		recentSignals: "Sinais recentes",
		riskReward: "RISCO/GANHO",
		trendMtf: "Tendência · vários tempos gráficos",
		wait: "AGUARDAR",
		warmingUp: "INICIANDO"
	},
	overbought: "Sobrecomprado",
	overboughtMax: "Sobrecompra Máx",
	overboughtMin: "Sobrecompra Mín",
	oversold: "Sobrevendido",
	oversoldMax: "Sobrevenda Máx",
	oversoldMin: "Sobrevenda Mín",
	rsiLength: "Comprimento RSI",
	rsiLine: "Linha RSI",
	rsiLineShadow: "Sombra da Linha RSI",
	sell: "Venda",
	short: "Short",
	signalsFromHeikinAshiCandles: "Sinais das Velas Heikin Ashi",
	sl: "SL",
	smoothedMode: "Modo Suavizado",
	sydney: "Sydney",
	sydneyBackground: "Fundo de Sydney",
	sydneySession: "Sessão de Sydney",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tóquio",
	tokyoBackground: "Fundo de Tóquio",
	tokyoSession: "Sessão de Tóquio",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "baixista",
			bullish: "altista",
			confluence: "confluência",
			entry: "entrada",
			neckline: "linha de pescoço",
			score: "pontuação",
			state: "estado",
			states: {
				completed: "concluído",
				invalidated: "invalidado",
				projected: "projetado",
				przActive: "PRZ ativa",
				stopped: "stop atingido"
			},
			stop: "stop",
			target: "alvo"
		},
		classic: {
			doubleBottom: "Fundo duplo",
			doubleTop: "Topo duplo",
			headAndShoulders: "Ombro-Cabeça-Ombro",
			inverseHeadAndShoulders: "OCO inv.",
			tripleBottom: "Fundo triplo",
			tripleTop: "Topo triplo"
		},
		direction: {
			bearishOnly: "Somente baixista",
			both: "Ambos",
			bullishOnly: "Somente altista"
		},
		group: {
			classics: "Padrões clássicos e S/R",
			filters: "Filtros e exibição",
			patterns: "Padrões",
			pivotEngine: "Motor de pivôs",
			ratios: "Proporções e tolerância"
		},
		input: {
			atrLen: "Período do ATR",
			atrMult: "Reversão do zigzag (x ATR)",
			colBear: "Baixista",
			colBull: "Altista",
			colPrz: "PRZ",
			colSR: "Níveis-chave",
			dirFilter: "Filtro de direção",
			enClassics: "Detectar padrões clássicos",
			enDoubles: "Topo / Fundo duplo",
			enHS: "Ombro-Cabeça-Ombro",
			enTriples: "Topo / Fundo triplo",
			fillTransp: "Transparência do preenchimento do padrão",
			formingLife: "Duração da zona em formação (barras)",
			keepFailed: "Manter no gráfico os padrões stopados (✕, esmaecidos)",
			keepSuccessful: "Manter no gráfico os padrões bem-sucedidos (✓)",
			maxPatterns: "Máx. de padrões no gráfico",
			minScore: "Pontuação mínima de qualidade",
			pivotDepth: "Profundidade do buffer de pivôs",
			showLetters: "Mostrar letras dos pontos X A B C D",
			showPlan: "Mostrar níveis do plano de trade",
			showProjected: "Mostrar padrões projetados (em formação)",
			showRatios: "Mostrar proporções nas pernas",
			showSR: "Níveis de suporte/resistência",
			showStats: "Mostrar tabela de estatísticas",
			srMinTouch: "S/R: mínimo de toques no pivô",
			tolEdge: "Tolerância na borda do intervalo",
			tolPoint: "Tolerância das proporções dos pontos",
			useScale2: "Escanear também a escala 2x (estruturas maiores)"
		},
		label: {
			confirmed: "confirmado",
			forming: "em formação",
			sl: "SL",
			target: "alvo",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Concluídos",
			stops: "Stops",
			t1Wins: "T1 atingidos",
			winRate: "Acerto %"
		},
		tooltip: {
			colPrz: "PRZ em âmbar independentemente da direção do padrão (predefinição do ProTrader).",
			fillTransp: "Menor = preenchimento mais visível. Entre 65 e 80 funciona bem.",
			formingLife: "Um padrão em formação cujo ponto C é mais antigo do que este valor, sem se completar nem ser invalidado, expira e é removido.",
			maxPatterns: "Os padrões mais antigos são removidos primeiro, para que o histórico recente (✓ / ✕) e as zonas em formação recentes fiquem sempre visíveis.",
			showProjected: "Desenha a estrutura X-A-B com uma guia tracejada até à PRZ projetada.",
			showRatios: "Diagonais de medição pontilhadas (X-B, A-C, B-D, X-D) com a proporção de Fibonacci medida no ponto médio de cada uma, a anotação padrão dos gráficos harmónicos.",
			tolPoint: "Aplica-se a proporções exatas como Gartley B=0.618. Rigoroso = 0.03, equilibrado = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ FECHAR TUDO",
		duplicateRemoved: "É suportado apenas um indicador Trade Finder por gráfico; o duplicado foi removido.",
		durationHm: "{{h}} h {{m}} min",
		durationM: "{{m}} min",
		emaEntry1: "EMA Entrada 1",
		emaEntry2: "EMA Entrada 2 / Tendência",
		emaRangeFilter: "EMA Filtro de intervalo",
		emaTrigger: "EMA Gatilho",
		entry1: "Entrada 1",
		entry2: "Entrada 2",
		entry2Mark: "E2",
		entryZoneBear: "Zona de entrada {{n}} (baixista)",
		entryZoneBull: "Zona de entrada {{n}} (altista)",
		frameFailed: "Não foi possível carregar o tempo gráfico {{frame}}; será tentado novamente.",
		framesUnavailable: "Sem dados de tempos · aguardar",
		ghostEntry: "Setup anterior",
		ghostStop: "Stop anterior",
		group: {
			bias: "Viés",
			display: "Exibição",
			emaSystem: "Sistema de EMA",
			entries: "Entradas",
			filter: "Filtro",
			riskManagement: "Gestão de risco",
			session: "Sessão",
			supportResistance: "Suporte e resistência",
			trailingStop: "Stop móvel",
			trendPanel: "Painel de tendência"
		},
		input: {
			adxLen: "Comprimento do ADX",
			adxSmoothing: "Suavização do ADX",
			asiaSession: "Sessão da Ásia / Tóquio (UTC)",
			atrBufferMultBtc: "Margem do stop atrás do swing — BTC (× ATR)",
			atrBufferMultGold: "Margem do stop atrás do swing — ouro (× ATR)",
			atrBufferMultOther: "Margem do stop atrás do swing — outros (× ATR)",
			atrLength: "Comprimento do ATR (gestão de risco)",
			atrSlMult: "Stop loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Ouro: ponto de equilíbrio após estes pontos",
			biasEmaLen: "Comprimento da EMA do viés",
			crossLookback: "Janela de cruzamentos do viés (barras)",
			dxySymbol: "Símbolo do índice do dólar (vazio desativa)",
			emaBigLen: "Comprimento do EMA Filtro de intervalo",
			emaFastLen: "Comprimento do EMA Entrada 1",
			emaMidLen: "Comprimento do EMA Entrada 2 / Tendência",
			emaTriggerLen: "Comprimento do EMA Gatilho",
			feeBufferPct: "Margem de taxas acima do ponto de equilíbrio (%)",
			flatThreshPct: "Limiar de lateralidade (% da EMA do viés)",
			londonSession: "Sessão de Londres (UTC)",
			maxCrosses: "Máx. de cruzamentos antes de descartar o viés",
			newYorkSession: "Sessão de Nova York (UTC)",
			showEmaLabels: "Mostrar etiquetas com o nome das EMA",
			showEntrySignals: "Mostrar marcadores de configuração",
			showEntryZone: "Mostrar a zona de entrada",
			showSRLines: "Mostrar suporte e resistência",
			showTradeLevels: "Mostrar níveis de entrada, stop e alvo",
			slMaxPointsBtc: "Distância máxima do stop — BTC (pontos)",
			slMaxPointsGold: "Distância máxima do stop — ouro (pontos)",
			slMaxPointsIndex: "Distância máxima do stop — índices (pontos)",
			slMaxPointsOther: "Distância máxima do stop — outros (pontos)",
			slMinPointsGold: "Distância mínima do stop — ouro (pontos)",
			slopeLookback: "Janela de inclinação do viés (barras)",
			srLeftBars: "Suporte / resistência · barras à esquerda do pivô",
			srRightBars: "Suporte / resistência · barras à direita do pivô",
			swingPivotLen: "Comprimento do pivô de swing (stop loss)",
			tp1ClosePct: "Fechar no TP1 %",
			tp2ClosePct: "Fechar no TP2 %",
			tp5CloseAlways: "O TP5 fecha sempre, mesmo com stop móvel",
			tpR: "TP{{n}} (em R)",
			tpSlMode: "Modo de stop e alvos",
			trailAtrMult: "Distância do stop móvel (× ATR)",
			trendPanelEmaLen: "Comprimento da EMA da linha de tendência",
			trendSlopeLB: "Retrospetiva da inclinação de EMA Entrada 2 (barras)",
			useAdxFilter: "Exigir ADX acima do limiar do modo",
			useBiasFilter: "Pontuar o viés superior (nunca bloqueia a entrada)",
			useEmaStackCheck: "Exigir que as EMA estejam ordenadas",
			useInstrumentAutoDetect: "Detetar o instrumento automaticamente",
			useSessionFilter: "Sinais apenas durante as sessões de negociação",
			useSlopeDynamic: "Ajustar a retrospetiva da inclinação ao período",
			useStrictCandle: "Filtro de vela rigoroso (pavio e fecho)",
			useTrailingStop: "Stop móvel (a partir do TP1)",
			useVolumeConfirm: "Exigir volume acima da média na entrada",
			volAvgLen: "Comprimento da média de volume",
			volMultiplier: "Volume mínimo (× média)"
		},
		maxStop: "SL máx.",
		minuteAgainst: "Cruzamento contra o setup",
		minuteOk: "Sem avisos",
		minuteReversal: "Cruzamento · reversão possível",
		modeAtr: "ATR",
		modeAuto: "Automático",
		modeRiskReward: "Risco / retorno",
		noBias: "Sem viés",
		noSetup: "Sem setup ativo",
		recentTitle: "Setups recentes",
		reEntry: "Reentrada",
		reEntryMark: "RE",
		rest: "RESTO",
		rowBias: "Viés",
		rowContext: "Contexto",
		rowInfo: "Info",
		rowSession: "Sessão",
		rowSetup: "Setup",
		rowVolume: "Volume",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "faltam {{time}}",
		sessionOutside: "Sem sessão · Londres {{time}} UTC",
		sessionOverlap: "Sobreposição",
		statsTitle: "Últimos {{n}} setups",
		statusBreakEvenSet: "Sem perda",
		statusMoveToBreakEven: "Mover o stop",
		statusPending: "Toque na zona",
		statusRunning: "Em curso",
		statusSpike: "Volátil · espera",
		statusWaiting: "Aguardando",
		stopHit: "Stop atingido",
		styleDaytrade: "Day trading",
		styleScalping: "Scalping",
		styleSwing: "Swing",
		subFrameReversal: "O período inferior está a virar",
		targetHit: "Alvo final atingido",
		trailStop: "Stop móvel",
		volAboveAverage: "acima da média",
		volBelowAverage: "abaixo da média",
		zoneEdgeBear: "Borda da zona {{n}} (baixista)",
		zoneEdgeBull: "Borda da zona {{n}} (altista)"
	},
	tradingSessions: "Sessões de negociação",
	unintendedSymbol: "Esta estratégia foi feita para {{symbols}}; em {{symbol}} os seus níveis podem não significar nada.",
	utBotAlerts: "Alertas UT Bot"
}, be = {
	asia: "Азия",
	atrPeriod: "Период ATR",
	auraScanner: /* @__PURE__ */ JSON.parse("{\"guide\":{\"bigDiamondMark\":\"Крупный красный/зелёный\",\"bigDiamondMeaning\":\"Крупный красный ромб над максимумом предостерегает от покупки. Крупный зелёный под минимумом — от продажи.\",\"blueMark\":\"Синяя кривая\",\"blueMeaning\":\"50 EMA. Розовая выше синей — покупка, ниже — продажа.\",\"dashedMark\":\"Пунктирные линии\",\"dashedMeaning\":\"Поддержка и сопротивление. Красные ниже цены, зелёные выше.\",\"diamondsMark\":\"Ромбы\",\"diamondsMeaning\":\"Точки разворота. Золотые самые слабые, затем синие, красные и зелёные.\",\"flatGoldMark\":\"Горизонтальная золотая\",\"flatGoldMeaning\":\"Уровень наибольшего объёма на 15-минутном графике за последние шесть часов.\",\"levelsMark\":\"Линии уровней\",\"levelsMeaning\":\"Вход, стоп и цели последней сделки. Галочка означает достижение.\",\"pinkMark\":\"Розовая кривая\",\"pinkMeaning\":\"20 EMA. Сигнал — её пересечение с синей линией.\",\"subtitle\":\"Как читать этот график\",\"thickGoldMark\":\"Толстая золотая\",\"thickGoldMeaning\":\"Линия 238. Если она между входом и целью, пропустите сделку.\",\"title\":\"AURA\",\"triangleMark\":\"Треугольник\",\"triangleMeaning\":\"Сделка, прошедшая все проверки. Наведите курсор, чтобы увидеть значения.\"},\"groups\":{\"display\":\"Отображение\",\"eightChecks\":\"Восемь проверок\",\"riskAndTargets\":\"Риск и цели\",\"signalEngine\":\"Механизм сигналов\"},\"inputs\":{\"emaFastLen\":\"Быстрая линия (розовая)\",\"emaSlowLen\":\"Медленная линия (синяя)\",\"f1Clock\":\"1. Только в часы хорошего объёма\",\"f2Trend\":\"2. По 15-минутному тренду\",\"f3Mode\":\"3. Свеча неподходящего цвета\",\"f4Min\":\"Минимальное расширение (пипсов за свечу)\",\"f4Sep\":\"4. Линии расходятся\",\"f5Clear\":\"5. 238 не между входом и целью\",\"f6R\":\"Минимальный запас (× риск)\",\"f6Reward\":\"6. Запас до следующего уровня\",\"f7Bars\":\"За последние (свечей)\",\"f7Consol\":\"7. Цена не зажата в диапазоне\",\"f7Pips\":\"Диапазон должен превышать (пипсов)\",\"f9Bars\":\"За последние N свечей\",\"f9Star\":\"8. Нет крупного предупреждающего ромба\",\"guidePos\":\"Положение памятки\",\"longMode\":\"Режим защитной линии (238)\",\"panelSize\":\"Размер текста панелей\",\"pipIn\":\"Размер пипса (0 = автоматически)\",\"showClock\":\"Панель текущей ситуации\",\"showGuide\":\"Памятка о значении меток\",\"showLadder\":\"Уровни сделки справа\",\"showPoc\":\"Линия объёма\",\"showSr\":\"Пунктирные уровни\",\"showStars\":\"Предупреждающие ромбы\",\"showTable\":\"Таблица трендов\",\"showTint\":\"Цвет фона\",\"showWhy\":\"Объяснять пропущенные сигналы\",\"slMinPips\":\"Минимальный отступ за медленной линией (пипсов)\",\"srAtrMove\":\"Уровни: необходимый отскок (× обычный размер свечи)\",\"srLookback\":\"Уровни: глубина поиска экстремумов\",\"srMax\":\"Максимум уровней на экране\",\"srRange\":\"Не учитывать уровни дальше (× обычный размер свечи)\",\"srReset\":\"Уровни: повторных касаний до удаления\",\"stripLen\":\"Ширина правого столбца (свечей)\",\"tablePos\":\"Положение панели текущей ситуации\",\"theme\":\"Цветовая тема графика\",\"tp1R\":\"TP1 (множитель R)\",\"tp2R\":\"TP2 (множитель R)\",\"trendPos\":\"Положение таблицы трендов\",\"tz\":\"Часовой пояс торговых окон\"},\"ladder\":{\"closedAtStop\":\"ЗАКРЫТО по стопу\",\"closedAtTarget\":\"ЗАКРЫТО TP{{hit}}\",\"entry\":\"ВХОД\",\"stop\":\"СТОП\",\"tp1\":\"TP1\",\"tp2\":\"TP2\"},\"options\":{\"autoScale\":\"Автоматический масштаб\",\"bottomCentre\":\"Внизу по центру\",\"bottomLeft\":\"Внизу слева\",\"bottomRight\":\"Внизу справа\",\"dark\":\"Тёмная\",\"ignore\":\"Не учитывать\",\"large\":\"Крупный\",\"light\":\"Светлая\",\"literal238\":\"Фиксированное значение 238\",\"middleCentre\":\"В центре\",\"middleLeft\":\"Посередине слева\",\"middleRight\":\"Посередине справа\",\"normal\":\"Обычный\",\"reject\":\"Отклонять\",\"small\":\"Мелкий\",\"topCentre\":\"Вверху по центру\",\"topLeft\":\"Вверху слева\",\"topRight\":\"Вверху справа\",\"waitForPullback\":\"Ждать отката\"},\"reasons\":{\"clock\":\"вне торгового окна\",\"diamond\":\"только что появился крупный предупреждающий ромб\",\"range\":\"цена зажата в боковом диапазоне\",\"room\":\"уровень слишком близко, нет запаса до цели\",\"safetyLine\":\"линия 238 между входом и целью\",\"separation\":\"линии слишком близко, пока нет пространства для движения\",\"trend\":\"против 15-минутного тренда\",\"wrongColour\":\"свеча пересечения закрылась неподходящим цветом\"},\"rightNow\":{\"aBuy\":\"Покупка\",\"aSell\":\"Продажа\",\"bestBuysOnly\":\"искать только покупки\",\"bestNow\":\"Сейчас лучше\",\"bestSellsOnly\":\"искать только продажи\",\"bestWaitThin\":\"ждать, объём низкий\",\"goodVolume\":\"Хороший объём\",\"lowVolume\":\"Низкий объём\",\"safetyAbove\":\"238 выше цены, есть запас для продаж\",\"safetyBelow\":\"238 ниже цены, есть запас для покупок\",\"safetyLine\":\"Защитная линия\",\"skipped\":\"Пропущено\",\"skippedAgo_one\":\"{{side}} {{bars}} свечу назад: {{reason}}\",\"skippedAgo_other\":\"{{side}} {{bars}} свечи назад: {{reason}}\",\"skippedNothing\":\"пока ничего не пропущено\",\"title\":\"ПРЯМО СЕЙЧАС\",\"trend\":\"Тренд\",\"trendSummaryDown\":\"15m вниз, {{agree}} из 6 таймфреймов вверх\",\"trendSummaryUp\":\"15m вверх, {{agree}} из 6 таймфреймов вверх\",\"skippedAgo_few\":\"{{side}} {{bars}} свечи назад: {{reason}}\",\"skippedAgo_many\":\"{{side}} {{bars}} свечей назад: {{reason}}\"},\"signal\":{\"buy\":\"ПОКУПКА\",\"pips\":\"пипсов\",\"sell\":\"ПРОДАЖА\",\"stop\":\"Стоп\"},\"tooltip\":{\"f3Mode\":\"Покупка на красной свече или продажа на синей не выполняется сразу. Режим ожидания отката ждёт возврата цены к линиям на свече подходящего цвета. Режим отклонения отбрасывает сигнал.\",\"f4Min\":\"Скорость расхождения линий на сигнальной свече. Переплетённые горизонтальные линии не дают запаса для движения.\",\"f6Reward\":\"Следующий пунктирный уровень должен быть не ближе этого расстояния. По умолчанию выключено: сканер строит уровни своим методом, поэтому оцените запас и визуально.\",\"f7Pips\":\"Избегайте консолидации шириной 100 пипсов и менее.\",\"longMode\":\"238 — стандарт для минутного графика. Автоматический масштаб подстраивает защитную линию под другие таймфреймы: около 83 на трёхминутном графике.\",\"pipIn\":\"Автоматически: 0.10 для золота и десять тиков для остальных инструментов (1 пункт для US30).\",\"showGuide\":\"Краткая памятка на графике. Выключите её, когда запомните значения меток.\",\"showLadder\":\"Вход, стоп и цели последней сделки показаны справа от последней свечи. Достигнутые цели отмечаются галочкой.\",\"showWhy\":\"Если линии пересеклись, но проверка не пропустила сделку, панель текущей ситуации показывает проверку и причину.\",\"slMinPips\":\"Стоп ставится за красной и синей линиями, минимум в 10 пипсах от синей.\",\"srMax\":\"Сохраняются только ближайшие к цене уровни, чтобы график оставался читаемым.\",\"theme\":\"Выберите тему как в TradingView, чтобы все цвета были хорошо видны.\",\"tz\":\"Торговые окна заданы в этом часовом поясе. America/Denver — горное время США с переходом на летнее время. Для горного времени без сезонного перевода используйте America/Phoenix.\"},\"trendTable\":{\"above\":\"выше\",\"below\":\"ниже\",\"down\":\"Вниз\",\"notAvailable\":\"нет данных\",\"up\":\"Вверх\",\"volumeLine\":\"Линия объёма\"}}"),
	bearish: "Медвежий",
	bfs: {
		duplicateRemoved: "На одном графике поддерживается только один индикатор BFS — Blessed Flow System, поэтому дубликат удалён.",
		emaCrossSoon: "EMA30/50 вот-вот пересекутся",
		engineOff: "перейдите на M1",
		engineOn: "движок M1",
		input: {
			armWin: "Окно (свечи M1) для касания EMA30",
			asiaSess: "Азия (ЧЧММ-ЧЧММ)",
			bePts: "БУ: при +пунктах стоп переносится РОВНО на этот уровень",
			cooldown: "Пауза (свечи M1) после закрытия сделки",
			lenFast: "Быстрая EMA (направление)",
			lenH1a: "H1 · короткая EMA",
			lenH1b: "H1 · длинная EMA",
			lenMid: "Средняя EMA",
			lenSlow: "Медленная EMA",
			londonSess: "Лондон (ЧЧММ-ЧЧММ, часы сессии)",
			maxPerBlock: "Макс. входов на блок сессии (0 = без лимита)",
			nearLb: "Свечей для оценки сближения",
			nearPts: "Макс. расстояние EMA30-EMA50 (пункты)",
			nySess: "Нью-Йорк (ЧЧММ-ЧЧММ)",
			onlyM1: "Запускать движок только на M1",
			pv: "Стоимость одного пункта в цене",
			r1lb: "R1 · свечей M1 назад (цена не растянута)",
			rr: "Отношение ТП R:R (когда лестница выключена)",
			rsiHi: "RSI >= для ШОРТА",
			rsiLen: "Период RSI",
			rsiLo: "RSI <= для ЛОНГА",
			rsiWin: "Окно ожидания (свечей после сигнала)",
			showLevels: "Рисовать уровни сделки",
			showNear: "Отмечать, когда EMA30 вот-вот пересечёт EMA50",
			slPts: "СЛ (пункты)",
			swLenA: "Сила пивота (свечей с каждой стороны)",
			tp1Pts: "ТП1 (пункты)",
			tp2Pts: "ТП2 (пункты)",
			tp3Pts: "ТП3 (пункты)",
			tzOffset: "Смещение UTC для часов сессии (Богота = -5)",
			useArm: "Требовать коррекцию 50% и касание EMA30 в окне",
			useAsia: "Включить Азию (только для тестов)",
			useBE: "Безубыток включён",
			useLadder: "Использовать ТП1/ТП2/ТП3 (финальный выход = ТП3)",
			useR2: "R2 · требовать порядок M5 + M15 и настрой H1",
			useRSI: "Ждать RSI после сигнала",
			useSess: "Фильтровать по сессии",
			useTrend: "Сохранять порядок EMA во время ожидания"
		},
		longSignal: "Сигнал в лонг",
		noSignal: "нет сигнала",
		retracementDot: "Точка коррекции 50%",
		rewardZone: "Зона прибыли",
		riskZone: "Зона риска",
		session: "Сессия",
		sessionClosed: "закрыта",
		sessionOpen: "открыта",
		shortSignal: "Сигнал в шорт",
		signal: "Сигнал",
		signalActive: "{{side}} в работе",
		waitingRsi: "ожидание RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Ожидание RSI (лонг)",
		waitingRsiShort: "Ожидание RSI (шорт)"
	},
	breakEven: "Безубыток",
	bullish: "Бычий",
	buy: "Покупка",
	colour: "Цвет",
	cypher: {
		above55: "Выше 55",
		aboveBelow: "Выше/Ниже",
		barColors: "Цвета баров",
		bbLength: "Длина BB",
		bbStdDev: "Станд. отклонение BB {{n}}",
		bearBreak: "Медвежий пробой",
		bearPattern: "Медвежий пин-бар / поглощение",
		below55: "Ниже 55",
		bullBreak: "Бычий пробой",
		bullPattern: "Бычий пин-бар / поглощение",
		cmoLength: "Длина CMO",
		colorCandles: "Раскрашивать свечи",
		confluenceLong: "Конфлюенция лонг",
		confluenceShort: "Конфлюенция шорт",
		consolidating: "Консолидация",
		direction: "Направление",
		emaPeriodTrend: "Период EMA (тренд)",
		flagOffsetAtr: "Отступ флага (x ATR)",
		flashBackground: "Фон вспышки",
		flashCount: "Количество вспышек",
		flashHz: "Скорость вспышки (мигания / сек)",
		flashOn: "Вспышка при новом флаге",
		flashShowBanner: "Баннер NEW BUY / SELL",
		flashShowBg: "Подсветка фона графика",
		flashStrength: "Сила вспышки фона",
		flashTest: "Проверить вспышку (предпросмотр)",
		fvgKeep: "Fair Value Gaps на сторону",
		glowOpacity: "Непрозрачность подсветки (больше = прозрачнее)",
		glowSizeTicks: "Размер подсветки (тики)",
		groupFlash: "Оповещение о новом флаге",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "Уровни KDE",
		groupKeyLevels: "Ключевые уровни",
		groupLrEma: "LR-канал / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Пивоты",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Полосы разворота",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Компоненты",
		groupTrendTable: "Таблица тренда",
		groupVidya: "VIDYA / Тренд",
		halfTrendAmplitude: "Амплитуда HalfTrend",
		halfTrendChannelDeviation: "Отклонение канала HalfTrend",
		ichimokuBase: "Базовая линия Ichimoku",
		ichimokuConversion: "Конверсионная линия Ichimoku",
		kdeActivation: "Включить порог активации",
		kdeBins: "Количество интервалов",
		kdeThreshold: "Порог %",
		labelPosition: "Положение подписей",
		lineWidth: "Толщина линии",
		lowerBb: "Нижняя BB{{n}}",
		lowerInnerZone: "Нижняя внутренняя зона",
		lowerReversalZone: "Нижняя зона разворота",
		maCloudLong: "Облако MA (длинное)",
		maCloudShort: "Облако MA (короткое)",
		newBuy: "НОВАЯ ПОКУПКА",
		newSell: "НОВАЯ ПРОДАЖА",
		numberOfLevels: "Количество уровней",
		parabolicSar: "Параболический SAR",
		pivotAuto: "Авто",
		pivotDaily: "Дневной",
		pivotMonthly: "Месячный",
		pivotsTimeframe: "Таймфрейм пивотов",
		pivotWeekly: "Недельный",
		positionBottomCenter: "Внизу по центру",
		positionBottomLeft: "Внизу слева",
		positionBottomRight: "Внизу справа",
		positionLeft: "Слева",
		positionRight: "Справа",
		positionTopCenter: "Вверху по центру",
		positionTopLeft: "Вверху слева",
		positionTopRight: "Вверху справа",
		psarBear: "PSAR медвежий",
		psarBull: "PSAR бычий",
		psarIncrement: "Шаг PSAR",
		psarMax: "Максимум PSAR",
		psarStart: "Старт PSAR",
		pullingBack: "Откат",
		pulseSmoothingBars: "Бары сглаживания Pulse",
		reEntry: "Повторный вход",
		rightOffsetBars: "Отступ справа (бары)",
		showCamarillaPivots: "Показать пивоты Camarilla",
		showConfluenceFlag: "Показать флаг конфлюенции (B/S)",
		showFvg: "Fair Value Gaps (15m и выше)",
		showKde: "Уровни объёма KDE",
		showKeyLevels: "Показать ключевые уровни",
		showLabels: "Показать подписи",
		showLevelGlow: "Показать подсветку уровней",
		showMaCloud: "Показать облако MA",
		showPrices: "Показать цены",
		showPsar: "Показать PSAR",
		showReversalBands: "Показать полосы разворота",
		showSlTpLabels: "Показать метки SL / TP",
		showSniperBreakArrows: "Показать стрелки Sniper / пробоя",
		showTrendTable: "Показать таблицу тренда",
		showVidya233: "Показать VIDYA 233",
		showVidya55: "Показать VIDYA 55",
		showVidya987: "Показать VIDYA 987 (магнит)",
		showVidyaLines: "Показать линии VIDYA",
		sizeNormal: "Обычный",
		sizeSmall: "Маленький",
		sizeTiny: "Крошечный",
		slBufferAtr: "SL: предел запаса (x ATR)",
		slBufferPips: "SL: запас за свингом (пипсы)",
		slMaxRiskAtr: "SL: макс. риск (x ATR)",
		slSwingLookback: "SL: глубина поиска свинга (бары)",
		sniperDown: "Sniper вниз",
		sniperUp: "Sniper вверх",
		source: "Источник",
		state: "Состояние",
		strength: "Сила",
		strong: "Сильная",
		superTrend2AtrLength: "Длина ATR SuperTrend 2",
		superTrend2Factor: "Коэффициент SuperTrend 2",
		superTrendAtrLength: "Длина ATR SuperTrend",
		superTrendMultiplier: "Множитель SuperTrend",
		tablePosition: "Положение таблицы",
		tableSize: "Размер таблицы",
		tpRiskReward: "TP {{n}} риск/прибыль",
		tradeManagement: "Управление сделкой (SL / TP)",
		trend: "Тренд",
		trending: "В тренде",
		upperBb: "Верхняя BB{{n}}",
		upperInnerZone: "Верхняя внутренняя зона",
		upperReversalZone: "Верхняя зона разворота",
		veryStrong: "Очень сильная",
		veryWeak: "Очень слабая",
		vidya987Magnet: "VIDYA 987 (магнит)",
		volumeAvgLength: "Длина среднего объёма (фильтр пробоя)",
		weak: "Слабая",
		zoneEdge: "{{name}} (граница заливки)"
	},
	entry: "Вход",
	gainColor: "Цвет прибыли",
	harsiCandle: "Свеча HARSI",
	harsiLength: "Длина HARSI",
	heikinAshiRsiOscillator: "Осциллятор Heikin-Ashi RSI",
	keyValueThisChangesTheSensitivity: "Ключевое значение 'Это меняет чувствительность'",
	labelsIndicator: "Индикатор меток",
	london: "Лондон",
	londonBackground: "Фон Лондонской сессии",
	londonSession: "Лондонская сессия",
	long: "Лонг",
	lossColor: "Цвет убытка",
	median: "Медиана",
	neutral: "Нейтральный",
	newYork: "Нью-Йорк",
	newYorkBackground: "Фон Нью-Йоркской сессии",
	newYorkSession: "Нью-Йоркская сессия",
	openSmoothing: "Сглаживание открытия",
	optimus: {
		activeTradeLevels: "Открытая сделка · уровни",
		bias: "Настрой",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "СМЕШАННЫЙ {{n}}/{{total}}",
		disclaimer: "Уровни нанесены на график. Это не инвестиционная рекомендация.",
		duplicateRemoved: "На одном графике поддерживается только один индикатор Optimus Prime, поэтому дубликат удалён.",
		enter: "ВХОД · {{side}}",
		input: {
			atrLength: "Период ATR для KC",
			buffer: "Запас по свингу (в цене)",
			emaLength: "Период EMA",
			kcLength: "Период KC",
			kcMult: "Множитель KC",
			lrcLength: "Период LRC",
			minRisk: "Мин. риск R (в цене)",
			requireAlign: "Требовать согласованность EMA и LRC",
			rrTp1: "ТП1 (xR)",
			rrTp2: "ТП2 (xR)",
			rrTp3: "ТП3 (xR)",
			rrTp4: "ТП4 (xR)",
			swingLookback: "Свечей назад для свинга (R)"
		},
		kcLower: "KC нижняя",
		kcMid: "KC средняя",
		kcUpper: "KC верхняя",
		keltnerFill: "Заливка Keltner",
		noClosedTrades: "Закрытых сделок пока нет",
		reasonForming: "Сетап формируется — нужно подтверждение",
		reasonLatched: "Сделка зафиксирована · уровни на графике",
		reasonNoSetup: "Сетапа нет · EMA/LRC не согласованы",
		recentSignals: "Последние сигналы",
		riskReward: "РИСК/ПРИБЫЛЬ",
		trendMtf: "Тренд · несколько таймфреймов",
		wait: "ЖДЁМ",
		warmingUp: "ПРОГРЕВ"
	},
	overbought: "Перекупленность",
	overboughtMax: "Макс. перекупленности",
	overboughtMin: "Мин. перекупленности",
	oversold: "Перепроданность",
	oversoldMax: "Макс. перепроданности",
	oversoldMin: "Мин. перепроданности",
	rsiLength: "Длина RSI",
	rsiLine: "Линия RSI",
	rsiLineShadow: "Тень линии RSI",
	sell: "Продажа",
	short: "Шорт",
	signalsFromHeikinAshiCandles: "Сигналы со свечей Heikin Ashi",
	sl: "СЛ",
	smoothedMode: "Сглаженный режим",
	sydney: "Сидней",
	sydneyBackground: "Фон Сиднейской сессии",
	sydneySession: "Сиднейская сессия",
	tfD1: "Д1",
	tfH1: "Ч1",
	tfH4: "Ч4",
	tfM1: "М1",
	tfM15: "М15",
	tfM30: "М30",
	tfM5: "М5",
	tokyo: "Токио",
	tokyoBackground: "Фон Токийской сессии",
	tokyoSession: "Токийская сессия",
	tp: "ТП {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "медвежий",
			bullish: "бычий",
			confluence: "конфлюэнс",
			entry: "вход",
			neckline: "линия шеи",
			score: "оценка",
			state: "статус",
			states: {
				completed: "завершён",
				invalidated: "отменён",
				projected: "прогноз",
				przActive: "PRZ активна",
				stopped: "стоп сработал"
			},
			stop: "стоп",
			target: "цель"
		},
		classic: {
			doubleBottom: "Двойное дно",
			doubleTop: "Двойная вершина",
			headAndShoulders: "Голова и плечи",
			inverseHeadAndShoulders: "Перев. ГиП",
			tripleBottom: "Тройное дно",
			tripleTop: "Тройная вершина"
		},
		direction: {
			bearishOnly: "Только медвежьи",
			both: "Оба",
			bullishOnly: "Только бычьи"
		},
		group: {
			classics: "Классические паттерны и S/R",
			filters: "Фильтры и отображение",
			patterns: "Паттерны",
			pivotEngine: "Движок пивотов",
			ratios: "Соотношения и допуск"
		},
		input: {
			atrLen: "Период ATR",
			atrMult: "Разворот зигзага (x ATR)",
			colBear: "Медвежий",
			colBull: "Бычий",
			colPrz: "PRZ",
			colSR: "Ключевые уровни",
			dirFilter: "Фильтр направления",
			enClassics: "Искать классические паттерны",
			enDoubles: "Двойная вершина / дно",
			enHS: "Голова и плечи",
			enTriples: "Тройная вершина / дно",
			fillTransp: "Прозрачность заливки паттерна",
			formingLife: "Время жизни формирующейся зоны (баров)",
			keepFailed: "Оставлять на графике сработавшие по стопу паттерны (✕, приглушённые)",
			keepSuccessful: "Оставлять на графике успешные паттерны (✓)",
			maxPatterns: "Макс. паттернов на графике",
			minScore: "Минимальная оценка качества",
			pivotDepth: "Глубина буфера пивотов",
			showLetters: "Показывать буквы точек X A B C D",
			showPlan: "Показывать уровни торгового плана",
			showProjected: "Показывать прогнозные (формирующиеся) паттерны",
			showRatios: "Показывать соотношения на сторонах",
			showSR: "Уровни поддержки/сопротивления",
			showStats: "Показывать таблицу статистики",
			srMinTouch: "S/R: минимум касаний пивота",
			tolEdge: "Допуск на краю диапазона",
			tolPoint: "Допуск соотношений точек",
			useScale2: "Сканировать также масштаб 2x (более крупные структуры)"
		},
		label: {
			confirmed: "подтверждено",
			forming: "формируется",
			sl: "SL",
			target: "цель",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Завершено",
			stops: "Стопы",
			t1Wins: "Достигли T1",
			winRate: "Прибыльных %"
		},
		tooltip: {
			colPrz: "PRZ янтарного цвета независимо от направления паттерна (по умолчанию в ProTrader).",
			fillTransp: "Чем меньше значение, тем заметнее заливка. Обычно хорошо подходит 65-80.",
			formingLife: "Если точка C формирующегося паттерна старше этого числа баров, а паттерн так и не завершился и не был отменён, он истекает и удаляется.",
			maxPatterns: "Первыми удаляются самые старые паттерны, поэтому недавняя история (✓ / ✕) и свежие формирующиеся зоны всегда остаются видны.",
			showProjected: "Рисует структуру X-A-B с пунктирной направляющей к прогнозной PRZ.",
			showRatios: "Точечные измерительные диагонали (X-B, A-C, B-D, X-D) с измеренным коэффициентом Фибоначчи посередине каждой — стандартная разметка гармонических паттернов.",
			tolPoint: "Применяется к точным соотношениям, например Gartley B=0.618. Строгий допуск = 0.03, сбалансированный = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ ЗАКРЫТЬ ВСЁ",
		duplicateRemoved: "На одном графике поддерживается только один индикатор Trade Finder, поэтому дубликат удалён.",
		durationHm: "{{h}} ч {{m}} мин",
		durationM: "{{m}} мин",
		emaEntry1: "EMA Вход 1",
		emaEntry2: "EMA Вход 2 / Тренд",
		emaRangeFilter: "EMA Фильтр диапазона",
		emaTrigger: "EMA Триггер",
		entry1: "Вход 1",
		entry2: "Вход 2",
		entry2Mark: "E2",
		entryZoneBear: "Зона входа {{n}} (медвежья)",
		entryZoneBull: "Зона входа {{n}} (бычья)",
		frameFailed: "Не удалось загрузить таймфрейм {{frame}} — попробуем ещё раз.",
		framesUnavailable: "Нет данных таймфреймов · ждём",
		ghostEntry: "Предыдущая идея",
		ghostStop: "Предыдущий стоп",
		group: {
			bias: "Смещение",
			display: "Отображение",
			emaSystem: "Система EMA",
			entries: "Входы",
			filter: "Фильтр",
			riskManagement: "Управление риском",
			session: "Сессия",
			supportResistance: "Поддержка и сопротивление",
			trailingStop: "Трейлинг-стоп",
			trendPanel: "Панель тренда"
		},
		input: {
			adxLen: "Длина ADX",
			adxSmoothing: "Сглаживание ADX",
			asiaSession: "Азиатская / Токийская сессия (UTC)",
			atrBufferMultBtc: "Буфер стопа за свингом — BTC (× ATR)",
			atrBufferMultGold: "Буфер стопа за свингом — золото (× ATR)",
			atrBufferMultOther: "Буфер стопа за свингом — прочее (× ATR)",
			atrLength: "Длина ATR (управление риском)",
			atrSlMult: "Стоп-лосс = ATR ×",
			atrTpMult: "ТП{{n}} = ATR ×",
			beGoldPoints: "Золото: безубыток после стольких пунктов",
			biasEmaLen: "Длина EMA смещения",
			crossLookback: "Окно пересечений смещения (бары)",
			dxySymbol: "Символ индекса доллара (пусто — выключено)",
			emaBigLen: "Длина EMA Фильтр диапазона",
			emaFastLen: "Длина EMA Вход 1",
			emaMidLen: "Длина EMA Вход 2 / Тренд",
			emaTriggerLen: "Длина EMA Триггер",
			feeBufferPct: "Буфер на комиссии за безубытком (%)",
			flatThreshPct: "Порог плоского участка (% от EMA смещения)",
			londonSession: "Лондонская сессия (UTC)",
			maxCrosses: "Максимум пересечений, после которого смещение отбрасывается",
			newYorkSession: "Нью-Йоркская сессия (UTC)",
			showEmaLabels: "Показывать подписи EMA",
			showEntrySignals: "Показывать метки сетапа",
			showEntryZone: "Показывать зону входа",
			showSRLines: "Показывать поддержку и сопротивление",
			showTradeLevels: "Показывать уровни входа, стопа и целей",
			slMaxPointsBtc: "Максимальная дистанция стопа — BTC (пункты)",
			slMaxPointsGold: "Максимальная дистанция стопа — золото (пункты)",
			slMaxPointsIndex: "Максимальная дистанция стопа — индексы (пункты)",
			slMaxPointsOther: "Максимальная дистанция стопа — прочее (пункты)",
			slMinPointsGold: "Минимальная дистанция стопа — золото (пункты)",
			slopeLookback: "Окно наклона смещения (бары)",
			srLeftBars: "Поддержка / сопротивление · баров слева от пивота",
			srRightBars: "Поддержка / сопротивление · баров справа от пивота",
			swingPivotLen: "Длина свингового пивота (стоп-лосс)",
			tp1ClosePct: "Закрыть на ТП1, %",
			tp2ClosePct: "Закрыть на ТП2, %",
			tp5CloseAlways: "ТП5 всегда закрывает, даже при трейлинге",
			tpR: "ТП{{n}} (в R)",
			tpSlMode: "Режим стопа и целей",
			trailAtrMult: "Дистанция трейлинг-стопа (× ATR)",
			trendPanelEmaLen: "Длина EMA строки тренда",
			trendSlopeLB: "Окно наклона EMA Вход 2 (бары)",
			useAdxFilter: "Требовать ADX выше порога режима",
			useBiasFilter: "Учитывать смещение старшего таймфрейма (не блокирует вход)",
			useEmaStackCheck: "Требовать правильный порядок EMA",
			useInstrumentAutoDetect: "Определять инструмент автоматически",
			useSessionFilter: "Сигналы только во время торговых сессий",
			useSlopeDynamic: "Масштабировать окно наклона под таймфрейм",
			useStrictCandle: "Строгий фильтр свечи (тень и закрытие)",
			useTrailingStop: "Трейлинг-стоп (с ТП1)",
			useVolumeConfirm: "Требовать объём выше среднего на входе",
			volAvgLen: "Длина среднего объёма",
			volMultiplier: "Минимальный объём (× среднее)"
		},
		maxStop: "Макс. СЛ",
		minuteAgainst: "Пересечение против сетапа",
		minuteOk: "Предупреждений нет",
		minuteReversal: "Пересечение · возможен разворот",
		modeAtr: "ATR",
		modeAuto: "Автоматически",
		modeRiskReward: "Риск / прибыль",
		noBias: "Нет уклона",
		noSetup: "Нет активного сетапа",
		recentTitle: "Недавние сетапы",
		reEntry: "Повторный вход",
		reEntryMark: "RE",
		rest: "ОСТАТОК",
		rowBias: "Уклон",
		rowContext: "Контекст",
		rowInfo: "Инфо",
		rowSession: "Сессия",
		rowSetup: "Сетап",
		rowVolume: "Объём",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "до конца {{time}}",
		sessionOutside: "Вне сессий · Лондон {{time}} UTC",
		sessionOverlap: "Перекрытие",
		statsTitle: "Последние {{n}} сетапов",
		statusBreakEvenSet: "Безубыток",
		statusMoveToBreakEven: "Сдвиньте стоп",
		statusPending: "Касание зоны",
		statusRunning: "В работе",
		statusSpike: "Волатильно · ждём",
		statusWaiting: "Ожидание",
		stopHit: "Стоп сработал",
		styleDaytrade: "Внутридневная",
		styleScalping: "Скальпинг",
		styleSwing: "Свинг",
		subFrameReversal: "Младший таймфрейм разворачивается",
		targetHit: "Достигнута последняя цель",
		trailStop: "Трейлинг-стоп",
		volAboveAverage: "выше среднего",
		volBelowAverage: "ниже среднего",
		zoneEdgeBear: "Граница зоны {{n}} (медвежья)",
		zoneEdgeBull: "Граница зоны {{n}} (бычья)"
	},
	tradingSessions: "Торговые сессии",
	unintendedSymbol: "Эта стратегия рассчитана на {{symbols}} — на {{symbol}} её уровни могут ничего не значить.",
	utBotAlerts: "UT Bot Alerts"
}, I = {
	asia: "เอเชีย",
	atrPeriod: "ช่วงเวลา ATR",
	auraScanner: /* @__PURE__ */ JSON.parse("{\"guide\":{\"bigDiamondMark\":\"สีแดง/เขียวขนาดใหญ่\",\"bigDiamondMeaning\":\"รูปข้าวหลามตัดสีแดงขนาดใหญ่เหนือจุดสูงเตือนการซื้อ สีเขียวขนาดใหญ่ใต้จุดต่ำเตือนการขาย\",\"blueMark\":\"เส้นโค้งสีน้ำเงิน\",\"blueMeaning\":\"50 EMA สีชมพูอยู่เหนือสีน้ำเงินคือซื้อ อยู่ใต้คือขาย\",\"dashedMark\":\"เส้นประ\",\"dashedMeaning\":\"แนวรับและแนวต้าน สีแดงอยู่ใต้ราคา สีเขียวอยู่เหนือราคา\",\"diamondsMark\":\"รูปข้าวหลามตัด\",\"diamondsMeaning\":\"จุดกลับตัว สีทองอ่อนที่สุด ตามด้วยสีน้ำเงิน สีแดง และสีเขียว\",\"flatGoldMark\":\"เส้นสีทองแนวนอน\",\"flatGoldMeaning\":\"ระดับราคาที่มีปริมาณซื้อขายสูงสุดในหกชั่วโมงล่าสุดบนกราฟ 15 นาที\",\"levelsMark\":\"เส้นระดับราคา\",\"levelsMeaning\":\"จุดเข้า จุดตัดขาดทุน และเป้าหมายของการเทรดล่าสุด เครื่องหมายถูกหมายถึงแตะแล้ว\",\"pinkMark\":\"เส้นโค้งสีชมพู\",\"pinkMeaning\":\"20 EMA สัญญาณเกิดเมื่อเส้นนี้ตัดกับเส้นสีน้ำเงิน\",\"subtitle\":\"วิธีอ่านกราฟนี้\",\"thickGoldMark\":\"เส้นสีทองหนา\",\"thickGoldMeaning\":\"เส้น 238 หากอยู่ระหว่างจุดเข้ากับเป้าหมาย ให้ข้าม\",\"title\":\"AURA\",\"triangleMark\":\"รูปสามเหลี่ยม\",\"triangleMeaning\":\"การเทรดที่ผ่านทุกเงื่อนไข วางเมาส์เหนือสัญลักษณ์เพื่อดูตัวเลข\"},\"groups\":{\"display\":\"การแสดงผล\",\"eightChecks\":\"การตรวจสอบแปดข้อ\",\"riskAndTargets\":\"ความเสี่ยงและเป้าหมาย\",\"signalEngine\":\"ระบบสัญญาณ\"},\"inputs\":{\"emaFastLen\":\"เส้นเร็ว (สีชมพู)\",\"emaSlowLen\":\"เส้นช้า (สีน้ำเงิน)\",\"f1Clock\":\"1. เฉพาะช่วงปริมาณซื้อขายดี\",\"f2Trend\":\"2. สอดคล้องกับแนวโน้ม 15 นาที\",\"f3Mode\":\"3. แท่งเทียนสีไม่ถูกต้อง\",\"f4Min\":\"ระยะขยายขั้นต่ำ (ปิ๊ปต่อแท่ง)\",\"f4Sep\":\"4. เส้นกำลังแยกออกจากกัน\",\"f5Clear\":\"5. 238 ไม่อยู่ระหว่างจุดเข้ากับเป้าหมาย\",\"f6R\":\"พื้นที่ขั้นต่ำ (เท่าของความเสี่ยง)\",\"f6Reward\":\"6. พื้นที่ถึงระดับถัดไป\",\"f7Bars\":\"จำนวนแท่งย้อนหลัง\",\"f7Consol\":\"7. ไม่ติดอยู่ในกรอบราคา\",\"f7Pips\":\"กรอบราคาต้องกว้างกว่า (ปิ๊ป)\",\"f9Bars\":\"ภายใน N แท่งล่าสุด\",\"f9Star\":\"8. ไม่มีรูปข้าวหลามตัดเตือนขนาดใหญ่\",\"guidePos\":\"ตำแหน่งแผงคำอธิบาย\",\"longMode\":\"โหมดเส้นความปลอดภัย (238)\",\"panelSize\":\"ขนาดข้อความในแผง\",\"pipIn\":\"ขนาดปิ๊ป (0 = อัตโนมัติ)\",\"showClock\":\"แผงสถานการณ์ปัจจุบัน\",\"showGuide\":\"แผงอธิบายความหมายสัญลักษณ์\",\"showLadder\":\"ระดับการเทรดทางขวา\",\"showPoc\":\"เส้นปริมาณซื้อขาย\",\"showSr\":\"ระดับเส้นประ\",\"showStars\":\"รูปข้าวหลามตัดเตือน\",\"showTable\":\"ตารางแนวโน้ม\",\"showTint\":\"สีพื้นหลัง\",\"showWhy\":\"อธิบายสัญญาณที่ข้าม\",\"slMinPips\":\"ระยะขั้นต่ำเลยเส้นช้า (ปิ๊ป)\",\"srAtrMove\":\"ระดับราคา: ระยะเด้งที่ต้องการ (เท่าของขนาดแท่งปกติ)\",\"srLookback\":\"ระดับราคา: ระยะย้อนหลังหาจุดกลับตัว\",\"srMax\":\"จำนวนระดับสูงสุดที่แสดง\",\"srRange\":\"ละเว้นระดับที่ไกลเกิน (เท่าของขนาดแท่งปกติ)\",\"srReset\":\"ระดับราคา: จำนวนทดสอบซ้ำก่อนลบ\",\"stripLen\":\"ความกว้างคอลัมน์ขวา (แท่ง)\",\"tablePos\":\"ตำแหน่งแผงปัจจุบัน\",\"theme\":\"ธีมกราฟ\",\"tp1R\":\"TP1 (เท่าของ R)\",\"tp2R\":\"TP2 (เท่าของ R)\",\"trendPos\":\"ตำแหน่งตารางแนวโน้ม\",\"tz\":\"เขตเวลาของช่วงเทรด\"},\"ladder\":{\"closedAtStop\":\"ปิดที่จุดตัดขาดทุน\",\"closedAtTarget\":\"ปิดแล้ว TP{{hit}}\",\"entry\":\"จุดเข้า\",\"stop\":\"จุดตัดขาดทุน\",\"tp1\":\"TP1\",\"tp2\":\"TP2\"},\"options\":{\"autoScale\":\"ปรับอัตโนมัติ\",\"bottomCentre\":\"ล่างกลาง\",\"bottomLeft\":\"ล่างซ้าย\",\"bottomRight\":\"ล่างขวา\",\"dark\":\"มืด\",\"ignore\":\"ละเว้น\",\"large\":\"ใหญ่\",\"light\":\"สว่าง\",\"literal238\":\"คงค่า 238\",\"middleCentre\":\"กึ่งกลาง\",\"middleLeft\":\"กลางซ้าย\",\"middleRight\":\"กลางขวา\",\"normal\":\"ปกติ\",\"reject\":\"ปฏิเสธ\",\"small\":\"เล็ก\",\"topCentre\":\"บนกลาง\",\"topLeft\":\"บนซ้าย\",\"topRight\":\"บนขวา\",\"waitForPullback\":\"รอราคาย่อตัว\"},\"reasons\":{\"clock\":\"อยู่นอกช่วงเวลาเทรด\",\"diamond\":\"เพิ่งเกิดรูปข้าวหลามตัดเตือนขนาดใหญ่\",\"range\":\"กราฟติดอยู่ในช่วงพักตัว\",\"room\":\"ระดับราคาใกล้เกินไป ไม่มีพื้นที่ถึงเป้าหมาย\",\"safetyLine\":\"238 อยู่ระหว่างจุดเข้ากับเป้าหมาย\",\"separation\":\"สองเส้นชิดกันเกินไป ยังไม่มีพื้นที่ให้ราคาไปต่อ\",\"trend\":\"สวนแนวโน้ม 15 นาที\",\"wrongColour\":\"แท่งที่เกิดการตัดกันปิดด้วยสีไม่ถูกต้อง\"},\"rightNow\":{\"aBuy\":\"ซื้อ\",\"aSell\":\"ขาย\",\"bestBuysOnly\":\"มองหาการซื้อเท่านั้น\",\"bestNow\":\"ตอนนี้ควร\",\"bestSellsOnly\":\"มองหาการขายเท่านั้น\",\"bestWaitThin\":\"รอ ปริมาณซื้อขายน้อย\",\"goodVolume\":\"ปริมาณซื้อขายดี\",\"lowVolume\":\"ปริมาณซื้อขายต่ำ\",\"safetyAbove\":\"238 อยู่เหนือราคา มีพื้นที่สำหรับการขาย\",\"safetyBelow\":\"238 อยู่ใต้ราคา มีพื้นที่สำหรับการซื้อ\",\"safetyLine\":\"เส้นความปลอดภัย\",\"skipped\":\"ข้ามแล้ว\",\"skippedAgo_other\":\"{{side}} เมื่อ {{bars}} แท่งก่อน: {{reason}}\",\"skippedNothing\":\"ยังไม่มีสัญญาณที่ข้าม\",\"title\":\"ขณะนี้\",\"trend\":\"แนวโน้ม\",\"trendSummaryDown\":\"15m ลง โดย {{agree}} จาก 6 กรอบเวลาขึ้น\",\"trendSummaryUp\":\"15m ขึ้น โดย {{agree}} จาก 6 กรอบเวลาขึ้น\"},\"signal\":{\"buy\":\"ซื้อ\",\"pips\":\"ปิ๊ป\",\"sell\":\"ขาย\",\"stop\":\"ตัดขาดทุน\"},\"tooltip\":{\"f3Mode\":\"จะไม่เข้าซื้อบนแท่งสีแดงหรือขายบนแท่งสีน้ำเงินทันที โหมดรอราคาย่อตัวจะรอให้ราคากลับมาที่เส้นบนแท่งสีที่ถูกต้อง ส่วนปฏิเสธจะตัดสัญญาณนั้นทิ้ง\",\"f4Min\":\"ความเร็วที่สองเส้นแยกออกจากกันบนแท่งสัญญาณ เส้นที่พันกันและแบนราบไม่มีพื้นที่ให้ราคาไปต่อ\",\"f6Reward\":\"ระดับเส้นประถัดไปต้องห่างอย่างน้อยเท่านี้ ค่าเริ่มต้นปิดไว้ เพราะตัวสแกนใช้วิธีสร้างระดับของตัวเอง จึงควรดูระยะด้วยตาอีกครั้ง\",\"f7Pips\":\"หลีกเลี่ยงกรอบพักตัวกว้างไม่เกิน 100 ปิ๊ป\",\"longMode\":\"238 เป็นค่ามาตรฐานสำหรับกราฟหนึ่งนาที การปรับอัตโนมัติจะปรับเส้นความปลอดภัยตามกรอบเวลาอื่น เช่น ประมาณ 83 บนกราฟสามนาที\",\"pipIn\":\"อัตโนมัติ: 0.10 สำหรับทองคำ และสิบช่วงราคาขั้นต่ำสำหรับสินทรัพย์อื่น (1 จุดบน US30)\",\"showGuide\":\"คำอธิบายสั้นบนกราฟ ปิดได้เมื่อคุ้นเคยกับสัญลักษณ์แล้ว\",\"showLadder\":\"จุดเข้า จุดตัดขาดทุน และเป้าหมายของการเทรดล่าสุดแสดงทางขวาของแท่งสุดท้าย เป้าหมายที่แตะแล้วจะมีเครื่องหมายถูก\",\"showWhy\":\"เมื่อเส้นตัดกันแต่เงื่อนไขขวางการเทรด แผงปัจจุบันจะแสดงว่าเป็นเงื่อนไขใดและเพราะอะไร\",\"slMinPips\":\"จุดตัดขาดทุนอยู่เลยทั้งเส้นสีแดงและสีน้ำเงิน โดยห่างจากสีน้ำเงินอย่างน้อย 10 ปิ๊ป\",\"srMax\":\"เก็บเฉพาะระดับที่ใกล้ราคาที่สุดเพื่อให้กราฟอ่านง่าย\",\"theme\":\"เลือกให้ตรงกับธีม TradingView เพื่อให้เห็นทุกสีชัดเจน\",\"tz\":\"ช่วงเทรดอ้างอิงเขตเวลานี้ America/Denver คือเวลาภูเขาอเมริกาเหนือที่ปรับเวลาออมแสง ใช้ America/Phoenix หากต้องการเวลาภูเขาที่ไม่ปรับตามฤดูกาล\"},\"trendTable\":{\"above\":\"เหนือ\",\"below\":\"ใต้\",\"down\":\"ลง\",\"notAvailable\":\"ไม่มีข้อมูล\",\"up\":\"ขึ้น\",\"volumeLine\":\"เส้นปริมาณซื้อขาย\"}}"),
	bearish: "ขาลง",
	bfs: {
		duplicateRemoved: "รองรับอินดิเคเตอร์ BFS — Blessed Flow System ได้เพียงหนึ่งตัวต่อกราฟ จึงลบตัวที่ซ้ำออกแล้ว",
		emaCrossSoon: "EMA30/50 ใกล้ตัดกัน",
		engineOff: "เปลี่ยนไป M1",
		engineOn: "เอนจิน M1",
		input: {
			armWin: "ช่วงเวลา (แท่ง M1) ที่ให้ราคาแตะ EMA30",
			asiaSess: "เอเชีย (HHMM-HHMM)",
			bePts: "BE: เมื่อกำไร +จุด สต็อปจะเลื่อนไปที่ระดับนั้นพอดี",
			cooldown: "เว้นระยะ (แท่ง M1) หลังปิดออร์เดอร์",
			lenFast: "EMA เร็ว (ทิศทาง)",
			lenH1a: "H1 · EMA สั้น",
			lenH1b: "H1 · EMA ยาว",
			lenMid: "EMA กลาง",
			lenSlow: "EMA ช้า",
			londonSess: "ลอนดอน (HHMM-HHMM, เวลาเซสชัน)",
			maxPerBlock: "จำนวนการเข้าสูงสุดต่อช่วงเซสชัน (0 = ไม่จำกัด)",
			nearLb: "จำนวนแท่งที่ใช้วัดการบีบตัว",
			nearPts: "ระยะห่าง EMA30-EMA50 มากสุด (จุด)",
			nySess: "นิวยอร์ก (HHMM-HHMM)",
			onlyM1: "รันเอนจินบน M1 เท่านั้น",
			pv: "มูลค่าราคาต่อ 1 จุด",
			r1lb: "R1 · จำนวนแท่ง M1 ย้อนหลัง (ราคายังไม่ยืดเกิน)",
			rr: "อัตรา TP R:R (เมื่อปิดการใช้ TP หลายชั้น)",
			rsiHi: "RSI >= สำหรับ SHORT",
			rsiLen: "ความยาว RSI",
			rsiLo: "RSI <= สำหรับ LONG",
			rsiWin: "ช่วงรอ (แท่งเทียนหลังสัญญาณ)",
			showLevels: "วาดระดับราคาของออร์เดอร์",
			showNear: "ทำเครื่องหมายเมื่อ EMA30 ใกล้ตัด EMA50",
			slPts: "SL (จุด)",
			swLenA: "ความแข็งแรงของ pivot (แท่งเทียนแต่ละข้าง)",
			tp1Pts: "TP1 (จุด)",
			tp2Pts: "TP2 (จุด)",
			tp3Pts: "TP3 (จุด)",
			tzOffset: "ส่วนต่าง UTC ของเวลาเซสชัน (โบโกตา = -5)",
			useArm: "ต้องย่อตัว 50% และแตะ EMA30 ภายในช่วงที่กำหนด",
			useAsia: "รวมเซสชันเอเชีย (สำหรับทดสอบเท่านั้น)",
			useBE: "เปิดใช้จุดคุ้มทุน",
			useLadder: "ใช้ TP1/TP2/TP3 (ออกครั้งสุดท้าย = TP3)",
			useR2: "R2 · ต้องเรียง M5 + M15 และมีทิศทาง H1",
			useRSI: "รอ RSI หลังเกิดสัญญาณ",
			useSess: "กรองตามเซสชัน",
			useTrend: "คงลำดับของ EMA ไว้ระหว่างที่รอ"
		},
		longSignal: "สัญญาณ Long",
		noSignal: "ไม่มีสัญญาณ",
		retracementDot: "จุดย่อตัว 50%",
		rewardZone: "โซนกำไร",
		riskZone: "โซนความเสี่ยง",
		session: "เซสชัน",
		sessionClosed: "ปิดแล้ว",
		sessionOpen: "เปิดอยู่",
		shortSignal: "สัญญาณ Short",
		signal: "สัญญาณ",
		signalActive: "{{side}} กำลังทำงาน",
		waitingRsi: "รอ RSI {{arrow}} ({{n}})",
		waitingRsiLong: "รอ RSI (Long)",
		waitingRsiShort: "รอ RSI (Short)"
	},
	breakEven: "จุดคุ้มทุน",
	bullish: "ขาขึ้น",
	buy: "ซื้อ",
	colour: "สี",
	cypher: {
		above55: "สูงกว่า 55",
		aboveBelow: "เหนือ/ใต้",
		barColors: "สีแท่งเทียน",
		bbLength: "ความยาว BB",
		bbStdDev: "ส่วนเบี่ยงเบนมาตรฐาน BB {{n}}",
		bearBreak: "เบรกเอาท์ขาลง",
		bearPattern: "พินบาร์ / กลืนกินขาลง",
		below55: "ต่ำกว่า 55",
		bullBreak: "เบรกเอาท์ขาขึ้น",
		bullPattern: "พินบาร์ / กลืนกินขาขึ้น",
		cmoLength: "ความยาว CMO",
		colorCandles: "ระบายสีแท่งเทียน",
		confluenceLong: "สัญญาณรวม Long",
		confluenceShort: "สัญญาณรวม Short",
		consolidating: "สะสมตัว",
		direction: "ทิศทาง",
		emaPeriodTrend: "ช่วงเวลา EMA (แนวโน้ม)",
		flagOffsetAtr: "ระยะห่างธง (x ATR)",
		flashBackground: "พื้นหลังแฟลช",
		flashCount: "จำนวนครั้งที่แฟลช",
		flashHz: "ความเร็วแฟลช (ครั้ง / วินาที)",
		flashOn: "แฟลชเมื่อมีธงใหม่",
		flashShowBanner: "แสดงแบนเนอร์ NEW BUY / SELL",
		flashShowBg: "แฟลชพื้นหลังกราฟ",
		flashStrength: "ความเข้มของแฟลชพื้นหลัง",
		flashTest: "ทดสอบแฟลชตอนนี้ (ตัวอย่าง)",
		fvgKeep: "จำนวน Fair Value Gap ต่อฝั่ง",
		glowOpacity: "ความทึบของแสงเรือง (สูงขึ้น = โปร่งใสขึ้น)",
		glowSizeTicks: "ขนาดแสงเรือง (tick)",
		groupFlash: "การแจ้งเตือนธงใหม่",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "ระดับ KDE",
		groupKeyLevels: "ระดับสำคัญ",
		groupLrEma: "ช่อง LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivot",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "แถบการกลับตัว",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "ส่วนประกอบ",
		groupTrendTable: "ตารางแนวโน้ม",
		groupVidya: "VIDYA / แนวโน้ม",
		halfTrendAmplitude: "แอมพลิจูด HalfTrend",
		halfTrendChannelDeviation: "ค่าเบี่ยงเบนช่อง HalfTrend",
		ichimokuBase: "เส้น Base ของ Ichimoku",
		ichimokuConversion: "เส้น Conversion ของ Ichimoku",
		kdeActivation: "เปิดใช้เกณฑ์การเปิดใช้งาน",
		kdeBins: "จำนวนช่อง",
		kdeThreshold: "เกณฑ์ %",
		labelPosition: "ตำแหน่งป้าย",
		lineWidth: "ความหนาเส้น",
		lowerBb: "BB{{n}} ล่าง",
		lowerInnerZone: "โซนด้านในล่าง",
		lowerReversalZone: "โซนกลับตัวด้านล่าง",
		maCloudLong: "เมฆ MA (ยาว)",
		maCloudShort: "เมฆ MA (สั้น)",
		newBuy: "ซื้อใหม่",
		newSell: "ขายใหม่",
		numberOfLevels: "จำนวนระดับ",
		parabolicSar: "Parabolic SAR",
		pivotAuto: "อัตโนมัติ",
		pivotDaily: "รายวัน",
		pivotMonthly: "รายเดือน",
		pivotsTimeframe: "กรอบเวลา Pivot",
		pivotWeekly: "รายสัปดาห์",
		positionBottomCenter: "ล่างกลาง",
		positionBottomLeft: "ล่างซ้าย",
		positionBottomRight: "ล่างขวา",
		positionLeft: "ซ้าย",
		positionRight: "ขวา",
		positionTopCenter: "บนกลาง",
		positionTopLeft: "บนซ้าย",
		positionTopRight: "บนขวา",
		psarBear: "PSAR ขาลง",
		psarBull: "PSAR ขาขึ้น",
		psarIncrement: "ค่าเพิ่ม PSAR",
		psarMax: "ค่าสูงสุด PSAR",
		psarStart: "ค่าเริ่มต้น PSAR",
		pullingBack: "ย่อตัว",
		pulseSmoothingBars: "จำนวนแท่งปรับเรียบ Pulse",
		reEntry: "เข้าซ้ำ",
		rightOffsetBars: "ระยะห่างด้านขวา (แท่ง)",
		showCamarillaPivots: "แสดงจุด Pivot Camarilla",
		showConfluenceFlag: "แสดงธงสัญญาณรวม (B/S)",
		showFvg: "Fair Value Gap (15 นาทีขึ้นไป)",
		showKde: "ระดับวอลุ่ม KDE",
		showKeyLevels: "แสดงระดับสำคัญ",
		showLabels: "แสดงป้าย",
		showLevelGlow: "แสดงแสงเรืองของระดับ",
		showMaCloud: "แสดงเมฆ MA",
		showPrices: "แสดงราคา",
		showPsar: "แสดง PSAR",
		showReversalBands: "แสดงแถบการกลับตัว",
		showSlTpLabels: "แสดงป้าย SL / TP",
		showSniperBreakArrows: "แสดงลูกศร Sniper / เบรกเอาท์",
		showTrendTable: "แสดงตารางแนวโน้ม",
		showVidya233: "แสดง VIDYA 233",
		showVidya55: "แสดง VIDYA 55",
		showVidya987: "แสดง VIDYA 987 (แม่เหล็ก)",
		showVidyaLines: "แสดงเส้น VIDYA",
		sizeNormal: "ปกติ",
		sizeSmall: "เล็ก",
		sizeTiny: "เล็กมาก",
		slBufferAtr: "SL เพดานบัฟเฟอร์ (x ATR)",
		slBufferPips: "SL บัฟเฟอร์เลยสวิง (pips)",
		slMaxRiskAtr: "SL ความเสี่ยงสูงสุด (x ATR)",
		slSwingLookback: "SL ช่วงย้อนหลังสวิง (แท่ง)",
		sniperDown: "Sniper ลง",
		sniperUp: "Sniper ขึ้น",
		source: "แหล่งข้อมูล",
		state: "สถานะ",
		strength: "ความแข็งแกร่ง",
		strong: "แข็งแกร่ง",
		superTrend2AtrLength: "ความยาว ATR SuperTrend 2",
		superTrend2Factor: "แฟกเตอร์ SuperTrend 2",
		superTrendAtrLength: "ความยาว ATR SuperTrend",
		superTrendMultiplier: "ตัวคูณ SuperTrend",
		tablePosition: "ตำแหน่งตาราง",
		tableSize: "ขนาดตาราง",
		tpRiskReward: "TP {{n}} ความเสี่ยง/ผลตอบแทน",
		tradeManagement: "การจัดการเทรด (SL / TP)",
		trend: "แนวโน้ม",
		trending: "มีแนวโน้ม",
		upperBb: "BB{{n}} บน",
		upperInnerZone: "โซนด้านในบน",
		upperReversalZone: "โซนกลับตัวด้านบน",
		veryStrong: "แข็งแกร่งมาก",
		veryWeak: "อ่อนมาก",
		vidya987Magnet: "VIDYA 987 (แม่เหล็ก)",
		volumeAvgLength: "ความยาวเฉลี่ยปริมาณ (ตัวกรองเบรกเอาท์)",
		weak: "อ่อน",
		zoneEdge: "{{name}} (ขอบการเติมสี)"
	},
	entry: "จุดเข้า",
	gainColor: "สีกำไร",
	harsiCandle: "แท่งเทียน HARSI",
	harsiLength: "ความยาว HARSI",
	heikinAshiRsiOscillator: "ตัวแกว่ง RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "ค่าหลัก 'นี่จะเปลี่ยนความไว'",
	labelsIndicator: "ตัวบ่งชี้ป้าย",
	london: "ลอนดอน",
	londonBackground: "พื้นหลังลอนดอน",
	londonSession: "ช่วงลอนดอน",
	long: "Long",
	lossColor: "สีขาดทุน",
	median: "ค่ามัธยฐาน",
	neutral: "เป็นกลาง",
	newYork: "นิวยอร์ก",
	newYorkBackground: "พื้นหลังนิวยอร์ก",
	newYorkSession: "ช่วงนิวยอร์ก",
	openSmoothing: "การปรับเรียบราคาเปิด",
	optimus: {
		activeTradeLevels: "ออร์เดอร์ที่เปิดอยู่ · ระดับราคา",
		bias: "ทิศทาง",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "ผสม {{n}}/{{total}}",
		disclaimer: "ระดับราคาถูกวาดไว้บนกราฟ ไม่ใช่คำแนะนำการลงทุน",
		duplicateRemoved: "รองรับอินดิเคเตอร์ Optimus Prime ได้เพียงหนึ่งตัวต่อกราฟ จึงลบตัวที่ซ้ำออกแล้ว",
		enter: "เข้า · {{side}}",
		input: {
			atrLength: "ความยาว ATR ของ KC",
			buffer: "ส่วนเผื่อของสวิง (เป็นราคา)",
			emaLength: "ความยาว EMA",
			kcLength: "ความยาว KC",
			kcMult: "ตัวคูณ KC",
			lrcLength: "ความยาว LRC",
			minRisk: "ความเสี่ยง R ต่ำสุด (เป็นราคา)",
			requireAlign: "ต้องให้ EMA และ LRC ไปทางเดียวกัน",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "จำนวนแท่งย้อนหลังของสวิง (R)"
		},
		kcLower: "KC ล่าง",
		kcMid: "KC กลาง",
		kcUpper: "KC บน",
		keltnerFill: "พื้นที่ Keltner",
		noClosedTrades: "ยังไม่มีออร์เดอร์ที่ปิดแล้ว",
		reasonForming: "รูปแบบกำลังก่อตัว — รอการยืนยัน",
		reasonLatched: "ล็อกออร์เดอร์แล้ว · ระดับราคาอยู่บนกราฟ",
		reasonNoSetup: "ยังไม่มีรูปแบบ · EMA/LRC ไม่ไปทางเดียวกัน",
		recentSignals: "สัญญาณล่าสุด",
		riskReward: "ความเสี่ยง/ผลตอบแทน",
		trendMtf: "เทรนด์ · หลายไทม์เฟรม",
		wait: "รอ",
		warmingUp: "กำลังเริ่มระบบ"
	},
	overbought: "ซื้อมากเกินไป",
	overboughtMax: "ซื้อมากเกินไป สูงสุด",
	overboughtMin: "ซื้อมากเกินไป ต่ำสุด",
	oversold: "ขายมากเกินไป",
	oversoldMax: "ขายมากเกินไป สูงสุด",
	oversoldMin: "ขายมากเกินไป ต่ำสุด",
	rsiLength: "ความยาว RSI",
	rsiLine: "เส้น RSI",
	rsiLineShadow: "เงาเส้น RSI",
	sell: "ขาย",
	short: "Short",
	signalsFromHeikinAshiCandles: "สัญญาณจากแท่งเทียน Heikin Ashi",
	sl: "SL",
	smoothedMode: "โหมดปรับเรียบ",
	sydney: "ซิดนีย์",
	sydneyBackground: "พื้นหลังซิดนีย์",
	sydneySession: "ช่วงซิดนีย์",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "โตเกียว",
	tokyoBackground: "พื้นหลังโตเกียว",
	tokyoSession: "ช่วงโตเกียว",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "ขาลง",
			bullish: "ขาขึ้น",
			confluence: "จุดบรรจบ",
			entry: "จุดเข้า",
			neckline: "เนคไลน์",
			score: "คะแนน",
			state: "สถานะ",
			states: {
				completed: "เสร็จสมบูรณ์",
				invalidated: "ใช้ไม่ได้",
				projected: "คาดการณ์",
				przActive: "PRZ ทำงานอยู่",
				stopped: "ถึงจุดตัดขาดทุน"
			},
			stop: "จุดตัดขาดทุน",
			target: "เป้าหมาย"
		},
		classic: {
			doubleBottom: "ดับเบิลบอตทอม",
			doubleTop: "ดับเบิลท็อป",
			headAndShoulders: "หัวและไหล่",
			inverseHeadAndShoulders: "หัวและไหล่กลับหัว",
			tripleBottom: "ทริปเปิลบอตทอม",
			tripleTop: "ทริปเปิลท็อป"
		},
		direction: {
			bearishOnly: "ขาลงเท่านั้น",
			both: "ทั้งสองทิศทาง",
			bullishOnly: "ขาขึ้นเท่านั้น"
		},
		group: {
			classics: "รูปแบบคลาสสิกและ S/R",
			filters: "ตัวกรองและการแสดงผล",
			patterns: "รูปแบบ",
			pivotEngine: "เอนจินพิวอต",
			ratios: "อัตราส่วนและค่าเผื่อ"
		},
		input: {
			atrLen: "ช่วงเวลา ATR",
			atrMult: "การกลับตัวของซิกแซก (x ATR)",
			colBear: "ขาลง",
			colBull: "ขาขึ้น",
			colPrz: "PRZ",
			colSR: "ระดับสำคัญ",
			dirFilter: "ตัวกรองทิศทาง",
			enClassics: "ตรวจจับรูปแบบคลาสสิก",
			enDoubles: "ดับเบิลท็อป / บอตทอม",
			enHS: "หัวและไหล่",
			enTriples: "ทริปเปิลท็อป / บอตทอม",
			fillTransp: "ความโปร่งใสของสีเติมรูปแบบ",
			formingLife: "อายุของโซนที่กำลังก่อตัว (แท่ง)",
			keepFailed: "คงรูปแบบที่ถูกหยุดขาดทุนไว้บนกราฟ (✕, สีจาง)",
			keepSuccessful: "คงรูปแบบที่สำเร็จไว้บนกราฟ (✓)",
			maxPatterns: "จำนวนรูปแบบสูงสุดบนกราฟ",
			minScore: "คะแนนคุณภาพขั้นต่ำ",
			pivotDepth: "ความลึกของบัฟเฟอร์พิวอต",
			showLetters: "แสดงตัวอักษรจุด X A B C D",
			showPlan: "แสดงระดับแผนการเทรด",
			showProjected: "แสดงรูปแบบที่คาดการณ์ (กำลังก่อตัว)",
			showRatios: "แสดงตัวเลขอัตราส่วนบนแต่ละขา",
			showSR: "ระดับแนวรับ/แนวต้าน",
			showStats: "แสดงตารางสถิติ",
			srMinTouch: "S/R: จำนวนครั้งที่แตะพิวอตขั้นต่ำ",
			tolEdge: "ค่าเผื่อที่ขอบช่วง",
			tolPoint: "ค่าเผื่ออัตราส่วนของจุด",
			useScale2: "สแกนสเกล 2x ด้วย (โครงสร้างที่ใหญ่กว่า)"
		},
		label: {
			confirmed: "ยืนยันแล้ว",
			forming: "กำลังก่อตัว",
			sl: "SL",
			target: "เป้าหมาย",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "เสร็จสิ้น",
			stops: "หยุดขาดทุน",
			t1Wins: "ถึง T1",
			winRate: "อัตราชนะ %"
		},
		tooltip: {
			colPrz: "PRZ เป็นสีอำพันไม่ว่ารูปแบบจะไปทิศทางใด (ค่าเริ่มต้นของ ProTrader)",
			fillTransp: "ค่ายิ่งต่ำ สีเติมยิ่งเห็นชัด ประมาณ 65-80 ใช้ได้ดี",
			formingLife: "รูปแบบที่กำลังก่อตัวซึ่งจุด C เก่ากว่าค่านี้ และยังไม่สมบูรณ์หรือยังไม่ถูกยกเลิก จะหมดอายุและถูกลบ",
			maxPatterns: "รูปแบบที่เก่าที่สุดจะถูกลบก่อน ประวัติล่าสุด (✓ / ✕) และโซนที่กำลังก่อตัวใหม่จึงยังมองเห็นได้เสมอ",
			showProjected: "วาดโครงสร้าง X-A-B พร้อมเส้นนำทางแบบเส้นประไปยัง PRZ ที่คาดการณ์",
			showRatios: "เส้นทแยงสำหรับวัดแบบเส้นจุด (X-B, A-C, B-D, X-D) พร้อมอัตราส่วน Fibonacci ที่วัดได้ตรงกึ่งกลางของแต่ละเส้น ซึ่งเป็นการกำกับมาตรฐานของกราฟฮาร์มอนิก",
			tolPoint: "ใช้กับอัตราส่วนที่แม่นยำ เช่น Gartley B=0.618 เข้มงวด = 0.03, สมดุล = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ ปิดทั้งหมด",
		duplicateRemoved: "รองรับอินดิเคเตอร์ Trade Finder ได้เพียงหนึ่งตัวต่อกราฟ จึงลบตัวที่ซ้ำออกแล้ว",
		durationHm: "{{h}} ชม {{m}} นาที",
		durationM: "{{m}} นาที",
		emaEntry1: "EMA จุดเข้า 1",
		emaEntry2: "EMA จุดเข้า 2 / เทรนด์",
		emaRangeFilter: "EMA ตัวกรองกรอบราคา",
		emaTrigger: "EMA ทริกเกอร์",
		entry1: "จุดเข้า 1",
		entry2: "จุดเข้า 2",
		entry2Mark: "E2",
		entryZoneBear: "โซนเข้า {{n}} (ขาลง)",
		entryZoneBull: "โซนเข้า {{n}} (ขาขึ้น)",
		frameFailed: "โหลดไทม์เฟรม {{frame}} ไม่สำเร็จ ระบบจะลองใหม่",
		framesUnavailable: "ไม่มีข้อมูลไทม์เฟรม · รอ",
		ghostEntry: "เซ็ตอัปก่อนหน้า",
		ghostStop: "Stop ก่อนหน้า",
		group: {
			bias: "ไบอัส",
			display: "การแสดงผล",
			emaSystem: "ระบบ EMA",
			entries: "การเข้า",
			filter: "ตัวกรอง",
			riskManagement: "การบริหารความเสี่ยง",
			session: "เซสชัน",
			supportResistance: "แนวรับและแนวต้าน",
			trailingStop: "Stop แบบเลื่อนตาม",
			trendPanel: "แผงเทรนด์"
		},
		input: {
			adxLen: "ความยาว ADX",
			adxSmoothing: "การปรับเรียบ ADX",
			asiaSession: "เซสชันเอเชีย / โตเกียว (UTC)",
			atrBufferMultBtc: "ระยะเผื่อ Stop หลังสวิง — BTC (× ATR)",
			atrBufferMultGold: "ระยะเผื่อ Stop หลังสวิง — ทองคำ (× ATR)",
			atrBufferMultOther: "ระยะเผื่อ Stop หลังสวิง — อื่น ๆ (× ATR)",
			atrLength: "ความยาว ATR (การบริหารความเสี่ยง)",
			atrSlMult: "Stop Loss = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "ทองคำ: เลื่อนมาจุดคุ้มทุนหลังได้กำไรกี่จุด",
			biasEmaLen: "ความยาว EMA ของไบอัส",
			crossLookback: "ช่วงนับการตัดกันของไบอัส (แท่ง)",
			dxySymbol: "สัญลักษณ์ดัชนีดอลลาร์ (เว้นว่างเพื่อปิด)",
			emaBigLen: "ความยาว EMA ตัวกรองกรอบราคา",
			emaFastLen: "ความยาว EMA จุดเข้า 1",
			emaMidLen: "ความยาว EMA จุดเข้า 2 / เทรนด์",
			emaTriggerLen: "ความยาว EMA ทริกเกอร์",
			feeBufferPct: "ระยะเผื่อค่าธรรมเนียมเหนือจุดคุ้มทุน (%)",
			flatThreshPct: "เกณฑ์แนวราบ (% ของ EMA ไบอัส)",
			londonSession: "เซสชันลอนดอน (UTC)",
			maxCrosses: "จำนวนการตัดกันสูงสุดก่อนตัดไบอัสทิ้ง",
			newYorkSession: "เซสชันนิวยอร์ก (UTC)",
			showEmaLabels: "แสดงป้ายชื่อ EMA",
			showEntrySignals: "แสดงเครื่องหมายเซ็ตอัป",
			showEntryZone: "แสดงโซนเข้า",
			showSRLines: "แสดงแนวรับและแนวต้าน",
			showTradeLevels: "แสดงระดับจุดเข้า Stop และเป้าหมาย",
			slMaxPointsBtc: "ระยะ Stop สูงสุด — BTC (จุด)",
			slMaxPointsGold: "ระยะ Stop สูงสุด — ทองคำ (จุด)",
			slMaxPointsIndex: "ระยะ Stop สูงสุด — ดัชนี (จุด)",
			slMaxPointsOther: "ระยะ Stop สูงสุด — อื่น ๆ (จุด)",
			slMinPointsGold: "ระยะ Stop ต่ำสุด — ทองคำ (จุด)",
			slopeLookback: "ช่วงความชันของไบอัส (แท่ง)",
			srLeftBars: "แนวรับ / แนวต้าน · แท่งเทียนทางซ้ายของพิวอต",
			srRightBars: "แนวรับ / แนวต้าน · แท่งเทียนทางขวาของพิวอต",
			swingPivotLen: "ความยาวพิวอตสวิง (Stop Loss)",
			tp1ClosePct: "ปิดที่ TP1 %",
			tp2ClosePct: "ปิดที่ TP2 %",
			tp5CloseAlways: "TP5 ปิดเสมอ แม้กำลังเลื่อน Stop",
			tpR: "TP{{n}} (หน่วย R)",
			tpSlMode: "โหมด Stop และเป้าหมาย",
			trailAtrMult: "ระยะ Stop แบบเลื่อนตาม (× ATR)",
			trendPanelEmaLen: "ความยาว EMA ของแถวเทรนด์",
			trendSlopeLB: "จำนวนแท่งย้อนหลังของความชัน EMA จุดเข้า 2",
			useAdxFilter: "บังคับให้ ADX สูงกว่าเกณฑ์ของโหมด",
			useBiasFilter: "ให้คะแนนไบอัสไทม์เฟรมสูงกว่า (ไม่บล็อกการเข้า)",
			useEmaStackCheck: "ต้องให้ EMA เรียงลำดับถูกต้อง",
			useInstrumentAutoDetect: "ตรวจจับสินทรัพย์อัตโนมัติ",
			useSessionFilter: "ส่งสัญญาณเฉพาะช่วงเซสชันการเทรด",
			useSlopeDynamic: "ปรับจำนวนแท่งความชันตามไทม์เฟรม",
			useStrictCandle: "ตัวกรองแท่งเทียนเข้มงวด (ไส้และราคาปิด)",
			useTrailingStop: "Stop แบบเลื่อนตาม (เริ่มจาก TP1)",
			useVolumeConfirm: "ต้องมีวอลุ่มสูงกว่าค่าเฉลี่ยตอนเข้า",
			volAvgLen: "ความยาวค่าเฉลี่ยวอลุ่ม",
			volMultiplier: "วอลุ่มขั้นต่ำ (× ค่าเฉลี่ย)"
		},
		maxStop: "SL สูงสุด",
		minuteAgainst: "ตัดสวนทางกับเซตอัป",
		minuteOk: "ไม่มีคำเตือน",
		minuteReversal: "ตัดกัน · อาจกลับตัว",
		modeAtr: "ATR",
		modeAuto: "อัตโนมัติ",
		modeRiskReward: "ความเสี่ยง / ผลตอบแทน",
		noBias: "ไม่มีแนวโน้ม",
		noSetup: "ไม่มีเซ็ตอัปที่ใช้งาน",
		recentTitle: "เซ็ตอัปล่าสุด",
		reEntry: "เข้าซ้ำ",
		reEntryMark: "RE",
		rest: "ส่วนที่เหลือ",
		rowBias: "แนวโน้มหลัก",
		rowContext: "บริบท",
		rowInfo: "ข้อมูล",
		rowSession: "เซสชัน",
		rowSetup: "เซ็ตอัป",
		rowVolume: "วอลุ่ม",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "เหลือ {{time}}",
		sessionOutside: "นอกเวลาทำการ · ลอนดอน {{time}} UTC",
		sessionOverlap: "ช่วงคาบเกี่ยว",
		statsTitle: "{{n}} เซ็ตอัปล่าสุด",
		statusBreakEvenSet: "เท่าทุน",
		statusMoveToBreakEven: "เลื่อนสต็อป",
		statusPending: "แตะโซน",
		statusRunning: "กำลังเทรด",
		statusSpike: "ผันผวน · รอ",
		statusWaiting: "รอสัญญาณ",
		stopHit: "ชน Stop",
		styleDaytrade: "เดย์เทรด",
		styleScalping: "สแกลป์",
		styleSwing: "สวิง",
		subFrameReversal: "ไทม์เฟรมย่อยกำลังกลับตัว",
		targetHit: "ถึงเป้าหมายสุดท้าย",
		trailStop: "Stop แบบเลื่อนตาม",
		volAboveAverage: "สูงกว่าค่าเฉลี่ย",
		volBelowAverage: "ต่ำกว่าค่าเฉลี่ย",
		zoneEdgeBear: "ขอบโซน {{n}} (ขาลง)",
		zoneEdgeBull: "ขอบโซน {{n}} (ขาขึ้น)"
	},
	tradingSessions: "ช่วงเวลาการซื้อขาย",
	unintendedSymbol: "กลยุทธ์นี้ออกแบบมาสำหรับ {{symbols}} ระดับราคาของมันอาจไม่มีความหมายบน {{symbol}}",
	utBotAlerts: "การแจ้งเตือน UT Bot"
}, xe = {
	asia: "Asya",
	atrPeriod: "ATR Periyodu",
	auraScanner: {
		guide: {
			bigDiamondMark: "Büyük kırmızı/yeşil",
			bigDiamondMeaning: "Tepe üstündeki büyük kırmızı eşkenar dörtgen alış için uyarır. Dip altındaki büyük yeşil ise satış için uyarır.",
			blueMark: "Mavi eğri",
			blueMeaning: "50 EMA. Pembe mavinin üstündeyse alış, altındaysa satış.",
			dashedMark: "Kesikli çizgiler",
			dashedMeaning: "Destek ve direnç. Kırmızı fiyatın altında, yeşil üstünde.",
			diamondsMark: "Eşkenar dörtgenler",
			diamondsMeaning: "Dönüş noktaları. Altın renk en zayıfı, sonra mavi, kırmızı ve yeşil.",
			flatGoldMark: "Yatay altın çizgi",
			flatGoldMeaning: "15 dakikalık grafikte son altı saatin en yüksek hacimli fiyat seviyesi.",
			levelsMark: "Seviye çizgileri",
			levelsMeaning: "Son işlemin giriş, zarar durdurma ve hedefleri. Onay işareti ulaşıldığını gösterir.",
			pinkMark: "Pembe eğri",
			pinkMeaning: "20 EMA. Mavi çizgiyle kesişmesi sinyal üretir.",
			subtitle: "Bu grafik nasıl okunur",
			thickGoldMark: "Kalın altın çizgi",
			thickGoldMeaning: "238 çizgisi. Giriş ile hedef arasındaysa işlemi atlayın.",
			title: "AURA",
			triangleMark: "Üçgen",
			triangleMeaning: "Tüm kontrolleri geçen işlem. Değerleri görmek için imleci üzerine getirin."
		},
		groups: {
			display: "Görünüm",
			eightChecks: "Sekiz kontrol",
			riskAndTargets: "Risk ve hedefler",
			signalEngine: "Sinyal motoru"
		},
		inputs: {
			emaFastLen: "Hızlı çizgi (pembe)",
			emaSlowLen: "Yavaş çizgi (mavi)",
			f1Clock: "1. Yalnızca iyi hacim aralığında",
			f2Trend: "2. 15 dakikalık eğilimle uyumlu",
			f3Mode: "3. Yanlış renkli mum",
			f4Min: "En az açılma (mum başına pip)",
			f4Sep: "4. Çizgiler birbirinden uzaklaşıyor",
			f5Clear: "5. 238 giriş ile hedef arasında değil",
			f6R: "En az alan (× risk)",
			f6Reward: "6. Sonraki seviyeye kadar alan",
			f7Bars: "Son mum sayısı",
			f7Consol: "7. Yatay aralıkta sıkışmamış",
			f7Pips: "Aralık bundan büyük olmalı (pip)",
			f9Bars: "Son N mum içinde",
			f9Star: "8. Büyük uyarı eşkenar dörtgeni yok",
			guidePos: "Kılavuz panelinin konumu",
			longMode: "Güvenlik çizgisi (238) modu",
			panelSize: "Panel yazı boyutu",
			pipIn: "Pip boyutu (0 = otomatik)",
			showClock: "Şu an paneli",
			showGuide: "İşaretleri açıklayan kılavuz paneli",
			showLadder: "Sağdaki işlem seviyeleri",
			showPoc: "Hacim çizgisi",
			showSr: "Kesikli seviyeler",
			showStars: "Uyarı eşkenar dörtgenleri",
			showTable: "Eğilim tablosu",
			showTint: "Arka plan rengi",
			showWhy: "Atlanan sinyalleri açıkla",
			slMinPips: "Yavaş çizginin ötesinde en az mesafe (pip)",
			srAtrMove: "Seviyeler: gerekli tepki (× olağan mum boyutu)",
			srLookback: "Seviyeler: dönüş noktası geçmişi",
			srMax: "Ekranda tutulacak en fazla seviye",
			srRange: "Bundan uzak seviyeleri yok say (× olağan mum boyutu)",
			srReset: "Seviyeler: kaldırılmadan önce yeniden test sayısı",
			stripLen: "Sağ sütunun genişliği (mum)",
			tablePos: "Şu an panelinin konumu",
			theme: "Grafik teması",
			tp1R: "TP1 (R katı)",
			tp2R: "TP2 (R katı)",
			trendPos: "Eğilim tablosunun konumu",
			tz: "İşlem saatlerinin saat dilimi"
		},
		ladder: {
			closedAtStop: "ZARAR DURDURMADA KAPANDI",
			closedAtTarget: "KAPANDI TP{{hit}}",
			entry: "GİRİŞ",
			stop: "ZARAR DURDUR",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Otomatik ölçekle",
			bottomCentre: "Alt orta",
			bottomLeft: "Alt sol",
			bottomRight: "Alt sağ",
			dark: "Koyu",
			ignore: "Yok say",
			large: "Büyük",
			light: "Açık",
			literal238: "Sabit 238",
			middleCentre: "Tam orta",
			middleLeft: "Orta sol",
			middleRight: "Orta sağ",
			normal: "Standart",
			reject: "Reddet",
			small: "Küçük",
			topCentre: "Üst orta",
			topLeft: "Üst sol",
			topRight: "Üst sağ",
			waitForPullback: "Geri çekilmeyi bekle"
		},
		reasons: {
			clock: "işlem saatleri dışında",
			diamond: "az önce büyük bir uyarı eşkenar dörtgeni oluştu",
			range: "grafik yatay sıkışmada",
			room: "seviye çok yakın, hedefe kadar alan yok",
			safetyLine: "238 giriş ile hedef arasında",
			separation: "iki çizgi çok yakın, henüz hareket alanı yok",
			trend: "15 dakikalık eğilime karşı",
			wrongColour: "kesişim mumu yanlış renkte kapandı"
		},
		rightNow: {
			aBuy: "Alış",
			aSell: "Satış",
			bestBuysOnly: "yalnızca alış ara",
			bestNow: "Şu an en iyisi",
			bestSellsOnly: "yalnızca satış ara",
			bestWaitThin: "bekle, hacim düşük",
			goodVolume: "İyi hacim",
			lowVolume: "Düşük hacim",
			safetyAbove: "238 fiyatın üstünde, satış için alan var",
			safetyBelow: "238 fiyatın altında, alış için alan var",
			safetyLine: "Güvenlik çizgisi",
			skipped: "Atlandı",
			skippedAgo_one: "{{bars}} mum önce {{side}}: {{reason}}",
			skippedAgo_other: "{{bars}} mum önce {{side}}: {{reason}}",
			skippedNothing: "henüz atlanan yok",
			title: "ŞU AN",
			trend: "Eğilim",
			trendSummaryDown: "15m aşağı, 6 zaman diliminin {{agree}} tanesi yukarı",
			trendSummaryUp: "15m yukarı, 6 zaman diliminin {{agree}} tanesi yukarı"
		},
		signal: {
			buy: "ALIŞ",
			pips: "pip",
			sell: "SATIŞ",
			stop: "Zarar durdur"
		},
		tooltip: {
			f3Mode: "Kırmızı mumdaki alış veya mavi mumdaki satış doğrudan alınmaz. Geri çekilmeyi bekle, doğru renkte bir mumda fiyatın çizgilere dönmesini bekler. Reddet sinyali eler.",
			f4Min: "Sinyal mumunda iki çizginin ne hızla uzaklaştığı. Birbirine dolanmış yatay çizgiler hareket alanı bırakmaz.",
			f6Reward: "Sonraki kesikli seviye en az bu kadar uzakta olmalı. Varsayılan olarak kapalıdır: tarayıcı seviyeleri kendi yöntemiyle çizer; bu yüzden alanı gözle de kontrol edin.",
			f7Pips: "100 pip veya daha dar sıkışmalardan uzak durun.",
			longMode: "238, bir dakikalık grafikler için standart ayardır. Otomatik ölçekleme güvenlik çizgisini diğer zaman dilimlerine uyarlar; üç dakikalık grafikte yaklaşık 83.",
			pipIn: "Otomatik: altında 0.10, diğer araçlarda on tik (US30 için 1 puan).",
			showGuide: "Grafikte kısa bir açıklama. İşaretleri öğrendikten sonra kapatın.",
			showLadder: "Son işlemin giriş, zarar durdurma ve hedefleri son mumun sağına çizilir. Ulaşılan hedefler onay işareti alır.",
			showWhy: "Çizgiler kesiştiğinde bir kontrol işlemi engellerse Şu an paneli hangi kontrol olduğunu ve nedenini açıklar.",
			slMinPips: "Zarar durdurma hem kırmızı hem mavi çizginin ötesine, maviden en az 10 pip uzağa yerleştirilir.",
			srMax: "Grafiğin okunabilir kalması için yalnızca fiyata en yakın seviyeler tutulur.",
			theme: "Tüm renklerin net görünmesi için TradingView temanızla eşleştirin.",
			tz: "İşlem aralıkları bu saat dilimine göre belirlenir. America/Denver, yaz saati uygulayan Kuzey Amerika Dağ Saatidir. Yaz saati olmadan Dağ Saati için America/Phoenix kullanın."
		},
		trendTable: {
			above: "üstünde",
			below: "altında",
			down: "Aşağı",
			notAvailable: "veri yok",
			up: "Yukarı",
			volumeLine: "Hacim çizgisi"
		}
	},
	bearish: "Düşüş",
	bfs: {
		duplicateRemoved: "Grafik başına yalnızca bir BFS — Blessed Flow System göstergesi desteklenir; kopyası kaldırıldı.",
		emaCrossSoon: "EMA30/50 kesişmek üzere",
		engineOff: "M1'e geçin",
		engineOn: "motor M1",
		input: {
			armWin: "EMA30'a temas için pencere (M1 mumu)",
			asiaSess: "Asya (HHMM-HHMM)",
			bePts: "BE: +puanda stop TAM o seviyeye taşınır",
			cooldown: "İşlem kapandıktan sonra bekleme (M1 mumu)",
			lenFast: "Hızlı EMA (yön)",
			lenH1a: "H1 · kısa EMA",
			lenH1b: "H1 · uzun EMA",
			lenMid: "Orta EMA",
			lenSlow: "Yavaş EMA",
			londonSess: "Londra (HHMM-HHMM, seans saati)",
			maxPerBlock: "Seans bloğu başına azami giriş (0 = sınırsız)",
			nearLb: "Yakınsamayı ölçmek için kullanılan mumlar",
			nearPts: "Azami EMA30-EMA50 mesafesi (puan)",
			nySess: "New York (HHMM-HHMM)",
			onlyM1: "Motoru yalnızca M1'de çalıştır",
			pv: "1 puanın fiyat değeri",
			r1lb: "R1 · geriye bakılan M1 mumu (fiyat aşırı uzamamış)",
			rr: "TP oranı R:R (kademeler kapalıyken)",
			rsiHi: "SHORT için RSI >=",
			rsiLen: "RSI uzunluğu",
			rsiLo: "LONG için RSI <=",
			rsiWin: "Bekleme penceresi (sinyalden sonraki mumlar)",
			showLevels: "İşlem seviyelerini çiz",
			showNear: "EMA30, EMA50'yi kesmek üzereyken işaretle",
			slPts: "SL (puan)",
			swLenA: "Pivot gücü (her iki yanda mum sayısı)",
			tp1Pts: "TP1 (puan)",
			tp2Pts: "TP2 (puan)",
			tp3Pts: "TP3 (puan)",
			tzOffset: "Seans saatinin UTC farkı (Bogota = -5)",
			useArm: "%50 düzeltme ve pencere içinde EMA30 teması şart",
			useAsia: "Asya'yı dahil et (yalnızca test)",
			useBE: "Başabaş etkin",
			useLadder: "TP1/TP2/TP3 kullan (son çıkış = TP3)",
			useR2: "R2 · M5 + M15 dizilimi ve H1 eğilimi şart",
			useRSI: "Sinyalden sonra RSI'ı bekle",
			useSess: "Seansa göre filtrele",
			useTrend: "Bekleme boyunca EMA sıralamasını koru"
		},
		longSignal: "Long sinyali",
		noSignal: "sinyal yok",
		retracementDot: "%50 düzeltme noktası",
		rewardZone: "Kâr bölgesi",
		riskZone: "Risk bölgesi",
		session: "Seans",
		sessionClosed: "kapalı",
		sessionOpen: "açık",
		shortSignal: "Short sinyali",
		signal: "Sinyal",
		signalActive: "{{side}} sürüyor",
		waitingRsi: "RSI bekleniyor {{arrow}} ({{n}})",
		waitingRsiLong: "RSI bekleniyor (long)",
		waitingRsiShort: "RSI bekleniyor (short)"
	},
	breakEven: "Başabaş",
	bullish: "Yükseliş",
	buy: "Al",
	colour: "Renk",
	cypher: {
		above55: "55 üstü",
		aboveBelow: "Üstünde/Altında",
		barColors: "Mum renkleri",
		bbLength: "BB uzunluğu",
		bbStdDev: "BB standart sapma {{n}}",
		bearBreak: "Düşüş kırılması",
		bearPattern: "Düşüş pin bar / yutan",
		below55: "55 altı",
		bullBreak: "Yükseliş kırılması",
		bullPattern: "Yükseliş pin bar / yutan",
		cmoLength: "CMO uzunluğu",
		colorCandles: "Mumları renklendir",
		confluenceLong: "Birleşim Long",
		confluenceShort: "Birleşim Short",
		consolidating: "Konsolidasyon",
		direction: "Yön",
		emaPeriodTrend: "EMA periyodu (trend)",
		flagOffsetAtr: "Bayrak mesafesi (x ATR)",
		flashBackground: "Flaş arka planı",
		flashCount: "Flaş sayısı",
		flashHz: "Flaş hızı (yanıp sönme / sn)",
		flashOn: "Yeni bayrakta flaş",
		flashShowBanner: "NEW BUY / SELL bannerını göster",
		flashShowBg: "Grafik arka planını yakıp söndür",
		flashStrength: "Arka plan flaş gücü",
		flashTest: "Flaşı şimdi test et (önizleme)",
		fvgKeep: "Taraf başına Adil Değer Boşlukları",
		glowOpacity: "Parıltı opaklığı (yüksek = daha şeffaf)",
		glowSizeTicks: "Parıltı boyutu (tick)",
		groupFlash: "Yeni bayrak uyarısı",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "KDE seviyeleri",
		groupKeyLevels: "Anahtar seviyeler",
		groupLrEma: "LR kanalı / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivotlar",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Dönüş bantları",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Bileşenler",
		groupTrendTable: "Trend tablosu",
		groupVidya: "VIDYA / Trend",
		halfTrendAmplitude: "HalfTrend genliği",
		halfTrendChannelDeviation: "HalfTrend kanal sapması",
		ichimokuBase: "Ichimoku taban çizgisi",
		ichimokuConversion: "Ichimoku dönüşüm çizgisi",
		kdeActivation: "Aktivasyon eşiğini etkinleştir",
		kdeBins: "Aralık sayısı",
		kdeThreshold: "Eşik %",
		labelPosition: "Etiket konumu",
		lineWidth: "Çizgi kalınlığı",
		lowerBb: "Alt BB{{n}}",
		lowerInnerZone: "Alt iç bölge",
		lowerReversalZone: "Alt dönüş bölgesi",
		maCloudLong: "MA bulutu (uzun)",
		maCloudShort: "MA bulutu (kısa)",
		newBuy: "YENİ ALIŞ",
		newSell: "YENİ SATIŞ",
		numberOfLevels: "Seviye sayısı",
		parabolicSar: "Parabolik SAR",
		pivotAuto: "Otomatik",
		pivotDaily: "Günlük",
		pivotMonthly: "Aylık",
		pivotsTimeframe: "Pivot zaman dilimi",
		pivotWeekly: "Haftalık",
		positionBottomCenter: "Alt orta",
		positionBottomLeft: "Sol alt",
		positionBottomRight: "Sağ alt",
		positionLeft: "Sol",
		positionRight: "Sağ",
		positionTopCenter: "Üst orta",
		positionTopLeft: "Sol üst",
		positionTopRight: "Sağ üst",
		psarBear: "PSAR düşüş",
		psarBull: "PSAR yükseliş",
		psarIncrement: "PSAR artış",
		psarMax: "PSAR maksimum",
		psarStart: "PSAR başlangıç",
		pullingBack: "Geri çekilme",
		pulseSmoothingBars: "Pulse yumuşatma barları",
		reEntry: "Yeniden giriş",
		rightOffsetBars: "Sağ boşluk (bar)",
		showCamarillaPivots: "Camarilla pivotlarını göster",
		showConfluenceFlag: "Birleşim bayrağını göster (B/S)",
		showFvg: "Adil Değer Boşlukları (15m ve üzeri)",
		showKde: "KDE hacim seviyeleri",
		showKeyLevels: "Anahtar seviyeleri göster",
		showLabels: "Etiketleri göster",
		showLevelGlow: "Seviye parıltısını göster",
		showMaCloud: "MA bulutunu göster",
		showPrices: "Fiyatları göster",
		showPsar: "PSAR'ı göster",
		showReversalBands: "Dönüş bantlarını göster",
		showSlTpLabels: "SL / TP etiketlerini göster",
		showSniperBreakArrows: "Sniper / kırılma oklarını göster",
		showTrendTable: "Trend tablosunu göster",
		showVidya233: "VIDYA 233'ü göster",
		showVidya55: "VIDYA 55'i göster",
		showVidya987: "VIDYA 987'yi (mıknatıs) göster",
		showVidyaLines: "VIDYA çizgilerini göster",
		sizeNormal: "Normal",
		sizeSmall: "Küçük",
		sizeTiny: "Çok küçük",
		slBufferAtr: "SL tampon üst sınırı (x ATR)",
		slBufferPips: "SL swing ötesi tampon (pip)",
		slMaxRiskAtr: "SL azami risk (x ATR)",
		slSwingLookback: "SL swing geriye bakış (bar)",
		sniperDown: "Sniper aşağı",
		sniperUp: "Sniper yukarı",
		source: "Kaynak",
		state: "Durum",
		strength: "Güç",
		strong: "Güçlü",
		superTrend2AtrLength: "SuperTrend 2 ATR uzunluğu",
		superTrend2Factor: "SuperTrend 2 faktörü",
		superTrendAtrLength: "SuperTrend ATR uzunluğu",
		superTrendMultiplier: "SuperTrend çarpanı",
		tablePosition: "Tablo konumu",
		tableSize: "Tablo boyutu",
		tpRiskReward: "TP {{n}} risk/ödül",
		tradeManagement: "İşlem yönetimi (SL / TP)",
		trend: "Trend",
		trending: "Trendde",
		upperBb: "Üst BB{{n}}",
		upperInnerZone: "Üst iç bölge",
		upperReversalZone: "Üst dönüş bölgesi",
		veryStrong: "Çok güçlü",
		veryWeak: "Çok zayıf",
		vidya987Magnet: "VIDYA 987 (mıknatıs)",
		volumeAvgLength: "Hacim ortalaması uzunluğu (kırılma filtresi)",
		weak: "Zayıf",
		zoneEdge: "{{name}} (dolgu kenarı)"
	},
	entry: "Giriş",
	gainColor: "Kazanç Rengi",
	harsiCandle: "HARSI Mum",
	harsiLength: "HARSI Uzunluğu",
	heikinAshiRsiOscillator: "Heikin-Ashi RSI Osilatörü",
	keyValueThisChangesTheSensitivity: "Anahtar Değer 'Bu hassasiyeti değiştirir'",
	labelsIndicator: "Etiket Göstergesi",
	london: "Londra",
	londonBackground: "Londra Arka Planı",
	londonSession: "Londra Seansı",
	long: "Long",
	lossColor: "Kayıp Rengi",
	median: "Medyan",
	neutral: "Nötr",
	newYork: "New York",
	newYorkBackground: "New York Arka Planı",
	newYorkSession: "New York Seansı",
	openSmoothing: "Açılış Yumuşatma",
	optimus: {
		activeTradeLevels: "Açık işlem · seviyeler",
		bias: "Eğilim",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "KARIŞIK {{n}}/{{total}}",
		disclaimer: "Seviyeler grafik üzerine çizilmiştir. Yatırım tavsiyesi değildir.",
		duplicateRemoved: "Grafik başına yalnızca bir Optimus Prime göstergesi desteklenir; kopyası kaldırıldı.",
		enter: "GİRİŞ · {{side}}",
		input: {
			atrLength: "KC ATR uzunluğu",
			buffer: "Salınım payı (fiyat olarak)",
			emaLength: "EMA uzunluğu",
			kcLength: "KC uzunluğu",
			kcMult: "KC çarpanı",
			lrcLength: "LRC uzunluğu",
			minRisk: "Asgari risk R (fiyat olarak)",
			requireAlign: "EMA ile LRC hizalı olsun",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Salınım için geriye bakış (R)"
		},
		kcLower: "KC alt",
		kcMid: "KC orta",
		kcUpper: "KC üst",
		keltnerFill: "Keltner dolgusu",
		noClosedTrades: "Henüz kapanmış işlem yok",
		reasonForming: "Kurulum oluşuyor — onay bekleniyor",
		reasonLatched: "İşlem kilitli · seviyeler grafikte",
		reasonNoSetup: "Kurulum yok · EMA/LRC hizalı değil",
		recentSignals: "Son sinyaller",
		riskReward: "RİSK/KÂR",
		trendMtf: "Trend · çoklu zaman dilimi",
		wait: "BEKLE",
		warmingUp: "ISINIYOR"
	},
	overbought: "Aşırı Alım",
	overboughtMax: "Aşırı Alım Maks",
	overboughtMin: "Aşırı Alım Min",
	oversold: "Aşırı Satım",
	oversoldMax: "Aşırı Satım Maks",
	oversoldMin: "Aşırı Satım Min",
	rsiLength: "RSI Uzunluğu",
	rsiLine: "RSI Çizgisi",
	rsiLineShadow: "RSI Çizgi Gölgesi",
	sell: "Sat",
	short: "Short",
	signalsFromHeikinAshiCandles: "Heikin Ashi Mumlarından Sinyaller",
	sl: "SL",
	smoothedMode: "Yumuşatılmış Mod",
	sydney: "Sidney",
	sydneyBackground: "Sidney Arka Planı",
	sydneySession: "Sidney Seansı",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokyo",
	tokyoBackground: "Tokyo Arka Planı",
	tokyoSession: "Tokyo Seansı",
	tp: "TP {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "düşüş",
			bullish: "yükseliş",
			confluence: "konfluans",
			entry: "giriş",
			neckline: "boyun çizgisi",
			score: "skor",
			state: "durum",
			states: {
				completed: "tamamlandı",
				invalidated: "geçersiz",
				projected: "öngörülen",
				przActive: "PRZ aktif",
				stopped: "stop oldu"
			},
			stop: "stop",
			target: "hedef"
		},
		classic: {
			doubleBottom: "Çift Dip",
			doubleTop: "Çift Tepe",
			headAndShoulders: "Omuz Baş Omuz",
			inverseHeadAndShoulders: "Ters OBO",
			tripleBottom: "Üçlü Dip",
			tripleTop: "Üçlü Tepe"
		},
		direction: {
			bearishOnly: "Yalnızca düşüş",
			both: "Her ikisi",
			bullishOnly: "Yalnızca yükseliş"
		},
		group: {
			classics: "Klasik formasyonlar ve S/R",
			filters: "Filtreler ve görünüm",
			patterns: "Formasyonlar",
			pivotEngine: "Pivot motoru",
			ratios: "Oranlar ve tolerans"
		},
		input: {
			atrLen: "ATR periyodu",
			atrMult: "Zigzag dönüşü (x ATR)",
			colBear: "Düşüş",
			colBull: "Yükseliş",
			colPrz: "PRZ",
			colSR: "Anahtar seviyeler",
			dirFilter: "Yön filtresi",
			enClassics: "Klasik formasyonları algıla",
			enDoubles: "Çift Tepe / Dip",
			enHS: "Omuz Baş Omuz",
			enTriples: "Üçlü Tepe / Dip",
			fillTransp: "Formasyon dolgu şeffaflığı",
			formingLife: "Oluşan bölgenin ömrü (mum)",
			keepFailed: "Stop olan formasyonları grafikte tut (✕, soluk)",
			keepSuccessful: "Başarılı formasyonları grafikte tut (✓)",
			maxPatterns: "Grafikteki en fazla formasyon",
			minScore: "Minimum kalite puanı",
			pivotDepth: "Pivot tampon derinliği",
			showLetters: "X A B C D nokta harflerini göster",
			showPlan: "İşlem planı seviyelerini göster",
			showProjected: "Öngörülen (oluşmakta olan) formasyonları göster",
			showRatios: "Bacaklarda oran sayılarını göster",
			showSR: "Destek/direnç seviyeleri",
			showStats: "İstatistik tablosunu göster",
			srMinTouch: "S/R: en az pivot teması",
			tolEdge: "Aralık kenarı toleransı",
			tolPoint: "Nokta oranı toleransı",
			useScale2: "2x ölçeği de tara (daha büyük yapılar)"
		},
		label: {
			confirmed: "onaylandı",
			forming: "oluşuyor",
			sl: "SL",
			target: "hedef",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Tamamlanan",
			stops: "Stoplar",
			t1Wins: "T1 başarılı",
			winRate: "Başarı %"
		},
		tooltip: {
			colPrz: "Formasyon yönünden bağımsız olarak kehribar renkli PRZ (ProTrader varsayılanı).",
			fillTransp: "Daha düşük = daha belirgin dolgu. 65-80 civarı iyi çalışır.",
			formingLife: "C noktası bu değerden eski olan, tamamlanmamış ve geçersiz hale gelmemiş oluşmakta olan bir formasyonun süresi dolar ve kaldırılır.",
			maxPatterns: "Önce en eski formasyonlar kaldırılır, böylece yakın geçmiş (✓ / ✕) ve yeni oluşan bölgeler her zaman görünür kalır.",
			showProjected: "X-A-B yapısını, öngörülen PRZ bölgesine uzanan kesikli bir kılavuz çizgiyle çizer.",
			showRatios: "Her birinin ortasında ölçülen Fibonacci oranıyla noktalı ölçüm köşegenleri (X-B, A-C, B-D, X-D), harmonik grafiklerde standart işaretleme.",
			tolPoint: "Gartley B=0.618 gibi kesin oranlara uygulanır. Sıkı = 0.03, dengeli = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ TÜMÜNÜ KAPAT",
		duplicateRemoved: "Grafik başına yalnızca bir Trade Finder göstergesi desteklenir; kopyası kaldırıldı.",
		durationHm: "{{h}} sa {{m}} dk",
		durationM: "{{m}} dk",
		emaEntry1: "EMA Giriş 1",
		emaEntry2: "EMA Giriş 2 / Trend",
		emaRangeFilter: "EMA Aralık filtresi",
		emaTrigger: "EMA Tetikleyici",
		entry1: "Giriş 1",
		entry2: "Giriş 2",
		entry2Mark: "E2",
		entryZoneBear: "Giriş bölgesi {{n}} (düşüş)",
		entryZoneBull: "Giriş bölgesi {{n}} (yükseliş)",
		frameFailed: "{{frame}} zaman dilimi yüklenemedi; yeniden denenecek.",
		framesUnavailable: "Zaman dilimi verisi yok · bekle",
		ghostEntry: "Önceki kurulum",
		ghostStop: "Önceki stop",
		group: {
			bias: "Eğilim",
			display: "Görünüm",
			emaSystem: "EMA sistemi",
			entries: "Girişler",
			filter: "Filtre",
			riskManagement: "Risk yönetimi",
			session: "Seans",
			supportResistance: "Destek ve direnç",
			trailingStop: "İz süren stop",
			trendPanel: "Trend paneli"
		},
		input: {
			adxLen: "ADX uzunluğu",
			adxSmoothing: "ADX yumuşatma",
			asiaSession: "Asya / Tokyo seansı (UTC)",
			atrBufferMultBtc: "Salınımın arkasındaki stop payı — BTC (× ATR)",
			atrBufferMultGold: "Salınımın arkasındaki stop payı — altın (× ATR)",
			atrBufferMultOther: "Salınımın arkasındaki stop payı — diğer (× ATR)",
			atrLength: "ATR uzunluğu (risk yönetimi)",
			atrSlMult: "Zarar durdur = ATR ×",
			atrTpMult: "TP{{n}} = ATR ×",
			beGoldPoints: "Altın: bu kadar puan sonra başabaşa çek",
			biasEmaLen: "Eğilim EMA uzunluğu",
			crossLookback: "Eğilim kesişim penceresi (bar)",
			dxySymbol: "Dolar endeksi sembolü (boş bırakmak kapatır)",
			emaBigLen: "EMA Aralık filtresi uzunluğu",
			emaFastLen: "EMA Giriş 1 uzunluğu",
			emaMidLen: "EMA Giriş 2 / Trend uzunluğu",
			emaTriggerLen: "EMA Tetikleyici uzunluğu",
			feeBufferPct: "Başabaşın ötesinde komisyon payı (%)",
			flatThreshPct: "Yatay eşiği (eğilim EMA'sının %'si)",
			londonSession: "Londra seansı (UTC)",
			maxCrosses: "Eğilim iptal edilmeden önceki azami kesişim",
			newYorkSession: "New York seansı (UTC)",
			showEmaLabels: "EMA adı etiketlerini göster",
			showEntrySignals: "Kurulum işaretlerini göster",
			showEntryZone: "Giriş bölgesini göster",
			showSRLines: "Destek ve direnci göster",
			showTradeLevels: "Giriş, stop ve hedef seviyelerini göster",
			slMaxPointsBtc: "Azami stop mesafesi — BTC (puan)",
			slMaxPointsGold: "Azami stop mesafesi — altın (puan)",
			slMaxPointsIndex: "Azami stop mesafesi — endeksler (puan)",
			slMaxPointsOther: "Azami stop mesafesi — diğer (puan)",
			slMinPointsGold: "Asgari stop mesafesi — altın (puan)",
			slopeLookback: "Eğilim eğimi penceresi (bar)",
			srLeftBars: "Destek / direnç · pivotun solundaki barlar",
			srRightBars: "Destek / direnç · pivotun sağındaki barlar",
			swingPivotLen: "Salınım pivot uzunluğu (zarar durdur)",
			tp1ClosePct: "TP1'de kapatma %",
			tp2ClosePct: "TP2'de kapatma %",
			tp5CloseAlways: "TP5 her zaman kapatır, iz sürerken bile",
			tpR: "TP{{n}} (R cinsinden)",
			tpSlMode: "Stop ve hedef modu",
			trailAtrMult: "İz süren stop mesafesi (× ATR)",
			trendPanelEmaLen: "Trend satırı EMA uzunluğu",
			trendSlopeLB: "EMA Giriş 2 eğim geriye bakışı (bar)",
			useAdxFilter: "ADX'in mod eşiğinin üzerinde olmasını şart koş",
			useBiasFilter: "Üst zaman dilimi eğilimini puanla (girişi asla engellemez)",
			useEmaStackCheck: "EMA sıralamasının doğru olmasını iste",
			useInstrumentAutoDetect: "Enstrümanı otomatik algıla",
			useSessionFilter: "Yalnızca işlem seansları sırasında sinyal ver",
			useSlopeDynamic: "Eğim geriye bakışını zaman dilimine göre ölçekle",
			useStrictCandle: "Katı mum filtresi (fitil ve kapanış)",
			useTrailingStop: "İz süren stop (TP1 sonrası)",
			useVolumeConfirm: "Girişte ortalamanın üzerinde hacim iste",
			volAvgLen: "Hacim ortalaması uzunluğu",
			volMultiplier: "Asgari hacim (× ortalama)"
		},
		maxStop: "Maks. SL",
		minuteAgainst: "Kuruluma karşı kesişim",
		minuteOk: "Uyarı yok",
		minuteReversal: "Kesişim · dönüş olabilir",
		modeAtr: "ATR",
		modeAuto: "Otomatik",
		modeRiskReward: "Risk / kazanç",
		noBias: "Eğilim yok",
		noSetup: "Aktif kurulum yok",
		recentTitle: "Son kurulumlar",
		reEntry: "Yeniden giriş",
		reEntryMark: "RE",
		rest: "KALAN",
		rowBias: "Eğilim",
		rowContext: "Bağlam",
		rowInfo: "Bilgi",
		rowSession: "Seans",
		rowSetup: "Kurulum",
		rowVolume: "Hacim",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "kalan {{time}}",
		sessionOutside: "Seans dışı · Londra {{time}} UTC",
		sessionOverlap: "Çakışma",
		statsTitle: "Son {{n}} kurulum",
		statusBreakEvenSet: "Başabaş",
		statusMoveToBreakEven: "Stop’u taşı",
		statusPending: "Bölgeye temas",
		statusRunning: "Devam ediyor",
		statusSpike: "Oynak · bekle",
		statusWaiting: "Bekleniyor",
		stopHit: "Stop tetiklendi",
		styleDaytrade: "Gün içi",
		styleScalping: "Skalping",
		styleSwing: "Swing",
		subFrameReversal: "Alt zaman dilimi dönüyor",
		targetHit: "Son hedefe ulaşıldı",
		trailStop: "İz süren stop",
		volAboveAverage: "ortalamanın üzerinde",
		volBelowAverage: "ortalamanın altında",
		zoneEdgeBear: "Bölge kenarı {{n}} (düşüş)",
		zoneEdgeBull: "Bölge kenarı {{n}} (yükseliş)"
	},
	tradingSessions: "İşlem Seansları",
	unintendedSymbol: "Bu strateji {{symbols}} için tasarlandı; {{symbol}} üzerinde seviyeleri bir şey ifade etmeyebilir.",
	utBotAlerts: "UT Bot Uyarıları"
}, Se = {
	asia: "Châu Á",
	atrPeriod: "Chu kỳ ATR",
	auraScanner: {
		guide: {
			bigDiamondMark: "Lớn màu đỏ/xanh lá",
			bigDiamondMeaning: "Hình thoi đỏ lớn trên đỉnh cảnh báo lệnh mua. Hình thoi xanh lá lớn dưới đáy cảnh báo lệnh bán.",
			blueMark: "Đường cong xanh dương",
			blueMeaning: "50 EMA. Hồng trên xanh dương là mua, bên dưới là bán.",
			dashedMark: "Đường nét đứt",
			dashedMeaning: "Hỗ trợ và kháng cự. Đỏ dưới giá, xanh lá phía trên.",
			diamondsMark: "Hình thoi",
			diamondsMeaning: "Điểm đảo chiều. Vàng yếu nhất, tiếp theo là xanh dương, đỏ và xanh lá.",
			flatGoldMark: "Đường vàng nằm ngang",
			flatGoldMeaning: "Mức giá có khối lượng lớn nhất trong sáu giờ qua trên biểu đồ 15 phút.",
			levelsMark: "Đường mức giá",
			levelsMeaning: "Điểm vào, dừng lỗ và mục tiêu của giao dịch gần nhất. Dấu tích nghĩa là đã chạm.",
			pinkMark: "Đường cong hồng",
			pinkMeaning: "20 EMA. Giao cắt với đường xanh dương tạo tín hiệu.",
			subtitle: "Cách đọc biểu đồ này",
			thickGoldMark: "Đường vàng đậm",
			thickGoldMeaning: "Đường 238. Nếu nằm giữa điểm vào và mục tiêu, hãy bỏ qua.",
			title: "AURA",
			triangleMark: "Tam giác",
			triangleMeaning: "Giao dịch đã vượt qua mọi kiểm tra. Di chuột lên để xem số liệu."
		},
		groups: {
			display: "Hiển thị",
			eightChecks: "Tám bước kiểm tra",
			riskAndTargets: "Rủi ro và mục tiêu",
			signalEngine: "Bộ tạo tín hiệu"
		},
		inputs: {
			emaFastLen: "Đường nhanh (hồng)",
			emaSlowLen: "Đường chậm (xanh dương)",
			f1Clock: "1. Chỉ trong khung giờ có khối lượng tốt",
			f2Trend: "2. Thuận xu hướng 15 phút",
			f3Mode: "3. Nến sai màu",
			f4Min: "Mức tách rộng tối thiểu (pip mỗi nến)",
			f4Sep: "4. Hai đường đang tách xa",
			f5Clear: "5. 238 không nằm giữa điểm vào và mục tiêu",
			f6R: "Khoảng trống tối thiểu (× rủi ro)",
			f6Reward: "6. Khoảng trống tới mức tiếp theo",
			f7Bars: "Trong số nến gần nhất",
			f7Consol: "7. Không bị kẹt trong vùng đi ngang",
			f7Pips: "Biên độ phải lớn hơn (pip)",
			f9Bars: "Trong N nến gần nhất",
			f9Star: "8. Không có hình thoi cảnh báo lớn",
			guidePos: "Vị trí bảng hướng dẫn",
			longMode: "Chế độ đường an toàn (238)",
			panelSize: "Cỡ chữ của bảng",
			pipIn: "Kích thước pip (0 = tự động)",
			showClock: "Bảng tình hình hiện tại",
			showGuide: "Hướng dẫn ý nghĩa các dấu",
			showLadder: "Mức giao dịch bên phải",
			showPoc: "Đường khối lượng",
			showSr: "Mức nét đứt",
			showStars: "Hình thoi cảnh báo",
			showTable: "Bảng xu hướng",
			showTint: "Màu nền",
			showWhy: "Giải thích tín hiệu bị bỏ qua",
			slMinPips: "Khoảng cách tối thiểu qua đường chậm (pip)",
			srAtrMove: "Mức giá: độ bật lại cần thiết (× kích thước nến thông thường)",
			srLookback: "Mức giá: phạm vi tìm điểm đảo chiều",
			srMax: "Số mức tối đa trên màn hình",
			srRange: "Bỏ qua mức xa hơn (× kích thước nến thông thường)",
			srReset: "Mức giá: số lần kiểm tra lại trước khi xóa",
			stripLen: "Chiều rộng cột bên phải (nến)",
			tablePos: "Vị trí bảng hiện tại",
			theme: "Giao diện biểu đồ",
			tp1R: "TP1 (bội số R)",
			tp2R: "TP2 (bội số R)",
			trendPos: "Vị trí bảng xu hướng",
			tz: "Múi giờ của các khung giao dịch"
		},
		ladder: {
			closedAtStop: "ĐÃ ĐÓNG do dừng lỗ",
			closedAtTarget: "ĐÃ ĐÓNG TP{{hit}}",
			entry: "ĐIỂM VÀO",
			stop: "DỪNG LỖ",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "Tự điều chỉnh",
			bottomCentre: "Dưới giữa",
			bottomLeft: "Dưới trái",
			bottomRight: "Dưới phải",
			dark: "Tối",
			ignore: "Bỏ qua",
			large: "Lớn",
			light: "Sáng",
			literal238: "Cố định 238",
			middleCentre: "Chính giữa",
			middleLeft: "Giữa trái",
			middleRight: "Giữa phải",
			normal: "Vừa",
			reject: "Loại bỏ",
			small: "Nhỏ",
			topCentre: "Trên giữa",
			topLeft: "Trên trái",
			topRight: "Trên phải",
			waitForPullback: "Chờ hồi giá"
		},
		reasons: {
			clock: "ngoài khung giờ giao dịch",
			diamond: "vừa xuất hiện hình thoi cảnh báo lớn",
			range: "biểu đồ đang kẹt trong vùng tích lũy",
			room: "mức giá quá gần, không đủ khoảng trống tới mục tiêu",
			safetyLine: "238 nằm giữa điểm vào và mục tiêu",
			separation: "hai đường quá gần, chưa có khoảng trống để chạy",
			trend: "ngược xu hướng 15 phút",
			wrongColour: "nến giao cắt đóng cửa với màu không phù hợp"
		},
		rightNow: {
			aBuy: "Mua",
			aSell: "Bán",
			bestBuysOnly: "chỉ tìm lệnh mua",
			bestNow: "Tốt nhất lúc này",
			bestSellsOnly: "chỉ tìm lệnh bán",
			bestWaitThin: "chờ, khối lượng thấp",
			goodVolume: "Khối lượng tốt",
			lowVolume: "Khối lượng thấp",
			safetyAbove: "238 trên giá, còn khoảng trống cho lệnh bán",
			safetyBelow: "238 dưới giá, còn khoảng trống cho lệnh mua",
			safetyLine: "Đường an toàn",
			skipped: "Đã bỏ qua",
			skippedAgo_other: "{{side}} cách đây {{bars}} nến: {{reason}}",
			skippedNothing: "chưa bỏ qua tín hiệu nào",
			title: "HIỆN TẠI",
			trend: "Xu hướng",
			trendSummaryDown: "15m giảm, {{agree}} trong 6 khung thời gian tăng",
			trendSummaryUp: "15m tăng, {{agree}} trong 6 khung thời gian tăng"
		},
		signal: {
			buy: "MUA",
			pips: "pip",
			sell: "BÁN",
			stop: "Dừng lỗ"
		},
		tooltip: {
			f3Mode: "Không vào ngay lệnh mua trên nến đỏ hoặc lệnh bán trên nến xanh dương. Chờ hồi giá sẽ đợi giá quay lại các đường trên nến đúng màu. Loại bỏ sẽ bỏ tín hiệu đó.",
			f4Min: "Tốc độ hai đường tách xa trên nến tín hiệu. Các đường đan vào nhau và nằm ngang không để lại khoảng trống cho giá chạy.",
			f6Reward: "Mức nét đứt tiếp theo phải cách ít nhất chừng này. Mặc định tắt: bộ quét vẽ mức theo phương pháp riêng, vì vậy hãy kiểm tra khoảng trống bằng mắt.",
			f7Pips: "Tránh vùng tích lũy có biên độ từ 100 pip trở xuống.",
			longMode: "238 là thiết lập chuẩn cho biểu đồ một phút. Tự điều chỉnh sẽ đổi đường an toàn theo khung thời gian khác, khoảng 83 trên biểu đồ ba phút.",
			pipIn: "Tự động: 0.10 với vàng và mười bước giá nhỏ nhất cho các mã khác (1 điểm trên US30).",
			showGuide: "Chú giải ngắn trên biểu đồ. Tắt khi bạn đã hiểu các dấu.",
			showLadder: "Điểm vào, dừng lỗ và mục tiêu của giao dịch gần nhất được vẽ bên phải nến cuối. Mục tiêu được đánh dấu tích khi chạm.",
			showWhy: "Khi hai đường giao cắt nhưng một kiểm tra chặn giao dịch, bảng hiện tại cho biết kiểm tra nào và lý do.",
			slMinPips: "Dừng lỗ đặt bên kia cả đường đỏ lẫn đường xanh dương, cách đường xanh dương ít nhất 10 pip.",
			srMax: "Chỉ giữ các mức gần giá nhất để biểu đồ dễ đọc.",
			theme: "Chọn theo giao diện TradingView để mọi màu đều rõ.",
			tz: "Các khung giờ giao dịch dùng múi giờ này. America/Denver là giờ miền Núi Bắc Mỹ có giờ mùa hè. Dùng America/Phoenix cho giờ miền Núi không đổi theo mùa."
		},
		trendTable: {
			above: "phía trên",
			below: "phía dưới",
			down: "Giảm",
			notAvailable: "không có dữ liệu",
			up: "Tăng",
			volumeLine: "Đường khối lượng"
		}
	},
	bearish: "Giảm",
	bfs: {
		duplicateRemoved: "Mỗi đồ thị chỉ hỗ trợ một chỉ báo BFS — Blessed Flow System; bản trùng đã được xóa.",
		emaCrossSoon: "EMA30/50 sắp cắt nhau",
		engineOff: "hãy chuyển sang M1",
		engineOn: "engine M1",
		input: {
			armWin: "Cửa sổ (nến M1) để chạm EMA30",
			asiaSess: "Châu Á (HHMM-HHMM)",
			bePts: "BE: khi lãi +điểm, stop được dời ĐÚNG tới mức đó",
			cooldown: "Nghỉ (nến M1) sau khi đóng một lệnh",
			lenFast: "EMA nhanh (hướng)",
			lenH1a: "H1 · EMA ngắn",
			lenH1b: "H1 · EMA dài",
			lenMid: "EMA trung bình",
			lenSlow: "EMA chậm",
			londonSess: "London (HHMM-HHMM, giờ phiên)",
			maxPerBlock: "Số lần vào tối đa mỗi khối phiên (0 = không giới hạn)",
			nearLb: "Số nến dùng để đo độ thu hẹp",
			nearPts: "Khoảng cách EMA30-EMA50 tối đa (điểm)",
			nySess: "New York (HHMM-HHMM)",
			onlyM1: "Chỉ chạy engine trên M1",
			pv: "Giá trị của 1 điểm",
			r1lb: "R1 · số nến M1 xét lại (giá chưa đi quá xa)",
			rr: "Tỷ lệ TP R:R (khi tắt thang TP)",
			rsiHi: "RSI >= để vào SHORT",
			rsiLen: "Chu kỳ RSI",
			rsiLo: "RSI <= để vào LONG",
			rsiWin: "Cửa sổ chờ (số nến sau tín hiệu)",
			showLevels: "Vẽ các mức của lệnh",
			showNear: "Đánh dấu khi EMA30 sắp cắt EMA50",
			slPts: "SL (điểm)",
			swLenA: "Độ mạnh của pivot (số nến mỗi bên)",
			tp1Pts: "TP1 (điểm)",
			tp2Pts: "TP2 (điểm)",
			tp3Pts: "TP3 (điểm)",
			tzOffset: "Lệch UTC của giờ phiên (Bogota = -5)",
			useArm: "Yêu cầu hồi 50% và giá chạm EMA30 trong cửa sổ",
			useAsia: "Gồm cả phiên Á (chỉ để thử)",
			useBE: "Bật hòa vốn",
			useLadder: "Dùng TP1/TP2/TP3 (thoát cuối = TP3)",
			useR2: "R2 · yêu cầu thứ tự M5 + M15 và xu hướng H1",
			useRSI: "Chờ RSI sau tín hiệu",
			useSess: "Lọc theo phiên",
			useTrend: "Giữ đúng thứ tự EMA trong lúc chờ"
		},
		longSignal: "Tín hiệu long",
		noSignal: "không có tín hiệu",
		retracementDot: "Điểm hồi 50%",
		rewardZone: "Vùng lợi nhuận",
		riskZone: "Vùng rủi ro",
		session: "Phiên",
		sessionClosed: "đã đóng",
		sessionOpen: "đang mở",
		shortSignal: "Tín hiệu short",
		signal: "Tín hiệu",
		signalActive: "{{side}} đang chạy",
		waitingRsi: "đang chờ RSI {{arrow}} ({{n}})",
		waitingRsiLong: "Đang chờ RSI (long)",
		waitingRsiShort: "Đang chờ RSI (short)"
	},
	breakEven: "Hòa vốn",
	bullish: "Tăng",
	buy: "Mua",
	colour: "Màu sắc",
	cypher: {
		above55: "Trên 55",
		aboveBelow: "Trên/Dưới",
		barColors: "Màu nến",
		bbLength: "Độ dài BB",
		bbStdDev: "Độ lệch chuẩn BB {{n}}",
		bearBreak: "Phá vỡ giảm",
		bearPattern: "Pin bar / nhấn chìm giảm",
		below55: "Dưới 55",
		bullBreak: "Phá vỡ tăng",
		bullPattern: "Pin bar / nhấn chìm tăng",
		cmoLength: "Độ dài CMO",
		colorCandles: "Tô màu nến",
		confluenceLong: "Hợp lưu Long",
		confluenceShort: "Hợp lưu Short",
		consolidating: "Tích lũy",
		direction: "Hướng",
		emaPeriodTrend: "Chu kỳ EMA (xu hướng)",
		flagOffsetAtr: "Khoảng cách cờ (x ATR)",
		flashBackground: "Nền nhấp nháy",
		flashCount: "Số lần nhấp nháy",
		flashHz: "Tốc độ nhấp nháy (lần / giây)",
		flashOn: "Nhấp nháy khi có cờ mới",
		flashShowBanner: "Hiển thị biểu ngữ NEW BUY / SELL",
		flashShowBg: "Nhấp nháy nền biểu đồ",
		flashStrength: "Cường độ nhấp nháy nền",
		flashTest: "Thử nhấp nháy ngay (xem trước)",
		fvgKeep: "Số Fair Value Gap mỗi phía",
		glowOpacity: "Độ mờ vùng sáng (cao hơn = trong suốt hơn)",
		glowSizeTicks: "Kích thước vùng sáng (tick)",
		groupFlash: "Cảnh báo cờ mới",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "Ichimoku",
		groupKde: "Mức KDE",
		groupKeyLevels: "Mức quan trọng",
		groupLrEma: "Kênh LR / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "Pivot",
		groupPsar: "Parabolic SAR",
		groupReversalBands: "Dải đảo chiều",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "Thành phần",
		groupTrendTable: "Bảng xu hướng",
		groupVidya: "VIDYA / Xu hướng",
		halfTrendAmplitude: "Biên độ HalfTrend",
		halfTrendChannelDeviation: "Độ lệch kênh HalfTrend",
		ichimokuBase: "Đường cơ sở Ichimoku",
		ichimokuConversion: "Đường chuyển đổi Ichimoku",
		kdeActivation: "Bật ngưỡng kích hoạt",
		kdeBins: "Số khoảng",
		kdeThreshold: "Ngưỡng %",
		labelPosition: "Vị trí nhãn",
		lineWidth: "Độ dày đường",
		lowerBb: "BB{{n}} dưới",
		lowerInnerZone: "Vùng trong phía dưới",
		lowerReversalZone: "Vùng đảo chiều dưới",
		maCloudLong: "Đám mây MA (dài)",
		maCloudShort: "Đám mây MA (ngắn)",
		newBuy: "MUA MỚI",
		newSell: "BÁN MỚI",
		numberOfLevels: "Số mức",
		parabolicSar: "SAR Parabol",
		pivotAuto: "Tự động",
		pivotDaily: "Hàng ngày",
		pivotMonthly: "Hàng tháng",
		pivotsTimeframe: "Khung thời gian điểm xoay",
		pivotWeekly: "Hàng tuần",
		positionBottomCenter: "Dưới giữa",
		positionBottomLeft: "Dưới trái",
		positionBottomRight: "Dưới phải",
		positionLeft: "Trái",
		positionRight: "Phải",
		positionTopCenter: "Trên giữa",
		positionTopLeft: "Trên trái",
		positionTopRight: "Trên phải",
		psarBear: "PSAR giảm",
		psarBull: "PSAR tăng",
		psarIncrement: "Bước tăng PSAR",
		psarMax: "Tối đa PSAR",
		psarStart: "Khởi đầu PSAR",
		pullingBack: "Điều chỉnh",
		pulseSmoothingBars: "Số nến làm mượt Pulse",
		reEntry: "Vào lại",
		rightOffsetBars: "Khoảng cách bên phải (nến)",
		showCamarillaPivots: "Hiển thị điểm xoay Camarilla",
		showConfluenceFlag: "Hiển thị cờ hợp lưu (B/S)",
		showFvg: "Fair Value Gap (từ 15m trở lên)",
		showKde: "Mức khối lượng KDE",
		showKeyLevels: "Hiển thị mức quan trọng",
		showLabels: "Hiển thị nhãn",
		showLevelGlow: "Hiển thị vùng sáng của mức",
		showMaCloud: "Hiển thị đám mây MA",
		showPrices: "Hiển thị giá",
		showPsar: "Hiển thị PSAR",
		showReversalBands: "Hiển thị dải đảo chiều",
		showSlTpLabels: "Hiển thị nhãn SL / TP",
		showSniperBreakArrows: "Hiển thị mũi tên Sniper / phá vỡ",
		showTrendTable: "Hiển thị bảng xu hướng",
		showVidya233: "Hiển thị VIDYA 233",
		showVidya55: "Hiển thị VIDYA 55",
		showVidya987: "Hiển thị VIDYA 987 (nam châm)",
		showVidyaLines: "Hiển thị đường VIDYA",
		sizeNormal: "Bình thường",
		sizeSmall: "Nhỏ",
		sizeTiny: "Rất nhỏ",
		slBufferAtr: "SL: giới hạn vùng đệm (x ATR)",
		slBufferPips: "SL: vùng đệm sau swing (pip)",
		slMaxRiskAtr: "SL: rủi ro tối đa (x ATR)",
		slSwingLookback: "SL: số nến tìm swing",
		sniperDown: "Sniper xuống",
		sniperUp: "Sniper lên",
		source: "Nguồn",
		state: "Trạng thái",
		strength: "Sức mạnh",
		strong: "Mạnh",
		superTrend2AtrLength: "Độ dài ATR SuperTrend 2",
		superTrend2Factor: "Hệ số SuperTrend 2",
		superTrendAtrLength: "Độ dài ATR SuperTrend",
		superTrendMultiplier: "Hệ số nhân SuperTrend",
		tablePosition: "Vị trí bảng",
		tableSize: "Kích thước bảng",
		tpRiskReward: "TP {{n}} rủi ro/lợi nhuận",
		tradeManagement: "Quản lý giao dịch (SL / TP)",
		trend: "Xu hướng",
		trending: "Đang có xu hướng",
		upperBb: "BB{{n}} trên",
		upperInnerZone: "Vùng trong phía trên",
		upperReversalZone: "Vùng đảo chiều trên",
		veryStrong: "Rất mạnh",
		veryWeak: "Rất yếu",
		vidya987Magnet: "VIDYA 987 (nam châm)",
		volumeAvgLength: "Độ dài TB khối lượng (bộ lọc phá vỡ)",
		weak: "Yếu",
		zoneEdge: "{{name}} (cạnh vùng tô)"
	},
	entry: "Điểm vào",
	gainColor: "Màu lời",
	harsiCandle: "Nến HARSI",
	harsiLength: "Độ dài HARSI",
	heikinAshiRsiOscillator: "Bộ dao động RSI Heikin-Ashi",
	keyValueThisChangesTheSensitivity: "Giá trị chính 'Điều này thay đổi độ nhạy'",
	labelsIndicator: "Chỉ báo nhãn",
	london: "London",
	londonBackground: "Nền London",
	londonSession: "Phiên London",
	long: "Long",
	lossColor: "Màu lỗ",
	median: "Trung vị",
	neutral: "Trung lập",
	newYork: "New York",
	newYorkBackground: "Nền New York",
	newYorkSession: "Phiên New York",
	openSmoothing: "Làm mượt giá mở cửa",
	optimus: {
		activeTradeLevels: "Lệnh đang mở · các mức",
		bias: "Xu hướng",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "TRÁI CHIỀU {{n}}/{{total}}",
		disclaimer: "Các mức được vẽ trên đồ thị. Đây không phải lời khuyên đầu tư.",
		duplicateRemoved: "Mỗi đồ thị chỉ hỗ trợ một chỉ báo Optimus Prime; bản trùng đã được xóa.",
		enter: "VÀO · {{side}}",
		input: {
			atrLength: "Chu kỳ ATR của KC",
			buffer: "Biên đệm swing (theo giá)",
			emaLength: "Chu kỳ EMA",
			kcLength: "Chu kỳ KC",
			kcMult: "Hệ số KC",
			lrcLength: "Chu kỳ LRC",
			minRisk: "Rủi ro R tối thiểu (theo giá)",
			requireAlign: "Yêu cầu EMA và LRC cùng hướng",
			rrTp1: "TP1 (xR)",
			rrTp2: "TP2 (xR)",
			rrTp3: "TP3 (xR)",
			rrTp4: "TP4 (xR)",
			swingLookback: "Số nến xét lại cho swing (R)"
		},
		kcLower: "KC dưới",
		kcMid: "KC giữa",
		kcUpper: "KC trên",
		keltnerFill: "Vùng tô Keltner",
		noClosedTrades: "Chưa có lệnh nào đã đóng",
		reasonForming: "Mô hình đang hình thành — chờ xác nhận",
		reasonLatched: "Lệnh đã chốt · các mức đã vẽ trên đồ thị",
		reasonNoSetup: "Chưa có mô hình · EMA/LRC chưa cùng hướng",
		recentSignals: "Tín hiệu gần đây",
		riskReward: "RỦI RO/LỢI NHUẬN",
		trendMtf: "Xu hướng · nhiều khung thời gian",
		wait: "CHỜ",
		warmingUp: "ĐANG KHỞI ĐỘNG"
	},
	overbought: "Quá mua",
	overboughtMax: "Quá mua tối đa",
	overboughtMin: "Quá mua tối thiểu",
	oversold: "Quá bán",
	oversoldMax: "Quá bán tối đa",
	oversoldMin: "Quá bán tối thiểu",
	rsiLength: "Độ dài RSI",
	rsiLine: "Đường RSI",
	rsiLineShadow: "Bóng đường RSI",
	sell: "Bán",
	short: "Short",
	signalsFromHeikinAshiCandles: "Tín hiệu từ nến Heikin Ashi",
	sl: "Cắt lỗ",
	smoothedMode: "Chế độ làm mượt",
	sydney: "Sydney",
	sydneyBackground: "Nền Sydney",
	sydneySession: "Phiên Sydney",
	tfD1: "D1",
	tfH1: "H1",
	tfH4: "H4",
	tfM1: "M1",
	tfM15: "M15",
	tfM30: "M30",
	tfM5: "M5",
	tokyo: "Tokyo",
	tokyoBackground: "Nền Tokyo",
	tokyoSession: "Phiên Tokyo",
	tp: "Chốt lời {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "giảm",
			bullish: "tăng",
			confluence: "hội tụ",
			entry: "điểm vào",
			neckline: "đường viền cổ",
			score: "điểm số",
			state: "trạng thái",
			states: {
				completed: "hoàn thành",
				invalidated: "vô hiệu",
				projected: "dự kiến",
				przActive: "PRZ đang hoạt động",
				stopped: "đã chạm dừng lỗ"
			},
			stop: "dừng lỗ",
			target: "mục tiêu"
		},
		classic: {
			doubleBottom: "Hai đáy",
			doubleTop: "Hai đỉnh",
			headAndShoulders: "Vai-Đầu-Vai",
			inverseHeadAndShoulders: "VĐV ngược",
			tripleBottom: "Ba đáy",
			tripleTop: "Ba đỉnh"
		},
		direction: {
			bearishOnly: "Chỉ giảm",
			both: "Cả hai",
			bullishOnly: "Chỉ tăng"
		},
		group: {
			classics: "Mô hình cổ điển & S/R",
			filters: "Bộ lọc & hiển thị",
			patterns: "Mô hình",
			pivotEngine: "Bộ máy pivot",
			ratios: "Tỷ lệ & dung sai"
		},
		input: {
			atrLen: "Chu kỳ ATR",
			atrMult: "Đảo chiều zigzag (x ATR)",
			colBear: "Giảm",
			colBull: "Tăng",
			colPrz: "PRZ",
			colSR: "Mức quan trọng",
			dirFilter: "Bộ lọc hướng",
			enClassics: "Nhận diện mô hình cổ điển",
			enDoubles: "Hai đỉnh / Hai đáy",
			enHS: "Vai-Đầu-Vai",
			enTriples: "Ba đỉnh / Ba đáy",
			fillTransp: "Độ trong suốt màu nền mô hình",
			formingLife: "Thời gian tồn tại của vùng đang hình thành (nến)",
			keepFailed: "Giữ các mô hình đã cắt lỗ trên biểu đồ (✕, làm mờ)",
			keepSuccessful: "Giữ các mô hình thành công trên biểu đồ (✓)",
			maxPatterns: "Số mô hình tối đa trên biểu đồ",
			minScore: "Điểm chất lượng tối thiểu",
			pivotDepth: "Độ sâu bộ đệm pivot",
			showLetters: "Hiển thị chữ cái các điểm X A B C D",
			showPlan: "Hiển thị các mức kế hoạch giao dịch",
			showProjected: "Hiển thị mô hình dự phóng (đang hình thành)",
			showRatios: "Hiển thị tỷ lệ trên các cạnh",
			showSR: "Các mức hỗ trợ/kháng cự",
			showStats: "Hiển thị bảng thống kê",
			srMinTouch: "S/R: số lần chạm pivot tối thiểu",
			tolEdge: "Dung sai ở mép vùng",
			tolPoint: "Dung sai tỷ lệ điểm",
			useScale2: "Quét thêm thang 2x (cấu trúc lớn hơn)"
		},
		label: {
			confirmed: "đã xác nhận",
			forming: "đang hình thành",
			sl: "SL",
			target: "mục tiêu",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "Hoàn tất",
			stops: "Cắt lỗ",
			t1Wins: "Đạt T1",
			winRate: "Tỷ lệ thắng %"
		},
		tooltip: {
			colPrz: "PRZ màu hổ phách bất kể hướng của mô hình (mặc định của ProTrader).",
			fillTransp: "Thấp hơn = màu nền rõ hơn. Khoảng 65-80 là phù hợp.",
			formingLife: "Mô hình đang hình thành có điểm C cũ hơn giá trị này mà chưa hoàn tất và chưa bị vô hiệu sẽ hết hạn và bị xóa.",
			maxPatterns: "Các mô hình cũ nhất bị xóa trước, nhờ vậy lịch sử gần đây (✓ / ✕) và các vùng mới đang hình thành luôn hiển thị.",
			showProjected: "Vẽ cấu trúc X-A-B với đường dẫn nét đứt tới PRZ dự phóng.",
			showRatios: "Các đường chéo đo nét chấm (X-B, A-C, B-D, X-D) kèm tỷ lệ Fibonacci đo được ở điểm giữa mỗi đường, cách chú thích chuẩn trên biểu đồ mô hình hài hòa.",
			tolPoint: "Áp dụng cho các tỷ lệ chính xác như Gartley B=0.618. Chặt = 0.03, cân bằng = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ ĐÓNG TẤT CẢ",
		duplicateRemoved: "Mỗi đồ thị chỉ hỗ trợ một chỉ báo Trade Finder; bản trùng đã được xóa.",
		durationHm: "{{h}} giờ {{m}} phút",
		durationM: "{{m}} phút",
		emaEntry1: "EMA Điểm vào 1",
		emaEntry2: "EMA Điểm vào 2 / Xu hướng",
		emaRangeFilter: "EMA Bộ lọc biên độ",
		emaTrigger: "EMA Kích hoạt",
		entry1: "Điểm vào 1",
		entry2: "Điểm vào 2",
		entry2Mark: "E2",
		entryZoneBear: "Vùng vào lệnh {{n}} (giảm)",
		entryZoneBull: "Vùng vào lệnh {{n}} (tăng)",
		frameFailed: "Không tải được khung thời gian {{frame}}; sẽ thử lại.",
		framesUnavailable: "Không có dữ liệu khung · chờ",
		ghostEntry: "Thiết lập trước",
		ghostStop: "Cắt lỗ trước",
		group: {
			bias: "Thiên hướng",
			display: "Hiển thị",
			emaSystem: "Hệ thống EMA",
			entries: "Vào lệnh",
			filter: "Bộ lọc",
			riskManagement: "Quản trị rủi ro",
			session: "Phiên giao dịch",
			supportResistance: "Hỗ trợ và kháng cự",
			trailingStop: "Cắt lỗ động",
			trendPanel: "Bảng xu hướng"
		},
		input: {
			adxLen: "Độ dài ADX",
			adxSmoothing: "Làm mượt ADX",
			asiaSession: "Phiên Á / Tokyo (UTC)",
			atrBufferMultBtc: "Đệm cắt lỗ sau swing — BTC (× ATR)",
			atrBufferMultGold: "Đệm cắt lỗ sau swing — vàng (× ATR)",
			atrBufferMultOther: "Đệm cắt lỗ sau swing — khác (× ATR)",
			atrLength: "Độ dài ATR (quản trị rủi ro)",
			atrSlMult: "Cắt lỗ = ATR ×",
			atrTpMult: "Chốt lời {{n}} = ATR ×",
			beGoldPoints: "Vàng: hòa vốn sau bấy nhiêu điểm",
			biasEmaLen: "Độ dài EMA thiên hướng",
			crossLookback: "Cửa sổ giao cắt thiên hướng (nến)",
			dxySymbol: "Mã chỉ số đô la (để trống là tắt)",
			emaBigLen: "Độ dài EMA Bộ lọc biên độ",
			emaFastLen: "Độ dài EMA Điểm vào 1",
			emaMidLen: "Độ dài EMA Điểm vào 2 / Xu hướng",
			emaTriggerLen: "Độ dài EMA Kích hoạt",
			feeBufferPct: "Đệm phí vượt điểm hòa vốn (%)",
			flatThreshPct: "Ngưỡng đi ngang (% của EMA thiên hướng)",
			londonSession: "Phiên London (UTC)",
			maxCrosses: "Số giao cắt tối đa trước khi bỏ thiên hướng",
			newYorkSession: "Phiên New York (UTC)",
			showEmaLabels: "Hiện nhãn tên EMA",
			showEntrySignals: "Hiện dấu thiết lập",
			showEntryZone: "Hiển thị vùng vào lệnh",
			showSRLines: "Hiển thị hỗ trợ và kháng cự",
			showTradeLevels: "Hiện mức vào lệnh, cắt lỗ và mục tiêu",
			slMaxPointsBtc: "Khoảng cắt lỗ tối đa — BTC (điểm)",
			slMaxPointsGold: "Khoảng cắt lỗ tối đa — vàng (điểm)",
			slMaxPointsIndex: "Khoảng cắt lỗ tối đa — chỉ số (điểm)",
			slMaxPointsOther: "Khoảng cắt lỗ tối đa — khác (điểm)",
			slMinPointsGold: "Khoảng cắt lỗ tối thiểu — vàng (điểm)",
			slopeLookback: "Cửa sổ độ dốc thiên hướng (nến)",
			srLeftBars: "Hỗ trợ / kháng cự · số nến bên trái pivot",
			srRightBars: "Hỗ trợ / kháng cự · số nến bên phải pivot",
			swingPivotLen: "Độ dài pivot swing (cắt lỗ)",
			tp1ClosePct: "Đóng tại chốt lời 1 (%)",
			tp2ClosePct: "Đóng tại chốt lời 2 (%)",
			tp5CloseAlways: "Chốt lời 5 luôn đóng lệnh, kể cả khi đang trailing",
			tpR: "Chốt lời {{n}} (theo R)",
			tpSlMode: "Chế độ cắt lỗ và mục tiêu",
			trailAtrMult: "Khoảng cắt lỗ động (× ATR)",
			trendPanelEmaLen: "Độ dài EMA của hàng xu hướng",
			trendSlopeLB: "Số nến tính độ dốc EMA Điểm vào 2",
			useAdxFilter: "Yêu cầu ADX trên ngưỡng của chế độ",
			useBiasFilter: "Chấm điểm thiên hướng khung lớn (không bao giờ chặn lệnh)",
			useEmaStackCheck: "Yêu cầu các EMA xếp đúng thứ tự",
			useInstrumentAutoDetect: "Tự động nhận diện sản phẩm",
			useSessionFilter: "Chỉ báo tín hiệu trong phiên giao dịch",
			useSlopeDynamic: "Điều chỉnh số nến độ dốc theo khung thời gian",
			useStrictCandle: "Bộ lọc nến nghiêm ngặt (râu và giá đóng)",
			useTrailingStop: "Cắt lỗ động (từ chốt lời 1)",
			useVolumeConfirm: "Yêu cầu khối lượng trên trung bình khi vào lệnh",
			volAvgLen: "Độ dài trung bình khối lượng",
			volMultiplier: "Khối lượng tối thiểu (× trung bình)"
		},
		maxStop: "Cắt lỗ tối đa",
		minuteAgainst: "Cắt ngược thiết lập",
		minuteOk: "Không có cảnh báo",
		minuteReversal: "Cắt · có thể đảo chiều",
		modeAtr: "ATR",
		modeAuto: "Tự động",
		modeRiskReward: "Rủi ro / lợi nhuận",
		noBias: "Không có thiên hướng",
		noSetup: "Không có thiết lập nào",
		recentTitle: "Thiết lập gần đây",
		reEntry: "Vào lại",
		reEntryMark: "RE",
		rest: "CÒN LẠI",
		rowBias: "Bias",
		rowContext: "Bối cảnh",
		rowInfo: "Thông tin",
		rowSession: "Phiên",
		rowSetup: "Thiết lập",
		rowVolume: "Volume",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "còn {{time}}",
		sessionOutside: "Ngoài giờ · London {{time}} UTC",
		sessionOverlap: "Giao phiên",
		statsTitle: "{{n}} thiết lập gần nhất",
		statusBreakEvenSet: "Hòa vốn",
		statusMoveToBreakEven: "Dời stop",
		statusPending: "Chạm vùng",
		statusRunning: "Đang chạy",
		statusSpike: "Biến động · chờ",
		statusWaiting: "Đang chờ",
		stopHit: "Chạm cắt lỗ",
		styleDaytrade: "Trong ngày",
		styleScalping: "Lướt sóng",
		styleSwing: "Swing",
		subFrameReversal: "Khung dưới đang đảo chiều",
		targetHit: "Đạt mục tiêu cuối",
		trailStop: "Cắt lỗ động",
		volAboveAverage: "trên trung bình",
		volBelowAverage: "dưới trung bình",
		zoneEdgeBear: "Biên vùng {{n}} (giảm)",
		zoneEdgeBull: "Biên vùng {{n}} (tăng)"
	},
	tradingSessions: "Phiên giao dịch",
	unintendedSymbol: "Chiến lược này dành cho {{symbols}}; trên {{symbol}} các mức của nó có thể không có ý nghĩa gì.",
	utBotAlerts: "Cảnh báo UT Bot"
}, Ce = {
	asia: "亚洲",
	atrPeriod: "ATR周期",
	auraScanner: {
		guide: {
			bigDiamondMark: "大型红色／绿色",
			bigDiamondMeaning: "高点上方的大型红色菱形提示买入风险。低点下方的大型绿色菱形提示卖出风险。",
			blueMark: "蓝色曲线",
			blueMeaning: "50 EMA。粉色在蓝色上方表示买入，下方表示卖出。",
			dashedMark: "虚线",
			dashedMeaning: "支撑位和阻力位。红色在价格下方，绿色在上方。",
			diamondsMark: "菱形",
			diamondsMeaning: "转折点。金色最弱，其次是蓝色、红色和绿色。",
			flatGoldMark: "水平金线",
			flatGoldMeaning: "15分钟图上最近六小时成交量最大的价位。",
			levelsMark: "价位线",
			levelsMeaning: "最近一笔交易的入场、止损和目标。对勾表示已触及。",
			pinkMark: "粉色曲线",
			pinkMeaning: "20 EMA。与蓝线交叉时产生信号。",
			subtitle: "如何阅读此图表",
			thickGoldMark: "粗金线",
			thickGoldMeaning: "238线。如果位于入场与目标之间，请跳过。",
			title: "AURA",
			triangleMark: "三角形",
			triangleMeaning: "通过全部检查的交易。悬停可查看数值。"
		},
		groups: {
			display: "显示",
			eightChecks: "八项检查",
			riskAndTargets: "风险与目标",
			signalEngine: "信号引擎"
		},
		inputs: {
			emaFastLen: "快线（粉色）",
			emaSlowLen: "慢线（蓝色）",
			f1Clock: "1. 仅在成交量充足的时段",
			f2Trend: "2. 顺应15分钟趋势",
			f3Mode: "3. K线颜色不符时",
			f4Min: "最小扩张幅度（每根K线的点数）",
			f4Sep: "4. 两线正在分离",
			f5Clear: "5. 238不在入场与目标之间",
			f6R: "最小空间（风险倍数）",
			f6Reward: "6. 距下一价位的空间",
			f7Bars: "最近检查的K线数",
			f7Consol: "7. 未困于盘整区间",
			f7Pips: "区间必须大于（点）",
			f9Bars: "最近N根K线内",
			f9Star: "8. 无大型警告菱形",
			guidePos: "说明面板位置",
			longMode: "安全线（238）模式",
			panelSize: "面板文字大小",
			pipIn: "点值大小（0 = 自动）",
			showClock: "当前情况面板",
			showGuide: "标记含义说明",
			showLadder: "右侧交易价位",
			showPoc: "成交量线",
			showSr: "虚线价位",
			showStars: "警告菱形",
			showTable: "趋势表",
			showTint: "背景颜色",
			showWhy: "解释跳过的信号",
			slMinPips: "越过慢线的最小间距（点）",
			srAtrMove: "价位：所需反弹幅度（正常K线大小的倍数）",
			srLookback: "价位：转折点回溯范围",
			srMax: "屏幕保留价位数量上限",
			srRange: "忽略更远价位（正常K线大小的倍数）",
			srReset: "价位：移除前的重复测试次数",
			stripLen: "右侧栏宽度（K线数）",
			tablePos: "当前情况面板位置",
			theme: "图表主题",
			tp1R: "TP1（R倍数）",
			tp2R: "TP2（R倍数）",
			trendPos: "趋势表位置",
			tz: "交易时段时区"
		},
		ladder: {
			closedAtStop: "已止损平仓",
			closedAtTarget: "已平仓 TP{{hit}}",
			entry: "入场",
			stop: "止损",
			tp1: "TP1",
			tp2: "TP2"
		},
		options: {
			autoScale: "自动缩放",
			bottomCentre: "底部居中",
			bottomLeft: "左下",
			bottomRight: "右下",
			dark: "深色",
			ignore: "忽略",
			large: "大",
			light: "浅色",
			literal238: "固定238",
			middleCentre: "正中",
			middleLeft: "左侧居中",
			middleRight: "右侧居中",
			normal: "标准",
			reject: "拒绝",
			small: "小",
			topCentre: "顶部居中",
			topLeft: "左上",
			topRight: "右上",
			waitForPullback: "等待回调"
		},
		reasons: {
			clock: "不在交易时段内",
			diamond: "刚出现大型警告菱形",
			range: "图表处于盘整状态",
			room: "价位太近，目标前没有足够空间",
			safetyLine: "238位于入场与目标之间",
			separation: "两线过近，暂时没有运行空间",
			trend: "逆15分钟趋势",
			wrongColour: "交叉K线收盘时颜色不符"
		},
		rightNow: {
			aBuy: "买入",
			aSell: "卖出",
			bestBuysOnly: "只寻找买入机会",
			bestNow: "当前最佳选择",
			bestSellsOnly: "只寻找卖出机会",
			bestWaitThin: "等待，成交量不足",
			goodVolume: "成交量充足",
			lowVolume: "成交量低",
			safetyAbove: "238在价格上方，卖出有空间",
			safetyBelow: "238在价格下方，买入有空间",
			safetyLine: "安全线",
			skipped: "已跳过",
			skippedAgo_other: "{{bars}}根K线前的{{side}}：{{reason}}",
			skippedNothing: "尚未跳过任何信号",
			title: "当前情况",
			trend: "趋势",
			trendSummaryDown: "15m下行，6个周期中{{agree}}个上行",
			trendSummaryUp: "15m上行，6个周期中{{agree}}个上行"
		},
		signal: {
			buy: "买入",
			pips: "点",
			sell: "卖出",
			stop: "止损"
		},
		tooltip: {
			f3Mode: "红色K线上的买入或蓝色K线上的卖出不会直接执行。“等待回调”会等价格在正确颜色的K线上回到两线区域。“拒绝”会舍弃该信号。",
			f4Min: "信号K线上两线分离的速度。两线纠缠且平坦时，没有运行空间。",
			f6Reward: "下一条虚线价位至少要相距这么远。默认关闭：价位由此扫描器的独有方法绘制，因此还需目测空间。",
			f7Pips: "避开宽度不超过100点的盘整区间。",
			longMode: "238是为1分钟图设计的标准设置。自动缩放会根据其他周期调整安全线，例如3分钟图约为83。",
			pipIn: "自动：黄金为0.10，其他品种为十个最小变动单位（US30为1点）。",
			showGuide: "图表上的简短图例。熟悉标记后可关闭。",
			showLadder: "最近一笔交易的入场、止损和目标绘制在最后一根K线右侧。目标触及时显示对勾。",
			showWhy: "当两线交叉但某项检查阻止交易时，当前情况面板会说明是哪项检查及其原因。",
			slMinPips: "止损放在红线和蓝线的另一侧，距蓝线至少10点。",
			srMax: "只保留最接近价格的价位，以保持图表清晰。",
			theme: "与TradingView主题保持一致，以便清楚辨认所有颜色。",
			tz: "交易时段按此时区设置。America/Denver为实行夏令时的北美山地时间。如需不实行夏令时的山地时间，请使用America/Phoenix。"
		},
		trendTable: {
			above: "上方",
			below: "下方",
			down: "下行",
			notAvailable: "无数据",
			up: "上行",
			volumeLine: "成交量线"
		}
	},
	bearish: "看跌",
	bfs: {
		duplicateRemoved: "每张图表只支持一个 BFS — Blessed Flow System 指标，重复的那个已被移除。",
		emaCrossSoon: "EMA30/50 即将交叉",
		engineOff: "请切换到 M1",
		engineOn: "引擎 M1",
		input: {
			armWin: "触及 EMA30 的窗口（M1 K 线数）",
			asiaSess: "亚洲（HHMM-HHMM）",
			bePts: "保本：盈利 +点 时，止损移到该价位",
			cooldown: "平仓后的冷却（M1 K 线数）",
			lenFast: "快线 EMA（定方向）",
			lenH1a: "H1 · 短周期 EMA",
			lenH1b: "H1 · 长周期 EMA",
			lenMid: "中线 EMA",
			lenSlow: "慢线 EMA",
			londonSess: "伦敦（HHMM-HHMM，时段时钟）",
			maxPerBlock: "每个时段区间最多入场次数（0 = 不限）",
			nearLb: "用于衡量收敛的 K 线数",
			nearPts: "EMA30-EMA50 最大间距（点）",
			nySess: "纽约（HHMM-HHMM）",
			onlyM1: "仅在 M1 上运行引擎",
			pv: "1 点对应的价格",
			r1lb: "R1 · 回溯的 M1 K 线数（价格未过度偏离）",
			rr: "止盈盈亏比 R:R（不使用多级止盈时）",
			rsiHi: "做空所需 RSI >=",
			rsiLen: "RSI 周期",
			rsiLo: "做多所需 RSI <=",
			rsiWin: "等待窗口（信号后的 K 线数）",
			showLevels: "绘制交易价位",
			showNear: "EMA30 即将上穿/下穿 EMA50 时标记",
			slPts: "止损（点）",
			swLenA: "枢轴强度（每侧 K 线数）",
			tp1Pts: "TP1（点）",
			tp2Pts: "TP2（点）",
			tp3Pts: "TP3（点）",
			tzOffset: "时段时钟的 UTC 偏移（波哥大 = -5）",
			useArm: "要求 50% 回撤并在窗口内触及 EMA30",
			useAsia: "纳入亚洲时段（仅供测试）",
			useBE: "启用保本",
			useLadder: "使用 TP1/TP2/TP3（最终离场 = TP3）",
			useR2: "R2 · 要求 M5 + M15 排列及 H1 方向一致",
			useRSI: "出现信号后等待 RSI",
			useSess: "按交易时段过滤",
			useTrend: "等待期间保持 EMA 排列"
		},
		longSignal: "做多信号",
		noSignal: "无信号",
		retracementDot: "50% 回撤标记点",
		rewardZone: "盈利区",
		riskZone: "风险区",
		session: "时段",
		sessionClosed: "已收盘",
		sessionOpen: "开盘中",
		shortSignal: "做空信号",
		signal: "信号",
		signalActive: "{{side}} 进行中",
		waitingRsi: "等待 RSI {{arrow}}（{{n}}）",
		waitingRsiLong: "等待 RSI（做多）",
		waitingRsiShort: "等待 RSI（做空）"
	},
	breakEven: "保本",
	bullish: "看涨",
	buy: "买入",
	colour: "颜色",
	cypher: {
		above55: "高于55",
		aboveBelow: "上方/下方",
		barColors: "K线颜色",
		bbLength: "BB长度",
		bbStdDev: "BB标准差 {{n}}",
		bearBreak: "看跌突破",
		bearPattern: "看跌Pin Bar／吞没",
		below55: "低于55",
		bullBreak: "看涨突破",
		bullPattern: "看涨Pin Bar／吞没",
		cmoLength: "CMO长度",
		colorCandles: "为K线着色",
		confluenceLong: "共振做多",
		confluenceShort: "共振做空",
		consolidating: "盘整中",
		direction: "方向",
		emaPeriodTrend: "EMA周期（趋势）",
		flagOffsetAtr: "旗标偏移（x ATR）",
		flashBackground: "闪烁背景",
		flashCount: "闪烁次数",
		flashHz: "闪烁速度（次 / 秒）",
		flashOn: "新旗标时闪烁",
		flashShowBanner: "显示NEW BUY / SELL横幅",
		flashShowBg: "闪烁图表背景",
		flashStrength: "背景闪烁强度",
		flashTest: "立即测试闪烁（预览）",
		fvgKeep: "每侧保留的公允价值缺口",
		glowOpacity: "光晕不透明度（越高越透明）",
		glowSizeTicks: "光晕大小（tick）",
		groupFlash: "新旗标提醒",
		groupHalfTrend: "Half Trend",
		groupIchimoku: "一目均衡表",
		groupKde: "KDE价位",
		groupKeyLevels: "关键价位",
		groupLrEma: "LR通道 / EMA",
		groupMaCloud: "MA Cloud",
		groupPivots: "枢轴点",
		groupPsar: "抛物线SAR",
		groupReversalBands: "反转带",
		groupRsi: "RSI",
		groupSuperTrend: "Super Trend",
		groupSuperTrend2: "Super Trend 2",
		groupToggles: "组件",
		groupTrendTable: "趋势表",
		groupVidya: "VIDYA / 趋势",
		halfTrendAmplitude: "HalfTrend振幅",
		halfTrendChannelDeviation: "HalfTrend通道偏差",
		ichimokuBase: "一目均衡表基准线",
		ichimokuConversion: "一目均衡表转换线",
		kdeActivation: "启用激活阈值",
		kdeBins: "区间数量",
		kdeThreshold: "阈值 %",
		labelPosition: "标签位置",
		lineWidth: "线宽",
		lowerBb: "下轨BB{{n}}",
		lowerInnerZone: "下方内区",
		lowerReversalZone: "下方反转区",
		maCloudLong: "MA云（长期）",
		maCloudShort: "MA云（短期）",
		newBuy: "新买入",
		newSell: "新卖出",
		numberOfLevels: "价位数量",
		parabolicSar: "抛物线SAR",
		pivotAuto: "自动",
		pivotDaily: "日线",
		pivotMonthly: "月线",
		pivotsTimeframe: "枢轴点时间周期",
		pivotWeekly: "周线",
		positionBottomCenter: "底部居中",
		positionBottomLeft: "左下",
		positionBottomRight: "右下",
		positionLeft: "左",
		positionRight: "右",
		positionTopCenter: "顶部居中",
		positionTopLeft: "左上",
		positionTopRight: "右上",
		psarBear: "PSAR看跌",
		psarBull: "PSAR看涨",
		psarIncrement: "PSAR增量",
		psarMax: "PSAR最大值",
		psarStart: "PSAR起始值",
		pullingBack: "回调中",
		pulseSmoothingBars: "Pulse平滑K线数",
		reEntry: "再入场",
		rightOffsetBars: "右侧偏移（K线数）",
		showCamarillaPivots: "显示Camarilla枢轴点",
		showConfluenceFlag: "显示共振信号旗标（B/S）",
		showFvg: "公允价值缺口（15分钟及以上）",
		showKde: "KDE成交量价位",
		showKeyLevels: "显示关键价位",
		showLabels: "显示标签",
		showLevelGlow: "显示价位光晕",
		showMaCloud: "显示MA云",
		showPrices: "显示价格",
		showPsar: "显示PSAR",
		showReversalBands: "显示反转带",
		showSlTpLabels: "显示SL / TP标签",
		showSniperBreakArrows: "显示Sniper/突破箭头",
		showTrendTable: "显示趋势表",
		showVidya233: "显示VIDYA 233",
		showVidya55: "显示VIDYA 55",
		showVidya987: "显示VIDYA 987（磁力线）",
		showVidyaLines: "显示VIDYA线",
		sizeNormal: "正常",
		sizeSmall: "小",
		sizeTiny: "极小",
		slBufferAtr: "SL 缓冲上限（x ATR）",
		slBufferPips: "SL 摆动外缓冲（点）",
		slMaxRiskAtr: "SL 最大风险（x ATR）",
		slSwingLookback: "SL 摆动回溯（K线数）",
		sniperDown: "Sniper向下",
		sniperUp: "Sniper向上",
		source: "来源",
		state: "状态",
		strength: "强度",
		strong: "强",
		superTrend2AtrLength: "SuperTrend 2 ATR长度",
		superTrend2Factor: "SuperTrend 2系数",
		superTrendAtrLength: "SuperTrend ATR长度",
		superTrendMultiplier: "SuperTrend乘数",
		tablePosition: "表格位置",
		tableSize: "表格大小",
		tpRiskReward: "TP {{n}} 风险回报比",
		tradeManagement: "交易管理（SL / TP）",
		trend: "趋势",
		trending: "趋势中",
		upperBb: "上轨BB{{n}}",
		upperInnerZone: "上方内区",
		upperReversalZone: "上方反转区",
		veryStrong: "非常强",
		veryWeak: "非常弱",
		vidya987Magnet: "VIDYA 987（磁力线）",
		volumeAvgLength: "成交量均值长度（突破过滤）",
		weak: "弱",
		zoneEdge: "{{name}}（填充边界）"
	},
	entry: "入场",
	gainColor: "盈利颜色",
	harsiCandle: "HARSI蜡烛",
	harsiLength: "HARSI长度",
	heikinAshiRsiOscillator: "平均足RSI振荡器",
	keyValueThisChangesTheSensitivity: "关键值 '这会改变灵敏度'",
	labelsIndicator: "标签指标",
	london: "伦敦",
	londonBackground: "伦敦背景",
	londonSession: "伦敦时段",
	long: "做多",
	lossColor: "亏损颜色",
	median: "中位数",
	neutral: "中性",
	newYork: "纽约",
	newYorkBackground: "纽约背景",
	newYorkSession: "纽约时段",
	openSmoothing: "开盘平滑",
	optimus: {
		activeTradeLevels: "持仓中 · 价位",
		bias: "方向",
		biasAgreed: "{{side}} {{n}}/{{total}}",
		biasMixed: "分歧 {{n}}/{{total}}",
		disclaimer: "价位已画在图表上。本内容不构成投资建议。",
		duplicateRemoved: "每张图表只支持一个 Optimus Prime 指标，重复的那个已被移除。",
		enter: "入场 · {{side}}",
		input: {
			atrLength: "KC 的 ATR 周期",
			buffer: "波段缓冲（按价格）",
			emaLength: "EMA 周期",
			kcLength: "KC 周期",
			kcMult: "KC 乘数",
			lrcLength: "LRC 周期",
			minRisk: "最小风险 R（按价格）",
			requireAlign: "要求 EMA 与 LRC 方向一致",
			rrTp1: "TP1（xR）",
			rrTp2: "TP2（xR）",
			rrTp3: "TP3（xR）",
			rrTp4: "TP4（xR）",
			swingLookback: "波段回溯 K 线数（R）"
		},
		kcLower: "KC 下轨",
		kcMid: "KC 中轨",
		kcUpper: "KC 上轨",
		keltnerFill: "Keltner 填充",
		noClosedTrades: "暂无已平仓交易",
		reasonForming: "形态正在形成 — 等待确认",
		reasonLatched: "交易已锁定 · 价位已画在图上",
		reasonNoSetup: "暂无形态 · EMA/LRC 方向不一致",
		recentSignals: "最近信号",
		riskReward: "风险/收益",
		trendMtf: "趋势 · 多周期",
		wait: "等待",
		warmingUp: "正在预热"
	},
	overbought: "超买",
	overboughtMax: "超买最大值",
	overboughtMin: "超买最小值",
	oversold: "超卖",
	oversoldMax: "超卖最大值",
	oversoldMin: "超卖最小值",
	rsiLength: "RSI长度",
	rsiLine: "RSI线",
	rsiLineShadow: "RSI线阴影",
	sell: "卖出",
	short: "做空",
	signalsFromHeikinAshiCandles: "来自平均足蜡烛的信号",
	sl: "止损",
	smoothedMode: "平滑模式",
	sydney: "悉尼",
	sydneyBackground: "悉尼背景",
	sydneySession: "悉尼时段",
	tfD1: "1天",
	tfH1: "1小时",
	tfH4: "4小时",
	tfM1: "1分",
	tfM15: "15分",
	tfM30: "30分",
	tfM5: "5分",
	tokyo: "东京",
	tokyoBackground: "东京背景",
	tokyoSession: "东京时段",
	tp: "止盈 {{n}}",
	traceScanner: {
		chartTooltip: {
			bearish: "看跌",
			bullish: "看涨",
			confluence: "汇合",
			entry: "入场",
			neckline: "颈线",
			score: "评分",
			state: "状态",
			states: {
				completed: "已完成",
				invalidated: "已失效",
				projected: "预测",
				przActive: "PRZ 激活",
				stopped: "已止损"
			},
			stop: "止损",
			target: "目标"
		},
		classic: {
			doubleBottom: "双底",
			doubleTop: "双顶",
			headAndShoulders: "头肩形态",
			inverseHeadAndShoulders: "头肩底",
			tripleBottom: "三重底",
			tripleTop: "三重顶"
		},
		direction: {
			bearishOnly: "仅看跌",
			both: "双向",
			bullishOnly: "仅看涨"
		},
		group: {
			classics: "经典形态与 S/R",
			filters: "过滤与显示",
			patterns: "形态",
			pivotEngine: "枢轴引擎",
			ratios: "比率与容差"
		},
		input: {
			atrLen: "ATR周期",
			atrMult: "Zigzag 反转 (x ATR)",
			colBear: "看跌",
			colBull: "看涨",
			colPrz: "PRZ",
			colSR: "关键价位",
			dirFilter: "方向过滤",
			enClassics: "识别经典形态",
			enDoubles: "双顶 / 双底",
			enHS: "头肩形态",
			enTriples: "三重顶 / 三重底",
			fillTransp: "形态填充透明度",
			formingLife: "形成中区域的存续时间 (K 线数)",
			keepFailed: "在图表上保留已止损的形态 (✕，变暗)",
			keepSuccessful: "在图表上保留成功的形态 (✓)",
			maxPatterns: "图表上的最大形态数",
			minScore: "最低质量评分",
			pivotDepth: "枢轴缓冲深度",
			showLetters: "显示 X A B C D 点字母",
			showPlan: "显示交易计划价位",
			showProjected: "显示预测 (形成中) 的形态",
			showRatios: "在各边上显示比率数值",
			showSR: "支撑/阻力位",
			showStats: "显示统计表",
			srMinTouch: "S/R 最少枢轴触碰次数",
			tolEdge: "区间边缘容差",
			tolPoint: "点位比率容差",
			useScale2: "同时扫描 2x 级别 (更大结构)"
		},
		label: {
			confirmed: "已确认",
			forming: "形成中",
			sl: "SL",
			target: "目标",
			tp1: "TP1",
			tp2: "TP2"
		},
		table: {
			done: "已完成",
			stops: "止损",
			t1Wins: "达到 T1",
			winRate: "胜率 %"
		},
		tooltip: {
			colPrz: "无论形态方向如何，PRZ 均为琥珀色 (ProTrader 默认)。",
			fillTransp: "数值越低，填充越明显。65-80 左右效果较好。",
			formingLife: "若形成中形态的 C 点早于该值，且既未完成也未失效，则该形态过期并被移除。",
			maxPatterns: "最早的形态会被优先移除，因此近期历史 (✓ / ✕) 和新形成的区域始终可见。",
			showProjected: "绘制 X-A-B 结构，并用虚线引导至预测的 PRZ。",
			showRatios: "点线测量对角线 (X-B、A-C、B-D、X-D)，并在每条线的中点标出测得的斐波那契比率，这是谐波形态图表的标准标注。",
			tolPoint: "适用于精确比率，例如 Gartley B=0.618。严格 = 0.03，均衡 = 0.05"
		}
	},
	tradeFinder: {
		atrMultTag: "(ATR x{{mult}})",
		breakEvenMark: "BE ✓",
		closeAll: "★ 全部平仓",
		duplicateRemoved: "每张图表只支持一个 Trade Finder 指标，重复的那个已被移除。",
		durationHm: "{{h}}小时{{m}}分",
		durationM: "{{m}}分",
		emaEntry1: "EMA 入场 1",
		emaEntry2: "EMA 入场 2 / 趋势",
		emaRangeFilter: "EMA 区间过滤",
		emaTrigger: "EMA 触发",
		entry1: "入场 1",
		entry2: "入场 2",
		entry2Mark: "E2",
		entryZoneBear: "入场区 {{n}}（看跌）",
		entryZoneBull: "入场区 {{n}}（看涨）",
		frameFailed: "无法加载 {{frame}} 周期数据，将重试。",
		framesUnavailable: "缺少周期数据 · 等待",
		ghostEntry: "上一组设置",
		ghostStop: "上一个止损",
		group: {
			bias: "偏向",
			display: "显示",
			emaSystem: "EMA 系统",
			entries: "入场",
			filter: "过滤器",
			riskManagement: "风险管理",
			session: "交易时段",
			supportResistance: "支撑与阻力",
			trailingStop: "追踪止损",
			trendPanel: "趋势面板"
		},
		input: {
			adxLen: "ADX 周期",
			adxSmoothing: "ADX 平滑",
			asiaSession: "亚洲 / 东京时段（UTC）",
			atrBufferMultBtc: "波段后方止损缓冲 — BTC（× ATR）",
			atrBufferMultGold: "波段后方止损缓冲 — 黄金（× ATR）",
			atrBufferMultOther: "波段后方止损缓冲 — 其他（× ATR）",
			atrLength: "ATR 长度（风险管理）",
			atrSlMult: "止损 = ATR ×",
			atrTpMult: "止盈 {{n}} = ATR ×",
			beGoldPoints: "黄金：盈利达到该点数后移至保本",
			biasEmaLen: "偏向 EMA 周期",
			crossLookback: "偏向交叉回溯（K线）",
			dxySymbol: "美元指数代码（留空则关闭）",
			emaBigLen: "EMA 区间过滤周期",
			emaFastLen: "EMA 入场 1 周期",
			emaMidLen: "EMA 入场 2 / 趋势周期",
			emaTriggerLen: "EMA 触发周期",
			feeBufferPct: "保本之外的手续费缓冲（%）",
			flatThreshPct: "走平阈值（偏向 EMA 的 %）",
			londonSession: "伦敦时段（UTC）",
			maxCrosses: "超过该交叉次数则放弃偏向",
			newYorkSession: "纽约时段（UTC）",
			showEmaLabels: "显示 EMA 名称标签",
			showEntrySignals: "显示设置标记",
			showEntryZone: "显示入场区",
			showSRLines: "显示支撑与阻力",
			showTradeLevels: "显示入场、止损与目标位",
			slMaxPointsBtc: "最大止损距离 — BTC（点）",
			slMaxPointsGold: "最大止损距离 — 黄金（点）",
			slMaxPointsIndex: "最大止损距离 — 指数（点）",
			slMaxPointsOther: "最大止损距离 — 其他（点）",
			slMinPointsGold: "最小止损距离 — 黄金（点）",
			slopeLookback: "偏向斜率回溯（K线）",
			srLeftBars: "支撑 / 阻力 · 枢轴左侧的K线数",
			srRightBars: "支撑 / 阻力 · 枢轴右侧的K线数",
			swingPivotLen: "波段枢轴长度（止损）",
			tp1ClosePct: "止盈 1 平仓比例 (%)",
			tp2ClosePct: "止盈 2 平仓比例 (%)",
			tp5CloseAlways: "止盈 5 始终平仓，即使正在追踪",
			tpR: "止盈 {{n}}（以 R 计）",
			tpSlMode: "止损与目标模式",
			trailAtrMult: "追踪止损距离（× ATR）",
			trendPanelEmaLen: "趋势行 EMA 周期",
			trendSlopeLB: "EMA 入场 2 斜率回看（根）",
			useAdxFilter: "要求 ADX 高于模式阈值",
			useBiasFilter: "计入高周期偏向（从不阻止入场）",
			useEmaStackCheck: "要求 EMA 按顺序排列",
			useInstrumentAutoDetect: "自动识别品种",
			useSessionFilter: "仅在交易时段发出信号",
			useSlopeDynamic: "按周期缩放斜率回看长度",
			useStrictCandle: "严格K线过滤（影线与收盘）",
			useTrailingStop: "追踪止损（自止盈 1 起）",
			useVolumeConfirm: "入场时要求成交量高于均值",
			volAvgLen: "成交量均值周期",
			volMultiplier: "最低成交量（× 均值）"
		},
		maxStop: "最大止损",
		minuteAgainst: "与设置反向交叉",
		minuteOk: "无警告",
		minuteReversal: "交叉 · 可能反转",
		modeAtr: "ATR",
		modeAuto: "自动",
		modeRiskReward: "风险回报",
		noBias: "无偏向",
		noSetup: "无活动设置",
		recentTitle: "近期设置",
		reEntry: "再次入场",
		reEntryMark: "RE",
		rest: "剩余",
		rowBias: "偏向",
		rowContext: "环境",
		rowInfo: "信息",
		rowSession: "时段",
		rowSetup: "设置",
		rowVolume: "成交量",
		scoreLine: "S: {{setup}} / 5   E: {{entry}} / 100",
		scoreTag: "S:{{setup}} E:{{entry}}",
		sessionEndsIn: "剩余{{time}}",
		sessionOutside: "非交易时段 · 伦敦 {{time}} UTC",
		sessionOverlap: "重叠时段",
		statsTitle: "最近 {{n}} 组设置",
		statusBreakEvenSet: "保本",
		statusMoveToBreakEven: "移动止损",
		statusPending: "触及区域",
		statusRunning: "进行中",
		statusSpike: "波动大 · 等待",
		statusWaiting: "等待中",
		stopHit: "触发止损",
		styleDaytrade: "日内交易",
		styleScalping: "剥头皮",
		styleSwing: "波段",
		subFrameReversal: "低级别周期正在反转",
		targetHit: "达到最终目标",
		trailStop: "追踪止损",
		volAboveAverage: "高于均值",
		volBelowAverage: "低于均值",
		zoneEdgeBear: "区域边界 {{n}}（看跌）",
		zoneEdgeBull: "区域边界 {{n}}（看涨）"
	},
	tradingSessions: "交易时段",
	unintendedSymbol: "此策略是为 {{symbols}} 设计的，在 {{symbol}} 上它的价位可能没有意义。",
	utBotAlerts: "UT机器人警报"
}, L = F, we = {
	ar: { [L]: ue },
	de: { [L]: de },
	en: { [L]: fe },
	es: { [L]: pe },
	fr: { [L]: me },
	id: { [L]: he },
	ja: { [L]: ge },
	ko: { [L]: _e },
	pl: { [L]: ve },
	pt: { [L]: ye },
	ru: { [L]: be },
	th: { [L]: I },
	tr: { [L]: xe },
	vi: { [L]: Se },
	zh: { [L]: Ce }
}, R = e();
R.init({
	debug: !1,
	resources: we,
	ns: [L],
	defaultNS: L,
	fallbackLng: "en",
	interpolation: { escapeValue: !1 }
});
//#endregion
//#region src/components/harsi.ts
var Te = (e, t) => {
	let n = R.getFixedT(t || "en", F);
	return {
		name: "HARSI",
		metainfo: {
			_metainfoVersion: 51,
			id: "HARSI@tv-basicstudies-1",
			name: "HARSI",
			description: n("heikinAshiRsiOscillator"),
			shortDescription: "HARSI",
			isCustomIndicator: !0,
			is_price_study: !1,
			linkedToSeries: !0,
			format: {
				type: "price",
				precision: 2
			},
			inputs: [
				{
					id: "lenHARSI",
					name: n("harsiLength"),
					type: "integer",
					defval: 14,
					min: 1,
					max: 50
				},
				{
					id: "openSmooth",
					name: n("openSmoothing"),
					type: "integer",
					defval: 1,
					min: 1,
					max: 50
				},
				{
					id: "lenRSI",
					name: n("rsiLength"),
					type: "integer",
					defval: 7,
					min: 1,
					max: 50
				},
				{
					id: "smoothMode",
					name: n("smoothedMode"),
					type: "bool",
					defval: !1
				},
				{
					id: "obMax",
					name: n("overboughtMax"),
					type: "integer",
					defval: 30,
					min: -50,
					max: 50
				},
				{
					id: "obMin",
					name: n("overboughtMin"),
					type: "integer",
					defval: 20,
					min: -50,
					max: 50
				},
				{
					id: "osMax",
					name: n("oversoldMax"),
					type: "integer",
					defval: -30,
					min: -50,
					max: 50
				},
				{
					id: "osMin",
					name: n("oversoldMin"),
					type: "integer",
					defval: -20,
					min: -50,
					max: 50
				}
			],
			bands: [{
				id: "hline_0",
				name: n("median"),
				zorder: -1.1
			}],
			ohlcPlots: { plotcandle_0: { title: n("harsiCandle") } },
			defaults: {
				bands: [{
					color: "rgb(255, 152, 0)",
					linestyle: 4,
					linewidth: 1,
					visible: !0,
					value: 0
				}],
				ohlcPlots: { plotcandle_0: {
					plottype: "ohlc_candles",
					color: "#000000",
					borderColor: "#000000",
					wickColor: "#000000",
					drawWick: !0,
					drawBorder: !1,
					visible: !0
				} },
				palettes: {
					palette_bar: { colors: [{
						color: "#fb2c36",
						width: 1,
						style: 0
					}, {
						color: "#4caf50",
						width: 1,
						style: 0
					}] },
					fill_palette_1: { colors: [{ color: "rgba(255, 82, 82, 0.1)" }, { color: "rgba(0, 0, 0, 0)" }] },
					fill_palette_2: { colors: [{ color: "rgba(76, 175, 80, 0.1)" }, { color: "rgba(0, 0, 0, 0)" }] },
					fill_palette_3: { colors: [{ color: "rgba(33, 150, 243, 0.1)" }, { color: "rgba(0, 0, 0, 0)" }] }
				},
				styles: {
					rsiLine: {
						color: "rgba(250,200,50,1)",
						linewidth: 1
					},
					rsiLineShadow: {
						color: "rgb(29, 29, 29)",
						linewidth: 2
					},
					obMax: {
						color: "rgba(250,200,50,1)",
						linewidth: 1,
						visible: !1
					},
					obMin: {
						color: "rgba(250,200,50,1)",
						linewidth: 1,
						visible: !1
					},
					osMax: {
						color: "rgba(250,200,50,1)",
						linewidth: 1,
						visible: !1
					},
					osMin: {
						color: "rgba(250,200,50,1)",
						linewidth: 1,
						visible: !1
					}
				},
				precision: 2,
				inputs: {
					lenHARSI: 14,
					openSmooth: 1,
					lenRSI: 7,
					smoothMode: !1,
					obMax: 30,
					obMin: 20,
					osMax: -30,
					osMin: -20
				},
				filledAreasStyle: {
					fill_ob: {
						visible: !0,
						color: "#FF0000",
						transparency: 0
					},
					fill_os: {
						visible: !0,
						color: "#00FF00",
						transparency: 0
					},
					fill_between_os_ob: {
						visible: !0,
						color: "#0000FF",
						transparency: 0
					}
				}
			},
			styles: {
				rsiLine: { title: n("rsiLine") },
				rsiLineShadow: { title: n("rsiLineShadow") },
				obMax: { isHidden: !0 },
				obMin: { isHidden: !0 },
				osMax: { isHidden: !0 },
				osMin: { isHidden: !0 }
			},
			plots: [
				{
					id: "plot_0",
					type: "ohlc_open",
					target: "plotcandle_0"
				},
				{
					id: "plot_1",
					type: "ohlc_high",
					target: "plotcandle_0"
				},
				{
					id: "plot_2",
					type: "ohlc_low",
					target: "plotcandle_0"
				},
				{
					id: "plot_3",
					type: "ohlc_close",
					target: "plotcandle_0"
				},
				{
					id: "plot_bar_color",
					type: "ohlc_colorer",
					palette: "palette_bar",
					target: "plotcandle_0"
				},
				{
					id: "rsiLineShadow",
					type: "line",
					target: "rsiLineShadow"
				},
				{
					id: "rsiLine",
					type: "line",
					target: "rsiLine"
				},
				{
					id: "obMax",
					type: "line",
					target: "obMax"
				},
				{
					id: "obMin",
					type: "line",
					target: "obMin"
				},
				{
					id: "osMax",
					type: "line",
					target: "osMax"
				},
				{
					id: "osMin",
					type: "line",
					target: "osMin"
				},
				{
					id: "fill_ob_id",
					type: "colorer",
					target: "fill_ob",
					palette: "fill_palette_1"
				},
				{
					id: "fill_os_id",
					type: "colorer",
					target: "fill_os",
					palette: "fill_palette_2"
				},
				{
					id: "fill_between_os_ob_id",
					type: "colorer",
					target: "fill_between_os_ob",
					palette: "fill_palette_3"
				}
			],
			palettes: {
				palette_bar: {
					colors: [{ name: n("lossColor") }, { name: n("gainColor") }],
					valToIndex: {
						0: 0,
						1: 1
					}
				},
				fill_palette_1: {
					colors: [{ name: n("colour") }],
					valToIndex: {
						0: 0,
						1: 1
					}
				},
				fill_palette_2: {
					colors: [{ name: n("colour") }],
					valToIndex: {
						0: 0,
						1: 1
					}
				},
				fill_palette_3: {
					colors: [{ name: n("colour") }],
					valToIndex: {
						0: 0,
						1: 1
					}
				}
			},
			filledAreas: [
				{
					id: "fill_ob",
					objAId: "obMax",
					objBId: "obMin",
					type: "plot_plot",
					palette: "fill_palette_1",
					title: n("overbought")
				},
				{
					id: "fill_os",
					objAId: "osMax",
					objBId: "osMin",
					type: "plot_plot",
					palette: "fill_palette_2",
					title: n("oversold")
				},
				{
					id: "fill_between_os_ob",
					objAId: "osMin",
					objBId: "obMin",
					type: "plot_plot",
					palette: "fill_palette_3",
					title: n("neutral")
				}
			]
		},
		constructor: function() {
			let t = (t, n, r) => {
				for (let e = 1; e <= n; e++) if (Number.isNaN(t.get(e))) {
					n = e - 1;
					break;
				}
				let i = e.Std.change(t), a = e.Std.iff(+(i > 0), i, 0), o = e.Std.iff(+(i < 0), -i, 0), s = 0, c = 0;
				if (r === 0) {
					let t = this._context.new_unlimited_var(a), r = this._context.new_unlimited_var(o);
					s = e.Std.rma(t, n, this._context), c = e.Std.rma(r, n, this._context);
				} else if (r === 1) {
					let t = this._context.new_unlimited_var(a), r = this._context.new_unlimited_var(o);
					s = e.Std.rma(t, n, this._context), c = e.Std.rma(r, n, this._context);
				} else if (r === 2) {
					let t = this._context.new_unlimited_var(a), r = this._context.new_unlimited_var(o);
					s = e.Std.rma(t, n, this._context), c = e.Std.rma(r, n, this._context);
				} else if (r === 3) {
					let t = this._context.new_unlimited_var(a), r = this._context.new_unlimited_var(o);
					s = e.Std.rma(t, n, this._context), c = e.Std.rma(r, n, this._context);
				}
				return e.Std.rsi(s, c) - 50;
			};
			this.main = function(n, r) {
				this._context = n, n.setMinimumAdditionalDepth(30);
				let i = r(0), a = r(1), o = r(2), s = r(3), c = n.new_unlimited_var(e.Std.close(n)), l = t(c, i, 0), u = n.new_unlimited_var(l), d = e.Std.nz(u.get(1), u.get(0)), f = n.new_unlimited_var(e.Std.high(n)), p = t(f, i, 1), m = n.new_unlimited_var(e.Std.low(n)), h = t(m, i, 2), g = e.Std.max(p, h), _ = e.Std.min(p, h), v = (d + g + _ + l) / 4, y = n.new_unlimited_var(v), b = n.new_unlimited_var(NaN);
				try {
					b.set(isNaN(b.get(a)) ? (d + l) / 2 : (b.get(1) * a + y.get(1)) / (a + 1));
				} catch {
					b.set((d + l) / 2);
				}
				let x = e.Std.max(g, e.Std.max(b.get(0), v)), S = e.Std.min(_, e.Std.min(b.get(0), v)), C = (e.Std.open(n) + e.Std.high(n) + e.Std.low(n) + e.Std.close(n)) / 4, w = n.new_unlimited_var(C), T = t(w, o, 3), E = n.new_unlimited_var(T), D = s ? (T + E.get(1)) / 2 : T;
				return [
					b.get(0),
					x,
					S,
					v,
					+(v > b.get(0)),
					D,
					D,
					r(4),
					r(5),
					r(6),
					r(7),
					0,
					0,
					0
				];
			};
		}
	};
}, Ee = (e, t) => ({
	name: "OilIndicator",
	metainfo: {
		_metainfoVersion: 53,
		id: "OilIndicator@tv-basicstudies-1",
		description: "OilIndicator",
		shortDescription: "USOUSD",
		isCustomIndicator: !0,
		is_price_study: !0,
		isTVScript: !1,
		isTVScriptStub: !1,
		format: { type: "inherit" },
		plots: [{
			id: "plot_tp",
			type: "line"
		}, {
			id: "plot_sl",
			type: "line"
		}],
		styles: {
			plot_tp: {
				title: "Take Profit (TP)",
				histogramBase: 0,
				joinPoints: !1
			},
			plot_sl: {
				title: "Stop Loss (SL)",
				histogramBase: 0,
				joinPoints: !1
			}
		},
		defaults: {
			styles: {
				plot_tp: {
					linestyle: 1,
					linewidth: 2,
					plottype: 0,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: "#00FF00"
				},
				plot_sl: {
					linestyle: 1,
					linewidth: 2,
					plottype: 0,
					trackPrice: !1,
					transparency: 0,
					visible: !0,
					color: "#FF0000"
				}
			},
			inputs: {
				in_timezone_offset: 1,
				in_target_pct: 60,
				in_sl_pct: 90,
				in_activ_pct: .01
			}
		},
		inputs: [
			{
				id: "in_timezone_offset",
				name: "Timezone offset (UTC+X) — Warsaw: 1 winter, 2 summer",
				defval: 1,
				type: "integer",
				min: -12,
				max: 14
			},
			{
				id: "in_target_pct",
				name: "Take Profit — zone range % (e.g. 60)",
				defval: 60,
				type: "float",
				min: 1,
				max: 1e3,
				step: 1
			},
			{
				id: "in_sl_pct",
				name: "Stop Loss — zone range % (e.g. 90)",
				defval: 90,
				type: "float",
				min: 1,
				max: 1e3,
				step: 1
			},
			{
				id: "in_activ_pct",
				name: "Breakout activation threshold (%)",
				defval: .01,
				type: "float",
				min: .001,
				max: 5,
				step: .001
			}
		]
	},
	constructor: function() {
		let n = NaN, r = NaN, i = NaN, a = 0, o = NaN, s = NaN, c = !1, l = !1, u = NaN, d = NaN, f = NaN, p = !1;
		this.main = function(m, h) {
			this._context = m, this._input = h;
			let g = this._input(0), _ = this._input(1) / 100, v = this._input(2) / 100, y = this._input(3) / 100, b = e.Std.high(this._context), x = e.Std.low(this._context), S = e.Std.time(this._context), C = m.symbol.isLastBar, w = g * 60 * 60 * 1e3, T = new Date(S + w), E = T.getUTCHours(), D = T.getUTCMinutes(), O = E === 12 && D === 15, k = S !== u;
			if (k && p && (n = d, r = f, i = u + 900 * 1e3, a = 0, o = NaN, s = NaN, c = !1, l = !1), k && (u = S, d = b, f = x, p = O), !isNaN(n) && S > i && a === 0) {
				let e = n - r;
				b > n * (1 + y) ? (a = 1, o = n + e * _, s = n - e * v, C && t?.("Upward Breakout — Activation", "USOUSD: zone broken to the UPSIDE. TP and SL levels active.")) : x < r * (1 - y) && (a = -1, o = r - e * _, s = r + e * v, C && t?.("Downward Breakout — Activation", "USOUSD: zone broken to the DOWNSIDE. TP and SL levels active."));
			}
			a !== 0 && !c && !l && (a === 1 && x <= s || a === -1 && b >= s ? (l = !0, C && t?.("Stop Loss Hit", "USOUSD: price reached the Stop Loss (SL) level.")) : (a === 1 && b >= o || a === -1 && x <= o) && (c = !0, C && t?.("Take Profit Reached", "USOUSD: price reached the Take Profit (TP) level.")));
			let ee = NaN, te = NaN;
			return !isNaN(o) && !l && (ee = o), !isNaN(s) && !c && (te = s), [{ value: ee }, { value: te }];
		};
	}
}), De = ({ high: e, low: t, close: n }) => {
	let r = e - t, i = (e + t + n) / 3;
	return {
		p: i,
		r1: 2 * i - t,
		r2: i + r,
		s1: 2 * i - e,
		s2: i - r
	};
}, Oe = ({ high: e, low: t, close: n }) => {
	let r = e - t, i = (e + t + n) / 3;
	return {
		p: i,
		r1: i + .382 * r,
		r2: i + .618 * r,
		s1: i - .382 * r,
		s2: i - .618 * r
	};
}, ke = ({ open: e, high: t, low: n, close: r }) => {
	let i;
	return i = r < e ? t + 2 * n + r : r > e ? 2 * t + n + r : t + n + 2 * r, {
		p: NaN,
		r1: i / 2 - n,
		r2: NaN,
		s1: i / 2 - t,
		s2: NaN
	};
}, Ae = ({ high: e, low: t, close: n }) => {
	let r = e - t, i = (e + t + 2 * n) / 4;
	return {
		p: i,
		r1: 2 * i - t,
		r2: i + r,
		s1: 2 * i - e,
		s2: i - r
	};
}, z = ({ high: e, low: t, close: n }) => {
	let r = e - t, i = n + r * 1.1 / 2, a = e / t * n, o = n - r * 1.1 / 2, s = n - (a - n);
	return {
		r1: n + r * 1.1 / 12,
		r2: n + r * 1.1 / 6,
		r3: n + r * 1.1 / 4,
		r4: i,
		r5: a,
		r6: a + (a - i) * .5,
		r7: a + (a - i),
		s1: n - r * 1.1 / 12,
		s2: n - r * 1.1 / 6,
		s3: n - r * 1.1 / 4,
		s4: o,
		s5: s,
		s6: s - (o - s) * .5,
		s7: s - (o - s)
	};
}, B = {
	startMinutes: 0,
	isOvernight: !1
}, V = (e) => {
	if (!e || e === "24x7" || e === "24/7") return B;
	let [t, n] = e.split(/[;,]/)[0].split("-");
	if (!t || !n) return B;
	let r = t.replace(/[^0-9]/g, ""), i = n.replace(/[^0-9]/g, "");
	if (r.length < 4 || i.length < 4) return B;
	let a = parseInt(r.slice(0, 2), 10) * 60 + parseInt(r.slice(2, 4), 10);
	return {
		startMinutes: a,
		isOvernight: a >= parseInt(i.slice(0, 2), 10) * 60 + parseInt(i.slice(2, 4), 10)
	};
}, H = (e) => {
	let t = /^\s*(\d{2})(\d{2})\s*-\s*(\d{2})(\d{2})\s*$/.exec(String(e || ""));
	return t ? {
		from: t[1] * 60 + +t[2],
		to: t[3] * 60 + +t[4]
	} : null;
}, je = (e, t) => t ? ((t.to - e) % 1440 + 1440) % 1440 : 0, Me = (e, t) => t ? t.from <= t.to ? e >= t.from && e < t.to : e >= t.from || e < t.to : !1, Ne = 0, Pe = 1, Fe = 2, Ie = 3, Le = 4, Re = (e) => ({
	name: "The Rich Garden",
	metainfo: {
		_metainfoVersion: 51,
		id: "TheRichGarden@tv-basicstudies-1",
		name: "The Rich Garden",
		description: "The Rich Garden (Pivot Points)",
		shortDescription: "The Rich Garden",
		isCustomIndicator: !0,
		is_price_study: !0,
		format: {
			type: "price",
			precision: 5
		},
		inputs: [{
			id: "pivotType",
			name: "Pivot Type",
			type: "text",
			defval: "Classic",
			options: [
				"Classic",
				"Fibonacci",
				"Demark",
				"Camarilla",
				"Woodies"
			]
		}, {
			id: "showVLines",
			name: "Show Vertical Separators",
			type: "bool",
			defval: !0
		}],
		plots: [
			{
				id: "plot_p",
				type: "line"
			},
			{
				id: "plot_r1",
				type: "line"
			},
			{
				id: "plot_r2",
				type: "line"
			},
			{
				id: "plot_s1",
				type: "line"
			},
			{
				id: "plot_s2",
				type: "line"
			},
			{
				id: "plot_bg",
				type: "bg_colorer",
				palette: "palette_bg"
			}
		],
		palettes: { palette_bg: {
			colors: [{ name: "Day Separator" }],
			valToIndex: { 100: 0 }
		} },
		defaults: {
			inputs: {
				pivotType: "Classic",
				showVLines: !0
			},
			palettes: { palette_bg: { colors: [{ color: "rgba(255, 255, 255, 0.12)" }] } },
			styles: {
				plot_p: {
					linestyle: 0,
					linewidth: 3,
					plottype: 9,
					trackPrice: !1,
					color: "#FF3B30",
					visible: !0
				},
				plot_r1: {
					linestyle: 0,
					linewidth: 2,
					plottype: 9,
					trackPrice: !1,
					color: "#9E9E9E",
					visible: !0
				},
				plot_r2: {
					linestyle: 0,
					linewidth: 2,
					plottype: 9,
					trackPrice: !1,
					color: "#9E9E9E",
					visible: !0
				},
				plot_s1: {
					linestyle: 0,
					linewidth: 2,
					plottype: 9,
					trackPrice: !1,
					color: "#9E9E9E",
					visible: !0
				},
				plot_s2: {
					linestyle: 0,
					linewidth: 2,
					plottype: 9,
					trackPrice: !1,
					color: "#9E9E9E",
					visible: !0
				}
			}
		},
		styles: {
			plot_p: {
				title: "Pivot Point (P)",
				histogramBase: 0
			},
			plot_r1: {
				title: "Resistance 1 (R1)",
				histogramBase: 0
			},
			plot_r2: {
				title: "Resistance 2 (R2)",
				histogramBase: 0
			},
			plot_s1: {
				title: "Support 1 (S1)",
				histogramBase: 0
			},
			plot_s2: {
				title: "Support 2 (S2)",
				histogramBase: 0
			}
		}
	},
	constructor: function() {
		let t = NaN, n = NaN, r = NaN, i = NaN, a = NaN, o = NaN, s = NaN, c = NaN, l = NaN, u = NaN, d = !1, f = null, p = null, m = null, h = {
			startMinutes: 0,
			isOvernight: !1
		};
		this.main = function(g, _) {
			this._context = g, this._input = _;
			let v = _(0), y = _(1), b = Ne;
			v === "Fibonacci" ? b = Pe : v === "Demark" ? b = Fe : v === "Camarilla" ? b = Ie : v === "Woodies" && (b = Le);
			let x = g.symbol.info, S = x?.timezone || "Etc/UTC", C = x?.session || "24x7";
			(S !== f || C !== p) && (f = S, p = C, m = new Intl.DateTimeFormat("en-US", {
				timeZone: S,
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
				hour12: !1
			}), h = V(C));
			let w = e.Std.time(g), T = e.Std.open(g), E = e.Std.high(g), D = e.Std.low(g), O = e.Std.close(g);
			if (!isFinite(w)) return [
				NaN,
				NaN,
				NaN,
				NaN,
				NaN,
				NaN
			];
			let k = m.formatToParts(new Date(w)), ee = "1970", te = "01", ne = "01", A = "0", j = "0";
			for (let e of k) e.type === "year" ? ee = e.value : e.type === "month" ? te = e.value : e.type === "day" ? ne = e.value : e.type === "hour" ? A = e.value : e.type === "minute" && (j = e.value);
			let M = parseInt(A, 10) % 24, re = parseInt(j, 10), N = M * 60 + re, P = 0;
			h.isOvernight && N >= h.startMinutes && (P = 1);
			let ie = Date.UTC(parseInt(ee, 10), parseInt(te, 10) - 1, parseInt(ne, 10) + P), ae = w !== u;
			d = !1, ae ? (isNaN(t) ? (t = ie, n = T, r = E, i = D, a = O) : ie === t ? (r = Math.max(r, E), i = Math.min(i, D), a = O) : (o = n, s = r, c = i, l = a, t = ie, n = T, r = E, i = D, a = O, d = !0), u = w) : (isNaN(r) || (r = Math.max(r, E)), isNaN(i) || (i = Math.min(i, D)), a = O);
			let oe = NaN, se = NaN, ce = NaN, le = NaN, F = NaN;
			if (!isNaN(s) && !isNaN(c) && !isNaN(l)) {
				let e = {
					open: o,
					high: s,
					low: c,
					close: l
				}, t = null;
				if (b === Ne) t = De(e);
				else if (b === Pe) t = Oe(e);
				else if (b === Fe) t = ke(e);
				else if (b === Le) t = Ae(e);
				else if (b === Ie) {
					let n = z(e);
					t = {
						p: NaN,
						r1: n.r1,
						r2: n.r2,
						s1: n.s1,
						s2: n.s2
					};
				}
				t && ({p: oe, r1: se, r2: ce, s1: le, s2: F} = t);
			}
			return [
				oe,
				se,
				ce,
				le,
				F,
				y && d ? 100 : NaN
			];
		};
	}
}), ze = (e, t) => {
	let n = R.getFixedT(t || "en", F);
	return {
		name: n("tradingSessions"),
		metainfo: {
			_metainfoVersion: 51,
			id: "TradingSessions@tv-basicstudies-1",
			name: n("tradingSessions"),
			description: n("tradingSessions"),
			shortDescription: n("tradingSessions"),
			isCustomIndicator: !0,
			is_price_study: !0,
			format: {
				type: "price",
				precision: 2
			},
			defaults: {
				styles: { Sydney: { visible: !1 } },
				inputs: {
					londonSession: "0700-1600",
					newYorkSession: "1200-2100",
					tokyoSession: "0000-0900",
					sydneySession: "2100-0600"
				},
				palettes: {
					palette_0: { colors: [{ color: "rgba(41, 98, 255, 0.06)" }] },
					palette_1: { colors: [{ color: "rgba(255, 235, 59, 0.06)" }] },
					palette_2: { colors: [{ color: "rgba(255, 82, 82, 0.06)" }] },
					palette_3: { colors: [{ color: "rgba(8, 153, 129, 0.06)" }] }
				}
			},
			inputs: [
				{
					id: "londonSession",
					name: n("londonSession"),
					type: "session",
					defval: "0700-1600"
				},
				{
					id: "newYorkSession",
					name: n("newYorkSession"),
					type: "session",
					defval: "1200-2100"
				},
				{
					id: "tokyoSession",
					name: n("tokyoSession"),
					type: "session",
					defval: "0000-0900"
				},
				{
					id: "sydneySession",
					name: n("sydneySession"),
					type: "session",
					defval: "2100-0600"
				}
			],
			plots: [
				{
					id: n("london"),
					type: "bg_colorer",
					palette: "palette_0"
				},
				{
					id: n("newYork"),
					type: "bg_colorer",
					palette: "palette_1"
				},
				{
					id: n("tokyo"),
					type: "bg_colorer",
					palette: "palette_2"
				},
				{
					id: n("sydney"),
					type: "bg_colorer",
					palette: "palette_3"
				}
			],
			palettes: {
				palette_0: {
					colors: [{ name: n("londonBackground") }],
					valToIndex: { 100: 0 }
				},
				palette_1: {
					colors: [{ name: n("newYorkBackground") }],
					valToIndex: { 100: 0 }
				},
				palette_2: {
					colors: [{ name: n("tokyoBackground") }],
					valToIndex: { 100: 0 }
				},
				palette_3: {
					colors: [{ name: n("sydneyBackground") }],
					valToIndex: { 100: 0 }
				}
			}
		},
		constructor: function() {
			this.main = function(e, t) {
				this._input = t, this._context = e;
				let n = this._context.symbol.time, r = new Date(n), i = r.getUTCHours() * 60 + r.getUTCMinutes(), a = H(this._input(0)), o = H(this._input(1)), s = H(this._input(2)), c = H(this._input(3));
				return [
					Me(i, a) ? 100 : NaN,
					Me(i, o) ? 100 : NaN,
					Me(i, s) ? 100 : NaN,
					Me(i, c) ? 100 : NaN
				];
			};
		}
	};
}, Be = (e, t) => {
	let n = R.getFixedT(t || "en", F);
	return {
		name: n("utBotAlerts"),
		metainfo: {
			_metainfoVersion: 52,
			description: n("utBotAlerts"),
			shortDescription: n("utBotAlerts"),
			is_price_study: !0,
			is_hidden_study: !1,
			id: "UT Bot Alerts@tv-basicstudies-1",
			isTVScript: !1,
			isTVScriptStub: !1,
			defaults: {
				palettes: { palette_0: { colors: [{ color: "rgb(255, 82, 82)" }, { color: "rgb(76, 175, 80)" }] } },
				styles: {
					plot_0: {
						plottype: "shape_label_up",
						visible: !0,
						location: "BelowBar",
						text: n("long"),
						size: "small",
						textColor: "white",
						color: "rgb(76, 175, 80)"
					},
					plot_1: {
						plottype: "shape_label_down",
						visible: !0,
						location: "AboveBar",
						text: n("short"),
						size: "small",
						textColor: "white",
						color: "rgb(255, 82, 82)"
					}
				},
				inputs: {
					keyValue: 10,
					atrPeriod: 10,
					heikinCandles: !1
				}
			},
			plots: [
				{
					id: "plot_0",
					type: "shapes",
					textColor: "black"
				},
				{
					id: "plot_1",
					type: "shapes",
					textColor: "black"
				},
				{
					id: "plot_0",
					type: "bar_colorer",
					palette: "palette_0"
				}
			],
			styles: {
				plot_0: {
					title: n("long"),
					isHidden: !1,
					text: n("long")
				},
				plot_1: {
					title: n("short"),
					isHidden: !1,
					text: n("short")
				}
			},
			inputs: [
				{
					id: "keyValue",
					name: n("keyValueThisChangesTheSensitivity"),
					type: "integer",
					defval: 10,
					min: 1,
					max: 100
				},
				{
					id: "atrPeriod",
					name: n("atrPeriod"),
					type: "integer",
					defval: 10,
					min: 1,
					max: 100
				},
				{
					id: "heikinCandles",
					name: n("signalsFromHeikinAshiCandles"),
					type: "bool",
					defval: !1
				}
			],
			palettes: { palette_0: {
				colors: [{ name: n("short") }, { name: n("long") }],
				valToIndex: {
					100: 0,
					200: 1
				}
			} },
			scriptIdPart: "",
			name: n("labelsIndicator"),
			isCustomIndicator: !0,
			format: { type: "inherit" }
		},
		constructor: function() {
			let t = 0, n = 0, r = NaN, i = NaN, a = NaN, o = 100, s = {
				trueRanges: [],
				sum: 0,
				count: 0
			}, c = (t, n) => {
				let r = e.Std.high(t), i = e.Std.low(t), a = e.Std.close(t), o = t.new_var(NaN);
				try {
					let e = o.get(1);
					if (o.set(a), isNaN(e)) return NaN;
					let t = r - i, c = Math.abs(r - e), l = Math.abs(i - e), u = Math.max(t, Math.max(c, l));
					if (s.trueRanges.push(u), s.sum += u, s.count++, s.trueRanges.length > n) {
						let e = s.trueRanges.shift();
						s.sum -= e, s.count--;
					}
					return s.count >= n ? s.sum / n : NaN;
				} catch {
					return NaN;
				}
			}, l = (t) => {
				let n = e.Std.open(t), r = e.Std.high(t), i = e.Std.low(t), a = e.Std.close(t);
				return (n + r + i + a) / 4;
			}, u = (e, t, n, r) => n <= r && e > t;
			this.main = function(s, d) {
				this._context = s, this._input = d;
				let f = this._input(0), p = this._input(1), m = this._input(2), h = c(this._context, p);
				if (isNaN(h)) return [{ value: NaN }, { value: NaN }];
				let g = f * h, _ = m ? l(s) : e.Std.close(s), v = t;
				t = _ > v && a > v ? Math.max(v, _ - g) : _ < v && a < v ? Math.min(v, _ + g) : _ > v ? _ - g : _ + g, n = a < v && _ > v ? 1 : a > v && _ < v ? -1 : n;
				let y = _, b = u(y, t, r, i), x = u(t, y, i, r), S = _ > t && b, C = _ < t && x;
				return S ? o = 200 : C && (o = 100), a = _, r = y, i = t, [
					S ? 1 : NaN,
					C ? 1 : NaN,
					o
				];
			};
		}
	};
}, U = {}, Ve = /* @__PURE__ */ new Set(), He = () => {
	for (let e of Ve) e();
}, Ue = (e, t, n) => {
	U = {
		...U,
		[e]: {
			render: t,
			panels: n
		}
	}, He();
}, We = () => {
	Object.keys(U).length && (U = {}, He());
}, Ge = {
	subscribe: (e) => (Ve.add(e), () => {
		Ve.delete(e);
	}),
	getSnapshot: () => U
}, Ke = () => o(Ge.subscribe, Ge.getSnapshot), qe = t(({ render: e, panels: t, theme: n, language: r }) => /* @__PURE__ */ c(s, { children: e(t, {
	theme: n,
	language: r
}) })), Je = ({ theme: e, language: t }) => {
	let n = Ke();
	return /* @__PURE__ */ c(s, { children: Object.entries(n).map(([n, r]) => /* @__PURE__ */ c(qe, {
		render: r.render,
		panels: r.panels,
		theme: e,
		language: t
	}, n)) });
}, Ye = (e) => (t, { theme: n, language: r }) => t.map((t) => /* @__PURE__ */ c(e, {
	data: t.data,
	mountTarget: t.mountTarget,
	theme: n,
	language: r
}, t.chartId)), Xe = class {
	ctx;
	id;
	owned = [];
	disposed = !1;
	boundRender = null;
	renderPanels = null;
	publish = (e) => {
		this.disposed || !this.renderPanels || (this.boundRender ??= this.renderPanels.bind(this), Ue(this.id, this.boundRender, e));
	};
	constructor(e, t) {
		this.ctx = e, this.id = t;
	}
	settings(e) {
		return this.ctx.account.getIndicatorSettings(this.id, e);
	}
	studies(e) {
		throw Error(`${this.constructor.name} does not implement studies(), so it would register nothing.`);
	}
	own(e) {
		return this.owned.push(e), e;
	}
	destroy() {
		if (!this.disposed) {
			this.disposed = !0;
			for (let e of this.owned.reverse()) try {
				e.destroy();
			} catch (e) {
				console.warn("Indicator resource failed to destroy", e);
			}
			this.owned.length = 0;
		}
	}
}, Ze = (e) => class extends Xe {
	studies(t) {
		return [e(t, this.ctx)];
	}
}, Qe = (e) => e.trim().toUpperCase(), $e = (e) => {
	let t = e.trim().toUpperCase();
	return t === "D" ? "1D" : t === "W" ? "1W" : t === "M" ? "1M" : t;
}, W = (e, t) => `${Qe(e)}|${$e(t)}`, et = (e) => {
	let t = e.symbolExt?.();
	return t?.ticker || t?.name || e.symbol?.() || "";
}, tt = (e) => {
	if (!e) return 60;
	let t = /^(\d+)([DWM]?)$/.exec(e);
	if (!t) return 60;
	let n = parseInt(t[1] || "1", 10) || 1;
	switch (t[2]) {
		case "D": return n * 86400;
		case "W": return n * 604800;
		case "M": return n * 2592e3;
		default: return n * 60;
	}
}, nt = (e) => tt(String(e.resolution?.() ?? "")), rt = (e) => e.chartsCount?.() ?? 1, it = (e, t) => {
	try {
		return e.chart(t) ?? null;
	} catch {
		return null;
	}
}, at = (e, t) => {
	let n = rt(e);
	for (let r = 0; r < n; r++) {
		let n = it(e, r);
		n && t(n, r);
	}
}, ot = (e, t, n) => {
	try {
		return e.getAllStudies().filter((e) => e.name === t);
	} catch (e) {
		return console.warn(`${n}: unable to inspect ${t} studies`, e), null;
	}
}, st = (e, t) => {
	try {
		return e.getStudyById(t)?.isVisible?.() ?? !0;
	} catch {
		return !0;
	}
}, ct = (e, t, n) => {
	for (let r of t) e.subscribe(r, n);
	return () => {
		try {
			for (let r of t) e.unsubscribe(r, n);
		} catch {}
	};
}, lt = (e, t, n) => {
	let r = Object.entries(t);
	try {
		for (let [t, n] of r) e[t]?.().subscribe(null, n);
	} catch (e) {
		console.warn(`${n}: chart subscription failed`, e);
	}
	return () => {
		try {
			for (let [t, n] of r) e[t]?.().unsubscribe(null, n);
		} catch {}
	};
}, ut = 1, dt = class {
	chart;
	deps;
	id = ut++;
	chartIndex = -1;
	mountTarget = null;
	resolution;
	snapshot = null;
	studyId = null;
	symbolName;
	visible = !1;
	unsubscribe;
	disposed = !1;
	constructor(e, t) {
		this.chart = e, this.deps = t, this.symbolName = et(e), this.resolution = $e(String(e.resolution?.() ?? "")), this.unsubscribe = lt(e, {
			onSymbolChanged: (n) => {
				this.symbolName = n.ticker || n.name || et(e), this.resolution = $e(String(e.resolution?.() ?? "")), this.snapshot = t.snapshotFor(this.routeKey), this.refreshStudy(), t.publish(), t.scheduleReconcile();
			},
			onIntervalChanged: (e) => {
				this.resolution = $e(String(e)), this.snapshot = t.snapshotFor(this.routeKey), this.refreshStudy(), t.publish();
			}
		}, `${t.studyName} panels`);
	}
	get route() {
		return {
			symbol: this.symbolName,
			resolution: this.resolution
		};
	}
	get routeKey() {
		return W(this.symbolName, this.resolution);
	}
	get isLive() {
		return this.studyId !== null && !!Qe(this.symbolName);
	}
	refreshStudy() {
		let e = ot(this.chart, this.deps.studyName, `${this.deps.studyName} panels`);
		if (!e) return;
		let t = e[0];
		if (!t) {
			this.studyId = null, this.visible = !1, this.snapshot = null, this.deps.onLiveChanged();
			return;
		}
		this.studyId = t.id, this.visible = st(this.chart, t.id), this.snapshot = this.deps.snapshotFor(this.routeKey), this.deps.onLiveChanged();
	}
	syncIdentity() {
		let e, t;
		try {
			e = et(this.chart), t = $e(String(this.chart.resolution?.() ?? ""));
		} catch {
			return;
		}
		Qe(e) === Qe(this.symbolName) && t === this.resolution || (this.symbolName = e, this.resolution = t, this.snapshot = this.deps.snapshotFor(this.routeKey), this.deps.onLiveChanged());
	}
	destroy() {
		this.disposed || (this.disposed = !0, this.unsubscribe());
	}
}, G = (e, t) => {
	if (e === t) return !0;
	if (typeof e == "number" && typeof t == "number") return Number.isNaN(e) && Number.isNaN(t);
	if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
	if (Array.isArray(e) || Array.isArray(t)) return Array.isArray(e) && Array.isArray(t) && e.length === t.length && e.every((e, n) => G(e, t[n]));
	let n = Object.keys(e);
	return n.length === Object.keys(t).length && n.every((n) => G(e[n], t[n]));
}, ft = ({ studyName: e, onUpdate: t, buildData: n, onLiveRoutesChanged: r }) => {
	let i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = !0, c = null, l = null, u = null, d = "", f = n ?? ((e) => e), p = /* @__PURE__ */ new Map(), m = null, h = null, g = () => {
		if (!s) return;
		let e = Array.from(i.values()).sort((e, t) => e.chartIndex - t.chartIndex).map((e) => {
			let t = e.studyId !== null && e.visible && e.snapshot ? f(e.snapshot, e.route) : null, n = p.get(e.id), r = n !== void 0 && G(n, t) ? n : t;
			return p.set(e.id, r), {
				chartId: e.id,
				chartIndex: e.chartIndex,
				mountTarget: e.mountTarget,
				data: r
			};
		});
		m !== null && m.length === e.length && e.every((e, t) => {
			let n = m[t];
			return n.chartId === e.chartId && n.chartIndex === e.chartIndex && n.mountTarget === e.mountTarget && n.data === e.data;
		}) || (m = e, t(e));
	}, _ = () => {
		if (!(!s || h !== null)) {
			if (typeof requestAnimationFrame != "function") {
				g();
				return;
			}
			h = requestAnimationFrame(() => {
				h = null, g();
			});
		}
	}, v = () => {
		if (!r) return;
		let e = /* @__PURE__ */ new Set(), t = [];
		for (let n of i.values()) !n.isLive || e.has(n.routeKey) || (e.add(n.routeKey), t.push(n.route));
		let n = Array.from(e).sort().join(",");
		n !== d && (d = n, r(t));
	}, y = {
		studyName: e,
		snapshotFor: (e) => a.get(e) ?? null,
		onLiveChanged: () => v(),
		publish: () => _(),
		scheduleReconcile: () => E()
	}, b = (e) => {
		let t = Array.from(e.querySelectorAll(".chart-container[data-qa-id=\"chart-container\"]"));
		return t.length > 0 ? t : Array.from(e.querySelectorAll(".chart-container"));
	}, x = () => {
		if (!u || !l) return;
		let e = b(l);
		e.length === rt(u) && (o.clear(), at(u, (t, n) => {
			o.set(t, e[n]);
		}));
	}, S = (e) => {
		let t = o.get(e);
		return t && t.isConnected ? t : null;
	}, C = () => {
		if (!s || !u || !l) return;
		let e = [];
		at(u, (t, n) => {
			e.push([t, n]);
		});
		let t = new Set(e.map(([e]) => e));
		for (let [e, n] of i) t.has(e) || (n.destroy(), i.delete(e));
		for (let [t, n] of e) {
			let e = i.get(t);
			e || (e = new dt(t, y), i.set(t, e)), e.chartIndex = n, e.mountTarget = S(t), e.syncIdentity(), e.refreshStudy();
		}
		v(), _();
	}, w = () => {
		x(), C();
	}, T = () => {
		o.size === 0 && x(), C();
	}, E = () => {
		if (!s || !l || c !== null) return;
		let e = l.defaultView;
		if (!e) {
			T();
			return;
		}
		c = e.requestAnimationFrame(() => {
			c = null, T();
		});
	}, D = () => {
		for (let e of i.values()) e.refreshStudy();
		_(), E();
	}, O = () => {
		w(), E();
	}, k = null, ee = () => {
		for (let e of i.values()) e.syncIdentity();
	};
	return {
		onSnapshot: (e) => {
			if (!s) return;
			ee();
			let t = W(e.symbol, e.resolution);
			a.set(t, e);
			let n = !1;
			for (let r of i.values()) r.routeKey === t && (r.snapshot = e, n = !0);
			n && _();
		},
		republish: _,
		attach: (e, t) => {
			if (!s || u) return;
			u = e, l = t;
			let n = ct(u, ["layout_changed"], O), r = ct(u, ["study_event", "study_properties_changed"], D);
			k = () => {
				n(), r();
			}, w(), E();
		},
		destroy: () => {
			if (s) {
				s = !1, k?.(), k = null, c !== null && l?.defaultView && l.defaultView.cancelAnimationFrame(c), h !== null && typeof cancelAnimationFrame == "function" && cancelAnimationFrame(h), h = null, p.clear(), m = null;
				for (let e of i.values()) e.destroy();
				i.clear(), o.clear(), a.clear(), d !== "" && (d = "", r?.([]));
			}
		}
	};
}, pt = 4.5, mt = .02, ht = 3.5, gt = .05, _t = (e) => !e || e.height <= 0 ? !1 : !e.log || e.from > 0, vt = (e) => e.log ? Math.log(e.to / e.from) / e.height : (e.to - e.from) / e.height, yt = (e, t, n) => {
	if (!_t(t)) return e.price;
	let r = e.pointing === "down";
	if (t.log) {
		let i = (t.to / t.from) ** (n / t.height);
		return r ? e.price * i : e.price / i;
	}
	let i = n * (t.to - t.from) / t.height;
	return r ? e.price + i : e.price - i;
}, bt = (e, t) => yt(e, t, pt), xt = (e, t) => yt(e, t, ht + (e.offsetPx ?? 0)), St = (e, t) => yt(e, t, ht + (e.offsetPx ?? 0) - gt), Ct = (e, t) => _t(t) ? t.log ? Math.log(t.to / e) / Math.log(t.to / t.from) * t.height : (t.to - e) / (t.to - t.from) * t.height : null, wt = (e, t) => {
	if (!_t(t)) return !1;
	if (!_t(e) || e.log !== t.log) return !0;
	let n = vt(e), r = vt(t);
	return Math.abs(r - n) > Math.abs(n) * mt;
}, Tt = 1440, Et = 86400, Dt = [
	1,
	2,
	3,
	4,
	5,
	6,
	7
], Ot = [
	2,
	3,
	4,
	5,
	6
], kt = 9, At = (e) => ((e + 4) % 7 + 7) % 7 + 1, jt = (e) => {
	if (!/^\d{4}$/.test(e)) return null;
	let t = parseInt(e, 10);
	return Math.trunc(t / 100) * 60 + t % 100;
}, Mt = (e) => {
	let [t, n] = e.split("F"), r = jt(t);
	return r === null ? null : e.includes("F") ? {
		minutes: r,
		daysBefore: n ? parseInt(n, 10) : 1
	} : {
		minutes: r,
		daysBefore: 0
	};
}, Nt = (e) => {
	let t = e.split("-");
	if (t.length !== 2) return null;
	let n = Mt(t[0]), r = Mt(t[1]);
	if (!n || !r) return null;
	let i = r.minutes === 0 ? Tt : r.minutes, a = n.daysBefore === r.daysBefore && i <= n.minutes ? n.daysBefore + 1 : n.daysBefore, o = {
		start: n.minutes - a * Tt,
		end: i - r.daysBefore * Tt
	};
	return o.end > o.start ? o : null;
}, Pt = (e) => {
	let t = e.split(";"), n = (t.length > 1 ? t.find((e) => e.includes("-")) ?? "" : e).trim(), r = /* @__PURE__ */ new Map();
	if (n.toLowerCase() === "24x7") {
		for (let e of Dt) r.set(e, [{
			start: 0,
			end: Tt
		}]);
		return r;
	}
	let i = /* @__PURE__ */ new Map(), a = null;
	for (let e of n.split("|")) {
		let [t, n, ...r] = e.split(":").filter(Boolean);
		if (!t || r.length > 0) return null;
		if (n === void 0) {
			a = t;
			continue;
		}
		for (let e of n) {
			let n = Number(e);
			if (!(n >= 1 && n <= 7)) return null;
			i.set(n, t);
		}
	}
	if (a !== null) for (let e of Ot) i.has(e) || i.set(e, a);
	for (let [e, t] of i) {
		let n = t.split(",").filter(Boolean).map(Nt);
		if (n.length === 0 || n.some((e) => e === null)) return null;
		r.set(e, n);
	}
	return r.size > 0 ? r : null;
}, Ft = /* @__PURE__ */ new Map(), It = (e) => {
	if (!Ft.has(e)) try {
		Ft.set(e, new Intl.DateTimeFormat("en-US", {
			timeZone: e,
			hourCycle: "h23",
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit"
		}));
	} catch {
		Ft.set(e, null);
	}
	return Ft.get(e) ?? null;
}, Lt = (e) => !e || e === "Etc/UTC" || e === "UTC", Rt = (e, t) => {
	if (!e) return 0;
	let n = Object.fromEntries(e.formatToParts(/* @__PURE__ */ new Date(t * 1e3)).map((e) => [e.type, e.value]));
	return Date.UTC(Number(n.year), Number(n.month) - 1, Number(n.day), Number(n.hour), Number(n.minute), Number(n.second)) / 1e3 - t;
}, zt = (e, t) => {
	let n = Math.floor(t / Et), r = null;
	for (let i = n; i < n + kt; i++) for (let n of e.get(At(i)) ?? []) {
		let e = i * Et + n.start * 60, a = i * Et + n.end * 60;
		a > t && (!r || e < r.start) && (r = {
			start: e,
			end: a
		});
	}
	return r;
}, Bt = (e, t) => {
	let n = /* @__PURE__ */ new Date(e * 1e3), r = n.getUTCDate();
	n.setUTCDate(1), n.setUTCMonth(n.getUTCMonth() + t);
	let i = new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth() + 1, 0)).getUTCDate();
	return n.setUTCDate(Math.min(r, i)), n.getTime() / 1e3;
}, Vt = (e, t, n, r = null) => {
	let i = tt(e), a = (e, t) => e + t * i, o = /^(\d*)([SDWM]?)$/.exec(e.trim().toUpperCase()), s = Pt(t || "24x7"), c = Lt(n ?? "") ? null : It(n ?? "");
	if (!o || !s || !Lt(n ?? "") && !c) return a;
	let l = parseInt(o[1] || "1", 10) || 1, u = o[2], d = new Set([...s].filter(([, e]) => e.length > 0).map(([e]) => e)), f = (e, t, n) => {
		let r = e + Rt(c, e), i = zt(s, r);
		if (!i) return a(e, t);
		let o = r < i.start ? -1 : Math.floor((r - i.start) / n);
		for (let r = 0; r < t; r++) if (o += 1, i.start + o * n >= i.end) {
			let n = zt(s, i.end);
			if (!n) return a(e, t);
			i = n, o = 0;
		}
		let l = i.start + o * n;
		return l - Rt(c, l - Rt(c, l));
	}, p = (e) => {
		let t = s.get(At(e)) ?? [];
		if (t.length === 0) return null;
		let n = e * Et + Math.min(...t.map((e) => e.start)) * 60;
		return n - Rt(c, n - Rt(c, n));
	}, m = (e, t) => {
		let n = e - Math.floor(e / Et) * Et, i = Math.floor(e / Et), o = t * l, s = i + o * 7 + 14;
		for (; o > 0 && i < s;) i += 1, d.has(At(i)) && --o;
		if (o > 0) return a(e, t);
		let c = i * Et + n;
		return r !== null && c <= r ? c : p(i) ?? c;
	}, h = /* @__PURE__ */ new Map();
	return (e, t) => {
		if (!(t > 0) || !Number.isFinite(e)) return a(e, t);
		let n = `${e}|${t}`, r = h.get(n);
		if (r !== void 0) return r;
		let i = u === "W" ? e + t * l * 7 * Et : u === "M" ? Bt(e, t * l) : u === "D" ? m(e, t) : f(e, t, u === "S" ? l : l * 60);
		return h.set(n, i), i;
	};
}, Ht = (e, t) => {
	let n = Pt(e || "24x7"), r = Lt(t ?? "") ? null : It(t ?? "");
	return (e) => {
		let t = e + Rt(r, e), i = Math.floor(t / Et);
		for (let e = i; e < i + kt; e++) if ((n?.get(At(e)) ?? []).some((n) => t >= e * Et + n.start * 60 && t < e * Et + n.end * 60)) return e;
		return i;
	};
}, Ut = (e, t) => {
	let n = null, r = "";
	try {
		n = e.symbolExt?.(), r = String(e.resolution?.() ?? "");
	} catch {}
	return Vt(r, n?.session, n?.timezone, t);
}, Wt = {
	solid: 0,
	dotted: 1,
	dashed: 2
}, Gt = 200, Kt = 1e4, qt = 750, Jt = 6, K = 11, Yt = 4 / 3, Xt = 1.7, Zt = 100, Qt = 1, $t = "rgba(0, 0, 0, 0)", en = 61661, tn = Math.PI, nn = {
	down: Math.PI / 2,
	up: Math.PI * 1.5
}, rn = .1, an = {
	line: "trend_line",
	box: "rectangle",
	label: "text",
	column: "vertical_line",
	banner: "callout",
	tag: "text_note",
	pointer: "icon",
	plate: "text_note",
	plateTail: "icon",
	segment: "trend_line",
	polygon: "polyline"
}, q = (e) => e.points.length === 3, on = (e) => e.kind === "polygon" && q(e) ? "triangle" : an[e.kind], sn = (e) => ({
	linecolor: e.color,
	linewidth: e.width ?? 1,
	linestyle: Wt[e.style ?? "dotted"],
	extendLeft: !1,
	extendRight: e.extendRight ?? !1,
	leftEnd: 0,
	rightEnd: 0,
	showLabel: !!e.text,
	...e.text ? {
		textcolor: e.textColor ?? e.color,
		horzLabelsAlign: e.textAlign ?? "left",
		vertLabelsAlign: "middle",
		fontsize: e.fontSize ?? 12
	} : null,
	showPriceLabels: !1,
	showBarsRange: !1,
	showDateTimeRange: !1,
	showDistance: !1,
	showPriceRange: !1,
	showAngle: !1
}), cn = (e) => ({
	backgroundColor: e.fill,
	color: e.border,
	fillBackground: !0,
	linewidth: 1,
	extendLeft: !1,
	extendRight: e.extendRight ?? !1,
	showLabel: !1,
	...e.text ? {
		textColor: e.textColor ?? e.border,
		fontSize: e.fontSize ?? 12,
		horzLabelsAlign: "center",
		vertLabelsAlign: "middle"
	} : null
}), ln = (e) => ({
	color: e.textColor ?? h(e.color),
	backgroundColor: e.color,
	backgroundTransparency: 0,
	fillBackground: !0,
	drawBorder: !1,
	fontsize: e.fontSize ?? K,
	bold: !1,
	italic: !1
}), un = (e, t) => ({
	linecolor: e.color,
	linewidth: Math.max(1, Math.round(t)),
	linestyle: 0,
	showTime: !1,
	extendLine: !1
}), dn = (e) => ({
	color: e.textColor,
	backgroundColor: e.color,
	bordercolor: e.color,
	transparency: 0,
	fontsize: e.fontSize,
	linewidth: 1,
	wordWrap: !1
}), fn = (e) => ({
	textColor: e.textColor,
	fontSize: e.fontSize,
	backgroundColor: e.color,
	drawBackground: !0,
	drawBorder: !1,
	lineColor: $t,
	bold: !1,
	italic: !1
}), pn = (e) => ({
	color: e.color,
	size: e.size,
	angle: tn
}), mn = (e) => ({
	textColor: e.textColor,
	fontSize: e.fontSize,
	backgroundColor: e.color,
	drawBackground: !0,
	drawBorder: !1,
	borderColor: $t,
	lineColor: $t,
	bold: !1,
	italic: !1
}), hn = (e) => ({
	color: e.color,
	size: 10,
	angle: nn[e.pointing]
}), gn = (e) => ({
	linecolor: e.color,
	linewidth: e.width ?? 1,
	linestyle: Wt[e.style ?? "solid"],
	extendLeft: !1,
	extendRight: !1,
	leftEnd: 0,
	rightEnd: 0,
	showLabel: !1,
	showPriceLabels: !1,
	showBarsRange: !1,
	showDateTimeRange: !1,
	showDistance: !1,
	showPriceRange: !1,
	showAngle: !1
}), _n = (e) => ({
	backgroundColor: e.fill,
	fillBackground: !0,
	color: e.border,
	linewidth: e.width ?? 1,
	transparency: 0
}), vn = (e) => ({
	backgroundColor: e.fill,
	fillBackground: !0,
	filled: !0,
	linecolor: e.border,
	linestyle: 0,
	linewidth: e.width ?? 1,
	transparency: 0
}), yn = (e) => q(e) ? _n(e) : vn(e), bn = (e) => {
	let t = e.points.map((e) => ({
		time: e.time,
		price: e.price
	}));
	return q(e) || t.length === 0 ? t : [...t, t[0]];
}, xn = (e, t) => {
	switch (e.kind) {
		case "line": return sn(e);
		case "box": return cn(e);
		case "label": return ln(e);
		case "column": return un(e, t);
		case "tag": return fn(e);
		case "pointer": return pn(e);
		case "plate": return mn(e);
		case "plateTail": return hn(e);
		case "segment": return gn(e);
		case "polygon": return yn(e);
		default: return dn(e);
	}
}, Sn = (e) => {
	switch (e.kind) {
		case "column":
		case "pointer":
		case "plateTail":
		case "segment":
		case "polygon": return;
		default: return e.text;
	}
}, Cn = (e) => e === "pointer" || e === "plateTail", wn = (e) => e === "plate" || e === "plateTail", Tn = (e) => {
	switch (e.kind) {
		case "box": return e.top;
		case "column": return 0;
		case "segment": return e.from.price;
		case "polygon": return e.points[0]?.price ?? 0;
		default: return e.price;
	}
}, En = (e, t) => {
	try {
		let n = e.getPanes?.()[e.getStudyById(t).paneIndex()], r = n?.getMainSourcePriceScale?.()?.getVisiblePriceRange?.(), i = n?.getHeight?.();
		return !r || !i || i <= 0 ? 0 : (r.to - r.from) / i;
	} catch {
		return 0;
	}
}, Dn = (e, t) => {
	try {
		let n = e.getPanes?.()[t], r = n?.getMainSourcePriceScale?.(), i = r?.getVisiblePriceRange?.(), a = n?.getHeight?.();
		return !i || !Number.isFinite(i.from) || !Number.isFinite(i.to) || !a || a <= 0 ? null : {
			from: i.from,
			to: i.to,
			height: a,
			log: r.getMode?.() === Qt
		};
	} catch {
		return null;
	}
}, On = (e, t) => {
	try {
		return Dn(e, e.getStudyById(t).paneIndex());
	} catch {
		return null;
	}
}, kn = (e, t, n) => e + (n.pricePerPixel ?? 0) * t * Yt / 2, An = (e, t, n) => {
	let r = e.getVisibleBarsRange?.();
	if (r && typeof r.to == "number" && r.to >= t) return r.to;
	let i = e.getVisibleRange?.();
	return typeof i?.to == "number" && i.to > t ? i.to - 5 * n : t + 15 * n;
}, jn = (e, t, n) => {
	let r = An(e, t.time, n);
	return {
		lineRight: r,
		labelTime: r
	};
}, Mn = (e) => (t, n, r) => {
	let i = An(t, n.time, r), a = t.getVisibleRange?.(), o = i + (typeof e == "function" ? e(r) : e) * r;
	return typeof a?.to == "number" && a.to > i && (o = Math.min(o, a.to - r)), o < i && (o = i), {
		lineRight: o,
		labelTime: o
	};
}, Nn = class {
	chart;
	deps;
	studyId = null;
	studyCount = null;
	visible = !1;
	shapes = [];
	anchors = null;
	canReposition = !0;
	repositionChecked = !1;
	drawnTheme = null;
	drawnSignal = null;
	staleSignal = null;
	loadedFrom = null;
	loadedTo = null;
	dataLoads = 0;
	repointedLoads = 0;
	shapesSymbol = null;
	awaitingData = !1;
	plateScale = null;
	unsubscribe;
	disposed = !1;
	lastDataLoadedAt = 0;
	stash = /* @__PURE__ */ new Map();
	constructor(e, t) {
		this.chart = e, this.deps = t;
		let n = () => {
			this.loadedFrom = null, this.awaitingData = !0, this.blockStale(), t.requestSync();
		}, r = () => {
			this.lastDataLoadedAt = Date.now(), this.loadedFrom = null, this.awaitingData = !1, this.dataLoads += 1, this.drawnSignal = null, t.requestSync();
		};
		this.unsubscribe = lt(e, {
			onSymbolChanged: () => {
				this.swapSymbol(), n();
			},
			onIntervalChanged: n,
			onDataLoaded: r,
			...t.reanchor ? { onVisibleRangeChanged: () => t.scheduleReanchor() } : null
		}, `${t.label} drawings`);
	}
	get routeKey() {
		return W(et(this.chart), String(this.chart.resolution?.() ?? ""));
	}
	get isDrawn() {
		return !!this.drawnSignal && this.shapes.length > 0;
	}
	get barsReloaded() {
		return this.dataLoads !== this.repointedLoads;
	}
	get isLoadingBars() {
		return Date.now() - this.lastDataLoadedAt < qt;
	}
	get hasShownPlates() {
		return this.shapes.some((e) => wn(e.kind) && !e.hidden);
	}
	symbolNow() {
		try {
			return Qe(et(this.chart));
		} catch {
			return "";
		}
	}
	forget() {
		this.shapes = [], this.stash.clear(), this.shapesSymbol = null, this.anchors = null, this.drawnTheme = null, this.drawnSignal = null, this.plateScale = null;
	}
	remove(e) {
		for (let t of e) try {
			this.chart.removeEntity(t.id, { disableUndo: !0 });
		} catch {}
	}
	clear() {
		this.remove([...this.shapes, ...[...this.stash.values()].flat()]), this.forget();
	}
	swapSymbol() {
		let e = this.symbolNow();
		this.shapesSymbol === null || this.shapesSymbol === e || (this.hide(this.shapes), this.stash.set(this.shapesSymbol, this.shapes), this.shapes = this.stash.get(e) ?? [], this.stash.delete(e), this.shapesSymbol = e);
	}
	hide(e) {
		for (let t of e) if (!t.hidden) {
			try {
				this.chart.getShapeById(t.id)?.setProperties({ visible: !1 });
			} catch {}
			t.hidden = !0;
		}
	}
	park() {
		this.hide(this.shapes), this.invalidate();
	}
	invalidate() {
		this.anchors = null, this.drawnTheme = null, this.drawnSignal = null;
	}
	adopt(e, t, n, r, i, a) {
		if (t !== this.symbolNow()) {
			this.hide(e), this.stash.set(t, e), this.invalidate();
			return;
		}
		this.shapes = e, this.shapesSymbol = t, this.anchors = n, this.drawnTheme = r, this.drawnSignal = i, this.plateScale = a;
	}
	refreshStudy() {
		let e = ot(this.chart, this.deps.studyName, `${this.deps.label} drawings`);
		if (!e) return;
		let t = e[0], n = this.studyCount;
		if (this.studyCount = e.length, this.deps.blockStaleOnDuplicateRemoval && n !== null && n > 1 && e.length < n && this.blockStale(), !t) {
			this.studyId = null, this.visible = !1, this.forget();
			return;
		}
		this.studyId !== t.id && this.forget(), this.studyId = t.id, this.visible = st(this.chart, t.id);
	}
	sendStudyBack() {
		try {
			this.chart.getStudyById(this.studyId).sendToBack();
		} catch {}
	}
	blockStale() {
		try {
			this.staleSignal = this.deps.pendingSignalFor(this.routeKey);
		} catch {
			this.staleSignal = null;
		}
		this.park();
	}
	hasDrifted(e, t) {
		if (!this.anchors) return !0;
		let n = this.anchors.pricePerPixel ?? 0;
		return Math.abs(e.labelTime - this.anchors.labelTime) >= t || Math.abs(e.lineRight - this.anchors.lineRight) >= t || Math.abs((e.pricePerPixel ?? 0) - n) > rn * Math.abs(n);
	}
	reposition(e) {
		let t = this.drawnSignal, n = this.anchors;
		if (!t || !n) return "moved";
		let r = this.shapes.filter((e) => !e.hidden);
		try {
			for (let n of r) {
				let r;
				try {
					r = this.chart.getShapeById(n.id);
				} catch {
					return "vanished";
				}
				if (!r) return "vanished";
				if (!r.setPoints || n.kind === "box" || n.kind === "column" || n.kind === "banner" || n.kind === "segment" || n.kind === "polygon" || wn(n.kind)) return "unsupported";
				n.kind === "line" ? r.setPoints([{
					time: n.fromTime ?? t.time,
					price: n.price
				}, {
					time: e.lineRight,
					price: n.price
				}]) : n.kind === "tag" ? r.setPoints([{
					time: e.labelTime,
					price: n.price
				}, {
					time: e.labelTime,
					price: n.price
				}]) : n.kind === "pointer" ? r.setPoints([{
					time: e.labelTime,
					price: n.price
				}]) : r.setPoints([{
					time: e.labelTime,
					price: kn(n.price, n.fontSize ?? K, e)
				}]), n.key = void 0;
			}
			let i = r[0];
			if (!this.repositionChecked && i) {
				let t = this.chart.getShapeById?.(i.id)?.getPoints?.(), r = t?.[t.length - 1]?.time, a = i.kind === "line" ? e.lineRight : e.labelTime, o = i.kind === "line" ? n.lineRight : n.labelTime;
				if (typeof r == "number" && Math.abs(r - a) > Math.abs(r - o)) return "unsupported";
				this.repositionChecked = !0;
			}
		} catch (e) {
			return console.warn(`${this.deps.label} drawings: cannot re-anchor shapes, redrawing instead`, e), "unsupported";
		}
		return this.anchors = e, "moved";
	}
	repointPlates(e) {
		for (let t of this.shapes) {
			if (!wn(t.kind) || t.hidden) continue;
			let { time: n, price: r, pointing: i, offsetPx: a } = t;
			if (n === void 0 || !i) return !1;
			let o;
			try {
				o = this.chart.getShapeById(t.id);
			} catch {
				return !1;
			}
			if (!o?.setPoints) return !1;
			let s = {
				time: n,
				price: St({
					price: r,
					pointing: i,
					offsetPx: a
				}, e)
			}, c = {
				time: n,
				price: xt({
					price: r,
					pointing: i,
					offsetPx: a
				}, e)
			}, l = {
				time: n,
				price: bt({
					price: r,
					pointing: i
				}, e)
			};
			try {
				o.setPoints(t.kind === "plate" ? [s, c] : [l]);
			} catch (e) {
				return console.warn(`${this.deps.label} drawings: cannot re-point plates, redrawing instead`, e), !1;
			}
			t.key = void 0;
		}
		return this.plateScale = e, !0;
	}
	destroy() {
		this.disposed || (this.disposed = !0, this.unsubscribe(), this.clear());
	}
}, Pn = ({ studyName: e, label: t, anchorsFor: n, specsFor: r, reanchor: i = !1, themeAware: a = !1, blockStaleOnDuplicateRemoval: o = !1, labelAlign: s = "top", studyBehindDrawings: c = !1 }) => {
	let l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), d = !0, f = null, p = null, m = null, h = null, g = !1, _ = !1, v = () => {
		try {
			return f?.getTheme?.() === "light" ? "light" : "dark";
		} catch {
			return "dark";
		}
	}, y = async () => {
		if (!_) {
			_ = !0;
			try {
				for (; d && g;) {
					g = !1;
					try {
						await P();
					} catch (e) {
						console.error(`${t} drawings sync failed`, e);
					}
				}
			} finally {
				_ = !1;
			}
		}
	}, b = () => {
		d && (g = !0, y());
	}, x = (e = Gt) => {
		!d || p || (p = setTimeout(() => {
			p = null, re();
		}, e));
	}, S = () => {
		if (!d) {
			h && clearInterval(h), h = null;
			return;
		}
		if (_) return;
		let e = !1, t = !1;
		for (let n of l.values()) {
			if (!n.hasShownPlates || (e = !0, !n.isDrawn || n.isLoadingBars)) continue;
			let r = On(n.chart, n.studyId);
			!r || !wt(n.plateScale, r) || n.repointPlates(r) || (n.invalidate(), t = !0);
		}
		t && b(), !e && h && (clearInterval(h), h = null);
	}, C = () => {
		!d || h || (h = setInterval(S, Zt));
	}, w = {
		studyName: e,
		label: t,
		reanchor: i,
		blockStaleOnDuplicateRemoval: o,
		pendingSignalFor: (e) => u.get(e) ?? null,
		requestSync: () => b(),
		scheduleReanchor: () => x()
	}, T = (e, t) => {
		let n = t.kind === "label" || t.kind === "banner" || t.kind === "tag" || t.kind === "plate", r = {
			shape: t.shapeType,
			...n || t.text ? { text: t.text ?? "" } : null,
			...t.kind === "column" ? { zOrder: "bottom" } : null,
			...Cn(t.kind) ? { icon: en } : null,
			lock: !0,
			disableSelection: !0,
			disableSave: !0,
			disableUndo: !0,
			showInObjectsTree: !1,
			ownerStudyId: e.studyId,
			overrides: t.overrides
		};
		return t.kind === "label" || t.kind === "column" || Cn(t.kind) ? e.chart.createShape(t.points[0], r) : e.chart.createMultipointShape(t.points, r);
	}, E = (e, t, r, i) => {
		let a = n(e.chart, t, r, i);
		return s === "middle" ? {
			...a,
			pricePerPixel: En(e.chart, e.studyId)
		} : a;
	}, D = (e, t, n, r, i) => {
		switch (t.kind) {
			case "line": return [{
				time: t.fromTime ?? n.time,
				price: t.price
			}, {
				time: t.toTime ?? r.lineRight,
				price: t.price
			}];
			case "box": return [{
				time: t.fromTime,
				price: t.top
			}, {
				time: t.toTime,
				price: t.bottom
			}];
			case "label": return [{
				time: r.labelTime,
				price: kn(t.price, t.fontSize ?? K, r)
			}];
			case "column": return [{
				time: t.time,
				price: 0
			}];
			case "tag": return [{
				time: r.labelTime,
				price: t.price
			}, {
				time: r.labelTime,
				price: t.price
			}];
			case "pointer": return [{
				time: r.labelTime,
				price: t.price
			}];
			case "plate": return [{
				time: t.time,
				price: St(t, i)
			}, {
				time: t.time,
				price: xt(t, i)
			}];
			case "plateTail": return [{
				time: t.time,
				price: bt(t, i)
			}];
			case "segment": return [{
				time: t.from.time,
				price: t.from.price
			}, {
				time: t.to.time,
				price: t.to.price
			}];
			case "polygon": return bn(t);
			default: {
				let n = t.fontSize * Xt * En(e.chart, e.studyId);
				return [{
					time: t.time,
					price: t.price
				}, {
					time: t.time,
					price: t.pointing === "up" ? t.price - n : t.price + n
				}];
			}
		}
	}, O = (e, t, n) => {
		let r = e.get(t);
		for (let e = r?.pop(); e; e = r?.pop()) if (!n.has(e)) return n.add(e), e;
		return null;
	}, k = (e, t) => {
		let n = /* @__PURE__ */ new Map();
		for (let r of e) {
			let e = t(r);
			if (!e) continue;
			let i = n.get(e);
			i ? i.push(r) : n.set(e, [r]);
		}
		return n;
	}, ee = (e, t) => {
		let n = /* @__PURE__ */ new Set(), r = k(e, (e) => e.key), i = k(e, (e) => e.look ? `${e.kind}|${e.look}` : void 0), a = k(e, (e) => `${e.kind}|${e.shapeType}`), o = t.map((e) => O(r, e.key, n));
		return t.forEach((e, t) => {
			o[t] ??= O(i, `${e.kind}|${e.look}`, n);
		}), t.forEach((e, t) => {
			o[t] ??= O(a, `${e.kind}|${e.shapeType}`, n);
		}), o;
	}, te = (e, t, n, r) => {
		try {
			let i = e.chart.getShapeById?.(t.id);
			if (!i) return !1;
			if (r) {
				if (!i.setPoints) return !1;
				i.setPoints(n.points);
			}
			let a = t.look === n.look ? {} : { ...n.overrides };
			return n.kind !== "column" && t.text !== n.text && (a.text = n.text ?? ""), t.hidden && (a.visible = !0), Object.keys(a).length > 0 && i.setProperties(a), !0;
		} catch {
			return !1;
		}
	}, ne = async (e) => {
		if (e.loadedFrom === null) try {
			let t = await e.chart.exportData({
				includeTime: !0,
				includeSeries: !1,
				includedStudies: []
			}), n = t.schema.findIndex((e) => e.type === "time"), r = t.data[0]?.[n];
			if (r === void 0) return Infinity;
			e.loadedFrom = r, e.loadedTo = t.data[t.data.length - 1][n];
		} catch {
			if (e.awaitingData) return Infinity;
			e.loadedFrom = -Infinity, e.loadedTo = null;
		}
		return e.loadedFrom ?? -Infinity;
	}, A = (e, t, n) => e.every((e) => e.time < t) || (n === "segment" || n === "polygon") && e.some((e) => e.time < t) ? null : e.map((e) => e.time < t ? {
		...e,
		time: t
	} : e), j = (e) => e.shapes.filter((t) => {
		try {
			return !!e.chart.getShapeById(t.id);
		} catch {
			return !1;
		}
	}), M = async (e, t) => {
		let n = e.dataLoads, i = e.barsReloaded;
		i && (e.loadedFrom = null);
		let a = await ne(e);
		e.swapSymbol();
		let o = e.symbolNow(), s = j(e), l = nt(e.chart), u = Ut(e.chart, e.loadedTo), d = E(e, t, l, u), f = v(), p = e.chart.priceFormatter?.(), m = Jt;
		try {
			m = e.chart.getTimeScale?.()?.barSpacing?.() ?? Jt;
		} catch {}
		let h = r(t, {
			barSpacing: m,
			barsAfter: u,
			theme: f,
			secondsPerBar: l,
			fmt: (e) => p?.format?.(e) ?? String(e)
		}), g = h.some((e) => wn(e.kind)) ? On(e.chart, e.studyId) : null, _ = h.flatMap((n) => {
			let r = A(D(e, n, t, d, g), a, n.kind);
			if (!r) return [];
			let i = xn(n, m), o = JSON.stringify(i), s = Sn(n), c = on(n);
			return [{
				key: JSON.stringify([
					n.kind,
					o,
					r,
					s
				]),
				kind: n.kind,
				look: o,
				overrides: i,
				points: r,
				shapeType: c,
				spec: n,
				text: s
			}];
		}), y = [], b = ee(s, _).map((t, n) => {
			if (!t) return null;
			let r = t.key !== _[n].key || t.hidden === !0 || i;
			return te(e, t, _[n], r) ? t : (y.push(t), null);
		});
		e.repointedLoads = n, e.remove(y);
		let x = /* @__PURE__ */ new Set([...b, ...y]), S = s.filter((e) => !x.has(e));
		e.hide(S);
		let w = _.some((e, t) => !b[t]), O = (t) => Promise.allSettled(_.map((n, r) => Cn(n.kind) === t ? b[r]?.id ?? T(e, n) : null)), k = await O(!1), M = await O(!0), re = _.map((e, t) => (Cn(e.kind) ? M : k)[t]);
		c && w && e.sendStudyBack();
		let N = re.find((e) => e.status === "rejected"), P = _.map((e, t) => {
			let n = re[t];
			return {
				id: n.status === "fulfilled" ? n.value : null,
				kind: e.kind,
				price: Tn(e.spec),
				shapeType: e.shapeType,
				fontSize: e.spec.kind === "label" ? e.spec.fontSize ?? K : void 0,
				fromTime: e.kind === "line" ? e.points[0].time : void 0,
				key: e.key,
				look: e.look,
				text: e.text,
				...e.spec.kind === "plate" ? {
					fontSize: e.spec.fontSize,
					pointing: e.spec.pointing,
					time: e.points[0].time,
					tooltip: e.spec.tooltip,
					anchor: e.spec.anchor,
					offsetPx: e.spec.offsetPx
				} : null,
				...e.spec.kind === "plateTail" ? {
					pointing: e.spec.pointing,
					time: e.points[0].time
				} : null
			};
		}).filter((e) => !!e.id);
		if (e.adopt([...P, ...S], o, d, f, N ? null : t, g), e.hasShownPlates && C(), N) throw N.reason;
	}, re = () => {
		if (!d || !f) return;
		let e = v(), t = !1, n = !1;
		for (let r of l.values()) {
			if (!r.isDrawn) continue;
			if (r.isLoadingBars) {
				n = !0;
				continue;
			}
			if (a && r.drawnTheme && r.drawnTheme !== e) {
				r.invalidate(), t = !0;
				continue;
			}
			let i, o;
			try {
				o = nt(r.chart), i = E(r, r.drawnSignal, o, Ut(r.chart, r.loadedTo));
			} catch {
				continue;
			}
			if (!r.hasDrifted(i, o)) continue;
			let s = r.canReposition ? r.reposition(i) : "unsupported";
			s !== "moved" && (s === "unsupported" ? (r.canReposition = !1, r.clear()) : r.invalidate(), t = !0);
		}
		t && b(), n && x(qt);
	}, N = () => {
		let e = /* @__PURE__ */ new Set();
		at(f, (t) => {
			e.add(t);
		});
		for (let [t, n] of l) e.has(t) || (n.destroy(), l.delete(t));
		for (let t of e) l.has(t) || l.set(t, new Nn(t, w));
	}, P = async () => {
		if (!(!d || !f)) {
			N();
			for (let e of l.values()) {
				if (!d) return;
				e.refreshStudy();
				let n = null;
				if (e.studyId !== null && e.visible) try {
					n = u.get(e.routeKey) ?? null;
				} catch {
					n = null;
				}
				if (n && n === e.staleSignal && (n = null), !(n === e.drawnSignal && !e.barsReloaded)) {
					if (!n) {
						e.park();
						continue;
					}
					try {
						await M(e, n);
					} catch (e) {
						console.error(`${t} drawings draw failed`, e);
					}
				}
			}
		}
	}, ie = () => {
		if (d) {
			for (let e of l.values()) e.invalidate();
			b();
		}
	}, ae = null;
	return {
		onSignal: (e) => {
			d && (u.set(W(e.symbol, e.resolution), e), b());
		},
		invalidateCachedSignals: () => {
			if (d) {
				for (let e of l.values()) e.blockStale();
				b();
			}
		},
		isRouteShown: (e) => {
			for (let t of l.values()) try {
				if (t.studyId !== null && t.visible && t.routeKey === e) return !0;
			} catch {}
			return !1;
		},
		shownPlates: (e) => {
			let t = l.get(e);
			return !t || t.studyId === null || !t.visible ? [] : t.shapes.flatMap((e) => {
				let { anchor: t, fontSize: n, pointing: r, time: i, tooltip: a } = e;
				return e.kind !== "plate" || e.hidden || n === void 0 || !r || i === void 0 || !a ? [] : [{
					anchorTime: t?.time ?? i,
					barsAfter: t?.barsAfter ?? 0,
					fontSize: n,
					pointing: r,
					price: e.price,
					text: e.text ?? "",
					time: i,
					tooltip: a,
					...e.offsetPx === void 0 ? null : { offsetPx: e.offsetPx }
				}];
			});
		},
		attach: (e) => {
			if (!d || f) return;
			f = e;
			let t = ct(f, [
				"layout_changed",
				"study_event",
				"study_properties_changed"
			], b), n = a ? ct(f, ["chart_theme_changed"], ie) : null;
			ae = () => {
				t(), n?.();
			}, i && (m = setInterval(x, Kt)), b();
		},
		destroy: () => {
			if (d) {
				d = !1, m && clearInterval(m), p && clearTimeout(p), h && clearInterval(h), m = null, p = null, h = null, ae?.(), ae = null;
				for (let e of l.values()) e.destroy();
				l.clear(), u.clear(), f = null;
			}
		}
	};
}, Fn = { press: null }, In = 5, Ln = ".chart-container[data-qa-id=\"chart-container\"]", Rn = ".chart-container", zn = ".chart-markup-table.pane", Bn = [
	"pointerdown",
	"pointermove",
	"pointerup",
	"pointercancel",
	"wheel",
	"pointerleave",
	"pointerout"
], Vn = .25, Hn = (e, t) => Math.hypot(t.x - e.x, t.y - e.y) <= In, Un = (e, t) => {
	let { press: n } = e;
	switch (t.type) {
		case "pointerdown": return t.pointerType === "mouse" && t.button !== 0 ? {
			kind: null,
			state: Fn
		} : n && n.pointerId !== t.pointerId ? {
			kind: "gesture",
			state: Fn
		} : {
			kind: null,
			state: { press: {
				pointerId: t.pointerId,
				x: t.x,
				y: t.y
			} }
		};
		case "pointermove": return t.buttons === 0 ? {
			kind: "move",
			state: Fn
		} : n && Hn(n, t) ? {
			kind: null,
			state: e
		} : {
			kind: "gesture",
			state: Fn
		};
		case "pointerup": return {
			kind: n !== null && n.pointerId === t.pointerId && Hn(n, t) ? "tap" : null,
			state: Fn
		};
		case "leave": return t.pointerType === "mouse" ? {
			kind: "leave",
			state: Fn
		} : {
			kind: null,
			state: e
		};
		case "pointercancel":
		case "wheel": return {
			kind: "gesture",
			state: Fn
		};
	}
}, Wn = (e) => {
	let t = e;
	return t?.closest?.(Ln) ?? t?.closest?.(Rn) ?? null;
}, Gn = (e) => {
	let t = Array.from(e.querySelectorAll(Ln));
	return t.length > 0 ? t : Array.from(e.querySelectorAll(Rn));
}, Kn = (e, t) => {
	if (e.type === "pointerleave") return e.target === t ? "leave" : null;
	if (e.type === "pointerout") {
		let n = e.relatedTarget;
		return n && t.contains(n) ? null : "leave";
	}
	return e.type;
}, qn = (e, t) => {
	let n = e;
	return {
		type: t,
		button: n.button,
		buttons: n.buttons,
		pointerId: n.pointerId ?? 0,
		pointerType: n.pointerType ?? "",
		x: n.clientX,
		y: n.clientY
	};
}, Jn = (e, t, n) => {
	try {
		let r = Gn(t);
		return r.length === rt(e) ? it(e, r.indexOf(n)) : e.activeChart() ?? null;
	} catch {
		return null;
	}
}, Yn = (e, t, n, r) => {
	if (t === "gesture" || t === "leave") return {
		chart: e,
		kind: t,
		point: null,
		paneRect: null
	};
	let i = n.querySelector(zn);
	if (!i) return null;
	let a = i.getBoundingClientRect();
	return {
		chart: e,
		kind: t,
		point: {
			x: r.x - a.left,
			y: r.y - a.top
		},
		paneRect: a
	};
}, Xn = (e, t, n) => {
	let r = {
		capture: !0,
		passive: !0
	}, i = Fn, a = (r) => {
		let a = Wn(r.target);
		if (!a) return;
		let o = Kn(r, a);
		if (!o) return;
		let s = qn(r, o), c = Un(i, s);
		if (i = c.state, !c.kind) return;
		let l = Jn(e, t, a), u = l ? Yn(l, c.kind, a, s) : null;
		u && n(u);
	};
	for (let e of Bn) t.addEventListener(e, a, r);
	return () => {
		for (let e of Bn) t.removeEventListener(e, a, r);
	};
}, Zn = (e) => {
	let t = e.getTimeScale?.(), n = t?.width?.(), r = t?.barSpacing?.();
	return !t || !n || n <= 0 || !r || r <= 0 ? null : {
		barSpacing: r,
		width: n,
		timeAt: (e) => t.coordinateToTime(e) ?? Infinity
	};
}, Qn = (e, t, n) => {
	if (e(t)) return t;
	if (!e(n)) return null;
	let r = t, i = n;
	for (; i - r > Vn;) {
		let t = (r + i) / 2;
		e(t) ? i = t : r = t;
	}
	return i;
}, $n = ({ barSpacing: e, timeAt: t, width: n }, r) => {
	let i = Qn((e) => t(e) >= r, 0, n);
	if (i === null || t(i) !== r) return null;
	let a = Qn((e) => t(e) > r, i, n);
	return a === null ? i + e / 2 : a - e / 2;
}, er = (e, t) => {
	try {
		let n = Zn(e), r = n ? $n(n, t.anchorTime) : null;
		return !n || r === null ? null : r + t.barsAfter * n.barSpacing;
	} catch {
		return null;
	}
}, tr = (e, t, n, r) => {
	let i = r + 16, a = ht + (e.offsetPx ?? 0), o = e.pointing === "down" ? n - a - 22 : n + a;
	return {
		left: t - i / 2,
		top: o,
		width: i,
		height: 22
	};
}, nr = (e, t) => t.x >= e.left && t.x <= e.left + e.width && t.y >= e.top && t.y <= e.top + e.height, rr = (e, t) => {
	for (let n = e.length - 1; n >= 0; n--) if (nr(e[n].rect, t)) return e[n];
	return null;
}, ir = "#1A1A1A", ar = "#F2F2F2", or = 13, sr = 18, cr = 3, lr = 8, ur = 2, dr = 12, fr = 4, pr = 1, mr = 8, hr = 1e3, gr = 0, _r = 100, vr = {
	position: "fixed",
	zIndex: String(hr),
	display: "none",
	width: "max-content",
	paddingBlock: `${cr}px`,
	paddingInline: `${lr}px`,
	borderRadius: `${ur}px`,
	background: ir,
	color: ar,
	fontSize: `${or}px`,
	lineHeight: `${sr}px`,
	fontWeight: "400",
	whiteSpace: "pre-wrap",
	textAlign: "start",
	pointerEvents: "none"
}, yr = {
	position: "absolute",
	width: "0",
	height: "0",
	borderInline: `${dr / 2}px solid transparent`
}, br = `${fr}px solid ${ir}`, xr = (e, t, n) => Math.min(Math.max(e, t), n), Sr = (e, t, n) => {
	let r = e.left + e.width / 2, i = xr(r - t.width / 2, 0, Math.max(0, n.width - t.width)), a = xr(r - i, mr, t.width - mr), o = e.top - pr - t.height;
	return o < 0 ? {
		left: i,
		top: e.top + e.height + pr,
		placement: "below",
		earLeft: a
	} : {
		left: i,
		top: o,
		placement: "above",
		earLeft: a
	};
}, Cr = (e, t, n, r) => {
	let i = [];
	for (let a of e) {
		let e = Ct(a.price, n);
		if (e === null) continue;
		let o = tr(a, 0, e, 0);
		if (t.y < o.top || t.y > o.top + o.height) continue;
		let s = r.centerX(a);
		s !== null && i.push({
			plate: a,
			rect: tr(a, s, e, r.textWidth(a))
		});
	}
	return i;
}, wr = (e, t) => e.x >= 0 && e.y >= 0 && e.x <= t.width && e.y <= t.height, Tr = (e, t) => {
	let { chart: n, kind: r, paneRect: i, point: a } = e;
	if (r === "gesture" || r === "leave" || !a || !i || !wr(a, i)) return null;
	let o = t.platesFor(n);
	return o.length === 0 ? null : rr(Cr(o, a, t.scaleOf(n), {
		centerX: (e) => t.centerX(n, e),
		textWidth: t.textWidth
	}), a);
}, Er = (e) => {
	let t = /* @__PURE__ */ new Map(), n = null;
	return (r) => {
		let i = `${r.fontSize}|${r.text}`, a = t.get(i);
		if (a !== void 0) return a;
		if (n ??= {
			context: e.createElement("canvas").getContext("2d"),
			fontFamily: e.defaultView?.getComputedStyle(e.body).fontFamily ?? "sans-serif"
		}, !n.context) return 0;
		n.context.font = `${r.fontSize}px ${n.fontFamily}`;
		let o = n.context.measureText(r.text).width;
		return t.set(i, o), o;
	};
}, Dr = (e, t) => {
	let n = e.createElement("div"), r = e.createTextNode(""), i = e.createElement("div"), a = null;
	return n.dir = t, n.setAttribute("role", "tooltip"), Object.assign(n.style, vr), Object.assign(i.style, yr), n.append(r, i), e.body.append(n), {
		show: ({ plate: e, rect: t }, o) => {
			let s = [
				e.tooltip,
				t.left,
				t.top,
				t.width,
				o.left,
				o.top
			].join("|");
			if (s === a) return;
			a = s, r.data = e.tooltip, n.style.display = "block";
			let c = Sr(t, n.getBoundingClientRect(), o), l = c.placement === "above";
			n.style.left = `${o.left + c.left}px`, n.style.top = `${o.top + c.top}px`, Object.assign(i.style, {
				left: `${c.earLeft - dr / 2}px`,
				top: l ? "100%" : "",
				bottom: l ? "" : "100%",
				borderTop: l ? br : "0",
				borderBottom: l ? "0" : br
			});
		},
		hide: () => {
			a !== null && (a = null, n.style.display = "none");
		},
		remove: () => {
			n.remove();
		}
	};
}, Or = (e) => {
	let { direction: t, label: n, platesFor: r } = e, i = !0, a = !1, o = null, s = null, c = null, l = null, u = () => {
		l && clearInterval(l), l = null, c = null;
	}, d = (e) => {
		a || (a = !0, console.warn(`${n}: cannot show a tooltip`, e));
	};
	return {
		attach: (e, n) => {
			if (!i || o) return;
			let a = Dr(n, t), f = {
				platesFor: r,
				centerX: er,
				scaleOf: (e) => Dn(e, gr),
				textWidth: Er(n)
			}, p = (e) => {
				if (i) {
					try {
						let t = Tr(e, f);
						if (t && e.paneRect) {
							a.show(t, e.paneRect), c = e, l ??= setInterval(() => {
								c && p(c);
							}, _r);
							return;
						}
					} catch (e) {
						d(e);
					}
					a.hide(), u();
				}
			};
			o = a, s = Xn(e, n, p);
		},
		destroy: () => {
			i && (i = !1, u(), s?.(), o?.remove(), s = null, o = null);
		}
	};
}, kr = 5, Ar = (e) => ({
	time: e.time,
	close: e.close
}), jr = (e) => {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) !Number.isFinite(n.time) || !Number.isFinite(n.close) || t.set(n.time, n);
	return Array.from(t.values()).sort((e, t) => e.time - t.time);
}, Mr = (e, t, n, r, i, a) => new Promise((o, s) => {
	e.getBars(t, n, {
		from: r,
		to: i,
		countBack: a,
		firstDataRequest: !1
	}, (e) => o(e), (e) => s(Error(e))).catch((e) => s(e instanceof Error ? e : Error(String(e))));
}), Nr = async ({ datafeed: e, symbolInfo: t, resolution: n, resolutionMinutes: r, barCount: i }) => {
	let a = Math.ceil(Date.now() / 1e3), o = r * 60 * i * 2, s = /* @__PURE__ */ new Map();
	for (let r = 0; r < kr && s.size < i; r++) {
		let r = a - o, c = await Mr(e, t, n, r, a, i), l = s.size;
		for (let e of c) {
			let t = Ar(e);
			Number.isFinite(t.time) && Number.isFinite(t.close) && s.set(t.time, t);
		}
		if (c.length && s.size === l) break;
		let u = c.reduce((e, t) => Math.min(e, t.time), Infinity);
		a = Number.isFinite(u) ? Math.floor(u / 1e3) : r, o *= 2;
	}
	return Array.from(s.values()).sort((e, t) => e.time - t.time).slice(-i);
}, Pr = 2e4, Fr = 12, Ir = async ({ datafeed: e, symbolInfo: t, resolution: n, resolutionMinutes: r, barCount: i }) => {
	let a = r * 60 * Pr, o = /* @__PURE__ */ new Map(), s = Math.ceil(Date.now() / 1e3);
	for (let r = 0; r < Fr && o.size < i; r++) {
		let i = s - a, c;
		try {
			c = await Mr(e, t, n, i, s, Pr);
		} catch (e) {
			if (r === 0) throw e;
			break;
		}
		let l = o.size;
		for (let e of c) {
			let t = Ar(e);
			Number.isFinite(t.time) && Number.isFinite(t.close) && o.set(t.time, t);
		}
		if (o.size === l) break;
		s = i;
	}
	return Array.from(o.values()).sort((e, t) => e.time - t.time).slice(-i);
}, Lr = async (e, t, n, r, i, a) => {
	let o = Math.ceil(Date.now() / 1e3);
	return jr((await Mr(e, t, n, o - r * 60 * i, o, a)).map(Ar));
}, Rr = (e, t, n) => {
	for (let [n, r] of t) if (e < n) return r;
	return n;
}, zr = (e, t, n) => {
	for (let [n, r] of t) if (e <= n) return r;
	return n;
}, Br = (e, t, n) => {
	for (let [n, r] of t) if (e >= n) return r;
	return n;
}, Vr = /* @__PURE__ */ function(e) {
	return e.Gold = "GOLD", e.Btc = "BTC", e.Eth = "ETH", e.Nas100 = "NAS100", e.Sp500 = "SP500", e.Dow = "DOW", e.Oil = "OIL", e.Silver = "SILVER", e.Gbp = "GBP", e.Eur = "EUR", e.Jpy = "JPY", e.Other = "OTHER", e;
}({}), Hr = /* @__PURE__ */ function(e) {
	return e.Scalping = "Scalping", e.Daytrade = "Daytrade", e.Swing = "Swing", e;
}({}), Ur = [
	["GOLD", ["XAU", "GOLD"]],
	["BTC", ["BTC"]],
	["ETH", ["ETH"]],
	["NAS100", [
		"NAS",
		"NDX",
		"US100",
		"NQ",
		"USTEC"
	]],
	["SP500", [
		"SPX",
		"SP500",
		"US500",
		"ES1"
	]],
	["DOW", [
		"DOW",
		"US30",
		"YM1"
	]],
	["OIL", [
		"OIL",
		"WTI",
		"BRENT",
		"CL1",
		"UKOUSD",
		"USOUSD"
	]],
	["SILVER", ["XAG", "SILVER"]],
	["GBP", ["GBP"]],
	["EUR", ["EUR"]],
	["JPY", ["JPY"]]
], Wr = (e) => {
	let t = (e || "").toUpperCase();
	return Ur.find(([, e]) => e.some((e) => t.includes(e)))?.[0] ?? "OTHER";
}, Gr = [[5, "Scalping"], [60, "Daytrade"]], Kr = (e) => zr(e, Gr, "Swing"), qr = {
	Scalping: {
		biasMaxMinutes: 30,
		adxThreshold: 13,
		lineAheadMinutes: 10,
		biasMultiplier: 4
	},
	Daytrade: {
		biasMaxMinutes: 240,
		adxThreshold: 18,
		lineAheadMinutes: 60,
		biasMultiplier: 6
	},
	Swing: {
		biasMaxMinutes: 1440,
		adxThreshold: 20,
		lineAheadMinutes: 240,
		biasMultiplier: 8
	}
}, Jr = {
	GOLD: -2,
	BTC: 2
}, Yr = (e, t) => qr[e].adxThreshold + (Jr[t] ?? 0), Xr = {
	doji: .2,
	wick: 2
}, Zr = { BTC: {
	doji: .15,
	wick: 2.5
} }, Qr = (e) => Zr[e] ?? Xr, $r = {
	slopeStrongThreshold: .05,
	slopeMidThreshold: .02,
	slopeMultiplier: 1,
	structureMultiplier: 1,
	distOptimalMin: .05,
	distOptimalMax: .4,
	chopLookback: 7,
	chopMaxBonus: .25,
	chopMultiplier: 1,
	volumeAvgMultiplier: 1
}, ei = {
	GOLD: {
		...$r,
		slopeStrongThreshold: .03,
		slopeMidThreshold: .01,
		slopeMultiplier: 1.1,
		structureMultiplier: 1.1,
		distOptimalMin: .03,
		distOptimalMax: .2
	},
	BTC: {
		...$r,
		slopeStrongThreshold: .08,
		slopeMidThreshold: .03,
		slopeMultiplier: .9,
		structureMultiplier: .85,
		chopLookback: 10,
		chopMaxBonus: .3,
		chopMultiplier: 1.2,
		volumeAvgMultiplier: 1.5
	}
}, ti = (e) => ei[e] ?? $r, ni = [[10, 5], [60, 20]], ri = (e) => zr(e, ni, 50), ii = [
	"1",
	"2",
	"3",
	"5",
	"15",
	"60",
	"240",
	"1D"
], ai = [
	1,
	2,
	3,
	5,
	15,
	30,
	60,
	120,
	240,
	480,
	1440
], oi = (e) => tt($e(e)) / 60, si = (e) => e >= 1440 ? "1D" : String(e), ci = [
	[1, 2],
	[2, 3],
	[3, 5],
	[5, 15],
	[15, 30],
	[30, 60],
	[60, 120],
	[120, 240],
	[240, 480]
], li = (e) => Rr(e, ci, 1440), ui = (e, t) => {
	let { biasMultiplier: n, biasMaxMinutes: r } = qr[t], i = Math.round(e * n), a = Math.min(Math.max(i, li(e)), r), o = ai.filter((e) => e <= r);
	return si(o.find((e) => e >= a) ?? o[o.length - 1] ?? r);
}, di = [
	[2, "1"],
	[3, "2"],
	[5, "3"],
	[15, "5"],
	[30, "15"],
	[60, "30"]
], fi = (e) => zr(e, di, "60"), pi = [
	[1, null],
	[2, "1"],
	[3, "2"],
	[5, "3"],
	[15, "5"],
	[60, "15"]
], mi = [
	[2, null],
	[3, "1"],
	[5, "2"],
	[15, "3"],
	[60, "5"]
], hi = (e) => ({
	lower1: zr(e, pi, "60"),
	lower2: zr(e, mi, "30")
}), gi = ({ chartResolution: e, mode: t, dxySymbol: n }) => {
	let r = oi(e), i = [], a = /* @__PURE__ */ new Map([[$e(e), 0]]), o = (e) => {
		let t = $e(e), n = a.get(t);
		if (n !== void 0) return n;
		i.push({
			symbol: null,
			resolution: e
		});
		let r = i.length;
		return a.set(t, r), r;
	}, s = ii.map(o), c = o(fi(r)), { lower1: l, lower2: u } = hi(r), d = l === null ? 0 : o(l), f = u === null ? 0 : o(u), p = ui(r, t), m = o(p), h = o("15"), g = o("60"), _ = n.trim().length > 0, v = 0;
	return _ && (i.push({
		symbol: n.trim(),
		resolution: e
	}), v = i.length), {
		frames: i,
		panelSlots: s,
		richSlots: [.../* @__PURE__ */ new Set([
			c,
			s[0],
			d,
			f,
			h,
			g
		])].sort((e, t) => e - t),
		biasSlot: m,
		biasResolution: p,
		warnSlot: c,
		minuteSlot: s[0],
		lower1Slot: d,
		lower1Valid: l !== null,
		lower2Slot: f,
		lower2Valid: u !== null,
		htf15Slot: h,
		htf60Slot: g,
		dxySlot: v,
		dxyValid: _
	};
}, _i = 3e3, vi = 2, yi = 2e3, bi = 5, xi = 5 * 6e4, Si = () => {
	let e = [], t = [], n = /* @__PURE__ */ new Map(), r = !1, i = (t) => {
		let n = 0, r = e.length - 1, i = -1;
		for (; n <= r;) {
			let a = n + r >> 1;
			e[a] <= t ? (i = a, n = a + 1) : r = a - 1;
		}
		return i;
	}, a = (e, r, i) => {
		let a = n.get(e);
		if (a && a.key === r) return a.values;
		let o = i(), s = [];
		for (let e = 0; e < t.length; e++) e > 0 && o.advance(), s.push(o.read(t[e]));
		return n.set(e, {
			key: r,
			math: o,
			values: s
		}), s;
	}, o = (r, i) => {
		e.push(r), t.push(i);
		for (let e of n.values()) e.values.length > 0 && e.math.advance(), e.values.push(e.math.read(i));
	}, s = (r) => {
		if (e.length !== 0) {
			t[t.length - 1] = r;
			for (let e of n.values()) e.values[e.values.length - 1] = e.math.read(r);
		}
	}, c = () => r;
	return {
		slot: {
			hasHistory: c,
			indexAt: i,
			series: a
		},
		hasHistory: c,
		get lastTime() {
			return e.length ? e[e.length - 1] : NaN;
		},
		get barCount() {
			return e.length;
		},
		appendBar: o,
		updateForming: s,
		setHistory(i) {
			r = i.length > 0, e.length = 0, t.length = 0;
			for (let n of i) e.push(n.time), t.push(n.close);
			n.clear();
		},
		mergeTail(a) {
			if (!a.length || !r) return !1;
			let o = a[0].time;
			if (e.length > 0 && o < e[0]) return !1;
			let s = i(o - 1) + 1, c = e.length - 1;
			if (e.length - s === a.length && a.every((n, r) => e[s + r] === n.time && (s + r === c || t[s + r] === n.close))) return !1;
			let l = e.length ? e[e.length - 1] : NaN, u = t[t.length - 1];
			e.length = s, t.length = s;
			for (let n of a) e.push(n.time), t.push(n.close);
			return e[e.length - 1] === l && (t[t.length - 1] = u), n.clear(), !0;
		}
	};
}, Ci = (e) => e.historyBars ?? _i, wi = (e) => {
	let t = Ci(e), n = `${e.symbol ?? ""}@${e.resolution}`;
	return t === _i ? n : `${n}#${t}`;
}, Ti = ({ symbol: e, frames: t }) => `${Qe(e)}|${t.map(wi).join(",")}`, Ei = ({ datafeed: e, ticker: t, onReady: n, onFrameFailed: r }) => {
	let i = !0, a = 0, o = !1, s = "", c = [], l = null, u = null, d = /* @__PURE__ */ new Set(), f = (e) => {
		let t = `${e.symbol}@${e.resolution}`;
		d.has(t) || (d.add(t), r?.(e.symbol, e.resolution));
	}, p = () => {
		l && t.unsubscribe(l), u && clearTimeout(u), l = null, u = null;
	}, m = (e) => {
		let t = e.bid, n = e.timestamp;
		if (!Number.isFinite(t) || !Number.isFinite(n)) return;
		let r = Qe(e.symbol);
		for (let e of c) {
			if (e.tickSymbol !== r || !e.store.hasHistory()) continue;
			let i = e.store.lastTime, a = e.minutes * 6e4;
			if (n >= i + a) {
				let r = Math.floor((n - i) / a);
				e.store.appendBar(i + r * a, t);
			} else e.store.updateForming(t);
		}
	}, h = (t, n) => {
		let r = {
			datafeed: e,
			symbolInfo: n,
			resolution: t.resolution,
			resolutionMinutes: t.minutes,
			barCount: t.historyBars
		};
		return t.historyBars > _i ? Ir(r) : Nr(r);
	}, g = async (t, n, r) => {
		try {
			let o = await Lr(e, r, n.resolution, n.minutes, bi, _i);
			return !i || t !== a ? !1 : o.length > 0 && n.store.mergeTail(o);
		} catch {
			return !1;
		}
	}, _ = async (e, t, n) => {
		try {
			let r = await h(t, n);
			return !i || e !== a || !r.length ? !1 : (t.store.setHistory(r), !0);
		} catch {
			return !1;
		}
	}, v = async ({ symbol: r, frames: u }, d = 0) => {
		let _ = ++a, b = () => {
			d >= vi || setTimeout(() => {
				i && _ === a && v({
					symbol: r,
					frames: u
				}, d + 1);
			}, yi * 2 ** d);
		}, x = () => {
			b(), d >= vi && (s = "");
		};
		try {
			if (p(), o = !1, c = u.map((e) => ({
				symbol: e.symbol ?? r,
				tickSymbol: Qe(e.symbol ?? r),
				resolution: e.resolution,
				minutes: oi(e.resolution),
				historyBars: Ci(e),
				store: Si()
			})), !c.length) {
				o = !0, n();
				return;
			}
			let s = await e.whenSymbolsReady();
			if (!i || _ !== a) return;
			let d = c.map((e) => s.get(e.symbol.toLowerCase()));
			if (!d.some((e) => e !== void 0)) {
				console.warn(`Trade Finder frames: the data feed knows none of ${c.map((e) => e.symbol).join(", ")} - secondary timeframes will read flat. The chart symbol is what the feed keys on.`), x();
				return;
			}
			if (await Promise.all(c.map(async (e, t) => {
				let n = d[t];
				if (n) try {
					e.store.setHistory(await h(e, n));
				} catch (t) {
					console.warn(`Trade Finder frames: ${e.symbol} ${e.resolution} failed`, t);
				}
				e.store.hasHistory() || f(e);
			})), !i || _ !== a) return;
			if (l = m, t.subscribe(l), o = !0, n(), c.every((e) => e.store.barCount === 0)) {
				b();
				return;
			}
			let v = await Promise.all(c.map((e, t) => {
				let n = d[t];
				return n ? g(_, e, n) : Promise.resolve(!1);
			}));
			if (!i || _ !== a) return;
			v.some(Boolean) && n(), y(_, d);
		} catch (e) {
			if (console.error("Trade Finder frames failed to load", e), !i || _ !== a) return;
			x();
		}
	}, y = (e, t) => {
		u && clearTimeout(u), u = setTimeout(() => {
			!i || e !== a || Promise.all(c.map((n, r) => {
				let i = t[r];
				return i ? n.store.hasHistory() ? g(e, n, i).then(() => !1) : _(e, n, i) : Promise.resolve(!1);
			})).then((t) => {
				!i || e !== a || t.some(Boolean) && n();
			}).finally(() => {
				i && e === a && y(e, t);
			});
		}, xi);
	};
	return {
		request: (e) => {
			if (!i) return;
			let t = Ti(e);
			t !== s && (s = t, v(e).catch((e) => {
				console.error("Trade Finder frames: the failure handler failed", e);
			}));
		},
		isReady: () => o,
		slot: (e) => c[e - 1]?.store.slot,
		destroy: () => {
			i && (i = !1, a++, p(), c = []);
		}
	};
}, Di = "frameRevision", Oi = 1e6, ki = 10 * 6e4, Ai = 6e4, ji = 20, Mi = ({ datafeed: e, ticker: t, studyName: n, onFrameFailed: r, isRefreshNeeded: i }) => {
	let a = !0, o = null, s = null, c = null, l = Date.now() % Oi, u = !1, d = 0, f = /* @__PURE__ */ new Map(), p = () => {
		if (!a || !o || !u) return;
		if (d >= ji) {
			u = !1, console.warn(`${n}: gave up refreshing after the frames loaded; the secondary timeframes will read flat until it recalculates`);
			return;
		}
		d++, l = (l + 1) % Oi;
		let e = 0;
		at(o, (t) => {
			let r = ot(t, n, "Trade Finder frames");
			if (r) for (let n of r) try {
				let r = t.getStudyById(n.id);
				if (r && i && !i(r)) {
					e++;
					continue;
				}
				r?.setInputValues([{
					id: Di,
					value: l
				}]), e++;
			} catch (e) {
				console.warn("Trade Finder frames: unable to refresh the study", e);
			}
		}), e > 0 && (u = !1, d = 0);
	}, m = () => {
		!a || c || (c = setTimeout(() => {
			c = null, p();
		}, 0));
	}, h = (n, i) => {
		let a = Ei({
			datafeed: e,
			ticker: t,
			onFrameFailed: r,
			onReady: () => {
				u = !0, d = 0, m();
			}
		}), o = {
			feed: a,
			lastRead: Date.now()
		};
		return f.set(n, o), a.request(i), o;
	}, g = (e, t) => {
		if (!a) return null;
		let n = f.get(e) ?? h(e, t);
		return n.lastRead = Date.now(), n.feed;
	}, _ = setInterval(() => {
		if (!a) return;
		let e = Date.now() - ki;
		for (let [t, n] of Array.from(f)) n.lastRead > e || (f.delete(t), n.feed.destroy());
	}, Ai);
	return {
		acquire: (e) => {
			let t = Ti(e);
			return g(t, e), {
				isReady: () => g(t, e)?.isReady() ?? !1,
				slot: (n) => g(t, e)?.slot(n)
			};
		},
		attach: (e) => {
			!a || o || (o = e, s = ct(o, ["study_event", "layout_changed"], m), m());
		},
		destroy: () => {
			if (a) {
				a = !1, clearInterval(_), c && clearTimeout(c), c = null, s?.(), s = null, o = null;
				for (let e of f.values()) e.feed.destroy();
				f.clear();
			}
		}
	};
}, Ni = (e) => {
	let t = 0, n = 0, r = NaN, i = NaN, a = (e) => Number.isNaN(i) ? e.high - e.low : Math.max(e.high - e.low, Math.abs(e.high - i), Math.abs(e.low - i)), o = (i) => t + 1 < e ? NaN : t + 1 === e ? (n + i) / e : (r * (e - 1) + i) / e;
	return {
		confirm: (s) => {
			let c = a(s), l = o(c);
			return t + 1 < e && (n += c), r = l, t += 1, i = s.close, l;
		},
		preview: (e) => o(a(e))
	};
}, Pi = 6e4, Fi = 60 * Pi, Ii = 1440, Li = (e) => new Intl.DateTimeFormat("en-US", {
	timeZone: e,
	hourCycle: "h23",
	hour: "2-digit",
	minute: "2-digit"
}), J = (e, t) => {
	let n = e.formatToParts(t), r = Number(n.find((e) => e.type === "hour")?.value), i = Number(n.find((e) => e.type === "minute")?.value);
	return r % 24 * 60 + i;
}, Ri = (e, t = "America/Denver") => {
	let n;
	try {
		n = Li(e);
	} catch {
		console.warn(`Unknown timezone "${e}", falling back to "${t}"`), n = Li(t);
	}
	let r = NaN, i = 0;
	return (e) => {
		let t = Math.floor(e / Fi);
		t !== r && (r = t, i = J(n, t * Fi));
		let a = Math.floor((e - t * Fi) / Pi);
		return (i + a) % Ii;
	};
}, zi = (e) => {
	let t = 2 / (e + 1), n = 0, r = 0, i = NaN, a = (a) => n + 1 < e ? NaN : n + 1 === e ? (r + a) / e : t * a + (1 - t) * i;
	return {
		confirm: (t) => {
			let o = a(t);
			return n + 1 < e && (r += t), i = o, n += 1, o;
		},
		preview: (e) => a(e)
	};
}, Bi = (e, t, n) => {
	let r = t + n, i = [], a = (t, n) => e === "high" ? t > n : t < n, o = (e, t) => !a(t, e), s = (e) => {
		if (i.length < r) return NaN;
		let n = [...i, e], s = n[t];
		for (let e = 0; e < n.length; e++) if (e !== t && !(e < t ? o(s, n[e]) : a(s, n[e]))) return NaN;
		return s;
	};
	return {
		confirm: (e) => {
			let t = s(e);
			return i.push(e), i.length > r && i.shift(), t;
		},
		preview: (e) => s(e)
	};
}, Y = (e, t) => ({
	hex: e,
	transparency: t
}), Vi = {
	black: "#363A45",
	gray: "#787B86",
	white: "#FFFFFF",
	silver: "#B2B5BE"
}, Hi = {
	atrLen: 14,
	atrMult: 2,
	useScale2: !0,
	pivotDepth: 60,
	tolPoint: .05,
	tolEdge: .03,
	enGartley: !0,
	enBat: !0,
	enAltBat: !0,
	enButterfly: !0,
	enCrab: !0,
	enDeepCrab: !0,
	enShark: !0,
	enCypher: !0,
	enAbcd: !0,
	minScore: 60,
	maxPatterns: 18,
	formingLife: 100,
	dirFilter: "Both",
	showProjected: !0,
	keepSuccessful: !0,
	keepFailed: !0,
	showLetters: !0,
	showRatios: !0,
	showPlan: !0,
	showStats: !0,
	fillTransp: 70,
	colBull: Y("#22C55E", 0),
	colBear: Y("#9236DA", 0),
	colPrz: Y("#FFB74D", 70),
	colSR: Y("#6B7280", 45),
	enClassics: !0,
	enDoubles: !0,
	enTriples: !0,
	enHS: !0,
	showSR: !0,
	srMinTouch: 3
}, Ui = {
	forming: "forming",
	confirmed: "confirmed",
	target: "target",
	sl: "SL",
	tp1: "TP1",
	tp2: "TP2",
	classicNames: [
		"Double Top",
		"Double Bottom",
		"Triple Top",
		"Triple Bottom",
		"Head & Shoulders",
		"Inv H&S"
	],
	chartTooltip: {
		bullish: "bullish",
		bearish: "bearish",
		confluence: "confluence",
		entry: "entry",
		neckline: "neckline",
		score: "score",
		state: "state",
		stop: "stop",
		target: "target",
		states: [
			"projected",
			"prz_active",
			"completed",
			"t1",
			"t2",
			"t3",
			"t4",
			"stopped",
			"invalidated"
		]
	}
}, Wi = (e, t) => {
	let n = 10 ** t, r = Number((e * n).toPrecision(12));
	return (Math.round(r) / n).toFixed(t);
}, Gi = (e, t) => e.toFixed(t), Ki = (e, t, n) => {
	if (Number.isNaN(e)) return "NaN";
	if (!Number.isFinite(e)) return e > 0 ? "Infinity" : "-Infinity";
	let r = n(Math.abs(e), t);
	return e < 0 && Number(r) > 0 ? `-${r}` : r;
}, qi = (e, t) => Ki(e, t, Wi), Ji = (e) => qi(e, 1).replace(/\.0$/, ""), Yi = (e, t) => Ki(e, t.toFixed(12).replace(/0+$/, "").split(".")[1]?.length ?? 0, Gi), Xi = .25, Zi = (e) => {
	let t = [], n = (e, n, r) => {
		let i = !1;
		for (let n of t) Math.abs(n.price - e) < r * Xi && (n.hits += 1, i = !0);
		i || t.push({
			below: !1,
			fromIndex: n,
			hits: 1,
			price: e
		});
	}, r = (n, r) => {
		for (let i = t.length - 1; i >= 0; i--) {
			let a = t[i];
			a.below = a.price < n;
			let o = a.hits > e.srReset, s = Math.abs(a.price - n) > e.srRange * r;
			(o || s) && t.splice(i, 1);
		}
	}, i = (n) => {
		for (; t.length > e.srMax;) {
			let e = 0, r = -1;
			for (let i = 0; i < t.length; i++) {
				let a = Math.abs(t[i].price - n);
				a > r && (r = a, e = i);
			}
			t.splice(e, 1);
		}
	};
	return {
		confirm: (e, t, a, o) => {
			for (let t of o) n(t, e, a);
			r(t, a), i(t);
		},
		levels: () => t,
		nearest: (e) => {
			let n = NaN, r = NaN;
			for (let i of t) i.price > e && (Number.isNaN(n) || i.price < n) && (n = i.price), i.price < e && (Number.isNaN(r) || i.price > r) && (r = i.price);
			return {
				above: n,
				below: r
			};
		}
	};
}, Qi = [
	"Top left",
	"Top centre",
	"Top right",
	"Middle left",
	"Middle centre",
	"Middle right",
	"Bottom left",
	"Bottom centre",
	"Bottom right"
], X = {
	emaFastLen: 20,
	emaSlowLen: 50,
	longMode: "Literal 238",
	tz: "America/Denver",
	f1Clock: !0,
	f2Trend: !0,
	f3Mode: "Wait for pullback",
	f4Sep: !0,
	f4Min: 1,
	f5Clear: !0,
	f6Reward: !1,
	f6R: 2,
	f7Consol: !0,
	f7Pips: 100,
	f7Bars: 20,
	f9Star: !0,
	f9Bars: 10,
	pipIn: 0,
	slMinPips: 10,
	tp1R: 1,
	tp2R: 2,
	theme: "Dark",
	showTable: !0,
	showClock: !0,
	showTint: !0,
	showPoc: !0,
	showSr: !0,
	showStars: !0,
	tablePos: "Top right",
	trendPos: "Top centre",
	guidePos: "Bottom left",
	panelSize: "Normal",
	showGuide: !0,
	showWhy: !0,
	showLadder: !0,
	stripLen: 18,
	srLookback: 25,
	srAtrMove: 1,
	srReset: 25,
	srMax: 6,
	srRange: 6
}, $i = {
	fast: "#e0568f",
	slow: "#3987e5",
	long: "#c98500",
	bull: "#2fae6a",
	bear: "#d94040",
	star1: "#c98500",
	star2: "#3987e5",
	ink: "#e8e8e8",
	neutral: "#8a8a8a",
	tableBg: "#0e1116"
}, ea = {
	fast: "#c9316d",
	slow: "#2a78d6",
	long: "#eda100",
	bull: "#1a7f4b",
	bear: "#c62828",
	star1: "#eda100",
	star2: "#2a78d6",
	ink: "#0b0b0b",
	neutral: "#8a8a8a",
	tableBg: "#ffffff"
}, ta = (e) => e === "Dark" ? $i : ea, na = (e, t, n) => t ? qi(e, 2) : Yi(e, n), ra = (e) => qi(e, 1).replace(/\.0$/, ""), ia = (e) => e.includes("XAU") || e.includes("GOLD"), aa = 48, oa = (e, t) => {
	if (e.length < t + 1) return NaN;
	let n = (t) => e[e.length - 1 - t], r = n(1).high, i = n(1).low;
	for (let e = 1; e <= t; e++) r = Math.max(r, n(e).high), i = Math.min(i, n(e).low);
	if (!(r > i)) return NaN;
	let a = (r - i) / aa, o = Array(aa).fill(0);
	for (let e = 1; e <= t; e++) {
		let t = n(e), r = Math.max(Math.trunc((t.low - i) / a), 0), s = Math.min(Math.trunc((t.high - i) / a), aa - 1);
		if (s >= r) {
			let e = (Number.isNaN(t.volume) ? 1 : t.volume) / (s - r + 1);
			for (let t = r; t <= s; t++) o[t] += e;
		}
	}
	let s = 0, c = -1;
	for (let e = 0; e < aa; e++) o[e] > c && (c = o[e], s = e);
	return i + (s + .5) * a;
}, sa = (e, t, n) => {
	let r = e === 1, i = r ? t.colourOkBuy : t.colourOkSell, a = r ? t.longClearBuy : t.longClearSell, o = r ? t.roomBuy : t.roomSell, s = r ? t.trend15 : !t.trend15, c = r ? !t.recentBear : !t.recentBull;
	return n.f1Clock && !t.goodVolume ? 0 : n.f2Trend && !s ? 1 : n.f3Mode === "Reject" && !i ? 2 : n.f4Sep && !t.separating ? 3 : n.f5Clear && !a ? 4 : n.f6Reward && !o ? 5 : n.f7Consol && t.ranging ? 6 : n.f9Star && !c ? 7 : -1;
}, ca = (e, t, n) => sa(e, t, n) === -1, la = () => {
	let e = !1, t = !1;
	return { confirm: (n) => {
		let r = e, i = t, a = n.mode === "Wait for pullback";
		return n.passBuy && a && !n.colourOkBuy && (e = !0, t = !1), n.passSell && a && !n.colourOkSell && (t = !0, e = !1), e && (n.pullbackBuy || n.fastBelowSlow) && (e = !1), t && (n.pullbackSell || n.fastAboveSlow) && (t = !1), {
			fireBuy: n.passBuy && (!a || n.colourOkBuy) || r && n.pullbackBuy,
			fireSell: n.passSell && (!a || n.colourOkSell) || i && n.pullbackSell
		};
	} };
}, ua = (e, t) => Number.isNaN(e) ? t : e, da = (e) => ({
	buyStop: Math.min(Math.min(e.emaFast, e.emaSlow), e.emaSlow - e.slMinPips * e.pip, ua(e.lastSwingLow, e.low)),
	sellStop: Math.max(Math.max(e.emaFast, e.emaSlow), e.emaSlow + e.slMinPips * e.pip, ua(e.lastSwingHigh, e.high))
}), fa = () => {
	let e = null;
	return {
		open: (t) => {
			e = {
				...t,
				hit: 0,
				live: !0,
				stopped: !1
			};
		},
		confirm: (t, n) => {
			if (e === null || !e.live) return;
			let r = e.direction === 1, i = r ? t : n, a = r ? i >= e.t2 : i <= e.t2, o = r ? i >= e.t1 : i <= e.t1, s = a ? 2 : +!!o, c = Math.max(e.hit, s), l = r ? n <= e.stop : t >= e.stop, u = l || c === 2;
			e = {
				...e,
				hit: c,
				live: !u,
				stopped: u ? l && c < 2 : e.stopped
			};
		},
		state: () => e === null ? null : { ...e }
	};
}, pa = (e, t, n, r) => {
	let [i, a] = e.split(" "), o = a === "left" ? r : a === "right" ? t.width - n.width - r : (t.width - n.width) / 2, s = i === "Top" ? r : i === "Bottom" ? t.height - n.height - r : (t.height - n.height) / 2;
	return {
		left: t.left + o,
		top: t.top + s
	};
}, ma = [
	"trend",
	"rightNow",
	"guide"
], ha = (e) => ma.filter((t, n) => {
	let r = e[t];
	return !ma.slice(n + 1).some((t) => e[t] === r);
}), ga = (e) => ha(e.positions).flatMap((t) => {
	let n = e[t];
	return n === null ? [] : [n];
}), _a = [
	{
		head: "1m",
		key: "m1"
	},
	{
		head: "5m",
		key: "m5"
	},
	{
		head: "15m",
		key: "m15"
	},
	{
		head: "30m",
		key: "m30"
	},
	{
		head: "4h",
		key: "h4"
	},
	{
		head: "1D",
		key: "d1"
	}
], va = Y(Vi.white, 0), ya = (e, t, n = null, r = "center") => ({
	text: e,
	textColor: t,
	bg: n,
	size: "text",
	align: r
}), ba = (e, t) => ({
	text: e,
	textColor: t,
	bg: null,
	size: "head",
	align: "center"
}), xa = (e, t) => Array.from({ length: e }, () => Array(t).fill(null)), Sa = (e, t, n, r, i) => {
	let a = !Number.isNaN(t), o = a && n > t;
	return ya(`${e} ${a ? o ? i.above : i.below : i.notAvailable}`, va, Y(o ? r.bull : r.bear, 20));
}, Ca = (e, t, n, r, i) => {
	let a = xa(3, _a.length + 1), o = Y(r.ink, 25);
	return a[0][0] = ba(e, Y(r.ink, 0)), _a.forEach(({ head: e, key: n }, s) => {
		let c = t[n];
		a[0][s + 1] = ya(e, o), a[1][s + 1] = ya(c ? i.trendUp : i.trendDown, va, Y(c ? r.bull : r.bear, 20));
	}), a[2][0] = ya(i.volumeLine, o), {
		position: n.trendPos,
		columns: _a.length + 1,
		rows: 3,
		cells: a
	};
}, wa = (e, t, n, r, i) => {
	let a = _a.filter(({ key: e }) => t[e]).length, o = (e) => ya(e, Y(r.ink, 40)), s = (e) => ya(e, Y(r.ink, 20)), c = ya(e.goodVolume ? i.goodVolume : i.lowVolume, va, Y(e.goodVolume ? r.bull : r.bear, 10)), l = ya(i.trendSummary(t.m15, a), Y(t.m15 ? r.bull : r.bear, 0)), u = e.goodVolume ? t.m15 ? i.bestBuysOnly : i.bestSellsOnly : i.bestWaitThin, d = e.close > e.emaLong ? i.safetyBelow : i.safetyAbove, f = [
		[ba(i.rightNow, Y(r.ink, 0)), c],
		[o(i.trend), l],
		[o(i.bestNow), s(u)],
		[o(i.safetyLine), s(d)],
		[o(i.skipped), s((() => {
			let t = e.skipped;
			if (!n.showWhy || t === null) return i.skippedNothing;
			let r = t.direction === 1 ? i.aBuy : i.aSell;
			return i.skippedAgo(r, e.lastIndex - t.index, i.reasons[t.reason]);
		})())]
	];
	return {
		position: n.tablePos,
		columns: 2,
		rows: f.length,
		cells: f
	};
}, Ta = (e, t, n) => {
	let r = [
		t.fast,
		t.slow,
		t.long,
		t.long,
		t.neutral,
		t.star2,
		t.bear,
		t.ink,
		t.neutral
	], i = Y(t.ink, 8), a = n.legendRows.map((e, t) => [ya(e.mark, Y(r[t], 0), null, "left"), ya(e.meaning, i, null, "left")]), o = [[ba(n.legendTitle, Y(t.ink, 0)), ya(n.legendSubtitle, Y(t.ink, 35))], ...a];
	return {
		position: e.guidePos,
		columns: 2,
		rows: o.length,
		cells: o
	};
}, Ea = 14, Da = 5, Oa = 99999, ka = 4900, Aa = 500, ja = "#2962FF", Ma = [
	NaN,
	NaN,
	NaN,
	NaN,
	NaN,
	NaN
], Na = [
	{
		kind: "high",
		span: 2
	},
	{
		kind: "low",
		span: 2
	},
	{
		kind: "high",
		span: 5
	},
	{
		kind: "low",
		span: 5
	},
	{
		kind: "high",
		span: 10
	},
	{
		kind: "low",
		span: 10
	}
], Pa = [
	[300, 420],
	[465, 540],
	[630, 810],
	[1020, 1260],
	[1410, 180]
], Fa = {
	Small: "tiny",
	Normal: "small",
	Large: "normal"
}, Ia = (e) => Math.max(Math.floor(e / 60), 1), La = (e, t) => e === "Auto-scale" ? Math.max(Math.round(250 / Ia(t)), 3) : 238, Ra = (e) => Math.max(Math.trunc(360 / Ia(e)), 20), za = (e, [t, n]) => t < n ? e >= t && e < n : e >= t || e < n, Ba = (...e) => e.every(Number.isFinite), Va = (e) => {
	let { inputs: t, symbol: n, texts: r } = e, i = ta(t.theme), a = ia(n.ticker), o = t.pipIn > 0 ? t.pipIn : a ? .1 : n.mintick * 10, s = Ra(n.resolutionSeconds), c = Math.max(Math.trunc(t.srLookback / 5), 2), l = Ri(t.tz), u = zi(t.emaFastLen), d = zi(t.emaSlowLen), f = zi(La(t.longMode, n.resolutionSeconds)), p = Ni(Ea), m = Bi("high", c, c), h = Bi("low", c, c), g = Na.map(({ kind: e, span: t }) => ({
		kind: e,
		pivot: Bi(e, t, t)
	})), _ = Zi({
		srReset: t.srReset,
		srMax: t.srMax,
		srRange: t.srRange
	}), v = la(), y = fa(), b = [], x = [], S = null, C = null, w = NaN, T = NaN, E = NaN, D = NaN, O = !1, k = NaN, ee = NaN, te = NaN, ne = null, A = null, j = null, M = (e) => na(e, a, n.mintick), re = (e) => {
		let t = l(e);
		return Pa.some((e) => za(t, e));
	}, N = (e, t) => {
		let [n, r, i, a, o, s] = g.map(({ kind: n, pivot: r }) => {
			let i = n === "high" ? e.high : e.low;
			return t ? r.confirm(i) : r.preview(i);
		});
		return [
			n,
			r,
			i,
			a,
			o,
			s
		];
	}, P = (e, n, r, i, a) => ({
		emaFast: n,
		emaSlow: r,
		emaLong: i,
		tint: t.showTint ? n > r ? 0 : 1 : NaN,
		candle: t.showTint ? e.close >= e.open ? 0 : 1 : NaN,
		poc: t.showPoc ? k : NaN,
		diamonds: t.showStars ? a : Ma
	}), ie = () => {
		if (b.length < t.f7Bars) return NaN;
		let e = -Infinity, n = Infinity;
		for (let r = b.length - t.f7Bars; r < b.length; r++) e = Math.max(e, b[r].high), n = Math.min(n, b[r].low);
		return e - n;
	}, ae = (e, n, r) => {
		let i = m.confirm(n.high), a = h.confirm(n.low);
		if (!t.showSr) return;
		let o = [];
		!Number.isNaN(i) && i - n.low >= t.srAtrMove * r && o.push(i), !Number.isNaN(a) && n.high - a >= t.srAtrMove * r && o.push(a), _.confirm(e - c, n.close, r, o);
	}, oe = (e, t, n, a) => {
		let s = [
			`${n ? r.buy : r.sell}  ${M(t.close)}`,
			`${r.stop}  ${M(a.stop)} (${ra(a.risk / o)} ${r.pips})`,
			`TP1  ${M(a.t1)}`,
			`TP2  ${M(a.t2)}`
		].join("\n");
		return {
			type: "label",
			x: e,
			y: n ? t.low : t.high,
			yloc: n ? "belowbar" : "abovebar",
			text: n ? "▲" : "▼",
			style: "none",
			color: Y(ja, 0),
			textColor: Y(n ? i.bull : i.bear, 0),
			size: "small",
			tooltip: s
		};
	};
	return {
		confirmBar: (n, r, i) => {
			if (S !== null && C !== null && n <= S) return C;
			let a = T > E, c = u.confirm(r.close), l = d.confirm(r.close), m = f.confirm(r.close), h = p.confirm(r);
			b.push({
				high: r.high,
				low: r.low,
				volume: r.volume
			});
			let g = e.trend15 === "chart" ? a : e.trend15(n, r, i), M = re(r.time);
			n > s && n % Da === 0 && (k = oa(b, s)), ae(n, r, h);
			let se = _.nearest(r.close), ce = N(r, !0), [le, F, , , ue, de] = ce;
			Number.isNaN(ue) || (ne = n), Number.isNaN(de) || (A = n);
			let fe = (e) => e === null ? Oa : n - e, pe = Ba(c, l, T, E), me = pe && c > l && T <= E, he = pe && c < l && T >= E, ge = c - l, _e = Math.abs(ge - D) >= t.f4Min * o, ve = ie() <= t.f7Pips * o, ye = r.close >= r.open, be = r.close <= r.open, I = ye && r.low <= c, xe = be && r.high >= c;
			Number.isNaN(F) || (ee = F), Number.isNaN(le) || (te = le);
			let { buyStop: Se, sellStop: Ce } = da({
				emaFast: c,
				emaSlow: l,
				low: r.low,
				high: r.high,
				lastSwingLow: ee,
				lastSwingHigh: te,
				pip: o,
				slMinPips: t.slMinPips
			}), L = r.close - Se, we = Ce - r.close, R = r.close + L * t.tp2R, Te = r.close - we * t.tp2R, Ee = {
				goodVolume: M,
				trend15: g,
				colourOkBuy: ye,
				colourOkSell: be,
				separating: _e,
				longClearBuy: !(m > r.close && m < R),
				longClearSell: !(m < r.close && m > Te),
				roomBuy: Number.isNaN(se.above) || se.above - r.close >= t.f6R * L,
				roomSell: Number.isNaN(se.below) || r.close - se.below >= t.f6R * we,
				ranging: ve,
				recentBear: fe(ne) <= t.f9Bars,
				recentBull: fe(A) <= t.f9Bars
			}, De = me && ca(1, Ee, t), Oe = he && ca(-1, Ee, t);
			if (me || he) {
				let e = me ? 1 : -1, r = sa(e, Ee, t);
				r !== -1 && (j = {
					index: n,
					direction: e,
					reason: r
				});
			}
			let { fireBuy: ke, fireSell: Ae } = v.confirm({
				passBuy: De,
				passSell: Oe,
				colourOkBuy: ye,
				colourOkSell: be,
				pullbackBuy: I,
				pullbackSell: xe,
				fastAboveSlow: c > l,
				fastBelowSlow: c < l,
				mode: t.f3Mode
			}), z = r.close, B = ke ? Se : Ce, V = Math.abs(z - B), H = ke ? z + V * t.tp1R : z - V * t.tp1R, je = ke ? z + V * t.tp2R : z - V * t.tp2R, Me = ke && V > 0;
			return Me || Ae && V > 0 ? (x.push(oe(n, r, Me, {
				stop: B,
				risk: V,
				t1: H,
				t2: je
			})), x.length > Aa && x.shift(), y.open({
				direction: Me ? 1 : -1,
				entry: z,
				stop: B,
				t1: H,
				t2: je,
				barIndex: n
			})) : y.confirm(r.high, r.low), S = n, w = m, T = c, E = l, D = ge, O = a, C = P(r, c, l, m, ce), C;
		},
		lastBar: (e, t) => S !== null && C !== null && e <= S ? C : (O = T > E, P(t, u.preview(t.close), d.preview(t.close), f.preview(t.close), N(t, !1))),
		lastConfirmedIndex: () => S,
		chartTrend: () => O,
		signals: () => [...x],
		levels: () => _.levels().map((e) => ({
			type: "line",
			x1: e.fromIndex,
			y1: e.price,
			x2: e.fromIndex + c,
			y2: e.price,
			color: Y(e.below ? i.bear : i.bull, 55),
			style: "dashed",
			width: 1,
			extendRight: !0
		})),
		ladder: (e) => {
			let n = y.state();
			if (!t.showLadder || n === null || e - n.barIndex > ka) return [];
			let a = e + t.stripLen, o = i.bull, s = n.live ? 0 : 55, c = (e, t, r) => ({
				type: "box",
				left: n.barIndex,
				top: Math.max(n.entry, e),
				right: a,
				bottom: Math.min(n.entry, e),
				border: Y(t, 100),
				fill: Y(t, r)
			}), l = () => n.stopped ? r.closedAtStop : r.closedAtTarget(n.hit), u = [
				{
					price: n.t2,
					name: r.ladderTp2,
					hex: o,
					isHit: n.hit >= 2,
					isEntry: !1
				},
				{
					price: n.t1,
					name: r.ladderTp1,
					hex: o,
					isHit: n.hit >= 1,
					isEntry: !1
				},
				{
					price: n.entry,
					name: r.ladderEntry,
					hex: i.neutral,
					isHit: !1,
					isEntry: !0
				},
				{
					price: n.stop,
					name: r.ladderStop,
					hex: i.bear,
					isHit: !1,
					isEntry: !1
				}
			], d = [c(n.t2, o, n.live ? 88 : 95), c(n.stop, i.bear, n.live ? 86 : 95)], f = (e) => e.isEntry && !n.live ? l() : `${e.name}  ${M(e.price)}${e.isHit ? "  ✓" : ""}`;
			for (let e of u) d.push({
				type: "line",
				x1: n.barIndex,
				y1: e.price,
				x2: a,
				y2: e.price,
				color: Y(e.hex, s),
				style: e.isEntry ? "solid" : "dashed",
				width: e.isEntry ? 2 : 1,
				extendRight: !1
			}), d.push({
				type: "label",
				x: a,
				y: e.price,
				yloc: "price",
				text: f(e),
				style: "label_left",
				color: Y(e.hex, 20 + s / 2),
				textColor: Y(Vi.white, 0),
				size: Fa[t.panelSize]
			});
			return d;
		},
		panels: (e, a, o) => {
			let s = S === null || e > S, c = {
				goodVolume: re(a.time),
				close: a.close,
				emaLong: s ? f.preview(a.close) : w,
				skipped: j,
				lastIndex: e
			};
			return {
				positions: {
					trend: t.trendPos,
					rightNow: t.tablePos,
					guide: t.guidePos
				},
				trend: t.showTable ? Ca(n.ticker, o, t, i, r) : null,
				rightNow: t.showClock ? wa(c, o, t, i, r) : null,
				guide: t.showGuide ? Ta(t, i, r) : null,
				close: a.close,
				palette: i,
				size: t.panelSize
			};
		}
	};
}, Ha = [
	{
		key: "m1",
		resolution: "1",
		minutes: 1
	},
	{
		key: "m5",
		resolution: "5",
		minutes: 5
	},
	{
		key: "m15",
		resolution: "15",
		minutes: 15
	},
	{
		key: "m30",
		resolution: "30",
		minutes: 30
	},
	{
		key: "h4",
		resolution: "240",
		minutes: 240
	},
	{
		key: "d1",
		resolution: "1D",
		minutes: 1440
	}
], Ua = 6e4, Wa = 864e5, Ga = 15, Ka = 3e3, qa = 4e4, Ja = 300, Ya = (e, t) => {
	let n = $e(t), r = /^(\d+)M$/.exec(n);
	if (r && Number(r[1]) > 0) {
		let t = new Date(e);
		return Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + Number(r[1]), 1);
	}
	return e + tt(n) * 1e3;
}, Xa = (e, t) => {
	let n = zi(e), r = zi(t), i = NaN, a = NaN, o = NaN;
	return {
		advance() {
			a = n.confirm(i), o = r.confirm(i);
		},
		read(e) {
			return i = e, a > o;
		}
	};
}, Za = (e, t) => {
	let n = e * 60;
	return n === t ? "same" : n > t ? "higher" : "lower";
}, Qa = (e, t, n, r, i) => e === "same" ? t : e === "lower" || i ? n - 1 : n - r * Ua, $a = (e, t, n, r, i) => {
	if (!e.isReady()) return !1;
	let a = e.slot(t);
	if (!a || !a.hasHistory()) return !1;
	let o = a.indexAt(n);
	return o < 0 ? !1 : a.series("auraTrend", `${r}:${i}`, () => Xa(r, i))[o] ?? !1;
}, eo = (e, t, n, r) => e.key === "d1" && n - t <= Wa ? r(Math.floor(t / 1e3)) * Wa : n - 1, to = (e, t) => {
	let n = Math.ceil(e * t / Ga) + Ja;
	return Math.min(Math.max(n, Ka), qa);
}, Z = (e, t) => {
	let n = Number(e);
	return Number.isFinite(n) ? n : t;
}, no = (e, t) => e == null || !Number.isFinite(e) ? t : e, ro = /* @__PURE__ */ "emaFastLen.emaSlowLen.longMode.tz.f1Clock.f2Trend.f3Mode.f4Sep.f4Min.f5Clear.f6Reward.f6R.f7Consol.f7Pips.f7Bars.f9Star.f9Bars.pipIn.slMinPips.tp1R.tp2R.theme.showTable.showClock.showTint.showPoc.showSr.showStars.tablePos.trendPos.guidePos.panelSize.showGuide.showWhy.showLadder.stripLen.srLookback.srAtrMove.srReset.srMax.srRange".split(".");
ro.length;
var io = ["Literal 238", "Auto-scale"], ao = [
	"Reject",
	"Wait for pullback",
	"Ignore"
], oo = ["Dark", "Light"], so = [
	"Small",
	"Normal",
	"Large"
], co = (e) => {
	let t = e("auraScanner.groups.signalEngine"), n = e("auraScanner.groups.eightChecks"), r = e("auraScanner.groups.riskAndTargets"), i = e("auraScanner.groups.display"), a = {
		"Top left": e("auraScanner.options.topLeft"),
		"Top centre": e("auraScanner.options.topCentre"),
		"Top right": e("auraScanner.options.topRight"),
		"Middle left": e("auraScanner.options.middleLeft"),
		"Middle centre": e("auraScanner.options.middleCentre"),
		"Middle right": e("auraScanner.options.middleRight"),
		"Bottom left": e("auraScanner.options.bottomLeft"),
		"Bottom centre": e("auraScanner.options.bottomCentre"),
		"Bottom right": e("auraScanner.options.bottomRight")
	}, o = (e, t, n, r) => ({
		id: e,
		name: t,
		type: "bool",
		defval: X[e],
		group: n,
		...r === void 0 ? {} : { tooltip: r }
	}), s = (e, t) => ({
		id: e,
		name: t,
		type: "text",
		defval: X[e],
		options: Qi,
		optionsTitles: a,
		group: i
	});
	return [
		{
			id: "emaFastLen",
			name: e("auraScanner.inputs.emaFastLen"),
			type: "integer",
			defval: X.emaFastLen,
			min: 2,
			group: t
		},
		{
			id: "emaSlowLen",
			name: e("auraScanner.inputs.emaSlowLen"),
			type: "integer",
			defval: X.emaSlowLen,
			min: 3,
			group: t
		},
		{
			id: "longMode",
			name: e("auraScanner.inputs.longMode"),
			type: "text",
			defval: X.longMode,
			options: io,
			optionsTitles: {
				"Literal 238": e("auraScanner.options.literal238"),
				"Auto-scale": e("auraScanner.options.autoScale")
			},
			group: t,
			tooltip: e("auraScanner.tooltip.longMode")
		},
		{
			id: "tz",
			name: e("auraScanner.inputs.tz"),
			type: "text",
			defval: X.tz,
			group: t,
			tooltip: e("auraScanner.tooltip.tz")
		},
		o("f1Clock", e("auraScanner.inputs.f1Clock"), n),
		o("f2Trend", e("auraScanner.inputs.f2Trend"), n),
		{
			id: "f3Mode",
			name: e("auraScanner.inputs.f3Mode"),
			type: "text",
			defval: X.f3Mode,
			options: ao,
			optionsTitles: {
				Reject: e("auraScanner.options.reject"),
				"Wait for pullback": e("auraScanner.options.waitForPullback"),
				Ignore: e("auraScanner.options.ignore")
			},
			group: n,
			tooltip: e("auraScanner.tooltip.f3Mode")
		},
		o("f4Sep", e("auraScanner.inputs.f4Sep"), n),
		{
			id: "f4Min",
			name: e("auraScanner.inputs.f4Min"),
			type: "float",
			defval: X.f4Min,
			min: 0,
			step: .5,
			group: n,
			tooltip: e("auraScanner.tooltip.f4Min")
		},
		o("f5Clear", e("auraScanner.inputs.f5Clear"), n),
		o("f6Reward", e("auraScanner.inputs.f6Reward"), n, e("auraScanner.tooltip.f6Reward")),
		{
			id: "f6R",
			name: e("auraScanner.inputs.f6R"),
			type: "float",
			defval: X.f6R,
			min: .5,
			step: .5,
			group: n
		},
		o("f7Consol", e("auraScanner.inputs.f7Consol"), n),
		{
			id: "f7Pips",
			name: e("auraScanner.inputs.f7Pips"),
			type: "float",
			defval: X.f7Pips,
			min: 1,
			step: 5,
			group: n,
			tooltip: e("auraScanner.tooltip.f7Pips")
		},
		{
			id: "f7Bars",
			name: e("auraScanner.inputs.f7Bars"),
			type: "integer",
			defval: X.f7Bars,
			min: 5,
			max: 300,
			group: n
		},
		o("f9Star", e("auraScanner.inputs.f9Star"), n),
		{
			id: "f9Bars",
			name: e("auraScanner.inputs.f9Bars"),
			type: "integer",
			defval: X.f9Bars,
			min: 1,
			max: 60,
			group: n
		},
		{
			id: "pipIn",
			name: e("auraScanner.inputs.pipIn"),
			type: "float",
			defval: X.pipIn,
			min: 0,
			step: 1e-4,
			group: r,
			tooltip: e("auraScanner.tooltip.pipIn")
		},
		{
			id: "slMinPips",
			name: e("auraScanner.inputs.slMinPips"),
			type: "float",
			defval: X.slMinPips,
			min: 0,
			step: 1,
			group: r,
			tooltip: e("auraScanner.tooltip.slMinPips")
		},
		{
			id: "tp1R",
			name: e("auraScanner.inputs.tp1R"),
			type: "float",
			defval: X.tp1R,
			min: .25,
			step: .25,
			group: r
		},
		{
			id: "tp2R",
			name: e("auraScanner.inputs.tp2R"),
			type: "float",
			defval: X.tp2R,
			min: .5,
			step: .25,
			group: r
		},
		{
			id: "theme",
			name: e("auraScanner.inputs.theme"),
			type: "text",
			defval: X.theme,
			options: oo,
			optionsTitles: {
				Dark: e("auraScanner.options.dark"),
				Light: e("auraScanner.options.light")
			},
			group: i,
			tooltip: e("auraScanner.tooltip.theme")
		},
		o("showTable", e("auraScanner.inputs.showTable"), i),
		o("showClock", e("auraScanner.inputs.showClock"), i),
		o("showTint", e("auraScanner.inputs.showTint"), i),
		o("showPoc", e("auraScanner.inputs.showPoc"), i),
		o("showSr", e("auraScanner.inputs.showSr"), i),
		o("showStars", e("auraScanner.inputs.showStars"), i),
		s("tablePos", e("auraScanner.inputs.tablePos")),
		s("trendPos", e("auraScanner.inputs.trendPos")),
		s("guidePos", e("auraScanner.inputs.guidePos")),
		{
			id: "panelSize",
			name: e("auraScanner.inputs.panelSize"),
			type: "text",
			defval: X.panelSize,
			options: so,
			optionsTitles: {
				Small: e("auraScanner.options.small"),
				Normal: e("auraScanner.options.normal"),
				Large: e("auraScanner.options.large")
			},
			group: i
		},
		o("showGuide", e("auraScanner.inputs.showGuide"), i, e("auraScanner.tooltip.showGuide")),
		o("showWhy", e("auraScanner.inputs.showWhy"), i, e("auraScanner.tooltip.showWhy")),
		o("showLadder", e("auraScanner.inputs.showLadder"), i, e("auraScanner.tooltip.showLadder")),
		{
			id: "stripLen",
			name: e("auraScanner.inputs.stripLen"),
			type: "integer",
			defval: X.stripLen,
			min: 6,
			max: 80,
			group: i
		},
		{
			id: "srLookback",
			name: e("auraScanner.inputs.srLookback"),
			type: "integer",
			defval: X.srLookback,
			min: 5,
			group: i
		},
		{
			id: "srAtrMove",
			name: e("auraScanner.inputs.srAtrMove"),
			type: "float",
			defval: X.srAtrMove,
			min: .1,
			step: .1,
			group: i
		},
		{
			id: "srReset",
			name: e("auraScanner.inputs.srReset"),
			type: "integer",
			defval: X.srReset,
			min: 2,
			group: i
		},
		{
			id: "srMax",
			name: e("auraScanner.inputs.srMax"),
			type: "integer",
			defval: X.srMax,
			min: 1,
			max: 30,
			group: i,
			tooltip: e("auraScanner.tooltip.srMax")
		},
		{
			id: "srRange",
			name: e("auraScanner.inputs.srRange"),
			type: "float",
			defval: X.srRange,
			min: 1,
			step: .5,
			group: i
		},
		{
			id: "frameRevision",
			name: "Frame revision",
			type: "integer",
			defval: 0,
			min: 0,
			max: 1e6,
			isHidden: !0
		}
	];
}, lo = (e, t, n) => t.find((t) => t === e) ?? n, uo = (e) => {
	let t = (t) => e(ro.indexOf(t)), n = (e) => Z(t(e), X[e]), r = (e) => {
		let n = t(e);
		return typeof n == "boolean" ? n : X[e];
	}, i = (e) => lo(t(e), Qi, X[e]), a = t("tz");
	return {
		emaFastLen: n("emaFastLen"),
		emaSlowLen: n("emaSlowLen"),
		longMode: lo(t("longMode"), io, X.longMode),
		tz: typeof a == "string" && a.trim() !== "" ? a : X.tz,
		f1Clock: r("f1Clock"),
		f2Trend: r("f2Trend"),
		f3Mode: lo(t("f3Mode"), ao, X.f3Mode),
		f4Sep: r("f4Sep"),
		f4Min: n("f4Min"),
		f5Clear: r("f5Clear"),
		f6Reward: r("f6Reward"),
		f6R: n("f6R"),
		f7Consol: r("f7Consol"),
		f7Pips: n("f7Pips"),
		f7Bars: n("f7Bars"),
		f9Star: r("f9Star"),
		f9Bars: n("f9Bars"),
		pipIn: n("pipIn"),
		slMinPips: n("slMinPips"),
		tp1R: n("tp1R"),
		tp2R: n("tp2R"),
		theme: lo(t("theme"), oo, X.theme),
		showTable: r("showTable"),
		showClock: r("showClock"),
		showTint: r("showTint"),
		showPoc: r("showPoc"),
		showSr: r("showSr"),
		showStars: r("showStars"),
		tablePos: i("tablePos"),
		trendPos: i("trendPos"),
		guidePos: i("guidePos"),
		panelSize: lo(t("panelSize"), so, X.panelSize),
		showGuide: r("showGuide"),
		showWhy: r("showWhy"),
		showLadder: r("showLadder"),
		stripLen: n("stripLen"),
		srLookback: n("srLookback"),
		srAtrMove: n("srAtrMove"),
		srReset: n("srReset"),
		srMax: n("srMax"),
		srRange: n("srRange")
	};
}, fo = (e, t, n) => {
	let r = (e) => e <= n ? {
		time: t[e],
		after: 0
	} : {
		time: t[n],
		after: e - n
	};
	return e.map((e) => {
		switch (e.type) {
			case "label": return {
				...e,
				x: r(e.x)
			};
			case "line": return {
				...e,
				x1: r(e.x1),
				x2: r(e.x2)
			};
			default: return {
				...e,
				left: r(e.left),
				right: r(e.right)
			};
		}
	});
}, po = "Aura Scanner", mo = 1e4, ho = 22, go = (e) => ({
	buy: e("auraScanner.signal.buy"),
	sell: e("auraScanner.signal.sell"),
	stop: e("auraScanner.signal.stop"),
	pips: e("auraScanner.signal.pips"),
	ladderTp1: e("auraScanner.ladder.tp1"),
	ladderTp2: e("auraScanner.ladder.tp2"),
	ladderEntry: e("auraScanner.ladder.entry"),
	ladderStop: e("auraScanner.ladder.stop"),
	closedAtStop: e("auraScanner.ladder.closedAtStop"),
	closedAtTarget: (t) => e("auraScanner.ladder.closedAtTarget", { hit: t }),
	trendUp: e("auraScanner.trendTable.up"),
	trendDown: e("auraScanner.trendTable.down"),
	volumeLine: e("auraScanner.trendTable.volumeLine"),
	above: e("auraScanner.trendTable.above"),
	below: e("auraScanner.trendTable.below"),
	notAvailable: e("auraScanner.trendTable.notAvailable"),
	rightNow: e("auraScanner.rightNow.title"),
	goodVolume: e("auraScanner.rightNow.goodVolume"),
	lowVolume: e("auraScanner.rightNow.lowVolume"),
	trend: e("auraScanner.rightNow.trend"),
	trendSummary: (t, n) => e(t ? "auraScanner.rightNow.trendSummaryUp" : "auraScanner.rightNow.trendSummaryDown", { agree: n }),
	bestNow: e("auraScanner.rightNow.bestNow"),
	bestWaitThin: e("auraScanner.rightNow.bestWaitThin"),
	bestBuysOnly: e("auraScanner.rightNow.bestBuysOnly"),
	bestSellsOnly: e("auraScanner.rightNow.bestSellsOnly"),
	safetyLine: e("auraScanner.rightNow.safetyLine"),
	safetyBelow: e("auraScanner.rightNow.safetyBelow"),
	safetyAbove: e("auraScanner.rightNow.safetyAbove"),
	skipped: e("auraScanner.rightNow.skipped"),
	skippedNothing: e("auraScanner.rightNow.skippedNothing"),
	aBuy: e("auraScanner.rightNow.aBuy"),
	aSell: e("auraScanner.rightNow.aSell"),
	skippedAgo: (t, n, r) => e("auraScanner.rightNow.skippedAgo", {
		count: n,
		side: t,
		bars: n,
		reason: r
	}),
	reasons: [
		e("auraScanner.reasons.clock"),
		e("auraScanner.reasons.trend"),
		e("auraScanner.reasons.wrongColour"),
		e("auraScanner.reasons.separation"),
		e("auraScanner.reasons.safetyLine"),
		e("auraScanner.reasons.room"),
		e("auraScanner.reasons.range"),
		e("auraScanner.reasons.diamond")
	],
	legendTitle: e("auraScanner.guide.title"),
	legendSubtitle: e("auraScanner.guide.subtitle"),
	legendRows: [
		{
			mark: e("auraScanner.guide.pinkMark"),
			meaning: e("auraScanner.guide.pinkMeaning")
		},
		{
			mark: e("auraScanner.guide.blueMark"),
			meaning: e("auraScanner.guide.blueMeaning")
		},
		{
			mark: e("auraScanner.guide.thickGoldMark"),
			meaning: e("auraScanner.guide.thickGoldMeaning")
		},
		{
			mark: e("auraScanner.guide.flatGoldMark"),
			meaning: e("auraScanner.guide.flatGoldMeaning")
		},
		{
			mark: e("auraScanner.guide.dashedMark"),
			meaning: e("auraScanner.guide.dashedMeaning")
		},
		{
			mark: e("auraScanner.guide.diamondsMark"),
			meaning: e("auraScanner.guide.diamondsMeaning")
		},
		{
			mark: e("auraScanner.guide.bigDiamondMark"),
			meaning: e("auraScanner.guide.bigDiamondMeaning")
		},
		{
			mark: e("auraScanner.guide.triangleMark"),
			meaning: e("auraScanner.guide.triangleMeaning")
		},
		{
			mark: e("auraScanner.guide.levelsMark"),
			meaning: e("auraScanner.guide.levelsMeaning")
		}
	]
}), _o = [
	{
		id: "starSmallHigh",
		title: "Star small high",
		color: "star1",
		size: "auto",
		offset: -2
	},
	{
		id: "starSmallLow",
		title: "Star small low",
		color: "star1",
		size: "auto",
		offset: -2
	},
	{
		id: "starMediumHigh",
		title: "Star medium high",
		color: "star2",
		size: "tiny",
		offset: -5
	},
	{
		id: "starMediumLow",
		title: "Star medium low",
		color: "star2",
		size: "tiny",
		offset: -5
	},
	{
		id: "starLargeRed",
		title: "Star large red",
		color: "bear",
		size: "small",
		offset: -10
	},
	{
		id: "starLargeGreen",
		title: "Star large green",
		color: "bull",
		size: "small",
		offset: -10
	}
], vo = (e, t, n, r) => {
	let i = R.getFixedT(r || "en", F), a = co(i), o = go(i), s = ta("Dark"), c = ta("Light"), l = [
		{
			id: "emaFast",
			title: "EMA fast",
			color: "fast",
			width: 2
		},
		{
			id: "emaSlow",
			title: "EMA slow",
			color: "slow",
			width: 2
		},
		{
			id: "emaLong",
			title: "EMA 238",
			color: "long",
			width: 3
		}
	], u = (e, t = 0) => [s[e], c[e]].map((e) => t === 0 ? e : p(e, t)), d = (e) => [
		s.slow,
		s.bear,
		c.slow,
		c.bear
	].map((t) => p(t, e)), f = {
		emaFast: u("fast"),
		emaSlow: u("slow"),
		emaLong: u("long"),
		tint: d(93),
		candle: d(20),
		poc: u("long", 20),
		...Object.fromEntries(_o.map((e) => [e.id, u(e.color)]))
	}, m = (e) => ({
		id: `${e}Color`,
		type: "colorer",
		target: e,
		palette: e
	}), h = (e, t, n = 0) => ({
		color: e,
		linewidth: t,
		linestyle: 0,
		plottype: n,
		trackPrice: !1,
		transparency: 0,
		visible: !0
	});
	return {
		name: po,
		metainfo: {
			_metainfoVersion: 51,
			id: "auraScanner@tv-basicstudies-1",
			name: po,
			description: po,
			shortDescription: "AURA",
			isCustomIndicator: !0,
			is_price_study: !0,
			format: { type: "inherit" },
			inputs: a,
			plots: [
				...l.flatMap((e) => [{
					id: e.id,
					type: "line"
				}, m(e.id)]),
				{
					id: "tint",
					type: "bg_colorer",
					palette: "tint"
				},
				{
					id: "candle",
					type: "bar_colorer",
					palette: "candle"
				},
				{
					id: "poc",
					type: "line"
				},
				m("poc"),
				..._o.flatMap((e) => [{
					id: e.id,
					type: "shapes"
				}, m(e.id)])
			],
			styles: {
				...Object.fromEntries(l.map((e) => [e.id, {
					title: e.title,
					histogramBase: 0
				}])),
				poc: {
					title: o.volumeLine,
					histogramBase: 0
				},
				...Object.fromEntries(_o.map((e) => [e.id, {
					title: e.title,
					...e.size === "auto" ? {} : { size: e.size }
				}]))
			},
			palettes: Object.fromEntries(Object.entries(f).map(([e, t]) => [e, {
				colors: t.map((e, n) => ({ name: t.length === 2 ? i(n === 0 ? "auraScanner.options.dark" : "auraScanner.options.light") : `${i(n < 2 ? "auraScanner.options.dark" : "auraScanner.options.light")} ${n % 2 == 0 ? o.trendUp : o.trendDown}` })),
				valToIndex: Object.fromEntries(t.map((e, t) => [t, t]))
			}])),
			defaults: {
				inputs: Object.fromEntries(a.map((e) => [e.id, e.defval])),
				palettes: Object.fromEntries(Object.entries(f).map(([e, t]) => [e, { colors: t.map((t) => ({
					color: t,
					width: l.find((t) => t.id === e)?.width ?? 1,
					style: 0
				})) }])),
				styles: {
					...Object.fromEntries(l.map((e) => [e.id, h(s[e.color], e.width)])),
					poc: h(p(s.long, 20), 1, 7),
					...Object.fromEntries(_o.map((e) => [e.id, {
						color: s[e.color],
						plottype: "shape_diamond",
						location: "Absolute",
						transparency: 0,
						visible: !0
					}]))
				}
			}
		},
		constructor: function() {
			let r = null, i = [], a = 0, s = 60, c = "1", l, u, d = !1, f = -1, p = -1, m = null, h = null, _ = null, v = null;
			this.init = function(t, y) {
				let b = uo(y), x = g(t, e.Std), S = t.symbol.info;
				s = tt(x.resolution), c = x.resolution, a = b.theme === "Dark" ? 0 : 1, i = [], d = !1, f = -1, p = -1, m = null, h = null, _ = null, v = null, l = Ht(S?.session, S?.timezone);
				let C = Ha.filter((e) => Za(e.minutes, s) !== "same"), w = C.filter((e) => e.key !== "m15"), T = n.acquire({
					symbol: x.symbol,
					frames: w.map((e) => ({
						resolution: e.resolution,
						symbol: null
					}))
				}), E = C.find((e) => e.key === "m15"), D = E ? n.acquire({
					symbol: x.symbol,
					frames: [{
						resolution: E.resolution,
						symbol: null,
						historyBars: to(mo, Math.max(Math.floor(s / 60), 1))
					}]
				}) : null;
				u = (e, t) => {
					let n = e.key === "m15" ? D : T, r = e.key === "m15" ? 1 : w.findIndex((t) => t.key === e.key) + 1;
					return n === null || r <= 0 ? !1 : $a(n, r, t, b.emaFastLen, b.emaSlowLen);
				}, r = Va({
					inputs: b,
					texts: o,
					symbol: {
						ticker: (S?.name || x.symbol).split(":").pop() || x.symbol,
						mintick: t.symbol.minTick ?? (S?.minmov / S?.pricescale || .01),
						resolutionSeconds: s
					},
					trend15: s === 900 ? "chart" : (e, t, n) => u(Ha[2], Qa(Za(15, s), t.time, Ya(t.time, c), 15, n))
				}), t.setMinimumAdditionalDepth(mo);
			};
			let y = (e) => {
				let t = (e) => Number.isNaN(e) ? NaN : e + a * 2, n = e.diamonds.flatMap((e, t) => Number.isNaN(e) ? [NaN, NaN] : [{
					value: e,
					offset: _o[t].offset
				}, a]);
				return [
					e.emaFast,
					a,
					e.emaSlow,
					a,
					e.emaLong,
					a,
					t(e.tint),
					t(e.candle),
					e.poc,
					Number.isNaN(e.poc) ? NaN : a,
					...n
				];
			};
			this.main = function(n) {
				let a = n.symbol.index, o = r;
				if (o === null || a < 0) return Array(ho).fill(NaN);
				let b = {
					time: e.Std.time(n),
					open: e.Std.open(n),
					high: e.Std.high(n),
					low: e.Std.low(n),
					close: e.Std.close(n),
					volume: e.Std.volume(n)
				}, x = n.symbol.isLastBar;
				i[a] = b.time / 1e3, x && ((!n.symbol.isBarClosed || d && a > f) && (p = a), d = !0, f = a);
				let S = x && p === a, C = null;
				if (n.symbol.isBarClosed && (C = o.confirmBar(a, b, S)), !x) return C === null ? Array(ho).fill(NaN) : y(C);
				C = o.lastBar(a, b, S);
				let w = g(n, e.Std), T = i[a], E = Object.fromEntries(Ha.map((e) => [e.key, Za(e.minutes, s) === "same" ? o.chartTrend() : u(e, eo(e, b.time, Ya(b.time, c), l))])), D = fo(o.signals(), i, a), O = fo(o.levels(), i, a), k = fo(o.ladder(a), i, a), ee = {
					model: o.panels(a, b, E),
					lastBarTime: b.time
				}, te = JSON.stringify(D), ne = JSON.stringify(O), A = JSON.stringify(k), j = JSON.stringify(ee);
				return te !== m && (m = te, t.onSignals({
					...w,
					time: T,
					objects: D
				})), ne !== h && (h = ne, t.onLevels({
					...w,
					time: T,
					objects: O
				})), A !== _ && (_ = A, t.onLadder({
					...w,
					time: T,
					objects: k
				})), j !== v && (v = j, t.onPanels({
					...w,
					...ee
				})), y(C);
			};
		}
	};
}, yo = {
	tiny: 8,
	small: 10,
	normal: 14,
	large: 20
}, bo = 12, xo = 23 - 22 / 2 - ht, So = "rgba(0, 0, 0, 0)", Co = (e) => p(e.hex, e.transparency), wo = (e, t) => e.after === 0 ? e.time : t(e.time, e.after), To = (e, t) => {
	let n = yo[e.size], r = Co(e.textColor);
	if (e.style === "label_left") {
		let t = Co(e.color);
		return [{
			kind: "tag",
			price: e.y,
			color: t,
			text: e.text,
			textColor: r,
			fontSize: n
		}, {
			kind: "pointer",
			price: e.y,
			color: t,
			size: bo
		}];
	}
	return [{
		kind: "plate",
		time: wo(e.x, t.barsAfter),
		price: e.y,
		text: e.text,
		color: So,
		textColor: r,
		fontSize: n,
		pointing: e.yloc === "belowbar" ? "up" : "down",
		tooltip: e.tooltip,
		anchor: {
			time: e.x.time,
			barsAfter: e.x.after
		},
		offsetPx: xo
	}];
}, Eo = (e, t) => {
	let { barsAfter: n } = t;
	switch (e.type) {
		case "label": return To(e, t);
		case "line": return [{
			kind: "line",
			price: e.y1,
			fromTime: wo(e.x1, n),
			toTime: wo(e.x2, n),
			color: Co(e.color),
			style: e.style,
			width: e.width,
			extendRight: e.extendRight
		}];
		default: return [{
			kind: "box",
			top: Math.max(e.top, e.bottom),
			bottom: Math.min(e.top, e.bottom),
			fromTime: wo(e.left, n),
			toTime: wo(e.right, n),
			fill: Co(e.fill),
			border: Co(e.border)
		}];
	}
}, Do = (e, t) => e.objects.flatMap((e) => Eo(e, t)), Oo = (e) => Pn({
	studyName: po,
	label: e,
	anchorsFor: (e, t, n, r) => {
		let i = t.objects.find((e) => e.type === "label" && e.style === "label_left");
		if (i?.type === "label") {
			let e = wo(i.x, r);
			return {
				labelTime: e,
				lineRight: e
			};
		}
		return jn(e, t, n);
	},
	specsFor: Do,
	reanchor: !1,
	themeAware: !1
}), ko = {
	tableBackground: "#ffffff",
	tableGrid: "#ebebeb",
	rowDivider: "#f2f2f2",
	textColor: "#0f0f0f",
	textMuted: "#707070",
	bullish: {
		text: "#06806b",
		textOnTint: "#056656",
		fill: "#089981",
		border: "#42bda8",
		tint: "#daf2ee",
		tintMedium: "#ace5dc"
	},
	bearish: {
		text: "#cc2f3c",
		textOnTint: "#b22833",
		fill: "#f23645",
		border: "#f77c80",
		tint: "#ffebec",
		tintMedium: "#fccbcd"
	},
	amber: {
		text: "#8c541c",
		textOnTint: "#8c541c",
		fill: "#ff9800",
		border: "#ffb74d",
		tint: "#fff3e0",
		tintMedium: "#ffe0b2"
	},
	blue: {
		text: "#2962ff",
		textOnTint: "#1848cc",
		fill: "#2962ff",
		border: "#5b9cf6",
		tint: "#e3effd",
		tintMedium: "#bbd9fb"
	},
	mutedFill: "#b8b8b8",
	panelShadow: "0 2px 4px #00000033",
	scrollbarThumb: "#9c9c9c"
}, Ao = {
	tableBackground: "#1f1f1f",
	tableGrid: "#4a4a4a",
	rowDivider: "#2e2e2e",
	textColor: "#dbdbdb",
	textMuted: "#8c8c8c",
	bullish: {
		text: "#22ab94",
		textOnTint: "#42bda8",
		fill: "#089981",
		border: "#056656",
		tint: "#082621",
		tintMedium: "#10443b"
	},
	bearish: {
		text: "#f7525f",
		textOnTint: "#f77c80",
		fill: "#f23645",
		border: "#b22833",
		tint: "#331f20",
		tintMedium: "#4d191d"
	},
	amber: {
		text: "#fbc02d",
		textOnTint: "#fbc02d",
		fill: "#ff9800",
		border: "#8c541c",
		tint: "#33261a",
		tintMedium: "#593a1b"
	},
	blue: {
		text: "#5b9cf6",
		textOnTint: "#5b9cf6",
		fill: "#2962ff",
		border: "#1848cc",
		tint: "#132042",
		tintMedium: "#142e61"
	},
	mutedFill: "#636363",
	panelShadow: "0 2px 4px #00000066",
	scrollbarThumb: "#3d3d3d"
}, jo = (e) => e === "light" ? ko : Ao, Q = {
	micro: {
		fontSize: 11,
		lineHeight: "16px"
	},
	data: {
		fontSize: 12,
		lineHeight: "16px"
	},
	value: {
		fontSize: 13,
		lineHeight: "18px"
	},
	body: {
		fontSize: 14,
		lineHeight: "18px"
	},
	title: {
		fontSize: 16,
		lineHeight: "24px"
	}
}, Mo = 10, No = 90, Po = 100, Fo = "max(120px, calc(100% - 100px))", Io = ({ accents: e, size: t }) => {
	let n = (e) => ({
		background: e,
		borderRadius: 2,
		transform: "rotate(45deg) scale(.82)"
	}), [r, i, a, o] = e;
	return /* @__PURE__ */ l("span", {
		style: {
			width: t,
			height: t,
			display: "grid",
			gridTemplateColumns: "1fr 1fr",
			gap: 2,
			flex: "0 0 auto"
		},
		children: [
			/* @__PURE__ */ c("i", { style: n(r) }),
			/* @__PURE__ */ c("i", { style: n(i) }),
			/* @__PURE__ */ c("i", { style: n(a) }),
			/* @__PURE__ */ c("i", { style: n(o) })
		]
	});
}, Lo = ({ dir: e, size: t = 14 }) => /* @__PURE__ */ c("svg", {
	width: t,
	height: t,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": "true",
	children: /* @__PURE__ */ c("path", { d: e === "up" ? "m18 15-6-6-6 6" : "m6 9 6 6 6-6" })
}), Ro = ({ mountTarget: e, theme: t, width: r, title: o, emblemAccents: s, emblemSize: f = 18, status: p, statusColor: m, children: h, "aria-label": g }) => {
	let [_, v] = a(!1), y = jo(t), b = i(null), { panelRef: x, handleRef: S, isDragging: C } = d({
		enabled: !0,
		initialPosition: "bottom-left",
		container: e,
		margin: {
			x: Mo,
			y: No
		}
	});
	return n(() => {
		let e = b.current;
		if (!e) return;
		let t = (t) => {
			e.scrollHeight > e.clientHeight && t.stopPropagation();
		};
		return e.addEventListener("wheel", t), () => e.removeEventListener("wheel", t);
	}, [_]), u(/* @__PURE__ */ l("div", {
		ref: x,
		role: "group",
		"aria-label": g,
		style: {
			position: "absolute",
			zIndex: Po,
			width: r,
			maxWidth: `calc(100% - ${Mo * 2}px)`,
			maxHeight: Fo,
			display: "flex",
			flexDirection: "column",
			userSelect: "none",
			WebkitUserSelect: "none",
			color: y.textColor,
			background: y.tableBackground,
			borderRadius: 6,
			overflow: "hidden",
			boxShadow: y.panelShadow
		},
		children: [/* @__PURE__ */ l("div", {
			ref: S,
			style: {
				flex: "0 0 auto",
				display: "flex",
				alignItems: "center",
				gap: 8,
				padding: "4px 4px 4px 8px",
				cursor: C ? "grabbing" : "grab"
			},
			children: [
				/* @__PURE__ */ c(Io, {
					accents: s,
					size: f
				}),
				/* @__PURE__ */ c("span", {
					style: {
						flex: "0 0 auto",
						...Q.body,
						fontWeight: 600,
						letterSpacing: ".4px",
						whiteSpace: "nowrap"
					},
					children: o
				}),
				/* @__PURE__ */ c("span", {
					style: {
						marginLeft: "auto",
						...Q.value,
						fontWeight: 600,
						color: m,
						whiteSpace: "nowrap",
						minWidth: 0,
						overflow: "hidden",
						textOverflow: "ellipsis"
					},
					children: p
				}),
				/* @__PURE__ */ c("button", {
					type: "button",
					onClick: () => v((e) => !e),
					"aria-expanded": !_,
					"aria-label": _ ? "Expand panel" : "Collapse panel",
					style: {
						width: 24,
						height: 24,
						border: 0,
						borderRadius: 4,
						background: "transparent",
						color: y.textMuted,
						display: "grid",
						placeItems: "center",
						flex: "0 0 auto",
						padding: 0,
						cursor: "pointer"
					},
					children: /* @__PURE__ */ c(Lo, { dir: _ ? "down" : "up" })
				})
			]
		}), !_ && /* @__PURE__ */ c("div", {
			ref: b,
			style: {
				flex: "1 1 auto",
				minHeight: 0,
				overflowY: "auto",
				overscrollBehavior: "contain",
				borderTop: `1px solid ${y.rowDivider}`,
				scrollbarWidth: "thin",
				scrollbarColor: `${y.scrollbarThumb} transparent`
			},
			children: h
		})]
	}), e);
}, zo = [
	{
		head: "15m",
		resolution: "15",
		minutes: 15,
		bars: 24
	},
	{
		head: "30m",
		resolution: "30",
		minutes: 30,
		bars: 12
	},
	{
		head: "1h",
		resolution: "60",
		minutes: 60,
		bars: 6
	}
], Bo = [
	NaN,
	NaN,
	NaN
], Vo = 32, Ho = 4 * 86400, Uo = ({ datafeed: e, onData: t }) => {
	let n = /* @__PURE__ */ new Map(), r = !0, i = async (i, a, o, s) => {
		let c = () => r && n.get(i) === a && a.frames[o].get(s.time) === s, l = zo[o];
		try {
			a.info ??= e.whenSymbolsReady().then((e) => e.get(i.toLowerCase())).catch(() => {
				a.info = null;
			});
			let n = await a.info;
			if (!n || !c()) return;
			let r = s.time / 1e3 + 1, o = l.bars + 1, u = r - l.minutes * 60 * o - Ho, d = await Mr(e, n, l.resolution, u, r, o);
			if (!c()) return;
			let f = /* @__PURE__ */ new Map();
			for (let e of d) Number.isFinite(e.time) && e.time <= s.time && f.set(e.time, e);
			let p = oa(Array.from(f.values()).sort((e, t) => e.time - t.time).slice(-o).map((e) => ({
				high: e.high ?? NaN,
				low: e.low ?? NaN,
				volume: e.volume ?? NaN
			})), l.bars);
			Object.is(s.value, p) || (s.value = p, t());
		} catch {}
	};
	return {
		sync: (e) => {
			if (!r) return;
			let t = new Set(e.map(Qe).filter(Boolean));
			for (let e of n.keys()) t.has(e) || n.delete(e);
			for (let e of t) n.has(e) || n.set(e, {
				frames: zo.map(() => /* @__PURE__ */ new Map()),
				info: null
			});
		},
		valuesFor: (e, t) => {
			let a = Qe(e), o = n.get(a);
			if (!r || !o || !Number.isFinite(t)) return Bo;
			let s = zo.map((e, n) => {
				let r = e.minutes * 6e4, s = Math.floor(t / r) * r, c = o.frames[n], l = c.get(s);
				if (l) return c.delete(s), c.set(s, l), l.value;
				let u = {
					time: s,
					value: NaN
				};
				if (c.set(s, u), c.size > Vo) {
					let e = c.keys().next().value;
					e !== void 0 && c.delete(e);
				}
				return i(a, o, n, u), NaN;
			});
			return [
				s[0],
				s[1],
				s[2]
			];
		},
		destroy: () => {
			r = !1, n.clear();
		}
	};
}, Wo = ".chart-markup-table.pane", Go = 100, Ko = {
	Small: {
		text: 8,
		head: 10
	},
	Normal: {
		text: 10,
		head: 14
	},
	Large: {
		text: 14,
		head: 20
	}
}, qo = (e, t, n) => {
	let r = e.model;
	if (!r.trend) return r;
	let i = r.trend.cells.map((e) => [...e]);
	return zo.forEach((e, a) => {
		i[2][a + 1] = Sa(e.head, t[a], r.close, r.palette, n);
	}), {
		...r,
		trend: {
			...r.trend,
			cells: i
		}
	};
}, Jo = (e) => p(e.hex, e.transparency), Yo = (e, t, n) => ({
	padding: "2px 5px",
	border: `1px solid ${n}`,
	whiteSpace: "nowrap",
	textAlign: e?.align ?? "center",
	color: e ? Jo(e.textColor) : void 0,
	background: e?.bg ? Jo(e.bg) : void 0,
	fontSize: Ko[t][e?.size ?? "text"],
	lineHeight: 1.25
}), Xo = ({ table: e, palette: t, size: n, mountTarget: a, language: o }) => {
	let s = i(null);
	r(() => {
		let t = s.current;
		if (!t) return;
		let n = () => {
			let n = a.getBoundingClientRect(), r = a.querySelector(Wo)?.getBoundingClientRect() ?? n, i = pa(e.position, {
				left: r.left - n.left,
				top: r.top - n.top,
				width: r.width,
				height: r.height
			}, {
				width: t.offsetWidth,
				height: t.offsetHeight
			}, 8);
			t.style.left = `${Math.max(0, i.left)}px`, t.style.top = `${Math.max(0, i.top)}px`;
		}, r = new ((a.ownerDocument.defaultView?.ResizeObserver) ?? window.ResizeObserver)(n);
		r.observe(a), r.observe(t);
		let i = a.querySelector(Wo);
		return i && r.observe(i), n(), () => r.disconnect();
	}, [a, e]);
	let l = o?.split(/[-_]/)[0] === "ar" ? "rtl" : "ltr", d = p(t.neutral, 55);
	return u(/* @__PURE__ */ c("div", {
		ref: s,
		role: "group",
		dir: "ltr",
		style: {
			position: "absolute",
			zIndex: Go,
			background: p(t.tableBg, 4),
			userSelect: "none",
			WebkitUserSelect: "none",
			pointerEvents: "none",
			fontVariantNumeric: "tabular-nums"
		},
		children: /* @__PURE__ */ c("table", {
			style: { borderCollapse: "collapse" },
			children: /* @__PURE__ */ c("tbody", { children: e.cells.map((e, t) => /* @__PURE__ */ c("tr", { children: e.map((e, t) => /* @__PURE__ */ c("td", {
				style: Yo(e, n, d),
				children: e && /* @__PURE__ */ c("span", {
					dir: l,
					children: e.text
				})
			}, t)) }, t)) })
		})
	}), a);
}, Zo = t(({ data: e, mountTarget: t, language: n }) => !e || !t ? null : /* @__PURE__ */ c(s, { children: ga(e).map((r) => /* @__PURE__ */ c(Xo, {
	table: r,
	palette: e.palette,
	size: e.size,
	mountTarget: t,
	language: n
}, r.position)) }));
Zo.displayName = "AuraScannerPanels";
//#endregion
//#region src/components/auraScanner/auraScannerIndicator.tsx
var Qo = class extends Xe {
	renderPanels = Ye(Zo);
	frames;
	signals;
	levels;
	ladder;
	poc;
	panels;
	tooltips;
	constructor(e, t) {
		super(e, t);
		let n = go(R.getFixedT(e.language || "en", F));
		this.frames = this.own(Mi({
			datafeed: e.datafeed,
			ticker: e.ticker,
			studyName: po
		})), this.signals = this.own(Oo("Aura Scanner signals")), this.levels = this.own(Oo("Aura Scanner levels")), this.ladder = this.own(Oo("Aura Scanner ladder")), this.poc = this.own(Uo({
			datafeed: e.datafeed,
			onData: () => this.panels.republish()
		})), this.panels = this.own(ft({
			studyName: po,
			onUpdate: this.publish,
			onLiveRoutesChanged: (e) => this.poc.sync(e.map((e) => e.symbol)),
			buildData: (e) => {
				let t = Ya(e.lastBarTime, e.resolution), r = Math.min(Date.now(), t - 1);
				return qo(e, this.poc.valuesFor(e.symbol, r), n);
			}
		})), this.tooltips = this.own(Or({
			label: "Aura Scanner tooltips",
			direction: e.language.split(/[-_]/)[0] === "ar" ? "rtl" : "ltr",
			platesFor: (e) => this.signals.shownPlates(e)
		}));
	}
	studies(e) {
		return [vo(e, {
			onSignals: this.signals.onSignal,
			onLevels: this.levels.onSignal,
			onLadder: this.ladder.onSignal,
			onPanels: this.panels.onSnapshot
		}, this.frames, this.ctx.language)];
	}
	onChartReady(e) {
		this.frames.attach(e), this.signals.attach(e), this.levels.attach(e), this.ladder.attach(e);
	}
	onDocumentReady(e, t) {
		this.panels.attach(e, t), this.tooltips.attach(e, t);
	}
}, $o = (e) => e, es = (e) => typeof e == "object" && !!e && !Array.isArray(e), ts = (e, t) => {
	let n = {};
	for (let [r, { entitlement: i }] of Object.entries(e)) i && (n[r] = t(i, r));
	return n;
}, ns = (e) => ts(e, (e) => ({
	isAllow: !1,
	preferences: e.denied
})), rs = (e) => ts(e, (e) => ({
	isAllow: !0,
	preferences: e.devPreview
})), is = (e, t) => {
	let n = ts(e, (e, n) => {
		let r = t?.[n];
		if (!es(r)) return {
			isAllow: !1,
			preferences: e.denied
		};
		let i = e.parse(r);
		return i === null ? (console.warn(`Entitlement "${n}" was granted with an unusable payload — treating as denied.`), {
			isAllow: !1,
			preferences: e.denied
		}) : {
			isAllow: !0,
			preferences: i
		};
	}), r = Object.keys(t ?? {}).filter((e) => !(e in n));
	return r.length && console.warn(`Preferences returned indicators this client cannot render: ${r.join(", ")}`), n;
}, as = (e, t, n) => e[t] ?? {
	isAllow: !1,
	preferences: n.denied
}, os = (e) => {
	try {
		return et(e);
	} catch {
		return "";
	}
}, ss = (e) => {
	let t = !0, n = null, r = null, i = /* @__PURE__ */ new Map(), a = (t, n) => {
		let r = 0;
		for (let i of n) try {
			t.removeEntity(i.id), r++;
		} catch (t) {
			console.warn(`Study policy guard: unable to remove ${e.studyName}`, t);
		}
		return r;
	}, o = (t, n) => {
		let r = ot(t, e.studyName, "Study policy guard");
		if (!r) return;
		let o = i.get(t);
		if (!r.length) {
			o && (o.warnedSymbol = null);
			return;
		}
		if (e.isIntendedSymbol) {
			let r = os(t);
			r && !e.isIntendedSymbol(r) ? (!o || o.warnedSymbol !== r) && (o && (o.warnedSymbol = r), e.onUnintendedSymbol?.(n, r)) : o && (o.warnedSymbol = null);
		}
		e.singleInstance && r.length > 1 && a(t, r.slice(1)) && e.onDuplicateRemoved?.(n);
	}, s = () => {
		let e = /* @__PURE__ */ new Set();
		at(n, (t) => {
			e.add(t);
		});
		for (let [t, n] of i) e.has(t) || (n.unsubscribe(), i.delete(t));
		for (let t of e) i.has(t) || i.set(t, {
			unsubscribe: lt(t, { onSymbolChanged: l }, "Study policy guard"),
			warnedSymbol: null
		});
	}, c = () => {
		!t || !n || (e.isIntendedSymbol && s(), at(n, o));
	}, l = () => {
		!t || r || (r = setTimeout(() => {
			r = null, c();
		}, 0));
	}, u = null;
	return {
		attach: (e) => {
			!t || n || (n = e, u = ct(n, ["study_event", "layout_changed"], l), l());
		},
		destroy: () => {
			if (t) {
				t = !1, r && clearTimeout(r), r = null, u?.(), u = null;
				for (let e of i.values()) e.unsubscribe();
				i.clear(), n = null;
			}
		}
	};
}, cs = [
	{
		symbol: null,
		resolution: "5"
	},
	{
		symbol: null,
		resolution: "15"
	},
	{
		symbol: null,
		resolution: "60"
	}
], ls = (e, t, n, r, i) => e < t - 1 ? NaN : e === t - 1 ? (i + n) / t : 2 * (n - r) / (t + 1) + r, us = (e) => {
	let t = 0, n = 0, r = NaN, i = NaN, a = NaN;
	return {
		advance() {
			t < e && (n += a), r = i, t++;
		},
		read(o) {
			return a = o, i = ls(t, e, o, r, n), i;
		}
	};
}, ds = (e) => {
	if (!e?.isReady()) return null;
	let t = cs.map((t, n) => e.slot(n + 1)).filter((e) => e?.hasHistory() === !0);
	return t.length === cs.length ? t : null;
}, fs = () => ({
	advance: () => void 0,
	read: (e) => e
}), ps = ({ slot: e, lengths: t, live: n, barTime: r, barSpanMs: i, frameMs: a, close: o }) => {
	let s = t.map((t) => e.series(`ema${t}`, "", () => us(t)));
	if (!n) return s.map((e) => e[e.length - 1] ?? NaN);
	let c = Number.isFinite(i) ? r + i - 1 : Infinity, l = e.indexAt(c), u = l >= 0 && e.indexAt(r - a) < l ? l : l + 1, d = e.series("close", "", fs);
	return t.map((e, t) => {
		let n = 0;
		if (u === e - 1) for (let e = 0; e < u; e++) n += d[e] ?? NaN;
		return ls(u, e, o, s[t]?.[u - 1] ?? NaN, n);
	});
}, ms = {
	e30: "#43A047",
	e50: "#FB8C00",
	e100: "#E53935",
	long: "#2E7D32",
	short: "#C62828",
	dot: "#FFBF00",
	near: "#EF9F27"
}, hs = {
	entry: "#9598A1",
	sl: "#C62828",
	be: "#FF394A",
	tp: "#00B39F"
}, gs = "BFS — Blessed Flow System", _s = [
	NaN,
	NaN,
	NaN
], vs = 864e5, ys = (e, t) => {
	if (!Number.isFinite(e)) return 0;
	let n = ((e + t * 36e5) % vs + vs) % vs;
	return Math.floor(n / 6e4);
}, bs = () => {
	let e = null, t = null;
	return (n) => (n !== e && (e = n, t = H(n)), t);
}, xs = (e, t, n, r) => {
	let i = R.getFixedT(r || "en", F), a = ms, o = hs, s = e.Std;
	return {
		name: gs,
		metainfo: {
			_metainfoVersion: 53,
			id: "BFSBlessedFlowSystem@tv-basicstudies-1",
			description: gs,
			shortDescription: "BFS",
			format: { type: "inherit" },
			is_price_study: !0,
			isCustomIndicator: !0,
			linkedToSeries: !0,
			plots: [
				{
					id: "e30",
					type: "line"
				},
				{
					id: "e50",
					type: "line"
				},
				{
					id: "e100",
					type: "line"
				},
				{
					id: "entry",
					type: "line"
				},
				{
					id: "sl",
					type: "line"
				},
				{
					id: "be",
					type: "line"
				},
				{
					id: "tp1",
					type: "line"
				},
				{
					id: "tp2",
					type: "line"
				},
				{
					id: "tp3",
					type: "line"
				},
				{
					id: "long",
					type: "shapes"
				},
				{
					id: "short",
					type: "shapes"
				},
				{
					id: "dot",
					type: "shapes"
				},
				{
					id: "pendLong",
					type: "shapes"
				},
				{
					id: "pendShort",
					type: "shapes"
				},
				{
					id: "near",
					type: "shapes"
				}
			],
			filledAreas: [{
				id: "risk",
				objAId: "entry",
				objBId: "sl",
				type: "plot_plot",
				title: i("bfs.riskZone"),
				fillgaps: !1
			}, {
				id: "reward",
				objAId: "entry",
				objBId: "tp3",
				type: "plot_plot",
				title: i("bfs.rewardZone"),
				fillgaps: !1
			}],
			styles: {
				e30: { title: "EMA 30" },
				e50: { title: "EMA 50" },
				e100: { title: "EMA 100" },
				entry: { title: i("entry") },
				sl: { title: i("sl") },
				be: { title: i("breakEven") },
				tp1: { title: i("tp", { n: 1 }) },
				tp2: { title: i("tp", { n: 2 }) },
				tp3: { title: i("tp", { n: 3 }) },
				long: {
					title: i("bfs.longSignal"),
					text: i("long").toUpperCase()
				},
				short: {
					title: i("bfs.shortSignal"),
					text: i("short").toUpperCase()
				},
				dot: {
					title: i("bfs.retracementDot"),
					text: "50%"
				},
				pendLong: {
					title: i("bfs.waitingRsiLong"),
					text: ""
				},
				pendShort: {
					title: i("bfs.waitingRsiShort"),
					text: ""
				},
				near: {
					title: i("bfs.emaCrossSoon"),
					text: ""
				}
			},
			defaults: {
				inputs: {
					lenFast: 30,
					lenMid: 50,
					lenSlow: 100,
					lenH1a: 30,
					lenH1b: 50,
					r1lb: 10,
					useR2: !1,
					useArm: !0,
					armWin: 5,
					swLenA: 3,
					useRSI: !1,
					rsiLen: 4,
					rsiWin: 5,
					rsiHi: 75,
					rsiLo: 25,
					useTrend: !0,
					showNear: !1,
					nearPts: 50,
					nearLb: 3,
					useSess: !1,
					londonSess: "0530-0700",
					nySess: "0930-1100",
					useAsia: !1,
					asiaSess: "2200-2330",
					tzOffset: -5,
					maxPerBlock: 0,
					cooldown: 15,
					pv: .01,
					slPts: 400,
					rr: 1,
					useBE: !0,
					bePts: 200,
					useLadder: !0,
					tp1Pts: 200,
					tp2Pts: 400,
					tp3Pts: 600,
					onlyM1: !0,
					showLevels: !0,
					[Di]: 0
				},
				filledAreasStyle: {
					risk: {
						color: o.sl,
						transparency: 86,
						visible: !0
					},
					reward: {
						color: o.tp,
						transparency: 88,
						visible: !0
					}
				},
				styles: {
					e30: {
						color: a.e30,
						linewidth: 1,
						linestyle: 0,
						plottype: 0,
						transparency: 10,
						visible: !0
					},
					e50: {
						color: a.e50,
						linewidth: 1,
						linestyle: 0,
						plottype: 0,
						transparency: 10,
						visible: !0
					},
					e100: {
						color: a.e100,
						linewidth: 2,
						linestyle: 0,
						plottype: 0,
						transparency: 0,
						visible: !0
					},
					entry: {
						color: o.entry,
						linewidth: 1,
						linestyle: 1,
						plottype: 7,
						transparency: 0,
						visible: !0,
						trackPrice: !1
					},
					sl: {
						color: o.sl,
						linewidth: 1,
						linestyle: 1,
						plottype: 7,
						transparency: 0,
						visible: !0,
						trackPrice: !1
					},
					be: {
						color: o.be,
						linewidth: 1,
						linestyle: 1,
						plottype: 7,
						transparency: 0,
						visible: !0,
						trackPrice: !1
					},
					tp1: {
						color: o.tp,
						linewidth: 1,
						linestyle: 1,
						plottype: 7,
						transparency: 10,
						visible: !0,
						trackPrice: !1
					},
					tp2: {
						color: o.tp,
						linewidth: 1,
						linestyle: 1,
						plottype: 7,
						transparency: 10,
						visible: !0,
						trackPrice: !1
					},
					tp3: {
						color: o.tp,
						linewidth: 1,
						linestyle: 1,
						plottype: 7,
						transparency: 0,
						visible: !0,
						trackPrice: !1
					},
					long: {
						color: a.long,
						textColor: a.long,
						plottype: "shape_triangle_up",
						location: "BelowBar",
						size: "small",
						transparency: 0,
						visible: !0
					},
					short: {
						color: a.short,
						textColor: a.short,
						plottype: "shape_triangle_down",
						location: "AboveBar",
						size: "small",
						transparency: 0,
						visible: !0
					},
					dot: {
						color: a.dot,
						textColor: a.dot,
						plottype: "shape_circle",
						location: "Absolute",
						size: "small",
						transparency: 30,
						visible: !0
					},
					pendLong: {
						color: a.long,
						textColor: a.long,
						plottype: "shape_circle",
						location: "BelowBar",
						size: "tiny",
						transparency: 40,
						visible: !0
					},
					pendShort: {
						color: a.short,
						textColor: a.short,
						plottype: "shape_circle",
						location: "AboveBar",
						size: "tiny",
						transparency: 40,
						visible: !0
					},
					near: {
						color: a.near,
						textColor: a.near,
						plottype: "shape_cross",
						location: "Absolute",
						size: "tiny",
						transparency: 20,
						visible: !0
					}
				}
			},
			inputs: [
				{
					id: "lenFast",
					name: i("bfs.input.lenFast"),
					type: "integer",
					defval: 30,
					min: 1,
					max: 5e3
				},
				{
					id: "lenMid",
					name: i("bfs.input.lenMid"),
					type: "integer",
					defval: 50,
					min: 1,
					max: 5e3
				},
				{
					id: "lenSlow",
					name: i("bfs.input.lenSlow"),
					type: "integer",
					defval: 100,
					min: 1,
					max: 5e3
				},
				{
					id: "lenH1a",
					name: i("bfs.input.lenH1a"),
					type: "integer",
					defval: 30,
					min: 1,
					max: 5e3
				},
				{
					id: "lenH1b",
					name: i("bfs.input.lenH1b"),
					type: "integer",
					defval: 50,
					min: 1,
					max: 5e3
				},
				{
					id: "r1lb",
					name: i("bfs.input.r1lb"),
					type: "integer",
					defval: 10,
					min: 1,
					max: 500
				},
				{
					id: "useR2",
					name: i("bfs.input.useR2"),
					type: "bool",
					defval: !1
				},
				{
					id: "useArm",
					name: i("bfs.input.useArm"),
					type: "bool",
					defval: !0
				},
				{
					id: "armWin",
					name: i("bfs.input.armWin"),
					type: "integer",
					defval: 5,
					min: 1,
					max: 500
				},
				{
					id: "swLenA",
					name: i("bfs.input.swLenA"),
					type: "integer",
					defval: 3,
					min: 1,
					max: 100
				},
				{
					id: "useRSI",
					name: i("bfs.input.useRSI"),
					type: "bool",
					defval: !1
				},
				{
					id: "rsiLen",
					name: i("bfs.input.rsiLen"),
					type: "integer",
					defval: 4,
					min: 1,
					max: 500
				},
				{
					id: "rsiWin",
					name: i("bfs.input.rsiWin"),
					type: "integer",
					defval: 5,
					min: 1,
					max: 500
				},
				{
					id: "rsiHi",
					name: i("bfs.input.rsiHi"),
					type: "float",
					defval: 75,
					min: 0,
					max: 100
				},
				{
					id: "rsiLo",
					name: i("bfs.input.rsiLo"),
					type: "float",
					defval: 25,
					min: 0,
					max: 100
				},
				{
					id: "useTrend",
					name: i("bfs.input.useTrend"),
					type: "bool",
					defval: !0
				},
				{
					id: "showNear",
					name: i("bfs.input.showNear"),
					type: "bool",
					defval: !1
				},
				{
					id: "nearPts",
					name: i("bfs.input.nearPts"),
					type: "float",
					defval: 50,
					min: 0,
					max: 1e5
				},
				{
					id: "nearLb",
					name: i("bfs.input.nearLb"),
					type: "integer",
					defval: 3,
					min: 1,
					max: 500
				},
				{
					id: "useSess",
					name: i("bfs.input.useSess"),
					type: "bool",
					defval: !1
				},
				{
					id: "londonSess",
					name: i("bfs.input.londonSess"),
					type: "text",
					defval: "0530-0700"
				},
				{
					id: "nySess",
					name: i("bfs.input.nySess"),
					type: "text",
					defval: "0930-1100"
				},
				{
					id: "useAsia",
					name: i("bfs.input.useAsia"),
					type: "bool",
					defval: !1
				},
				{
					id: "asiaSess",
					name: i("bfs.input.asiaSess"),
					type: "text",
					defval: "2200-2330"
				},
				{
					id: "tzOffset",
					name: i("bfs.input.tzOffset"),
					type: "integer",
					defval: -5,
					min: -12,
					max: 14
				},
				{
					id: "maxPerBlock",
					name: i("bfs.input.maxPerBlock"),
					type: "integer",
					defval: 0,
					min: 0,
					max: 1e3
				},
				{
					id: "cooldown",
					name: i("bfs.input.cooldown"),
					type: "integer",
					defval: 15,
					min: 0,
					max: 1e4
				},
				{
					id: "pv",
					name: i("bfs.input.pv"),
					type: "float",
					defval: .01,
					min: 1e-5,
					max: 1e3
				},
				{
					id: "slPts",
					name: i("bfs.input.slPts"),
					type: "integer",
					defval: 400,
					min: 1,
					max: 1e6
				},
				{
					id: "rr",
					name: i("bfs.input.rr"),
					type: "float",
					defval: 1,
					min: .1,
					max: 100
				},
				{
					id: "useBE",
					name: i("bfs.input.useBE"),
					type: "bool",
					defval: !0
				},
				{
					id: "bePts",
					name: i("bfs.input.bePts"),
					type: "integer",
					defval: 200,
					min: 1,
					max: 1e6
				},
				{
					id: "useLadder",
					name: i("bfs.input.useLadder"),
					type: "bool",
					defval: !0
				},
				{
					id: "tp1Pts",
					name: i("bfs.input.tp1Pts"),
					type: "integer",
					defval: 200,
					min: 1,
					max: 1e6
				},
				{
					id: "tp2Pts",
					name: i("bfs.input.tp2Pts"),
					type: "integer",
					defval: 400,
					min: 1,
					max: 1e6
				},
				{
					id: "tp3Pts",
					name: i("bfs.input.tp3Pts"),
					type: "integer",
					defval: 600,
					min: 1,
					max: 1e6
				},
				{
					id: "onlyM1",
					name: i("bfs.input.onlyM1"),
					type: "bool",
					defval: !0
				},
				{
					id: "showLevels",
					name: i("bfs.input.showLevels"),
					type: "bool",
					defval: !0
				},
				{
					id: Di,
					name: "Frame revision",
					type: "integer",
					defval: 0,
					min: 0,
					max: 1e6,
					isHidden: !0
				}
			]
		},
		constructor: function() {
			let e = NaN, r = null, i = null, a = bs(), o = bs(), c = bs();
			this.init = function(e, n) {
				this._context = e, this._input = n, i = null;
				let r = String(e.symbol?.info?.name ?? s.ticker(e));
				this._frames = t.acquire({
					symbol: r,
					frames: cs
				});
			}, this.main = function(t, l) {
				this._context = t, this._input = l;
				let u = Z(this._input(0), 30), d = Z(this._input(1), 50), f = Z(this._input(2), 100), p = Z(this._input(3), 30), m = Z(this._input(4), 50), h = Z(this._input(5), 10), _ = !!this._input(6), v = !!this._input(7), y = Z(this._input(8), 5), b = Z(this._input(9), 3), x = !!this._input(10), S = Z(this._input(11), 4), C = Z(this._input(12), 5), w = Z(this._input(13), 75), T = Z(this._input(14), 25), E = !!this._input(15), D = !!this._input(16), O = Z(this._input(17), 50), k = Z(this._input(18), 3), ee = !!this._input(19), te = String(this._input(20) ?? ""), ne = String(this._input(21) ?? ""), A = !!this._input(22), j = String(this._input(23) ?? ""), M = Z(this._input(24), -5), re = Z(this._input(25), 0), N = Z(this._input(26), 15), P = Z(this._input(27), .01), ie = Z(this._input(28), 400), ae = Z(this._input(29), 1), oe = !!this._input(30), se = Z(this._input(31), 200), ce = !!this._input(32), le = Z(this._input(33), 200), F = Z(this._input(34), 400), ue = Z(this._input(35), 600), de = !!this._input(36), fe = !!this._input(37);
				t.setMinimumAdditionalDepth(Math.ceil(Math.max(f, h, 2 * b + 2, k, S)) + 10);
				let pe = s.close(t), me = s.high(t), he = s.low(t), ge = s.time(t), _e = ge !== e, ve = Math.max(h - 1, 1), ye = 2 * b, be = t.new_var(pe), I = t.new_var(me), xe = t.new_var(he);
				be.get(ve), I.get(ye), xe.get(ye);
				let Se = t.new_var(pe), Ce = s.ema(Se, u, t), L = s.ema(Se, d, t), we = s.ema(Se, f, t), R = t.new_var(Math.min(Ce, L, we)), Te = t.new_var(Math.max(Ce, L, we));
				R.get(ve), Te.get(ve);
				let Ee = s.change(Se), De = t.new_var(Math.max(Ee, 0)), Oe = t.new_var(Math.max(-Ee, 0)), ke = s.rma(De, S, t), Ae = s.rma(Oe, S, t), z = s.na(ke) || s.na(Ae) ? NaN : Ae === 0 ? 100 : ke === 0 ? 0 : 100 - 100 / (1 + ke / Ae), B = s.n(t) === 1, V = (e) => {
					let t = e.get(1);
					return B ? 0 : t;
				}, H = t.new_var(Math.abs(Ce - L) / P), je = H.get(k), Ne = !s.na(je) && H.get(0) <= O && H.get(0) < je, Pe = V(t.new_var(+!!Ne)), Fe = Ne && Pe !== 1, Ie = !!t.symbol.isLastBar, Le = _ || Ie ? ds(this._frames) : null, Re = Le !== null, ze = t.symbol.resolution, Be = s.interval(t) * (ze === "" ? 6e4 : ze === "S" ? 1e3 : NaN), U = (e, t, n, r) => ps({
					slot: e[t],
					lengths: r,
					live: Ie,
					barTime: ge,
					barSpanMs: Be,
					frameMs: n * 6e4,
					close: pe
				}), [Ve, He, Ue] = Le ? U(Le, 0, 5, [
					u,
					d,
					f
				]) : _s, [We, Ge, Ke] = Le ? U(Le, 1, 15, [
					u,
					d,
					f
				]) : _s, [qe, Je] = Le ? U(Le, 2, 60, [p, m]) : _s, Ye = Re && Ve > He && He > Ue, Xe = Re && Ve < He && He < Ue, Ze = Re && We > Ge && Ge > Ke, Qe = Re && We < Ge && Ge < Ke, $e = Re && qe > Je, W = Re && qe < Je, et = !_ || Ye && Ze && $e, tt = !_ || Xe && Qe && W, nt = ee || Ie, rt = nt ? ys(ge, M) : 0, it = nt && Me(rt, a(te)), at = nt && Me(rt, o(ne)), ot = nt && A && Me(rt, c(j)), st = !ee || it || at || ot, ct = t.new_var(), lt = t.new_var(), ut = t.new_var(), dt = t.new_var(), G = t.new_var(), ft = t.new_var(), pt = t.new_var(), mt = t.new_var(), ht = t.new_var(), gt = t.new_var(), _t = t.new_var(), vt = t.new_var(), yt = t.new_var(), bt = t.new_var(), xt = t.new_var(), St = t.new_var(), Ct = t.new_var(), wt = t.new_var(), Tt = V(ct), Et = s.na(Tt) ? 0 : Tt + 1, Dt = no(V(lt), 0), Ot = V(ut), kt = Dt ? Ot : NaN, At = V(dt), jt = V(G), Mt = V(ft), Nt = no(V(pt), 0) === 1, Pt = no(V(mt), 0) === 1, Ft = no(V(ht), 0), It = no(V(gt), 0), Lt = no(V(_t), 0), Rt = no(V(vt), 0), zt = no(V(yt), -1e5), Bt = no(V(bt), 0), Vt = V(xt), Ht = no(V(St), 0) === 1, Ut = V(Ct), Wt = V(wt), Gt = Dt !== 0;
				i === null && Number.isFinite(ge) && (i = g(t, s));
				let Kt = i ?? g(t, s), qt = Kt.resolution.trim().toUpperCase(), Jt = !de || qt === "1" || qt === "1S" || qt === "", K = Ce > L && L > we, Yt = Ce < L && L < we, Xt = s.n(t) >= h, Zt = Xt, Qt = Xt;
				for (let e = 0; Xt && e < h; e++) {
					let t = be.get(e), n = R.get(e), r = Te.get(e);
					if (s.na(t) || s.na(n) || s.na(r)) {
						Zt = !1, Qt = !1;
						break;
					}
					t < n && (Zt = !1), t > r && (Qt = !1);
				}
				let $t = he <= Ce && Ce <= me, en = NaN, tn = NaN, nn = b, rn = 2 * b, an = I.get(nn), q = xe.get(nn);
				if (s.n(t) > rn) {
					let e = !0, t = !0;
					for (let n = 0; n <= rn; n++) {
						if (n === nn) continue;
						let r = I.get(n), i = xe.get(n);
						if (s.na(r) || s.na(i)) {
							e = !1, t = !1;
							break;
						}
						r >= an && (e = !1), i <= q && (t = !1);
					}
					e && (en = an), t && (tn = q);
				}
				s.na(en) || (Ut = en), s.na(tn) || (Wt = tn);
				let on = s.na(Ut) || s.na(Wt) ? NaN : (Ut + Wt) / 2, sn = be.get(1), cn = Yt && !s.na(on) && !s.na(sn) && pe > on && sn <= on, ln = K && !s.na(on) && !s.na(sn) && pe < on && sn >= on;
				(st && !Ht || !st) && (Bt = 0);
				let un = (s.na(Vt) ? 1e6 : Et - Vt) > N, dn = !(ee && re > 0 && Bt >= re) && un, fn = !v || Lt === 1 && Rt === 1 && Et <= zt + y, pn = !v || Lt === 1 && Rt === -1 && Et <= zt + y, mn = Jt && K && Zt && et && st && $t && dn && fn && !Gt && !Pt, hn = Jt && Yt && Qt && tt && st && $t && dn && pn && !Gt && !Pt && !mn, gn = !1, _n = !1, vn = !1;
				if (Jt && (v && (Lt === 1 && (Rt === -1 && !Yt || Rt === 1 && !K) && (Lt = 0), Lt === 1 && Et > zt + y && (Lt = 2), Lt !== 1 && !Gt && (cn || ln) && (Rt = ln ? 1 : -1, zt = Et, Lt = 1, vn = !0)), Gt && (oe && !Nt && (Dt === 1 ? me >= Mt : he <= Mt) && (Nt = !0, At = Mt), ((Dt === 1 ? he <= At : me >= At) || (Dt === 1 ? me >= jt : he <= jt)) && (Dt = 0, Gt = !1, Vt = Et)), !Gt)) {
					let e = !1, t = !1;
					if (x ? (Pt && (E && !(Ft === 1 ? K : Yt) ? Pt = !1 : Ft === 1 && !s.na(z) && z <= T ? (e = !0, Pt = !1) : Ft === -1 && !s.na(z) && z >= w ? (t = !0, Pt = !1) : (--It, It <= 0 && (Pt = !1))), !Pt && !e && !t && (mn || hn) && (Pt = !0, Ft = mn ? 1 : -1, It = C)) : (e = mn, t = hn), e || t) {
						Dt = e ? 1 : -1, Gt = !0, kt = x ? pe : Ce, Nt = !1, v && (Lt = 0);
						let t = ce ? ue : Math.round(ie * ae);
						Dt === 1 ? (At = kt - ie * P, jt = kt + t * P, Mt = kt + se * P, gn = !0) : (At = kt + ie * P, jt = kt - t * P, Mt = kt - se * P, _n = !0), Bt += 1;
					}
				}
				Dt === 0 && (kt = NaN, At = NaN, jt = NaN, Mt = NaN, Nt = !1), ct.set(Et), lt.set(Dt), ut.set(kt), dt.set(At), G.set(jt), ft.set(Mt), pt.set(+!!Nt), mt.set(+!!Pt), ht.set(Ft), gt.set(It), _t.set(Lt), vt.set(Rt), yt.set(zt), bt.set(Bt), xt.set(Vt), St.set(+!!st), Ct.set(Ut), wt.set(Wt);
				let yn = Dt !== 0 && ce ? kt + Dt * le * P : NaN, bn = Dt !== 0 && ce ? kt + Dt * F * P : NaN, xn = Dt === 0 ? NaN : ce ? kt + Dt * ue * P : jt, Sn = fe && Dt !== 0, Cn = Sn ? kt : NaN, wn = Sn ? At : NaN, Tn = Sn && oe ? Mt : NaN, En = Sn ? yn : NaN, Dn = Sn ? bn : NaN, On = Sn ? xn : NaN, kn = x && Pt && Ft === 1 && It === C, An = x && Pt && Ft === -1 && It === C;
				if (n && Ie && (_e || Re !== r)) {
					let { symbol: e, resolution: t } = Kt;
					r = Re, n({
						symbol: e,
						resolution: t,
						engineOn: Jt,
						mtfReady: Re,
						h1: $e ? 1 : W ? -1 : 0,
						m15: Ze ? 1 : Qe ? -1 : 0,
						m5: Ye ? 1 : Xe ? -1 : 0,
						m1: K ? 1 : Yt ? -1 : 0,
						inSession: st,
						session: at ? "NY" : it ? "London" : ot ? "Asia" : st ? "open" : null,
						dir: Dt,
						pending: Pt,
						pendDir: Ft,
						pendLeft: It
					});
				}
				return e = ge, [
					Ce,
					L,
					we,
					Cn,
					wn,
					Tn,
					En,
					Dn,
					On,
					gn ? 1 : NaN,
					_n ? 1 : NaN,
					vn ? Ce : NaN,
					kn ? 1 : NaN,
					An ? 1 : NaN,
					D && Fe ? L : NaN
				];
			};
		}
	};
}, Ss = 4294967295, Cs = 0, ws = [{
	input: "useRSI",
	plots: ["pendLong", "pendShort"]
}, {
	input: "showNear",
	plots: ["near"]
}], Ts = ({ studyName: e }) => {
	let t = !0, n = null, r = null, i = null, a = /* @__PURE__ */ new Map(), o = (e, t) => `${String(e)}|${t}`, s = (e, t) => {
		let n = t.getInputValues(), r = t.getStyleValues().styles, i = {};
		for (let t of ws) {
			let s = !!n.find((e) => e.id === t.input)?.value, c = o(e, t.input), l = a.get(c);
			if (a.set(c, s), l === s || l === void 0 && s) continue;
			let u = s ? Ss : Cs;
			for (let e of t.plots) r[e]?.display !== u && (i[`styles.${e}.display`] = u);
		}
		return i;
	}, c = (t, n) => {
		let r = ot(t, e, "BFS marker visibility");
		if (r) for (let e of r) {
			for (let t of ws) n.add(o(e.id, t.input));
			try {
				let n = t.getStudyById(e.id);
				if (!n) continue;
				let r = s(e.id, n);
				Object.keys(r).length > 0 && n.applyOverrides(r);
			} catch (e) {
				console.warn("BFS marker visibility: unable to sync the markers", e);
			}
		}
	}, l = () => {
		if (!t || !n) return;
		let e = /* @__PURE__ */ new Set();
		at(n, (t) => c(t, e));
		for (let t of Array.from(a.keys())) e.has(t) || a.delete(t);
	}, u = () => {
		!t || i || (i = setTimeout(() => {
			i = null, l();
		}, 0));
	};
	return {
		attach: (e) => {
			!t || n || (n = e, r = ct(n, [
				"study_event",
				"study_properties_changed",
				"layout_changed"
			], u), u());
		},
		destroy: () => {
			t && (t = !1, i && clearTimeout(i), i = null, r?.(), r = null, n = null, a.clear());
		}
	};
}, Es = ({ studyName: e, onUpdate: t }) => ft({
	studyName: e,
	onUpdate: t
}), Ds = (e) => {
	let t = e.lastIndexOf(":");
	return (t === -1 ? e : e.slice(t + 1)).trim().toUpperCase();
}, Os = (e) => {
	let t = e.map((e) => e.toUpperCase());
	return (e) => {
		if (!e) return !1;
		let n = Ds(e);
		return t.some((e) => n.startsWith(e));
	};
}, ks = ["XAUUSD", "GOLD247"], As = Os(ks), js = {
	verticalAlign: "-.125em",
	flex: "0 0 auto"
}, Ms = {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": !0
}, Ns = ({ size: e = 12 }) => /* @__PURE__ */ c("svg", {
	width: e,
	height: e,
	style: js,
	...Ms,
	children: /* @__PURE__ */ c("path", { d: "M20 6 9 17l-5-5" })
}), Ps = ({ size: e = 12 }) => /* @__PURE__ */ l("svg", {
	width: e,
	height: e,
	style: js,
	...Ms,
	children: [
		/* @__PURE__ */ c("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }),
		/* @__PURE__ */ c("path", { d: "M12 9v4" }),
		/* @__PURE__ */ c("path", { d: "M12 17h.01" })
	]
}), Fs = 54, Is = 240, Ls = [
	"H1",
	"M15",
	"M5",
	"M1"
], Rs = t(({ data: e, mountTarget: t, theme: n = "dark", language: r }) => !e || !t ? null : /* @__PURE__ */ c(zs, {
	data: e,
	mountTarget: t,
	theme: n,
	language: r
}));
Rs.displayName = "BfsTable";
var zs = ({ data: e, mountTarget: t, theme: n, language: r }) => {
	let i = jo(n), a = R.getFixedT(r ?? "en", F), o = e.engineOn ? /* @__PURE__ */ l(s, { children: [
		a("bfs.engineOn"),
		" ",
		/* @__PURE__ */ c(Ns, {})
	] }) : /* @__PURE__ */ l(s, { children: [
		/* @__PURE__ */ c(Ps, {}),
		" ",
		a("bfs.engineOff")
	] }), u = e.engineOn ? i.bullish.text : i.amber.text, d = {
		H1: e.h1,
		M15: e.m15,
		M5: e.m5,
		M1: e.m1
	}, f = [{
		label: a("bfs.session"),
		value: e.session === null ? a("bfs.sessionClosed") : e.session === "open" ? a("bfs.sessionOpen") : /* @__PURE__ */ l(s, { children: [
			((e) => e === "NY" ? a("newYork") : e === "London" ? a("london") : e === "Asia" ? a("asia") : e)(e.session),
			" ",
			/* @__PURE__ */ c(Ns, {})
		] }),
		color: e.inSession ? i.bullish.text : i.textMuted
	}, {
		label: a("bfs.signal"),
		value: e.dir === 0 ? e.pending ? a("bfs.waitingRsi", {
			arrow: e.pendDir > 0 ? "▲" : "▼",
			n: e.pendLeft
		}) : a("bfs.noSignal") : a("bfs.signalActive", { side: (e.dir > 0 ? a("long") : a("short")).toUpperCase() }),
		color: e.dir > 0 ? i.bullish.text : e.dir < 0 ? i.bearish.text : e.pending ? i.amber.text : i.textMuted
	}];
	return /* @__PURE__ */ l(Ro, {
		mountTarget: t,
		theme: n,
		width: Is,
		title: "BFS",
		"aria-label": "BFS status panel",
		emblemAccents: [
			i.bullish.fill,
			i.amber.fill,
			i.blue.fill,
			i.bearish.fill
		],
		status: o,
		statusColor: u,
		children: [/* @__PURE__ */ c("div", {
			style: { padding: 8 },
			children: /* @__PURE__ */ l("div", {
				style: {
					border: `1px solid ${i.tableGrid}`,
					borderRadius: 4,
					overflow: "hidden"
				},
				children: [/* @__PURE__ */ c("div", {
					style: {
						display: "grid",
						gridTemplateColumns: `repeat(${Ls.length},1fr)`,
						borderBottom: `1px solid ${i.rowDivider}`
					},
					children: Ls.map((e) => /* @__PURE__ */ c("span", {
						style: {
							...Q.micro,
							color: e === "M1" ? i.textColor : i.textMuted,
							fontWeight: e === "M1" ? 600 : 400,
							textAlign: "center",
							padding: "4px 0"
						},
						children: a(`tf${e}`)
					}, e))
				}), /* @__PURE__ */ c("div", {
					style: {
						display: "grid",
						gridTemplateColumns: `repeat(${Ls.length},1fr)`
					},
					children: Ls.map((t) => {
						let n = d[t], r = t !== "M1" && !e.mtfReady, a = n > 0 ? i.bullish : i.bearish, o = n !== 0 && t === "M1";
						return /* @__PURE__ */ c("span", {
							style: {
								textAlign: "center",
								padding: "4px 0",
								...Q.value,
								color: n === 0 ? i.textMuted : o ? a.textOnTint : a.text,
								background: o ? a.tint : "transparent"
							},
							children: r ? "·" : n === 0 ? "—" : n > 0 ? "▲" : "▼"
						}, t);
					})
				})]
			})
		}), f.map((e, t) => /* @__PURE__ */ l("div", {
			style: {
				display: "grid",
				gridTemplateColumns: `${Fs}px 1fr`,
				alignItems: "center",
				columnGap: 8,
				padding: "4px 8px",
				borderTop: `1px solid ${i.rowDivider}`
			},
			children: [/* @__PURE__ */ c("span", {
				style: {
					...Q.data,
					textAlign: "right",
					color: i.textMuted
				},
				children: e.label
			}), /* @__PURE__ */ c("span", {
				style: {
					...Q.data,
					fontWeight: 600,
					color: e.color,
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis"
				},
				children: e.value
			})]
		}, t))]
	});
}, Bs = $o({
	denied: {},
	parse: () => ({}),
	devPreview: {}
}), Vs = class extends Xe {
	renderPanels = Ye(Rs);
	panels;
	studyPolicy;
	frames;
	markerVisibility;
	constructor(e, t) {
		super(e, t);
		let n = R.getFixedT(e.language || "en", F), r = (t) => e.notify(gs, t);
		this.frames = this.own(Mi({
			studyName: gs,
			datafeed: e.datafeed,
			ticker: e.ticker,
			isRefreshNeeded: (e) => !!e.getInputValues().find((e) => e.id === "useR2")?.value
		})), this.panels = this.own(Es({
			studyName: gs,
			onUpdate: this.publish
		})), this.studyPolicy = this.own(ss({
			studyName: gs,
			singleInstance: !0,
			isIntendedSymbol: As,
			onDuplicateRemoved: () => r(n("bfs.duplicateRemoved")),
			onUnintendedSymbol: (e, t) => r(n("unintendedSymbol", {
				symbols: ks.join(", "),
				symbol: t
			}))
		})), this.markerVisibility = this.own(Ts({ studyName: gs }));
	}
	studies(e) {
		return [xs(e, this.frames, (e) => this.panels.onSnapshot(e), this.ctx.language)];
	}
	onChartReady(e) {
		this.studyPolicy.attach(e), this.frames.attach(e), this.markerVisibility.attach(e);
	}
	onDocumentReady(e, t) {
		this.panels.attach(e, t);
	}
}, Hs = 30, Us = 2, Ws = "#FFFFFF", Gs = "rgba(0, 0, 0, 0)", Ks = 2e3, qs = 12e3, Js = ({ studyName: e, label: t, bullColor: n, bearColor: r, padding: i, banner: a }) => {
	let o = Pn({
		studyName: e,
		label: t,
		anchorsFor: (e, t) => ({
			labelTime: t.time,
			lineRight: t.time
		}),
		specsFor: (e, { barsAfter: t }) => {
			if (!e.lit) return [];
			let o = e.playsOnNextBar ? t(e.time, 1) : e.time, s = e.buy ? n : r, c = [];
			return e.showBackground && (Number.isFinite(e.high) && Number.isFinite(e.low) && c.push({
				kind: "box",
				top: e.high + i,
				bottom: e.low - i,
				fromTime: e.fromTime,
				toTime: t(o, Hs),
				fill: p(s, e.transparency),
				border: Gs
			}), c.push({
				kind: "column",
				time: o,
				color: p(s, Math.min(96, e.transparency + 6))
			})), a && e.showBanner && Number.isFinite(e.buy ? e.low : e.high) && c.push({
				kind: "banner",
				time: t(o, Us),
				price: e.buy ? e.low : e.high,
				pointing: e.buy ? "up" : "down",
				text: e.buy ? a.buy : a.sell,
				color: s,
				textColor: Ws,
				fontSize: a.fontSize
			}), c;
		}
	}), s = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Set(), u = (e) => {
		clearTimeout(s.get(e)), s.delete(e), l.delete(e);
		let t = c.get(e);
		c.delete(e), t && o.onSignal({
			...t,
			lit: !1
		});
	}, d = (e, t, n) => {
		u(e), n && l.add(e);
		let r = 1e3 / (t.hz * 2), i = t.blinks / t.hz * 1e3, a = qs > i, d = a ? i - 2 * r : i, f = a ? qs : i, p = Date.now(), m = {
			symbol: t.symbol,
			resolution: t.resolution,
			time: t.time,
			fromTime: t.fromTime,
			high: t.high,
			low: t.low,
			playsOnNextBar: t.playsOnNextBar,
			showBackground: t.showBackground,
			showBanner: t.showBanner,
			transparency: t.transparency,
			buy: t.direction === "buy",
			lit: !1
		}, h = NaN, g = () => {
			let t = Date.now();
			if (n && !o.isRouteShown(e)) {
				if (Number.isNaN(h)) h = t;
				else if (t - h > Ks) {
					u(e);
					return;
				}
			} else h = NaN;
			let i = n ? t : t - p, a = n || i < d, l = n || i < f, _ = {
				...m,
				lit: a ? Math.floor(i / r) % 2 == 0 : l
			};
			c.get(e)?.lit !== _.lit && o.onSignal(_), c.set(e, _), a ? s.set(e, setTimeout(g, r - i % r)) : l ? s.set(e, setTimeout(g, f - i)) : s.delete(e);
		};
		g();
	};
	return {
		attach: o.attach,
		destroy: () => {
			for (let e of s.values()) clearTimeout(e);
			s.clear(), c.clear(), l.clear(), o.destroy();
		},
		onSignal: (e) => {
			let t = W(e.symbol, e.resolution);
			e.enabled ? e.triggered ? d(t, e, !1) : e.test ? d(t, e, !0) : l.has(t) && u(t) : u(t);
		}
	};
}, Ys = 5, Xs = 7, Zs = 1.5, Qs = [
	{
		key: "bearReversal",
		text: "Bearish Reversal",
		background: p(A.bear, 60),
		textColor: A.bear
	},
	{
		key: "bearRetest",
		text: "Bearish Retest",
		background: p(A.bear, 80),
		textColor: p(A.bear, 30)
	},
	{
		key: "trend",
		text: "Trend Direction",
		background: p(A.neutral, 70),
		textColor: "#FFFFFF"
	},
	{
		key: "bullRetest",
		text: "Bullish Retest",
		background: p(A.bull, 80),
		textColor: p(A.bull, 30)
	},
	{
		key: "bullReversal",
		text: "Bullish Reversal",
		background: p(A.bull, 60),
		textColor: A.bull
	}
], $s = ({ studyName: e }) => Pn({
	studyName: e,
	label: "C Trigger levels",
	reanchor: !0,
	labelAlign: "middle",
	anchorsFor: (e, t, n, r) => {
		let i = r(t.time, Ys);
		return {
			labelTime: i,
			lineRight: i
		};
	},
	specsFor: (e) => Qs.map((t) => ({
		kind: "label",
		price: e[t.key],
		text: t.text,
		color: t.background,
		textColor: t.textColor,
		fontSize: Xs
	}))
}), ec = ({ studyName: e }) => Js({
	studyName: e,
	label: "C Trigger flash",
	bullColor: A.bull,
	bearColor: A.bear,
	padding: Zs
}), tc = class extends Xe {
	levelLabels;
	flash;
	constructor(e, t) {
		super(e, t), this.levelLabels = this.own($s({ studyName: ne })), this.flash = this.own(ec({ studyName: ne }));
	}
	studies(e) {
		return [le(e, {
			onLevels: this.levelLabels.onSignal,
			onFlash: this.flash.onSignal
		})];
	}
	onChartReady(e) {
		this.levelLabels.attach(e), this.flash.attach(e);
	}
}, nc = [
	{
		key: "M1",
		resolution: "1",
		minutes: 1
	},
	{
		key: "M5",
		resolution: "5",
		minutes: 5
	},
	{
		key: "M15",
		resolution: "15",
		minutes: 15
	},
	{
		key: "M30",
		resolution: "30",
		minutes: 30
	},
	{
		key: "H1",
		resolution: "60",
		minutes: 60
	},
	{
		key: "H4",
		resolution: "240",
		minutes: 240
	},
	{
		key: "D1",
		resolution: "1D",
		minutes: 1440
	}
], rc = () => ({
	M1: 0,
	M5: 0,
	M15: 0,
	M30: 0,
	H1: 0,
	H4: 0,
	D1: 0
}), ic = "const e=[{key:`M1`,resolution:`1`,minutes:1},{key:`M5`,resolution:`5`,minutes:5},{key:`M15`,resolution:`15`,minutes:15},{key:`M30`,resolution:`30`,minutes:30},{key:`H1`,resolution:`60`,minutes:60},{key:`H4`,resolution:`240`,minutes:240},{key:`D1`,resolution:`1D`,minutes:1440}],t=()=>({M1:0,M5:0,M15:0,M30:0,H1:0,H4:0,D1:0}),n=2/56;let r=0,i=a();self.onmessage=e=>{let t=e.data;if(t.type===`reset`){r=t.generation,i=a();return}if(t.generation<r)return;if(r=t.generation,t.type===`init`){i=s(t.histories),u();return}let n=i[t.key];t.closedBar.time>n.lastCommittedTime&&l(n,t.closedBar),u()};function a(){return Object.fromEntries(e.map(({key:e})=>[e,o()]))}function o(){return{ema:NaN,sum:0,count:0,lastCommittedTime:-1,trend:0}}function s(t){let n=a();for(let{key:r}of e){let e=c(t[r]),i=n[r];for(let t=0;t<e.length-1;t++)l(i,e[t])}return n}function c(e){let t=new Map;for(let n of e)!Number.isFinite(n.time)||!Number.isFinite(n.close)||t.set(n.time,n);return Array.from(t.values()).sort((e,t)=>e.time-t.time)}function l(e,t){Number.isFinite(t.close)&&(e.count<55?(e.sum+=t.close,e.count++,e.ema=e.sum/e.count):(e.ema=n*t.close+(1-n)*e.ema,e.count++),e.lastCommittedTime=t.time,e.trend=t.close>e.ema?1:-1)}function u(){let n=t();for(let{key:t}of e)n[t]=i[t].trend;let a={type:`result`,generation:r,mtf:n};self.postMessage(a)}", ac = typeof self < "u" && self.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", ic], { type: "text/javascript;charset=utf-8" });
function oc(e) {
	let t;
	try {
		if (t = ac && (self.URL || self.webkitURL).createObjectURL(ac), !t) throw "";
		let n = new Worker(t, {
			type: "module",
			name: e?.name
		});
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(ic), {
			type: "module",
			name: e?.name
		});
	}
}
//#endregion
//#region src/utils/mtf/mtfEngine.ts
var sc = 3e3, cc = 2, lc = 2e3, uc = 5, dc = ({ datafeed: e, ticker: t, onUpdate: n, label: r }) => {
	let i = r ? `${r} MTF` : "MTF", a = new oc(), o = !0, s = 0, c = null, l = {};
	a.onmessage = (e) => {
		let t = e.data;
		!o || t.generation !== s || n(t.mtf);
	}, a.onerror = (e) => {
		console.error(`${i} worker failed`, e);
	};
	let u = () => {
		c && t.unsubscribe(c), c = null, l = {};
	}, d = async (r, a = 0) => {
		let h = ++s, g = () => {
			a >= cc || setTimeout(() => {
				o && h === s && d(r, a + 1);
			}, lc * 2 ** a);
		};
		u(), n(rc()), m({
			type: "reset",
			generation: h
		});
		let _ = await e.whenSymbolsReady();
		if (!o || h !== s) return;
		let v = _.get(r.toLowerCase());
		if (!v) {
			console.warn(`${i} symbol not found: ${r}`), g();
			return;
		}
		let y;
		try {
			y = await Promise.all(nc.map(async (t) => {
				let n = await Nr({
					datafeed: e,
					symbolInfo: v,
					resolution: t.resolution,
					resolutionMinutes: t.minutes,
					barCount: sc
				});
				return [t.key, n];
			}));
		} catch (e) {
			o && h === s && (console.error(`${i} history load failed`, e), g());
			return;
		}
		if (!o || h !== s) return;
		let b = Object.fromEntries(y);
		for (let { key: e } of nc) l[e] = b[e].at(-1);
		m({
			type: "init",
			generation: h,
			histories: b
		});
		let x = (e) => p(h, v.name, e);
		c = x, t.subscribe(x), Promise.all(nc.map((e) => f(h, v, e))), nc.some(({ key: e }) => b[e].length === 0) && g();
	}, f = async (t, n, r) => {
		try {
			let i = await Lr(e, n, r.resolution, r.minutes, uc, sc);
			if (!o || t !== s || !i.length) return;
			let a = l[r.key], c = i[i.length - 1], u = a && a.time >= c.time ? a : c;
			for (let e of i) e.time < u.time && m({
				type: "barClosed",
				generation: t,
				key: r.key,
				closedBar: e
			});
			(!a || u.time > a.time) && (l[r.key] = u);
		} catch {}
	}, p = (e, t, n) => {
		if (!o || e !== s || n.symbol !== t) return;
		let r = n.bid, i = n.timestamp;
		if (!(!Number.isFinite(r) || !Number.isFinite(i))) for (let t of nc) {
			let n = l[t.key];
			if (!n) {
				l[t.key] = {
					time: i,
					close: r
				};
				continue;
			}
			let a = t.minutes * 6e4;
			if (i >= n.time + a) {
				m({
					type: "barClosed",
					generation: e,
					key: t.key,
					closedBar: n
				});
				let o = Math.floor((i - n.time) / a);
				l[t.key] = {
					time: n.time + o * a,
					close: r
				};
			} else l[t.key] = {
				time: n.time,
				close: r
			};
		}
	}, m = (e) => a.postMessage(e);
	return {
		start: d,
		destroy: () => {
			o && (o = !1, s++, u(), a.terminate());
		}
	};
}, fc = rc(), pc = ({ datafeed: e, ticker: t, onData: n, label: r }) => {
	let i = /* @__PURE__ */ new Map(), a = !0;
	return {
		sync: (o) => {
			if (!a) return;
			let s = /* @__PURE__ */ new Map();
			for (let e of o) {
				let t = Qe(e);
				t && !s.has(t) && s.set(t, e);
			}
			for (let [e, t] of Array.from(i)) s.has(e) || (i.delete(e), t.controller.destroy());
			for (let [o, c] of s) {
				if (i.has(o)) continue;
				let s = {
					controller: null,
					data: fc
				};
				s.controller = dc({
					datafeed: e,
					ticker: t,
					label: r,
					onUpdate: (e) => {
						a && (s.data = e, n());
					}
				}), i.set(o, s), s.controller.start(c).catch((e) => {
					console.error(`${r} MTF failed to start for ${c}`, e);
				});
			}
		},
		get: (e) => i.get(Qe(e))?.data ?? fc,
		destroy: () => {
			if (a) {
				a = !1;
				for (let e of i.values()) e.controller.destroy();
				i.clear();
			}
		}
	};
}, mc = ({ studyName: e, label: t, datafeed: n, ticker: r, onUpdate: i, buildData: a }) => {
	let o, s = pc({
		datafeed: n,
		ticker: r,
		label: t,
		onData: () => o.republish()
	});
	return o = ft({
		studyName: e,
		onUpdate: i,
		onLiveRoutesChanged: (e) => s.sync(e.map((e) => e.symbol)),
		buildData: (e, t) => a(e, t, s.get(t.symbol))
	}), {
		onSnapshot: o.onSnapshot,
		republish: o.republish,
		attach: o.attach,
		destroy: () => {
			o.destroy(), s.destroy();
		}
	};
}, hc = {
	bear: [],
	bull: []
}, gc = (e, t) => e.length > t ? e.slice(e.length - t) : e, _c = (e, t) => {
	let n = e.map((e) => e.createdIndex + 1 === t.barIndex ? {
		...e,
		startTime: t.time
	} : e.createdIndex + 8 === t.barIndex ? {
		...e,
		endTime: t.time
	} : e), r = (t.open + t.close) / 2, i = (e, n, r) => ({
		side: e,
		top: n,
		bottom: r,
		createdIndex: t.barIndex,
		startTime: NaN,
		endTime: NaN
	}), a = [...t.bullFlag ? [i("bull", r, Math.min(t.open, t.close))] : [], ...t.bearFlag ? [i("bear", Math.max(t.open, t.close), r)] : []];
	return gc(a.length > 0 ? [...n, ...a] : n, 400);
}, vc = (e, t) => {
	if (!t.bullBreak && !t.bearBreak) return e;
	let n = {
		side: t.bullBreak ? "bull" : "bear",
		price: t.bullBreak ? t.low - t.offset : t.high + t.offset,
		ratio: t.ratio,
		createdIndex: t.barIndex,
		time: t.time
	};
	return gc([...e, n], 150);
}, yc = (e) => `Vol: ${Math.round(e * 10) / 10}%`, bc = (e, t, n, r, i) => {
	let a = t ? [...e, t] : e;
	return (a.length > n ? a.slice(a.length - n) : a).filter((e) => !r(e)).map((e) => e.createdIndex + 10 === i.barIndex && Number.isNaN(e.endTime) ? {
		...e,
		endTime: i.time
	} : e);
}, xc = (e, t, n) => {
	let r = (e, n) => ({
		top: e,
		bottom: n,
		createdIndex: t.barIndex,
		startTime: t.startTime,
		endTime: NaN
	});
	return {
		bull: bc(e.bull, t.bullGap ? r(t.low, t.high2) : null, n, (e) => t.low <= e.bottom, t),
		bear: bc(e.bear, t.bearGap ? r(t.low2, t.high) : null, n, (e) => t.high >= e.top, t)
	};
}, Sc = (e, t, n) => {
	let r = e * (t && n <= 3 ? .0012 : t && n <= 5 ? .00245 : t && n <= 30 ? .006 : t && n <= 60 ? .012 : .0245), i = 10 ** Math.floor(Math.log10(r)), a = r / i;
	return (a < 1.5 ? 1 : a < 3.5 ? 2.5 : a < 7.5 ? 5 : 10) * i;
}, Cc = (e, t, n, r) => {
	let i = Math.floor(r / 2), a = r - i;
	return Number.isNaN(e) || t > e + (a - 1) * n || t < e - i * n ? Math.floor(t / n) * n : e;
}, wc = (e, t, n) => {
	let r = Math.floor(n / 2), i = n - r, a = [];
	for (let n = 1; n <= r; n++) a.push(e - n * t);
	for (let n = 0; n < i; n++) a.push(e + n * t);
	return a.sort((e, t) => e - t);
}, Tc = (e, t, n, r, i, a, o, s) => {
	let c = (n - r) / o;
	if (!(c > 0)) return [];
	let l = Array(o).fill(0), u = Math.min(a - 1, i, 20);
	for (let n = 0; n <= u; n++) {
		let i = e.get(n), a = t.get(n);
		if (Number.isNaN(i) || Number.isNaN(a)) continue;
		let s = Math.min(Math.trunc((i - r) / c), o - 1);
		s >= 0 && s < o && (l[s] += a);
	}
	let d = Math.max(...l) * s / 100;
	return l.flatMap((e, t) => e >= d ? [r + (t + .5) * c] : []);
}, Ec = (e) => (e ?? "").toLowerCase() === "forex", Dc = (e, t, n) => {
	let r = Ec(t), i = (t) => e.includes(t), a = n;
	return r && i("JPY") ? a = .01 : r ? a = 1e-4 : i("XAU") || i("GOLD") ? a = .1 : i("XAG") || i("SILVER") ? a = .01 : i("BTC") || i("XBT") ? a = 10 : i("ETH") && (a = 1), {
		minPips: r ? 5 : 10,
		pipSize: a
	};
}, Oc = (e, t, n, r) => {
	let i = (t.high + t.low) / 2, a = Math.min(Math.max(n.minPips * n.pipSize, t.close * 2e-4), t.atr), o = Math.min(r.bufferPips * n.pipSize, r.bufferAtr * t.atr), s = r.maxRiskAtr > 0 ? r.maxRiskAtr * t.atr : 0xe8d4a51000, [c, l, u] = r.rewardRatios;
	if (e === "bull") {
		let e = t.low;
		for (let n = 0; n < r.swingLookback; n++) {
			let r = t.lows.get(n);
			r < e && i - (r - o) <= s && (e = r);
		}
		let n = Math.max(i - (e - o), Math.max(i - (t.low - o), a));
		return {
			entry: i,
			sl: i - n,
			tp1: i + c * n,
			tp2: i + l * n,
			tp3: i + u * n
		};
	}
	let d = t.high;
	for (let e = 0; e < r.swingLookback; e++) {
		let n = t.highs.get(e);
		n > d && n + o - i <= s && (d = n);
	}
	let f = Math.max(d + o - i, Math.max(t.high + o - i, a));
	return {
		entry: i,
		sl: i + f,
		tp1: i - c * f,
		tp2: i - l * f,
		tp3: i - u * f
	};
}, kc = "#787B86", Ac = "#1E88E5", jc = "#FFB74D", Mc = "#2962FF", Nc = "#F23645", Pc = "#FFFFFF", Fc = 4294967291, Ic = 1, Lc = 0, Rc = 3, zc = " ", Bc = 7, Vc = 864e5, Hc = [
	"R7",
	"R6",
	"R5",
	"R4",
	"R3",
	"R2",
	"R1",
	"S1",
	"S2",
	"S3",
	"S4",
	"S5",
	"S6",
	"S7"
], Uc = [
	"S1",
	"S2",
	"S3",
	"S4",
	"S5",
	"S6",
	"S7",
	"R1",
	"R2",
	"R3",
	"R4",
	"R5",
	"R6",
	"R7"
], Wc = [
	"open",
	"high",
	"low",
	"close",
	"hl2",
	"hlc3",
	"ohlc4"
], Gc = [
	"Top Left",
	"Top Center",
	"Top Right",
	"Bottom Left",
	"Bottom Center",
	"Bottom Right"
], Kc = [
	"Tiny",
	"Small",
	"Normal"
], qc = (e, t) => t ? "bear" : e ? "bull" : null, Jc = (e, t, n, r) => {
	let { onSignal: i, onTableUpdate: a } = t, o = n.brand_color_2, s = n.brand_color_1, c = n.name, l = R.getFixedT(r || "en", F), u = x(o, s), d = l("cypher.groupToggles"), f = l("cypher.tradeManagement"), p = l("cypher.groupReversalBands"), m = l("cypher.groupVidya"), h = l("cypher.groupMaCloud"), _ = l("cypher.groupSuperTrend"), v = l("cypher.groupSuperTrend2"), y = l("cypher.groupHalfTrend"), b = l("cypher.groupIchimoku"), S = l("cypher.groupPsar"), w = l("cypher.groupRsi"), T = l("cypher.groupLrEma"), E = l("cypher.groupKde"), D = l("cypher.groupTrendTable"), O = l("cypher.groupKeyLevels"), k = l("cypher.groupPivots"), ee = l("cypher.groupFlash"), te = Object.fromEntries(Wc.map((e) => [e, e])), ne = [
		{
			id: "showReversalBands",
			name: l("cypher.showReversalBands"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showVIDYA",
			name: l("cypher.showVidyaLines"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showMACloud",
			name: l("cypher.showMaCloud"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showCandleColor",
			name: l("cypher.colorCandles"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showSar",
			name: l("cypher.showPsar"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showFlag",
			name: l("cypher.showConfluenceFlag"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showArrows",
			name: l("cypher.showSniperBreakArrows"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showTrendTable",
			name: l("cypher.showTrendTable"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showKeyLevels",
			name: l("cypher.showKeyLevels"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showPivots",
			name: l("cypher.showCamarillaPivots"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showKDE",
			name: l("cypher.showKde"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showSLTP",
			name: l("cypher.showSlTpLabels"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "showFVG",
			name: l("cypher.showFvg"),
			type: "bool",
			defval: !0,
			group: d
		},
		{
			id: "fvgKeep",
			name: l("cypher.fvgKeep"),
			type: "integer",
			defval: 40,
			min: 4,
			max: 200,
			group: d
		},
		{
			id: "tp1RR",
			name: l("cypher.tpRiskReward", { n: 1 }),
			type: "float",
			defval: 1,
			min: .1,
			step: .1,
			group: f
		},
		{
			id: "tp2RR",
			name: l("cypher.tpRiskReward", { n: 2 }),
			type: "float",
			defval: 2,
			min: .1,
			step: .1,
			group: f
		},
		{
			id: "tp3RR",
			name: l("cypher.tpRiskReward", { n: 3 }),
			type: "float",
			defval: 3,
			min: .1,
			step: .1,
			group: f
		},
		{
			id: "swingLookback",
			name: l("cypher.slSwingLookback"),
			type: "integer",
			defval: 15,
			min: 3,
			group: f
		},
		{
			id: "slBufferPips",
			name: l("cypher.slBufferPips"),
			type: "float",
			defval: 5,
			min: 0,
			step: .5,
			group: f
		},
		{
			id: "slBufferATR",
			name: l("cypher.slBufferAtr"),
			type: "float",
			defval: .25,
			min: 0,
			step: .05,
			group: f
		},
		{
			id: "slMaxATR",
			name: l("cypher.slMaxRiskAtr"),
			type: "float",
			defval: 3,
			min: 0,
			step: .5,
			group: f
		},
		{
			id: "flagOffsetMult",
			name: l("cypher.flagOffsetAtr"),
			type: "float",
			defval: .8,
			min: 0,
			step: .1,
			group: f
		},
		{
			id: "bbSrc",
			name: l("cypher.source"),
			type: "source",
			defval: "hl2",
			options: Wc,
			optionsTitles: te,
			group: p
		},
		{
			id: "bbLen",
			name: l("cypher.bbLength"),
			type: "integer",
			defval: 55,
			min: 1,
			group: p
		},
		{
			id: "bbDev1",
			name: l("cypher.bbStdDev", { n: 1 }),
			type: "float",
			defval: 1.5,
			step: .1,
			group: p
		},
		{
			id: "bbDev2",
			name: l("cypher.bbStdDev", { n: 2 }),
			type: "float",
			defval: 2,
			step: .1,
			group: p
		},
		{
			id: "bbDev3",
			name: l("cypher.bbStdDev", { n: 3 }),
			type: "float",
			defval: 2.5,
			step: .1,
			group: p
		},
		{
			id: "vSrc",
			name: l("cypher.source"),
			type: "source",
			defval: "close",
			options: Wc,
			optionsTitles: te,
			group: m
		},
		{
			id: "cmoLen",
			name: l("cypher.cmoLength"),
			type: "integer",
			defval: 9,
			min: 1,
			group: m
		},
		{
			id: "tsShow55",
			name: l("cypher.showVidya55"),
			type: "bool",
			defval: !0,
			group: m
		},
		{
			id: "tsShow233",
			name: l("cypher.showVidya233"),
			type: "bool",
			defval: !0,
			group: m
		},
		{
			id: "tsShow987",
			name: l("cypher.showVidya987"),
			type: "bool",
			defval: !0,
			group: m
		},
		{
			id: "maShort",
			name: l("cypher.maCloudShort"),
			type: "integer",
			defval: 3,
			min: 1,
			group: h
		},
		{
			id: "maLong",
			name: l("cypher.maCloudLong"),
			type: "integer",
			defval: 8,
			min: 1,
			group: h
		},
		{
			id: "stAtrLen",
			name: l("cypher.superTrendAtrLength"),
			type: "integer",
			defval: 2,
			min: 1,
			group: _
		},
		{
			id: "stMult",
			name: l("cypher.superTrendMultiplier"),
			type: "float",
			defval: 1,
			step: .1,
			group: _
		},
		{
			id: "st2AtrLen",
			name: l("cypher.superTrend2AtrLength"),
			type: "integer",
			defval: 10,
			min: 1,
			group: v
		},
		{
			id: "st2Factor",
			name: l("cypher.superTrend2Factor"),
			type: "float",
			defval: 3,
			step: .1,
			group: v
		},
		{
			id: "htAmp",
			name: l("cypher.halfTrendAmplitude"),
			type: "integer",
			defval: 2,
			min: 1,
			group: y
		},
		{
			id: "htDev",
			name: l("cypher.halfTrendChannelDeviation"),
			type: "integer",
			defval: 2,
			min: 1,
			group: y
		},
		{
			id: "ichConv",
			name: l("cypher.ichimokuConversion"),
			type: "integer",
			defval: 5,
			min: 1,
			group: b
		},
		{
			id: "ichBase",
			name: l("cypher.ichimokuBase"),
			type: "integer",
			defval: 25,
			min: 1,
			group: b
		},
		{
			id: "sarStart",
			name: l("cypher.psarStart"),
			type: "float",
			defval: .02,
			step: .01,
			group: S
		},
		{
			id: "sarInc",
			name: l("cypher.psarIncrement"),
			type: "float",
			defval: .02,
			step: .01,
			group: S
		},
		{
			id: "sarMax",
			name: l("cypher.psarMax"),
			type: "float",
			defval: .2,
			step: .01,
			group: S
		},
		{
			id: "rsiLen",
			name: l("rsiLength"),
			type: "integer",
			defval: 5,
			min: 1,
			group: w
		},
		{
			id: "emaPeriod",
			name: l("cypher.emaPeriodTrend"),
			type: "integer",
			defval: 200,
			min: 1,
			group: T
		},
		{
			id: "lrBars",
			name: l("cypher.pulseSmoothingBars"),
			type: "integer",
			defval: 5,
			min: 1,
			group: T
		},
		{
			id: "kdeBins",
			name: l("cypher.kdeBins"),
			type: "integer",
			defval: 100,
			min: 10,
			group: E
		},
		{
			id: "kdeThresh",
			name: l("cypher.kdeThreshold"),
			type: "integer",
			defval: 33,
			min: 1,
			max: 100,
			group: E
		},
		{
			id: "kdeVolLen",
			name: l("cypher.volumeAvgLength"),
			type: "integer",
			defval: 25,
			min: 1,
			group: E
		},
		{
			id: "kdeActive",
			name: l("cypher.kdeActivation"),
			type: "bool",
			defval: !1,
			group: E
		},
		{
			id: "tblPos",
			name: l("cypher.tablePosition"),
			type: "text",
			defval: "Top Right",
			group: D,
			options: Gc,
			optionsTitles: {
				"Top Left": l("cypher.positionTopLeft"),
				"Top Center": l("cypher.positionTopCenter"),
				"Top Right": l("cypher.positionTopRight"),
				"Bottom Left": l("cypher.positionBottomLeft"),
				"Bottom Center": l("cypher.positionBottomCenter"),
				"Bottom Right": l("cypher.positionBottomRight")
			}
		},
		{
			id: "tblSize",
			name: l("cypher.tableSize"),
			type: "text",
			defval: "Tiny",
			group: D,
			options: Kc,
			optionsTitles: {
				Tiny: l("cypher.sizeTiny"),
				Small: l("cypher.sizeSmall"),
				Normal: l("cypher.sizeNormal")
			}
		},
		{
			id: "klNumLevels",
			name: l("cypher.numberOfLevels"),
			type: "integer",
			defval: 10,
			min: 1,
			max: 50,
			group: O
		},
		{
			id: "klLineWidth",
			name: l("cypher.lineWidth"),
			type: "integer",
			defval: 1,
			min: 1,
			max: 4,
			group: O
		},
		{
			id: "klShowGlow",
			name: l("cypher.showLevelGlow"),
			type: "bool",
			defval: !1,
			group: O
		},
		{
			id: "klGlowOpacity",
			name: l("cypher.glowOpacity"),
			type: "integer",
			defval: 90,
			min: 0,
			max: 100,
			group: O
		},
		{
			id: "klGlowSize",
			name: l("cypher.glowSizeTicks"),
			type: "integer",
			defval: 10,
			min: 1,
			max: 100,
			group: O
		},
		{
			id: "pivotTF",
			name: l("cypher.pivotsTimeframe"),
			type: "text",
			defval: "Auto",
			group: k,
			options: [
				"Auto",
				"Daily",
				"Weekly",
				"Monthly"
			],
			optionsTitles: {
				Auto: l("cypher.pivotAuto"),
				Daily: l("cypher.pivotDaily"),
				Weekly: l("cypher.pivotWeekly"),
				Monthly: l("cypher.pivotMonthly")
			}
		},
		{
			id: "pvShowLabels",
			name: l("cypher.showLabels"),
			type: "bool",
			defval: !0,
			group: k
		},
		{
			id: "pvShowPrices",
			name: l("cypher.showPrices"),
			type: "bool",
			defval: !1,
			group: k
		},
		{
			id: "pvLabelPos",
			name: l("cypher.labelPosition"),
			type: "text",
			defval: "Left",
			group: k,
			options: ["Left", "Right"],
			optionsTitles: {
				Left: l("cypher.positionLeft"),
				Right: l("cypher.positionRight")
			}
		},
		{
			id: "pvLineW",
			name: l("cypher.lineWidth"),
			type: "integer",
			defval: 1,
			min: 1,
			max: 4,
			group: k
		},
		{
			id: "pvRightOffset",
			name: l("cypher.rightOffsetBars"),
			type: "integer",
			defval: 20,
			min: 5,
			max: 100,
			group: k
		},
		...Uc.map((e) => ({
			id: `pvShow${e}`,
			name: e,
			type: "bool",
			defval: !0,
			group: k
		})),
		{
			id: "flashOn",
			name: l("cypher.flashOn"),
			type: "bool",
			defval: !0,
			group: ee
		},
		{
			id: "flashCount",
			name: l("cypher.flashCount"),
			type: "integer",
			defval: 3,
			min: 1,
			max: 12,
			group: ee
		},
		{
			id: "flashHz",
			name: l("cypher.flashHz"),
			type: "float",
			defval: 1.5,
			min: .3,
			max: 6,
			step: .1,
			group: ee
		},
		{
			id: "flashShowBg",
			name: l("cypher.flashShowBg"),
			type: "bool",
			defval: !0,
			group: ee
		},
		{
			id: "flashShowBan",
			name: l("cypher.flashShowBanner"),
			type: "bool",
			defval: !0,
			group: ee
		},
		{
			id: "flashBgTransp",
			name: l("cypher.flashStrength"),
			type: "integer",
			defval: 82,
			min: 50,
			max: 96,
			group: ee
		},
		{
			id: "flashTest",
			name: l("cypher.flashTest"),
			type: "bool",
			defval: !1,
			group: ee
		}
	], A = new Map(ne.map((e, t) => [e.id, t]));
	return {
		name: c,
		metainfo: {
			_metainfoVersion: 51,
			id: "cypherid@tv-basicstudies-1",
			name: c,
			description: c,
			shortDescription: c,
			isCustomIndicator: !0,
			is_price_study: !0,
			format: { type: "inherit" },
			inputs: ne,
			plots: [
				{
					id: "bb1Upper",
					type: "line"
				},
				{
					id: "bb1Lower",
					type: "line"
				},
				{
					id: "bb2Upper",
					type: "line"
				},
				{
					id: "bb2Lower",
					type: "line"
				},
				{
					id: "bb3Upper",
					type: "line"
				},
				{
					id: "bb3Lower",
					type: "line"
				},
				{
					id: "vidya55",
					type: "line"
				},
				{
					id: "vidya55Color",
					type: "colorer",
					target: "vidya55",
					palette: "palette_vidya55_side"
				},
				{
					id: "vidya233",
					type: "line"
				},
				{
					id: "vidya987",
					type: "line"
				},
				{
					id: "emaFast",
					type: "line"
				},
				{
					id: "emaSlow",
					type: "line"
				},
				{
					id: "parabolicSar",
					type: "line"
				},
				{
					id: "parabolicSarColor",
					type: "colorer",
					target: "parabolicSar",
					palette: "palette_psar_side"
				},
				{
					id: "barColor",
					type: "bar_colorer",
					palette: "palette_bar"
				},
				{
					id: "sniperUp",
					type: "shapes"
				},
				{
					id: "sniperDown",
					type: "shapes"
				},
				{
					id: "breakUp",
					type: "shapes"
				},
				{
					id: "breakDown",
					type: "shapes"
				},
				{
					id: "confluenceBuy",
					type: "shapes"
				},
				{
					id: "confluenceSell",
					type: "shapes"
				},
				{
					id: "bullPattern",
					type: "chars"
				},
				{
					id: "bearPattern",
					type: "chars"
				},
				{
					id: "upperZone1",
					type: "line"
				},
				{
					id: "upperZone2",
					type: "line"
				},
				{
					id: "upperZone3",
					type: "line"
				},
				{
					id: "lowerZone1",
					type: "line"
				},
				{
					id: "lowerZone2",
					type: "line"
				},
				{
					id: "lowerZone3",
					type: "line"
				},
				{
					id: "flashBackground",
					type: "bg_colorer",
					palette: "palette_flash_background"
				}
			],
			palettes: {
				palette_vidya55_side: {
					colors: [{ name: l("cypher.below55") }, { name: l("cypher.above55") }],
					valToIndex: {
						0: 0,
						1: 1
					}
				},
				palette_psar_side: {
					colors: [{ name: l("cypher.psarBear") }, { name: l("cypher.psarBull") }],
					valToIndex: {
						0: 0,
						1: 1
					}
				},
				palette_bar: {
					colors: [
						{ name: l("bearish") },
						{ name: l("neutral") },
						{ name: l("bullish") }
					],
					valToIndex: {
						0: 0,
						1: 1,
						2: 2
					}
				},
				palette_flash_background: u.palette
			},
			filledAreas: [
				{
					id: "upperReversalZone",
					objAId: "upperZone2",
					objBId: "upperZone3",
					type: "plot_plot",
					title: l("cypher.upperReversalZone")
				},
				{
					id: "lowerReversalZone",
					objAId: "lowerZone2",
					objBId: "lowerZone3",
					type: "plot_plot",
					title: l("cypher.lowerReversalZone")
				},
				{
					id: "upperInnerZone",
					objAId: "upperZone1",
					objBId: "upperZone2",
					type: "plot_plot",
					title: l("cypher.upperInnerZone")
				},
				{
					id: "lowerInnerZone",
					objAId: "lowerZone1",
					objBId: "lowerZone2",
					type: "plot_plot",
					title: l("cypher.lowerInnerZone")
				}
			],
			defaults: {
				inputs: Object.fromEntries(ne.map((e) => [e.id, e.defval])),
				palettes: {
					palette_vidya55_side: { colors: [{
						color: s,
						width: 2,
						style: 0
					}, {
						color: o,
						width: 2,
						style: 0
					}] },
					palette_psar_side: { colors: [{
						color: s,
						width: 1,
						style: 0
					}, {
						color: o,
						width: 1,
						style: 0
					}] },
					palette_bar: { colors: [
						{ color: s },
						{ color: kc },
						{ color: o }
					] },
					palette_flash_background: u.defaults
				},
				styles: {
					bb1Upper: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 80,
						visible: !0,
						color: s,
						display: Fc
					},
					bb1Lower: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 80,
						visible: !0,
						color: o,
						display: Fc
					},
					bb2Upper: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 70,
						visible: !0,
						color: s,
						display: Fc
					},
					bb2Lower: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 70,
						visible: !0,
						color: o,
						display: Fc
					},
					bb3Upper: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 60,
						visible: !0,
						color: s,
						display: Fc
					},
					bb3Lower: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 60,
						visible: !0,
						color: o,
						display: Fc
					},
					vidya55: {
						linestyle: 0,
						linewidth: 2,
						plottype: Lc,
						trackPrice: !1,
						transparency: 0,
						visible: !0,
						color: o,
						display: Fc
					},
					vidya233: {
						linestyle: 0,
						linewidth: 2,
						plottype: Lc,
						trackPrice: !1,
						transparency: 0,
						visible: !0,
						color: Ac,
						display: Fc
					},
					vidya987: {
						linestyle: 0,
						linewidth: 2,
						plottype: Lc,
						trackPrice: !1,
						transparency: 0,
						visible: !0,
						color: jc,
						display: Fc
					},
					emaFast: {
						linestyle: 0,
						linewidth: 2,
						plottype: Lc,
						trackPrice: !1,
						transparency: 0,
						visible: !0,
						color: Mc,
						display: Fc
					},
					emaSlow: {
						linestyle: 0,
						linewidth: 2,
						plottype: Lc,
						trackPrice: !1,
						transparency: 0,
						visible: !0,
						color: Nc,
						display: Fc
					},
					parabolicSar: {
						linestyle: 0,
						linewidth: 1,
						plottype: Rc,
						trackPrice: !1,
						transparency: 0,
						visible: !0,
						color: o,
						display: Fc
					},
					sniperUp: {
						plottype: "shape_triangle_up",
						location: "BelowBar",
						color: o,
						textColor: Pc,
						visible: !0
					},
					sniperDown: {
						plottype: "shape_triangle_down",
						location: "AboveBar",
						color: s,
						textColor: Pc,
						visible: !0
					},
					breakUp: {
						plottype: "shape_arrow_up",
						location: "BelowBar",
						color: o,
						textColor: Pc,
						visible: !0
					},
					breakDown: {
						plottype: "shape_arrow_down",
						location: "AboveBar",
						color: s,
						textColor: Pc,
						visible: !0
					},
					confluenceBuy: {
						plottype: "shape_label_up",
						location: "Absolute",
						color: o,
						textColor: Pc,
						visible: !0,
						display: Ic
					},
					confluenceSell: {
						plottype: "shape_label_down",
						location: "Absolute",
						color: s,
						textColor: Pc,
						visible: !0,
						display: Ic
					},
					bullPattern: {
						char: "◆",
						location: "BelowBar",
						color: o,
						textColor: o,
						transparency: 30,
						visible: !0,
						display: Ic
					},
					bearPattern: {
						char: "◆",
						location: "AboveBar",
						color: s,
						textColor: s,
						transparency: 30,
						visible: !0,
						display: Ic
					},
					upperZone1: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 100,
						visible: !1,
						color: s
					},
					upperZone2: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 100,
						visible: !1,
						color: s
					},
					upperZone3: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 100,
						visible: !1,
						color: s
					},
					lowerZone1: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 100,
						visible: !1,
						color: o
					},
					lowerZone2: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 100,
						visible: !1,
						color: o
					},
					lowerZone3: {
						linestyle: 0,
						linewidth: 1,
						plottype: Lc,
						trackPrice: !1,
						transparency: 100,
						visible: !1,
						color: o
					},
					flashBackground: {
						transparency: 0,
						visible: !0
					}
				},
				filledAreasStyle: {
					upperReversalZone: {
						visible: !0,
						color: s,
						transparency: 55
					},
					lowerReversalZone: {
						visible: !0,
						color: o,
						transparency: 55
					},
					upperInnerZone: {
						visible: !0,
						color: s,
						transparency: 80
					},
					lowerInnerZone: {
						visible: !0,
						color: o,
						transparency: 80
					}
				}
			},
			styles: {
				bb1Upper: {
					title: l("cypher.upperBb", { n: 1 }),
					histogramBase: 0
				},
				bb1Lower: {
					title: l("cypher.lowerBb", { n: 1 }),
					histogramBase: 0
				},
				bb2Upper: {
					title: l("cypher.upperBb", { n: 2 }),
					histogramBase: 0
				},
				bb2Lower: {
					title: l("cypher.lowerBb", { n: 2 }),
					histogramBase: 0
				},
				bb3Upper: {
					title: l("cypher.upperBb", { n: 3 }),
					histogramBase: 0
				},
				bb3Lower: {
					title: l("cypher.lowerBb", { n: 3 }),
					histogramBase: 0
				},
				vidya55: {
					title: "VIDYA 55",
					histogramBase: 0
				},
				vidya233: {
					title: "VIDYA 233",
					histogramBase: 0
				},
				vidya987: {
					title: l("cypher.vidya987Magnet"),
					histogramBase: 0
				},
				emaFast: {
					title: l("cypher.maCloudShort"),
					histogramBase: 0
				},
				emaSlow: {
					title: l("cypher.maCloudLong"),
					histogramBase: 0
				},
				parabolicSar: {
					title: l("cypher.parabolicSar"),
					histogramBase: 0
				},
				barColor: { title: l("cypher.barColors") },
				sniperUp: {
					title: l("cypher.sniperUp"),
					isHidden: !1,
					text: "",
					size: "tiny"
				},
				sniperDown: {
					title: l("cypher.sniperDown"),
					isHidden: !1,
					text: "",
					size: "tiny"
				},
				breakUp: {
					title: l("cypher.bullBreak"),
					isHidden: !1,
					text: "",
					size: "normal"
				},
				breakDown: {
					title: l("cypher.bearBreak"),
					isHidden: !1,
					text: "",
					size: "normal"
				},
				confluenceBuy: {
					title: l("cypher.confluenceLong"),
					isHidden: !1,
					text: `${zc}B${zc}`,
					size: "small"
				},
				confluenceSell: {
					title: l("cypher.confluenceShort"),
					isHidden: !1,
					text: `${zc}S${zc}`,
					size: "small"
				},
				bullPattern: {
					title: l("cypher.bullPattern"),
					isHidden: !1,
					char: "◆",
					size: Bc
				},
				bearPattern: {
					title: l("cypher.bearPattern"),
					isHidden: !1,
					char: "◆",
					size: Bc
				},
				upperZone1: {
					title: l("cypher.zoneEdge", { name: l("cypher.upperBb", { n: 1 }) }),
					histogramBase: 0
				},
				upperZone2: {
					title: l("cypher.zoneEdge", { name: l("cypher.upperBb", { n: 2 }) }),
					histogramBase: 0
				},
				upperZone3: {
					title: l("cypher.zoneEdge", { name: l("cypher.upperBb", { n: 3 }) }),
					histogramBase: 0
				},
				lowerZone1: {
					title: l("cypher.zoneEdge", { name: l("cypher.lowerBb", { n: 1 }) }),
					histogramBase: 0
				},
				lowerZone2: {
					title: l("cypher.zoneEdge", { name: l("cypher.lowerBb", { n: 2 }) }),
					histogramBase: 0
				},
				lowerZone3: {
					title: l("cypher.zoneEdge", { name: l("cypher.lowerBb", { n: 3 }) }),
					histogramBase: 0
				},
				flashBackground: {
					title: l("cypher.flashBackground"),
					isHidden: !0
				}
			}
		},
		constructor: function() {
			let n = -1, r = 0, o = NaN, s = NaN, c = 0, l = NaN, u = NaN, d = 0, f = NaN, p = NaN, m = 0, h = NaN, _ = NaN, v = 0, y = NaN, b = 0, x = NaN, S = NaN, w = NaN, T = NaN, E = NaN, D = NaN, O = NaN, k = NaN, ee = NaN, te = null, ne = null, j = Ht(void 0, void 0), M = hc, re = hc, N = [], P = [], ie = [], ae = [], oe = NaN, se = NaN, ce = null, le = C(), F = "", ue = "", de = "", fe = "", pe = "", me = "", he = "", ge = "", _e = () => ({
				ema: NaN,
				sum: 0,
				count: 0,
				lastBarIdx: -1,
				liveEma: NaN,
				liveSum: 0,
				liveCount: 0
			}), ve = _e(), ye = _e(), be = _e(), I = () => ({
				result: NaN,
				lastBarIdx: -1,
				liveResult: NaN
			}), xe = I(), Se = I(), Ce = I(), L = I(), we = I(), R = I(), Te = I(), Ee = I(), De = (e, t, n, r, i) => {
				i !== r.lastBarIdx && (r.result = r.liveResult, r.lastBarIdx = i);
				let a = r.result, o = 2 / (t + 1) * n, s = Number.isNaN(a) ? e : o * e + (1 - o) * a;
				return r.liveResult = s, s;
			}, Oe = (e, t, n, r) => {
				r !== n.lastBarIdx && (n.ema = n.liveEma, n.sum = n.liveSum, n.count = n.liveCount, n.lastBarIdx = r);
				let { ema: i, sum: a, count: o } = n;
				if (isFinite(e)) if (o < t) a += e, o++, i = a / o;
				else {
					let n = 2 / (t + 1);
					i = n * e + (1 - n) * i;
				}
				return n.liveEma = i, n.liveSum = a, n.liveCount = o, o < t ? NaN : i;
			}, ke = () => {
				n = -1, r = 0, o = NaN, s = NaN, c = 0, l = NaN, u = NaN, d = 0, f = NaN, p = NaN, m = 0, h = NaN, _ = NaN, v = 0, y = NaN, b = 0, x = NaN, S = NaN, w = NaN, T = NaN, E = NaN, D = NaN, O = NaN, k = NaN, ee = NaN, te = null, ne = null, M = hc, re = hc, N = [], P = [], ie = [], ae = [], oe = NaN, se = NaN, ce = null, le.reset(), F = "", ue = "", de = "", fe = "", pe = "", me = "", he = "", ge = "";
				let e = (e) => {
					e.ema = NaN, e.sum = 0, e.count = 0, e.lastBarIdx = -1, e.liveEma = NaN, e.liveSum = 0, e.liveCount = 0;
				};
				e(ve), e(ye), e(be);
				let t = (e) => {
					e.result = NaN, e.lastBarIdx = -1, e.liveResult = NaN;
				};
				t(xe), t(Se), t(Ce), t(L), t(we), t(R), t(Te), t(Ee);
			};
			this.init = function(e) {
				ke(), e.setMinimumAdditionalDepth(3e3);
			}, this.main = function(C, _e) {
				this._context = C, this._input = _e;
				let I = C.symbol.index ?? 0, ke = I > n, Ae = C.symbol.isLastBar === !0, B = (e) => _e(A.get(e)), V = (e) => B(e) !== !1, H = V("showReversalBands"), je = V("showVIDYA"), Me = V("showMACloud"), Ne = V("showCandleColor"), Pe = V("showSar"), Fe = V("showFlag"), Ie = V("showArrows"), Le = V("showTrendTable"), Re = V("showKeyLevels"), ze = V("showPivots"), Be = V("showKDE"), U = V("showSLTP"), Ve = V("showFVG"), He = Z(B("fvgKeep"), 40), Ue = Z(B("tp1RR"), 1), We = Z(B("tp2RR"), 2), Ge = Z(B("tp3RR"), 3), Ke = Z(B("swingLookback"), 15), qe = Z(B("slBufferPips"), 5), Je = Z(B("slBufferATR"), .25), Ye = Z(B("slMaxATR"), 3), Xe = Z(B("flagOffsetMult"), .8), Ze = String(B("bbSrc") ?? "hl2"), Qe = Z(B("bbLen"), 55), $e = Z(B("bbDev1"), 1.5), W = Z(B("bbDev2"), 2), et = Z(B("bbDev3"), 2.5), tt = String(B("vSrc") ?? "close"), nt = Math.max(1, Math.trunc(Z(B("cmoLen"), 9))), rt = V("tsShow55"), it = V("tsShow233"), at = V("tsShow987"), ot = Z(B("maShort"), 3), st = Z(B("maLong"), 8), ct = Z(B("stAtrLen"), 2), lt = Z(B("stMult"), 1), ut = Z(B("st2AtrLen"), 10), dt = Z(B("st2Factor"), 3), G = Z(B("htAmp"), 2), ft = Z(B("ichConv"), 5), pt = Z(B("ichBase"), 25), mt = Z(B("sarStart"), .02), ht = Z(B("sarInc"), .02), gt = Z(B("sarMax"), .2), _t = Z(B("rsiLen"), 5), vt = Z(B("emaPeriod"), 200), yt = Z(B("lrBars"), 5), bt = Z(B("kdeBins"), 100), xt = Z(B("kdeThresh"), 33), St = Z(B("kdeVolLen"), 25), Ct = B("kdeActive") === !0, wt = Gc.includes(B("tblPos")) ? B("tblPos") : "Top Right", Tt = Kc.includes(B("tblSize")) ? B("tblSize") : "Tiny", Et = Z(B("klNumLevels"), 10), Dt = Z(B("klLineWidth"), 1), Ot = B("klShowGlow") === !0, kt = Z(B("klGlowOpacity"), 90), At = Z(B("klGlowSize"), 10), jt = String(B("pivotTF") ?? "Auto"), Mt = V("pvShowLabels"), Nt = B("pvShowPrices") === !0, Pt = B("pvLabelPos") === "Right" ? "Right" : "Left", Ft = Z(B("pvLineW"), 1), It = Z(B("pvRightOffset"), 20), Lt = Hc.map((e) => V(`pvShow${e}`)), Rt = V("flashOn"), zt = Z(B("flashCount"), 3), Bt = Z(B("flashHz"), 1.5), Vt = V("flashShowBg"), Ut = V("flashShowBan"), Wt = Z(B("flashBgTransp"), 82), Gt = B("flashTest") === !0, Kt = e.Std.open(C), qt = e.Std.high(C), Jt = e.Std.low(C), K = e.Std.close(C), Yt = e.Std.volume(C), Xt = e.Std.time(C), Zt = (e) => {
					switch (e) {
						case "open": return Kt;
						case "high": return qt;
						case "low": return Jt;
						case "hl2": return (qt + Jt) / 2;
						case "hlc3": return (qt + Jt + K) / 3;
						case "ohlc4": return (Kt + qt + Jt + K) / 4;
						default: return K;
					}
				}, Qt = C.new_unlimited_var(Kt), $t = C.new_unlimited_var(K), en = C.new_var(K), tn = C.new_unlimited_var(qt), nn = C.new_unlimited_var(Jt), rn = (qt + Jt) / 2, an = C.new_var(Zt(Ze)), q = Zt(tt), on = C.new_unlimited_var(q), sn = C.new_unlimited_var(Yt), cn = (t, n) => e.Std.n(C) >= t ? n : NaN, ln = e.Std.ema(an, Qe, C), un = e.Std.stdev(an, Qe, C), dn = ln + $e * un, fn = ln - $e * un, pn = ln + W * un, mn = ln - W * un, hn = ln + et * un, gn = ln - et * un, _n = Oe(q, 55, ve, I), vn = Oe(q, 233, ye, I), yn = Oe(q, 987, be, I), bn = K > _n, xn = 0, Sn = 0, Cn = !0;
				for (let e = 0; e < nt; e++) {
					let t = on.get(e), n = on.get(e + 1);
					if (e + 1 > I || !isFinite(t) || !isFinite(n)) {
						Cn = !1;
						break;
					}
					let r = t - n;
					r > 0 ? xn += r : Sn += -r;
				}
				let wn = xn + Sn, Tn = Cn && wn > 0 ? Math.abs(xn - Sn) / wn : NaN, En = De(q, 8, Tn, xe, I), Dn = De(q, 13, Tn, Se, I), On = De(q, 21, Tn, Ce, I), kn = De(q, 34, Tn, L, I), An = De(q, 89, Tn, we, I), jn = De(q, 144, Tn, R, I), Mn = De(q, 377, Tn, Te, I), Nn = De(q, 610, Tn, Ee, I), Pn = e.Std.ema(en, ot, C), Fn = e.Std.ema(en, st, C), In = Pn > Fn, Ln = C.new_unlimited_var(Pn), Rn = C.new_unlimited_var(Fn), zn = Ln.get(1), Bn = Rn.get(1), Vn = !isNaN(zn) && !isNaN(Bn) && zn <= Bn && Pn > Fn, Hn = !isNaN(zn) && !isNaN(Bn) && zn >= Bn && Pn < Fn, Un = C.new_unlimited_var(+!!Vn), Wn = C.new_unlimited_var(+!!Hn), Gn = Vn || Un.get(1) === 1 || Un.get(2) === 1, Kn = Hn || Wn.get(1) === 1 || Wn.get(2) === 1;
				ke && (o = l, s = u, r = c);
				let qn = e.Std.rma(C.new_var(e.Std.tr(!0, C)), ct, C), Jn = rn + lt * qn, Yn = rn - lt * qn, Xn = $t.get(1), Zn = isNaN(o) ? Jn : o, Qn = isNaN(s) ? Yn : s;
				Jn = Jn < Zn || !isNaN(Xn) && Xn > Zn ? Jn : Zn, Yn = Yn > Qn || !isNaN(Xn) && Xn < Qn ? Yn : Qn;
				let $n;
				$n = isNaN(o) ? 1 : r === 1 && K > Jn ? -1 : r === -1 && K < Yn ? 1 : r;
				let er = r;
				l = Jn, u = Yn, c = $n;
				let tr = $n < 0, nr = $n < 0 && er > 0, rr = $n > 0 && er < 0;
				ke && (f = h, p = _, d = m);
				let ir = e.Std.rma(C.new_var(e.Std.tr(!0, C)), ut, C), ar = rn + dt * ir, or = rn - dt * ir, sr = isNaN(f) ? ar : f, cr = isNaN(p) ? or : p;
				ar = ar < sr || !isNaN(Xn) && Xn > sr ? ar : sr, or = or > cr || !isNaN(Xn) && Xn < cr ? or : cr;
				let lr;
				lr = isNaN(f) ? 1 : d === 1 && K > ar ? -1 : d === -1 && K < or ? 1 : d, h = ar, _ = or, m = lr;
				let ur = lr < 0;
				ke && (v = b, y = x);
				let dr = e.Std.highest(tn, G, C), fr = e.Std.lowest(nn, G, C), pr = v, mr = y;
				if (I >= G) if (pr === 1) {
					let e = Math.max(isNaN(mr) ? fr : mr, fr);
					mr = e, K < e && (pr = -1, mr = dr);
				} else if (pr === -1) {
					let e = Math.min(isNaN(mr) ? dr : mr, dr);
					mr = e, K > e && (pr = 1, mr = fr);
				} else pr = -1, mr = dr;
				b = pr, x = mr;
				let hr = pr === 1, gr = cn(ft, (e.Std.highest(tn, ft, C) + e.Std.lowest(nn, ft, C)) / 2) > cn(pt, (e.Std.highest(tn, pt, C) + e.Std.lowest(nn, pt, C)) / 2), _r = e.Std.sar(mt, ht, gt, C), vr = K > _r, yr = e.Std.ema(en, vt, C), br = e.Std.change(en), xr = Math.max(br, 0), Sr = Math.max(-br, 0), Cr = C.new_var(xr), wr = C.new_var(Sr), Tr = e.Std.rma(Cr, _t, C), Er = e.Std.rma(wr, _t, C), Dr = e.Std.rsi(Tr, Er), Or = C.new_var(Dr), kr = e.Std.ema(Or, yt, C), Ar = C.new_var(kr), jr = e.Std.ema(Ar, yt, C) > 50, Mr = 0;
				In && Mr++, tr && Mr++, ur && Mr++, hr && Mr++, gr && Mr++, vr && Mr++, K > yr && Mr++, K > _n && Mr++;
				let Nr = Mr > 4, Pr = Mr >= 4, Fr = Mr <= 4, Ir = 0;
				ur && Ir++, hr && Ir++, gr && Ir++, vr && Ir++, jr && Ir++;
				let Lr = Ir >= 4, Rr = Ir <= 1, zr = Ne ? Mr >= 5 ? 2 : Mr <= 3 ? 0 : 1 : NaN, Br = K > Kt, Vr = K < Kt, Hr = Nr && Mr >= 5 && Br, Ur = !Nr && Mr <= 3 && Vr, Wr = C.new_unlimited_var(+!!Hr), Gr = C.new_unlimited_var(+!!Ur), Kr = Wr.get(1), qr = Gr.get(1), Jr = Hr && Kr !== 1, Yr = Ur && qr !== 1, Xr = cn(St, e.Std.sma(sn, St, C)), Zr = Xr > 0 ? Yt / Xr * 100 : 0, Qr = Zr > 30, $r = nr && Qr && K > _n, ei = rr && Qr && K < _n, ti = Pr, ni = Fr, ri = !Rr, ii = !Lr, ai = Gn && ti && ri, oi = Kn && ni && ii, si = C.new_unlimited_var(+!!ai), ci = C.new_unlimited_var(+!!oi), li = si.get(1), ui = ci.get(1), di = ai && li !== 1, fi = oi && ui !== 1, pi = si.get(1) === 1 && si.get(2) !== 1, mi = ci.get(1) === 1 && ci.get(2) !== 1, { symbol: hi, resolution: gi } = g(C, e.Std), _i = {
					symbol: hi,
					resolution: gi
				}, vi = e.Std.rma(C.new_var(e.Std.tr(!0, C)), 14, C), yi = C.symbol.info, bi = Ec(yi?.type), xi = (yi?.minmov ?? 1) / (yi?.pricescale ?? 100), Si = C.new_var(vi), Ci = C.new_unlimited_var(Xt), wi = Dc(hi, yi?.type, xi), Ti = {
					bufferAtr: Je,
					bufferPips: qe,
					maxRiskAtr: Ye,
					rewardRatios: [
						Ue,
						We,
						Ge
					],
					swingLookback: Ke
				}, Ei = (e, t) => {
					let n = {
						atr: Si.get(e),
						close: $t.get(e),
						high: tn.get(e),
						low: nn.get(e),
						highs: { get: (t) => tn.get(t + e) },
						lows: { get: (t) => nn.get(t + e) }
					};
					return {
						direction: t,
						time: Ci.get(e) / 1e3,
						...Oc(t, n, wi, Ti)
					};
				}, Di = cn(3, e.Std.lowest(nn, 3, C)), Oi = cn(3, e.Std.highest(tn, 3, C)), ki = Math.max(vi, Oi - Di) * Xe;
				if (ke && U) {
					let e = qc(pi, mi);
					e && isFinite(Si.get(1)) && (ce = Ei(1, e), i({
						..._i,
						...ce,
						lastBarTime: Xt / 1e3,
						shown: !0
					}));
				}
				if (Ae) {
					let e = 0;
					q > En && e++, q > Dn && e++, q > On && e++, q > kn && e++, q > _n && e++, q > An && e++, q > jn && e++, q > vn && e++, q > Mn && e++, q > Nn && e++, q > yn && e++;
					let t = e > 11 / 2, n = e / 11, r = n >= .9 || n <= .1 ? "Very Strong" : n >= .75 || n <= .25 ? "Strong" : n >= .6 || n <= .4 ? "Neutral" : n >= .45 && n <= .55 ? "Weak" : "Very Weak", i = (En + Dn + On) / 3, o = (_n + An + jn) / 3, s = (vn + Mn + Nn) / 3, c = i > o, l = o > s, u = Math.abs(i - s) / q * 100, d = {
						isBullish: t,
						state: c === l && u > .5 ? "Trending" : c === l ? "Consolidating" : "Pulling Back",
						strength: r,
						bullCount: e,
						totalLevels: 11,
						aboveV55: q > _n,
						aboveV233: q > vn,
						aboveV987: q > yn,
						activeTF: gi === "1" ? "M1" : gi === "5" ? "M5" : gi === "15" ? "M15" : gi === "30" ? "M30" : gi === "60" ? "H1" : gi === "240" ? "H4" : gi === "1D" || gi === "D" ? "D1" : "OTHER",
						symbol: hi,
						resolution: gi,
						barTime: Xt / 1e3,
						visible: Le,
						position: wt,
						size: Tt
					}, f = JSON.stringify(d);
					f !== ge && (ge = f, a(d));
				}
				let Ai = jt;
				Ai === "Auto" && (Ai = e.Std.isintraday(C) ? "Daily" : "Weekly");
				let ji = C.symbol.info, Mi = ji?.timezone || "Etc/UTC", Ni = ji?.session || "24x7";
				(Mi !== te || Ni !== ne) && (te = Mi, ne = Ni, j = Ht(Ni, Mi));
				let Pi = NaN, Fi = NaN, Ii = NaN, Li = NaN, J = NaN, Ri = NaN, zi = NaN, Bi = NaN, Y = NaN, Vi = NaN, Hi = NaN, Ui = NaN, Wi = NaN, Gi = NaN;
				if (isFinite(Xt)) {
					let e = j(Xt / 1e3), t = /* @__PURE__ */ new Date(e * Vc), n = Ai === "Weekly" ? e - t.getUTCDay() : Ai === "Monthly" ? Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 1) / Vc : e;
					if (Xt === ee ? (isNaN(w) || (w = Math.max(w, qt)), isNaN(T) || (T = Math.min(T, Jt)), E = K) : (isNaN(S) ? (S = n, w = qt, T = Jt, E = K) : n === S ? (w = Math.max(w, qt), T = Math.min(T, Jt), E = K) : (D = w, O = T, k = E, S = n, w = qt, T = Jt, E = K), ee = Xt), !isNaN(D) && !isNaN(O) && !isNaN(k)) {
						let e = z({
							high: D,
							low: O,
							close: k
						});
						Pi = e.r1, Fi = e.r2, Ii = e.r3, Li = e.r4, J = e.r5, Ri = e.r6, zi = e.r7, Bi = e.s1, Y = e.s2, Vi = e.s3, Hi = e.s4, Ui = e.s5, Wi = e.s6, Gi = e.s7;
					}
				}
				let Ki = Qt.get(1), qi = $t.get(1), Ji = Math.abs(K - Kt), Yi = qt - Math.max(K, Kt), Xi = Math.min(K, Kt) - Jt, Zi = Xi > 2 * Ji && Xi > Yi * 2 && Ji > 0, Qi = Yi > 2 * Ji && Yi > Xi * 2 && Ji > 0, X = K > Kt && qi < Ki && K > Ki && Kt < qi, $i = K < Kt && qi > Ki && K < Ki && Kt > qi, ea = (Zi || X) && Jt <= mn, ta = (Qi || $i) && qt >= pn, na = e.Std.isintraday(C), ra = parseInt(String(e.Std.interval(C)), 10), ia = bi && na && ra <= 3, aa = (e) => H && !ia ? e : NaN;
				ke && (M = re);
				let oa = (!na || ra >= 15) && I >= 2;
				re = Ve ? xc(M, {
					barIndex: I,
					bullGap: oa && Jt > tn.get(2),
					bearGap: oa && qt < nn.get(2),
					high: qt,
					high2: tn.get(2),
					low: Jt,
					low2: nn.get(2),
					startTime: Ci.get(2) / 1e3,
					time: Xt / 1e3
				}, He) : hc, ke && (N = P, ie = ae), P = _c(N, {
					barIndex: I,
					time: Xt / 1e3,
					open: Kt,
					close: K,
					bullFlag: U && di && isFinite(vi),
					bearFlag: U && fi && isFinite(vi)
				});
				let sa = e.Std.sma(Si, 30, C) * 3;
				ae = vc(ie, {
					barIndex: I,
					time: Xt / 1e3,
					high: qt,
					low: Jt,
					offset: sa,
					ratio: Zr,
					bullBreak: Ie && $r && isFinite(sa),
					bearBreak: Ie && ei && isFinite(sa)
				});
				let ca = le.step({
					isBarClosed: C.symbol.isBarClosed === !0,
					isLastBar: Ae,
					isNewBar: ke,
					time: Xt,
					trigger: di ? 1 : fi ? -1 : 0
				}, {
					blinks: zt,
					enabled: Rt,
					hz: Bt,
					test: Gt,
					transparency: Wt
				}, Date.now());
				ke && (oe = se);
				let la = cn(St, e.Std.highest(tn, St, C)), ua = cn(St, e.Std.lowest(nn, St, C));
				if (Ae) {
					let n = {
						..._i,
						time: Xt / 1e3
					};
					(ca.fired || ke) && t.onFlash({
						...n,
						fromTime: Ci.get(Math.min(400 - !!ca.fired, I)) / 1e3,
						high: cn(60, e.Std.highest(tn, 60, C)),
						low: cn(60, e.Std.lowest(nn, 60, C)),
						direction: ca.direction < 0 ? "sell" : "buy",
						enabled: Rt,
						test: Gt,
						triggered: ca.fired,
						playsOnNextBar: ca.fired,
						showBackground: Vt,
						showBanner: Ut,
						blinks: zt,
						hz: Bt,
						transparency: Wt
					});
					let r = U ? qc(di, fi) : null, a = r && isFinite(vi) ? Ei(0, r) : U ? ce : null, o = a ? {
						..._i,
						...a,
						lastBarTime: Xt / 1e3,
						shown: !0
					} : {
						...n,
						direction: "bull",
						entry: NaN,
						sl: NaN,
						tp1: NaN,
						tp2: NaN,
						tp3: NaN,
						lastBarTime: Xt / 1e3,
						shown: !1
					}, s = JSON.stringify(o);
					s !== he && (he = s, i(o));
					let c = {
						...n,
						barIndex: I,
						boxes: [...re.bull, ...re.bear]
					}, l = JSON.stringify(c.boxes);
					l !== F && (F = l, t.onFvg(c));
					let u = P[P.length - 1], d = [
						I,
						P.length,
						u?.createdIndex,
						u?.side,
						u?.top,
						u?.bottom
					].join();
					d !== pe && (pe = d, t.onReEntries({
						...n,
						barIndex: I,
						boxes: P
					}));
					let f = ae[ae.length - 1], p = [
						ae.length,
						f?.createdIndex,
						f?.price,
						f?.ratio
					].join();
					p !== me && (me = p, t.onVolumes({
						...n,
						labels: ae
					}));
					let m = [];
					if (Re) {
						let e = Sc(K, na, ra);
						se = Cc(oe, $t.get(1), e, Et), m = wc(se, e, Et).map((e) => ({
							above: Ot && e > K,
							price: e
						}));
					}
					let h = {
						...n,
						fromTime: Ci.get(Math.min(40, I)) / 1e3,
						glowHalf: Ot ? At * xi : 0,
						glowOpacity: kt,
						levels: m,
						lineWidth: Dt
					}, g = JSON.stringify(h);
					g !== ue && (ue = g, t.onKeyLevels(h));
					let _ = {
						...n,
						fromTime: Ci.get(Math.min(St, I)) / 1e3,
						levels: Be && Ct ? Tc($t, sn, la, ua, I, St, bt, xt) : []
					}, v = JSON.stringify(_);
					v !== de && (de = v, t.onKde(_));
					let y = [
						zi,
						Ri,
						J,
						Li,
						Ii,
						Fi,
						Pi,
						Bi,
						Y,
						Vi,
						Hi,
						Ui,
						Wi,
						Gi
					], b = {
						...n,
						labelPosition: Pt,
						levels: ze ? Hc.flatMap((e, t) => Lt[t] && Number.isFinite(y[t]) ? [{
							name: e,
							price: y[t]
						}] : []) : [],
						lineWidth: Ft,
						rightOffset: It,
						showLabels: Mt,
						showPrices: Nt
					}, x = JSON.stringify(b);
					x !== fe && (fe = x, t.onPivots(b));
				}
				return ke && (n = I), [
					H ? dn : NaN,
					H ? fn : NaN,
					H ? pn : NaN,
					H ? mn : NaN,
					H ? hn : NaN,
					H ? gn : NaN,
					je && rt ? _n : NaN,
					+!!bn,
					je && it ? vn : NaN,
					je && at ? yn : NaN,
					Me ? Pn : NaN,
					Me ? Fn : NaN,
					Pe ? _r : NaN,
					+!!vr,
					zr,
					Ie && Jr ? 1 : NaN,
					Ie && Yr ? 1 : NaN,
					Ie && $r ? 1 : NaN,
					Ie && ei ? 1 : NaN,
					Fe && di ? Di - ki : NaN,
					Fe && fi ? Oi + ki : NaN,
					ea ? 1 : NaN,
					ta ? 1 : NaN,
					aa(dn),
					aa(pn),
					aa(hn),
					aa(fn),
					aa(mn),
					aa(gn),
					Vt ? ca.stripe : NaN
				];
			};
		}
	};
}, Yc = "#1E88E5", Xc = "#FFFFFF", Zc = "#FFD600", Qc = "#787B86", $c = "#FDD835", el = "#FDD835", tl = {
	dark: "#5A5C64",
	light: "#9A9CA4"
}, nl = "rgba(0, 0, 0, 0)", rl = 8, il = 9, al = 12, ol = 7, sl = 10, cl = 10, ll = 24, ul = (e) => {
	let t = R.getFixedT(e.language ?? "en", F);
	return Pn({
		studyName: e.studyName,
		label: "Cypher",
		reanchor: !0,
		studyBehindDrawings: !0,
		themeAware: !0,
		anchorsFor: (e, t, n, r) => {
			let i = r(t.lastBarTime, rl);
			return {
				labelTime: i,
				lineRight: i
			};
		},
		specsFor: (n, { fmt: r, theme: i }) => {
			if (!n.shown) return [];
			let a = n.direction === "bull" ? `▲ ${t("buy").toUpperCase()}` : `▼ ${t("sell").toUpperCase()}`, o = (e, t, n) => [
				{
					kind: "line",
					price: e,
					color: tl[i],
					width: 1,
					style: "dotted"
				},
				{
					kind: "tag",
					price: e,
					color: t,
					text: n,
					textColor: Xc,
					fontSize: il
				},
				{
					kind: "pointer",
					price: e,
					color: t,
					size: al
				}
			];
			return [
				...o(n.sl, e.bearColor, ` ${t("sl")}: ${r(n.sl)} `),
				...o(n.entry, Yc, ` ${a} ${r(n.entry)} `),
				...o(n.tp1, e.bullColor, ` ${t("tp", { n: 1 })}: ${r(n.tp1)} `),
				...o(n.tp2, e.bullColor, ` ${t("tp", { n: 2 })}: ${r(n.tp2)} `),
				...o(n.tp3, e.bullColor, ` ${t("tp", { n: 3 })}: ${r(n.tp3)} `)
			];
		}
	});
}, dl = ({ studyName: e }) => Pn({
	studyName: e,
	label: "Cypher FVG",
	studyBehindDrawings: !0,
	anchorsFor: jn,
	specsFor: (e, { barsAfter: t }) => e.boxes.map((n) => ({
		kind: "box",
		top: n.top,
		bottom: n.bottom,
		fromTime: n.startTime,
		toTime: Number.isFinite(n.endTime) ? n.endTime : t(e.time, n.createdIndex + 10 - e.barIndex),
		fill: p(Zc, 85),
		border: p(Zc, 40)
	}))
}), fl = ({ studyName: e, bearColor: t, bullColor: n, language: r }) => {
	let i = R.getFixedT(r ?? "en", F);
	return Pn({
		studyName: e,
		label: "Cypher re-entry",
		studyBehindDrawings: !0,
		anchorsFor: jn,
		specsFor: (e, { barsAfter: r }) => e.boxes.map((a) => {
			let o = a.side === "bull" ? n : t, s = (t) => r(e.time, t - e.barIndex);
			return {
				kind: "box",
				top: a.top,
				bottom: a.bottom,
				fromTime: Number.isFinite(a.startTime) ? a.startTime : s(a.createdIndex + 1),
				toTime: Number.isFinite(a.endTime) ? a.endTime : s(a.createdIndex + 8),
				fill: p(o, 85),
				border: p(o, 40),
				text: i("cypher.reEntry"),
				textColor: p(o, 30),
				fontSize: ol
			};
		})
	});
}, pl = ({ studyName: e }) => Pn({
	studyName: e,
	label: "Cypher volume",
	studyBehindDrawings: !0,
	anchorsFor: jn,
	specsFor: (e) => e.labels.map((e) => ({
		kind: "line",
		price: e.price,
		color: nl,
		fromTime: e.time,
		toTime: e.time,
		style: "solid",
		text: yc(e.ratio),
		textAlign: "center",
		textColor: el,
		fontSize: sl
	}))
}), ml = ({ studyName: e, bearColor: t, bullColor: n, language: r }) => {
	let i = R.getFixedT(r ?? "en", F);
	return Js({
		studyName: e,
		label: "Cypher flash",
		bullColor: n,
		bearColor: t,
		padding: 0,
		banner: {
			buy: `⚡ ${i("cypher.newBuy")} ⚡`,
			sell: `⚡ ${i("cypher.newSell")} ⚡`,
			fontSize: ll
		}
	});
}, hl = ({ studyName: e, bearColor: t, bullColor: n }) => {
	let r = t, i = n;
	return Pn({
		studyName: e,
		label: "Cypher key levels",
		studyBehindDrawings: !0,
		anchorsFor: jn,
		specsFor: (e) => e.levels.flatMap((t) => [...e.glowHalf > 0 ? [{
			kind: "box",
			top: t.price + e.glowHalf,
			bottom: t.price - e.glowHalf,
			fromTime: e.fromTime,
			toTime: e.time,
			fill: p(t.above ? r : i, e.glowOpacity),
			border: nl,
			extendRight: !0
		}] : [], {
			kind: "line",
			price: t.price,
			color: Qc,
			width: e.lineWidth,
			style: "solid",
			fromTime: e.fromTime,
			toTime: e.time,
			extendRight: !0
		}])
	});
}, gl = ({ studyName: e }) => Pn({
	studyName: e,
	label: "Cypher KDE",
	studyBehindDrawings: !0,
	anchorsFor: jn,
	specsFor: (e, { barsAfter: t }) => e.levels.map((n) => ({
		kind: "line",
		price: n,
		color: p($c, 70),
		width: 1,
		style: "dotted",
		fromTime: e.fromTime,
		toTime: t(e.time, 10)
	}))
}), _l = ({ studyName: e, bearColor: t, bullColor: n }) => {
	let r = t, i = n;
	return Pn({
		studyName: e,
		label: "Cypher pivots",
		studyBehindDrawings: !0,
		anchorsFor: jn,
		specsFor: (e, { barsAfter: t, fmt: n }) => e.levels.flatMap((a) => {
			let o = a.name.startsWith("R") ? r : i, s = {
				kind: "line",
				price: a.price,
				color: o,
				width: e.lineWidth,
				style: "solid",
				fromTime: t(e.time, e.rightOffset),
				toTime: t(e.time, e.rightOffset + 60)
			};
			if (!e.showLabels) return [s];
			let c = e.labelPosition !== "Right", l = c ? t(e.time, e.rightOffset - 1) : t(e.time, e.rightOffset + 60 + 1);
			return [s, {
				kind: "line",
				price: a.price,
				color: nl,
				fromTime: l,
				toTime: l,
				style: "solid",
				text: e.showPrices ? `${a.name}  ${n(a.price)}` : a.name,
				textAlign: c ? "right" : "left",
				textColor: o,
				fontSize: cl
			}];
		})
	});
}, vl = { "paneProperties.gridLinesMode": "none" }, yl = { "paneProperties.gridLinesMode": "both" }, bl = [
	"layout_changed",
	"study_event",
	"study_properties_changed"
], xl = (e) => {
	let t = /* @__PURE__ */ new Set(), n = null, r = null, i = (e, t) => {
		try {
			return e.applyOverrides(t ? vl : yl), !0;
		} catch {
			return !1;
		}
	}, a = () => {
		if (!n) return;
		let r = /* @__PURE__ */ new Set();
		at(n, (n) => {
			r.add(n);
			let a = ot(n, e, "Cypher grid");
			if (!a) return;
			let o = a.some((e) => st(n, e.id));
			o === t.has(n) || !i(n, o) || (o ? t.add(n) : t.delete(n));
		});
		for (let e of t) r.has(e) || t.delete(e);
	};
	return {
		attach: (e) => {
			n || (n = e, r = ct(e, bl, a), a());
		},
		destroy: () => {
			r?.(), r = null;
			for (let e of t) i(e, !1);
			t.clear(), n = null;
		}
	};
}, Sl = {
	background: p("#000000", 20),
	frame: "#333333",
	activeTf: "#333333",
	inactiveTf: "#111111",
	inactiveArrows: "#0a0a0a",
	header: "#1a1a1a",
	value: "#111111",
	text: "#FFFFFF",
	dimText: p("#FFFFFF", 50),
	headerText: p("#FFFFFF", 30),
	neutral: "#787B86",
	yellow: "#FDD835",
	orange: "#FF9800"
}, Cl = {
	Tiny: 8,
	Small: 10,
	Normal: 14
}, wl = [
	"M1",
	"M5",
	"M15",
	"M30",
	"H1",
	"H4",
	"D1"
], Tl = ".chart-markup-table.pane", El = 10, Dl = 100, Ol = 500, kl = t(({ data: e, mountTarget: t, language: n }) => !e || !t || !e.visible ? null : /* @__PURE__ */ c(jl, {
	data: e,
	mountTarget: t,
	language: n
}, e.position));
kl.displayName = "CypherTable";
var Al = (e, t, n) => {
	let r = t.getBoundingClientRect(), i = t.querySelector(Tl)?.getBoundingClientRect() ?? r, a = i.left - r.left, o = i.top - r.top, s = n.endsWith("Left") ? a + El : n.endsWith("Right") ? a + i.width - e.offsetWidth - El : a + (i.width - e.offsetWidth) / 2, c = n.startsWith("Top") ? o + El : o + i.height - e.offsetHeight - El;
	e.style.left = `${Math.max(0, s)}px`, e.style.right = "auto", e.style.top = `${Math.max(0, c)}px`;
}, jl = ({ data: e, mountTarget: t, language: o }) => {
	let f = i(null), [m, h] = a(null), [g, _] = a(() => t.clientWidth > 0 && t.clientWidth < Ol), v = i(!0), y = e.position, b = R.getFixedT(o ?? "en", F), { panelRef: x, isDragging: S } = d({
		enabled: !0,
		initialPosition: "top-left",
		container: t,
		wholeElementHandle: !0,
		margin: El
	});
	n(() => {
		S && (v.current = !1);
	}, [S]), r(() => {
		let e = x.current;
		if (!e) return;
		let n = () => {
			v.current && Al(e, t, y);
		}, r = new ((t.ownerDocument?.defaultView?.ResizeObserver) ?? window.ResizeObserver)(n);
		r.observe(t), r.observe(e);
		let i = t.querySelector(Tl);
		return i && r.observe(i), n(), () => r.disconnect();
	}, [
		t,
		x,
		y
	]), r(() => {
		let e = f.current;
		if (!e) return;
		let n = () => {
			let n = t.clientWidth;
			n > 0 && _(n < Ol);
			let r = e.offsetWidth, i = e.offsetHeight, a = n - 20;
			if (r <= 0 || a <= 0) return;
			let o = Math.min(1, a / r), s = r * o, c = i * o;
			h((e) => e && e.scale === o && e.width === s && e.height === c ? e : {
				scale: o,
				width: s,
				height: c
			});
		}, r = t.ownerDocument?.defaultView?.ResizeObserver ?? window.ResizeObserver, i = new r(n), a = new r(n);
		return i.observe(t), a.observe(e), n(), () => {
			i.disconnect(), a.disconnect();
		};
	}, [t]);
	let C = Cl.Tiny, w = Cl[e.size], T = (e, t, n) => ({
		padding: "3px 7px",
		border: `1px solid ${Sl.frame}`,
		whiteSpace: "nowrap",
		textAlign: "center",
		background: e,
		color: t,
		fontSize: n,
		lineHeight: 1.25
	}), E = T(Sl.header, Sl.headerText, C), D = e.isBullish ? e.bullColor : e.bearColor, O = e.isBullish ? `${b("bullish")}  ▲` : `${b("bearish")}  ▼`, k = e.state === "Trending" ? b("cypher.trending") : e.state === "Pulling Back" ? b("cypher.pullingBack") : b("cypher.consolidating"), ee = e.strength === "Very Strong" ? b("cypher.veryStrong") : e.strength === "Strong" ? b("cypher.strong") : e.strength === "Neutral" ? b("neutral") : e.strength === "Weak" ? b("cypher.weak") : b("cypher.veryWeak"), te = e.state === "Trending" ? p(e.bullColor, 70) : e.state === "Pulling Back" ? p(e.bearColor, 70) : p(Sl.neutral, 70), ne = e.strength === "Very Strong" ? p(e.bullColor, 50) : e.strength === "Strong" ? p(e.bullColor, 70) : e.strength === "Neutral" ? p(Sl.yellow, 80) : e.strength === "Weak" ? p(Sl.orange, 70) : p(e.bearColor, 60), A = (e) => e ? "▲" : "▼", j = `${A(e.aboveV55)}  |  ${A(e.aboveV233)}  |  ${A(e.aboveV987)}`, M = (t) => {
		let n = e.activeTF === t;
		return T(n ? Sl.activeTf : Sl.inactiveTf, n ? Sl.text : Sl.dimText, C);
	}, re = (t) => {
		let n = e.mtf[t], r = n !== 0, i = n > 0, a = i ? e.bullColor : e.bearColor, o = e.activeTF === t;
		return {
			known: r,
			bull: i,
			style: T(o ? p(a, 80) : Sl.inactiveArrows, r ? a : Sl.dimText, w)
		};
	}, N = [
		{
			key: "trend",
			header: b("cypher.trend"),
			value: "C",
			valueStyle: T(D, Sl.text, w),
			span: 1
		},
		{
			key: "direction",
			header: b("cypher.direction"),
			value: O,
			valueStyle: {
				...T(Sl.value, D, w),
				textTransform: "uppercase"
			},
			span: 1
		},
		{
			key: "state",
			header: b("cypher.state"),
			value: k,
			valueStyle: T(te, Sl.text, w),
			span: 1
		},
		{
			key: "strength",
			header: b("cypher.strength"),
			value: ee,
			valueStyle: T(ne, Sl.text, w),
			span: 1
		},
		{
			key: "levels",
			header: b("cypher.aboveBelow"),
			value: `${e.bullCount} / ${e.totalLevels}`,
			valueStyle: T(Sl.value, Sl.text, w),
			span: 1
		},
		{
			key: "vlevels",
			header: "V55 | V233 | V987",
			value: j,
			valueStyle: T(Sl.value, Sl.text, w),
			span: 2
		}
	], P = {
		...E,
		textTransform: "uppercase"
	}, ie = /* @__PURE__ */ c("div", {
		ref: f,
		style: {
			width: "max-content",
			transform: `scale(${m?.scale ?? 1})`,
			transformOrigin: "top left",
			background: Sl.background,
			border: `1px solid ${Sl.frame}`,
			overflow: "hidden",
			color: Sl.text,
			fontVariantNumeric: "tabular-nums"
		},
		children: g ? /* @__PURE__ */ c("table", {
			style: { borderCollapse: "collapse" },
			children: /* @__PURE__ */ l("tbody", { children: [wl.map((e) => {
				let { known: t, bull: n, style: r } = re(e);
				return /* @__PURE__ */ l("tr", { children: [/* @__PURE__ */ c("td", {
					style: M(e),
					children: b(`tf${e}`)
				}), /* @__PURE__ */ c("td", {
					style: r,
					children: t ? n ? "▲▲" : "▼▼" : "—"
				})] }, e);
			}), N.map((e) => /* @__PURE__ */ l("tr", { children: [/* @__PURE__ */ c("td", {
				style: P,
				children: e.header
			}), /* @__PURE__ */ c("td", {
				style: e.valueStyle,
				children: e.value
			})] }, e.key))] })
		}) : /* @__PURE__ */ c("table", {
			style: { borderCollapse: "collapse" },
			children: /* @__PURE__ */ l("tbody", { children: [
				/* @__PURE__ */ c("tr", { children: wl.map((e) => /* @__PURE__ */ c("td", {
					style: M(e),
					children: b(`tf${e}`)
				}, e)) }),
				/* @__PURE__ */ c("tr", { children: wl.map((e) => {
					let { known: t, bull: n, style: r } = re(e);
					return /* @__PURE__ */ c("td", {
						style: r,
						children: t ? /* @__PURE__ */ l(s, { children: [/* @__PURE__ */ c("div", { children: n ? "▲" : "▼" }), /* @__PURE__ */ c("div", { children: n ? "▲" : "▼" })] }) : "—"
					}, e);
				}) }),
				/* @__PURE__ */ c("tr", { children: N.map((e) => /* @__PURE__ */ c("td", {
					style: P,
					colSpan: e.span,
					children: e.header
				}, e.key)) }),
				/* @__PURE__ */ c("tr", { children: N.map((e) => /* @__PURE__ */ c("td", {
					style: e.valueStyle,
					colSpan: e.span,
					children: e.value
				}, e.key)) })
			] })
		})
	});
	return u(/* @__PURE__ */ c("div", {
		ref: x,
		role: "group",
		style: {
			position: "absolute",
			zIndex: Dl,
			cursor: S ? "grabbing" : "grab",
			userSelect: "none",
			WebkitUserSelect: "none",
			...m ? {
				width: m.width,
				height: m.height,
				overflow: "hidden"
			} : null
		},
		children: ie
	}), t);
}, Ml = 75, Nl = 36, Pl = ".chart-markup-table.pane", Fl = 99, Il = t(({ text: e, color: t, mountTarget: n }) => {
	let a = i(null);
	return r(() => {
		let e = a.current;
		if (!e) return;
		let t = () => {
			let t = n.getBoundingClientRect(), r = n.querySelector(Pl)?.getBoundingClientRect() ?? t;
			e.style.left = `${r.left - t.left + r.width / 2}px`, e.style.top = `${r.top - t.top + r.height / 2}px`;
		}, r = new ((n.ownerDocument?.defaultView?.ResizeObserver) ?? window.ResizeObserver)(t);
		r.observe(n);
		let i = n.querySelector(Pl);
		return i && r.observe(i), t(), () => r.disconnect();
	}, [n]), u(/* @__PURE__ */ c("div", {
		ref: a,
		"aria-hidden": !0,
		style: {
			position: "absolute",
			transform: "translate(-50%, -50%)",
			zIndex: Fl,
			color: p(t, Ml),
			fontSize: Nl,
			lineHeight: 1,
			whiteSpace: "nowrap",
			pointerEvents: "none",
			userSelect: "none",
			WebkitUserSelect: "none"
		},
		children: e
	}), n);
});
Il.displayName = "CypherWatermark";
//#endregion
//#region src/components/cypher/cypherIndicator.tsx
var Ll = (e) => typeof e == "string" ? e : "", Rl = /^#[0-9A-Fa-f]{6}$/, zl = ({ data: e, mountTarget: t, language: n }) => /* @__PURE__ */ l(s, { children: [e && t ? /* @__PURE__ */ c(Il, {
	text: e.studyName,
	color: e.bearColor,
	mountTarget: t
}) : null, /* @__PURE__ */ c(kl, {
	data: e,
	mountTarget: t,
	language: n
})] }), Bl = $o({
	denied: {
		name: "",
		brand_color_1: "",
		brand_color_2: ""
	},
	parse: (e) => {
		let t = Ll(e.name), n = Ll(e.brand_color_1), r = Ll(e.brand_color_2);
		return !t || !Rl.test(n) || !Rl.test(r) ? null : {
			name: t,
			brand_color_1: n,
			brand_color_2: r
		};
	},
	devPreview: {
		name: "Cypher (Dev)",
		brand_color_1: "#9236da",
		brand_color_2: "#4caf50"
	}
}), Vl = class extends Xe {
	renderPanels = Ye(zl);
	preferences;
	drawings;
	fvgDrawings;
	keyLevelDrawings;
	kdeDrawings;
	pivotDrawings;
	reEntryDrawings;
	volumeDrawings;
	flash;
	grid;
	panels;
	constructor(e, t) {
		super(e, t), this.preferences = this.settings(Bl).preferences;
		let n = {
			studyName: this.preferences.name,
			bullColor: this.preferences.brand_color_2,
			bearColor: this.preferences.brand_color_1,
			language: e.language
		};
		this.drawings = this.own(ul(n)), this.fvgDrawings = this.own(dl(n)), this.keyLevelDrawings = this.own(hl(n)), this.kdeDrawings = this.own(gl(n)), this.pivotDrawings = this.own(_l(n)), this.reEntryDrawings = this.own(fl(n)), this.volumeDrawings = this.own(pl(n)), this.flash = this.own(ml(n)), this.grid = this.own(xl(this.preferences.name)), this.panels = this.own(mc({
			studyName: this.preferences.name,
			label: "Cypher",
			datafeed: e.datafeed,
			ticker: e.ticker,
			onUpdate: this.publish,
			buildData: (e, t, n) => ({
				...e,
				mtf: n,
				bullColor: this.preferences.brand_color_2,
				bearColor: this.preferences.brand_color_1,
				studyName: this.preferences.name
			})
		}));
	}
	studies(e) {
		return [Jc(e, {
			onSignal: this.drawings.onSignal,
			onTableUpdate: this.panels.onSnapshot,
			onFvg: this.fvgDrawings.onSignal,
			onKeyLevels: this.keyLevelDrawings.onSignal,
			onKde: this.kdeDrawings.onSignal,
			onPivots: this.pivotDrawings.onSignal,
			onReEntries: this.reEntryDrawings.onSignal,
			onVolumes: this.volumeDrawings.onSignal,
			onFlash: this.flash.onSignal
		}, this.preferences, this.ctx.language)];
	}
	onChartReady(e) {
		this.drawings.attach(e), this.fvgDrawings.attach(e), this.keyLevelDrawings.attach(e), this.kdeDrawings.attach(e), this.pivotDrawings.attach(e), this.reEntryDrawings.attach(e), this.volumeDrawings.attach(e), this.flash.attach(e), this.grid.attach(e);
	}
	onDocumentReady(e, t) {
		this.panels.attach(e, t);
	}
}, Hl = (e) => {
	let t = jo(e);
	return {
		sl: t.bearish.fill,
		entry: t.blue.fill,
		tp: t.bullish.fill
	};
}, Ul = 6, Wl = (e) => {
	let t = R.getFixedT(e.language ?? "en", F), n = e.labelOffsetBars ?? Ul, r = (t) => {
		let n = Hl(t);
		return {
			sl: e.slColor || n.sl,
			entry: e.entryColor || n.entry,
			tp: e.tpColor || n.tp
		};
	};
	return Pn({
		studyName: e.studyName,
		label: "Optimus",
		reanchor: !0,
		themeAware: !0,
		blockStaleOnDuplicateRemoval: !0,
		anchorsFor: Mn(n),
		specsFor: (e, { fmt: n, theme: i }) => {
			let a = r(i), o = e.direction === "long" ? `▲ ${t("long").toUpperCase()}` : `▼ ${t("short").toUpperCase()}`;
			return [
				{
					kind: "line",
					price: e.sl,
					color: a.sl
				},
				{
					kind: "label",
					price: e.sl,
					color: a.sl,
					text: ` ${t("sl")}: ${n(e.sl)} `
				},
				{
					kind: "line",
					price: e.entry,
					color: a.entry,
					width: 2
				},
				{
					kind: "label",
					price: e.entry,
					color: a.entry,
					text: ` ${o} ${n(e.entry)} `
				},
				...e.tps.flatMap((e, r) => [{
					kind: "line",
					price: e,
					color: a.tp
				}, {
					kind: "label",
					price: e,
					color: a.tp,
					text: ` ${t("tp", { n: r + 1 })}: ${n(e)} `
				}])
			];
		}
	});
}, Gl = {
	band: "#1E5AF0",
	mid: "#9598A1",
	fill: "#1E5AF0",
	ema: "#FFB02E",
	lrc: "#00E5FF",
	long: "#00D95F",
	short: "#FF394A"
}, Kl = "Optimus Prime Strategy", ql = (e, t, n, r, i, a) => {
	let o = R.getFixedT(a || "en", F), s = Gl, c = e.Std;
	return {
		name: Kl,
		metainfo: {
			_metainfoVersion: 53,
			id: "OptimusPrimeStrategy@tv-basicstudies-1",
			description: Kl,
			shortDescription: "Optimus",
			format: { type: "inherit" },
			is_price_study: !0,
			isCustomIndicator: !0,
			linkedToSeries: !0,
			plots: [
				{
					id: "kc_upper",
					type: "line"
				},
				{
					id: "kc_mid",
					type: "line"
				},
				{
					id: "kc_lower",
					type: "line"
				},
				{
					id: "ema",
					type: "line"
				},
				{
					id: "lrc",
					type: "line"
				},
				{
					id: "long",
					type: "shapes"
				},
				{
					id: "short",
					type: "shapes"
				}
			],
			filledAreas: [{
				id: "kc_fill",
				objAId: "kc_upper",
				objBId: "kc_lower",
				type: "plot_plot",
				title: o("optimus.keltnerFill")
			}],
			styles: {
				kc_upper: { title: o("optimus.kcUpper") },
				kc_mid: { title: o("optimus.kcMid") },
				kc_lower: { title: o("optimus.kcLower") },
				ema: { title: "EMA 15" },
				lrc: { title: "LRC 52" },
				long: {
					title: o("long"),
					text: o("long").toUpperCase()
				},
				short: {
					title: o("short"),
					text: o("short").toUpperCase()
				}
			},
			defaults: {
				inputs: {
					kcLength: 52,
					kcMult: 3.5,
					atrLength: 10,
					emaLength: 15,
					lrcLength: 52,
					swingLookback: 20,
					rrTp1: 1,
					rrTp2: 2,
					rrTp3: 3,
					rrTp4: 4,
					minRisk: 2,
					buffer: .2,
					requireAlign: !0
				},
				filledAreasStyle: { kc_fill: {
					color: s.fill,
					transparency: 92,
					visible: !0
				} },
				styles: {
					kc_upper: {
						color: s.band,
						linewidth: 1,
						linestyle: 0,
						plottype: 0,
						transparency: 0,
						visible: !0
					},
					kc_mid: {
						color: s.mid,
						linewidth: 2,
						linestyle: 0,
						plottype: 0,
						transparency: 0,
						visible: !0
					},
					kc_lower: {
						color: s.band,
						linewidth: 1,
						linestyle: 0,
						plottype: 0,
						transparency: 0,
						visible: !0
					},
					ema: {
						color: s.ema,
						linewidth: 2,
						linestyle: 0,
						plottype: 0,
						transparency: 0,
						visible: !0
					},
					lrc: {
						color: s.lrc,
						linewidth: 2,
						linestyle: 0,
						plottype: 0,
						transparency: 0,
						visible: !0
					},
					long: {
						color: s.long,
						textColor: s.long,
						plottype: "shape_arrow_up",
						location: "BelowBar",
						size: "small",
						transparency: 0,
						visible: !0
					},
					short: {
						color: s.short,
						textColor: s.short,
						plottype: "shape_arrow_down",
						location: "AboveBar",
						size: "small",
						transparency: 0,
						visible: !0
					}
				}
			},
			inputs: [
				{
					id: "kcLength",
					name: o("optimus.input.kcLength"),
					type: "integer",
					defval: 52,
					min: 1,
					max: 5e3
				},
				{
					id: "kcMult",
					name: o("optimus.input.kcMult"),
					type: "float",
					defval: 3.5,
					min: .1,
					max: 50
				},
				{
					id: "atrLength",
					name: o("optimus.input.atrLength"),
					type: "integer",
					defval: 10,
					min: 1,
					max: 5e3
				},
				{
					id: "emaLength",
					name: o("optimus.input.emaLength"),
					type: "integer",
					defval: 15,
					min: 1,
					max: 5e3
				},
				{
					id: "lrcLength",
					name: o("optimus.input.lrcLength"),
					type: "integer",
					defval: 52,
					min: 1,
					max: 5e3
				},
				{
					id: "swingLookback",
					name: o("optimus.input.swingLookback"),
					type: "integer",
					defval: 20,
					min: 2,
					max: 5e3
				},
				{
					id: "rrTp1",
					name: o("optimus.input.rrTp1"),
					type: "float",
					defval: 1,
					min: .1,
					max: 100
				},
				{
					id: "rrTp2",
					name: o("optimus.input.rrTp2"),
					type: "float",
					defval: 2,
					min: .1,
					max: 100
				},
				{
					id: "rrTp3",
					name: o("optimus.input.rrTp3"),
					type: "float",
					defval: 3,
					min: .1,
					max: 100
				},
				{
					id: "rrTp4",
					name: o("optimus.input.rrTp4"),
					type: "float",
					defval: 4,
					min: .1,
					max: 100
				},
				{
					id: "minRisk",
					name: o("optimus.input.minRisk"),
					type: "float",
					defval: 2,
					min: 0,
					max: 1e5
				},
				{
					id: "buffer",
					name: o("optimus.input.buffer"),
					type: "float",
					defval: .2,
					min: 0,
					max: 1e5
				},
				{
					id: "requireAlign",
					name: o("optimus.input.requireAlign"),
					type: "bool",
					defval: !0
				}
			]
		},
		constructor: function() {
			let e = NaN;
			this.main = function(a, o) {
				this._context = a, this._input = o, a.select_sym(0);
				let s = Z(this._input(0), 52), l = Z(this._input(1), 3.5), u = Z(this._input(2), 10), d = Z(this._input(3), 15), f = Z(this._input(4), 52), p = Z(this._input(5), 20), m = Z(this._input(6), 1), h = Z(this._input(7), 2), g = Z(this._input(8), 3), v = Z(this._input(9), 4), y = Z(this._input(10), 2), b = Z(this._input(11), .2), x = this._input(12), S = Math.max(s, f, u, p);
				a.setMinimumAdditionalDepth((Number.isFinite(S) ? Math.ceil(S) : 52) + 2);
				let C = c.open(a), w = c.close(a), T = c.high(a), E = c.low(a), D = c.time(a), O = D !== e, k = a.new_unlimited_var(w), ee = a.new_unlimited_var(E), te = a.new_unlimited_var(T), ne = a.new_unlimited_var(ee.get(1)), A = a.new_unlimited_var(te.get(1)), j = a.new_unlimited_var(), M = a.new_unlimited_var(), re = a.new_unlimited_var(), N = a.new_unlimited_var(), P = a.new_unlimited_var(), ie = a.new_unlimited_var(), ae = a.new_unlimited_var(), oe = a.new_unlimited_var(), se = a.new_unlimited_var(), ce = a.new_unlimited_var(), le = a.new_unlimited_var(), F = a.new_unlimited_var(), ue = a.new_unlimited_var(), de = a.new_unlimited_var(), fe = a.new_unlimited_var(), pe = a.new_unlimited_var(), me = a.new_unlimited_var(), he = (e) => Math.min(e, c.n(a) + 1), ge = c.ema(k, he(s), a), _e = c.atr(u, a), ve = ge + l * _e, ye = ge - l * _e, be = c.ema(k, he(d), a), I = c.linreg(k, f, 0), xe = c.lowest(ne, p, a), Se = c.highest(A, p, a), Ce = Math.min(C, w), L = Math.max(C, w), we = w > C, R = w < C, Te = !x || be > ge && I > ge, Ee = !x || be < ge && I < ge, De = we && Te && Ce > Math.max(ge, Math.max(be, I)), Oe = R && Ee && L < Math.min(ge, Math.min(be, I)), ke = _(a, c);
				i && isFinite(D) && (!isFinite(e) || D < e) && i(ke());
				let Ae = j.get(1);
				c.na(Ae) && (Ae = 0);
				let z = Ae, B = M.get(1), V = re.get(1), H = N.get(1), je = P.get(1), Me = ie.get(1), Ne = ae.get(1), Pe = se.get(1), Fe = !1, Ie = NaN;
				Ae > 0 && (E <= V || T >= Ne || Oe) ? (z = 0, Fe = !0, Ie = E <= V ? V : T >= Ne ? Ne : w) : Ae < 0 && (T >= V || E <= Ne || De) && (z = 0, Fe = !0, Ie = T >= V ? V : E <= Ne ? Ne : w);
				let Le = 0, Re = NaN, ze = NaN, Be = NaN, U = NaN, Ve = NaN, He = NaN;
				if (Fe && isFinite(Ie) && isFinite(B) && isFinite(V)) {
					let e = Math.abs(B - V), t = Ae > 0 ? Ie - B : B - Ie;
					Le = 1, Re = Ae, ze = B, Be = Ie, U = e > 0 ? t / e : 0, Ve = Pe, He = D;
				}
				let Ue = (e, t) => {
					let n = t ? e : NaN;
					return c.na(n) || !isFinite(n) || n < y ? y : n;
				}, We = !1, Ge = !1;
				if (z === 0) {
					if (De) {
						let e = Ue(w - xe + b, !c.na(xe) && xe > 0 && xe < w);
						w - e <= 0 && (e = y), z = 1, B = w, V = w - e, H = w + m * e, je = w + h * e, Me = w + g * e, Ne = w + v * e, We = !0;
					} else if (Oe) {
						let e = Ue(Se - w + b, !c.na(Se) && Se > w);
						z = -1, B = w, V = w + e, H = w - m * e, je = w - h * e, Me = w - g * e, Ne = w - v * e, Ge = !0;
					}
				}
				(We || Ge) && (Pe = D), z === 0 && (B = NaN, V = NaN, H = NaN, je = NaN, Me = NaN, Ne = NaN, Pe = NaN), j.set(z), M.set(B), re.set(V), N.set(H), P.set(je), ie.set(Me), ae.set(Ne), se.set(Pe), ce.set(We || Ge ? 1 : 0), le.set(Le), F.set(Re), ue.set(ze), de.set(Be), fe.set(U), pe.set(Ve), me.set(He);
				let Ke = oe.get(1), qe;
				qe = We || Ge ? B : z > 0 ? c.na(Ke) ? T : Math.max(Ke, T) : z < 0 ? c.na(Ke) ? E : Math.min(Ke, E) : NaN, oe.set(qe);
				let Je = (e) => z > 0 ? qe >= e : z < 0 && qe <= e, Ye = We ? 1 : NaN, Xe = Ge ? 1 : NaN;
				if (t && a.symbol.isLastBar) {
					let { symbol: e, resolution: n } = ke();
					t({
						symbol: e,
						resolution: n,
						active: z !== 0,
						side: z > 0 ? "LONG" : z < 0 ? "SHORT" : null,
						fresh: We || Ge,
						entryTime: Pe,
						entry: B,
						sl: V,
						tps: [
							H,
							je,
							Me,
							Ne
						],
						tpHits: [
							Je(H),
							Je(je),
							Je(Me),
							Je(Ne)
						],
						entryHit: z !== 0,
						price: w,
						maxR: v,
						longSignal: De,
						shortSignal: Oe
					});
				}
				if (n && O && le.get(1) === 1) {
					let e = pe.get(1), t = me.get(1), r = ue.get(1), i = de.get(1), a = F.get(1), o = fe.get(1);
					if (isFinite(r) && isFinite(i) && isFinite(o) && isFinite(e) && (a > 0 || a < 0)) {
						let { symbol: s, resolution: c } = ke();
						n({
							symbol: s,
							resolution: c,
							entryTime: e,
							time: isFinite(t) ? t : e,
							side: a > 0 ? "LONG" : "SHORT",
							entry: r,
							exit: i,
							rMultiple: o,
							win: o > 0
						});
					}
				}
				if (r && O && ce.get(1) === 1) {
					let e = se.get(1), t = j.get(1), n = M.get(1), i = re.get(1), a = N.get(1), o = P.get(1), s = ie.get(1), c = ae.get(1);
					if (isFinite(e) && (t > 0 || t < 0) && isFinite(n) && isFinite(i) && isFinite(a) && isFinite(o) && isFinite(s) && isFinite(c)) {
						let { symbol: l, resolution: u } = ke();
						r({
							symbol: l,
							resolution: u,
							time: Math.floor(e / 1e3),
							direction: t > 0 ? "long" : "short",
							entry: n,
							sl: i,
							tps: [
								a,
								o,
								s,
								c
							]
						});
					}
				}
				return e = D, [
					ve,
					ge,
					ye,
					be,
					I,
					Ye,
					Xe
				];
			};
		}
	};
}, Jl = [
	"XAUUSD",
	"NASUSD",
	"GOLD247"
], Yl = Os(Jl), Xl = 12, Zl = 4, Ql = "4px 8px", $l = 320, eu = nc.map((e) => e.key), tu = (e) => {
	let t = e.trim().toUpperCase();
	return t === "1" ? "M1" : t === "5" ? "M5" : t === "15" ? "M15" : t === "30" ? "M30" : t === "60" ? "H1" : t === "240" ? "H4" : t === "1D" || t === "D" ? "D1" : null;
}, nu = (e) => Number.isFinite(e) ? e >= 100 ? 2 : e >= 10 ? 3 : 5 : 2, ru = (e, t) => Number.isFinite(e) ? e.toFixed(t) : "—", iu = (e) => Number.isFinite(e) ? new Date(e).toLocaleTimeString([], {
	hour: "2-digit",
	minute: "2-digit",
	hour12: !1
}) : "—:—", au = (e) => `${e >= 0 ? "+" : "−"}${Math.abs(e).toFixed(1)}R`, ou = (e) => {
	let t = new Date(e);
	return `${t.getFullYear()}-${t.getMonth()}-${t.getDate()}`;
}, su = (e) => new Date(e).toLocaleDateString([], {
	day: "2-digit",
	month: "short"
}), cu = (e) => {
	let t = new Set(e.filter((e) => Number.isFinite(e.entryTime)).map((e) => ou(e.entryTime))), n = t.size > 1 || t.size === 1 && !t.has(ou(Date.now())), r = [], i = null;
	return e.forEach((e, t) => {
		let a = Number.isFinite(e.entryTime) ? ou(e.entryTime) : null;
		n && a && a !== i && (r.push({
			kind: "day",
			key: `day-${a}`,
			label: su(e.entryTime)
		}), i = a), r.push({
			kind: "trade",
			key: `${e.entryTime}-${t}`,
			trade: e
		});
	}), r;
}, lu = "40px 50px minmax(0, 1fr) auto", uu = (e) => ({
	...Q.micro,
	color: e.textMuted,
	padding: "4px 8px 0"
}), du = (e) => ({
	boxSizing: "border-box",
	textAlign: "center",
	...Q.micro,
	fontWeight: 600,
	letterSpacing: ".4px",
	padding: "2px 4px",
	borderRadius: 4,
	color: e.textOnTint,
	background: e.tintMedium
}), fu = t(({ data: e, mountTarget: t, theme: n = "dark", language: r }) => !e || !t ? null : /* @__PURE__ */ c(mu, {
	data: e,
	mountTarget: t,
	theme: n,
	language: r
}));
fu.displayName = "OptimusTable";
var pu = ({ size: e = 14 }) => /* @__PURE__ */ l("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	"aria-hidden": "true",
	children: [/* @__PURE__ */ c("rect", {
		x: "5",
		y: "3",
		width: "5",
		height: "18",
		rx: "1"
	}), /* @__PURE__ */ c("rect", {
		x: "14",
		y: "3",
		width: "5",
		height: "18",
		rx: "1"
	})]
}), mu = ({ data: e, mountTarget: t, theme: n, language: r }) => {
	let i = jo(n), a = R.getFixedT(r ?? "en", F), o = (e) => a(e === "SHORT" ? "short" : "long").toUpperCase(), s = nu(e.price), u = e.side === "SHORT", d = u ? i.bearish : i.bullish, f = e.active ? d : i.amber, p = e.active ? a("optimus.enter", { side: o(e.side) }) : a("optimus.wait"), m = e.active ? u ? "▼" : "▲" : /* @__PURE__ */ c(pu, {}), h = e.active ? a("optimus.reasonLatched") : e.longSignal || e.shortSignal ? a("optimus.reasonForming") : a("optimus.reasonNoSetup"), g = tu(e.resolution), _ = eu.reduce((t, n) => t + +(e.mtf[n] > 0), 0), v = eu.reduce((t, n) => t + +(e.mtf[n] < 0), 0), y = _ + v, b = _ === v, x = _ > v, S = Math.max(_, v), C = y > 0 ? Math.round(S / y * 100) : 0, w = y === 0 ? null : b ? i.amber : x ? i.bullish : i.bearish, T = y === 0 ? a("optimus.warmingUp") : b ? a("optimus.biasMixed", {
		n: _,
		total: y
	}) : a("optimus.biasAgreed", {
		side: a(x ? "bullish" : "bearish").toUpperCase(),
		n: S,
		total: y
	}), E = Math.abs(e.entry - e.sl), D = e.active && E > 0 ? (u ? e.entry - e.price : e.price - e.entry) / E : NaN, O = [
		{
			label: a("sl"),
			value: e.sl,
			tone: "sl",
			hit: !1
		},
		{
			label: a("entry"),
			value: e.entry,
			tone: "entry",
			hit: e.entryHit
		},
		...e.tps.map((t, n) => ({
			label: a("tp", { n: n + 1 }),
			value: t,
			tone: "tp",
			hit: e.tpHits[n]
		}))
	], k = (e, t) => t ? {
		background: i.bullish.tint,
		borderColor: i.bullish.border,
		color: i.textColor
	} : e === "sl" ? {
		background: i.bearish.tint,
		borderColor: i.bearish.border,
		color: i.textColor
	} : e === "entry" ? {
		background: i.blue.tint,
		borderColor: i.blue.border,
		color: i.textColor
	} : {
		background: "transparent",
		borderColor: i.tableGrid,
		color: i.textMuted
	};
	return /* @__PURE__ */ l(Ro, {
		mountTarget: t,
		theme: n,
		width: $l,
		title: "OPTIMUS",
		"aria-label": "Optimus Prime signal panel",
		emblemAccents: [
			i.bullish.fill,
			i.bearish.fill,
			i.amber.fill,
			i.blue.fill
		],
		emblemSize: 20,
		status: p,
		statusColor: f.text,
		children: [
			/* @__PURE__ */ l("div", {
				style: {
					margin: `8px 8px ${Xl}px`,
					borderRadius: 4,
					padding: 8,
					display: "flex",
					alignItems: "center",
					gap: 8,
					background: f.tint,
					border: `1px solid ${f.border}`
				},
				children: [
					/* @__PURE__ */ c("span", {
						style: {
							width: 32,
							height: 32,
							borderRadius: 4,
							display: "grid",
							placeItems: "center",
							...Q.title,
							fontWeight: 600,
							flex: "0 0 auto",
							background: f.tintMedium,
							color: f.textOnTint
						},
						children: m
					}),
					/* @__PURE__ */ l("span", {
						style: { minWidth: 0 },
						children: [/* @__PURE__ */ c("b", {
							style: {
								...Q.body,
								fontWeight: 600,
								display: "block"
							},
							children: p
						}), /* @__PURE__ */ c("span", {
							style: {
								...Q.data,
								color: i.textMuted,
								display: "block"
							},
							children: h
						})]
					}),
					/* @__PURE__ */ l("span", {
						style: {
							marginLeft: "auto",
							textAlign: "right",
							fontVariantNumeric: "tabular-nums"
						},
						children: [/* @__PURE__ */ c("b", {
							style: {
								...Q.body,
								fontWeight: 600,
								color: i.bullish.textOnTint
							},
							children: `1 : ${e.maxR}`
						}), /* @__PURE__ */ c("span", {
							style: {
								...Q.micro,
								color: i.textMuted,
								letterSpacing: ".4px",
								display: "block"
							},
							children: a("optimus.riskReward")
						})]
					})
				]
			}),
			/* @__PURE__ */ l("div", {
				style: { padding: `0 8px ${Xl}px` },
				children: [
					/* @__PURE__ */ c("h4", {
						style: {
							margin: `0 0 ${Zl}px`,
							...Q.micro,
							letterSpacing: ".4px",
							color: i.textMuted,
							textTransform: "uppercase",
							fontWeight: 600
						},
						children: a("optimus.trendMtf")
					}),
					/* @__PURE__ */ l("div", {
						style: {
							border: `1px solid ${i.tableGrid}`,
							borderRadius: 4,
							overflow: "hidden"
						},
						children: [/* @__PURE__ */ c("div", {
							style: {
								display: "grid",
								gridTemplateColumns: "repeat(7,1fr)",
								borderBottom: `1px solid ${i.rowDivider}`
							},
							children: eu.map((e) => /* @__PURE__ */ c("span", {
								style: {
									...Q.micro,
									color: e === g ? i.textColor : i.textMuted,
									fontWeight: e === g ? 600 : 400,
									textAlign: "center",
									padding: "4px 0"
								},
								children: a(`tf${e}`)
							}, e))
						}), /* @__PURE__ */ c("div", {
							style: {
								display: "grid",
								gridTemplateColumns: "repeat(7,1fr)"
							},
							children: eu.map((t) => {
								let n = e.mtf[t], r = n !== 0, a = n > 0, o = a ? i.bullish : i.bearish, s = r && t === g;
								return /* @__PURE__ */ c("span", {
									style: {
										textAlign: "center",
										padding: "4px 0",
										...Q.value,
										color: r ? s ? o.textOnTint : o.text : i.textMuted,
										background: s ? o.tint : "transparent"
									},
									children: r ? a ? "▲" : "▼" : "—"
								}, t);
							})
						})]
					}),
					/* @__PURE__ */ l("div", {
						style: {
							display: "flex",
							alignItems: "center",
							gap: 8,
							marginTop: 8,
							...Q.data,
							color: i.textMuted
						},
						children: [
							/* @__PURE__ */ c("span", { children: a("optimus.bias") }),
							/* @__PURE__ */ c("span", {
								style: {
									flex: 1,
									height: 4,
									borderRadius: 2,
									background: i.tableGrid,
									overflow: "hidden"
								},
								children: /* @__PURE__ */ c("i", { style: {
									display: "block",
									height: "100%",
									width: `${C}%`,
									borderRadius: 2,
									background: w ? w.fill : i.textMuted
								} })
							}),
							/* @__PURE__ */ c("b", {
								style: {
									...Q.micro,
									fontWeight: 600,
									color: w ? w.text : i.textMuted,
									whiteSpace: "nowrap"
								},
								children: T
							})
						]
					})
				]
			}),
			/* @__PURE__ */ l("div", {
				style: { padding: `0 8px ${Xl}px` },
				children: [/* @__PURE__ */ c("h4", {
					style: {
						margin: `0 0 ${Zl}px`,
						...Q.micro,
						letterSpacing: ".4px",
						color: i.textMuted,
						textTransform: "uppercase",
						fontWeight: 600
					},
					children: a("optimus.activeTradeLevels")
				}), /* @__PURE__ */ c("div", {
					style: {
						display: "grid",
						gridTemplateColumns: "repeat(3, 1fr)",
						gap: 4
					},
					children: O.map((e, t) => /* @__PURE__ */ l("div", {
						style: {
							position: "relative",
							textAlign: "center",
							padding: 4,
							borderRadius: 4,
							border: "1px solid",
							fontVariantNumeric: "tabular-nums",
							...k(e.tone, e.hit)
						},
						children: [
							e.hit && /* @__PURE__ */ c("span", {
								style: {
									position: "absolute",
									top: 4,
									right: 4,
									color: i.bullish.textOnTint,
									display: "grid"
								},
								children: /* @__PURE__ */ c(Ns, { size: Q.micro.fontSize })
							}),
							/* @__PURE__ */ c("div", {
								style: {
									...Q.micro,
									letterSpacing: ".4px",
									textTransform: "uppercase",
									color: i.textMuted,
									whiteSpace: "nowrap"
								},
								children: e.label
							}),
							/* @__PURE__ */ c("div", {
								style: {
									...Q.value,
									fontWeight: 600
								},
								children: ru(e.value, s)
							})
						]
					}, t))
				})]
			}),
			/* @__PURE__ */ l("div", {
				style: { padding: `0 8px ${Xl}px` },
				children: [
					/* @__PURE__ */ c("h4", {
						style: {
							margin: `0 0 ${Zl}px`,
							...Q.micro,
							letterSpacing: ".4px",
							color: i.textMuted,
							textTransform: "uppercase",
							fontWeight: 600
						},
						children: a("optimus.recentSignals")
					}),
					e.active && /* @__PURE__ */ l("div", {
						style: {
							display: "grid",
							gridTemplateColumns: lu,
							alignItems: "center",
							columnGap: 8,
							padding: Ql,
							borderRadius: 4,
							marginBottom: 4,
							background: d.tint,
							border: `1px solid ${d.border}`
						},
						children: [
							/* @__PURE__ */ c("span", {
								style: {
									fontVariantNumeric: "tabular-nums",
									...Q.data,
									color: i.textMuted
								},
								children: iu(e.entryTime)
							}),
							/* @__PURE__ */ c("span", {
								style: du(d),
								children: e.side && o(e.side)
							}),
							/* @__PURE__ */ l("span", {
								style: {
									fontVariantNumeric: "tabular-nums",
									...Q.data,
									color: i.textMuted
								},
								children: [
									ru(e.entry, s),
									"→",
									ru(e.price, s)
								]
							}),
							/* @__PURE__ */ c("span", {
								style: {
									fontVariantNumeric: "tabular-nums",
									...Q.value,
									fontWeight: 600,
									textAlign: "right",
									color: D > 0 ? i.bullish.textOnTint : D < 0 ? i.bearish.textOnTint : i.textMuted
								},
								children: Number.isFinite(D) ? au(D) : "—"
							})
						]
					}),
					e.recent.length === 0 && !e.active ? /* @__PURE__ */ c("div", {
						style: {
							padding: 8,
							borderRadius: 4,
							border: `1px dashed ${i.tableGrid}`,
							...Q.data,
							color: i.textMuted,
							textAlign: "center"
						},
						children: a("optimus.noClosedTrades")
					}) : e.recent.length > 0 ? /* @__PURE__ */ c("div", {
						style: {
							display: "flex",
							flexDirection: "column",
							gap: 4
						},
						children: cu(e.recent.slice(0, e.active ? 5 : 6)).map((e) => {
							if (e.kind === "day") return /* @__PURE__ */ c("div", {
								style: uu(i),
								children: e.label
							}, e.key);
							let t = e.trade, n = t.side === "LONG";
							return /* @__PURE__ */ l("div", {
								style: {
									display: "grid",
									gridTemplateColumns: lu,
									alignItems: "center",
									columnGap: 8,
									padding: Ql,
									borderRadius: 4,
									border: `1px solid ${i.tableGrid}`
								},
								children: [
									/* @__PURE__ */ c("span", {
										style: {
											fontVariantNumeric: "tabular-nums",
											...Q.data,
											color: i.textMuted
										},
										children: iu(t.entryTime)
									}),
									/* @__PURE__ */ c("span", {
										style: du(n ? i.bullish : i.bearish),
										children: o(t.side)
									}),
									/* @__PURE__ */ l("span", {
										style: {
											fontVariantNumeric: "tabular-nums",
											...Q.data,
											color: i.textMuted
										},
										children: [
											ru(t.entry, s),
											"→",
											ru(t.exit, s)
										]
									}),
									/* @__PURE__ */ c("span", {
										style: {
											fontVariantNumeric: "tabular-nums",
											...Q.value,
											fontWeight: 600,
											textAlign: "right",
											color: t.win ? i.bullish.text : i.bearish.text
										},
										children: au(t.rMultiple)
									})
								]
							}, e.key);
						})
					}) : null
				]
			}),
			/* @__PURE__ */ c("div", {
				style: {
					padding: "0 8px 8px",
					...Q.micro,
					color: i.textMuted
				},
				children: a("optimus.disclaimer")
			})
		]
	});
}, hu = [], gu = 12, _u = ({ studyName: e, datafeed: t, ticker: n, onUpdate: r }) => {
	let i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = !0, s = mc({
		studyName: e,
		label: "Optimus",
		datafeed: t,
		ticker: n,
		onUpdate: r,
		buildData: (e, t, n) => ({
			...e,
			mtf: n,
			recent: i.get(W(t.symbol, t.resolution)) ?? hu
		})
	});
	return {
		onTableUpdate: s.onSnapshot,
		onClosedTrade: (e) => {
			if (!o || !Number.isFinite(e.entryTime) || !Number.isFinite(e.entry) || !Number.isFinite(e.exit) || !Number.isFinite(e.rMultiple)) return;
			let t = W(e.symbol, e.resolution), n = `${e.entryTime}|${e.side}`, r = a.get(t);
			if (r || (r = /* @__PURE__ */ new Set(), a.set(t, r)), r.has(n)) return;
			r.add(n);
			let c = i.get(t) ?? [];
			c.push(e), c.sort((e, t) => t.entryTime - e.entryTime), i.set(t, c.slice(0, gu)), s.republish();
		},
		onCalcRestart: ({ symbol: e, resolution: t }) => {
			if (!o) return;
			let n = W(e, t);
			a.delete(n), i.delete(n) && s.republish();
		},
		attach: s.attach,
		destroy: () => {
			o && (o = !1, s.destroy(), i.clear(), a.clear());
		}
	};
}, vu = $o({
	denied: {},
	parse: () => ({}),
	devPreview: {}
}), yu = class extends Xe {
	renderPanels = Ye(fu);
	tables;
	drawings;
	studyPolicy;
	constructor(e, t) {
		super(e, t);
		let n = R.getFixedT(e.language || "en", F), r = (t) => e.notify(Kl, t);
		this.tables = this.own(_u({
			studyName: Kl,
			datafeed: e.datafeed,
			ticker: e.ticker,
			onUpdate: this.publish
		})), this.drawings = this.own(Wl({
			studyName: Kl,
			language: e.language
		})), this.studyPolicy = this.own(ss({
			studyName: Kl,
			singleInstance: !0,
			isIntendedSymbol: Yl,
			onDuplicateRemoved: () => {
				this.drawings.invalidateCachedSignals(), r(n("optimus.duplicateRemoved"));
			},
			onUnintendedSymbol: (e, t) => r(n("unintendedSymbol", {
				symbols: Jl.join(", "),
				symbol: t
			}))
		}));
	}
	studies(e) {
		return [ql(e, (e) => this.tables.onTableUpdate(e), (e) => this.tables.onClosedTrade(e), (e) => this.drawings.onSignal(e), (e) => this.tables.onCalcRestart(e), this.ctx.language)];
	}
	onChartReady(e) {
		this.studyPolicy.attach(e), this.drawings.attach(e);
	}
	onDocumentReady(e, t) {
		this.tables.attach(e, t);
	}
}, bu = (e) => {
	let t = [], n = 0, r = NaN, i = NaN, a = NaN, o = NaN, s = NaN, c = NaN, l = (e, t) => {
		n = 1, r = t, i = e;
	}, u = (e, t) => {
		n = -1, r = t, i = e;
	};
	return {
		update: (d, f, p, m) => {
			let h = !1;
			return n === 0 ? ((Number.isNaN(a) || f > a) && (a = f, o = d), (Number.isNaN(s) || p < s) && (s = p, c = d), a - p > m ? (t.push({
				price: a,
				index: o,
				dir: 1
			}), u(d, p), h = !0) : f - s > m && (t.push({
				price: s,
				index: c,
				dir: -1
			}), l(d, f), h = !0)) : n === 1 ? (f > r && (r = f, i = d), r - p > m && (t.push({
				price: r,
				index: i,
				dir: 1
			}), u(d, p), h = !0)) : (p < r && (r = p, i = d), f - r > m && (t.push({
				price: r,
				index: i,
				dir: -1
			}), l(d, f), h = !0)), t.length > e && t.shift(), h;
		},
		pivots: () => t
	};
}, xu = 12, Su = 10, Cu = 1, wu = 3, Tu = [
	1,
	3,
	5
], Eu = (e) => {
	let t = e.length;
	if (t < 3) return null;
	let n = e[t - 1].dir, r = n === 1 ? 1 : -1, i = n === 1, a = (n) => r * e[t - n].price, o = a(1), s = a(2), c = a(3);
	if (t >= 5) {
		let e = a(4), t = a(5), n = Math.min(s, e) + (Math.max(s, e) - Math.min(s, e)) / 2, l = c - n;
		if (l > 0 && c - Math.max(o, t) > .25 * l && Math.abs(o - t) <= .25 * l && o > Math.max(s, e) && t > Math.max(s, e)) return {
			typeId: i ? 4 : 5,
			count: 5,
			neck: r * n,
			target: r * (n - l),
			invalid: r * (c + .5 * l),
			peak: r * c
		};
		let u = Math.min(s, e), d = Math.max(o, Math.max(c, t)), f = d - u;
		if (f > 0 && d - Math.min(o, Math.min(c, t)) <= .25 * f && o > u && c > u && t > u) return {
			typeId: i ? 2 : 3,
			count: 5,
			neck: r * u,
			target: r * (u - f),
			invalid: r * (d + .5 * f),
			peak: r * d
		};
	}
	let l = Math.max(o, c), u = l - s;
	return u > 0 && Math.abs(o - c) <= .25 * u ? {
		typeId: +!i,
		count: 3,
		neck: r * s,
		target: r * (s - u),
		invalid: r * (l + .5 * u),
		peak: r * l
	} : null;
}, Du = (e, t, n) => [
	`${n.chartTooltip.neckline} `,
	{ price: e },
	`\n${n.chartTooltip.target} `,
	{ price: t }
], Ou = (e, t) => {
	let n = [], r = (t) => e.dirFilter === "Both" || e.dirFilter === "Bullish only" && t === 1 || e.dirFilter === "Bearish only" && t === -1, i = (t) => t === 1 ? e.colBull : e.colBear, a = (e) => e.dir === 1 ? " ▲" : " ▼", o = (e) => t.classicNames[e.typeId], s = (e) => {
		e.neckLine = null, e.label = null, e.targetLine = null;
	}, c = (t) => t <= Cu ? e.enDoubles : t <= wu ? e.enTriples : e.enHS, l = (e, n) => {
		let r = i(e.dir);
		e.neckLine = {
			type: "line",
			x1: e.b1,
			y1: e.neck,
			x2: n + Su,
			y2: e.neck,
			color: Y(r.hex, 25),
			style: "solid",
			width: 1
		}, e.label = {
			type: "label",
			x: e.bLast,
			y: e.peak,
			text: o(e) + a(e),
			style: e.dir === 1 ? "label_up" : "label_down",
			color: Y(r.hex, 35),
			textColor: Y(Vi.white, 0),
			size: "small",
			tooltip: Du(e.neck, e.target, t)
		};
	}, u = (e, t) => {
		e.label !== null && (e.label = {
			...e.label,
			text: t
		});
	};
	return {
		objects: () => n.flatMap((e) => [
			e.neckLine,
			e.label,
			e.targetLine
		].filter((e) => e !== null)),
		scan: (t, i) => {
			let a = Eu(t);
			if (a === null || !e.enClassics) return;
			let { typeId: o, count: u, neck: d, target: f, invalid: p, peak: m } = a, h = Tu.includes(o) ? 1 : -1;
			if (!c(o) || !r(h)) return;
			let g = t[t.length - u].index, _ = t[t.length - 1].index, v = `cls${o}-${g}-${_}`;
			if (n.some((e) => e.id === v)) return;
			if (o >= 2) {
				let e = (e) => e.dir === h && e.bLast >= g && e.state <= 1;
				for (let t of n.filter(e)) s(t);
				n = n.filter((t) => !e(t));
			}
			let y = {
				id: v,
				typeId: o,
				dir: h,
				neck: d,
				target: f,
				invalid: p,
				state: 0,
				b1: g,
				bLast: _,
				peak: m,
				neckLine: null,
				targetLine: null,
				label: null
			};
			if (n.push(y), n.length > xu) {
				let e = n.shift();
				e !== void 0 && s(e);
			}
			l(y, i);
		},
		sweep: (e, r) => {
			for (let c of n) if (c.state === 0) {
				let n = c.dir === 1 ? e > c.neck : e < c.neck, l = c.dir === 1 ? e < c.invalid : e > c.invalid;
				n ? (c.state = 1, u(c, `${o(c)}${a(c)} ${t.confirmed}`), c.targetLine = {
					type: "line",
					x1: r,
					y1: c.target,
					x2: r + Su,
					y2: c.target,
					color: Y(i(c.dir).hex, 40),
					style: "dashed",
					width: 1
				}) : l && (c.state = 3, s(c));
			} else c.state === 1 && (c.dir === 1 ? e >= c.target : e <= c.target) && (c.state = 2, u(c, `${o(c)} ✓ ${t.target}`));
		}
	};
}, ku = [
	[
		0,
		.618,
		.618,
		.618,
		3,
		0,
		.618,
		.382,
		.886,
		1,
		1.618,
		1.13,
		1.618,
		1,
		0,
		.786,
		.786,
		.786,
		2,
		0,
		1,
		1,
		0,
		0,
		0,
		0
	],
	[
		1,
		.5,
		.382,
		.5,
		3,
		0,
		.618,
		.382,
		.886,
		1,
		2,
		1.618,
		2.618,
		1,
		0,
		.886,
		.886,
		.886,
		2,
		0,
		1.272,
		1,
		0,
		0,
		0,
		0
	],
	[
		1,
		.382,
		.236,
		.382,
		3,
		0,
		.618,
		.382,
		.886,
		1,
		2.618,
		2,
		3.618,
		1,
		1,
		1.13,
		1,
		1.13,
		2,
		0,
		0,
		1.27,
		1,
		0,
		1.27,
		1
	],
	[
		0,
		.786,
		.786,
		.786,
		3,
		0,
		.618,
		.382,
		.886,
		1,
		1.618,
		1.618,
		2.618,
		1,
		1,
		1.272,
		1.272,
		1.414,
		2,
		0,
		1.272,
		1.618,
		1,
		0,
		1.414,
		1
	],
	[
		1,
		.618,
		.382,
		.618,
		3,
		0,
		.618,
		.382,
		.886,
		1,
		3.14,
		2.618,
		3.618,
		1,
		0,
		1.618,
		1.618,
		1.618,
		2,
		0,
		1.618,
		2,
		2,
		0,
		0,
		0
	],
	[
		1,
		.886,
		.886,
		.99,
		3,
		0,
		.618,
		.382,
		.886,
		1,
		2.618,
		2.24,
		3.618,
		1,
		0,
		1.618,
		1.618,
		1.618,
		2,
		0,
		1.272,
		2,
		2,
		0,
		0,
		0
	],
	[
		1,
		.5,
		.236,
		.886,
		0,
		0,
		1.27,
		1.13,
		1.618,
		2,
		2,
		1.618,
		2.24,
		1,
		1,
		.886,
		.886,
		1.13,
		2,
		0,
		0,
		1.27,
		1,
		2,
		1.272,
		1
	],
	[
		1,
		.5,
		.382,
		.618,
		2,
		1,
		1.272,
		1.272,
		1.414,
		2,
		1,
		.5,
		2,
		0,
		0,
		.786,
		.786,
		.786,
		3,
		1,
		0,
		1,
		0,
		2,
		0,
		1
	]
], $ = {
	bKind: 0,
	bIdeal: 1,
	bLo: 2,
	bHi: 3,
	bWeight: 4,
	cIsXa: 5,
	cIdeal: 6,
	cLo: 7,
	cHi: 8,
	cWeight: 9,
	bcIdeal: 10,
	bcLo: 11,
	bcHi: 12,
	bcWeight: 13,
	xdKind: 14,
	xdIdeal: 15,
	xdLo: 16,
	xdHi: 17,
	xdWeight: 18,
	refXc: 19,
	abcdMult: 20,
	invalidMult: 21,
	stopMode: 22,
	basisMode: 23,
	stopMult: 24,
	entryAtPrzDef: 25
}, Au = [
	"Gartley",
	"Bat",
	"Alt Bat",
	"Butterfly",
	"Crab",
	"Deep Crab",
	"Shark",
	"Cypher"
], ju = {
	projected: 0,
	przActive: 1,
	completed: 2,
	t1: 3,
	t2: 4,
	t3: 5,
	t4: 6,
	stopped: 7,
	invalidated: 8
}, Mu = Y("#2962FF", 0), Nu = Y(Vi.black, 100), Pu = Y(Vi.white, 0), Fu = (e) => e === ju.projected || e === ju.przActive, Iu = (e, t) => Y(e.hex, t), Lu = (e, t) => t > 0 ? e / t : NaN, Ru = (e) => e === 100 ? "AB=CD" : Au[e], zu = (e, t, n, r, i) => ({
	type: "polyline",
	points: e.map((e) => ({
		x: e.index,
		y: e.price
	})),
	closed: t,
	lineColor: n,
	fillColor: r,
	width: i
}), Bu = (e, t, n, r, i) => ({
	type: "line",
	x1: e,
	y1: n,
	x2: t,
	y2: n,
	color: r,
	style: i,
	width: 1
}), Vu = (e, t, n, r) => ({
	type: "label",
	x: e,
	y: t,
	text: `${n} `,
	price: t,
	style: "label_left",
	color: Nu,
	textColor: r,
	size: "tiny"
}), Hu = (e, t) => {
	let n = t.chartTooltip, r = e.dir === 1 ? n.bullish : n.bearish, { entry: i, stop: a, tp1: o, tp2: s } = e.plan;
	return [
		`${Ru(e.typeId)} (${r})\n`,
		`${n.state}: ${n.states[e.state]} | ${n.score} ${String(e.score)}\n`,
		"PRZ ",
		{ price: Math.min(e.przLo, e.przHi) },
		" - ",
		{ price: Math.max(e.przLo, e.przHi) },
		` (${n.confluence} ${String(e.confluence)})\n`,
		`${n.entry} `,
		{ price: i },
		`  ${n.stop} `,
		{ price: a },
		"\nT1 ",
		{ price: o },
		"  T2 ",
		{ price: s }
	];
}, Uu = (e, t, n, r) => {
	let { a: i, b: a, c: o, d: s, x: c } = e.points, l = e.dir === 1 ? n.colBull : n.colBear, u = Fu(e.state), d = Math.abs(i.price - a.price), f = Math.abs(o.price - a.price), p = () => {
		let r = Iu(l, u ? Math.min(96, n.fillTransp + 20) : n.fillTransp), d = Iu(l, 100), f = [
			c,
			i,
			a,
			o,
			s
		].filter((e) => e !== null), p = zu(f, !1, Iu(l, u ? 45 : 0), null, 3);
		if (c === null) return [p, zu(f, !0, d, r, 1)];
		let m = zu([
			c,
			i,
			a
		], !0, d, r, 1);
		return s === null ? [
			p,
			m,
			{
				type: "line",
				x1: o.index,
				y1: o.price,
				x2: t + 10,
				y2: e.przDef,
				color: Iu(l, 40),
				style: "dashed",
				width: 1
			}
		] : [
			p,
			m,
			zu([
				a,
				o,
				s
			], !0, d, r, 1)
		];
	}, m = () => {
		if (c === null) {
			let e = [{
				from: i,
				ratio: Lu(f, d),
				to: o
			}];
			return s !== null && e.push({
				from: a,
				ratio: Lu(Math.abs(s.price - o.price), d),
				to: s
			}), e;
		}
		let t = Math.abs(i.price - c.price), n = Math.abs(o.price - c.price), r = ku[e.typeId][$.cIsXa] > .5, l = [{
			from: c,
			ratio: Lu(d, t),
			to: a
		}, {
			from: i,
			ratio: r ? Lu(n, t) : Lu(f, d),
			to: o
		}];
		if (s !== null) {
			let r = ku[e.typeId][$.refXc] > .5 ? Lu(Math.abs(o.price - s.price), n) : Lu(Math.abs(i.price - s.price), t);
			l.push({
				from: a,
				ratio: Lu(Math.abs(s.price - o.price), f),
				to: s
			}), l.push({
				from: c,
				ratio: r,
				to: s
			});
		}
		return l;
	}, h = (e) => [{
		type: "line",
		x1: e.from.index,
		y1: e.from.price,
		x2: e.to.index,
		y2: e.to.price,
		color: Iu(l, 55),
		style: "dotted",
		width: 1
	}, {
		type: "label",
		x: Math.round((e.from.index + e.to.index) / 2),
		y: (e.from.price + e.to.price) / 2,
		text: qi(e.ratio, 3),
		style: "none",
		color: Mu,
		textColor: Iu(l, 15),
		size: "small"
	}], g = (e, t, n) => ({
		type: "label",
		x: e.index,
		y: e.price,
		text: t,
		style: n ? "label_down" : "label_up",
		color: Nu,
		textColor: l,
		size: "small"
	}), _ = () => {
		let t = e.dir === -1, n = [
			g(i, "A", !t),
			g(a, "B", t),
			g(o, "C", !t)
		];
		return c === null ? n : [g(c, "X", t), ...n];
	}, v = () => {
		let t = s === null ? o.index : s.index, i = t + 12, { stop: a, tp1: c, tp2: l } = e.plan;
		return [
			Bu(t, i, a, Iu(n.colBear, 15), "dashed"),
			Bu(t, i, c, Iu(n.colBull, 15), "solid"),
			Bu(t, i, l, Iu(n.colBull, 40), "solid"),
			Vu(i, a, r.sl, n.colBear),
			Vu(i, c, r.tp1, n.colBull),
			Vu(i, l, r.tp2, n.colBull)
		];
	}, y = e.dir === 1 ? "▲ " : "▼ ", b = {
		type: "label",
		x: s === null ? t + 10 : s.index,
		y: s === null ? e.przDef : s.price,
		text: y + Ru(e.typeId) + " " + String(e.score) + (u ? ` ${r.forming}` : ""),
		style: e.dir === 1 ? "label_up" : "label_down",
		color: Iu(l, u ? 55 : 15),
		textColor: Pu,
		size: "small",
		tooltip: Hu(e, r)
	}, x = p();
	return n.showRatios && x.push(...m().flatMap(h)), x.push({
		type: "box",
		left: s === null ? o.index : s.index - 2,
		top: Math.max(e.przLo, e.przHi),
		right: s === null ? t + 10 : s.index + 5,
		bottom: Math.min(e.przLo, e.przHi),
		border: Iu(n.colPrz, 20),
		fill: n.colPrz
	}), n.showLetters && x.push(..._()), x.push(b), n.showPlan && !u && x.push(...v()), {
		nameLabel: b,
		objects: x
	};
}, Wu = (e, t) => ku[e][t], Gu = (e, t, n, r, i, a) => {
	let o = t < .5, s = o ? n * (1 - a.tolPoint) : r * (1 - a.tolEdge), c = o ? n * (1 + a.tolPoint) : i * (1 + a.tolEdge), l = e >= s && e <= c, u = o ? n * a.tolPoint : Math.max(i - n, n - r);
	u <= 0 && (u = Math.max(n * a.tolPoint, 1e-9));
	let d = Math.abs(e - n) / u;
	return !o && l && (d *= .5), {
		ok: l,
		deviation: d
	};
}, Ku = (e, t, n, r) => {
	let { x: i, a, b: o, c: s, d: c } = e, l = Math.abs(a - i), u = Math.abs(a - o), d = Math.abs(s - o), f = Math.abs(s - i), p = l > 0 && u > 0 && d > 0 && f > 0, m = 0, h = 0;
	if (p) {
		let e = Gu(u / l, Wu(n, $.bKind), Wu(n, $.bIdeal), Wu(n, $.bLo), Wu(n, $.bHi), r), i = Wu(n, $.bWeight);
		p &&= e.ok, m += i * Math.min(1, e.deviation), h += i;
		let o = Gu(Wu(n, $.cIsXa) > .5 ? f / l : d / u, 1, Wu(n, $.cIdeal), Wu(n, $.cLo), Wu(n, $.cHi), r), g = Wu(n, $.cWeight);
		if (p &&= o.ok, m += g * Math.min(1, o.deviation), h += g, t && p) {
			let e = Wu(n, $.refXc) > .5, t = e ? f : l, i = Math.abs((e ? s : a) - c) / t, o = Gu(i, Wu(n, $.xdKind), Wu(n, $.xdIdeal), Wu(n, $.xdLo), Wu(n, $.xdHi), r), u = Wu(n, $.xdWeight);
			p &&= o.ok, p &&= i <= Wu(n, $.invalidMult) * (1 + r.tolEdge), m += u * Math.min(1, o.deviation), h += u;
			let g = Wu(n, $.bcWeight);
			if (g > 0) {
				let e = Gu(Math.abs(c - s) / d, 1, Wu(n, $.bcIdeal), Wu(n, $.bcLo), Wu(n, $.bcHi), r);
				p &&= e.ok, m += g * Math.min(1, e.deviation), h += g;
			}
		}
	}
	return {
		ok: p,
		weightedDeviation: m,
		weightSum: h
	};
}, qu = (e, t, n) => {
	let { x: r, a: i, b: a, c: o } = e, s = Math.abs(i - r), c = Math.abs(i - a), l = Math.abs(o - a), u = Math.abs(o - r), d = Wu(t, $.refXc) > .5, f = d ? u : s, p = d ? o : i, m = p - n * Wu(t, $.xdIdeal) * f, h = m, g = m, _ = 1, v = .2 * f;
	if (Wu(t, $.bcWeight) > 0) {
		let e = o - n * Wu(t, $.bcIdeal) * l;
		Math.abs(e - m) <= v && (h = Math.min(h, e), g = Math.max(g, e), _ += 1);
	}
	let y = Wu(t, $.abcdMult);
	if (y > 0) {
		let e = o - n * y * c;
		Math.abs(e - m) <= v && (h = Math.min(h, e), g = Math.max(g, e), _ += 1);
	}
	let b = f > 0 ? (g - h) / f : 0, x = p - n * Wu(t, $.invalidMult) * f;
	return {
		przDef: m,
		przLo: h,
		przHi: g,
		confluence: _,
		spanRel: b,
		invalidPx: x
	};
}, Ju = (e, t, n, r, i) => {
	let { x: a, a: o, c: s } = e, c = Wu(t, $.refXc) > .5, l = Math.abs(c ? s - a : o - a), u = c ? s : o, d = Wu(t, $.stopMode), f;
	f = d < .5 ? a - n * .13 * l : d < 1.5 ? u - n * Wu(t, $.stopMult) * l : (n === 1 ? Math.min(r.przLo, r.przHi) : Math.max(r.przLo, r.przHi)) - n * .13 * l;
	let p = Wu(t, $.entryAtPrzDef) > .5 ? r.przDef : i, m = Wu(t, $.basisMode) > 1.5 ? Math.abs(i - s) : Math.abs(o - i);
	return {
		entry: p,
		stop: f,
		tp1: p + n * .382 * m,
		tp2: p + n * .618 * m,
		tp3: s,
		tp4: o
	};
}, Yu = (e, t, n, r, i, a, o) => {
	let s = 1 - Math.min(1, t > 0 ? e / t : 1), c;
	c = n <= .05 ? 1 : n >= .25 ? 0 : 1 - (n - .05) / .2;
	let l = Math.max(0, Math.min(1, (r - 1) / 2)), u = 30 * s + 20 * c + 15 * l, d = 65;
	if (o) {
		let e = Math.max(i, a), t = e > 0 ? 1 - Math.min(1, Math.abs(i - a) / e) : 1;
		u += 10 * t, d += 10;
	}
	return Math.round(100 * u / d);
}, Xu = 9, Zu = 8, Qu = [
	1,
	1.272,
	1.618
], $u = Y(Vi.gray, 45), ed = () => Array(Xu).fill(0), td = (e) => ({
	confluence: e.confluence,
	invalidPx: e.invalidPx,
	przDef: e.przDef,
	przHi: e.przHi,
	przLo: e.przLo
}), nd = (e, t) => {
	let n = {
		tolPoint: e.tolPoint,
		tolEdge: e.tolEdge
	}, r = [
		e.enGartley,
		e.enBat,
		e.enAltBat,
		e.enButterfly,
		e.enCrab,
		e.enDeepCrab,
		e.enShark,
		e.enCypher
	], i = /* @__PURE__ */ new Map(), a = {
		done: ed(),
		losses: ed(),
		wins: ed()
	}, o = (t) => e.dirFilter === "Both" || e.dirFilter === "Bullish only" && t === 1 || e.dirFilter === "Bearish only" && t === -1, s = (e, t, n, r) => {
		let a = {
			id: e,
			typeId: t,
			dir: n,
			...r,
			drawing: null
		};
		return i.set(e, a), a;
	}, c = (n, r) => {
		n.drawing = Uu(n, r, e, t);
	}, l = (e) => {
		e.drawing = null;
	}, u = (e, t, n) => {
		let r = e.drawing;
		if (r === null) return;
		let i = r.nameLabel, a = {
			...i,
			text: i.text + t,
			color: n ?? i.color
		};
		e.drawing = {
			nameLabel: a,
			objects: r.objects.map((e) => e === i ? a : e)
		};
	}, d = (e) => e.state !== ju.invalidated && e.drawing !== null, f = () => {
		let t = [...i.values()].filter(d);
		if (t.length <= e.maxPatterns) return;
		let n = null, r = Infinity, a = 101;
		for (let e of t) {
			let t = e.points.d === null ? e.points.c.index : e.points.d.index;
			(t < r || t === r && e.score < a) && (r = t, a = e.score, n = e);
		}
		n !== null && l(n);
	}, p = (t, l, u) => {
		let [d, p, m, h, g] = t, _ = {
			x: d.price,
			a: p.price,
			b: m.price,
			c: h.price,
			d: g.price
		}, v = g.dir === -1 ? 1 : -1, y = -1, b = 1e9, x = 0;
		for (let e = 0; e < r.length; e++) {
			if (!r[e]) continue;
			let { ok: t, weightedDeviation: i, weightSum: a } = Ku(_, !0, e, n);
			t && a > 0 && i / a < b && (b = i / a, x = a, y = e);
		}
		if (y < 0 || !o(v)) return "";
		let S = `${y}-${l}-${d.index}-${h.index}`, C = qu(_, y, v), w = Math.abs(m.index - p.index), T = Math.abs(g.index - h.index), E = Yu(b * x, x, C.spanRel, C.confluence, w, T, !0);
		if (E < e.minScore) return "";
		let D = {
			points: {
				x: d,
				a: p,
				b: m,
				c: h,
				d: g
			},
			state: ju.completed,
			score: E,
			...td(C),
			plan: Ju(_, y, v, C, g.price)
		}, O = i.get(S);
		return O === void 0 ? O = s(S, y, v, D) : Object.assign(O, D), c(O, u), f(), a.done[y] += 1, `${p.index}-${g.index}`;
	}, m = (t, a, l) => {
		let [u, d, p, m] = t, h = {
			x: u.price,
			a: d.price,
			b: p.price,
			c: m.price,
			d: NaN
		}, g = m.dir === 1 ? 1 : -1;
		for (let t = 0; t < r.length; t++) {
			if (!r[t]) continue;
			let _ = Ku(h, !1, t, n), v = `${t}-${a}-${u.index}-${m.index}`;
			if (!_.ok || !o(g) || i.has(v)) continue;
			let y = qu(h, t, g), b = Yu(_.weightedDeviation, _.weightSum, y.spanRel, y.confluence, 0, 0, !1);
			if (b < e.minScore) continue;
			let x = s(v, t, g, {
				points: {
					x: u,
					a: d,
					b: p,
					c: m,
					d: null
				},
				state: ju.projected,
				score: b,
				...td(y),
				plan: Ju(h, t, g, y, y.przDef)
			});
			c(x, l), f();
		}
	}, h = (t, n, r, l) => {
		let [u, d, p, m] = t;
		if (`${u.index}-${m.index}` === l) return;
		let h = Math.abs(u.price - d.price), g = Math.abs(p.price - d.price);
		if (h <= 0 || g <= 0) return;
		let _ = g / h;
		if (_ < .382 * (1 - e.tolEdge) || _ > .886 * (1 + e.tolEdge)) return;
		let v = Math.abs(m.price - p.price) / h, y = Qu.find((t) => Math.abs(v - t) <= t * e.tolPoint);
		if (y === void 0) return;
		let b = m.dir === -1 ? 1 : -1, x = `abcd-${n}-${u.index}-${p.index}`;
		if (i.has(x) || !o(b)) return;
		let S = Math.abs(d.index - u.index), C = Math.abs(m.index - p.index), w = Math.max(S, C), T = w > 0 ? 1 - Math.min(1, Math.abs(S - C) / w) : 1, E = Math.abs(v - y) / (y * e.tolPoint), D = Math.round(100 * (.7 * (1 - Math.min(1, E)) + .3 * T));
		if (D < e.minScore) return;
		let O = Math.abs(u.price - m.price), k = p.price - b * y * h, ee = s(x, 100, b, {
			points: {
				x: null,
				a: u,
				b: d,
				c: p,
				d: m
			},
			state: ju.completed,
			score: D,
			przLo: k,
			przHi: k,
			przDef: k,
			confluence: 1,
			invalidPx: NaN,
			plan: {
				entry: m.price,
				stop: m.price - b * .13 * h,
				tp1: m.price + b * .382 * O,
				tp2: m.price + b * .618 * O,
				tp3: p.price,
				tp4: u.price
			}
		});
		c(ee, r), f(), a.done[Zu] += 1;
	}, g = (t, n, r) => {
		let i = t.length >= 5 ? p(t.slice(-5), n, r) : "";
		t.length >= 4 && e.showProjected && m(t.slice(-4), n, r), t.length >= 4 && e.enAbcd && h(t.slice(-4), n, r, i);
	}, _ = (t, n, r) => {
		let i = t.dir === 1 ? n.close < t.invalidPx : n.close > t.invalidPx;
		if (!Number.isNaN(t.invalidPx) && i || r - t.points.c.index > e.formingLife) t.state = ju.invalidated, l(t);
		else if (t.state === ju.projected) {
			let e = Math.max(t.przLo, t.przHi), r = Math.min(t.przLo, t.przHi);
			(t.dir === 1 ? n.low <= e : n.high >= r) && (t.state = ju.przActive);
		}
	}, v = (t, n) => {
		let r = t.typeId === 100 ? Zu : t.typeId, { stop: i, tp1: o, tp2: s, tp3: c, tp4: d } = t.plan, f = (e) => t.dir === 1 ? n.high >= e : n.low <= e, p = t.dir === 1 ? n.low <= i : n.high >= i;
		if (t.state === ju.completed && p) {
			t.state = ju.stopped, a.losses[r] += 1, e.keepFailed ? u(t, " ✕", $u) : l(t);
			return;
		}
		t.state === ju.completed && f(o) && (t.state = ju.t1, a.wins[r] += 1, e.keepSuccessful ? u(t, " ✓") : l(t)), t.state === ju.t1 && f(s) && (t.state = ju.t2), t.state === ju.t2 && f(c) && (t.state = ju.t3), t.state === ju.t3 && f(d) && (t.state = ju.t4);
	};
	return {
		objects: () => [...i.values()].flatMap((e) => e.drawing?.objects ?? []),
		patterns: () => [...i.values()].map((e) => ({
			id: e.id,
			dir: e.dir,
			drawn: e.drawing !== null,
			score: e.score,
			state: e.state,
			typeId: e.typeId
		})),
		scan: g,
		stats: () => ({
			done: [...a.done],
			losses: [...a.losses],
			wins: [...a.wins]
		}),
		sweep: (e, t) => {
			for (let n of i.values()) {
				let r = n.points.d, i = n.state >= ju.completed && n.state < ju.t4;
				Fu(n.state) ? _(n, e, t) : i && r !== null && t > r.index && v(n, e);
			}
		}
	};
}, rd = 8, id = 150, ad = 10, od = 5, sd = (e, t, n, r, i) => {
	if (e.length < r || Number.isNaN(t)) return [];
	let a = [...e].sort((e, t) => e - t), o = .5 * t, s = Math.max(0, n - id), c = [], l = (e, t) => {
		t < r || c.length >= rd || c.push({
			color: i,
			style: "solid",
			type: "line",
			width: t >= od ? 2 : 1,
			x1: s,
			x2: n + ad,
			y1: e,
			y2: e
		});
	}, u = a[0], d = 1;
	for (let e = 1; e < a.length; e++) {
		let t = a[e], n = u / d;
		t - n <= o ? (u += t, d += 1) : (l(n, d), u = t, d = 1);
	}
	return l(u / d, d), c;
}, cd = [...Au, "AB=CD"], ld = (e, t = Ui) => {
	let n = Ni(e.atrLen), r = bu(e.pivotDepth), i = bu(e.pivotDepth), a = nd(e, t), o = Ou(e, t), s = -1, c = NaN, l = [];
	return {
		classics: o.objects,
		confirmBar: (t, l) => {
			if (!(t <= s)) {
				if (s = t, c = n.confirm(l), !Number.isNaN(c)) {
					let n = r.update(t, l.high, l.low, e.atrMult * c), s = i.update(t, l.high, l.low, e.atrMult * 2 * c);
					n && (a.scan(r.pivots(), 0, t), o.scan(r.pivots(), t)), e.useScale2 && s && a.scan(i.pivots(), 1, t);
				}
				a.sweep(l, t), o.sweep(l.close, t);
			}
		},
		harmonics: a.objects,
		lastBar: (t, i) => {
			if (!e.showSR) {
				l = [];
				return;
			}
			let a = t === s ? c : n.preview(i);
			l = sd(r.pivots().map((e) => e.price), a, t, e.srMinTouch, e.colSR);
		},
		lastConfirmedIndex: () => s,
		levels: () => l,
		statsRows: () => {
			if (!e.showStats) return null;
			let { done: t, losses: n, wins: r } = a.stats();
			return cd.map((e, i) => {
				let a = r[i] + n[i], o = a > 0 ? `${Ji(100 * r[i] / a)}%` : "-";
				return [
					e,
					String(t[i]),
					String(r[i]),
					String(n[i]),
					o
				];
			});
		}
	};
}, ud = /* @__PURE__ */ "atrLen.atrMult.useScale2.pivotDepth.tolPoint.tolEdge.enGartley.enBat.enAltBat.enButterfly.enCrab.enDeepCrab.enShark.enCypher.enAbcd.minScore.maxPatterns.formingLife.dirFilter.showProjected.keepSuccessful.keepFailed.showLetters.showRatios.showPlan.showStats.fillTransp.colBull.colBear.colPrz.colSR.enClassics.enDoubles.enTriples.enHS.showSR.srMinTouch".split("."), dd = [
	"enGartley",
	"enBat",
	"enAltBat",
	"enButterfly",
	"enCrab",
	"enDeepCrab",
	"enShark",
	"enCypher"
], fd = [
	"Both",
	"Bullish only",
	"Bearish only"
], pd = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*([\d.]+)\s*)?\)$/i, md = (e) => {
	let t = e("traceScanner.group.pivotEngine"), n = e("traceScanner.group.ratios"), r = e("traceScanner.group.patterns"), i = e("traceScanner.group.filters"), a = e("traceScanner.group.classics"), o = (e, t, n, r = {}) => ({
		id: e,
		name: t,
		type: "bool",
		defval: Hi[e],
		group: n,
		...r
	}), s = (e, t, n = {}) => ({
		id: e,
		name: t,
		type: "color",
		defval: Hi[e].hex,
		group: i,
		inline: "c",
		...n
	});
	return [
		{
			id: "atrLen",
			name: e("traceScanner.input.atrLen"),
			type: "integer",
			defval: Hi.atrLen,
			min: 2,
			group: t
		},
		{
			id: "atrMult",
			name: e("traceScanner.input.atrMult"),
			type: "float",
			defval: Hi.atrMult,
			min: .5,
			step: .25,
			group: t
		},
		o("useScale2", e("traceScanner.input.useScale2"), t),
		{
			id: "pivotDepth",
			name: e("traceScanner.input.pivotDepth"),
			type: "integer",
			defval: Hi.pivotDepth,
			min: 10,
			group: t
		},
		{
			id: "tolPoint",
			name: e("traceScanner.input.tolPoint"),
			type: "float",
			defval: Hi.tolPoint,
			min: .005,
			max: .15,
			step: .005,
			group: n,
			tooltip: e("traceScanner.tooltip.tolPoint")
		},
		{
			id: "tolEdge",
			name: e("traceScanner.input.tolEdge"),
			type: "float",
			defval: Hi.tolEdge,
			min: 0,
			max: .1,
			step: .005,
			group: n
		},
		...dd.map((e, t) => o(e, Au[t], r, { inline: t < 4 ? "p1" : "p2" })),
		o("enAbcd", "AB=CD", r, { inline: "p3" }),
		{
			id: "minScore",
			name: e("traceScanner.input.minScore"),
			type: "integer",
			defval: Hi.minScore,
			min: 0,
			max: 100,
			group: i
		},
		{
			id: "maxPatterns",
			name: e("traceScanner.input.maxPatterns"),
			type: "integer",
			defval: Hi.maxPatterns,
			min: 1,
			max: 30,
			group: i,
			tooltip: e("traceScanner.tooltip.maxPatterns")
		},
		{
			id: "formingLife",
			name: e("traceScanner.input.formingLife"),
			type: "integer",
			defval: Hi.formingLife,
			min: 30,
			max: 300,
			step: 10,
			group: i,
			tooltip: e("traceScanner.tooltip.formingLife")
		},
		{
			id: "dirFilter",
			name: e("traceScanner.input.dirFilter"),
			type: "text",
			defval: Hi.dirFilter,
			options: fd,
			optionsTitles: {
				Both: e("traceScanner.direction.both"),
				"Bullish only": e("traceScanner.direction.bullishOnly"),
				"Bearish only": e("traceScanner.direction.bearishOnly")
			},
			group: i
		},
		o("showProjected", e("traceScanner.input.showProjected"), i, { tooltip: e("traceScanner.tooltip.showProjected") }),
		o("keepSuccessful", e("traceScanner.input.keepSuccessful"), i),
		o("keepFailed", e("traceScanner.input.keepFailed"), i),
		o("showLetters", e("traceScanner.input.showLetters"), i),
		o("showRatios", e("traceScanner.input.showRatios"), i, { tooltip: e("traceScanner.tooltip.showRatios") }),
		o("showPlan", e("traceScanner.input.showPlan"), i),
		o("showStats", e("traceScanner.input.showStats"), i),
		{
			id: "fillTransp",
			name: e("traceScanner.input.fillTransp"),
			type: "integer",
			defval: Hi.fillTransp,
			min: 40,
			max: 95,
			group: i,
			tooltip: e("traceScanner.tooltip.fillTransp")
		},
		s("colBull", e("traceScanner.input.colBull")),
		s("colBear", e("traceScanner.input.colBear")),
		s("colPrz", e("traceScanner.input.colPrz"), { tooltip: e("traceScanner.tooltip.colPrz") }),
		s("colSR", e("traceScanner.input.colSR")),
		o("enClassics", e("traceScanner.input.enClassics"), a),
		o("enDoubles", e("traceScanner.input.enDoubles"), a, { inline: "cl" }),
		o("enTriples", e("traceScanner.input.enTriples"), a, { inline: "cl" }),
		o("enHS", e("traceScanner.input.enHS"), a, { inline: "cl" }),
		o("showSR", e("traceScanner.input.showSR"), a),
		{
			id: "srMinTouch",
			name: e("traceScanner.input.srMinTouch"),
			type: "integer",
			defval: Hi.srMinTouch,
			min: 2,
			max: 10,
			group: a
		}
	];
}, hd = (e) => fd.some((t) => t === e), gd = (e) => e.toString(16).padStart(2, "0").toUpperCase(), _d = (e, t, n) => `#${gd(e)}${gd(t)}${gd(n)}`, vd = (e, t) => {
	if (typeof e != "string") return t;
	let n = f(e);
	if (n !== null) return {
		hex: _d(n.r, n.g, n.b),
		transparency: t.transparency
	};
	let r = pd.exec(e.trim());
	if (r === null) return t;
	let [i, a, o] = [
		r[1],
		r[2],
		r[3]
	].map(Number), s = r[4] === void 0 ? null : Number(r[4]);
	if (!(Math.max(i, a, o) <= 255 && (s === null || s >= 0 && s <= 1))) return t;
	let c = s === null ? t.transparency : Math.round((1 - s) * 100);
	return {
		hex: _d(i, a, o),
		transparency: c
	};
}, yd = (e) => {
	let t = (t) => e(ud.indexOf(t)), n = (e) => Z(t(e), Hi[e]), r = (e) => {
		let n = t(e);
		return typeof n == "boolean" ? n : Hi[e];
	}, i = (e) => vd(t(e), Hi[e]), a = t("dirFilter");
	return {
		atrLen: n("atrLen"),
		atrMult: n("atrMult"),
		useScale2: r("useScale2"),
		pivotDepth: n("pivotDepth"),
		tolPoint: n("tolPoint"),
		tolEdge: n("tolEdge"),
		enGartley: r("enGartley"),
		enBat: r("enBat"),
		enAltBat: r("enAltBat"),
		enButterfly: r("enButterfly"),
		enCrab: r("enCrab"),
		enDeepCrab: r("enDeepCrab"),
		enShark: r("enShark"),
		enCypher: r("enCypher"),
		enAbcd: r("enAbcd"),
		minScore: n("minScore"),
		maxPatterns: n("maxPatterns"),
		formingLife: n("formingLife"),
		dirFilter: hd(a) ? a : Hi.dirFilter,
		showProjected: r("showProjected"),
		keepSuccessful: r("keepSuccessful"),
		keepFailed: r("keepFailed"),
		showLetters: r("showLetters"),
		showRatios: r("showRatios"),
		showPlan: r("showPlan"),
		showStats: r("showStats"),
		fillTransp: n("fillTransp"),
		colBull: i("colBull"),
		colBear: i("colBear"),
		colPrz: i("colPrz"),
		colSR: i("colSR"),
		enClassics: r("enClassics"),
		enDoubles: r("enDoubles"),
		enTriples: r("enTriples"),
		enHS: r("enHS"),
		showSR: r("showSR"),
		srMinTouch: n("srMinTouch")
	};
}, bd = (e, t, n) => {
	let r = (e) => e <= n ? {
		time: t[e],
		after: 0
	} : {
		time: t[n],
		after: e - n
	};
	return e.map((e) => {
		switch (e.type) {
			case "label": return {
				...e,
				x: r(e.x)
			};
			case "line": return {
				...e,
				x1: r(e.x1),
				x2: r(e.x2)
			};
			case "box": return {
				...e,
				left: r(e.left),
				right: r(e.right)
			};
			default: return {
				...e,
				points: e.points.map((e) => ({
					x: r(e.x),
					y: e.y
				}))
			};
		}
	});
}, xd = "Trace Scanner", Sd = 1e4, Cd = (e, t, n) => {
	let r = R.getFixedT(n || "en", F), i = md(r), a = {
		classicNames: [
			r("traceScanner.classic.doubleTop"),
			r("traceScanner.classic.doubleBottom"),
			r("traceScanner.classic.tripleTop"),
			r("traceScanner.classic.tripleBottom"),
			r("traceScanner.classic.headAndShoulders"),
			r("traceScanner.classic.inverseHeadAndShoulders")
		],
		confirmed: r("traceScanner.label.confirmed"),
		forming: r("traceScanner.label.forming"),
		sl: r("traceScanner.label.sl"),
		target: r("traceScanner.label.target"),
		tp1: r("traceScanner.label.tp1"),
		tp2: r("traceScanner.label.tp2"),
		chartTooltip: {
			bearish: r("traceScanner.chartTooltip.bearish"),
			bullish: r("traceScanner.chartTooltip.bullish"),
			confluence: r("traceScanner.chartTooltip.confluence"),
			entry: r("traceScanner.chartTooltip.entry"),
			neckline: r("traceScanner.chartTooltip.neckline"),
			score: r("traceScanner.chartTooltip.score"),
			state: r("traceScanner.chartTooltip.state"),
			stop: r("traceScanner.chartTooltip.stop"),
			target: r("traceScanner.chartTooltip.target"),
			states: [
				r("traceScanner.chartTooltip.states.projected"),
				r("traceScanner.chartTooltip.states.przActive"),
				r("traceScanner.chartTooltip.states.completed"),
				"t1",
				"t2",
				"t3",
				"t4",
				r("traceScanner.chartTooltip.states.stopped"),
				r("traceScanner.chartTooltip.states.invalidated")
			]
		}
	};
	return {
		name: xd,
		metainfo: {
			_metainfoVersion: 51,
			id: "traceScanner@tv-basicstudies-1",
			name: xd,
			description: xd,
			shortDescription: "TRACE",
			isCustomIndicator: !0,
			is_price_study: !0,
			format: { type: "inherit" },
			inputs: i,
			plots: [{
				id: "hidden",
				type: "line"
			}],
			styles: { hidden: {
				title: "hidden",
				histogramBase: 0,
				isHidden: !0
			} },
			defaults: {
				inputs: Object.fromEntries(i.map((e) => [e.id, e.defval])),
				styles: { hidden: {
					color: "#000000",
					display: 1,
					linestyle: 0,
					linewidth: 1,
					plottype: 0,
					trackPrice: !1,
					transparency: 100,
					visible: !1
				} }
			}
		},
		constructor: function() {
			let n = null, r = "", i = "", o = [], s = null, c = null;
			this.init = function(e, t) {
				let l = yd(t);
				n = ld(l, a), r = p(l.colBull.hex, l.colBull.transparency), i = p(l.colBear.hex, l.colBear.transparency), o = [], s = null, c = null, e.setMinimumAdditionalDepth(Sd);
			}, this.main = function(a) {
				let l = a.symbol.index;
				if (n === null || l < 0) return [NaN];
				o[l] = e.Std.time(a) / 1e3;
				let u = {
					close: e.Std.close(a),
					high: e.Std.high(a),
					low: e.Std.low(a)
				};
				if (a.symbol.isBarClosed && n.confirmBar(l, u), !a.symbol.isLastBar) return [NaN];
				n.lastBar(l, u);
				let d = g(a, e.Std), f = o[l], p = n.lastConfirmedIndex();
				p !== s && (s = p, t.onHarmonics({
					...d,
					time: f,
					objects: bd(n.harmonics(), o, l)
				}), t.onClassics({
					...d,
					time: f,
					objects: bd(n.classics(), o, l)
				}), t.onStats({
					...d,
					rows: n.statsRows(),
					bullColor: r,
					bearColor: i
				}));
				let m = n.levels(), h = JSON.stringify(m);
				return h !== c && (c = h, t.onLevels({
					...d,
					time: f,
					objects: bd(m, o, l)
				})), [NaN];
			};
		}
	};
}, wd = {
	small: 10,
	tiny: 8
}, Td = "rgba(0, 0, 0, 0)", Ed = {
	light: "#FFFFFF",
	dark: "#0F0F0F"
}, Dd = (e) => p(e.hex, e.transparency), Od = (e, t) => e.after === 0 ? e.time : t(e.time, e.after), kd = (e, { barsAfter: t, fmt: n, theme: r }) => {
	let i = Od(e.x, t), a = e.text + (e.price === void 0 ? "" : n(e.price)), o = wd[e.size], s = Dd(e.textColor);
	if (e.style === "label_up" || e.style === "label_down") {
		let t = e.style === "label_up" ? "up" : "down", c = e.color.transparency < 100 ? m(e.color.hex, e.color.transparency, Ed[r]) : Dd(e.color), l = e.tooltip?.map((e) => typeof e == "string" ? e : n(e.price)).join(""), u = {
			time: e.x.time,
			barsAfter: e.x.after
		}, d = [{
			kind: "plate",
			time: i,
			price: e.y,
			text: a,
			color: c,
			textColor: s,
			fontSize: o,
			pointing: t,
			tooltip: l,
			anchor: u
		}];
		return e.color.transparency < 100 && d.push({
			kind: "plateTail",
			time: i,
			price: e.y,
			color: c,
			pointing: t
		}), d;
	}
	return [{
		kind: "line",
		price: e.y,
		color: Td,
		fromTime: i,
		toTime: i,
		text: a,
		textAlign: e.style === "label_left" ? "left" : "center",
		textColor: s,
		fontSize: o
	}];
}, Ad = (e, { barsAfter: t }) => ({
	kind: "segment",
	from: {
		time: Od(e.x1, t),
		price: e.y1
	},
	to: {
		time: Od(e.x2, t),
		price: e.y2
	},
	color: Dd(e.color),
	width: e.width,
	style: e.style
}), jd = (e, { barsAfter: t }) => ({
	kind: "box",
	top: Math.max(e.top, e.bottom),
	bottom: Math.min(e.top, e.bottom),
	fromTime: Od(e.left, t),
	toTime: Od(e.right, t),
	fill: Dd(e.fill),
	border: Dd(e.border)
}), Md = (e, { barsAfter: t }) => {
	let n = e.points.map((e) => ({
		time: Od(e.x, t),
		price: e.y
	})), r = Dd(e.lineColor);
	if (e.closed && e.fillColor) return [{
		kind: "polygon",
		points: n,
		fill: Dd(e.fillColor),
		border: r,
		width: e.width
	}];
	let i = e.closed ? n.length : n.length - 1, a = [];
	for (let t = 0; t < i; t++) a.push({
		kind: "segment",
		from: n[t],
		to: n[(t + 1) % n.length],
		color: r,
		width: e.width,
		style: "solid"
	});
	return a;
}, Nd = (e, t) => {
	switch (e.type) {
		case "label": return kd(e, t);
		case "line": return [Ad(e, t)];
		case "box": return [jd(e, t)];
		default: return Md(e, t);
	}
}, Pd = (e, t) => e.flatMap((e) => Nd(e, t)), Fd = (e) => Pn({
	studyName: xd,
	label: e,
	anchorsFor: (e, t, n) => jn(e, t, n),
	specsFor: (e, t) => Pd(e.objects, t),
	reanchor: !1,
	themeAware: !0
}), Id = ".chart-markup-table.pane", Ld = 100, Rd = 10, zd = 8, Bd = {
	background: p("#363A45", 85),
	border: p("#787B86", 70),
	title: "#B57BEA",
	header: "#787B86",
	name: "#FFFFFF",
	done: "#B2B5BE",
	winRate: "#FFFFFF"
}, Vd = [
	"done",
	"t1Wins",
	"stops",
	"winRate"
], Hd = (e, t) => {
	let n = t.getBoundingClientRect(), r = t.querySelector(Id)?.getBoundingClientRect() ?? n, i = r.left - n.left + r.width - e.offsetWidth - 8, a = r.top - n.top + 8;
	e.style.left = `${Math.max(0, i)}px`, e.style.top = `${Math.max(0, a)}px`;
}, Ud = (e, t, n) => ({
	padding: "2px 5px",
	border: `1px solid ${Bd.border}`,
	whiteSpace: "nowrap",
	textAlign: n,
	color: e,
	fontSize: t,
	lineHeight: 1.25
}), Wd = t(({ data: e, mountTarget: t, language: n }) => !e || !e.rows || !t ? null : /* @__PURE__ */ c(Gd, {
	rows: e.rows,
	bullColor: e.bullColor,
	bearColor: e.bearColor,
	mountTarget: t,
	language: n
}));
Wd.displayName = "TraceScannerTable";
var Gd = ({ rows: e, bullColor: t, bearColor: n, mountTarget: a, language: o }) => {
	let s = i(null), d = R.getFixedT(o ?? "en", F);
	r(() => {
		let e = s.current;
		if (!e) return;
		let t = () => Hd(e, a), n = new ((a.ownerDocument?.defaultView?.ResizeObserver) ?? window.ResizeObserver)(t);
		n.observe(a), n.observe(e);
		let r = a.querySelector(Id);
		return r && n.observe(r), t(), () => n.disconnect();
	}, [a, e]);
	let f = [
		Bd.name,
		Bd.done,
		t,
		n,
		Bd.winRate
	];
	return u(/* @__PURE__ */ c("div", {
		ref: s,
		role: "group",
		style: {
			position: "absolute",
			zIndex: Ld,
			background: Bd.background,
			userSelect: "none",
			WebkitUserSelect: "none",
			pointerEvents: "none",
			fontVariantNumeric: "tabular-nums"
		},
		children: /* @__PURE__ */ c("table", {
			style: { borderCollapse: "collapse" },
			children: /* @__PURE__ */ l("tbody", { children: [/* @__PURE__ */ l("tr", { children: [/* @__PURE__ */ c("td", {
				style: Ud(Bd.title, Rd, "left"),
				children: "TRACE"
			}), Vd.map((e) => /* @__PURE__ */ c("td", {
				style: Ud(Bd.header, zd, "center"),
				children: d(`traceScanner.table.${e}`)
			}, e))] }), e.map((e, t) => /* @__PURE__ */ c("tr", { children: e.map((e, t) => /* @__PURE__ */ c("td", {
				style: Ud(f[t] ?? Bd.name, zd, t === 0 ? "left" : "center"),
				children: e
			}, t)) }, t))] })
		})
	}), a);
}, Kd = class extends Xe {
	renderPanels = Ye(Wd);
	harmonics;
	classics;
	levels;
	panels;
	tooltips;
	constructor(e, t) {
		super(e, t), this.harmonics = this.own(Fd("Trace Scanner harmonics")), this.classics = this.own(Fd("Trace Scanner classics")), this.levels = this.own(Fd("Trace Scanner levels")), this.panels = this.own(ft({
			studyName: xd,
			onUpdate: this.publish
		})), this.tooltips = this.own(Or({
			label: "Trace Scanner tooltips",
			direction: e.language === "ar" ? "rtl" : "ltr",
			platesFor: (e) => [...this.harmonics.shownPlates(e), ...this.classics.shownPlates(e)]
		}));
	}
	studies(e) {
		return [Cd(e, {
			onHarmonics: this.harmonics.onSignal,
			onClassics: this.classics.onSignal,
			onLevels: this.levels.onSignal,
			onStats: this.panels.onSnapshot
		}, this.ctx.language)];
	}
	onChartReady(e) {
		this.harmonics.attach(e), this.classics.attach(e), this.levels.attach(e);
	}
	onDocumentReady(e, t) {
		this.panels.attach(e, t), this.tooltips.attach(e, t);
	}
}, qd = (e) => {
	let t = jo(e);
	return {
		sl: t.bearish.fill,
		tp: t.bullish.fill,
		entry: t.blue.fill,
		trail: t.amber.fill,
		muted: t.mutedFill
	};
}, Jd = 10, Yd = (e) => {
	if (!(e > 0)) return Jd;
	let { lineAheadMinutes: t } = qr[Kr(e / 60)];
	return Math.max(Jd, Math.ceil(t * 60 / e));
}, Xd = ({ studyName: e, language: t }) => {
	let n = t ?? "en", r = R.getFixedT(n, F), i = (e) => e.toLocaleUpperCase(n);
	return Pn({
		studyName: e,
		label: "Trade Finder",
		reanchor: !0,
		themeAware: !0,
		blockStaleOnDuplicateRemoval: !0,
		anchorsFor: Mn(Yd),
		specsFor: (e, { fmt: t, theme: n }) => {
			if (!e.active) return [];
			let a = qd(n), o = e.direction === "long", s = o ? `▲ ${i(r("long"))}` : `▼ ${i(r("short"))}`, c = [], l = Number.isFinite(e.entry) && Number.isFinite(e.sl);
			if (l && Number.isFinite(e.firstEntry) && c.push({
				kind: "line",
				price: e.firstEntry,
				color: a.muted
			}, {
				kind: "label",
				price: e.firstEntry,
				color: a.muted,
				text: ` ${r("tradeFinder.entry1")} ${t(e.firstEntry)} `
			}), l && c.push({
				kind: "line",
				price: e.entry,
				color: a.entry,
				width: 2
			}, {
				kind: "label",
				price: e.entry,
				color: a.entry,
				text: ` ✅ ${s} ${t(e.entry)}  ${r("tradeFinder.scoreTag", {
					setup: e.setupScore.toFixed(1),
					entry: Math.round(e.entryScore)
				})} `
			}), l && c.push({
				kind: "line",
				price: e.sl,
				color: a.sl
			}, {
				kind: "label",
				price: e.sl,
				color: a.sl,
				text: e.breakEven ? ` ${r("breakEven")}  ${t(e.sl)} ` : ` ${r("sl")}  ${t(e.sl)} `
			}), l && Number.isFinite(e.trail)) {
				let n = Number.isFinite(e.atr) ? e.atr * .4 : 0;
				c.push({
					kind: "line",
					price: e.trail,
					color: a.trail,
					width: 2
				}, {
					kind: "label",
					price: o ? e.trail - n : e.trail + n,
					color: a.trail,
					text: ` ${r("tradeFinder.trailStop")}  ${t(e.trail)}  ${r("tradeFinder.atrMultTag", { mult: e.trailAtrMult.toFixed(1) })} `
				});
			}
			l && Number.isFinite(e.maxSl) && !e.breakEven && !e.trailing && c.push({
				kind: "line",
				price: e.maxSl,
				color: a.muted
			}, {
				kind: "label",
				price: e.maxSl,
				color: a.muted,
				text: ` ${r("tradeFinder.maxStop")}: ${t(e.maxSl)} `
			});
			let u = (t) => {
				let n = Math.max(0, 100 - e.tp1ClosePct - e.tp2ClosePct);
				return t === 0 ? `${r("tp", { n: 1 })} ${e.tp1ClosePct}%` : t === 1 ? `${r("tp", { n: 2 })} ${e.tp2ClosePct}%` : t === 2 ? `${r("tp", { n: 3 })} ${n}% ${r("tradeFinder.rest")}` : t === 3 ? `${r("tp", { n: 4 })} ${r("tradeFinder.rest")}` : r("tradeFinder.closeAll");
			};
			if (e.tps.slice(0, e.activeTargets).forEach((e, n) => {
				Number.isFinite(e) && c.push({
					kind: "line",
					price: e,
					color: a.tp
				}, {
					kind: "label",
					price: e,
					color: a.tp,
					text: ` ${u(n)}  ${t(e)} `
				});
			}), e.ghost) {
				let n = e.ghost.direction === "long" ? "▲" : "▼";
				c.push({
					kind: "line",
					price: e.ghost.entry,
					color: a.muted
				}, {
					kind: "label",
					price: e.ghost.entry,
					color: a.muted,
					text: ` ${r("tradeFinder.ghostEntry")} ${n} ${t(e.ghost.entry)} `
				}, {
					kind: "line",
					price: e.ghost.sl,
					color: a.muted
				}, {
					kind: "label",
					price: e.ghost.sl,
					color: a.muted,
					text: ` ${r("tradeFinder.ghostStop")}: ${t(e.ghost.sl)} `
				});
			}
			return c;
		}
	});
}, Zd = {
	emaFast: "#4FC3F7",
	emaTrigger: "#2962FF",
	emaMid: "#FF9800",
	emaBig: "#FF5252"
}, Qd = {
	hintBull: "#00897B",
	hintBear: "#FF9800",
	bull: "#4CAF50",
	bear: "#FF5252"
}, $d = [
	92,
	87,
	80,
	70
], ef = {
	entryLong: "#4CAF50",
	entryShort: "#FF5252",
	reEntry: "#9E9E9E",
	stop: "#E53935",
	beExit: "#78909C",
	target: "#26A69A"
}, tf = {
	fast: Zd.emaFast,
	mid: Zd.emaMid,
	big: Zd.emaBig
}, nf = ({ studyName: e }) => Pn({
	studyName: e,
	label: "Trade Finder EMA labels",
	reanchor: !0,
	themeAware: !1,
	blockStaleOnDuplicateRemoval: !0,
	anchorsFor: jn,
	specsFor: (e) => e.emas.filter((e) => Number.isFinite(e.value)).map((e) => ({
		kind: "label",
		price: e.value,
		color: tf[e.key],
		text: ` EMA ${e.length} `
	}))
}), rf = 12, af = 20, of = Math.max(rf, af), sf = [], cf = {
	count: 0,
	tp1: 0,
	tp2: 0,
	tp3: 0,
	stopped: 0
}, lf = (e, t) => e.time === t.time && e.entry === t.entry && e.exit === t.exit && e.rMultiple === t.rMultiple && e.bestTarget === t.bestTarget && e.win === t.win, uf = (e) => {
	let t = e.slice(0, af);
	if (t.length === 0) return cf;
	let n = 0, r = 0, i = 0, a = 0;
	for (let e of t) e.bestTarget >= 1 && n++, e.bestTarget >= 2 && r++, e.bestTarget >= 3 && i++, e.bestTarget === 0 && a++;
	let o = (e) => Math.round(e / t.length * 100);
	return {
		count: t.length,
		tp1: o(n),
		tp2: o(r),
		tp3: o(i),
		stopped: o(a)
	};
}, df = ({ studyName: e, onUpdate: t }) => {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = !0, a = ft({
		studyName: e,
		onUpdate: t,
		buildData: (e, t) => {
			let i = W(t.symbol, t.resolution);
			return {
				...e,
				recent: n.get(i) ?? sf,
				stats: r.get(i) ?? cf
			};
		}
	});
	return {
		onSnapshot: a.onSnapshot,
		onClosedTrade: (e) => {
			if (!i || !Number.isFinite(e.entryTime) || !Number.isFinite(e.entry) || !Number.isFinite(e.exit) || !Number.isFinite(e.rMultiple)) return;
			let t = W(e.symbol, e.resolution), o = (t) => t.entryTime === e.entryTime && t.side === e.side, s = n.get(t) ?? sf, c = s.find(o);
			if (c && lf(c, e)) return;
			let l = [...s.filter((e) => !o(e)), e].sort((e, t) => t.entryTime - e.entryTime).slice(0, of);
			l.some(o) && (n.set(t, l), r.set(t, uf(l)), a.republish());
		},
		attach: a.attach,
		destroy: () => {
			i && (i = !1, a.destroy(), n.clear(), r.clear());
		}
	};
}, ff = {
	trend: 0,
	above: !1,
	crossUp: !1,
	crossDown: !1,
	strengthening: !1,
	ema19: NaN,
	valid: !1
}, pf = 3, mf = () => ({
	previous: NaN,
	current: NaN,
	bars: 0
}), hf = (e, t, n) => {
	let r = Math.min(n, e.bars + 1);
	return e.current = e.bars === 0 ? t : 2 * (t - e.previous) / (r + 1) + e.previous, e.current;
}, gf = (e, t) => {
	e.previous = e.current, e.bars = t;
}, _f = (e, t) => {
	let n = e.length - 1 - t;
	return n < 0 ? NaN : e[n] ?? NaN;
}, vf = (...e) => {
	for (let t of e) t.push(NaN);
}, yf = (...e) => {
	for (let t of e) t.length === 0 && t.push(NaN);
}, bf = ({ trendEmaLen: e, rich: t }) => {
	let n = mf(), r = mf(), i = mf(), a = 0, o = [], s = [];
	return {
		advance() {
			a++, gf(n, a), gf(r, a), gf(i, a), vf(o, s);
		},
		read(a) {
			yf(o, s);
			let c = hf(n, a, e), l = a > c ? 1 : a < c ? -1 : 0;
			if (!t) return {
				...ff,
				trend: l,
				valid: !0
			};
			let u = hf(r, a, 19), d = hf(i, a, 50), f = u > d, p = Number.isFinite(d) && d !== 0 ? (u - d) / d * 100 : 0, m = _f(o, 1), h = _f(s, pf);
			o[o.length - 1] = +!!f, s[s.length - 1] = p;
			let g = !Number.isNaN(m);
			return {
				trend: l,
				above: f,
				crossUp: g && f && m === 0,
				crossDown: g && !f && m === 1,
				strengthening: !Number.isNaN(h) && p > h,
				ema19: u,
				valid: !0
			};
		}
	};
}, xf = {
	above: !1,
	slopePercent: 0,
	crossings: 0
}, Sf = ({ biasEmaLen: e, slopeLookback: t, crossLookback: n }) => {
	let r = mf(), i = mf(), a = 0, o = [], s = [];
	return {
		advance() {
			a++, gf(r, a), gf(i, a), vf(o, s);
		},
		read(a) {
			yf(o, s);
			let c = hf(r, a, e), l = hf(i, a, 19) > c;
			o[o.length - 1] = c, s[s.length - 1] = +!!l;
			let u = _f(o, t), d = !Number.isNaN(u) && c !== 0 ? (c - u) / c * 100 : 0, f = 0;
			for (let e = 0; e < n; e++) {
				let t = _f(s, e), n = _f(s, e + 1);
				!Number.isNaN(t) && !Number.isNaN(n) && t !== n && f++;
			}
			return {
				above: l,
				slopePercent: d,
				crossings: f
			};
		}
	};
}, Cf = () => {
	let e = mf(), t = 0, n = [];
	return {
		advance() {
			t++, gf(e, t), vf(n);
		},
		read(t) {
			yf(n);
			let r = hf(e, t, 50);
			n[n.length - 1] = r;
			let i = _f(n, 3);
			return !Number.isNaN(i) && r > i;
		}
	};
}, wf = (e, t, n, r, i, a) => {
	if (!e || !e.hasHistory()) return a;
	let o = e.indexAt(t);
	return o < 0 ? a : e.series(n, r, i)[o] ?? a;
}, Tf = (e) => ({ context: t, plan: n, mtfReady: r, barTime: i, chartSpanMs: a, reader: o, trendEmaLen: s, biasEmaLen: c, slopeLookback: l, crossLookback: u }) => {
	let d = (n) => Math.min(n, e.n(t) + 1), f = r && o.isReady(), p = i + Math.max(a, 1) - 1, m = (n) => {
		let r = t.new_unlimited_var(e.close(t)), i = e.ema(r, d(s), t), a = e.close(t), o = a > i ? 1 : a < i ? -1 : 0;
		if (!n) return {
			...ff,
			trend: o,
			valid: !0
		};
		let c = e.ema(r, d(19), t), l = e.ema(r, d(50), t), u = c > l, f = t.new_unlimited_var(+!!u), p = Number.isFinite(l) && l !== 0 ? (c - l) / l * 100 : 0, m = t.new_unlimited_var(p), h = f.get(1), g = m.get(3), _ = !e.na(h);
		return {
			trend: o,
			above: u,
			crossUp: _ && u && h === 0,
			crossDown: _ && !u && h === 1,
			strengthening: !e.na(g) && p > g,
			ema19: c,
			valid: !0
		};
	}, h = (e, t) => wf(o.slot(e), p, "frame", `${t ? "rich" : "trend"}:${s}`, () => bf({
		trendEmaLen: s,
		rich: t
	}), ff), g = (e) => e === 0 || f && (o.slot(e)?.hasHistory() ?? !1), _ = (n?.frames.length ?? 0) + 1, v = n?.richSlots ?? [], y = [];
	for (let e = 0; e < _; e++) {
		let t = v.includes(e);
		y.push(e === 0 ? m(t) : f ? h(e, t) : ff);
	}
	let b = n?.biasSlot ?? 0, x = n?.dxyValid ? n.dxySlot : 0, S = () => {
		let n = t.new_unlimited_var(e.close(t)), r = e.ema(n, d(c), t), i = e.ema(n, d(19), t), a = t.new_unlimited_var(r), o = i > r, s = t.new_unlimited_var(+!!o), f = a.get(l), p = !e.na(f) && r !== 0 ? (r - f) / r * 100 : 0, m = 0;
		for (let t = 0; t < u; t++) {
			let n = s.get(t), r = s.get(t + 1);
			!e.na(n) && !e.na(r) && n !== r && m++;
		}
		return {
			above: o,
			slopePercent: p,
			crossings: m
		};
	}, C = () => {
		let n = t.new_unlimited_var(e.close(t)), r = e.ema(n, d(50), t), i = t.new_unlimited_var(r).get(3);
		return !e.na(i) && r > i;
	}, w = b === 0 ? S() : f ? wf(o.slot(b), p, "bias", `${c}:${l}:${u}`, () => Sf({
		biasEmaLen: c,
		slopeLookback: l,
		crossLookback: u
	}), xf) : xf, T = x === 0 ? C() : f && wf(o.slot(x), p, "dxy", "50", Cf, !1);
	return {
		frames: y,
		biasAbove: w.above,
		biasSlopePercent: w.slopePercent,
		biasCrossings: w.crossings,
		biasValid: g(b),
		dxyRising: T,
		dxyValid: g(x)
	};
}, Ef = [
	"Auto",
	"Risk Reward",
	"ATR"
], Df = (e, t) => e === "Auto" ? t === Vr.Gold ? "ATR" : "Risk Reward" : e, Of = {
	[Vr.Gold]: "gold",
	[Vr.Btc]: "btc",
	[Vr.Nas100]: "index",
	[Vr.Sp500]: "index",
	[Vr.Dow]: "index"
}, kf = (e, t) => t[Of[e] ?? "other"], Af = {
	[Vr.Gold]: "gold",
	[Vr.Btc]: "btc"
}, jf = (e, t) => t[Af[e] ?? "other"], Mf = (e) => {
	let t = kf(e.instrument, e.caps), n = e.atr * jf(e.instrument, e.buffer), r = e.isLong ? e.swing - n : e.swing + n, i = e.isLong ? Math.max(r, e.entry - t) : Math.min(r, e.entry + t), a = e.tick * 2, o = e.isLong ? Math.min(i, e.emaMid - a) : Math.max(i, e.emaMid + a);
	return e.isLong ? Math.max(o, e.entry - t) : Math.min(o, e.entry + t);
}, Nf = (e) => {
	let t = e.atr * e.atrStopMultiple;
	return e.isLong ? e.entry - t : e.entry + t;
}, Pf = (e) => {
	let t = e.atr * e.buffer.gold, n = Math.abs(e.entry - e.swing) + t, r = e.chartMinutes <= 15 ? Math.max(e.caps.goldMin, Math.min(n, e.caps.gold)) : n, i = e.isLong ? e.entry - r : e.entry + r, a = e.tick * 2;
	return e.isLong ? Math.min(i, e.emaMid - a) : Math.max(i, e.emaMid + a);
}, Ff = (e, t) => {
	let n = Number.isFinite(e.swing);
	return e.instrument === Vr.Gold && e.autoDetect && e.chartMinutes <= 15 && n ? Pf(e) : t === "ATR" || !n ? Nf(e) : Mf(e);
}, If = (e, t, n, r) => {
	let i = t === "ATR" ? e.atr * r : e.risk * n;
	return e.isLong ? e.entry + i : e.entry - i;
}, Lf = (e, t, n, r) => [
	0,
	1,
	2,
	3,
	4
].map((i) => If(e, t, n[i] ?? 0, r[i] ?? 0)), Rf = [
	[4.5, 5],
	[4, 4],
	[3.5, 3],
	[3, 2]
], zf = (e) => Br(e, Rf, 1), Bf = (e, t, n) => t ? e * (1 + n / 100) : e * (1 - n / 100), Vf = (e, t, n) => t * (e === Vr.Btc ? n * 1.3 : n), Hf = ({ isLong: e, emaTrigger: t, emaMid: n }) => (e ? t > n : t < n) ? 2 : 0, Uf = ({ isLong: e, tuning: t, emaMid: n, emaMidPrev: r }) => {
	if (!Number.isFinite(n) || !Number.isFinite(r) || n === 0) return 0;
	let i = (n - r) / n * 100;
	if (e ? i <= 0 : i >= 0) return 0;
	let a = Math.abs(i);
	return a >= t.slopeStrongThreshold ? 1.25 : a >= t.slopeMidThreshold ? .75 : 0;
}, Wf = (e) => {
	let t = e.highestRecent > e.highestPrior, n = e.lowestRecent > e.lowestPrior, r = e.lowestRecent < e.lowestPrior, i = e.highestRecent < e.highestPrior, [a, o] = e.isLong ? [t && n, t || n] : [r && i, r || i];
	return a ? 1 : o ? .5 : 0;
}, Gf = ({ tuning: e, emaTrigger: t, emaMid: n }) => {
	if (!Number.isFinite(t) || !Number.isFinite(n) || n === 0) return 0;
	let r = Math.abs(t - n) / n * 100;
	return r < .01 ? 0 : r >= e.distOptimalMin && r <= e.distOptimalMax ? .5 : .25;
}, Kf = ({ tuning: e, chopCrossings: t }) => t === 0 ? e.chopMaxBonus : t === 1 ? e.chopMaxBonus * .5 : 0, qf = (e) => {
	let { tuning: t } = e, n = Hf(e) + Math.min(Uf(e) * t.slopeMultiplier, 1.25) + Math.min(Wf(e) * t.structureMultiplier, 1) + Gf(e) + Math.min(Kf(e) * t.chopMultiplier, .25);
	return Math.min(Math.max(n, 0), 5);
}, Jf = [
	[.7, 15],
	[.5, 10],
	[.3, 5]
], Yf = [
	[6, 12],
	[5, 9],
	[4, 6],
	[3, 3]
], Xf = [[3, 8], [2, 5]], Zf = [[3, -12], [2, -8]], Qf = (e, t, n) => e ? Br(n, Xf, 3) : t ? Br(n, Zf, -5) : -4, $f = (e) => {
	let t = e.isLong ? e.emaFast > e.emaTrigger && e.emaTrigger > e.emaMid ? 20 : e.emaFast > e.emaMid ? 12 : 0 : e.emaFast < e.emaTrigger && e.emaTrigger < e.emaMid ? 20 : e.emaFast < e.emaMid ? 12 : 0, n = e.adxPass ? e.diCross ? 20 : e.diStrength ? 15 : e.adxRising ? 12 : 8 : e.adxRising ? 5 : 3, r = Br(e.candleRange > 0 ? e.candleBody / e.candleRange : 0, Jf, 2), i = (e.isLong ? e.close > e.vwap : e.close < e.vwap) ? 12 : -3, a = e.trendDirections.filter((t) => e.isLong ? t > 0 : t < 0).length, o = Br(a, Yf, 0), s = Math.min(e.volumeBonus * 10, 10), c = e.isLong ? e.htf15Above : !e.htf15Above, l = e.isLong ? e.htf60Above : !e.htf60Above, u = e.isLong ? e.lower1Above : !e.lower1Above, d = e.isLong ? e.lower2Above : !e.lower2Above, f = e.isLong ? e.warnCrossDown : e.warnCrossUp, p = e.isLong ? e.warnCrossUp : e.warnCrossDown, m = 0;
	e.lower1Valid && (m += f ? -6 : p ? 3 : u && e.lower1Strengthening ? 4 : u ? 2 : -3), e.lower2Valid && (m += f ? -3 : d && e.lower2Strengthening ? 2 : d ? 1 : -1.5), e.htf15Valid && (m += c && e.htf15Strengthening ? 3 : c ? 1 : -3), e.htf60Valid && (m += l && e.htf60Strengthening ? 2 : l ? .5 : -2);
	let h = e.instrument === Vr.Gold && e.dxyValid ? e.isLong ? e.dxyRising ? -4 : 4 : e.dxyRising ? 4 : -4 : 0, g = e.minuteWarnAgainst ? -10 : 0, _ = (e.isLong ? e.subFrameBearReversal : e.subFrameBullReversal) ? -5 : 0, v = e.nearPivot ? -8 : 0, y = e.biasFilterEnabled ? Qf(e.isLong ? e.biasBullish : e.biasBearish, e.isLong ? e.biasBearish : e.biasBullish, e.biasStrength) : 0, b = t + n + r + i + o + s + m + h + g + _ + v + y;
	return Math.min(Math.max(Math.round(b), 0), 92);
}, ep = [
	NaN,
	NaN,
	NaN,
	NaN,
	NaN
], tp = () => ({
	entry: 0,
	entry2: 0,
	reEntry: 0,
	stopExit: 0,
	beExit: 0,
	targetExit: 0
}), np = (e, t, n) => {
	let { high: r, low: i, close: a, atr: o } = t, s = tp(), c = e.direction, l = e.entry, u = e.firstEntry, d = e.stop, f = e.risk, p = e.entryTime, m = e.breakEvenDone, h = e.upgraded, g = e.bestTarget, _ = e.tp1Reached, v = e.trail, y = e.setupScore, b = e.entryScore, x = e.ghostDirection, S = e.ghostEntry, C = e.ghostStop, w = e.ghostTime, T = null, E = !1, D = kf(n.instrument, n.stopCaps), O = Number.isFinite(l) ? c === 1 ? l - D : l + D : NaN, k = [...ep], ee = () => {
		c = 0, l = NaN, u = NaN, d = NaN, f = NaN, p = NaN, m = !1, h = !1, _ = !1, g = 0, v = NaN, y = 0, b = 0, k = [...ep];
	};
	if (c !== 0 && Number.isFinite(l) && Number.isFinite(f)) {
		let e = c === 1;
		k = Lf({
			isLong: e,
			entry: l,
			risk: f,
			atr: o
		}, n.slTpMode, n.rMultiples, n.atrMultiples);
		for (let t = 0; t < 4; t++) {
			let n = k[t];
			Number.isFinite(n) && (e ? r >= n : i <= n) && (g = Math.max(g, t + 1));
		}
		(e ? r >= k[0] : i <= k[0]) && (_ = !0);
		let a = n.instrument === Vr.Gold && !m && (e ? r - l : l - i) >= n.beGoldPoints, u = !m && (e ? r >= k[0] : i <= k[0]);
		if (!m && (a || u) && (m = !0, d = Bf(l, e, n.feeBufferPct)), n.useTrailingStop && _) {
			let t = Vf(n.instrument, o, n.trailAtrMult), i = e ? r - t : r + t;
			v = Number.isNaN(v) ? i : e ? Math.max(v, i) : Math.min(v, i), d = e ? Math.max(d, v) : Math.min(d, v);
		}
		let h = !Number.isNaN(v) && (e ? i < v : r > v), y = Number.isFinite(O) && (e ? i < O : r > O), b = Number.isFinite(d) && Number.isNaN(v) && !m && (e ? i < d : r > d), x = k[4], S = Number.isFinite(x) && (e ? r >= x : i <= x), C = h || y || b, w = S && (Number.isNaN(v) || n.tp5CloseAlways);
		if (C || w) {
			let e = C ? h ? v : y ? O : d : x;
			w && (g = 5), T = {
				side: c,
				entry: l,
				exit: e,
				rMultiple: f > 0 ? (e - l) / f * c : NaN,
				bestTarget: g,
				entryTime: p,
				time: t.time
			}, n.showEntrySignals && (C && m ? s.beExit = c : C ? s.stopExit = c : s.targetExit = c), ee();
		}
	}
	if (c !== 0 && (c === 1 ? t.trendCrossDown : t.trendCrossUp) && (x = c, S = l, C = d, w = p, ee()), x !== 0 && Number.isFinite(C) && (x === 1 ? a < C : a > C) && (x = 0, S = NaN, C = NaN, w = NaN), c === 0) {
		let e = t.long.touch || t.long.scalp, r = t.short.touch || t.short.scalp;
		if (e || r) {
			let r = e, i = r ? t.long : t.short;
			c = r ? 1 : -1, l = t.entryLevel, u = NaN, p = t.time, d = n.stopFor(r, l), f = Math.abs(l - d), m = !1, h = !1, _ = !1, g = 0, v = NaN, y = i.setupScore, b = i.entryScore, E = !0, n.showEntrySignals && (s.entry = c);
		}
	}
	if (c !== 0 && !h && !m && t.hasPriorBar) {
		let e = c === 1, r = e ? t.long : t.short;
		r.reachedMid && t.volumeOk && (u = l, l = t.upgradeLevel, d = n.stopFor(e, l), f = Math.abs(l - d), h = !0, v = NaN, y = r.setupScore, b = r.entryScore, n.showEntrySignals && (s.entry2 = c));
	}
	return c !== 0 && !E && !m && x === 0 && t.hasPriorBar && n.showEntrySignals && b >= 55 && t.volumeOk && (c === 1 ? t.long : t.short).backInZone && (s.reEntry = c), {
		state: {
			direction: c,
			entry: l,
			firstEntry: u,
			stop: d,
			risk: f,
			entryTime: p,
			breakEvenDone: m,
			upgraded: h,
			bestTarget: g,
			tp1Reached: _,
			trail: v,
			setupScore: y,
			entryScore: b,
			ghostDirection: x,
			ghostEntry: S,
			ghostStop: C,
			ghostTime: w
		},
		marks: s,
		closed: T,
		targets: k,
		activeTargets: c === 0 ? 0 : n.clearTargets(l, k, zf(y))
	};
}, rp = "Trade Finder", ip = 5, ap = [
	[1, 5],
	[3, 4],
	[5, 3],
	[15, 2]
], op = [
	[.1, 3],
	[.05, 2],
	[.02, 1]
], sp = [
	[(e, t) => e && t, 1],
	[(e) => e, .75],
	[(e, t) => t, .5],
	[(e, t, n) => n, .25]
], cp = .1, lp = 3, up = "0800-1700", dp = "1300-2200", fp = "0000-0800", pp = 14, mp = 3, hp = 5, gp = 55, _p = 3, vp = 1e3, yp = {
	isReady: () => !1,
	slot: () => void 0
}, bp = (e, t, n, r, i, a, o, s, c) => {
	let l = a || "en", u = o ?? "", d = R.getFixedT(l, F), f = (e) => e.toLocaleUpperCase(l), p = Zd, m = Qd, h = ef, g = $d, v = e.Std, y = Tf(v), b = {
		session: d("tradeFinder.group.session"),
		ema: d("tradeFinder.group.emaSystem"),
		bias: d("tradeFinder.group.bias"),
		entries: d("tradeFinder.group.entries"),
		filter: d("tradeFinder.group.filter"),
		trailing: d("tradeFinder.group.trailingStop"),
		risk: d("tradeFinder.group.riskManagement"),
		trendPanel: d("tradeFinder.group.trendPanel"),
		levels: d("tradeFinder.group.supportResistance"),
		display: d("tradeFinder.group.display")
	}, x = (e) => ({
		color: e,
		linestyle: 0,
		linewidth: 1,
		plottype: 7,
		trackPrice: !1,
		transparency: 100,
		visible: !1
	}), S = (e, t, n) => ({
		color: e,
		textColor: e,
		plottype: t,
		location: n,
		size: "small",
		transparency: 0,
		visible: !0,
		showLast: vp
	});
	return {
		name: rp,
		metainfo: {
			_metainfoVersion: 53,
			id: "TradeFinder@tv-basicstudies-1",
			description: rp,
			shortDescription: "Trade Finder",
			format: { type: "inherit" },
			is_price_study: !0,
			isCustomIndicator: !0,
			linkedToSeries: !0,
			plots: [
				{
					id: "emaFast",
					type: "line"
				},
				{
					id: "emaTrigger",
					type: "line"
				},
				{
					id: "emaMid",
					type: "line"
				},
				{
					id: "emaBig",
					type: "line"
				},
				{
					id: "zbFast",
					type: "line"
				},
				{
					id: "zbTrigger",
					type: "line"
				},
				{
					id: "zb33",
					type: "line"
				},
				{
					id: "zb66",
					type: "line"
				},
				{
					id: "zbMid",
					type: "line"
				},
				{
					id: "zsFast",
					type: "line"
				},
				{
					id: "zsTrigger",
					type: "line"
				},
				{
					id: "zs33",
					type: "line"
				},
				{
					id: "zs66",
					type: "line"
				},
				{
					id: "zsMid",
					type: "line"
				},
				{
					id: "entryLong",
					type: "shapes"
				},
				{
					id: "entryShort",
					type: "shapes"
				},
				{
					id: "entry2Long",
					type: "shapes"
				},
				{
					id: "entry2Short",
					type: "shapes"
				},
				{
					id: "reEntryLong",
					type: "shapes"
				},
				{
					id: "reEntryShort",
					type: "shapes"
				},
				{
					id: "stopHitLong",
					type: "shapes"
				},
				{
					id: "stopHitShort",
					type: "shapes"
				},
				{
					id: "beExitLong",
					type: "shapes"
				},
				{
					id: "beExitShort",
					type: "shapes"
				},
				{
					id: "targetHitLong",
					type: "shapes"
				},
				{
					id: "targetHitShort",
					type: "shapes"
				}
			],
			filledAreas: [
				{
					id: "fillBull1",
					objAId: "zbFast",
					objBId: "zbTrigger",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBull", { n: 1 }),
					fillgaps: !1
				},
				{
					id: "fillBull2",
					objAId: "zbTrigger",
					objBId: "zb33",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBull", { n: 2 }),
					fillgaps: !1
				},
				{
					id: "fillBull3",
					objAId: "zb33",
					objBId: "zb66",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBull", { n: 3 }),
					fillgaps: !1
				},
				{
					id: "fillBull4",
					objAId: "zb66",
					objBId: "zbMid",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBull", { n: 4 }),
					fillgaps: !1
				},
				{
					id: "fillBear1",
					objAId: "zsFast",
					objBId: "zsTrigger",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBear", { n: 1 }),
					fillgaps: !1
				},
				{
					id: "fillBear2",
					objAId: "zsTrigger",
					objBId: "zs33",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBear", { n: 2 }),
					fillgaps: !1
				},
				{
					id: "fillBear3",
					objAId: "zs33",
					objBId: "zs66",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBear", { n: 3 }),
					fillgaps: !1
				},
				{
					id: "fillBear4",
					objAId: "zs66",
					objBId: "zsMid",
					type: "plot_plot",
					title: d("tradeFinder.entryZoneBear", { n: 4 }),
					fillgaps: !1
				}
			],
			styles: {
				emaFast: { title: d("tradeFinder.emaEntry1") },
				emaTrigger: { title: d("tradeFinder.emaTrigger") },
				emaMid: { title: d("tradeFinder.emaEntry2") },
				emaBig: { title: d("tradeFinder.emaRangeFilter") },
				zbFast: { title: d("tradeFinder.zoneEdgeBull", { n: 1 }) },
				zbTrigger: { title: d("tradeFinder.zoneEdgeBull", { n: 2 }) },
				zb33: { title: d("tradeFinder.zoneEdgeBull", { n: 3 }) },
				zb66: { title: d("tradeFinder.zoneEdgeBull", { n: 4 }) },
				zbMid: { title: d("tradeFinder.zoneEdgeBull", { n: 5 }) },
				zsFast: { title: d("tradeFinder.zoneEdgeBear", { n: 1 }) },
				zsTrigger: { title: d("tradeFinder.zoneEdgeBear", { n: 2 }) },
				zs33: { title: d("tradeFinder.zoneEdgeBear", { n: 3 }) },
				zs66: { title: d("tradeFinder.zoneEdgeBear", { n: 4 }) },
				zsMid: { title: d("tradeFinder.zoneEdgeBear", { n: 5 }) },
				entryLong: {
					title: `${d("tradeFinder.entry1")} ${d("long")}`,
					text: f(d("long"))
				},
				entryShort: {
					title: `${d("tradeFinder.entry1")} ${d("short")}`,
					text: f(d("short"))
				},
				entry2Long: {
					title: `${d("tradeFinder.entry2")} ${d("long")}`,
					text: d("tradeFinder.entry2Mark")
				},
				entry2Short: {
					title: `${d("tradeFinder.entry2")} ${d("short")}`,
					text: d("tradeFinder.entry2Mark")
				},
				reEntryLong: {
					title: `${d("tradeFinder.reEntry")} ${d("long")}`,
					text: d("tradeFinder.reEntryMark")
				},
				reEntryShort: {
					title: `${d("tradeFinder.reEntry")} ${d("short")}`,
					text: d("tradeFinder.reEntryMark")
				},
				stopHitLong: {
					title: `${d("tradeFinder.stopHit")} ${d("long")}`,
					text: d("sl")
				},
				stopHitShort: {
					title: `${d("tradeFinder.stopHit")} ${d("short")}`,
					text: d("sl")
				},
				beExitLong: {
					title: `${d("breakEven")} ${d("long")}`,
					text: d("tradeFinder.breakEvenMark")
				},
				beExitShort: {
					title: `${d("breakEven")} ${d("short")}`,
					text: d("tradeFinder.breakEvenMark")
				},
				targetHitLong: {
					title: `${d("tradeFinder.targetHit")} ${d("long")}`,
					text: d("tp", { n: 5 })
				},
				targetHitShort: {
					title: `${d("tradeFinder.targetHit")} ${d("short")}`,
					text: d("tp", { n: 5 })
				}
			},
			defaults: {
				inputs: {
					emaFastLen: 14,
					emaTriggerLen: 19,
					emaMidLen: 50,
					emaBigLen: 300,
					showEntryZone: !0,
					showSRLines: !0,
					srLeftBars: 15,
					srRightBars: 15,
					trendPanelEmaLen: 50,
					biasEmaLen: 50,
					slopeLookback: 5,
					flatThreshPct: .05,
					maxCrosses: 3,
					crossLookback: 10,
					useBiasFilter: !0,
					useAdxFilter: !0,
					adxLen: 14,
					adxSmoothing: 14,
					volAvgLen: 10,
					dxySymbol: u,
					useSessionFilter: !0,
					useEmaStackCheck: !0,
					useVolumeConfirm: !1,
					volMultiplier: 1,
					trendSlopeLB: 3,
					useSlopeDynamic: !0,
					useInstrumentAutoDetect: !0,
					swingPivotLen: 5,
					atrLength: 14,
					atrBufferMultGold: .3,
					atrBufferMultBtc: .75,
					atrBufferMultOther: .5,
					slMaxPointsGold: 10,
					slMinPointsGold: 5,
					slMaxPointsBtc: 500,
					slMaxPointsIndex: 50,
					slMaxPointsOther: 100,
					tpSlMode: "Auto",
					tp1R: .5,
					tp2R: 1,
					tp3R: 1.5,
					tp4R: 2,
					tp5R: 3,
					atrSlMult: 3,
					atrTp1Mult: 1.5,
					atrTp2Mult: 2.5,
					atrTp3Mult: 3.5,
					atrTp4Mult: 4.5,
					atrTp5Mult: 6,
					feeBufferPct: .02,
					beGoldPoints: 5.6,
					useTrailingStop: !0,
					trailAtrMult: 1.5,
					tp5CloseAlways: !1,
					showEntrySignals: !0,
					showTradeLevels: !0,
					useStrictCandle: !0,
					londonSession: up,
					newYorkSession: dp,
					asiaSession: fp,
					showEmaLabels: !0,
					tp1ClosePct: 33,
					tp2ClosePct: 33,
					[Di]: 0
				},
				filledAreasStyle: {
					fillBull1: {
						color: m.hintBull,
						transparency: g[0],
						visible: !0
					},
					fillBull2: {
						color: m.bull,
						transparency: g[1],
						visible: !0
					},
					fillBull3: {
						color: m.bull,
						transparency: g[2],
						visible: !0
					},
					fillBull4: {
						color: m.bull,
						transparency: g[3],
						visible: !0
					},
					fillBear1: {
						color: m.hintBear,
						transparency: g[0],
						visible: !0
					},
					fillBear2: {
						color: m.bear,
						transparency: g[1],
						visible: !0
					},
					fillBear3: {
						color: m.bear,
						transparency: g[2],
						visible: !0
					},
					fillBear4: {
						color: m.bear,
						transparency: g[3],
						visible: !0
					}
				},
				styles: {
					emaFast: {
						color: p.emaFast,
						linestyle: 0,
						linewidth: 2,
						plottype: 0,
						trackPrice: !1,
						transparency: 0,
						visible: !0
					},
					emaTrigger: {
						color: p.emaTrigger,
						linestyle: 0,
						linewidth: 1,
						plottype: 0,
						trackPrice: !1,
						transparency: 0,
						visible: !0
					},
					emaMid: {
						color: p.emaMid,
						linestyle: 0,
						linewidth: 3,
						plottype: 0,
						trackPrice: !1,
						transparency: 0,
						visible: !0
					},
					emaBig: {
						color: p.emaBig,
						linestyle: 0,
						linewidth: 2,
						plottype: 0,
						trackPrice: !1,
						transparency: 0,
						visible: !0
					},
					zbFast: x(m.hintBull),
					zbTrigger: x(m.bull),
					zb33: x(m.bull),
					zb66: x(m.bull),
					zbMid: x(m.bull),
					zsFast: x(m.hintBear),
					zsTrigger: x(m.bear),
					zs33: x(m.bear),
					zs66: x(m.bear),
					zsMid: x(m.bear),
					entryLong: S(h.entryLong, "shape_triangle_up", "BelowBar"),
					entryShort: S(h.entryShort, "shape_triangle_down", "AboveBar"),
					entry2Long: S(h.entryLong, "shape_arrow_up", "BelowBar"),
					entry2Short: S(h.entryShort, "shape_arrow_down", "AboveBar"),
					reEntryLong: S(h.reEntry, "shape_circle", "BelowBar"),
					reEntryShort: S(h.reEntry, "shape_circle", "AboveBar"),
					stopHitLong: S(h.stop, "shape_xcross", "BelowBar"),
					stopHitShort: S(h.stop, "shape_xcross", "AboveBar"),
					beExitLong: S(h.beExit, "shape_diamond", "BelowBar"),
					beExitShort: S(h.beExit, "shape_diamond", "AboveBar"),
					targetHitLong: S(h.target, "shape_flag", "AboveBar"),
					targetHitShort: S(h.target, "shape_flag", "BelowBar")
				}
			},
			inputs: [
				{
					id: "emaFastLen",
					name: d("tradeFinder.input.emaFastLen"),
					type: "integer",
					defval: 14,
					min: 1,
					max: 5e3,
					group: b.ema
				},
				{
					id: "emaTriggerLen",
					name: d("tradeFinder.input.emaTriggerLen"),
					type: "integer",
					defval: 19,
					min: 1,
					max: 5e3,
					group: b.ema
				},
				{
					id: "emaMidLen",
					name: d("tradeFinder.input.emaMidLen"),
					type: "integer",
					defval: 50,
					min: 1,
					max: 5e3,
					group: b.ema
				},
				{
					id: "emaBigLen",
					name: d("tradeFinder.input.emaBigLen"),
					type: "integer",
					defval: 300,
					min: 1,
					max: 5e3,
					group: b.ema
				},
				{
					id: "showEntryZone",
					name: d("tradeFinder.input.showEntryZone"),
					type: "bool",
					defval: !0,
					group: b.ema
				},
				{
					id: "showSRLines",
					name: d("tradeFinder.input.showSRLines"),
					type: "bool",
					defval: !0,
					group: b.levels
				},
				{
					id: "srLeftBars",
					name: d("tradeFinder.input.srLeftBars"),
					type: "integer",
					defval: 15,
					min: 1,
					max: 1e3,
					group: b.levels
				},
				{
					id: "srRightBars",
					name: d("tradeFinder.input.srRightBars"),
					type: "integer",
					defval: 15,
					min: 1,
					max: 1e3,
					group: b.levels
				},
				{
					id: "trendPanelEmaLen",
					name: d("tradeFinder.input.trendPanelEmaLen"),
					type: "integer",
					defval: 50,
					min: 1,
					max: 5e3,
					group: b.trendPanel
				},
				{
					id: "biasEmaLen",
					name: d("tradeFinder.input.biasEmaLen"),
					type: "integer",
					defval: 50,
					min: 1,
					max: 5e3,
					group: b.bias
				},
				{
					id: "slopeLookback",
					name: d("tradeFinder.input.slopeLookback"),
					type: "integer",
					defval: 5,
					min: 1,
					max: 500,
					group: b.bias
				},
				{
					id: "flatThreshPct",
					name: d("tradeFinder.input.flatThreshPct"),
					type: "float",
					defval: .05,
					min: 0,
					max: 100,
					group: b.bias
				},
				{
					id: "maxCrosses",
					name: d("tradeFinder.input.maxCrosses"),
					type: "integer",
					defval: 3,
					min: 1,
					max: 100,
					group: b.bias
				},
				{
					id: "crossLookback",
					name: d("tradeFinder.input.crossLookback"),
					type: "integer",
					defval: 10,
					min: 1,
					max: 500,
					group: b.bias
				},
				{
					id: "useBiasFilter",
					name: d("tradeFinder.input.useBiasFilter"),
					type: "bool",
					defval: !0,
					group: b.entries
				},
				{
					id: "useAdxFilter",
					name: d("tradeFinder.input.useAdxFilter"),
					type: "bool",
					defval: !0,
					group: b.filter
				},
				{
					id: "adxLen",
					name: d("tradeFinder.input.adxLen"),
					type: "integer",
					defval: 14,
					min: 1,
					max: 500,
					group: b.filter
				},
				{
					id: "adxSmoothing",
					name: d("tradeFinder.input.adxSmoothing"),
					type: "integer",
					defval: 14,
					min: 1,
					max: 500,
					group: b.filter
				},
				{
					id: "volAvgLen",
					name: d("tradeFinder.input.volAvgLen"),
					type: "integer",
					defval: 10,
					min: 1,
					max: 500,
					group: b.filter
				},
				{
					id: "dxySymbol",
					name: d("tradeFinder.input.dxySymbol"),
					type: "text",
					defval: u,
					group: b.entries
				},
				{
					id: "useSessionFilter",
					name: d("tradeFinder.input.useSessionFilter"),
					type: "bool",
					defval: !0,
					group: b.session
				},
				{
					id: "useEmaStackCheck",
					name: d("tradeFinder.input.useEmaStackCheck"),
					type: "bool",
					defval: !0,
					group: b.filter
				},
				{
					id: "useVolumeConfirm",
					name: d("tradeFinder.input.useVolumeConfirm"),
					type: "bool",
					defval: !1,
					group: b.filter
				},
				{
					id: "volMultiplier",
					name: d("tradeFinder.input.volMultiplier"),
					type: "float",
					defval: 1,
					min: 0,
					max: 100,
					group: b.filter
				},
				{
					id: "trendSlopeLB",
					name: d("tradeFinder.input.trendSlopeLB"),
					type: "integer",
					defval: 3,
					min: 1,
					max: 500,
					group: b.entries
				},
				{
					id: "useSlopeDynamic",
					name: d("tradeFinder.input.useSlopeDynamic"),
					type: "bool",
					defval: !0,
					group: b.entries
				},
				{
					id: "useInstrumentAutoDetect",
					name: d("tradeFinder.input.useInstrumentAutoDetect"),
					type: "bool",
					defval: !0,
					group: b.risk
				},
				{
					id: "swingPivotLen",
					name: d("tradeFinder.input.swingPivotLen"),
					type: "integer",
					defval: 5,
					min: 1,
					max: 500,
					group: b.risk
				},
				{
					id: "atrLength",
					name: d("tradeFinder.input.atrLength"),
					type: "integer",
					defval: 14,
					min: 1,
					max: 500,
					group: b.risk
				},
				{
					id: "atrBufferMultGold",
					name: d("tradeFinder.input.atrBufferMultGold"),
					type: "float",
					defval: .3,
					min: .1,
					max: 20,
					group: b.risk
				},
				{
					id: "atrBufferMultBtc",
					name: d("tradeFinder.input.atrBufferMultBtc"),
					type: "float",
					defval: .75,
					min: .1,
					max: 20,
					group: b.risk
				},
				{
					id: "atrBufferMultOther",
					name: d("tradeFinder.input.atrBufferMultOther"),
					type: "float",
					defval: .5,
					min: .1,
					max: 20,
					group: b.risk
				},
				{
					id: "slMaxPointsGold",
					name: d("tradeFinder.input.slMaxPointsGold"),
					type: "float",
					defval: 10,
					min: .1,
					max: 1e5,
					group: b.risk
				},
				{
					id: "slMinPointsGold",
					name: d("tradeFinder.input.slMinPointsGold"),
					type: "float",
					defval: 5,
					min: .1,
					max: 1e5,
					group: b.risk
				},
				{
					id: "slMaxPointsBtc",
					name: d("tradeFinder.input.slMaxPointsBtc"),
					type: "float",
					defval: 500,
					min: .1,
					max: 1e6,
					group: b.risk
				},
				{
					id: "slMaxPointsIndex",
					name: d("tradeFinder.input.slMaxPointsIndex"),
					type: "float",
					defval: 50,
					min: .1,
					max: 1e5,
					group: b.risk
				},
				{
					id: "slMaxPointsOther",
					name: d("tradeFinder.input.slMaxPointsOther"),
					type: "float",
					defval: 100,
					min: .1,
					max: 1e6,
					group: b.risk
				},
				{
					id: "tpSlMode",
					name: d("tradeFinder.input.tpSlMode"),
					type: "text",
					defval: "Auto",
					group: b.risk,
					options: Ef,
					optionsTitles: {
						Auto: d("tradeFinder.modeAuto"),
						"Risk Reward": d("tradeFinder.modeRiskReward"),
						ATR: d("tradeFinder.modeAtr")
					}
				},
				{
					id: "tp1R",
					name: d("tradeFinder.input.tpR", { n: 1 }),
					type: "float",
					defval: .5,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "tp2R",
					name: d("tradeFinder.input.tpR", { n: 2 }),
					type: "float",
					defval: 1,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "tp3R",
					name: d("tradeFinder.input.tpR", { n: 3 }),
					type: "float",
					defval: 1.5,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "tp4R",
					name: d("tradeFinder.input.tpR", { n: 4 }),
					type: "float",
					defval: 2,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "tp5R",
					name: d("tradeFinder.input.tpR", { n: 5 }),
					type: "float",
					defval: 3,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "atrSlMult",
					name: d("tradeFinder.input.atrSlMult"),
					type: "float",
					defval: 3,
					min: .5,
					max: 100,
					group: b.risk
				},
				{
					id: "atrTp1Mult",
					name: d("tradeFinder.input.atrTpMult", { n: 1 }),
					type: "float",
					defval: 1.5,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "atrTp2Mult",
					name: d("tradeFinder.input.atrTpMult", { n: 2 }),
					type: "float",
					defval: 2.5,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "atrTp3Mult",
					name: d("tradeFinder.input.atrTpMult", { n: 3 }),
					type: "float",
					defval: 3.5,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "atrTp4Mult",
					name: d("tradeFinder.input.atrTpMult", { n: 4 }),
					type: "float",
					defval: 4.5,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "atrTp5Mult",
					name: d("tradeFinder.input.atrTpMult", { n: 5 }),
					type: "float",
					defval: 6,
					min: .1,
					max: 100,
					group: b.risk
				},
				{
					id: "feeBufferPct",
					name: d("tradeFinder.input.feeBufferPct"),
					type: "float",
					defval: .02,
					min: 0,
					max: 10,
					group: b.risk
				},
				{
					id: "beGoldPoints",
					name: d("tradeFinder.input.beGoldPoints"),
					type: "float",
					defval: 5.6,
					min: .1,
					max: 1e5,
					group: b.risk
				},
				{
					id: "useTrailingStop",
					name: d("tradeFinder.input.useTrailingStop"),
					type: "bool",
					defval: !0,
					group: b.trailing
				},
				{
					id: "trailAtrMult",
					name: d("tradeFinder.input.trailAtrMult"),
					type: "float",
					defval: 1.5,
					min: .5,
					max: 100,
					group: b.trailing
				},
				{
					id: "tp5CloseAlways",
					name: d("tradeFinder.input.tp5CloseAlways"),
					type: "bool",
					defval: !1,
					group: b.trailing
				},
				{
					id: "showEntrySignals",
					name: d("tradeFinder.input.showEntrySignals"),
					type: "bool",
					defval: !0,
					group: b.display
				},
				{
					id: "showTradeLevels",
					name: d("tradeFinder.input.showTradeLevels"),
					type: "bool",
					defval: !0,
					group: b.display
				},
				{
					id: "useStrictCandle",
					name: d("tradeFinder.input.useStrictCandle"),
					type: "bool",
					defval: !0,
					group: b.filter
				},
				{
					id: "londonSession",
					name: d("tradeFinder.input.londonSession"),
					type: "session",
					defval: up,
					group: b.session
				},
				{
					id: "newYorkSession",
					name: d("tradeFinder.input.newYorkSession"),
					type: "session",
					defval: dp,
					group: b.session
				},
				{
					id: "asiaSession",
					name: d("tradeFinder.input.asiaSession"),
					type: "session",
					defval: fp,
					group: b.session
				},
				{
					id: "showEmaLabels",
					name: d("tradeFinder.input.showEmaLabels"),
					type: "bool",
					defval: !0,
					group: b.ema
				},
				{
					id: "tp1ClosePct",
					name: d("tradeFinder.input.tp1ClosePct"),
					type: "integer",
					defval: 33,
					min: 0,
					max: 100,
					group: b.risk
				},
				{
					id: "tp2ClosePct",
					name: d("tradeFinder.input.tp2ClosePct"),
					type: "integer",
					defval: 33,
					min: 0,
					max: 100,
					group: b.risk
				},
				{
					id: Di,
					name: "Frame revision",
					type: "integer",
					defval: 0,
					min: 0,
					max: 1e6,
					isHidden: !0
				}
			]
		},
		constructor: function() {
			let e = NaN, a = NaN, o = NaN, l = NaN, d = NaN, f = NaN, p = NaN, m = 0, h = 0, g = 0, b = 0, x = NaN, S = null, C = null, w = null, D = {
				startMinutes: 0,
				isOvernight: !1
			}, O = "", k = [
				null,
				null,
				null
			], ee = "", te = "", ne = "", A = 0, j = 0;
			this.init = function(e, n) {
				this._context = e, this._input = n;
				let r = String(e.symbol?.period ?? v.period(e) ?? ""), i = oi(r), a = v.ticker(e), o = n ? n(19) : u, s = typeof o == "string" ? o : u, c = gi({
					chartResolution: r,
					mode: Kr(i),
					dxySymbol: Wr(a) === Vr.Gold ? s : ""
				});
				this._plan = c, this._mtf = !1;
				try {
					let n = String(e.symbol?.info?.name ?? a);
					this._frames = t.acquire({
						symbol: n,
						frames: c.frames
					}), this._mtf = !0;
				} catch (e) {
					console.warn(`${rp}: frames unavailable`, e), this._mtf = !1;
				}
			}, this.main = function(t, u) {
				this._context = t, this._input = u, t.select_sym(0);
				let M = Z(this._input(0), 14), re = Z(this._input(1), 19), N = Z(this._input(2), 50), P = Z(this._input(3), 300), ie = !!this._input(4), ae = !!this._input(5), oe = Z(this._input(6), 15), se = Z(this._input(7), 15), ce = Z(this._input(8), 50), le = Z(this._input(9), 50), F = Z(this._input(10), 5), ue = Z(this._input(11), .05), de = Z(this._input(12), 3), fe = Z(this._input(13), 10), pe = !!this._input(14), me = !!this._input(15), he = Z(this._input(16), 14), ge = Z(this._input(17), 14), _e = Z(this._input(18), 10), ve = !!this._input(20), ye = !!this._input(21), be = !!this._input(22), I = Z(this._input(23), 1), xe = Z(this._input(24), 3), Se = !!this._input(25), Ce = !!this._input(26), L = Z(this._input(27), 5), we = Z(this._input(28), 14), R = {
					gold: Z(this._input(29), .3),
					btc: Z(this._input(30), .75),
					other: Z(this._input(31), .5)
				}, Te = {
					gold: Z(this._input(32), 10),
					goldMin: Z(this._input(33), 5),
					btc: Z(this._input(34), 500),
					index: Z(this._input(35), 50),
					other: Z(this._input(36), 100)
				}, Ee = String(this._input(37) ?? "Auto"), Oe = [
					Z(this._input(38), .5),
					Z(this._input(39), 1),
					Z(this._input(40), 1.5),
					Z(this._input(41), 2),
					Z(this._input(42), 3)
				], ke = Z(this._input(43), 3), Ae = [
					Z(this._input(44), 1.5),
					Z(this._input(45), 2.5),
					Z(this._input(46), 3.5),
					Z(this._input(47), 4.5),
					Z(this._input(48), 6)
				], z = Z(this._input(49), .02), B = Z(this._input(50), 5.6), Ne = !!this._input(51), Pe = Z(this._input(52), 1.5), Fe = !!this._input(53), Ie = !!this._input(54), Le = !!this._input(55), Re = !!this._input(56), ze = !!this._input(60), Be = Z(this._input(61), 33), U = Z(this._input(62), 33), Ve = this._plan, He = this._mtf === !0 && Ve !== void 0, Ue = oi(String(t.symbol?.period ?? v.period(t) ?? "")), We = Wr(v.ticker(t)), Ge = Kr(Ue), Ke = ti(We), qe = ri(Ue), Je = Math.max(1, Math.round(_e * Ke.volumeAvgMultiplier)), Ye = Df(Ef.includes(Ee) ? Ee : "Auto", We), Xe = Se ? zr(Ue, ap, 1) : 1, Ze = Math.max(Math.round(xe * Xe + +(We === Vr.Btc)), 2), Qe = Math.max(P, N, re, M, ce, le, oe + se + 1, L * 2 + 1, qe * 2, fe, F, Ke.chopLookback, Ze, he + ge, Je, we, 50);
				t.setMinimumAdditionalDepth((Number.isFinite(Qe) ? Math.ceil(Qe) : 300) + 20);
				let $e = v.open(t), W = v.close(t), et = v.high(t), tt = v.low(t), nt = v.time(t), rt = nt !== x, it = _(t, v), at = t.new_unlimited_var(W), ot = t.new_unlimited_var(et), st = t.new_unlimited_var(tt), ct = t.new_unlimited_var(nt), lt = (e) => Math.min(e, v.n(t) + 1), ut = v.ema(at, lt(M), t), dt = v.ema(at, lt(re), t), G = v.ema(at, lt(N), t), ft = v.ema(at, lt(P), t), pt = t.new_unlimited_var(dt), mt = t.new_unlimited_var(G), ht = dt + (G - dt) * .33, gt = dt + (G - dt) * .66, _t = ie && Number.isFinite(ut) && Number.isFinite(dt) && Number.isFinite(G), vt = _t && ut > G, yt = _t && !vt, bt = (e) => vt ? e : NaN, xt = (e) => yt ? e : NaN, St = t.new_unlimited_var(), Ct = t.new_unlimited_var(), wt = t.new_unlimited_var(), Tt = t.new_unlimited_var(), Et = T(ot, oe, se, v), Dt = E(st, oe, se, v), Ot = ct.get(se), kt = St.get(1), At = Ct.get(1), jt = v.na(Et) ? kt : Et, Mt = v.na(Dt) ? At : Dt, Nt = v.na(Et) ? wt.get(1) : Ot, Pt = v.na(Dt) ? Tt.get(1) : Ot;
				St.set(jt), Ct.set(Mt), wt.set(Nt), Tt.set(Pt);
				let Ft = t.new_unlimited_var(), It = t.new_unlimited_var(), Lt = T(ot, L, L, v), Rt = E(st, L, L, v), zt = v.na(Lt) ? Ft.get(1) : Lt, Bt = v.na(Rt) ? It.get(1) : Rt;
				Ft.set(zt), It.set(Bt);
				let Vt = v.dmi(he, ge, t), Ht = Vt[0], Ut = Vt[1], Wt = Vt[3], Gt = t.new_unlimited_var(Ht), Kt = t.new_unlimited_var(Ut), qt = t.new_unlimited_var(Wt), Jt = t.new_unlimited_var(+(Ht > Ut)), K = qt.get(3), Yt = Gt.get(3), Xt = Kt.get(3), Zt = Jt.get(1), Qt = !v.na(K) && Wt > K, $t = !me || Wt >= Yr(Ge, We), en = v.atr(we, t), tn = t.new_unlimited_var(en), nn = v.sma(tn, 20, t), rn = !v.na(nn) && nn > 0 && en > nn * lp, an = v.change(at), q = t.new_unlimited_var(an > 0 ? an : 0), on = t.new_unlimited_var(an < 0 ? -an : 0), sn = v.rsi(v.rma(q, pp, t), v.rma(on, pp, t)), cn = Math.abs(W - $e), ln = et - tt, un = et - Math.max(W, $e), dn = Math.min(W, $e) - tt, fn = Qr(We), pn = ln > 0 && cn / ln >= fn.doji, mn = v.volume(t), hn = t.new_unlimited_var(mn), gn = v.sma(hn, lt(Je), t), _n = hn.get(1), vn = hn.get(2), yn = !v.na(_n) && !v.na(vn), bn = yn && mn > _n && _n > vn, xn = yn && mn < _n && _n < vn, Sn = !bn && !xn, Cn = !v.na(gn) && mn >= gn, wn = sp.find(([e]) => e(bn, Cn, Sn))?.[1] ?? 0, Tn = !be || !v.na(gn) && mn >= gn * I, En = t.new_unlimited_var(ot.get(qe)), Dn = t.new_unlimited_var(st.get(qe)), On = v.highest(ot, qe, t), kn = v.lowest(st, qe, t), An = v.highest(En, qe, t), jn = v.lowest(Dn, qe, t), Mn = t.new_unlimited_var(dt - G), Nn = 0;
				for (let e = 0; e < Ke.chopLookback; e++) {
					let t = Mn.get(e), n = Mn.get(e + 1);
					v.na(t) || v.na(n) || (t > 0 && n <= 0 || t < 0 && n >= 0) && Nn++;
				}
				let Pn = mt.get(3), Fn = mt.get(Ze), In = !v.na(Fn) && G > Fn, Ln = !v.na(Fn) && G < Fn, Rn = Mn.get(1), zn = !v.na(Rn) && dt > G && Rn <= 0, Bn = !v.na(Rn) && dt < G && Rn >= 0, Vn = t.symbol?.info, Hn = Vn?.timezone || "Etc/UTC", Un = Vn?.session || "24x7";
				if ((Hn !== S || Un !== C) && (S = Hn, C = Un, w = new Intl.DateTimeFormat("en-US", {
					timeZone: Hn,
					year: "numeric",
					month: "2-digit",
					day: "2-digit",
					hour: "2-digit",
					minute: "2-digit",
					hour12: !1
				}), D = V(Un)), Number.isFinite(nt) && w) {
					let n = w.formatToParts(new Date(nt)), r = "1970", i = "01", s = "01", c = "0", u = "0";
					for (let e of n) e.type === "year" ? r = e.value : e.type === "month" ? i = e.value : e.type === "day" ? s = e.value : e.type === "hour" ? c = e.value : e.type === "minute" && (u = e.value);
					let _ = parseInt(c, 10) % 24 * 60 + parseInt(u, 10), y = D.isOvernight && _ >= D.startMinutes ? 1 : 0, x = Date.UTC(parseInt(r, 10), parseInt(i, 10) - 1, parseInt(s, 10) + y), S = v.hlc3(t) * mn;
					rt ? Number.isNaN(e) ? (e = x, a = et, o = tt, l = W, m = 0, h = 0) : x === e ? (a = Math.max(a, et), o = Math.min(o, tt), l = W, m += g, h += b) : (d = a, f = o, p = l, e = x, a = et, o = tt, l = W, m = 0, h = 0) : (Number.isNaN(a) || (a = Math.max(a, et)), Number.isNaN(o) || (o = Math.min(o, tt)), l = W), g = Number.isFinite(S) ? S : 0, b = Number.isFinite(mn) ? mn : 0;
				}
				let Wn = h + b, Gn = Wn > 0 ? (m + g) / Wn : W, Kn = Number.isNaN(d) || Number.isNaN(f) || Number.isNaN(p) ? null : De({
					high: d,
					low: f,
					close: p
				}), qn = Kn !== null && W > 0 && [
					Kn.p,
					Kn.r1,
					Kn.s1,
					Kn.r2,
					Kn.s2
				].some((e) => Math.abs(W - e) / W * 100 <= cp), Jn = (e, t) => Kn !== null && [
					Kn.p,
					Kn.r1,
					Kn.s1,
					Kn.r2,
					Kn.s2
				].some((n) => n > Math.min(e, t) && n < Math.max(e, t)), Yn = (e, t, n) => {
					if (Kn === null || !Number.isFinite(e)) return n;
					for (let r = 0; r < n; r += 1) if (Number.isFinite(t[r]) && Jn(e, t[r])) return Math.max(1, r);
					return n;
				}, Xn = Number.isFinite(nt) ? new Date(nt).getUTCHours() * 60 + new Date(nt).getUTCMinutes() : 0, Zn = String(this._input(57) ?? up), Qn = String(this._input(58) ?? dp), $n = String(this._input(59) ?? fp), er = `${Zn}|${Qn}|${$n}`;
				er !== O && (O = er, k = [
					H(Zn),
					H(Qn),
					H($n)
				]);
				let [tr, nr, rr] = k, ir = !ve || k.some((e) => Me(Xn, e)), ar = y({
					context: t,
					plan: Ve,
					mtfReady: He,
					barTime: nt,
					chartSpanMs: Ue * 6e4,
					reader: this._frames ?? yp,
					trendEmaLen: ce,
					biasEmaLen: le,
					slopeLookback: F,
					crossLookback: fe
				}), or = (e) => (He ? ar.frames[e] : void 0) ?? ff, { biasAbove: sr, biasSlopePercent: cr, biasCrossings: lr, biasValid: ur, dxyRising: dr, dxyValid: fr } = ar, pr = He && ur && !(Math.abs(cr) < ue) && !(lr >= de), mr = pr && sr && cr > 0, hr = pr && !sr && cr < 0, gr = pr ? Br(Math.abs(cr), op, 0) : 0, _r = Ve?.panelSlots ?? ii.map(() => 0), vr = _r.map((e) => or(e).trend), yr = _r.map((e) => or(e).valid), br = He && Ve !== void 0 && Ve.frames.every((e, t) => t + 1 === Ve.dxySlot || or(t + 1).valid), xr = Ue > ip, Sr = vr.slice(0, 7).map((e, t) => t >= 5 && !xr ? 0 : e), Cr = or(Ve?.warnSlot ?? 0), wr = or(Ve?.minuteSlot ?? 0), Tr = or(Ve?.lower1Slot ?? 0), Er = or(Ve?.lower2Slot ?? 0), Dr = or(Ve?.htf15Slot ?? 0), Or = or(Ve?.htf60Slot ?? 0), kr = Cr.crossUp && dt < G, Ar = Cr.crossDown && dt > G, jr = Ue > 1, Mr = t.new_unlimited_var(), Nr = t.new_unlimited_var(), Pr = t.new_unlimited_var(), Fr = t.new_unlimited_var(), Ir = t.new_unlimited_var(), Lr = t.new_unlimited_var(), Rr = t.new_unlimited_var(), Ur = t.new_unlimited_var(), Gr = t.new_unlimited_var(), qr = t.new_unlimited_var(), Jr = t.new_unlimited_var(), Xr = t.new_unlimited_var(), Zr = t.new_unlimited_var(), $r = t.new_unlimited_var(), ei = t.new_unlimited_var(), ni = t.new_unlimited_var(), ai = t.new_unlimited_var(), si = t.new_unlimited_var(), ci = t.new_unlimited_var(), li = t.new_unlimited_var(), ui = t.new_unlimited_var(), di = t.new_unlimited_var(), fi = t.new_unlimited_var(), pi = t.new_unlimited_var(), mi = t.new_unlimited_var(), hi = (e) => e === 1, gi = (e) => v.na(e) ? NaN : e, _i = (e) => v.na(e) ? 0 : e, vi = {
					direction: _i(Mr.get(1)),
					entry: gi(Nr.get(1)),
					firstEntry: gi(Pr.get(1)),
					stop: gi(Fr.get(1)),
					risk: gi(Ir.get(1)),
					entryTime: gi(Lr.get(1)),
					breakEvenDone: hi(Rr.get(1)),
					upgraded: hi(Ur.get(1)),
					bestTarget: _i(Gr.get(1)),
					tp1Reached: hi(qr.get(1)),
					trail: gi(Jr.get(1)),
					setupScore: _i(Xr.get(1)),
					entryScore: _i(Zr.get(1)),
					ghostDirection: _i($r.get(1)),
					ghostEntry: gi(ei.get(1)),
					ghostStop: gi(ni.get(1)),
					ghostTime: gi(ai.get(1))
				}, yi = vi.direction, bi = Ge === Hr.Scalping, xi = We === Vr.Btc ? 3.5 : 3, Si = Tn && ir && !rn && br, Ci = st.get(1), wi = ot.get(1), Ti = pt.get(1), Ei = mt.get(1), Di = !v.na(Ci) && !v.na(wi) && !v.na(Ti) && !v.na(Ei), Oi = (e) => {
					let t = (t, n) => e ? t > n : t < n, n = (t, n) => e ? t >= n : t <= n, r = e ? tt : et, i = e ? Ci : wi, a = e ? Ht : Ut, o = e ? Ut : Ht, s = e ? Yt : Xt, c = pn && (!Re || (e ? dn : un) <= cn * fn.wick && t(W, $e)), l = !ye || t(ut, G), u = t(ut, G) && (bi || (e ? In : Ln)) && (bi || $t) && (bi || l), d = n(dt, r) && n(r, G), f = a > o && !v.na(s) && a > s, p = !v.na(Zt) && t(Ht, Ut) && Zt === +!e, m = jr && (e ? wr.crossDown : wr.crossUp) && yi === (e ? 1 : -1), h = qf({
						isLong: e,
						tuning: Ke,
						emaTrigger: dt,
						emaMid: G,
						emaMidPrev: Pn,
						highestRecent: On,
						highestPrior: An,
						lowestRecent: kn,
						lowestPrior: jn,
						chopCrossings: Nn
					}), g = $f({
						isLong: e,
						instrument: We,
						emaFast: ut,
						emaTrigger: dt,
						emaMid: G,
						adxPass: $t,
						adxRising: Qt,
						diCross: p,
						diStrength: f,
						candleBody: cn,
						candleRange: ln,
						close: W,
						vwap: Gn,
						trendDirections: Sr,
						volumeBonus: wn,
						htf15Above: Dr.above,
						htf15Strengthening: Dr.strengthening,
						htf15Valid: Dr.valid,
						htf60Above: Or.above,
						htf60Strengthening: Or.strengthening,
						htf60Valid: Or.valid,
						lower1Valid: He && (Ve?.lower1Valid ?? !1) && Tr.valid,
						lower1Above: Tr.above,
						lower1Strengthening: Tr.strengthening,
						lower2Valid: He && (Ve?.lower2Valid ?? !1) && Er.valid,
						lower2Above: Er.above,
						lower2Strengthening: Er.strengthening,
						warnCrossUp: Cr.crossUp,
						warnCrossDown: Cr.crossDown,
						dxyValid: He && (Ve?.dxyValid ?? !1) && fr,
						dxyRising: dr,
						minuteWarnAgainst: m,
						subFrameBullReversal: kr,
						subFrameBearReversal: Ar,
						nearPivot: qn,
						biasFilterEnabled: pe,
						biasBullish: mr,
						biasBearish: hr,
						biasStrength: gr
					}), _ = u && d && t(i, Ti);
					return {
						minuteWarnAgainst: m,
						setupScore: h,
						entryScore: g,
						backInZone: _,
						touch: Di && c && Si && _,
						scalp: u && h >= xi && c && d && t(ut, G) && Si,
						reachedMid: n(G, r) && t(i, Ei) && t(ut, G)
					};
				}, ki = Oi(!0), Ai = Oi(!1), ji = t.symbol?.isLastBar === !0, Mi = Ue >= _p && ji && yi === 0;
				rt && (A = 0, j = 0), A = Mi && ki.scalp ? A + 1 : 0, j = Mi && Ai.scalp ? j + 1 : 0;
				let Ni = A >= hp && ki.entryScore >= gp, Pi = j >= hp && Ai.entryScore >= gp, Fi = (e, t) => Ff({
					isLong: e,
					instrument: We,
					entry: t,
					swing: e ? Bt : zt,
					atr: en,
					emaMid: G,
					tick: (Number(Vn?.minmov) || 1) / (Number(Vn?.pricescale) || 100),
					caps: Te,
					buffer: R,
					atrStopMultiple: ke,
					chartMinutes: Ue,
					autoDetect: Ce
				}, Ye), Ii = kf(We, Te), Li = np(vi, {
					high: et,
					low: tt,
					close: W,
					time: nt,
					atr: en,
					hasPriorBar: Di,
					volumeOk: Tn,
					trendCrossUp: zn,
					trendCrossDown: Bn,
					entryLevel: dt,
					upgradeLevel: G,
					long: ki,
					short: Ai
				}, {
					instrument: We,
					slTpMode: Ye,
					rMultiples: Oe,
					atrMultiples: Ae,
					stopCaps: Te,
					beGoldPoints: B,
					feeBufferPct: z,
					useTrailingStop: Ne,
					trailAtrMult: Pe,
					tp5CloseAlways: Fe,
					showEntrySignals: Ie,
					stopFor: Fi,
					clearTargets: Yn
				}), J = Li.state, { activeTargets: Ri } = Li, zi = (e, t) => Li.marks[e] === (t ? 1 : -1) ? 1 : NaN;
				Mr.set(J.direction), Nr.set(J.entry), Pr.set(J.firstEntry), Fr.set(J.stop), Ir.set(J.risk), Lr.set(J.entryTime), Rr.set(+!!J.breakEvenDone), Ur.set(+!!J.upgraded), Gr.set(J.bestTarget), qr.set(+!!J.tp1Reached), Jr.set(J.trail), Xr.set(J.setupScore), Zr.set(J.entryScore), $r.set(J.ghostDirection), ei.set(J.ghostEntry), ni.set(J.ghostStop), ai.set(J.ghostTime);
				let Bi = Li.closed;
				if (si.set(+!!Bi), ci.set(Bi ? Bi.side : 0), li.set(Bi ? Bi.entry : NaN), ui.set(Bi ? Bi.exit : NaN), di.set(Bi ? Bi.rMultiple : NaN), fi.set(Bi ? Bi.bestTarget : NaN), pi.set(Bi ? Bi.entryTime : NaN), mi.set(Bi ? Bi.time : NaN), r && rt && si.get(1) === 1) {
					let e = ci.get(1), t = li.get(1), n = ui.get(1), i = di.get(1), a = pi.get(1), o = mi.get(1);
					if ((e > 0 || e < 0) && Number.isFinite(t) && Number.isFinite(n) && Number.isFinite(i) && Number.isFinite(a)) {
						let { symbol: s, resolution: c } = it();
						r({
							symbol: s,
							resolution: c,
							time: Number.isFinite(o) ? o : a,
							entryTime: a,
							side: e > 0 ? "LONG" : "SHORT",
							entry: t,
							exit: n,
							rMultiple: i,
							bestTarget: v.na(fi.get(1)) ? 0 : fi.get(1),
							win: i > 0
						});
					}
				}
				if (c && rt) {
					let e = (e, t) => ae && !v.na(e) && !v.na(t) ? [e, Math.floor(t / 1e3)] : [NaN, NaN], [t, n] = e(St.get(0), wt.get(0)), [r, i] = e(Ct.get(0), Tt.get(0)), a = `${t}|${n}|${r}|${i}`;
					a !== ne && (ne = a, c({
						...it(),
						time: Math.floor(nt / 1e3),
						resistance: t,
						resistanceTime: n,
						support: r,
						supportTime: i
					}));
				}
				if (s && ji) {
					let e = ze ? [
						{
							key: "fast",
							length: M,
							value: ut
						},
						{
							key: "mid",
							length: N,
							value: G
						},
						{
							key: "big",
							length: P,
							value: ft
						}
					] : [], t = e.map((e) => `${e.key}${e.length}:${e.value.toPrecision(10)}`).join("|");
					t !== te && (te = t, s({
						...it(),
						time: Math.floor(nt / 1e3),
						emas: e
					}));
				}
				if (n && rt) {
					let e = v.na(Mr.get(1)) ? 0 : Mr.get(1), t = v.na($r.get(1)) ? 0 : $r.get(1), r = Nr.get(1), i = Fr.get(1), a = Ir.get(1), o = Lr.get(1), s = v.na(Xr.get(1)) ? 0 : Xr.get(1), c = Le && e !== 0 && Number.isFinite(r) && Number.isFinite(i) && Number.isFinite(a) && Number.isFinite(o), l = c ? Lf({
						isLong: e === 1,
						entry: r,
						risk: a,
						atr: en
					}, Ye, Oe, Ae) : [
						NaN,
						NaN,
						NaN,
						NaN,
						NaN
					], u = Le && t !== 0 && Number.isFinite(ei.get(1)) && Number.isFinite(ni.get(1)) ? {
						direction: t === 1 ? "long" : "short",
						entry: ei.get(1),
						sl: ni.get(1)
					} : null, d = c ? o : u === null ? nt : ai.get(1), f = {
						...it(),
						time: Math.floor((Number.isFinite(d) ? d : nt) / 1e3),
						active: c || u !== null,
						direction: c ? e === -1 ? "short" : "long" : u?.direction ?? "long",
						entry: r,
						firstEntry: Pr.get(1),
						sl: i,
						maxSl: c ? e === 1 ? r - Ii : r + Ii : NaN,
						tps: l,
						activeTargets: c ? Yn(r, l, zf(s)) : 0,
						setupScore: s,
						entryScore: v.na(Zr.get(1)) ? 0 : Zr.get(1),
						tp1ClosePct: Be,
						tp2ClosePct: U,
						breakEven: Rr.get(1) === 1,
						trailing: !v.na(Jr.get(1)),
						trail: v.na(Jr.get(1)) ? NaN : Jr.get(1),
						trailAtrMult: Pe,
						atr: en,
						ghost: u
					}, p = f.active ? [
						f.symbol,
						f.resolution,
						f.time,
						f.direction,
						f.entry,
						f.firstEntry,
						f.sl,
						f.maxSl,
						f.activeTargets,
						f.breakEven,
						f.trailing,
						f.trail,
						...f.tps.slice(0, f.activeTargets),
						f.ghost?.entry ?? "",
						f.ghost?.sl ?? ""
					].map((e) => typeof e == "number" ? e.toPrecision(10) : String(e)).join("|") : `inactive|${f.symbol}|${f.resolution}`;
					p !== ee && (ee = p, n(f));
				}
				if (i && ji) {
					let e = J.direction === 1, t = We === Vr.Gold && J.direction !== 0 && !J.breakEvenDone && Number.isFinite(J.entry) && (e ? W - J.entry : J.entry - W) >= mp, n = /* @__PURE__ */ new Date(), r = n.getUTCHours() * 60 + n.getUTCMinutes(), a = Me(r, tr), o = Me(r, nr), s = Me(r, rr), c = a && o ? "Overlap" : a ? "London" : o ? "NewYork" : s ? "Asia" : null, l = c === "Overlap" || c === "London" ? je(r, tr) : c === "NewYork" ? je(r, nr) : c === "Asia" ? je(r, rr) : 0;
					i({
						...it(),
						instrument: We,
						mode: Ge,
						trend: vr,
						trendValid: yr,
						scoredFrames: xr ? 7 : 5,
						framesComplete: br,
						rsi: sn,
						aboveVwap: W > Gn,
						adxRising: Qt,
						adxFalling: !v.na(K) && Wt < K,
						dxyValid: He && (Ve?.dxyValid ?? !1) && fr,
						dxyRising: dr,
						minuteCross: wr.crossUp ? 1 : wr.crossDown ? -1 : 0,
						minuteAgainstSetup: ki.minuteWarnAgainst || Ai.minuteWarnAgainst,
						subFrameReversal: kr ? 1 : Ar ? -1 : 0,
						biasBullish: mr,
						biasBearish: hr,
						biasStrength: gr,
						biasValid: ur,
						volumeRising: bn,
						volumeFalling: xn,
						volumeAboveAverage: Cn,
						volatilitySpike: rn,
						session: c,
						sessionMinutesLeft: l,
						londonOpenMinutes: tr ? tr.from : -1,
						sessionFilterOn: ve,
						side: J.direction === 0 ? null : e ? "LONG" : "SHORT",
						setupScore: J.setupScore,
						entryScore: J.entryScore,
						breakEven: J.breakEvenDone,
						breakEvenHint: t,
						trailing: !Number.isNaN(J.trail),
						entry: J.entry,
						sl: J.stop,
						tps: J.direction !== 0 && Number.isFinite(J.entry) && Number.isFinite(J.risk) ? Lf({
							isLong: e,
							entry: J.entry,
							risk: J.risk,
							atr: en
						}, Ye, Oe, Ae) : [
							NaN,
							NaN,
							NaN,
							NaN,
							NaN
						],
						activeTargets: Ri,
						bestTarget: J.bestTarget,
						price: W,
						ghost: J.ghostDirection !== 0 && Number.isFinite(J.ghostEntry) && Number.isFinite(J.ghostStop) ? {
							direction: J.ghostDirection === 1 ? "long" : "short",
							entry: J.ghostEntry,
							sl: J.ghostStop
						} : null,
						pending: Ni || Pi,
						pendingSide: Ni ? "LONG" : Pi ? "SHORT" : null,
						pendingScore: Ni ? ki.entryScore : Pi ? Ai.entryScore : 0
					});
				}
				return x = nt, [
					ut,
					dt,
					G,
					ft,
					bt(ut),
					bt(dt),
					bt(ht),
					bt(gt),
					bt(G),
					xt(ut),
					xt(dt),
					xt(ht),
					xt(gt),
					xt(G),
					zi("entry", !0),
					zi("entry", !1),
					zi("entry2", !0),
					zi("entry2", !1),
					zi("reEntry", !0),
					zi("reEntry", !1),
					zi("stopExit", !0),
					zi("stopExit", !1),
					zi("beExit", !0),
					zi("beExit", !1),
					zi("targetExit", !0),
					zi("targetExit", !1)
				];
			};
		}
	};
}, xp = ({ studyName: e }) => Pn({
	studyName: e,
	label: "Trade Finder S/R",
	reanchor: !0,
	themeAware: !0,
	blockStaleOnDuplicateRemoval: !0,
	anchorsFor: jn,
	specsFor: (e, { theme: t }) => {
		let n = jo(t), r = [], i = (e, t, n) => {
			!Number.isFinite(e) || !Number.isFinite(t) || r.push({
				kind: "line",
				price: e,
				color: n,
				width: 2,
				fromTime: t,
				style: "solid"
			});
		};
		return i(e.resistance, e.resistanceTime, n.bearish.fill), i(e.support, e.supportTime, n.bullish.fill), r;
	}
}), Sp = 64, Cp = 296, wp = 6, Tp = {
	[Vr.Gold]: "Gold (XAU)",
	[Vr.Btc]: "Bitcoin (BTC)",
	[Vr.Eth]: "Ethereum (ETH)",
	[Vr.Nas100]: "Nasdaq 100",
	[Vr.Sp500]: "S&P 500",
	[Vr.Dow]: "Dow Jones",
	[Vr.Oil]: "Crude Oil",
	[Vr.Silver]: "Silver (XAG)",
	[Vr.Gbp]: "GBP pair",
	[Vr.Eur]: "EUR pair",
	[Vr.Jpy]: "JPY pair",
	[Vr.Other]: "—"
}, Ep = {
	Overlap: "tradeFinder.sessionOverlap",
	London: "london",
	NewYork: "newYork",
	Asia: "asia"
}, Dp = {
	[Hr.Scalping]: "tradeFinder.styleScalping",
	[Hr.Daytrade]: "tradeFinder.styleDaytrade",
	[Hr.Swing]: "tradeFinder.styleSwing"
}, Op = t(({ data: e, mountTarget: t, theme: n = "dark", language: r }) => !e || !t ? null : /* @__PURE__ */ c(Mp, {
	data: e,
	mountTarget: t,
	theme: n,
	language: r
}));
Op.displayName = "TradeFinderTable";
var kp = (e, t) => {
	let n = Math.floor(e / 60);
	return n > 0 ? t("tradeFinder.durationHm", {
		h: n,
		m: e - n * 60
	}) : t("tradeFinder.durationM", { m: e });
}, Ap = (e, t) => Number.isFinite(e) ? e >= 70 ? t.bearish.text : e <= 30 || e >= 55 ? t.bullish.text : e <= 45 ? t.bearish.text : t.textMuted : t.textMuted, jp = (e, t) => e >= 4.5 ? t.blue.text : e >= 4 ? t.bullish.text : e >= 3 ? t.amber.text : t.bearish.text, Mp = ({ data: e, mountTarget: t, theme: n, language: r }) => {
	let i = jo(n), a = r ?? "en", o = R.getFixedT(a, F), s = (e) => e.toLocaleUpperCase(a), [u, d] = (() => {
		if (e.side === null && !e.framesComplete) return [o("tradeFinder.framesUnavailable"), i.amber.text];
		if (e.side === null && e.volatilitySpike) return [o("tradeFinder.statusSpike"), i.amber.text];
		if (e.side === null && e.pending) return [o("tradeFinder.statusPending"), i.amber.text];
		if (e.side === null) return [o("tradeFinder.statusWaiting"), i.textMuted];
		let t = e.side === "LONG" ? "▲" : "▼", n = e.side === "LONG" ? i.bullish.text : i.bearish.text;
		return e.breakEven ? [`${t} ${o("tradeFinder.statusBreakEvenSet")}`, i.blue.text] : e.breakEvenHint ? [`${t} ${o("tradeFinder.statusMoveToBreakEven")}`, i.amber.text] : [`${t} ${o("tradeFinder.statusRunning")}`, n];
	})(), f = [
		`RSI ${Number.isFinite(e.rsi) ? Math.round(e.rsi) : "—"}`,
		`VWAP ${e.aboveVwap ? "▲" : "▼"}`,
		`ADX ${e.adxRising ? "↑" : e.adxFalling ? "↓" : "~"}`,
		...e.instrument === Vr.Gold && e.dxyValid ? [`DXY ${e.dxyRising ? "↑" : "↓"}`] : []
	], [p, m] = e.minuteAgainstSetup ? [o("tradeFinder.minuteAgainst"), i.bearish.text] : e.minuteCross === 0 ? e.subFrameReversal === 0 ? [o("tradeFinder.minuteOk"), i.textMuted] : [o("tradeFinder.subFrameReversal"), i.amber.text] : [o("tradeFinder.minuteReversal"), i.amber.text], h = "●".repeat(Math.max(0, Math.min(3, e.biasStrength))), [g, _] = e.biasValid ? e.biasBullish ? [`${s(o("bullish"))} ${h}`, i.bullish.text] : e.biasBearish ? [`${s(o("bearish"))} ${h}`, i.bearish.text] : [o("tradeFinder.noBias"), i.textMuted] : ["·", i.textMuted], v = `${e.volumeRising ? "↑" : e.volumeFalling ? "↓" : "→"}  ${e.volumeAboveAverage ? o("tradeFinder.volAboveAverage") : o("tradeFinder.volBelowAverage")}`, y = e.volumeRising && e.volumeAboveAverage ? i.bullish.text : e.volumeFalling && !e.volumeAboveAverage ? i.bearish.text : i.textMuted, b = e.session === null ? null : o(Ep[e.session]), x = e.londonOpenMinutes >= 0 ? `${String(Math.floor(e.londonOpenMinutes / 60)).padStart(2, "0")}:${String(e.londonOpenMinutes % 60).padStart(2, "0")}` : "--:--", S = b === null ? o("tradeFinder.sessionOutside", { time: x }) : `${b} · ${o("tradeFinder.sessionEndsIn", { time: kp(e.sessionMinutesLeft, o) })}`, C = e.session === "Overlap" ? i.amber.text : e.session === null ? i.textMuted : e.sessionMinutesLeft <= 30 ? i.amber.text : i.textColor, w = o(Dp[e.mode]), T = [
		{
			label: o("tradeFinder.rowContext"),
			value: f.join("   "),
			color: Ap(e.rsi, i)
		},
		{
			label: "1M",
			value: p,
			color: m
		},
		{
			label: o("tradeFinder.rowBias"),
			value: g,
			color: _
		},
		{
			label: o("tradeFinder.rowSetup"),
			value: e.side === null ? o("tradeFinder.noSetup") : `${e.side === "LONG" ? o("long") : o("short")}   ${o("tradeFinder.scoreLine", {
				setup: e.setupScore.toFixed(2),
				entry: Math.round(e.entryScore)
			})}`,
			color: e.side === null ? i.textMuted : jp(e.setupScore, i)
		},
		{
			label: o("tradeFinder.rowVolume"),
			value: v,
			color: y
		},
		{
			label: o("tradeFinder.rowSession"),
			value: S,
			color: C
		},
		{
			label: o("tradeFinder.rowInfo"),
			value: `${Tp[e.instrument]} · ${w}`,
			color: i.textColor
		}
	], E = e.recent.slice(0, wp);
	return /* @__PURE__ */ l(Ro, {
		mountTarget: t,
		theme: n,
		width: Cp,
		title: "TRADE FINDER",
		"aria-label": "Trade Finder status panel",
		emblemAccents: [
			i.bullish.fill,
			i.blue.fill,
			i.amber.fill,
			i.bearish.fill
		],
		status: u,
		statusColor: d,
		children: [
			/* @__PURE__ */ c(Np, {
				data: e,
				pal: i
			}),
			T.map((e) => /* @__PURE__ */ l("div", {
				style: {
					display: "grid",
					gridTemplateColumns: `${Sp}px 1fr`,
					alignItems: "center",
					columnGap: 8,
					padding: "4px 8px",
					borderTop: `1px solid ${i.rowDivider}`
				},
				children: [/* @__PURE__ */ c("span", {
					style: {
						...Q.data,
						textAlign: "right",
						color: i.textMuted
					},
					children: e.label
				}), /* @__PURE__ */ c("span", {
					style: {
						...Q.data,
						fontWeight: 600,
						color: e.color,
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis"
					},
					children: e.value
				})]
			}, e.label)),
			e.stats.count > 0 && /* @__PURE__ */ c(Pp, {
				data: e,
				pal: i,
				t: o
			}),
			E.length > 0 && /* @__PURE__ */ c(Fp, {
				log: E,
				pal: i,
				t: o
			})
		]
	});
}, Np = ({ data: e, pal: t }) => {
	let n = `repeat(${ii.length},1fr)`;
	return /* @__PURE__ */ c("div", {
		style: { padding: 8 },
		children: /* @__PURE__ */ l("div", {
			style: {
				border: `1px solid ${t.tableGrid}`,
				borderRadius: 4,
				overflow: "hidden"
			},
			children: [/* @__PURE__ */ c("div", {
				style: {
					display: "grid",
					gridTemplateColumns: n,
					borderBottom: `1px solid ${t.rowDivider}`
				},
				children: ii.map((n, r) => /* @__PURE__ */ c("span", {
					style: {
						...Q.micro,
						textAlign: "center",
						padding: "4px 0",
						color: r < e.scoredFrames ? t.textColor : t.textMuted
					},
					children: n === "1D" ? "1D" : n === "60" ? "1H" : n === "240" ? "4H" : `${n}M`
				}, n))
			}), /* @__PURE__ */ c("div", {
				style: {
					display: "grid",
					gridTemplateColumns: n
				},
				children: ii.map((n, r) => {
					let i = e.trend[r] ?? 0, a = e.trendValid[r] ?? !1, o = r < e.scoredFrames, s = i > 0 ? t.bullish : t.bearish, l = i !== 0 && o;
					return /* @__PURE__ */ c("span", {
						style: {
							textAlign: "center",
							padding: "4px 0",
							...Q.value,
							color: i === 0 ? t.textMuted : l ? s.textOnTint : s.text,
							opacity: o ? 1 : .45,
							background: l ? s.tint : "transparent"
						},
						children: a ? i === 0 ? "—" : i > 0 ? "▲" : "▼" : "·"
					}, n);
				})
			})]
		})
	});
}, Pp = ({ data: e, pal: t, t: n }) => {
	let r = [
		[
			`${n("tp", { n: 1 })}+`,
			e.stats.tp1,
			t.bullish.text
		],
		[
			`${n("tp", { n: 2 })}+`,
			e.stats.tp2,
			t.bullish.text
		],
		[
			`${n("tp", { n: 3 })}+`,
			e.stats.tp3,
			t.bullish.text
		],
		[
			n("sl"),
			e.stats.stopped,
			t.bearish.text
		]
	];
	return /* @__PURE__ */ l("div", {
		style: { padding: "0 8px 8px" },
		children: [/* @__PURE__ */ c("div", {
			style: {
				...Q.micro,
				fontWeight: 600,
				color: t.textMuted,
				padding: "8px 0 4px"
			},
			children: n("tradeFinder.statsTitle", { n: e.stats.count })
		}), /* @__PURE__ */ c("div", {
			style: {
				display: "grid",
				gridTemplateColumns: `repeat(${r.length},1fr)`,
				border: `1px solid ${t.tableGrid}`,
				borderRadius: 4,
				overflow: "hidden"
			},
			children: r.map(([e, n, r]) => /* @__PURE__ */ l("span", {
				style: {
					textAlign: "center",
					padding: "4px 0"
				},
				children: [/* @__PURE__ */ c("span", {
					style: {
						display: "block",
						...Q.micro,
						color: t.textMuted
					},
					children: e
				}), /* @__PURE__ */ l("span", {
					style: {
						...Q.value,
						fontWeight: 600,
						color: r
					},
					children: [n, "%"]
				})]
			}, e))
		})]
	});
}, Fp = ({ log: e, pal: t, t: n }) => /* @__PURE__ */ l("div", {
	style: { padding: "0 8px 8px" },
	children: [/* @__PURE__ */ c("div", {
		style: {
			...Q.micro,
			fontWeight: 600,
			color: t.textMuted,
			padding: "8px 0 4px"
		},
		children: n("tradeFinder.recentTitle")
	}), /* @__PURE__ */ c("div", {
		style: {
			border: `1px solid ${t.tableGrid}`,
			borderRadius: 4,
			overflow: "hidden"
		},
		children: e.map((e, r) => {
			let i = e.win ? t.bullish : t.bearish, a = e.side === "LONG" ? t.bullish : t.bearish, o = r === 0;
			return /* @__PURE__ */ l("div", {
				style: {
					display: "grid",
					gridTemplateColumns: "auto 1fr auto",
					alignItems: "center",
					columnGap: 8,
					padding: "4px 8px",
					...Q.data,
					borderTop: o ? void 0 : `1px solid ${t.rowDivider}`,
					background: o ? i.tint : "transparent"
				},
				children: [
					/* @__PURE__ */ c("span", {
						style: { color: o ? a.textOnTint : a.text },
						children: e.side === "LONG" ? "▲" : "▼"
					}),
					/* @__PURE__ */ c("span", {
						style: { color: t.textMuted },
						children: e.bestTarget > 0 ? n("tp", { n: e.bestTarget }) : n("sl")
					}),
					/* @__PURE__ */ l("span", {
						style: {
							fontWeight: 600,
							color: o ? i.textOnTint : i.text
						},
						children: [
							e.rMultiple > 0 ? "+" : "",
							e.rMultiple.toFixed(2),
							"R"
						]
					})
				]
			}, `${e.entryTime}|${e.side}`);
		})
	})]
}), Ip = class extends Xe {
	renderPanels = Ye(Op);
	studyPolicy;
	drawings;
	emaLabels;
	srLines;
	panels;
	frames;
	dollarIndexSymbol = "";
	constructor(e, t) {
		super(e, t);
		let n = R.getFixedT(e.language || "en", F), r = (t) => e.notify(rp, t);
		this.frames = this.own(Mi({
			studyName: rp,
			datafeed: e.datafeed,
			ticker: e.ticker,
			onFrameFailed: (e, t) => r(n("tradeFinder.frameFailed", { frame: t }))
		})), this.drawings = this.own(Xd({
			studyName: rp,
			language: e.language
		})), this.emaLabels = this.own(nf({ studyName: rp })), this.srLines = this.own(xp({ studyName: rp })), this.panels = this.own(df({
			studyName: rp,
			onUpdate: this.publish
		})), this.studyPolicy = this.own(ss({
			studyName: rp,
			singleInstance: !0,
			onDuplicateRemoved: () => {
				this.drawings.invalidateCachedSignals(), this.emaLabels.invalidateCachedSignals(), this.srLines.invalidateCachedSignals(), r(n("tradeFinder.duplicateRemoved"));
			}
		}));
	}
	studies(e) {
		return [bp(e, this.frames, (e) => this.drawings.onSignal(e), (e) => this.panels.onClosedTrade(e), (e) => this.panels.onSnapshot(e), this.ctx.language, this.dollarIndexSymbol, (e) => this.emaLabels.onSignal(e), (e) => this.srLines.onSignal(e))];
	}
	onChartReady(e) {
		this.studyPolicy.attach(e), this.frames.attach(e), this.drawings.attach(e), this.emaLabels.attach(e), this.srLines.attach(e);
	}
	onDocumentReady(e, t) {
		this.panels.attach(e, t);
	}
}, Lp = {
	utBotAlerts: {
		indicator: Ze((e, t) => Be(e, t.language)),
		entitlement: null
	},
	harsi: {
		indicator: Ze((e, t) => Te(e, t.language)),
		entitlement: null
	},
	sessions: {
		indicator: Ze((e, t) => ze(e, t.language)),
		entitlement: null
	},
	richGarden: {
		indicator: Ze((e) => Re(e)),
		entitlement: null
	},
	usousd: {
		indicator: Ze((e, t) => Ee(e, t.notify)),
		entitlement: null
	},
	cypher: {
		indicator: Vl,
		entitlement: Bl
	},
	cTrigger: {
		indicator: tc,
		entitlement: null
	},
	optimus: {
		indicator: yu,
		entitlement: vu
	},
	bfs: {
		indicator: Vs,
		entitlement: Bs
	},
	tradeFinder: {
		indicator: Ip,
		entitlement: null
	},
	traceScanner: {
		indicator: Kd,
		entitlement: null
	},
	auraScanner: {
		indicator: Qo,
		entitlement: null
	}
}, Rp = Object.entries(Lp), zp = (e, t, n, r) => n[e]?.(r) === !1 ? !1 : !t.entitlement || r.account.getIndicatorSettings(e, t.entitlement).isAllow, Bp = (e) => e.studies === Xe.prototype.studies ? (console.error(`Indicator "${e.id}" does not implement studies(); skipping it.`), !1) : !0, Vp = (e, t, n) => {
	for (let r of e) try {
		n(r);
	} catch (e) {
		console.error(`Indicator "${r.id}" failed during ${t}`, e);
	}
}, Hp = class e {
	static current = null;
	indicators;
	studyNamesById = /* @__PURE__ */ new Map();
	disposed = !1;
	constructor(e) {
		let { enabled: t = {}, ...n } = e;
		this.indicators = Rp.filter(([e, r]) => zp(e, r, t, n)).map(([e, t]) => new t.indicator(n, e)).filter((e) => Bp(e) ? !0 : (e.destroy(), !1));
	}
	static setInstance(t) {
		return e.removeInstance(), e.current = new e(t), e.current;
	}
	static getInstance() {
		return e.current;
	}
	static removeInstance() {
		let t = e.current;
		e.current = null, t?.destroy();
	}
	getIndicators = (e) => {
		if (this.disposed) return console.error("custom_indicators_getter ran after the orchestrator was destroyed; no studies registered."), Promise.resolve([]);
		let t = [];
		return Vp(this.indicators, "studies()", (n) => {
			let r = n.studies(e);
			t.push(...r), this.studyNamesById.set(n.id, r.map((e) => e.metainfo.description));
		}), Promise.resolve(t);
	};
	studyNames(e) {
		return this.studyNamesById.get(e) ?? [];
	}
	onChartReady(e) {
		Vp(this.indicators, "onChartReady", (t) => t.onChartReady?.(e));
	}
	onDocumentReady(e, t) {
		Vp(this.indicators, "onDocumentReady", (n) => n.onDocumentReady?.(e, t));
	}
	destroy() {
		this.disposed || (this.disposed = !0, Vp(this.indicators, "destroy", (e) => e.destroy()), this.indicators.length = 0, We());
	}
};
//#endregion
export { Lp as INDICATOR_REGISTRY, Hp as IndicatorOrchestrator, Je as IndicatorPanels, is as buildIndicatorSettings, le as cTriggerIndicator, ns as deniedIndicatorSettings, rs as devIndicatorSettings, Te as harsiIndicator, as as readIndicatorSettings, Re as richGardenIndicator, ze as sessionIndicator, Ee as usousdIndicator, Be as utBotAlertsIndicator };
